
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("4ph1l", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $cd8a7b942d0ffbf8$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $cHEjl = parcelRequire("cHEjl");

var $2tyYF = parcelRequire("2tyYF");

var $6Wtd1 = parcelRequire("6Wtd1");
function $cd8a7b942d0ffbf8$export$2e2bcd8739ae039(props) {
    if ((0, $cHEjl.isIntersectionObserverSupported)()) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2tyYF.LazyIntersectionObserverCard), {
        ...props
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Wtd1.LazyLazilyRenderCard), {
        ...props
    });
}

});
parcelRegister("2tyYF", function(module, exports) {
$parcel$export(module.exports, "LazyIntersectionObserverCard", () => $b542d1314b3c3171$export$f7e6e9ba10fbcbe9);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $iSwY4 = parcelRequire("iSwY4");

var $Md55L = parcelRequire("Md55L");

var $hxp5N = parcelRequire("hxp5N");

var $8JuSD = parcelRequire("8JuSD");

var $1SK0s = parcelRequire("1SK0s");
// This property enables the intersection observer to be run once the
// HTML element being observed is within `X` px of the target container it is
// being compared to. Since the default container is the `document`, we set this
// up to check once a Smart Link is within `X` px from the bottom of the viewport.
const $b542d1314b3c3171$var$ROOT_MARGIN_VERTICAL = '360px';
function $b542d1314b3c3171$export$f7e6e9ba10fbcbe9(props) {
    const ref = (0, $eJOHy.useRef)(null);
    const [isIntersecting, setIsIntersecting] = (0, $eJOHy.useState)(false);
    const [shouldSendRenderedUFOEvent] = (0, $eJOHy.useState)((0, $hxp5N.shouldSample)());
    const { appearance: appearance, url: url, id: id } = props;
    const prefetch = (0, $iSwY4.usePrefetch)(url);
    const Component = appearance === 'inline' ? 'span' : 'div';
    const ComponentObserver = Component;
    const onIntersection = (0, $eJOHy.useCallback)((entries, observer)=>{
        const isVisible = entries.some((entry)=>entry.isIntersecting);
        if (isVisible) {
            if (shouldSendRenderedUFOEvent) (0, $Md55L.startUfoExperience)('smart-link-rendered', id);
            setIsIntersecting(true);
            observer.disconnect();
        } else prefetch();
    }, [
        id,
        prefetch,
        shouldSendRenderedUFOEvent
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!ref.current) return;
        const intersectionObserver = new IntersectionObserver(onIntersection, {
            rootMargin: `${$b542d1314b3c3171$var$ROOT_MARGIN_VERTICAL} 0px ${$b542d1314b3c3171$var$ROOT_MARGIN_VERTICAL} 0px`
        });
        intersectionObserver.observe(ref.current);
        return ()=>intersectionObserver.disconnect();
    }, [
        ref,
        onIntersection
    ]);
    const content = isIntersecting ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8JuSD.CardWithUrlContent), {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)(ComponentObserver, {
        ref: ref,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1SK0s.LoadingCardLink), {
            ...props
        })
    });
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        className: "loader-wrapper",
        children: content
    });
}

});
parcelRegister("iSwY4", function(module, exports) {
$parcel$export(module.exports, "usePrefetch", () => $36c39fa5ed4462ee$export$4dcd17e50290e364);

var $eJOHy = parcelRequire("eJOHy");

var $aeACg = parcelRequire("aeACg");

var $5hWYB = parcelRequire("5hWYB");
function $36c39fa5ed4462ee$export$4dcd17e50290e364(url) {
    const { store: store, prefetchStore: prefetchStore, connections: connections } = (0, $aeACg.useSmartLinkContext)();
    const { dispatch: dispatch, getState: getState } = store || {};
    const { client: client } = connections || {};
    return (0, $eJOHy.useCallback)(async ()=>{
        // If smartlink context props are undefined do nothing.
        if (!store || !prefetchStore || !connections) return;
        // If the link is already being prefetched, the prefetch store
        // should have a flag set against the URL. The prefetch store is purposefully
        // separate from the UI in order to ensure no rendering takes place;
        // all mutations which occur are purely store-based mutations.
        const isPrefetching = prefetchStore[url];
        // If the link has already been registered in the store, then it no
        // longer needs to be prefetched, as the normal flow of a link being in
        // the viewport and being fetched is now in motion.
        const isFetching = getState()[url];
        // We compute if a link needs to be prefetched thus, referencing the above.
        const needsPrefetch = !isPrefetching && !isFetching;
        if (needsPrefetch) {
            // We specify in the prefetch store that this link no
            // longer needs to be prefetched. Data which comes back
            // from a successful prefetch flow here will be used to
            // render all URLs which are the same.
            prefetchStore[url] = true;
            // Try fetch the data for this URL from Object Resolver Service (ORS), executing batch
            // requests by domain (as usual) to ensure we minimize the amount of connections
            // we create between browser -> ORS when making network requests.
            try {
                const response = await client.prefetchData(url);
                // Once the data comes back, we put the link in the `resolved` status. This ensures
                // that when the link enters the viewport and is rendered, we immediately show it as
                // a Smart Link, rather than rendering a loading spinner -> immediate Smart Link.
                if (response) {
                    dispatch({
                        type: 'resolved',
                        url: url,
                        payload: response
                    });
                    // Put the metadata in resolved state, theres no need for a pending or errored state as
                    // we are following the same render flow as described by the comments above and below.
                    dispatch((0, $5hWYB.cardAction)((0, $5hWYB.ACTION_UPDATE_METADATA_STATUS), {
                        url: url
                    }, undefined, undefined, 'resolved'));
                }
            } catch (_err) {
            // Do nothing, link will be retried under the hood with exponential backoff.
            // If it does not succeed even after those retries, the normal resolve flow
            // will start when the link is in view. Since we have not performed any store
            // mutations yet, the link will behave like a 'brand new' link.
            }
        }
    }, [
        store,
        prefetchStore,
        connections,
        url,
        getState,
        client,
        dispatch
    ]);
}

});

parcelRegister("hxp5N", function(module, exports) {
$parcel$export(module.exports, "shouldSample", () => $804b6952b2e1c75b$export$a86202d561cb4183);
const $804b6952b2e1c75b$export$a86202d561cb4183 = (threshold = 0.5)=>Math.random() > threshold;

});

parcelRegister("8JuSD", function(module, exports) {
$parcel$export(module.exports, "CardWithUrlContent", () => $71fe4bf1ac9ca9de$export$7598f5d7c597dd32);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aqlRB = parcelRequire("aqlRB");

var $kePQU = parcelRequire("kePQU");

var $aH6JV = parcelRequire("aH6JV");

var $5RpiZ = parcelRequire("5RpiZ");

var $4D53f = parcelRequire("4D53f");

var $6isqZ = parcelRequire("6isqZ");

var $Md55L = parcelRequire("Md55L");

var $75Eqs = parcelRequire("75Eqs");

var $9gN1t = parcelRequire("9gN1t");

var $cHEjl = parcelRequire("cHEjl");

var $eeRHf = parcelRequire("eeRHf");

var $eVkTT = parcelRequire("eVkTT");

var $aBejd = parcelRequire("aBejd");

var $b4EyC = parcelRequire("b4EyC");

var $3DQy8 = parcelRequire("3DQy8");

var $2iEwK = parcelRequire("2iEwK");

var $aAVNA = parcelRequire("aAVNA");

var $9ztRN = parcelRequire("9ztRN");

var $56NmJ = parcelRequire("56NmJ");

var $gEsSS = parcelRequire("gEsSS");
const $71fe4bf1ac9ca9de$var$thirdPartyARIPrefix = 'ari:third-party';
function $71fe4bf1ac9ca9de$var$Component({ id: id, url: url, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, platform: platform, onClick: onClick, appearance: appearance, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptionsProp, inheritDimensions: inheritDimensions, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, ui: ui, children: children, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton, disablePreviewPanel: disablePreviewPanel }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $aqlRB.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $5RpiZ.useAnalyticsEvents)();
    // Get state, actions for this card.
    const { state: state, actions: actions, config: config, renderers: renderers, error: error, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $6isqZ.useSmartLink)(id, url);
    const ari = (0, $75Eqs.getObjectAri)(state.details);
    const name = (0, $75Eqs.getObjectName)(state.details);
    const definitionId = (0, $75Eqs.getDefinitionId)(state.details);
    const extensionKey = (0, $75Eqs.getExtensionKey)(state.details);
    const resourceType = (0, $75Eqs.getResourceType)(state.details);
    const services = (0, $75Eqs.getServices)(state.details);
    const thirdPartyARI = (0, $75Eqs.getThirdPartyARI)(state.details);
    const firstPartyIdentifier = (0, $75Eqs.getFirstPartyIdentifier)();
    let isFlexibleUi = (0, $eJOHy.useMemo)(()=>(0, $b4EyC.isFlexibleUiCard)(children, ui), [
        children,
        ui
    ]);
    const actionOptions = (0, $eeRHf.combineActionOptions)({
        actionOptions: actionOptionsProp,
        platform: platform
    });
    const fire3PClickEvent = (0, $kePQU.fg)('platform_smartlink_3pclick_analytics') ? (0, $gEsSS.useFire3PWorkflowsClickEvent)(firstPartyIdentifier, thirdPartyARI) : undefined;
    // Setup UI handlers.
    const handleClickWrapper = (0, $eJOHy.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $cHEjl.isSpecialKey)(event) || (0, $cHEjl.isSpecialClick)(event);
        fireEvent('ui.smartLink.clicked', {
            id: id,
            display: isFlexibleUi ? (0, $4D53f.CardDisplay).Flexible : appearance,
            definitionId: definitionId ?? null,
            isModifierKeyPressed: isModifierKeyPressed
        });
        if ((0, $kePQU.fg)('platform_smartlink_3pclick_analytics')) {
            if (thirdPartyARI && thirdPartyARI.startsWith($71fe4bf1ac9ca9de$var$thirdPartyARIPrefix)) {
                const clickURL = (0, $75Eqs.getClickUrl)(url, state.details);
                if (clickURL === url && fire3PClickEvent) // For questions or concerns about this event,
                // please reach out to the 3P Workflows Team via Slack in #help-3p-connector-workflow
                fire3PClickEvent();
            }
        }
        const isDisablePreviewPanel = disablePreviewPanel && (0, $aH6JV.editorExperiment)('platform_editor_preview_panel_linking_exp', true, {
            exposure: true
        });
        // If preview panel is available and the user clicked on the link,
        // delegate the click to the preview panel handler
        if (!isModifierKeyPressed && ari && name && openPreviewPanel && isPreviewPanelAvailable?.({
            ari: ari
        }) && !isDisablePreviewPanel) {
            event.preventDefault();
            event.stopPropagation();
            openPreviewPanel({
                url: url,
                ari: ari,
                name: name,
                iconUrl: (0, $75Eqs.getObjectIconUrl)(state.details)
            });
            (0, $eVkTT.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                attributes: {
                    clickOutcome: 'previewPanel'
                }
            });
            return;
        } else if (!onClick && !isFlexibleUi) {
            const clickUrl = (0, $75Eqs.getClickUrl)(url, state.details);
            // Ctrl+left click on mac typically doesn't trigger onClick
            // The event could have potentially had `e.preventDefault()` called on it by now
            // event by smart card internally
            // If it has been called then only then can `isSpecialEvent` be true.
            const target = (0, $cHEjl.isSpecialEvent)(event) ? '_blank' : '_self';
            window.open(clickUrl, target);
            (0, $eVkTT.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                attributes: {
                    clickOutcome: target === '_blank' ? 'clickThroughNewTabOrWindow' : 'clickThrough'
                }
            });
        } else {
            if (onClick) onClick(event);
            (0, $eVkTT.fireLinkClickedEvent)(createAnalyticsEvent)(event);
        }
    }, [
        fireEvent,
        id,
        isFlexibleUi,
        appearance,
        definitionId,
        onClick,
        url,
        state.details,
        ari,
        name,
        fire3PClickEvent,
        isPreviewPanelAvailable,
        openPreviewPanel,
        createAnalyticsEvent,
        thirdPartyARI,
        disablePreviewPanel
    ]);
    const handleAuthorize = (0, $eJOHy.useCallback)(()=>actions.authorize(appearance), [
        actions,
        appearance
    ]);
    const handleRetry = (0, $eJOHy.useCallback)(()=>{
        actions.reload();
    }, [
        actions
    ]);
    const handleInvoke = (0, $eJOHy.useCallback)((opts)=>actions.invoke(opts, appearance), [
        actions,
        appearance
    ]);
    // NB: for each status change in a Smart Link, a performance mark is created.
    // Measures are sent relative to the first mark, matching what a user sees.
    (0, $eJOHy.useEffect)(()=>{
        $3DQy8.mark(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            $3DQy8.create(id, state.status);
            if (state.status === 'resolved') fireEvent('operational.smartLink.resolved', {
                definitionId: definitionId ?? null,
                duration: $3DQy8.getMeasure(id, state.status)?.duration ?? null
            });
            else if (state.error?.type !== 'ResolveUnsupportedError' && state.error?.type !== 'UnsupportedError') fireEvent('operational.smartLink.unresolved', {
                definitionId: definitionId ?? null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        appearance,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    // NB: once the smart-card has rendered into an end state, we capture
    // this as a successful render. These can be one of:
    // - the resolved state: when metadata is shown;
    // - the unresolved states: viz. forbidden, not_found, unauthorized, errored.
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $75Eqs.isFinalState)(state.status)) {
            (0, $Md55L.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
                extensionKey: extensionKey,
                display: isFlexibleUi ? 'flexible' : appearance
            });
            // UFO will disregard this if authentication experience has not yet been started
            (0, $Md55L.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
                display: isFlexibleUi ? 'flexible' : appearance
            });
            fireEvent('ui.smartLink.renderSuccess', {
                display: isFlexibleUi ? 'flexible' : appearance
            });
        }
    }, [
        appearance,
        extensionKey,
        fireEvent,
        id,
        isFlexibleUi,
        state.status
    ]);
    const onIframeDwell = (0, $eJOHy.useCallback)((dwellTime, dwellPercentVisible)=>{
        fireEvent('ui.smartLinkIframe.dwelled', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            dwellPercentVisible: dwellPercentVisible,
            dwellTime: dwellTime
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    const onIframeFocus = (0, $eJOHy.useCallback)(()=>{
        fireEvent('ui.smartLinkIframe.focused', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    if (isFlexibleUi) {
        let cardState = state;
        if (error) {
            if (error?.name === 'APIError') cardState = {
                status: 'errored'
            };
            else throw error;
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9ztRN.default), {
            id: id,
            cardState: cardState,
            onAuthorize: services.length && handleAuthorize || undefined,
            onClick: handleClickWrapper,
            origin: "smartLinkCard",
            renderers: renderers,
            ui: ui,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            actionOptions: actionOptions,
            url: url,
            testId: testId,
            onResolve: onResolve,
            onError: onError,
            children: children
        });
    }
    // We have to keep this last to prevent hook order from being violated
    if (error) throw error;
    switch(appearance){
        case 'inline':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $56NmJ.InlineCard), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                isSelected: isSelected,
                isHovered: isHovered,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inlinePreloaderStyle: inlinePreloaderStyle,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
                resolvingPlaceholder: resolvingPlaceholder,
                truncateInline: truncateInline,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'block':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2iEwK.BlockCard), {
                id: id,
                url: url,
                renderers: renderers,
                authFlow: config && config.authFlow,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                isSelected: isSelected,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                actionOptions: actionOptions,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'embed':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aAVNA.EmbedCard), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                iframeUrlType: embedIframeUrlType,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleErrorRetry: handleRetry,
                handleFrameClick: handleClickWrapper,
                handleInvoke: handleInvoke,
                isSelected: isSelected,
                frameStyle: frameStyle,
                platform: platform,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inheritDimensions: inheritDimensions,
                actionOptions: actionOptions,
                ref: embedIframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
    }
}
const $71fe4bf1ac9ca9de$export$7598f5d7c597dd32 = (props)=>{
    const display = (0, $b4EyC.isFlexibleUiCard)(props.children, props?.ui) ? (0, $4D53f.CardDisplay).Flexible : props.appearance;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9gN1t.SmartLinkModalProvider), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aBejd.SmartLinkAnalyticsContext), {
            url: props.url,
            id: props.id,
            display: display,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($71fe4bf1ac9ca9de$var$Component, {
                ...props
            })
        })
    });
};

});
parcelRegister("aH6JV", function(module, exports) {
$parcel$export(module.exports, "editorExperiment", () => $49385954af4e1eb9$export$9b7cf3b74f250027);
$parcel$export(module.exports, "unstable_editorExperimentParam", () => $49385954af4e1eb9$export$92316ae898e357eb);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $iDtdt = parcelRequire("iDtdt");

var $bEYxX = parcelRequire("bEYxX");

var $anSHl = parcelRequire("anSHl");

var $2ybeA = parcelRequire("2ybeA");
function $49385954af4e1eb9$export$9b7cf3b74f250027(experimentName, expectedExperimentValue, options = {
    exposure: false
}) {
    const experimentConfig = (0, $anSHl.editorExperimentsConfig)[experimentName];
    if ((0, $2ybeA._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $2ybeA._overrides)[experimentName] === expectedExperimentValue;
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    if (!(0, $2ybeA._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return experimentConfig.defaultValue === expectedExperimentValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig?.productKeys?.[0, $2ybeA._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return (0, $anSHl.editorExperimentsConfig)[experimentName]?.defaultValue === expectedExperimentValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $iDtdt.default).getExperimentValue(// @ts-ignore
    experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
        typeGuard: experimentConfig.typeGuard,
        fireExperimentExposure: options.exposure
    });
    if (// When cleaning this gate up -- `calling where the experiments have the product key set`
    // in __tests__/experiments should be updated (as it's had the count bumped to include these).
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $iDtdt.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) (0, $bEYxX.addFeatureFlagAccessed)(`${experimentName}:${experimentConfig.param}`, experimentValue);
    return expectedExperimentValue === experimentValue;
}
function $49385954af4e1eb9$export$92316ae898e357eb(experimentName, paramName, options) {
    if ((0, $2ybeA._paramOverrides)[experimentName]?.[paramName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $2ybeA._paramOverrides)[experimentName][paramName];
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $iDtdt.default).getExperimentValue(experimentName, paramName, options.defaultValue, {
        typeGuard: options.typeGuard,
        fireExperimentExposure: options.exposure ?? false
    });
    return experimentValue;
}

});

parcelRegister("6isqZ", function(module, exports) {
$parcel$export(module.exports, "useSmartLink", () => $b05fb9495e5a07cf$export$9f4e486b1dc3e700);

var $eJOHy = parcelRequire("eJOHy");

var $aeACg = parcelRequire("aeACg");

var $aMAiH = parcelRequire("aMAiH");

var $iUPpA = parcelRequire("iUPpA");

var $6PiGN = parcelRequire("6PiGN");

var $cgiz5 = parcelRequire("cgiz5");
function $b05fb9495e5a07cf$export$9f4e486b1dc3e700(id, url) {
    const state = (0, $cgiz5.useSmartCardState)(url);
    const { store: store, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $aeACg.useSmartLinkContext)();
    const actions = (0, $aMAiH.useSmartCardActions)(id, url);
    const config = (0, $iUPpA.useSmartLinkConfig)();
    const renderers = (0, $6PiGN.useSmartLinkRenderers)();
    // NB: used to propagate errors from hooks to error boundaries.
    const [error, setError] = (0, $eJOHy.useState)(null);
    // Register the current card.
    const register = ()=>{
        actions.register().catch((err)=>setError(err));
    };
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eJOHy.useEffect)(register, [
        url,
        store
    ]);
    // Provide the state and card actions to consumers.
    return {
        state: state,
        actions: actions,
        config: config,
        renderers: renderers,
        error: error,
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        openPreviewPanel: openPreviewPanel
    };
}

});
parcelRegister("aMAiH", function(module, exports) {
$parcel$export(module.exports, "useSmartCardActions", () => $196cc9c7568fd8d2$export$f7c340395f31e832);

var $eJOHy = parcelRequire("eJOHy");

var $aeACg = parcelRequire("aeACg");

var $5hWYB = parcelRequire("5hWYB");

var $nIUfp = parcelRequire("nIUfp");

var $5RpiZ = parcelRequire("5RpiZ");

var $4D53f = parcelRequire("4D53f");

var $Md55L = parcelRequire("Md55L");

var $75Eqs = parcelRequire("75Eqs");

var $kRRk5 = parcelRequire("kRRk5");

var $7rZ1M = parcelRequire("7rZ1M");
const $196cc9c7568fd8d2$export$f7c340395f31e832 = (id, url)=>{
    const resolveUrl = (0, $7rZ1M.default)();
    const invokeClientAction = (0, $kRRk5.default)({});
    const { fireEvent: fireEvent } = (0, $5RpiZ.useAnalyticsEvents)();
    const { store: store } = (0, $aeACg.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const getSmartLinkState = (0, $eJOHy.useCallback)(()=>{
        const { details: details, status: status, metadataStatus: metadataStatus } = getState()[url] ?? {
            status: (0, $4D53f.SmartLinkStatus).Pending
        };
        return {
            details: details,
            status: status,
            metadataStatus: metadataStatus
        };
    }, [
        getState,
        url
    ]);
    const setMetadataStatus = (0, $eJOHy.useCallback)((metadataStatus)=>{
        dispatch((0, $5hWYB.cardAction)((0, $5hWYB.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch,
        url
    ]);
    const resolve = (0, $eJOHy.useCallback)(async (resourceUrl = url, isReloading = false, isMetadataRequest = false)=>resolveUrl(resourceUrl, isReloading, isMetadataRequest, id), [
        id,
        resolveUrl,
        url
    ]);
    const register = (0, $eJOHy.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        if (!details) {
            dispatch((0, $5hWYB.cardAction)((0, $5hWYB.ACTION_RESOLVING), {
                url: url
            }));
            setMetadataStatus('pending');
        }
        return resolve();
    }, [
        getSmartLinkState,
        resolve,
        dispatch,
        url,
        setMetadataStatus
    ]);
    const reload = (0, $eJOHy.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        const definitionId = (0, $75Eqs.getDefinitionId)(details);
        if (definitionId) (0, $75Eqs.getByDefinitionId)(definitionId, getState()).map((url)=>resolve(url, true));
        else resolve(url, true);
    }, [
        getSmartLinkState,
        url,
        getState,
        resolve
    ]);
    const loadMetadata = (0, $eJOHy.useCallback)(()=>{
        const { metadataStatus: metadataStatus } = getSmartLinkState();
        //metadataStatus will be undefined for SSR links only
        if (metadataStatus === undefined) {
            setMetadataStatus('pending');
            return resolve(url, false, true);
        }
    }, [
        getSmartLinkState,
        resolve,
        setMetadataStatus,
        url
    ]);
    const authorize = (0, $eJOHy.useCallback)((appearance)=>{
        const { details: details, status: status } = getSmartLinkState();
        const definitionId = (0, $75Eqs.getDefinitionId)(details);
        const extensionKey = (0, $75Eqs.getExtensionKey)(details);
        const services = (0, $75Eqs.getServices)(details);
        // When authentication is triggered, let GAS know!
        if (status === 'unauthorized') fireEvent('ui.button.clicked.connectAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (status === 'forbidden') fireEvent('ui.smartLink.clicked.tryAnotherAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (services.length > 0) {
            fireEvent('screen.consentModal.viewed', {
                definitionId: definitionId ?? null
            });
            (0, $nIUfp.auth)(services[0].url).then(()=>{
                fireEvent('track.applicationAccount.connected', {
                    definitionId: definitionId ?? null
                });
                (0, $Md55L.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: 'success'
                });
                fireEvent('operational.smartLink.connectSucceeded', {
                    definitionId: definitionId ?? null
                });
                reload();
            }, (err)=>{
                (0, $Md55L.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: err.type
                });
                fireEvent('operational.smartLink.connectFailed', {
                    definitionId: definitionId ?? null,
                    reason: err.type ?? null
                });
                if (err.type === 'auth_window_closed') fireEvent('ui.consentModal.closed', {
                    display: appearance,
                    definitionId: definitionId ?? null
                });
                reload();
            });
        }
    }, [
        getSmartLinkState,
        id,
        reload,
        fireEvent
    ]);
    const invoke = (0, $eJOHy.useCallback)(async (opts, appearance)=>{
        const { key: key, action: action } = opts;
        const source = opts.source || appearance;
        if (opts.type === 'client') return await invokeClientAction({
            actionFn: opts.action.promise,
            actionType: action.type,
            display: source,
            extensionKey: key
        });
    }, [
        invokeClientAction
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            register: register,
            reload: reload,
            authorize: authorize,
            invoke: invoke,
            loadMetadata: loadMetadata
        }), [
        register,
        reload,
        authorize,
        invoke,
        loadMetadata
    ]);
};

});
parcelRegister("nIUfp", function(module, exports) {
$parcel$export(module.exports, "auth", () => $8b7d2800a3b52b24$export$73693bad9f5880b0);
$parcel$export(module.exports, "AuthError", () => (parcelRequire("hnOaA")).AuthError);

var $hnOaA = parcelRequire("hnOaA");

var $hPt7Q = parcelRequire("hPt7Q");
function $8b7d2800a3b52b24$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $hPt7Q.isOfTypeAuthError)(errorType)) reject(new (0, $hnOaA.AuthError)(data.message, errorType));
                    else reject(new (0, $hnOaA.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $hnOaA.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}

});
parcelRegister("hnOaA", function(module, exports) {
$parcel$export(module.exports, "AuthError", () => $214fe980c4698089$export$145273558d58e0ac);
class $214fe980c4698089$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message), this.message = message, this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}

});

parcelRegister("hPt7Q", function(module, exports) {
$parcel$export(module.exports, "isOfTypeAuthError", () => $9f0c4db827660d40$export$400e64c8451aa84f);
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $9f0c4db827660d40$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};

});


parcelRegister("75Eqs", function(module, exports) {
$parcel$export(module.exports, "getByDefinitionId", () => $a0d221dc2b38310a$export$f75b0b690ab4dfb9);
$parcel$export(module.exports, "getClickUrl", () => $a0d221dc2b38310a$export$cf3c5acf9e9d0f02);
$parcel$export(module.exports, "getDefinitionId", () => $a0d221dc2b38310a$export$46fa3e7718c82e41);
$parcel$export(module.exports, "getExtensionKey", () => $a0d221dc2b38310a$export$218d96312e385949);
$parcel$export(module.exports, "getObjectAri", () => $a0d221dc2b38310a$export$81164c1570bcd038);
$parcel$export(module.exports, "getThirdPartyARI", () => $a0d221dc2b38310a$export$e029950864672b4);
$parcel$export(module.exports, "getFirstPartyIdentifier", () => $a0d221dc2b38310a$export$48b4e58cdb8031ba);
$parcel$export(module.exports, "getObjectName", () => $a0d221dc2b38310a$export$5615361d76a8be5);
$parcel$export(module.exports, "getObjectIconUrl", () => $a0d221dc2b38310a$export$bcf275804417edda);
$parcel$export(module.exports, "getResourceType", () => $a0d221dc2b38310a$export$16c0ebb0de9b767b);
$parcel$export(module.exports, "getServices", () => $a0d221dc2b38310a$export$a009e3a1163d46fb);
$parcel$export(module.exports, "isFinalState", () => $a0d221dc2b38310a$export$d590d08942abc17a);
$parcel$export(module.exports, "hasAuthScopeOverrides", () => $a0d221dc2b38310a$export$3f9446bb21b945a0);

var $kePQU = parcelRequire("kePQU");

var $1aju8 = parcelRequire("1aju8");
const $a0d221dc2b38310a$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
    const urls = Object.keys(store);
    return urls.filter((url)=>{
        const { details: details } = store[url];
        return details && details.meta.definitionId === definitionId;
    });
};
const $a0d221dc2b38310a$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
    if (jsonLd && jsonLd.data) {
        const visitUrl = (0, $1aju8.extractVisitUrl)(jsonLd.data);
        if (visitUrl) return visitUrl;
    }
    return url;
};
const $a0d221dc2b38310a$export$46fa3e7718c82e41 = (details)=>details?.meta?.definitionId;
const $a0d221dc2b38310a$export$218d96312e385949 = (details)=>details?.meta?.key;
const $a0d221dc2b38310a$export$81164c1570bcd038 = (details)=>details?.data && 'atlassian:ari' in details.data && details.data['atlassian:ari'] || undefined;
const $a0d221dc2b38310a$export$e029950864672b4 = (details)=>{
    if ((0, $kePQU.fg)('platform_smartlink_3pclick_analytics')) {
        if (details?.entityData && 'thirdPartyAri' in details.entityData && details.entityData.thirdPartyAri) return details.entityData.thirdPartyAri;
        if (details?.data && 'atlassian:ari' in details.data && typeof details.data['atlassian:ari'] === 'string') {
            const ari = details.data['atlassian:ari'];
            if (ari.includes('ari:third-party')) return ari;
        }
    }
    return undefined;
};
const $a0d221dc2b38310a$export$48b4e58cdb8031ba = ()=>{
    if (!(0, $kePQU.fg)('platform_smartlink_3pclick_analytics')) return undefined;
    const product = $a0d221dc2b38310a$var$getProductFromWindowURL();
    const currentURL = window.location.href;
    if (product === 'confluence') {
        if (currentURL.includes('content.id')) {
            const contentId = $a0d221dc2b38310a$var$extractContentIdFromURL(currentURL);
            if (contentId) return `ConfluenceContentId:${contentId}`;
        }
        const pageId = $a0d221dc2b38310a$var$extractPageIdFromURL(currentURL);
        if (pageId) return `ConfluencePageId:${pageId}`;
    } else if (product === 'jira') {
        const issueKey = $a0d221dc2b38310a$var$extractJiraIssueIdFromURL(currentURL);
        if (issueKey) return `JiraIssueKey:${issueKey}`;
    }
    return undefined;
};
const $a0d221dc2b38310a$export$5615361d76a8be5 = (details)=>details?.data && 'name' in details.data && details.data.name || undefined;
const $a0d221dc2b38310a$export$bcf275804417edda = (details)=>{
    if (details?.data && 'icon' in details.data && details.data.icon) {
        if (typeof details.data.icon === 'object' && 'url' in details.data.icon && details.data.icon.url && typeof details.data.icon.url === 'string') return details.data.icon.url;
    }
    return undefined;
};
const $a0d221dc2b38310a$export$16c0ebb0de9b767b = (details)=>details?.meta?.resourceType;
const $a0d221dc2b38310a$export$e2005c9600188ac7 = (details)=>details?.meta?.product;
const $a0d221dc2b38310a$export$f8fdefc70357968e = (details)=>details?.meta?.subproduct;
const $a0d221dc2b38310a$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];
const $a0d221dc2b38310a$export$ac5d414b1ebfab5a = (details)=>details && $a0d221dc2b38310a$export$cd41ae544cfc2a65(details) && $a0d221dc2b38310a$export$795910f5f15a9633(details);
const $a0d221dc2b38310a$export$cd41ae544cfc2a65 = ({ meta: { access: access } })=>access === 'granted';
const $a0d221dc2b38310a$export$795910f5f15a9633 = ({ meta: { visibility: visibility } })=>visibility === 'restricted' || visibility === 'public';
const $a0d221dc2b38310a$export$a752a116d184ffbd = (details)=>{
    return details?.meta?.requestAccess?.accessType;
};
const $a0d221dc2b38310a$export$d590d08942abc17a = (status)=>{
    return [
        'unauthorized',
        'forbidden',
        'errored',
        'resolved',
        'not_found'
    ].indexOf(status) > -1;
};
const $a0d221dc2b38310a$export$66805b16d2a1da7c = (details)=>details?.datasources;
const $a0d221dc2b38310a$export$ba6d13ab7b87c55c = (details)=>{
    const datasources = $a0d221dc2b38310a$export$66805b16d2a1da7c(details);
    return !!datasources && datasources.length > 0;
};
const $a0d221dc2b38310a$export$3f9446bb21b945a0 = (details)=>!!details?.meta.hasScopeOverrides;
// Helper function to extract page ID from standard Confluence page URLs
const $a0d221dc2b38310a$var$extractPageIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Following this pattern for confluence URL -> /wiki/spaces/{space}/pages/{pageId}/{title}
        const pagesMatch = urlObj.pathname.match(/\/wiki\/spaces\/[^\/]+\/pages\/(\d+)(?:\/|$)/);
        if (pagesMatch && pagesMatch[1]) return pagesMatch[1];
        // Following this pattern for confluence URL -> /wiki/pages/viewpage.action?pageId={pageId}
        const pageIdParam = urlObj.searchParams.get('pageId');
        if (pageIdParam) return pageIdParam;
        // Following this pattern for confluence URL -> /wiki/display/{space}/{pageId}
        const displayMatch = urlObj.pathname.match(/\/wiki\/display\/[^\/]+\/(\d+)/);
        if (displayMatch && displayMatch[1]) return displayMatch[1];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $a0d221dc2b38310a$var$extractContentIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Pattern: ?content.id={contentId} (for app connector URLs and plugin servlet URLs)
        const contentId = urlObj.searchParams.get('content.id');
        if (contentId) return contentId;
        // Also support URLs where content.id is in the query string but not parsed by URL (edge case)
        // e.g., /wiki/plugins/servlet/ac/com.atlassian.perspectiveretros/perspective-retros?content.id=5662725850
        const match = url.match(/[?&]content\.id=(\d+)/);
        if (match && match[1]) return match[1];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $a0d221dc2b38310a$var$extractJiraIssueIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Support any case for Jira keys (e.g., AI3W-864, ai3w-864, Ai3W-864)
        const browseMatch = urlObj.pathname.match(/\/browse\/([A-Za-z0-9]+-\d+)/);
        if (browseMatch && browseMatch[1]) return browseMatch[1];
        // /jira/browse/{issueKey}
        const jiraBrowseMatch = urlObj.pathname.match(/\/jira\/browse\/([A-Za-z0-9]+-\d+)/);
        if (jiraBrowseMatch && jiraBrowseMatch[1]) return jiraBrowseMatch[1];
        // Query parameter ?selectedIssue={issueKey}
        const selectedIssue = urlObj.searchParams.get('selectedIssue');
        if (selectedIssue && /^[A-Za-z0-9]+-\d+$/.test(selectedIssue)) return selectedIssue;
        // Query parameter ?issueKey={issueKey}
        const issueKeyParam = urlObj.searchParams.get('issueKey');
        if (issueKeyParam && /^[A-Za-z0-9]+-\d+$/.test(issueKeyParam)) return issueKeyParam;
    } catch  {
        return undefined;
    }
    return undefined;
};
const $a0d221dc2b38310a$var$getProductFromWindowURL = ()=>{
    try {
        const currentUrl = window.location.href;
        const urlObj = new URL(currentUrl);
        const hostname = urlObj.hostname.toLowerCase();
        const pathname = urlObj.pathname.toLowerCase();
        // Check for Confluence patterns
        if (hostname.includes('confluence') || pathname.includes('/wiki/') || pathname.includes('/display/') || pathname.includes('/spaces/')) return 'confluence';
        // Check for Jira patterns
        if (hostname.includes('jira') || pathname.includes('/browse/') || pathname.includes('/projects/') || pathname.includes('/secure/')) return 'jira';
    } catch  {
        return undefined;
    }
    return undefined;
};

});
parcelRegister("1aju8", function(module, exports) {
$parcel$export(module.exports, "extractVisitUrl", () => $10e95000520ddafb$export$c81497d3681f24f4);
const $10e95000520ddafb$export$c81497d3681f24f4 = (jsonLd)=>{
    return jsonLd['atlassian:visitUrl'];
};

});



parcelRegister("iUPpA", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkConfig", () => $9ad6af138ab0c341$export$5d10838c1e539409);

var $aeACg = parcelRequire("aeACg");
const $9ad6af138ab0c341$export$5d10838c1e539409 = ()=>{
    const context = (0, $aeACg.useSmartLinkContext)();
    if (context) return context.config;
    return undefined;
};

});


parcelRegister("eeRHf", function(module, exports) {
$parcel$export(module.exports, "combineActionOptions", () => $28df08354cbdded3$export$2ae4cf79c720146a);
const $28df08354cbdded3$export$2ae4cf79c720146a = ({ actionOptions: actionOptions, platform: platform })=>{
    if (typeof actionOptions !== 'undefined') return actionOptions;
    if (platform === 'mobile') return {
        hide: true
    };
    let exclude = [];
    return {
        hide: false,
        exclude: exclude
    };
};

});

parcelRegister("2iEwK", function(module, exports) {
$parcel$export(module.exports, "BlockCard", () => $8caba9e4eeb32695$export$d18ccd25c0d2c6b0);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kePQU = parcelRequire("kePQU");

var $lUdvR = parcelRequire("lUdvR");

var $juXY2 = parcelRequire("juXY2");

var $lRukN = parcelRequire("lRukN");

var $9WNF0 = parcelRequire("9WNF0");

var $huCuF = parcelRequire("huCuF");

var $gGDtI = parcelRequire("gGDtI");

var $cf7hR = parcelRequire("cf7hR");

var $eTJs3 = parcelRequire("eTJs3");

var $fwAOH = parcelRequire("fwAOH");

var $7gHy8 = parcelRequire("7gHy8");
const $8caba9e4eeb32695$var$UFOLoadHoldWrapper = ({ children: children })=>{
    return (0, $kePQU.fg)('platform_renderer_blindspots') ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lUdvR.default), {
                name: "smart-card-block-card"
            }),
            children
        ]
    }) : children;
};
const $8caba9e4eeb32695$export$d18ccd25c0d2c6b0 = ({ id: id, url: url, cardState: cardState, authFlow: authFlow, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, renderers: renderers, isSelected: isSelected, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const { status: status } = cardState;
    const blockCardProps = {
        id: id,
        cardState: cardState,
        url: url,
        testId: testId,
        onClick: (event)=>(0, $9WNF0.handleClickCommon)(event, handleFrameClick),
        onError: onError,
        onResolve: onResolve,
        renderers: renderers,
        actionOptions: actionOptions,
        CompetitorPrompt: CompetitorPrompt,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton
    };
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $juXY2.useControlDataExportConfig)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($8caba9e4eeb32695$var$UFOLoadHoldWrapper, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fwAOH.default), {
                    ...blockCardProps,
                    testId: "smart-block-resolving-view"
                })
            });
        case 'resolved':
            if ((0, $lRukN.getIsDataExportEnabled)(shouldControlDataExport, cardState.details)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7gHy8.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fwAOH.default), {
                ...blockCardProps
            });
        case 'unauthorized':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7gHy8.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'forbidden':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cf7hR.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'not_found':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eTJs3.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            if (authFlow && authFlow === 'disabled') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $huCuF.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: `${testId}-${status}`
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gGDtI.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
    }
};

});
parcelRegister("juXY2", function(module, exports) {
$parcel$export(module.exports, "useControlDataExportConfig", () => $4ee7b6cc5488968f$export$f93c47f1b2b3f55b);

var $eJOHy = parcelRequire("eJOHy");

var $aeACg = parcelRequire("aeACg");
const $4ee7b6cc5488968f$export$f93c47f1b2b3f55b = ()=>{
    const { connections: connections, product: product, shouldControlDataExport: shouldControlDataExport } = (0, $aeACg.useSmartLinkContext)();
    return (0, $eJOHy.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            shouldControlDataExport: shouldControlDataExport
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        shouldControlDataExport
    ]);
};

});

parcelRegister("lRukN", function(module, exports) {
$parcel$export(module.exports, "getIsDataExportEnabled", () => $d0823ca3bb4190ea$export$a019611f39785186);
const $d0823ca3bb4190ea$export$a019611f39785186 = (shouldControlDataExport = false, response)=>Boolean(shouldControlDataExport && response?.meta?.supportedFeature?.includes('ExportBlocked'));

});

parcelRegister("9WNF0", function(module, exports) {
$parcel$export(module.exports, "handleClickCommon", () => $f6784b2a34e1d7c7$export$9759a67e215c4598);
const $f6784b2a34e1d7c7$export$9759a67e215c4598 = (event, onClick)=>{
    if (onClick) {
        event.preventDefault();
        event.stopPropagation();
        onClick(event);
    }
};

});

parcelRegister("gGDtI", function(module, exports) {
$parcel$export(module.exports, "default", () => $5050c40b174c2a9e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5sWlm = parcelRequire("5sWlm");

var $cafmZ = parcelRequire("cafmZ");

var $asDdI = parcelRequire("asDdI");

var $5GS0S = parcelRequire("5GS0S");

var $4LtOu = parcelRequire("4LtOu");

var $TVYgn = parcelRequire("TVYgn");
/**
 * This view represents a Block Card with an 'Errored' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $5050c40b174c2a9e$var$ErroredView = ({ testId: testId = 'smart-block-errored-view', ...props })=>{
    const actions = (0, $eJOHy.useMemo)(()=>props.onAuthorize ? [
            (0, $5GS0S.RetryAction)(props.onAuthorize)
        ] : [], [
        props.onAuthorize
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $4LtOu.default), {
        ...props,
        actions: actions,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5sWlm))), {
                label: "errored-warning-icon",
                color: "var(--ds-icon-warning, #E56910)",
                LEGACY_size: "small",
                testId: `${testId}-warning-icon`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $asDdI.default), {
                maxLines: 3,
                message: {
                    descriptor: (0, $cafmZ.messages).could_not_load_link
                }
            })
        ]
    });
};
var $5050c40b174c2a9e$export$2e2bcd8739ae039 = (0, $TVYgn.withFlexibleUIBlockCardStyle)($5050c40b174c2a9e$var$ErroredView);

});
parcelRegister("5GS0S", function(module, exports) {
$parcel$export(module.exports, "RetryAction", () => $704ca394ddeb59ee$export$c527d977b53f7537);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $4D53f = parcelRequire("4D53f");

var $cafmZ = parcelRequire("cafmZ");
const $704ca394ddeb59ee$export$c527d977b53f7537 = (onRetry)=>({
        name: (0, $4D53f.ActionName).CustomAction,
        onClick: onRetry,
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $cafmZ.messages).try_again
        }),
        testId: 'smart-action-try-again'
    });

});

parcelRegister("4LtOu", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b85e390775e9524$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $heSeW = parcelRequire("heSeW");

var $9ztRN = parcelRequire("9ztRN");

var $5dGlr = parcelRequire("5dGlr");
var $hczHz = parcelRequire("hczHz");
var $2u0se = parcelRequire("2u0se");
var $4RQt4 = parcelRequire("4RQt4");

var $7H3El = parcelRequire("7H3El");
const $0b85e390775e9524$var$customBlockStyles = null;
const $0b85e390775e9524$var$titleBlockCss = null;
const $0b85e390775e9524$var$footerBlockCss = null;
const $0b85e390775e9524$var$footerBlockSafariStyles = null;
const $0b85e390775e9524$var$UnresolvedView = ({ actions: actions, cardState: cardState, children: children, onAuthorize: onAuthorize, onClick: onClick, onError: onError, showPreview: showPreview = false, testId: testId, title: title, url: url })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $eJOHy.useMemo)(()=>(0, $heSeW.browser)(), []);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9ztRN.default), {
        appearance: "block",
        cardState: cardState,
        onAuthorize: onAuthorize,
        onClick: onClick,
        onError: onError,
        origin: "smartLinkCard",
        testId: testId,
        ui: (0, $7H3El.FlexibleCardUiOptions),
        url: url,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4RQt4.default), {
                ...(0, $7H3El.titleBlockOptions),
                hideIcon: !!title,
                text: title,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _13mh1pd9 _2yhz14q2"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5dGlr.default), {
                className: (0, $hcewu.default)([
                    "_zulp1b66 _1e0c1txw _4cvr1y6m _1wpz1fhb _7yjtidpf _ngc01fxt"
                ]),
                children: children
            }),
            showPreview && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2u0se.default), {
                ...(0, $7H3El.PreviewBlockOptions)
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hczHz.default), {
                actions: actions,
                testId: "smart-block-card-footer",
                className: (0, $hcewu.default)([
                    "_4t3i1k8s _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb",
                    safari && "_4t3i1osq"
                ])
            })
        ]
    });
};
var $0b85e390775e9524$export$2e2bcd8739ae039 = $0b85e390775e9524$var$UnresolvedView;

});
parcelRegister("9ztRN", function(module, exports) {
$parcel$export(module.exports, "default", () => $def3382adc6f5c9f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aeACg = parcelRequire("aeACg");

var $5RpiZ = parcelRequire("5RpiZ");

var $4D53f = parcelRequire("4D53f");

var $hv5Jn = parcelRequire("hv5Jn");

var $bunXF = parcelRequire("bunXF");

var $7rZ1M = parcelRequire("7rZ1M");

var $46zTA = parcelRequire("46zTA");

var $jZeFf = parcelRequire("jZeFf");
/**
 * This represents a Flexible Card: a link represented by a card with metadata.
 * This is the container in which all Flexible UI Blocks and Elements exist.
 * Note: TitleBlock is mandatory for a Flexible Card to render.
 * @see Container
 */ const $def3382adc6f5c9f$var$FlexibleCard = ({ appearance: appearance = 'flexible', cardState: cardState, children: children, id: id, onAuthorize: onAuthorize, onClick: onClick, onError: onError, onResolve: onResolve, origin: origin, renderers: renderers, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, testId: testId, ui: ui, url: url })=>{
    const aiSummaryConfig = (0, $bunXF.useAISummaryConfig)();
    const resolve = (0, $7rZ1M.default)();
    const { isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $aeACg.useSmartLinkContext)();
    const { fireEvent: fireEvent } = (0, $5RpiZ.useAnalyticsEvents)();
    const { status: cardType, details: details } = cardState;
    const status = cardType;
    const context = (0, $eJOHy.useMemo)(()=>(0, $jZeFf.getContextByStatus)({
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            response: details,
            id: id,
            onAuthorize: onAuthorize,
            onClick: onClick,
            origin: origin,
            renderers: renderers,
            resolve: resolve,
            actionOptions: actionOptions,
            status: status,
            url: url,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }), [
        aiSummaryConfig,
        appearance,
        fireEvent,
        details,
        id,
        onAuthorize,
        onClick,
        origin,
        renderers,
        resolve,
        actionOptions,
        status,
        url,
        isPreviewPanelAvailable,
        openPreviewPanel
    ]);
    const flexibleCardContext = (0, $eJOHy.useMemo)(()=>({
            data: context,
            status: status,
            ui: ui
        }), [
        context,
        status,
        ui
    ]);
    const { linkTitle: linkTitle } = context || {};
    const title = linkTitle?.text;
    (0, $eJOHy.useEffect)(()=>{
        switch(status){
            case (0, $4D53f.SmartLinkStatus).Resolved:
                if (onResolve) onResolve({
                    title: title,
                    url: url
                });
                break;
            case (0, $4D53f.SmartLinkStatus).Errored:
            case (0, $4D53f.SmartLinkStatus).Fallback:
            case (0, $4D53f.SmartLinkStatus).Forbidden:
            case (0, $4D53f.SmartLinkStatus).NotFound:
            case (0, $4D53f.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        title,
        url
    ]);
    const retry = flexibleCardContext.data?.actions?.[(0, $4D53f.InternalActionName).UnresolvedAction];
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hv5Jn.FlexibleCardContext).Provider, {
        value: flexibleCardContext,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46zTA.default), {
            testId: testId,
            ...ui,
            onClick: onClick,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            actionOptions: actionOptions,
            status: status,
            retry: retry,
            children: children
        })
    });
};
var $def3382adc6f5c9f$export$2e2bcd8739ae039 = $def3382adc6f5c9f$var$FlexibleCard;

});
parcelRegister("46zTA", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6e95744fa399fd8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $4D53f = parcelRequire("4D53f");

var $hv5Jn = parcelRequire("hv5Jn");

var $kRy7J = parcelRequire("kRy7J");

var $b4EyC = parcelRequire("b4EyC");

var $4RQt4 = parcelRequire("4RQt4");

var $eLqeI = parcelRequire("eLqeI");

var $fP5ry = parcelRequire("fP5ry");
const $f6e95744fa399fd8$export$6f4e0540a2f2295a = (children, context)=>{
    let options = {};
    if ((0, $kRy7J.isFlexUiPreviewPresent)(context)) (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
            if ((0, $b4EyC.isFlexibleUiPreviewBlock)(child)) {
                const { placement: placement } = child.props;
                if (placement === (0, $4D53f.MediaPlacement).Left) options.previewOnLeft = true;
                if (placement === (0, $4D53f.MediaPlacement).Right) options.previewOnRight = true;
            }
        }
    });
    return options;
};
const $f6e95744fa399fd8$var$filterChildren = (children, removeBlockRestriction)=>{
    if (removeBlockRestriction) return children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child) && (0, $b4EyC.isFlexibleUiBlock)(child) ? child : undefined);
};
const $f6e95744fa399fd8$export$f6c7a950371733c8 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return undefined;
    if (node.type === (0, $4RQt4.default)) return node;
    if ((0, $b4EyC.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f6e95744fa399fd8$export$f6c7a950371733c8(child);
        });
        return isChildrenValid;
    }
    return undefined;
};
const $f6e95744fa399fd8$var$getTitleBlockProps = (children)=>{
    const block = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children).map((child)=>$f6e95744fa399fd8$export$f6c7a950371733c8(child)).filter((x)=>x !== undefined).at(0);
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(block)) return block.props;
};
const $f6e95744fa399fd8$var$getLayeredLink = (testId, context, children, onClick)=>{
    const { linkTitle: linkTitle, url: url = '' } = context || {};
    const { anchorTarget: target, text: text } = $f6e95744fa399fd8$var$getTitleBlockProps(children) || {};
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fP5ry.default), {
        onClick: onClick,
        target: target,
        testId: testId,
        text: text || linkTitle?.text,
        url: url
    });
};
const $f6e95744fa399fd8$var$baseStyleCommon = null;
const $f6e95744fa399fd8$var$backgroundStyles = null;
const $f6e95744fa399fd8$var$elevationStyles = null;
const $f6e95744fa399fd8$var$clickableContainerStyles = null;
const $f6e95744fa399fd8$var$gapStyleMap = {
    xlarge: "_zulpr2fv",
    large: "_zulpzu5n",
    medium: "_zulp1bpf",
    small: "_zulpswc3"
};
/**
 * Get container padding based on smart link size
 * Equivalent version for DS primitives space token is getPrimitivesPaddingSpaceBySize()
 * at view/FlexibleCard/components/utils.tsx
 */ const $f6e95744fa399fd8$var$getPadding = (size)=>{
    switch(size){
        case (0, $4D53f.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $4D53f.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $4D53f.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $4D53f.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $f6e95744fa399fd8$var$getGap = (size)=>{
    switch(size){
        case (0, $4D53f.SmartLinkSize).XLarge:
            return "var(--ds-space-250, 20px)";
        case (0, $4D53f.SmartLinkSize).Large:
            return "var(--ds-space-200, 16px)";
        case (0, $4D53f.SmartLinkSize).Medium:
            return "var(--ds-space-100, 8px)";
        case (0, $4D53f.SmartLinkSize).Small:
        default:
            return "var(--ds-space-050, 4px)";
    }
};
const $f6e95744fa399fd8$var$previewOnLeftStyleMap = {
    xlarge: "_19bver0k _y5vk1ejb",
    large: "_19bv16ru _y5vkv47k",
    medium: "_19bv1g7w _y5vk1eak",
    small: "_19bvlbes _y5vku2gc"
};
const $f6e95744fa399fd8$var$previewOnRightStyleMap = {
    xlarge: "_u5f3er0k _1yob1ejb",
    large: "_u5f316ru _1yobv47k",
    medium: "_u5f31g7w _1yob1eak",
    small: "_u5f3lbes _1yobu2gc"
};
/**
 * A container is a hidden component that build the Flexible Smart Link.
 * All the Flexible UI components are wrapped inside the container.
 * It inherits the ui props from Card component and applies the custom styling
 * accordingly.
 * @internal
 * @see Block
 */ const $f6e95744fa399fd8$var$Container = ({ children: children, clickableContainer: clickableContainer = false, hideBackground: hideBackground = false, hideElevation: hideElevation = false, hidePadding: hidePadding = false, onClick: onClick, retry: retry, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeBlockRestriction: removeBlockRestriction = false, size: size = (0, $4D53f.SmartLinkSize).Medium, status: status, testId: testId = 'smart-links-container' })=>{
    (0, $gRw8I.di)((0, $eLqeI.default));
    const padding = hidePadding ? '0px' : $f6e95744fa399fd8$var$getPadding(size);
    const gap = $f6e95744fa399fd8$var$getGap(size);
    const context = (0, $hv5Jn.useFlexibleUiContext)();
    const { previewOnLeft: previewOnLeft, previewOnRight: previewOnRight } = $f6e95744fa399fd8$export$6f4e0540a2f2295a(children, context);
    const canShowHoverPreview = showHoverPreview && status === 'resolved';
    // `retry` object contains action that can be performed on
    // unresolved link (unauthorized, forbidden, not found, etc.)
    const canShowAuthTooltip = showHoverPreview && status === 'unauthorized' && retry !== undefined;
    const containerPaddingStyles = null;
    const container = /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-smart-link-container": true,
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _1ul9idpf _1reo15vq _kqswh2mm _1pcmkb7n _1v7y1i6y _ufn21i6y",
            $f6e95744fa399fd8$var$gapStyleMap[size],
            !hideBackground && "_bfhkhp5a",
            "_1yt418y6 _jb7v18y6 _y5vk167t _1yob1wow _r37x1r5k",
            previewOnLeft && $f6e95744fa399fd8$var$previewOnLeftStyleMap[size],
            previewOnRight && $f6e95744fa399fd8$var$previewOnRightStyleMap[size],
            !hideElevation && "_19it7r9e _2rkopb1k _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            clickableContainer && "_nqwih2mm _18ywh2mm _1nq3h2mm _1t4ckb7n _1nxdkb7n _xnbykb7n"
        ]),
        style: {
            "--_1xumd0e": (0, $awdRS.default)(padding),
            "--_73mooq": (0, $awdRS.default)(previewOnLeft ? gap : padding),
            "--_12k13bg": (0, $awdRS.default)(previewOnRight ? gap : padding)
        },
        children: [
            clickableContainer ? $f6e95744fa399fd8$var$getLayeredLink(testId, context, children, onClick) : null,
            $f6e95744fa399fd8$var$filterChildren(children, removeBlockRestriction)
        ]
    });
    if (context?.url && (canShowHoverPreview || canShowAuthTooltip)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eLqeI.default), {
        isHoverPreview: canShowHoverPreview,
        isAuthTooltip: canShowAuthTooltip,
        actionOptions: actionOptions,
        testId: testId,
        url: context.url,
        hoverPreviewOptions: hoverPreviewOptions,
        children: container
    });
    return container;
};
var $f6e95744fa399fd8$export$2e2bcd8739ae039 = $f6e95744fa399fd8$var$Container;

});
parcelRegister("kRy7J", function(module, exports) {
$parcel$export(module.exports, "isFlexUiPreviewPresent", () => $bdecacc8b20e0ec6$export$783c1bf8fee63f80);
const $bdecacc8b20e0ec6$export$783c1bf8fee63f80 = (context)=>Boolean(context && context.preview);

});

parcelRegister("eLqeI", function(module, exports) {
$parcel$export(module.exports, "default", () => $4889c4f654f90e2a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4D53f = parcelRequire("4D53f");

var $4GHj0 = parcelRequire("4GHj0");
const $4889c4f654f90e2a$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY = 100;
const $4889c4f654f90e2a$var$HoverCardControl = ({ children: children, isHoverPreview: isHoverPreview, isAuthTooltip: isAuthTooltip, actionOptions: actionOptions, testId: testId, url: url, delay: delay = $4889c4f654f90e2a$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY, hoverPreviewOptions: hoverPreviewOptions })=>{
    const [canOpen, setCanOpen] = (0, $eJOHy.useState)(true);
    const mouseStopTimer = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        };
    }, []);
    const onMouseLeave = (0, $eJOHy.useCallback)(()=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
    }, []);
    const onMouseMove = (0, $eJOHy.useCallback)((e)=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        // Never show hover card on action or when action dropdown opens.
        // The code below can be simplified by using :is() and :has()
        // but the pseudo-class isn't support by Firefox yet.
        const action = // Any action button group (title/footer block)
        e.target.closest('.actions-button-group') || // When action dropdown list is opened on action button group or lozenge action
        e.target.closest('[data-smart-link-container]')?.querySelector('[data-action-open="true"]');
        const canOpenOnElement = isAuthTooltip && !action || // EDM-7060: For hover preview, also hide hover card on all elements
        // except title element (link title)
        isHoverPreview && !action && !e.target.closest(`[data-smart-element]:not([data-smart-element="${(0, $4D53f.ElementName).Title}"])`);
        mouseStopTimer.current = setTimeout(()=>{
            if (canOpen !== canOpenOnElement) setCanOpen(Boolean(canOpenOnElement));
        }, delay);
    }, [
        isAuthTooltip,
        isHoverPreview,
        canOpen,
        delay
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4GHj0.HoverCard), {
        allowEventPropagation: true,
        canOpen: canOpen,
        closeOnChildClick: true,
        actionOptions: actionOptions,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            onMouseLeave: onMouseLeave,
            onMouseMove: onMouseMove,
            "data-testid": `${testId}-hover-card-wrapper`,
            role: 'presentation',
            children: children
        })
    });
};
var $4889c4f654f90e2a$export$2e2bcd8739ae039 = $4889c4f654f90e2a$var$HoverCardControl;

});
parcelRegister("4GHj0", function(module, exports) {
$parcel$export(module.exports, "HoverCard", () => $849048042deb2624$export$57a077cc9fbe653e);
$parcel$export(module.exports, "StandaloneHoverCard", () => $849048042deb2624$export$f1f63acbe6ed8fb0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $gRw8I = parcelRequire("gRw8I");

var $iedRq = parcelRequire("iedRq");

var $5RpiZ = parcelRequire("5RpiZ");

var $4D53f = parcelRequire("4D53f");

var $Md55L = parcelRequire("Md55L");

var $9gN1t = parcelRequire("9gN1t");

var $aBejd = parcelRequire("aBejd");

var $ax9JM = parcelRequire("ax9JM");
const $849048042deb2624$var$HoverCardWithErrorBoundary = (props)=>{
    (0, $gRw8I.di)((0, $ax9JM.HoverCardComponent));
    const { fireEvent: fireEvent } = (0, $5RpiZ.useAnalyticsEvents)();
    const { url: url, id: id, children: children } = props;
    const analyticsContext = (0, $aBejd.useSmartLinkAnalyticsContext)({
        display: (0, $4D53f.CardDisplay).HoverCardPreview,
        id: id,
        source: (0, $ax9JM.HOVER_CARD_SOURCE),
        url: url
    });
    const onError = (0, $eJOHy.useCallback)((error, info)=>{
        (0, $Md55L.startUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $Md55L.failUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $Md55L.failUfoExperience)('smart-link-authenticated', id || 'NULL');
        fireEvent('ui.smartLink.renderFailed', {
            ...analyticsContext?.attributes,
            display: (0, $4D53f.CardDisplay).HoverCardPreview,
            id: id ?? null,
            error: error,
            errorInfo: info
        });
    }, [
        analyticsContext,
        id,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
        fallback: children,
        onError: onError,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9gN1t.SmartLinkModalProvider), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ax9JM.HoverCardComponent), {
                ...props,
                children: children
            })
        })
    });
};
const $849048042deb2624$var$HoverCardWithoutAnalyticsContext = (0, $iedRq.default)()($849048042deb2624$var$HoverCardWithErrorBoundary);
const $849048042deb2624$export$57a077cc9fbe653e = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($849048042deb2624$var$HoverCardWithoutAnalyticsContext, {
        ...props
    });
};
const $849048042deb2624$export$f1f63acbe6ed8fb0 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)($849048042deb2624$export$57a077cc9fbe653e, {
        ...props
    });

});
parcelRegister("ax9JM", function(module, exports) {
$parcel$export(module.exports, "HOVER_CARD_SOURCE", () => $9f099b40d6720ae9$export$421dbc3834daf261);
$parcel$export(module.exports, "HoverCardComponent", () => $9f099b40d6720ae9$export$e2173dafa6a751bb);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6X0vU = parcelRequire("6X0vU");

var $aH6JV = parcelRequire("aH6JV");

var $4D53f = parcelRequire("4D53f");

var $aMAiH = parcelRequire("aMAiH");

var $6PiGN = parcelRequire("6PiGN");

var $cgiz5 = parcelRequire("cgiz5");

var $aBejd = parcelRequire("aBejd");

var $ePS3w = parcelRequire("ePS3w");

var $9JJsa = parcelRequire("9JJsa");

var $64RLL = parcelRequire("64RLL");
const $9f099b40d6720ae9$export$421dbc3834daf261 = 'smartLinkPreviewHoverCard';
const $9f099b40d6720ae9$var$HOVER_CARD_TRIGGER_WRAPPER = 'hover-card-trigger-wrapper';
const $9f099b40d6720ae9$var$FADE_IN_DELAY = 500;
const $9f099b40d6720ae9$var$FADE_OUT_DELAY = 300;
const $9f099b40d6720ae9$var$RESOLVE_DELAY = 100;
const $9f099b40d6720ae9$export$e2173dafa6a751bb = ({ children: children, url: url, id: id = '', canOpen: canOpen = true, closeOnChildClick: closeOnChildClick = false, actionOptions: actionOptions, allowEventPropagation: allowEventPropagation = false, zIndex: zIndex = (0, $64RLL.HOVER_CARD_Z_INDEX), noFadeDelay: noFadeDelay = false, hoverPreviewOptions: hoverPreviewOptions, role: role, label: label, titleId: titleId })=>{
    const fadeInDelay = hoverPreviewOptions?.fadeInDelay ?? $9f099b40d6720ae9$var$FADE_IN_DELAY;
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(false);
    const fadeOutTimeoutId = (0, $eJOHy.useRef)();
    const fadeInTimeoutId = (0, $eJOHy.useRef)();
    const resolveTimeOutId = (0, $eJOHy.useRef)();
    const mousePos = (0, $eJOHy.useRef)();
    const popupOffset = (0, $eJOHy.useRef)();
    const parentSpan = (0, $eJOHy.useRef)(null);
    const renderers = (0, $6PiGN.useSmartLinkRenderers)();
    const linkState = (0, $cgiz5.useSmartCardState)(url);
    const { loadMetadata: loadMetadata } = (0, $aMAiH.useSmartCardActions)(id, url);
    const setMousePosition = (0, $eJOHy.useCallback)((event)=>{
        if (isOpen && canOpen) return;
        mousePos.current = {
            x: event.clientX,
            y: event.clientY
        };
        //If these are undefined then popupOffset is undefined and we fallback to default bottom-start placement
        if ((!isOpen || !canOpen) && parentSpan.current && mousePos.current) {
            const { bottom: bottom, left: left } = parentSpan.current.getBoundingClientRect();
            popupOffset.current = [
                mousePos.current.x - left + (0, $64RLL.CARD_GAP_PX),
                mousePos.current.y - bottom + (0, $64RLL.CARD_GAP_PX)
            ];
        }
    }, [
        canOpen,
        isOpen
    ]);
    const hideCard = (0, $eJOHy.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const initHideCard = (0, $eJOHy.useCallback)(()=>{
        if (fadeInTimeoutId.current) {
            clearTimeout(fadeInTimeoutId.current);
            // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress fade in event
            fadeInTimeoutId.current = undefined;
        }
        if (resolveTimeOutId.current) {
            clearTimeout(resolveTimeOutId.current);
            // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress resolve event
            resolveTimeOutId.current = undefined;
        }
        if (noFadeDelay) hideCard();
        else fadeOutTimeoutId.current = setTimeout(()=>hideCard(), $9f099b40d6720ae9$var$FADE_OUT_DELAY);
    }, [
        hideCard,
        noFadeDelay
    ]);
    // clearing out the timeouts in order to avoid memory leaks
    // in case the component unmounts before they execute
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
            if (fadeInTimeoutId.current) {
                clearTimeout(fadeInTimeoutId.current);
                // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress fade in event
                fadeInTimeoutId.current = undefined;
            }
            if (resolveTimeOutId.current) {
                clearTimeout(resolveTimeOutId.current);
                // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress resolve event
                resolveTimeOutId.current = undefined;
            }
        };
    }, []);
    // we want to initiate resolve a bit earlier for standalone cards
    // to minimize the loading state
    const initResolve = (0, $eJOHy.useCallback)(()=>{
        // this check covers both non-SSR (status) & SSR case (metadataStatus)
        const isLinkUnresolved = linkState.status === 'pending' || !linkState.metadataStatus;
        if (!resolveTimeOutId.current && isLinkUnresolved) resolveTimeOutId.current = setTimeout(()=>{
            loadMetadata();
        }, $9f099b40d6720ae9$var$RESOLVE_DELAY);
    }, [
        linkState.metadataStatus,
        linkState.status,
        loadMetadata
    ]);
    const initShowCard = (0, $eJOHy.useCallback)((event)=>{
        // clearing out fadeOutTimeoutId in case it's already counting down to hide the card
        if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
        // starting to resolve the hover card if the store doesn't have data about the link yet
        initResolve();
        //Set mouse position in the case it's not already set by onMouseMove, as in the case of scrolling
        setMousePosition(event);
        if (!isOpen && !fadeInTimeoutId.current) {
            // setting a timeout to show a Hover Card after delay runs out
            if (noFadeDelay) setIsOpen(true);
            else fadeInTimeoutId.current = setTimeout(()=>{
                setIsOpen(true);
            }, fadeInDelay);
        }
    }, [
        initResolve,
        isOpen,
        setMousePosition,
        noFadeDelay,
        fadeInDelay
    ]);
    const onActionClick = (0, $eJOHy.useCallback)((actionId)=>{
        if (actionId === (0, $4D53f.ActionName).PreviewAction || actionId === (0, $4D53f.ActionName).AutomationAction) hideCard();
    }, [
        hideCard
    ]);
    // Stop hover preview content to propagate event to parent.
    const handleChildClick = (0, $eJOHy.useCallback)((e, closeOnClick)=>{
        if (!allowEventPropagation) e.stopPropagation();
        if (closeOnClick) hideCard();
    }, [
        allowEventPropagation,
        hideCard
    ]);
    const onContextMenuClick = (0, $eJOHy.useCallback)((e)=>handleChildClick(e, true), [
        handleChildClick
    ]);
    const onChildClick = (0, $eJOHy.useCallback)((e)=>handleChildClick(e, closeOnChildClick), [
        closeOnChildClick,
        handleChildClick
    ]);
    const content = (0, $eJOHy.useCallback)(({ update: update })=>{
        const hoverCardContentProps = {
            onMouseEnter: initShowCard,
            onMouseLeave: initHideCard,
            cardState: linkState,
            onActionClick: onActionClick,
            onResolve: update,
            renderers: renderers,
            actionOptions: actionOptions,
            url: url,
            id: id
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aBejd.SmartLinkAnalyticsContext), {
            url: url,
            display: (0, $4D53f.CardDisplay).HoverCardPreview,
            id: id,
            source: $9f099b40d6720ae9$export$421dbc3834daf261,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9JJsa.default), {
                ...hoverCardContentProps
            })
        });
    }, [
        initShowCard,
        initHideCard,
        linkState,
        onActionClick,
        renderers,
        actionOptions,
        url,
        id
    ]);
    const trigger = (0, $eJOHy.useCallback)(({ 'aria-haspopup': ariaHasPopup, 'aria-expanded': ariaExpanded, ...triggerProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            ref: parentSpan,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                ...triggerProps,
                // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
                onMouseOver: initShowCard,
                onMouseLeave: initHideCard,
                onMouseMove: setMousePosition,
                onClick: onChildClick,
                onContextMenu: onContextMenuClick,
                "data-testid": $9f099b40d6720ae9$var$HOVER_CARD_TRIGGER_WRAPPER,
                ...(0, $aH6JV.editorExperiment)('platform_editor_preview_panel_linking_exp', true) ? {
                    className: $9f099b40d6720ae9$var$HOVER_CARD_TRIGGER_WRAPPER
                } : {},
                children: children
            })
        }), [
        children,
        initHideCard,
        initShowCard,
        onChildClick,
        onContextMenuClick,
        setMousePosition
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6X0vU.default), {
        testId: "hover-card",
        isOpen: isOpen && canOpen,
        onClose: hideCard,
        placement: "bottom-start",
        offset: popupOffset.current,
        autoFocus: false,
        content: content,
        trigger: trigger,
        zIndex: zIndex,
        role: role,
        titleId: titleId,
        label: label,
        // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        popupComponent: (0, $ePS3w.default)
    });
};

});
parcelRegister("ePS3w", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb7ae289ab034d11$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
/**
 * The purpose of this component is to hide the default Popup border.
 * HoverCard border implementation is in ContentContainer where it can
 * change between the default border and prism border during runtime.
 */ const $cb7ae289ab034d11$var$CustomPopupContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ children: children, shouldFitContainer: _, shouldRenderToParent: __, ...props }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...props,
        ref: ref,
        children: children
    }));
var $cb7ae289ab034d11$export$2e2bcd8739ae039 = $cb7ae289ab034d11$var$CustomPopupContainer;

});

parcelRegister("9JJsa", function(module, exports) {
$parcel$export(module.exports, "hoverCardClassName", () => $2cd8f95c49449370$export$34883cbaea18402d);
$parcel$export(module.exports, "default", () => $2cd8f95c49449370$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aqlRB = parcelRequire("aqlRB");

var $aeACg = parcelRequire("aeACg");

var $kePQU = parcelRequire("kePQU");

var $5RpiZ = parcelRequire("5RpiZ");

var $4D53f = parcelRequire("4D53f");

var $75Eqs = parcelRequire("75Eqs");

var $cgiz5 = parcelRequire("cgiz5");

var $cHEjl = parcelRequire("cHEjl");

var $92TYi = parcelRequire("92TYi");

var $eVkTT = parcelRequire("eVkTT");

var $64RLL = parcelRequire("64RLL");

var $2sijv = parcelRequire("2sijv");

var $3nwp7 = parcelRequire("3nwp7");

var $7YHQ3 = parcelRequire("7YHQ3");

var $5G0Fa = parcelRequire("5G0Fa");

var $fqD0G = parcelRequire("fqD0G");

var $94Ozl = parcelRequire("94Ozl");
const $2cd8f95c49449370$export$34883cbaea18402d = 'smart-links-hover-preview';
const $2cd8f95c49449370$var$HoverCardContent = ({ id: id = '', cardState: cardState, onActionClick: onActionClick, onResolve: onResolve, renderers: renderers, url: url, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, actionOptions: actionOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $aqlRB.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $5RpiZ.useAnalyticsEvents)();
    const extensionKey = (0, $eJOHy.useMemo)(()=>(0, $75Eqs.getExtensionKey)(cardState.details), [
        cardState.details
    ]);
    const linkState = (0, $cgiz5.useSmartCardState)(url);
    const linkStatus = linkState.status ?? 'pending';
    const definitionId = (0, $eJOHy.useMemo)(()=>(0, $75Eqs.getDefinitionId)(cardState.details), [
        cardState.details
    ]);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $aeACg.useSmartLinkContext)();
    const isAISummaryEnabled = (0, $92TYi.getIsAISummaryEnabled)(isAdminHubAIEnabled, cardState.details);
    const services = (0, $75Eqs.getServices)(linkState.details);
    const statusRef = (0, $eJOHy.useRef)(linkStatus);
    const fireEventRef = (0, $eJOHy.useRef)(fireEvent);
    const definitionIdRef = (0, $eJOHy.useRef)(definitionId);
    (0, $eJOHy.useEffect)(()=>{
        /**
		 * Must access object value via ref because its not stable
		 * and it can trigger useEffect to re-run below
		 */ if (statusRef.current !== linkStatus) statusRef.current = linkStatus;
        if (fireEventRef.current !== fireEvent) fireEventRef.current = fireEvent;
        if (definitionIdRef.current !== definitionId) definitionIdRef.current = definitionId;
    }, [
        linkStatus,
        fireEvent,
        definitionId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const previewDisplay = 'card';
        const previewInvokeMethod = 'mouse_hover';
        const cardOpenTime = Date.now();
        const fireEventCurrent = fireEventRef.current;
        fireEventCurrent('ui.hoverCard.viewed', {
            previewDisplay: previewDisplay,
            previewInvokeMethod: previewInvokeMethod,
            definitionId: definitionIdRef.current ?? null
        });
        return ()=>{
            const hoverTime = Date.now() - cardOpenTime;
            fireEventCurrent('ui.hoverCard.dismissed', {
                previewDisplay: previewDisplay,
                previewInvokeMethod: previewInvokeMethod,
                hoverTime: hoverTime,
                definitionId: definitionIdRef.current ?? null
            });
        };
    }, []);
    const onClick = (0, $eJOHy.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $cHEjl.isSpecialEvent)(event);
        fireEvent('ui.smartLink.clicked.titleGoToLink', {
            id: id,
            display: (0, $4D53f.CardDisplay).HoverCardPreview,
            isModifierKeyPressed: isModifierKeyPressed,
            definitionId: definitionId ?? null
        });
        (0, $eVkTT.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        createAnalyticsEvent,
        id,
        fireEvent,
        definitionId
    ]);
    const data = cardState.details?.data;
    const { subtitle: subtitle } = (0, $2sijv.getMetadata)(extensionKey, data);
    const titleMaxLines = subtitle && subtitle.length > 0 ? 1 : 2;
    const titleBlockProps = {
        maxLines: titleMaxLines,
        size: (0, $4D53f.SmartLinkSize).Large,
        position: (0, $4D53f.SmartLinkPosition).Center,
        subtitle: subtitle
    };
    const uiOptions = (0, $64RLL.flexibleUiOptions);
    if ((0, $kePQU.fg)('cc-ai-linking-platform-snippet-renderer')) uiOptions.enableSnippetRenderer = true;
    const flexibleCardProps = {
        appearance: (0, $4D53f.CardDisplay).HoverCardPreview,
        cardState: cardState,
        onClick: onClick,
        onResolve: onResolve,
        origin: 'smartLinkPreviewHoverCard',
        renderers: renderers,
        actionOptions: actionOptions,
        ui: uiOptions,
        url: url,
        children: null
    };
    const onClickStopPropagation = (0, $eJOHy.useCallback)((e)=>e.stopPropagation(), []);
    const getCardView = (cardState)=>{
        if (cardState.metadataStatus === 'pending') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fqD0G.default), {
            flexibleCardProps: flexibleCardProps,
            titleBlockProps: titleBlockProps
        });
        if (cardState.status === 'unauthorized' && services?.length) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $94Ozl.default), {
            extensionKey: extensionKey,
            id: id,
            flexibleCardProps: flexibleCardProps,
            url: url
        });
        if (cardState.status === 'forbidden' || cardState.status === 'not_found') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7YHQ3.default), {
            flexibleCardProps: flexibleCardProps
        });
        if (cardState.status === 'resolved') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5G0Fa.default), {
            cardState: cardState,
            extensionKey: extensionKey,
            flexibleCardProps: flexibleCardProps,
            isAISummaryEnabled: isAISummaryEnabled,
            onActionClick: onActionClick,
            titleBlockProps: titleBlockProps,
            url: url
        });
        return null;
    };
    const cardView = getCardView(cardState);
    return cardView ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3nwp7.default), {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onClickStopPropagation,
        isAIEnabled: isAISummaryEnabled,
        url: url,
        children: cardView
    }) : null;
};
var $2cd8f95c49449370$export$2e2bcd8739ae039 = $2cd8f95c49449370$var$HoverCardContent;

});
parcelRegister("64RLL", function(module, exports) {
$parcel$export(module.exports, "HOVER_CARD_Z_INDEX", () => $1762c586a958a869$export$8245b0eaabf3440c);
$parcel$export(module.exports, "flexibleUiOptions", () => $1762c586a958a869$export$8e022b7269e8199a);
$parcel$export(module.exports, "CARD_WIDTH_REM", () => $1762c586a958a869$export$a0a37c997fbcd678);
$parcel$export(module.exports, "CARD_GAP_PX", () => $1762c586a958a869$export$e7cae8c75d768024);

var $fmxRJ = parcelRequire("fmxRJ");

var $4D53f = parcelRequire("4D53f");
const $1762c586a958a869$export$8245b0eaabf3440c = (0, $fmxRJ.layers).modal();
const $1762c586a958a869$export$8e022b7269e8199a = {
    hideBackground: true,
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true,
    size: (0, $4D53f.SmartLinkSize).Medium,
    zIndex: $1762c586a958a869$export$8245b0eaabf3440c + 1
};
const $1762c586a958a869$export$a0a37c997fbcd678 = 24;
const $1762c586a958a869$export$e7cae8c75d768024 = 10; // gap between mouse cursor and hover card

});

parcelRegister("2sijv", function(module, exports) {
$parcel$export(module.exports, "getMetadata", () => $54c713ce7b178e93$export$8548546c0aa631e6);

var $9Xp5L = parcelRequire("9Xp5L");

var $4D53f = parcelRequire("4D53f");

var $1YNHg = parcelRequire("1YNHg");
const $54c713ce7b178e93$var$getSimulatedBetterMetadata = (extensionKey, data)=>{
    const types = data ? (0, $9Xp5L.extractType)(data) : undefined;
    const defaultMetadata = {
        primary: [
            (0, $4D53f.ElementName).AuthorGroup,
            (0, $4D53f.ElementName).ModifiedOn
        ]
    };
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            if (types?.includes('atlassian:SourceCodePullRequest')) return {
                primary: [
                    (0, $4D53f.ElementName).AuthorGroup,
                    (0, $4D53f.ElementName).ModifiedOn,
                    (0, $4D53f.ElementName).SubscriberCount,
                    (0, $4D53f.ElementName).State
                ],
                subtitle: [
                    (0, $4D53f.ElementName).SourceBranch,
                    (0, $4D53f.ElementName).TargetBranch
                ]
            };
            if (types?.includes('schema:DigitalDocument')) return {
                primary: [
                    (0, $4D53f.ElementName).LatestCommit,
                    (0, $4D53f.ElementName).CollaboratorGroup,
                    (0, $4D53f.ElementName).ModifiedOn
                ]
            };
            return {
                primary: [
                    (0, $4D53f.ElementName).AuthorGroup,
                    (0, $4D53f.ElementName).ModifiedOn
                ]
            };
        case 'confluence-object-provider':
            const primaryAttribution = data && (0, $1YNHg.extractOwnedBy)(data) ? (0, $4D53f.ElementName).OwnedByGroup : (0, $4D53f.ElementName).AuthorGroup;
            return {
                primary: [
                    primaryAttribution,
                    (0, $4D53f.ElementName).ModifiedOn
                ],
                tertiary: [
                    (0, $4D53f.ElementName).ReactCount,
                    (0, $4D53f.ElementName).CommentCount,
                    (0, $4D53f.ElementName).ViewCount
                ]
            };
        case 'jira-object-provider':
            const isJiraTask = data?.['@type']?.includes('atlassian:Task') ?? false;
            return {
                ...defaultMetadata,
                ...isJiraTask && {
                    primary: [
                        (0, $4D53f.ElementName).AssignedToGroup,
                        (0, $4D53f.ElementName).State,
                        (0, $4D53f.ElementName).StoryPoints,
                        (0, $4D53f.ElementName).Priority
                    ]
                }
            };
        case 'trello-object-provider':
            return {
                primary: [
                    (0, $4D53f.ElementName).CollaboratorGroup,
                    (0, $4D53f.ElementName).State,
                    (0, $4D53f.ElementName).DueOn
                ],
                secondary: [
                    (0, $4D53f.ElementName).ReactCount,
                    (0, $4D53f.ElementName).CommentCount,
                    (0, $4D53f.ElementName).AttachmentCount,
                    (0, $4D53f.ElementName).ChecklistProgress
                ],
                subtitle: [
                    (0, $4D53f.ElementName).Location
                ]
            };
        case 'watermelon-object-provider':
            if (types?.includes('atlassian:Project')) return {
                primary: [
                    (0, $4D53f.ElementName).AuthorGroup,
                    (0, $4D53f.ElementName).ModifiedOn,
                    (0, $4D53f.ElementName).State,
                    (0, $4D53f.ElementName).DueOn
                ]
            };
            return {
                primary: [
                    (0, $4D53f.ElementName).AuthorGroup,
                    (0, $4D53f.ElementName).State,
                    (0, $4D53f.ElementName).DueOn
                ]
            };
        case 'slack-object-provider':
            return {
                primary: [
                    (0, $4D53f.ElementName).AuthorGroup,
                    (0, $4D53f.ElementName).SentOn
                ],
                tertiary: [
                    (0, $4D53f.ElementName).ReactCount,
                    (0, $4D53f.ElementName).CommentCount
                ]
            };
        case 'google-object-provider':
        case 'figma-object-provider':
            return {
                primary: [
                    (0, $4D53f.ElementName).AuthorGroup,
                    (0, $4D53f.ElementName).ModifiedOn
                ]
            };
        default:
            return defaultMetadata;
    }
};
const $54c713ce7b178e93$var$AvatarGroupsWithNamePrefix = [
    (0, $4D53f.ElementName).AssignedToGroup,
    (0, $4D53f.ElementName).OwnedByGroup,
    (0, $4D53f.ElementName).AuthorGroup
];
const $54c713ce7b178e93$var$toElementItem = (name)=>{
    const showNamePrefix = $54c713ce7b178e93$var$AvatarGroupsWithNamePrefix.indexOf(name) !== -1 ? true : undefined;
    const testId = `${name.toLowerCase()}-metadata-element`;
    return {
        name: name,
        showNamePrefix: showNamePrefix,
        testId: testId
    };
};
const $54c713ce7b178e93$var$toElementItems = (elementNames)=>{
    if (!elementNames?.length) return;
    return elementNames.filter((name)=>name in (0, $4D53f.ElementName)).map($54c713ce7b178e93$var$toElementItem);
};
const $54c713ce7b178e93$export$8548546c0aa631e6 = (extensionKey, data)=>{
    const metadata = $54c713ce7b178e93$var$getSimulatedBetterMetadata(extensionKey, data);
    const primary = [].concat(metadata.primary, metadata.tertiary);
    return {
        subtitle: $54c713ce7b178e93$var$toElementItems(metadata.subtitle),
        primary: $54c713ce7b178e93$var$toElementItems(primary),
        secondary: $54c713ce7b178e93$var$toElementItems(metadata.secondary)
    };
};

});
parcelRegister("1YNHg", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkCommentCount", () => $743b8b64af4f66b8$export$fb0960a89fb9c17b);
$parcel$export(module.exports, "extractAppliedToComponentsCount", () => $743b8b64af4f66b8$export$4356c594f5c138d6);
$parcel$export(module.exports, "extractDueOn", () => $743b8b64af4f66b8$export$ac56bd7a37249b48);
$parcel$export(module.exports, "extractViewCount", () => $743b8b64af4f66b8$export$e57334ce4738e29d);
$parcel$export(module.exports, "extractSmartLinkReactCount", () => $743b8b64af4f66b8$export$bb52c21c67a309ca);
$parcel$export(module.exports, "extractVoteCount", () => $743b8b64af4f66b8$export$c8bef3d5e550a3a);
$parcel$export(module.exports, "extractOwnedBy", () => $743b8b64af4f66b8$export$75b4b5a156f48ff3);
$parcel$export(module.exports, "extractAssignedTo", () => $743b8b64af4f66b8$export$5546969a505305);
$parcel$export(module.exports, "extractPersonAssignedToAsArray", () => $743b8b64af4f66b8$export$edb8a7a44b91274e);
$parcel$export(module.exports, "extractProgrammingLanguage", () => $743b8b64af4f66b8$export$43e54589935a1ff);
$parcel$export(module.exports, "extractSourceBranch", () => $743b8b64af4f66b8$export$949ac6a8325b3fdb);
$parcel$export(module.exports, "extractSubscriberCount", () => $743b8b64af4f66b8$export$8bd03a7beb5badf1);
$parcel$export(module.exports, "extractTeamMemberCount", () => $743b8b64af4f66b8$export$9fc8706c6cb5343a);
$parcel$export(module.exports, "extractAttachmentCount", () => $743b8b64af4f66b8$export$65362ff78a97fd8);
$parcel$export(module.exports, "extractTargetBranch", () => $743b8b64af4f66b8$export$29b0ac5d2f9890cf);
$parcel$export(module.exports, "extractChecklistProgress", () => $743b8b64af4f66b8$export$dd980f9881b65d9c);
$parcel$export(module.exports, "extractLocation", () => $743b8b64af4f66b8$export$9df94c77b0746c3c);
$parcel$export(module.exports, "extractSubTasksProgress", () => $743b8b64af4f66b8$export$744e3a2674114c1d);
$parcel$export(module.exports, "extractUserAttributes", () => $743b8b64af4f66b8$export$6052f26bb463e370);
$parcel$export(module.exports, "extractReadTime", () => $743b8b64af4f66b8$export$cc4028b2878d0675);
$parcel$export(module.exports, "extractSmartLinkSentOn", () => $743b8b64af4f66b8$export$5c05c5b7ca37e36e);
$parcel$export(module.exports, "extractStoryPoints", () => $743b8b64af4f66b8$export$bdcea84d1550eb9d);
$parcel$export(module.exports, "extractMetaObjectId", () => $743b8b64af4f66b8$export$bec1443e3e33b166);
$parcel$export(module.exports, "extractMetaResourceType", () => $743b8b64af4f66b8$export$11d1314ebbee594e);
$parcel$export(module.exports, "extractMetaTenantId", () => $743b8b64af4f66b8$export$92037aea7f27bf7f);

var $eyXxY = parcelRequire("eyXxY");
var $7kkmS = parcelRequire("7kkmS");
var $45XPC = parcelRequire("45XPC");
var $fAobW = parcelRequire("fAobW");
var $bP0JM = parcelRequire("bP0JM");
const $743b8b64af4f66b8$var$extractLinkName = (link)=>{
    if (link && typeof link === 'object' && link['@type'] === 'Link') return link.name;
};
const $743b8b64af4f66b8$var$extractValue = (data, key)=>{
    return data?.[key];
};
const $743b8b64af4f66b8$export$b68822b76d5d51d5 = (data)=>$743b8b64af4f66b8$var$extractValue(data, 'schema:commentCount');
const $743b8b64af4f66b8$export$fb0960a89fb9c17b = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $eyXxY.isEntityPresent)(response)) {
        const entity = (0, $eyXxY.extractEntity)(response);
        return entity && 'commentCount' in entity && typeof entity.commentCount === 'number' ? entity?.commentCount : undefined;
    }
    return response?.data && $743b8b64af4f66b8$export$b68822b76d5d51d5(response?.data);
};
const $743b8b64af4f66b8$export$4356c594f5c138d6 = (data)=>$743b8b64af4f66b8$var$extractValue(data, 'atlassian:appliedToComponentsCount');
const $743b8b64af4f66b8$export$ac56bd7a37249b48 = (data)=>$743b8b64af4f66b8$var$extractValue(data, 'endTime');
const $743b8b64af4f66b8$export$e57334ce4738e29d = (data)=>$743b8b64af4f66b8$var$extractValue(data, 'atlassian:viewCount');
const $743b8b64af4f66b8$export$44130aa92252501 = (data)=>$743b8b64af4f66b8$var$extractValue(data, 'atlassian:reactCount');
const $743b8b64af4f66b8$export$bb52c21c67a309ca = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $eyXxY.isEntityPresent)(response)) {
        const entity = (0, $eyXxY.extractEntity)(response);
        const reactions = entity && 'reactions' in entity && Array.isArray(entity.reactions) ? entity.reactions : undefined;
        return reactions?.reduce((total, reaction)=>total + reaction?.total, 0);
    }
    return response?.data && $743b8b64af4f66b8$export$44130aa92252501(response?.data);
};
const $743b8b64af4f66b8$export$c8bef3d5e550a3a = (data)=>$743b8b64af4f66b8$var$extractValue(data, 'atlassian:voteCount');
const $743b8b64af4f66b8$export$75b4b5a156f48ff3 = (data)=>{
    const persons = (0, $fAobW.extractPersonOwnedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $743b8b64af4f66b8$export$5546969a505305 = (data)=>{
    const person = (0, $7kkmS.extractPersonAssignedTo)(data);
    if (person) return person.name;
};
const $743b8b64af4f66b8$export$edb8a7a44b91274e = (data)=>{
    const person = (0, $7kkmS.extractPersonAssignedTo)(data);
    return person ? [
        person
    ] : undefined;
};
const $743b8b64af4f66b8$export$69b10d653f96288b = (data)=>{
    const persons = (0, $45XPC.extractPersonCreatedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $743b8b64af4f66b8$export$bcb193c84c865ec9 = (data)=>{
    const person = (0, $bP0JM.extractPersonUpdatedBy)(data);
    if (person) return person.name;
};
const $743b8b64af4f66b8$export$43e54589935a1ff = (data)=>$743b8b64af4f66b8$var$extractValue(data, 'schema:programmingLanguage');
const $743b8b64af4f66b8$export$949ac6a8325b3fdb = (data)=>$743b8b64af4f66b8$var$extractLinkName(data['atlassian:mergeSource']);
const $743b8b64af4f66b8$export$8bd03a7beb5badf1 = (data)=>$743b8b64af4f66b8$var$extractValue(data, 'atlassian:subscriberCount');
const $743b8b64af4f66b8$export$9fc8706c6cb5343a = (data)=>{
    const val = data?.attributedTo ? Array.isArray(data?.attributedTo) ? data?.attributedTo.length : 0 : 0;
    return val;
};
const $743b8b64af4f66b8$export$65362ff78a97fd8 = (data)=>$743b8b64af4f66b8$var$extractValue(data, 'atlassian:attachmentCount');
const $743b8b64af4f66b8$export$29b0ac5d2f9890cf = (data)=>$743b8b64af4f66b8$var$extractLinkName(data['atlassian:mergeDestination']);
const $743b8b64af4f66b8$export$dd980f9881b65d9c = (data)=>{
    const checkItemsObj = $743b8b64af4f66b8$var$extractValue(data, 'atlassian:checkItems');
    return checkItemsObj ? `${checkItemsObj.checkedItems}/${checkItemsObj.totalItems}` : undefined;
};
const $743b8b64af4f66b8$export$9df94c77b0746c3c = (data)=>{
    const { url: url, name: name } = $743b8b64af4f66b8$var$extractValue(data, 'location') || {};
    if (url && name && typeof url === 'string') return {
        text: name,
        url: url
    };
};
const $743b8b64af4f66b8$export$744e3a2674114c1d = (data)=>{
    const subTasksObject = $743b8b64af4f66b8$var$extractValue(data, 'atlassian:subTasks');
    return subTasksObject && subTasksObject.totalCount ? `${subTasksObject.resolvedCount}/${subTasksObject.totalCount}` : undefined;
};
const $743b8b64af4f66b8$export$6052f26bb463e370 = (data)=>{
    return data?.userAttributes;
};
const $743b8b64af4f66b8$export$cc4028b2878d0675 = (data)=>{
    return $743b8b64af4f66b8$var$extractValue(data, 'atlassian:readTimeInMinutes');
};
const $743b8b64af4f66b8$export$b592ddecae70b61d = (data)=>{
    return $743b8b64af4f66b8$var$extractValue(data, 'dateSent');
};
const $743b8b64af4f66b8$export$5c05c5b7ca37e36e = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $eyXxY.isEntityPresent)(response)) return (0, $eyXxY.extractEntity)(response)?.createdAt;
    return response?.data && $743b8b64af4f66b8$export$b592ddecae70b61d(response?.data);
};
const $743b8b64af4f66b8$export$bdcea84d1550eb9d = (data)=>{
    return $743b8b64af4f66b8$var$extractValue(data, 'atlassian:storyPoints');
};
const $743b8b64af4f66b8$export$bec1443e3e33b166 = (meta)=>meta.objectId;
const $743b8b64af4f66b8$export$11d1314ebbee594e = (meta)=>meta.resourceType;
const $743b8b64af4f66b8$export$92037aea7f27bf7f = (meta)=>meta.tenantId;

});
parcelRegister("7kkmS", function(module, exports) {
$parcel$export(module.exports, "extractPersonAssignedTo", () => $387a617c40d9b3e0$export$38a0979ebf273662);

var $6aZLo = parcelRequire("6aZLo");
const $387a617c40d9b3e0$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return (0, $6aZLo.extractPersonFromJsonLd)(assignedTo);
};

});

parcelRegister("fAobW", function(module, exports) {
$parcel$export(module.exports, "extractPersonOwnedBy", () => $1f28e8b392dd3b63$export$19ee667f3f7a6ec3);

var $6aZLo = parcelRequire("6aZLo");
const $1f28e8b392dd3b63$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map((0, $6aZLo.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $6aZLo.extractPersonFromJsonLd)(ownedBy);
            if (item) return [
                item
            ];
        }
    }
};

});



parcelRegister("3nwp7", function(module, exports) {
$parcel$export(module.exports, "default", () => $d037fa1701a837ae$export$2e2bcd8739ae039);
/* ContentContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $55smc = parcelRequire("55smc");

var $29KDj = parcelRequire("29KDj");

var $9JJsa = parcelRequire("9JJsa");
const $d037fa1701a837ae$var$NEW_CARD_WIDTH_REM = 25;
const $d037fa1701a837ae$var$HoverCardContainerStyle = null;
const $d037fa1701a837ae$var$popupContainerStyles = null;
const $d037fa1701a837ae$var$ConnectedAIPrismContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>{
    (0, $gRw8I.di)((0, $55smc.default), (0, $29KDj.default));
    const { state: { status: status } } = (0, $55smc.default)(url);
    const [showPrism, setShowPrism] = (0, $eJOHy.useState)(status === 'loading');
    (0, $eJOHy.useEffect)(()=>{
        setShowPrism(status === 'loading');
    }, [
        status
    ]);
    const container = /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_11q7glyw _189eidpf _vchhusvi _1bsb1f23 _9spsglyw",
            !isAIEnabled && "_2rko1mok _bfhk1bhr _16qs1e6u",
            (0, $9JJsa.hoverCardClassName)
        ]),
        "data-testid": testId,
        ...props,
        children: children
    });
    return isAIEnabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $29KDj.default), {
        isVisible: showPrism,
        testId: `${testId}-prism`,
        children: container
    }) : container;
};
const $d037fa1701a837ae$var$ContentContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)($d037fa1701a837ae$var$ConnectedAIPrismContainer, {
        isAIEnabled: isAIEnabled,
        url: url,
        testId: testId,
        ...props,
        children: children
    });
var $d037fa1701a837ae$export$2e2bcd8739ae039 = $d037fa1701a837ae$var$ContentContainer;

});
parcelRegister("29KDj", function(module, exports) {
$parcel$export(module.exports, "default", () => $82fdaaa1d6b7c65b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8Ku1L = parcelRequire("8Ku1L");

var $lGEcJ = parcelRequire("lGEcJ");

var $lAHBO = parcelRequire("lAHBO");
const $82fdaaa1d6b7c65b$var$contentStyles = null;
const $82fdaaa1d6b7c65b$var$contentStylesPrismVisible = null;
const $82fdaaa1d6b7c65b$var$animatedSvgContainerStyles = {
    true: "_v564fs5d _tzy4kb7n",
    false: "_v564fs5d _tzy4idpf"
};
const $82fdaaa1d6b7c65b$var$popupContainerStyles = null;
const $82fdaaa1d6b7c65b$var$AIPrism = ({ children: children, isGlowing: isGlowing = true, isMoving: isMoving = true, isVisible: isVisible, testId: testId })=>{
    const { colorMode: colorMode = 'light' } = (0, $8Ku1L.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lGEcJ.default), {
        palette: (0, $lAHBO.AI_BORDER_PALETTE)[colorMode] ?? (0, $lAHBO.AI_BORDER_PALETTE).light,
        isGlowing: isGlowing,
        isMoving: isMoving,
        testId: testId,
        className: (0, $hcewu.default)([
            $82fdaaa1d6b7c65b$var$animatedSvgContainerStyles[isVisible ? 'true' : 'false']
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            className: (0, $hcewu.default)([
                "_2rko1mok _bfhk1bhr _16qs1e6u",
                "_v5649spz",
                isVisible && "_16qs1sqb"
            ]),
            children: children
        })
    });
};
var $82fdaaa1d6b7c65b$export$2e2bcd8739ae039 = $82fdaaa1d6b7c65b$var$AIPrism;

});
parcelRegister("lGEcJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c901780e6cd6b69$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $9Bb3U = parcelRequire("9Bb3U");
const $8c901780e6cd6b69$var$borderContainerStyles = null;
const $8c901780e6cd6b69$var$borderContentStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $8c901780e6cd6b69$var$AIGlowingBorder = ({ children: children, palette: palette, isMoving: isMoving = true, isGlowing: isGlowing, testId: testId, className: className })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _kqswh2mm _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _1bsb1ns9"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9Bb3U.default), {
                palette: palette,
                isMoving: isMoving,
                className: className
            }),
            isGlowing && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9Bb3U.default), {
                palette: palette,
                isMoving: isMoving,
                isGlowing: true,
                className: className
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                className: (0, $hcewu.default)([
                    "_2rkoftgi _16jlkb7n _1pbykb7n"
                ]),
                children: [
                    children,
                    " "
                ]
            })
        ]
    });
var $8c901780e6cd6b69$export$2e2bcd8739ae039 = $8c901780e6cd6b69$var$AIGlowingBorder;

});
parcelRegister("9Bb3U", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f0bb9d6e30dff30$export$2e2bcd8739ae039);
/* animated-svg-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
let $5f0bb9d6e30dff30$var$namespaceUUID = 0;
const $5f0bb9d6e30dff30$var$svgStyles = null;
const $5f0bb9d6e30dff30$var$blurredStyles = null;
const $5f0bb9d6e30dff30$var$notBlurredStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $5f0bb9d6e30dff30$var$AnimatedSvgContainer = ({ palette: palette, isMoving: isMoving, isGlowing: isGlowing, className: className })=>{
    const svgRef = (0, $eJOHy.useRef)(null);
    const namespaceId = (0, $eJOHy.useRef)();
    if (namespaceId.current === undefined) {
        namespaceId.current = $5f0bb9d6e30dff30$var$namespaceUUID;
        $5f0bb9d6e30dff30$var$namespaceUUID += 1;
    }
    (0, $eJOHy.useEffect)(()=>{
        if (isMoving) {
            const svg = svgRef.current;
            // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg?.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg?.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isMoving
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_2rko19bv _kqswstnw",
            isGlowing ? "_1bsb1wgc _4t3i1wgc _154i1b66 _1ltv1b66 _kdam1rfl _w6ng15vq _t9ec161g" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
            className
        ]),
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg1`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0%",
                        y1: "0",
                        x2: "400%",
                        y2: "0",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x1",
                                from: "0%",
                                to: "400%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x2",
                                from: "400%",
                                to: "800%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg2`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0",
                        y1: "-100%",
                        x2: "0",
                        y2: "300%",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y1",
                                from: "-100%",
                                to: "300%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y2",
                                from: "300%",
                                to: "700%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg3`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "300%",
                        y1: "0",
                        x2: "700%",
                        y2: "0",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x1",
                                from: "300%",
                                to: "-100%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x2",
                                from: "700%",
                                to: "300%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg4`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0",
                        y1: "0",
                        x2: "0",
                        y2: "400%",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y1",
                                from: "0%",
                                to: "-400%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y2",
                                from: "400%",
                                to: "0%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                strokeWidth: "8",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg1)`,
                        d: "M0 0h24",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg2)`,
                        d: "M24 0v24",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg3)`,
                        d: "M24 24H0",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg4)`,
                        d: "M0 24V0",
                        vectorEffect: "non-scaling-stroke"
                    })
                ]
            })
        ]
    });
};
var $5f0bb9d6e30dff30$export$2e2bcd8739ae039 = $5f0bb9d6e30dff30$var$AnimatedSvgContainer;

});


parcelRegister("lAHBO", function(module, exports) {
$parcel$export(module.exports, "AI_BORDER_PALETTE", () => $7721eeae0783d7fa$export$23b7b83c7063ccfe);
const $7721eeae0783d7fa$export$3088ed82e2905d1e = {
    blueUniqueGradientLight: '#00ACF8',
    blueUniqueGradientDark: '#008BD2',
    blue1000: '#092957',
    blue800: '#0055CC',
    blue700: '#0C66E4',
    blue600: '#1D7AFC',
    blue500: '#388BFF',
    blue300: '#85B8FF',
    blue200: '#CCE0FF',
    blue100: '#E9F2FF',
    teal500: '#37B4C3',
    teal300: '#8BDBE5',
    yellow500: '#CF9F02',
    yellow200: '#F8E6A0',
    red800: '#AE2A19',
    red600: '#E34935',
    orange500: '#F18D13',
    orange300: '#FEC57B'
};
const $7721eeae0783d7fa$export$23b7b83c7063ccfe = {
    dark: {
        blue: $7721eeae0783d7fa$export$3088ed82e2905d1e.blue800,
        teal: $7721eeae0783d7fa$export$3088ed82e2905d1e.teal500,
        yellow: $7721eeae0783d7fa$export$3088ed82e2905d1e.yellow500
    },
    light: {
        blue: $7721eeae0783d7fa$export$3088ed82e2905d1e.blue600,
        teal: $7721eeae0783d7fa$export$3088ed82e2905d1e.teal300,
        yellow: $7721eeae0783d7fa$export$3088ed82e2905d1e.yellow200
    }
};

});



parcelRegister("7YHQ3", function(module, exports) {
$parcel$export(module.exports, "default", () => $779a1b6861d7794e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $aqlRB = parcelRequire("aqlRB");

var $3JpAh = parcelRequire("3JpAh");

var $aybSF = parcelRequire("aybSF");

var $j0zes = parcelRequire("j0zes");

var $9o0WU = parcelRequire("9o0WU");

var $cafmZ = parcelRequire("cafmZ");

var $9ztRN = parcelRequire("9ztRN");

var $5dGlr = parcelRequire("5dGlr");
var $2u0se = parcelRequire("2u0se");
const $779a1b6861d7794e$var$titleBlockStyles = null;
const $779a1b6861d7794e$var$mainTextStyles = null;
const $779a1b6861d7794e$var$connectButtonStyles = null;
const $779a1b6861d7794e$var$basePreviewStyles = null;
const $779a1b6861d7794e$var$HoverCardForbiddenView = ({ flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-forbidden-view' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $aqlRB.useAnalyticsEvents)();
    const { cardState: cardState, url: url } = flexibleCardProps;
    const meta = cardState.details?.meta;
    const product = (0, $aybSF.extractSmartLinkProvider)(cardState.details)?.text ?? '';
    const hostname = /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
        children: (0, $9o0WU.default)(url)
    });
    const { action: action, descriptiveMessageKey: descriptiveMessageKey, titleMessageKey: titleMessageKey, buttonDisabled: buttonDisabled } = (0, $j0zes.extractRequestAccessContextImproved)({
        jsonLd: meta,
        url: url,
        product: product,
        createAnalyticsEvent: createAnalyticsEvent
    }) ?? {};
    if (!titleMessageKey || !descriptiveMessageKey) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9ztRN.default), {
        ...flexibleCardProps,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2u0se.default), {
                ignoreContainerPadding: true,
                testId: testId,
                className: (0, $hcewu.default)([
                    "_13li1mok _qrwq1mok _otyru2gc"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5dGlr.default), {
                testId: `${testId}-title`,
                className: (0, $hcewu.default)([
                    "_1bah1h6o _k48p1pd9 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $cafmZ.messages)[titleMessageKey],
                    values: {
                        product: product
                    }
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5dGlr.default), {
                testId: `${testId}-content`,
                className: (0, $hcewu.default)([
                    "_11c8dcr7 _1e0c1nu9 _1bah1h6o _19pkze3t _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $cafmZ.messages)[descriptiveMessageKey],
                    values: {
                        product: product,
                        hostname: hostname
                    }
                })
            }),
            action && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5dGlr.default), {
                className: (0, $hcewu.default)([
                    "_1bah1h6o _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3JpAh.default), {
                    testId: `${testId}-button`,
                    onClick: action?.promise,
                    appearance: "primary",
                    isDisabled: buttonDisabled,
                    children: action?.text
                })
            })
        ]
    });
};
var $779a1b6861d7794e$export$2e2bcd8739ae039 = $779a1b6861d7794e$var$HoverCardForbiddenView;

});
parcelRegister("j0zes", function(module, exports) {
$parcel$export(module.exports, "extractRequestAccessContextImproved", () => $53044ffcfd022d6b$export$846c1540a86749e6);

var $cafmZ = parcelRequire("cafmZ");

var $4dsff = parcelRequire("4dsff");

var $4EOEb = parcelRequire("4EOEb");

var $9o0WU = parcelRequire("9o0WU");
const $53044ffcfd022d6b$export$846c1540a86749e6 = ({ jsonLd: jsonLd, url: url, product: product, createAnalyticsEvent: createAnalyticsEvent })=>{
    const requestAccess = jsonLd?.requestAccess ? {
        ...jsonLd?.requestAccess,
        hostname: (0, $9o0WU.default)(url)
    } : undefined;
    switch(jsonLd?.requestAccess?.accessType){
        case 'DIRECT_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'direct_access_title',
                descriptiveMessageKey: 'direct_access_description',
                callToActionMessageKey: 'direct_access',
                action: (0, $4EOEb.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'crossJoin',
                        eventType: 'ui'
                    }).fire((0, $4dsff.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'direct_access', (0, $cafmZ.messages).direct_access, {
                    product: product
                })
            };
        case 'REQUEST_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'default_no_access_title',
                descriptiveMessageKey: 'request_access_description',
                callToActionMessageKey: 'request_access',
                action: (0, $4EOEb.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $4dsff.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'request_access', (0, $cafmZ.messages).request_access)
            };
        case 'PENDING_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'request_access_pending_title',
                descriptiveMessageKey: 'request_access_pending_description',
                callToActionMessageKey: 'request_access_pending',
                action: (0, $4EOEb.ForbiddenAction)(()=>window.open(url), 'request_access_pending', (0, $cafmZ.messages).request_access_pending),
                buttonDisabled: true
            };
        case 'DENIED_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'request_denied_description'
            };
        case 'ACCESS_EXISTS':
            if (jsonLd?.visibility === 'not_found') return {
                ...requestAccess,
                titleMessageKey: 'not_found_title',
                descriptiveMessageKey: 'not_found_description'
            };
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'access_exists_description',
                callToActionMessageKey: 'request_access',
                action: (0, $4EOEb.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $4dsff.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'access_exists', (0, $cafmZ.messages).request_access)
            };
        case 'FORBIDDEN':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'forbidden_description'
            };
        default:
            return requestAccess;
    }
};

});
parcelRegister("4EOEb", function(module, exports) {
$parcel$export(module.exports, "ForbiddenAction", () => $dda3c6f33b988bbf$export$59f8830fb5467e35);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $cafmZ = parcelRequire("cafmZ");
const $dda3c6f33b988bbf$export$59f8830fb5467e35 = (handler, id = 'connect-other-account', message = (0, $cafmZ.messages).try_another_account, values = {})=>({
        id: id,
        text: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...message,
            values: values
        }),
        promise: ()=>new Promise((resolve)=>resolve(handler())),
        buttonAppearance: 'default'
    });

});

parcelRegister("9o0WU", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d969e616ab0da09$export$2e2bcd8739ae039);
const $4d969e616ab0da09$var$extractHostname = (url)=>{
    try {
        return new URL(url).hostname;
    } catch  {
        return url;
    }
};
var $4d969e616ab0da09$export$2e2bcd8739ae039 = $4d969e616ab0da09$var$extractHostname;

});



parcelRegister("5G0Fa", function(module, exports) {
$parcel$export(module.exports, "default", () => $c0b30bf86c95c3bc$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $5RpiZ = parcelRequire("5RpiZ");

var $4D53f = parcelRequire("4D53f");

var $Md55L = parcelRequire("Md55L");

var $9ztRN = parcelRequire("9ztRN");

var $kJPls = parcelRequire("kJPls");
var $6zeOQ = parcelRequire("6zeOQ");
var $2gQJf = parcelRequire("2gQJf");
var $er7te = parcelRequire("er7te");
var $9vcc4 = parcelRequire("9vcc4");
var $4RQt4 = parcelRequire("4RQt4");

var $2sijv = parcelRequire("2sijv");

var $lWBKY = parcelRequire("lWBKY");
const $c0b30bf86c95c3bc$var$hiddenSnippetStyles = null;
const $c0b30bf86c95c3bc$var$titleBlockStyles = null;
const $c0b30bf86c95c3bc$var$snippetBlockCss = null;
const $c0b30bf86c95c3bc$var$actionBlockCss = null;
const $c0b30bf86c95c3bc$var$HoverCardResolvedView = ({ cardState: cardState, extensionKey: extensionKey, flexibleCardProps: flexibleCardProps, isAISummaryEnabled: isAISummaryEnabled, onActionClick: onActionClick, titleBlockProps: titleBlockProps, id: id })=>{
    const { fireEvent: fireEvent } = (0, $5RpiZ.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        // Since this hover view is only rendered on resolved status,
        // there is no need to check for statuses.
        (0, $Md55L.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
            extensionKey: extensionKey,
            display: (0, $4D53f.CardDisplay).HoverCardPreview
        });
        // UFO will disregard this if authentication experience has not yet been started
        (0, $Md55L.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
            display: (0, $4D53f.CardDisplay).HoverCardPreview
        });
        fireEvent('ui.smartLink.renderSuccess', {
            display: (0, $4D53f.CardDisplay).HoverCardPreview
        });
    }, [
        extensionKey,
        fireEvent,
        id
    ]);
    const data = cardState.details?.data;
    const { primary: primary, secondary: secondary } = (0, $eJOHy.useMemo)(()=>{
        return (0, $2sijv.getMetadata)(extensionKey, data);
    }, [
        data,
        extensionKey
    ]);
    const snippetHeight = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(0);
    const snippetBlockRef = (0, $eJOHy.useRef)(null);
    const onSnippetRender = (0, $eJOHy.useCallback)(()=>{
        snippetHeight.current = snippetBlockRef.current?.getBoundingClientRect().height ?? 0;
    }, []);
    const imagePreview = (0, $lWBKY.default)({
        fallbackElementHeight: snippetHeight.current,
        response: cardState.details
    });
    const snippet = imagePreview ? null : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9vcc4.default), {
        className: (0, $hcewu.default)([
            "_ca0q1b66"
        ])
    });
    const aiSummaryMinHeight = snippet ? snippetHeight.current : 0;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9ztRN.default), {
        ...flexibleCardProps,
        children: [
            imagePreview,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4RQt4.default), {
                ...titleBlockProps,
                metadataPosition: (0, $4D53f.SmartLinkPosition).Top,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _quenze3t _oebj1txw _13mh1pd9"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $er7te.default), {
                primary: primary,
                secondary: secondary,
                maxLines: 1,
                size: (0, $4D53f.SmartLinkSize).Medium
            }),
            isAISummaryEnabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2gQJf.default), {
                aiSummaryMinHeight: aiSummaryMinHeight,
                placeholder: snippet
            }) : snippet,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9vcc4.default), {
                testId: "hidden-snippet",
                onRender: onSnippetRender,
                blockRef: snippetBlockRef,
                isHidden: true,
                className: (0, $hcewu.default)([
                    "_3um015vq _kqswstnw"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJPls.default), {
                onClick: onActionClick,
                spaceInline: "space.100",
                className: (0, $hcewu.default)([
                    "_n3td1b66"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6zeOQ.default), {})
        ]
    });
};
var $c0b30bf86c95c3bc$export$2e2bcd8739ae039 = $c0b30bf86c95c3bc$var$HoverCardResolvedView;

});
parcelRegister("lWBKY", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe18c4750ca8a704$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5jWRq = parcelRequire("5jWRq");

var $2u0se = parcelRequire("2u0se");
const $fe18c4750ca8a704$var$ImagePreview = ({ fallbackElementHeight: fallbackElementHeight, response: response })=>{
    const transitionStarted = (0, $eJOHy.useRef)(false);
    const previewBlockRef = (0, $eJOHy.useRef)(null);
    const [showPreview, setShowPreview] = (0, $eJOHy.useState)(true);
    const [dynamicStyles, setDynamicStyles] = (0, $eJOHy.useState)({});
    // Set Preview to a fixed height to enable transitions
    const onPreviewRender = (0, $eJOHy.useCallback)(()=>{
        if (previewBlockRef.current) {
            const previewHeight = previewBlockRef.current?.getBoundingClientRect().height;
            setDynamicStyles({
                borderTopLeftRadius: "var(--ds-radius-large, 8px)",
                borderTopRightRadius: "var(--ds-radius-large, 8px)",
                marginBottom: "var(--ds-space-100, 8px)",
                ...previewHeight ? {
                    height: `${previewHeight}px`
                } : {}
            });
        }
    }, []);
    // On error set Preview to Fallback height with transition
    const onPreviewError = (0, $eJOHy.useCallback)(()=>{
        if (transitionStarted.current === false) {
            setDynamicStyles({
                transition: 'height 300ms ease-in-out',
                height: `${fallbackElementHeight}px`
            });
            transitionStarted.current = true;
        }
    }, [
        fallbackElementHeight
    ]);
    const onPreviewTransitionEnd = (0, $eJOHy.useCallback)(()=>{
        setShowPreview(false);
    }, []);
    return showPreview && (0, $5jWRq.extractSmartLinkPreviewImage)(response) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2u0se.default), {
        onError: onPreviewError,
        ignoreContainerPadding: true,
        onTransitionEnd: onPreviewTransitionEnd,
        blockRef: previewBlockRef,
        onRender: onPreviewRender,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles
    }) : null;
};
var $fe18c4750ca8a704$export$2e2bcd8739ae039 = $fe18c4750ca8a704$var$ImagePreview;

});
parcelRegister("5jWRq", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkPreviewImage", () => $70662cf043f334c2$export$a79836076066b8b6);

var $eyXxY = parcelRequire("eyXxY");
var $5vtE5 = parcelRequire("5vtE5");

var $4D53f = parcelRequire("4D53f");
const $70662cf043f334c2$var$extractPreview = (data)=>{
    if (!data) return undefined;
    const url = (0, $5vtE5.extractImage)(data);
    return url ? {
        type: (0, $4D53f.MediaType).Image,
        url: url
    } : undefined;
};
var $70662cf043f334c2$export$2e2bcd8739ae039 = $70662cf043f334c2$var$extractPreview;
const $70662cf043f334c2$export$a79836076066b8b6 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $eyXxY.isEntityPresent)(response)) {
        const entity = (0, $eyXxY.extractEntity)(response);
        let url = entity?.thumbnail?.externalUrl;
        return url ? {
            type: (0, $4D53f.MediaType).Image,
            url: url
        } : undefined;
    }
    return $70662cf043f334c2$var$extractPreview(response.data);
};

});
parcelRegister("5vtE5", function(module, exports) {
$parcel$export(module.exports, "extractImage", () => $87acf54ac9292844$export$4c753a1297cb9805);

var $aVLAz = parcelRequire("aVLAz");
const $87acf54ac9292844$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $aVLAz.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $aVLAz.extractUrlFromLinkJsonLd)(image.url);
        }
    }
};

});




parcelRegister("fqD0G", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d5290a8621fbb7c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $5dGlr = parcelRequire("5dGlr");

var $7Fxjf = parcelRequire("7Fxjf");

var $ljtwQ = parcelRequire("ljtwQ");

var $dPaQX = parcelRequire("dPaQX");

var $64RLL = parcelRequire("64RLL");
const $1d5290a8621fbb7c$var$loadingViewContainer = null;
const $1d5290a8621fbb7c$var$skeletonContainer = null;
const $1d5290a8621fbb7c$var$titleStyle = null;
const $1d5290a8621fbb7c$var$titleBlockStyles = null;
const $1d5290a8621fbb7c$var$HoverCardLoadingView = ({ titleBlockProps: titleBlockProps })=>{
    const testId = 'hover-card-loading-view';
    const lineHeightRem = 1.25;
    const skeletonWidth = (0, $64RLL.CARD_WIDTH_REM) - 2;
    const { size: size, actions: actions } = titleBlockProps;
    const actionGroup = actions?.length && actions?.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Fxjf.default), {
        items: actions,
        visibleButtonsNum: 2
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _ca0q1e9d _u5f31e9d _n3td1e9d _19bv1e9d"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            className: (0, $hcewu.default)([
                "_zulpud5o _1e0c1txw _2lx21bp4 _4cvr1h6o"
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $5dGlr.default), {
                    ...titleBlockProps,
                    testId: `${testId}-title-block`,
                    className: (0, $hcewu.default)([
                        "_zulpcxkx _1bsb1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dPaQX.default), {
                            render: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $ljtwQ.LoadingSkeleton), {}),
                            size: size
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            "data-testid": `${testId}-title`,
                            className: (0, $hcewu.default)([
                                "_16jlkb7n _1o9zidpf _i0dl1wug _4t3i1k92 _e2oo1osq"
                            ]),
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ljtwQ.LoadingSkeleton), {
                                height: `${lineHeightRem}rem`
                            })
                        }),
                        actionGroup
                    ]
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ljtwQ.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem}rem`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ljtwQ.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem * 3}rem`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ljtwQ.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem}rem`
                        })
                    ]
                })
            ]
        })
    });
};
var $1d5290a8621fbb7c$export$2e2bcd8739ae039 = $1d5290a8621fbb7c$var$HoverCardLoadingView;

});

parcelRegister("94Ozl", function(module, exports) {
$parcel$export(module.exports, "default", () => $56bc6a5385799ee7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $aybSF = parcelRequire("aybSF");

var $5RpiZ = parcelRequire("5RpiZ");

var $4D53f = parcelRequire("4D53f");

var $cafmZ = parcelRequire("cafmZ");

var $aMAiH = parcelRequire("aMAiH");

var $75Eqs = parcelRequire("75Eqs");

var $kPwer = parcelRequire("kPwer");

var $9ztRN = parcelRequire("9ztRN");

var $5dGlr = parcelRequire("5dGlr");

var $7Fxjf = parcelRequire("7Fxjf");

var $8YgdK = parcelRequire("8YgdK");
const $56bc6a5385799ee7$var$connectButtonStyles = null;
const $56bc6a5385799ee7$var$titleBlockStyles = null;
const $56bc6a5385799ee7$var$mainTextStyles = null;
const $56bc6a5385799ee7$var$HoverCardUnauthorisedView = ({ id: id = '', flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-unauthorised-view', url: url })=>{
    const { cardState: cardState } = flexibleCardProps;
    const providerName = (0, $aybSF.extractSmartLinkProvider)(cardState.details)?.text;
    const isProductIntegrationSupported = (0, $75Eqs.hasAuthScopeOverrides)(cardState.details);
    const { authorize: authorize } = (0, $aMAiH.useSmartCardActions)(id, url);
    const { fireEvent: fireEvent } = (0, $5RpiZ.useAnalyticsEvents)();
    const handleAuthorize = (0, $eJOHy.useCallback)(()=>{
        if (authorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            authorize((0, $4D53f.CardDisplay).HoverCardPreview);
        }
    }, [
        authorize,
        fireEvent
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>[
            {
                name: (0, $4D53f.ActionName).CustomAction,
                content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $cafmZ.messages).connect_unauthorised_account_action,
                    values: {
                        context: providerName
                    }
                }),
                onClick: handleAuthorize
            }
        ], [
        handleAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9ztRN.default), {
        ...flexibleCardProps,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $5dGlr.default), {
                testId: `${testId}-title`,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _13mh1pd9"
                ]),
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8YgdK.default), {}),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $cafmZ.messages).connect_link_account_card_name,
                        values: {
                            context: providerName
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5dGlr.default), {
                testId: `${testId}-content`,
                className: (0, $hcewu.default)([
                    "_11c8dcr7 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kPwer.default), {
                        providerName: providerName,
                        isProductIntegrationSupported: isProductIntegrationSupported
                    })
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5dGlr.default), {
                testId: `${testId}-button`,
                className: (0, $hcewu.default)([
                    "_1bahesu3 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Fxjf.default), {
                    items: actions,
                    appearance: "primary"
                })
            })
        ]
    });
};
var $56bc6a5385799ee7$export$2e2bcd8739ae039 = $56bc6a5385799ee7$var$HoverCardUnauthorisedView;

});
parcelRegister("kPwer", function(module, exports) {
$parcel$export(module.exports, "default", () => $f468d4b8701c7eac$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $kePQU = parcelRequire("kePQU");

var $gq2HZ = parcelRequire("gq2HZ");

var $5RpiZ = parcelRequire("5RpiZ");

var $4D53f = parcelRequire("4D53f");

var $cafmZ = parcelRequire("cafmZ");
/**
 * This component is used in unauthorized views of a smart link.
 * It represents the main text that provides a user with information on how to connect their account
 */ const $f468d4b8701c7eac$var$UnauthorisedViewContent = ({ providerName: providerName, isProductIntegrationSupported: isProductIntegrationSupported, testId: testId = 'unauthorised-view-content' })=>{
    const { fireEvent: fireEvent } = (0, $5RpiZ.useAnalyticsEvents)();
    const handleLearnMoreClick = (0, $eJOHy.useCallback)(()=>{
        fireEvent('ui.button.clicked.learnMore', {});
    }, [
        fireEvent
    ]);
    const learnMoreMessage = isProductIntegrationSupported ? (0, $kePQU.fg)('product-terminology-refresh') ? (0, $cafmZ.messages).learn_more_about_connecting_account_appify : (0, $cafmZ.messages).learn_more_about_connecting_account : (0, $cafmZ.messages).learn_more_about_smart_links;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            providerName ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $kePQU.fg)('product-terminology-refresh') ? (0, $cafmZ.messages).connect_unauthorised_account_description_appify : (0, $cafmZ.messages).connect_unauthorised_account_description,
                values: {
                    context: providerName
                }
            }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $kePQU.fg)('product-terminology-refresh') ? (0, $cafmZ.messages).connect_unauthorised_account_description_no_provider_appify : (0, $cafmZ.messages).connect_unauthorised_account_description_no_provider
            }),
            ' ',
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gq2HZ.default), {
                href: isProductIntegrationSupported ? (0, $4D53f.CONTENT_URL_3P_ACCOUNT_AUTH) : (0, $4D53f.CONTENT_URL_SECURITY_AND_PERMISSIONS),
                target: "_blank",
                testId: `${testId}-learn-more`,
                onClick: handleLearnMoreClick,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...learnMoreMessage
                })
            })
        ]
    });
};
var $f468d4b8701c7eac$export$2e2bcd8739ae039 = $f468d4b8701c7eac$var$UnauthorisedViewContent;

});






parcelRegister("fP5ry", function(module, exports) {
$parcel$export(module.exports, "default", () => $3fe6578008bf3a09$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kePQU = parcelRequire("kePQU");

var $jAPxw = parcelRequire("jAPxw");
const $3fe6578008bf3a09$var$styles = null;
/**
 * An anchor component to cover the entire container creating a clickable area.
 * @internal
 * @see `clickableContainer`
 */ const $3fe6578008bf3a09$var$LayeredLink = ({ onClick: onClick, target: target, testId: testId, text: text, url: url })=>{
    const onMouseDown = (0, $jAPxw.useMouseDownEvent)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _azhw1osq _o5721q9c _hboxstnw _obkmidpf _a52dkb7n",
            "layered-link"
        ]),
        "data-testid": `${testId}-layered-link`,
        href: url,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: target,
        tabIndex: -1,
        "aria-hidden": (0, $kePQU.fg)('navx-1706-smart-link-layered-link-a11y-update'),
        children: text
    });
};
var $3fe6578008bf3a09$export$2e2bcd8739ae039 = $3fe6578008bf3a09$var$LayeredLink;

});


parcelRegister("jZeFf", function(module, exports) {
$parcel$export(module.exports, "getContextByStatus", () => $d946957c5b3a2799$export$e68aec76e359e401);

var $aybSF = parcelRequire("aybSF");

var $kePQU = parcelRequire("kePQU");

var $4D53f = parcelRequire("4D53f");

var $j0zes = parcelRequire("j0zes");

var $5itid = parcelRequire("5itid");

var $fL4Mn = parcelRequire("fL4Mn");

var $5jWRq = parcelRequire("5jWRq");

var $SREp6 = parcelRequire("SREp6");

var $53LXD = parcelRequire("53LXD");

var $cafmZ = parcelRequire("cafmZ");

var $cHEjl = parcelRequire("cHEjl");

var $5pSar = parcelRequire("5pSar");
const $d946957c5b3a2799$export$e68aec76e359e401 = (params)=>{
    const { onClick: onClick, response: response, status: status, url: url } = params ?? {};
    switch(status){
        case (0, $4D53f.SmartLinkStatus).Pending:
        case (0, $4D53f.SmartLinkStatus).Resolving:
            return {
                linkTitle: (0, $fL4Mn.default)(status, url, response, onClick),
                url: url
            };
        case (0, $4D53f.SmartLinkStatus).Resolved:
            return (0, $5itid.default)(params);
        case (0, $4D53f.SmartLinkStatus).Unauthorized:
        case (0, $4D53f.SmartLinkStatus).Forbidden:
        case (0, $4D53f.SmartLinkStatus).NotFound:
        case (0, $4D53f.SmartLinkStatus).Errored:
        case (0, $4D53f.SmartLinkStatus).Fallback:
        default:
            return {
                url: url,
                linkIcon: (0, $SREp6.extractErrorIcon)(response, status),
                linkTitle: (0, $fL4Mn.default)(status, url, response, onClick),
                preview: (0, $5jWRq.extractSmartLinkPreviewImage)(response),
                provider: (0, $53LXD.extractSmartLinkProviderIcon)(response),
                actions: {
                    [(0, $4D53f.InternalActionName).UnresolvedAction]: $d946957c5b3a2799$export$f3d3482baaff4bf6(url, status, response, params.onAuthorize)
                },
                meta: {
                    accessType: response?.meta?.requestAccess?.accessType
                }
            };
    }
};
const $d946957c5b3a2799$var$getForbiddenMessageKey = (meta)=>{
    const accessType = meta?.requestAccess?.accessType;
    switch(accessType){
        case 'DIRECT_ACCESS':
            return (0, $kePQU.fg)('confluence-issue-terminology-refresh') ? 'join_to_viewIssueTermRefresh' : 'join_to_view';
        case 'REQUEST_ACCESS':
            return (0, $kePQU.fg)('confluence-issue-terminology-refresh') ? 'request_access_to_viewIssueTermRefresh' : 'request_access_to_view';
        case 'PENDING_REQUEST_EXISTS':
            return 'pending_request';
        case 'FORBIDDEN':
            return 'forbidden_access';
        case 'DENIED_REQUEST_EXISTS':
            return 'request_denied';
        default:
            return 'restricted_link';
    }
};
const $d946957c5b3a2799$export$f3d3482baaff4bf6 = (url, status, response, onAuthorize)=>{
    const provider = (0, $aybSF.extractSmartLinkProvider)(response);
    const context = provider?.text;
    const values = context ? {
        context: context
    } : undefined;
    switch(status){
        case (0, $4D53f.SmartLinkStatus).Forbidden:
            const meta = response?.meta ?? (0, $5pSar.getForbiddenJsonLd)().meta;
            const access = (0, $j0zes.extractRequestAccessContextImproved)({
                jsonLd: meta,
                url: url,
                product: context ?? ''
            });
            const messageKey = $d946957c5b3a2799$var$getForbiddenMessageKey(meta);
            const descriptor = (0, $cafmZ.messages)[messageKey];
            const retry = onAuthorize || access?.action?.promise;
            const onClick = retry && !(access?.buttonDisabled ?? false) ? (0, $cHEjl.handleOnClick)(retry) : undefined;
            return {
                descriptor: descriptor,
                onClick: onClick,
                values: values
            };
        case (0, $4D53f.SmartLinkStatus).Unauthorized:
            return onAuthorize ? {
                descriptor: (0, $cafmZ.messages).connect_link_account_card_name,
                onClick: (0, $cHEjl.handleOnClick)(onAuthorize),
                values: values
            } : undefined;
        case (0, $4D53f.SmartLinkStatus).NotFound:
            return {
                descriptor: (0, $cafmZ.messages).cannot_find_link
            };
    }
};

});
parcelRegister("5itid", function(module, exports) {
$parcel$export(module.exports, "default", () => $3106300a6bb2a890$export$2e2bcd8739ae039);

var $fAobW = parcelRequire("fAobW");
var $aybSF = parcelRequire("aybSF");
var $9Xp5L = parcelRequire("9Xp5L");

var $kePQU = parcelRequire("kePQU");

var $fhCsJ = parcelRequire("fhCsJ");

var $aFtsL = parcelRequire("aFtsL");

var $d1A7Q = parcelRequire("d1A7Q");

var $fL4Mn = parcelRequire("fL4Mn");

var $5jWRq = parcelRequire("5jWRq");

var $i7cso = parcelRequire("i7cso");

var $3X5rD = parcelRequire("3X5rD");

var $SREp6 = parcelRequire("SREp6");

var $53LXD = parcelRequire("53LXD");

var $kRENZ = parcelRequire("kRENZ");

var $1YNHg = parcelRequire("1YNHg");
const $3106300a6bb2a890$var$extractFlexibleUiContext = ({ appearance: appearance, fireEvent: fireEvent, id: id, onClick: onClick, origin: origin, renderers: renderers, resolve: resolve, actionOptions: actionOptions, response: response, status: status, aiSummaryConfig: aiSummaryConfig, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel, ...props } = {})=>{
    if (!response) return undefined;
    const data = response.data;
    const meta = response.meta;
    const url = (0, $aybSF.extractSmartLinkUrl)(response);
    return {
        actions: (0, $aFtsL.extractFlexibleCardActions)({
            actionOptions: actionOptions,
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response,
            url: props.url,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }),
        appliedToComponentsCount: (0, $1YNHg.extractAppliedToComponentsCount)(data),
        assignedToGroup: (0, $1YNHg.extractPersonAssignedToAsArray)(data),
        attachmentCount: (0, $1YNHg.extractAttachmentCount)(data),
        authorGroup: (0, $aybSF.extractSmartLinkAuthorGroup)(response),
        ownedByGroup: (0, $fAobW.extractPersonOwnedBy)(data),
        collaboratorGroup: (0, $d1A7Q.extractPersonsUpdatedBy)(data),
        commentCount: (0, $1YNHg.extractSmartLinkCommentCount)(response),
        viewCount: (0, $1YNHg.extractViewCount)(data),
        reactCount: (0, $1YNHg.extractSmartLinkReactCount)(response),
        voteCount: (0, $1YNHg.extractVoteCount)(data),
        checklistProgress: (0, $1YNHg.extractChecklistProgress)(data),
        createdBy: (0, $aybSF.extractSmartLinkCreatedBy)(response),
        ownedBy: (0, $1YNHg.extractOwnedBy)(data),
        assignedTo: (0, $1YNHg.extractAssignedTo)(data),
        createdOn: (0, $aybSF.extractSmartLinkCreatedOn)(response),
        dueOn: (0, $1YNHg.extractDueOn)(data),
        latestCommit: (0, $kRENZ.extractLatestCommit)(data),
        linkIcon: (0, $SREp6.extractSmartLinkIcon)(response),
        linkTitle: (0, $fL4Mn.default)(status, props.url, response, onClick),
        location: (0, $1YNHg.extractLocation)(data),
        modifiedBy: (0, $aybSF.extractSmartLinkModifiedBy)(response),
        modifiedOn: (0, $aybSF.extractSmartLinkModifiedOn)(response),
        preview: (0, $5jWRq.extractSmartLinkPreviewImage)(response),
        priority: (0, $i7cso.default)(data),
        provider: (0, $53LXD.extractSmartLinkProviderIcon)(response),
        programmingLanguage: (0, $1YNHg.extractProgrammingLanguage)(data),
        readTime: (0, $1YNHg.extractReadTime)(data),
        sentOn: (0, $1YNHg.extractSmartLinkSentOn)(response),
        snippet: (0, $fhCsJ.extractSmartLinkSummary)(response) || undefined,
        sourceBranch: (0, $1YNHg.extractSourceBranch)(data),
        state: (0, $3X5rD.default)(response, actionOptions, id, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel),
        subscriberCount: (0, $1YNHg.extractSubscriberCount)(data),
        subTasksProgress: (0, $1YNHg.extractSubTasksProgress)(data),
        storyPoints: (0, $1YNHg.extractStoryPoints)(data),
        targetBranch: (0, $1YNHg.extractTargetBranch)(data),
        ...(0, $kePQU.fg)('platform-linking-user-attributes-component') && {
            userAttributes: (0, $1YNHg.extractUserAttributes)(data)
        },
        ...(0, $kePQU.fg)('platform-linking-team-member-count-component') && {
            teamMemberCount: (0, $1YNHg.extractTeamMemberCount)(data)
        },
        url: url,
        ari: (0, $aybSF.extractSmartLinkAri)(response),
        type: (0, $9Xp5L.extractType)(data),
        ...(0, $kePQU.fg)('cc-ai-linking-platform-snippet-renderer') && {
            meta: {
                objectId: (0, $1YNHg.extractMetaObjectId)(meta),
                resourceType: (0, $1YNHg.extractMetaResourceType)(meta),
                tenantId: (0, $1YNHg.extractMetaTenantId)(meta)
            }
        }
    };
};
var $3106300a6bb2a890$export$2e2bcd8739ae039 = $3106300a6bb2a890$var$extractFlexibleUiContext;

});
parcelRegister("fhCsJ", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkSummary", () => $f7b6c55932a3b223$export$8c6b9b49f358840);

var $eyXxY = parcelRequire("eyXxY");
const $f7b6c55932a3b223$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof jsonLd?.summary === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
};
const $f7b6c55932a3b223$export$8c6b9b49f358840 = (response)=>{
    if ((0, $eyXxY.isEntityPresent)(response)) return (0, $eyXxY.extractEntity)(response)?.description;
    return response?.data && $f7b6c55932a3b223$export$db5a8500f6b6286e(response.data);
};

});

parcelRegister("aFtsL", function(module, exports) {
$parcel$export(module.exports, "extractFlexibleCardActions", () => $981bee9b2d5050e2$export$abe8d0ca1daa1755);

var $4D53f = parcelRequire("4D53f");

var $FuLfR = parcelRequire("FuLfR");

var $cilHE = parcelRequire("cilHE");

var $6jPqD = parcelRequire("6jPqD");

var $62xYb = parcelRequire("62xYb");

var $ePTXn = parcelRequire("ePTXn");

var $fZPsw = parcelRequire("fZPsw");

var $jltTd = parcelRequire("jltTd");
const $981bee9b2d5050e2$export$abe8d0ca1daa1755 = ({ actionOptions: actionOptions, aiSummaryConfig: aiSummaryConfig, appearance: appearance, fireEvent: fireEvent, id: id, origin: origin, response: response, url: url, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel })=>{
    const action = {
        [(0, $4D53f.ActionName).CopyLinkAction]: (0, $6jPqD.extractCopyLinkClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $4D53f.ActionName).DownloadAction]: (0, $62xYb.extractDownloadClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $4D53f.ActionName).FollowAction]: (0, $ePTXn.default)(response, actionOptions, id),
        [(0, $4D53f.ActionName).PreviewAction]: (0, $fZPsw.extractPreviewClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }),
        [(0, $4D53f.ActionName).AutomationAction]: (0, $cilHE.extractAutomationAction)(response),
        [(0, $4D53f.InternalActionName).AISummaryAction]: (0, $FuLfR.extractAISummaryAction)(response, url, actionOptions, aiSummaryConfig),
        [(0, $4D53f.InternalActionName).ViewRelatedLinksAction]: (0, $jltTd.extractViewRelatedLinksAction)(response)
    };
    return Object.values(action).some((value)=>Boolean(value)) ? action : undefined;
};

});
parcelRegister("FuLfR", function(module, exports) {
$parcel$export(module.exports, "extractAISummaryAction", () => $25cb4c9da0d0fd30$export$e7f7a50a8b8932df);

var $29QD7 = parcelRequire("29QD7");

var $92TYi = parcelRequire("92TYi");

var $iV3IT = parcelRequire("iV3IT");
const $25cb4c9da0d0fd30$export$e7f7a50a8b8932df = (response, url, actionOptions, aiSummaryConfig)=>{
    if (!(0, $29QD7.canShowAction)((0, $iV3IT.CardAction).AISummaryAction, actionOptions) || !(0, $92TYi.getIsAISummaryEnabled)(aiSummaryConfig?.isAdminHubAIEnabled, response) || !url) return;
    return {
        url: url
    };
};

});
parcelRegister("29QD7", function(module, exports) {
$parcel$export(module.exports, "canShowAction", () => $09fad37905ab229e$export$2487b058456cca75);
const $09fad37905ab229e$export$2487b058456cca75 = (action, actionOptions)=>{
    if (typeof actionOptions === 'undefined') return true;
    if (actionOptions.hide || actionOptions.exclude?.includes(action)) return false;
    return true;
};

});

parcelRegister("iV3IT", function(module, exports) {
$parcel$export(module.exports, "CardAction", () => $e9b7b427b48dca24$export$f40b7e0b762b928b);
var $e9b7b427b48dca24$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    return CardAction;
}({});

});


parcelRegister("cilHE", function(module, exports) {
$parcel$export(module.exports, "extractAutomationAction", () => $f7a04ccf5f9643ea$export$f913cc6abf3ec084);

var $4D53f = parcelRequire("4D53f");
const $f7a04ccf5f9643ea$export$f913cc6abf3ec084 = (response)=>{
    if (!response.data) return undefined;
    if (!response?.meta?.supportedFeature?.includes((0, $4D53f.ActionName).AutomationAction)) return undefined;
    const data = response.data;
    const meta = response.meta;
    const { name: name, 'atlassian:ari': objectAri } = data;
    const { product: product, tenantId: tenantId, resourceType: resourceType } = meta;
    return {
        product: product,
        resourceType: resourceType,
        siteAri: `ari:cloud:${product}::site/${tenantId}`,
        objectName: name,
        objectAri: objectAri,
        // TODO: The admin experience will be a follow up
        canManageAutomation: false,
        baseAutomationUrl: '',
        analyticsSource: 'smartCardAutomationAction'
    };
};

});

parcelRegister("6jPqD", function(module, exports) {
$parcel$export(module.exports, "extractCopyLinkClientAction", () => $dde6e87caa2e3507$export$31ddd5c40039ce53);

var $cw0TR = parcelRequire("cw0TR");
const $dde6e87caa2e3507$export$31ddd5c40039ce53 = (param)=>{
    const invokeAction = (0, $cw0TR.extractInvokeCopyLinkAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("cw0TR", function(module, exports) {
$parcel$export(module.exports, "extractInvokeCopyLinkAction", () => $23ed42e02be69048$export$5ec86886067a062d);

var $aybSF = parcelRequire("aybSF");

var $4D53f = parcelRequire("4D53f");
var $iV3IT = parcelRequire("iV3IT");

var $75Eqs = parcelRequire("75Eqs");

var $29QD7 = parcelRequire("29QD7");
const $23ed42e02be69048$export$5ec86886067a062d = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $29QD7.canShowAction)((0, $iV3IT.CardAction).CopyLinkAction, actionOptions)) return;
    const url = (0, $aybSF.extractSmartLinkUrl)(response);
    if (!url) return;
    return {
        actionFn: async ()=>navigator.clipboard.writeText(url),
        actionSubjectId: 'copyLink',
        actionType: (0, $4D53f.ActionName).CopyLinkAction,
        definitionId: (0, $75Eqs.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $75Eqs.getExtensionKey)(response),
        id: id,
        resourceType: (0, $75Eqs.getResourceType)(response)
    };
};

});


parcelRegister("62xYb", function(module, exports) {
$parcel$export(module.exports, "extractDownloadClientAction", () => $1a33f90c9fc7428f$export$f6c386869a352b1f);

var $d2Jv6 = parcelRequire("d2Jv6");
const $1a33f90c9fc7428f$export$f6c386869a352b1f = (param)=>{
    const invokeAction = (0, $d2Jv6.extractInvokeDownloadAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("d2Jv6", function(module, exports) {
$parcel$export(module.exports, "extractInvokeDownloadAction", () => $d393b10ff09fd754$export$ea97cd34c2ca86de);

var $aybSF = parcelRequire("aybSF");

var $4D53f = parcelRequire("4D53f");
var $iV3IT = parcelRequire("iV3IT");

var $75Eqs = parcelRequire("75Eqs");

var $cHEjl = parcelRequire("cHEjl");

var $29QD7 = parcelRequire("29QD7");

var $c3Kzd = parcelRequire("c3Kzd");
const $d393b10ff09fd754$export$ea97cd34c2ca86de = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $29QD7.canShowAction)((0, $iV3IT.CardAction).DownloadAction, actionOptions)) return;
    const data = response.data;
    const downloadActionExists = (0, $c3Kzd.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'DownloadAction');
    if (downloadActionExists) {
        const downloadUrl = (0, $aybSF.extractSmartLinkDownloadUrl)(response);
        return {
            actionFn: async ()=>(0, $cHEjl.downloadUrl)(downloadUrl),
            actionSubjectId: 'downloadDocument',
            actionType: (0, $4D53f.ActionName).DownloadAction,
            definitionId: (0, $75Eqs.getDefinitionId)(response),
            display: appearance,
            extensionKey: (0, $75Eqs.getExtensionKey)(response),
            id: id,
            resourceType: (0, $75Eqs.getResourceType)(response)
        };
    }
};

});
parcelRegister("c3Kzd", function(module, exports) {
$parcel$export(module.exports, "getActionsFromJsonLd", () => $c8f5739c5ad9ccd8$export$8f031784a3a03b23);
const $c8f5739c5ad9ccd8$export$8f031784a3a03b23 = (jsonLd)=>{
    let actions = jsonLd && jsonLd['schema:potentialAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) actions = [
        actions
    ];
    return actions;
};

});



parcelRegister("ePTXn", function(module, exports) {
$parcel$export(module.exports, "default", () => $86a8d033d2ce0d2c$export$2e2bcd8739ae039);

var $cC7lh = parcelRequire("cC7lh");
var $9Xp5L = parcelRequire("9Xp5L");

var $cSfCz = parcelRequire("cSfCz");

var $75Eqs = parcelRequire("75Eqs");

var $29QD7 = parcelRequire("29QD7");

var $iV3IT = parcelRequire("iV3IT");

var $iptMY = parcelRequire("iptMY");
const $86a8d033d2ce0d2c$var$extractFollowAction = (response, actionOptions, id)=>{
    if (!(0, $29QD7.canShowAction)((0, $iV3IT.CardAction).FollowAction, actionOptions)) return;
    const extensionKey = (0, $75Eqs.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $iptMY.default)(data);
    const type = (0, $9Xp5L.extractType)(data);
    const isProject = type?.includes('atlassian:Project');
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>{
        if (item?.name === 'UpdateAction') {
            const actionName = item?.dataUpdateAction?.name;
            return actionName === (0, $cSfCz.SmartLinkActionType).FollowEntityAction || actionName === (0, $cSfCz.SmartLinkActionType).UnfollowEntityAction;
        }
        return false;
    });
    if (!action || !action.resourceIdentifiers) return;
    const url = (0, $cC7lh.extractLink)(data);
    const reload = url ? {
        id: id,
        url: url
    } : undefined;
    const actionType = action.dataUpdateAction?.name;
    return {
        action: {
            action: {
                actionType: actionType,
                resourceIdentifiers: action.resourceIdentifiers
            },
            providerKey: extensionKey,
            reload: reload
        },
        value: actionType === (0, $cSfCz.SmartLinkActionType).FollowEntityAction,
        isProject: isProject
    };
};
var $86a8d033d2ce0d2c$export$2e2bcd8739ae039 = $86a8d033d2ce0d2c$var$extractFollowAction;

});
parcelRegister("iptMY", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4ace8649f6e60c9$export$2e2bcd8739ae039);
const $a4ace8649f6e60c9$var$extractServerAction = (data)=>{
    const actions = data?.['atlassian:serverAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) return [
        actions
    ];
    return actions;
};
var $a4ace8649f6e60c9$export$2e2bcd8739ae039 = $a4ace8649f6e60c9$var$extractServerAction;

});


parcelRegister("fZPsw", function(module, exports) {
$parcel$export(module.exports, "extractPreviewClientAction", () => $ed00448a5f15563f$export$9f0d9100b079448);

var $MP4Yt = parcelRequire("MP4Yt");
const $ed00448a5f15563f$export$9f0d9100b079448 = (param)=>{
    const result = (0, $MP4Yt.extractInvokePreviewAction)(param);
    return result ? result : undefined;
};

});
parcelRegister("MP4Yt", function(module, exports) {
$parcel$export(module.exports, "extractInvokePreviewAction", () => $a72728a6b97a237d$export$caf83f49e52ac0bb);

var $a6yNw = parcelRequire("a6yNw");
var $aybSF = parcelRequire("aybSF");

var $kePQU = parcelRequire("kePQU");

var $lJsUk = parcelRequire("lJsUk");

var $4D53f = parcelRequire("4D53f");
var $iV3IT = parcelRequire("iV3IT");

var $75Eqs = parcelRequire("75Eqs");

var $29QD7 = parcelRequire("29QD7");

var $D7QEG = parcelRequire("D7QEG");

var $istX7 = parcelRequire("istX7");

var $lv4qg = parcelRequire("lv4qg");

var $5htly = parcelRequire("5htly");

var $SREp6 = parcelRequire("SREp6");

var $d2Jv6 = parcelRequire("d2Jv6");

var $fANC5 = parcelRequire("fANC5");
const $a72728a6b97a237d$export$caf83f49e52ac0bb = (param)=>{
    const { actionOptions: actionOptions, appearance: display, fireEvent: fireEvent, onClose: onClose, id: id, origin: origin, response: response, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = param;
    const ari = (0, $aybSF.extractSmartLinkAri)(response);
    const url = (0, $aybSF.extractSmartLinkUrl)(response);
    const name = (0, $aybSF.extractSmartLinkTitle)(response);
    const hasPreviewPanelParams = Boolean((0, $lJsUk.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && isPreviewPanelAvailable && openPreviewPanel && ari && url && name);
    const hasPreviewPanel = hasPreviewPanelParams && isPreviewPanelAvailable({
        ari: ari
    });
    const isInPreviewPanel = (0, $lJsUk.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && (0, $D7QEG.isModalWithinPreviewPanelIFrame)();
    const data = response.data;
    const meta = response.meta;
    if (!(0, $29QD7.canShowAction)((0, $iV3IT.CardAction).PreviewAction, actionOptions)) return;
    const src = (0, $a6yNw.extractPreview)(data, 'web')?.src;
    if (src) {
        const extensionKey = (0, $75Eqs.getExtensionKey)(response);
        return {
            invokeAction: {
                actionFn: async ()=>{
                    if (hasPreviewPanel) {
                        let resolvedUrl = url;
                        if ((0, $lJsUk.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test')) {
                            const responseUrl = response.data && 'url' in response.data ? response.data.url : undefined;
                            resolvedUrl = responseUrl || url;
                        }
                        openPreviewPanel({
                            ari: ari,
                            url: resolvedUrl,
                            name: name,
                            iconUrl: undefined
                        });
                    } else await (0, $istX7.openEmbedModal)({
                        fireEvent: fireEvent,
                        extensionKey: extensionKey,
                        id: id,
                        invokeDownloadAction: (0, $d2Jv6.extractInvokeDownloadAction)(param),
                        invokeViewAction: (0, $fANC5.extractInvokeViewAction)(param, true),
                        isSupportTheming: (0, $lv4qg.extractIsSupportTheming)(meta),
                        isTrusted: (0, $5htly.extractIsTrusted)(meta),
                        linkIcon: (0, $SREp6.extractLinkIcon)(response),
                        providerName: (0, $aybSF.extractSmartLinkProvider)(response)?.text,
                        onClose: onClose,
                        origin: origin,
                        src: (0, $aybSF.extractSmartLinkEmbed)(response)?.src,
                        title: (0, $aybSF.extractSmartLinkTitle)(response),
                        url: url,
                        size: (0, $kePQU.fg)('platform_linking_enable_card_preview_action_size') ? actionOptions?.previewAction?.size : undefined,
                        ...(0, $lJsUk.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && {
                            isInPreviewPanel: isInPreviewPanel
                        }
                    });
                },
                actionSubjectId: 'invokePreviewScreen',
                actionType: (0, $4D53f.ActionName).PreviewAction,
                display: display,
                extensionKey: extensionKey,
                id: id
            },
            hasPreviewPanel: hasPreviewPanel
        };
    }
};

});
parcelRegister("D7QEG", function(module, exports) {
$parcel$export(module.exports, "isModalWithinPreviewPanelIFrame", () => $32ea786336b33042$export$11948954f57ec572);
$parcel$export(module.exports, "openEmbedModalInParent", () => $32ea786336b33042$export$bf3b8a5d11107cf4);
const $32ea786336b33042$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
const $32ea786336b33042$export$f274fcef361fe59d = ()=>{
    try {
        const params = new URLSearchParams(window.location.search);
        return params.has('previewPanels') || params.get('embeddedConfluenceSource') === 'confluence-page-preview-panel';
    } catch  {
        return false;
    }
};
const $32ea786336b33042$export$11948954f57ec572 = ()=>{
    return $32ea786336b33042$export$9f140ed41af5108c() && $32ea786336b33042$export$f274fcef361fe59d();
};
const $32ea786336b33042$export$bf3b8a5d11107cf4 = (modalProps)=>{
    if (!$32ea786336b33042$export$9f140ed41af5108c()) return;
    window.parent.postMessage({
        type: 'OPEN_EMBED_MODAL',
        payload: {
            modal: {
                url: modalProps?.url || ''
            }
        }
    }, '*');
};

});

parcelRegister("istX7", function(module, exports) {
$parcel$export(module.exports, "openEmbedModal", () => $ba5af06d9be88b71$export$7859f96cd8cff034);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $4nehu = parcelRequire("4nehu");

var $lJsUk = parcelRequire("lJsUk");

var $D7QEG = parcelRequire("D7QEG");
const $ba5af06d9be88b71$var$IFRAME_NAME = 'twp-editor-preview-iframe';
const $ba5af06d9be88b71$var$POPUP_MOUNT_POINT_ID = 'twp-editor-preview-iframe';

async function $ba5af06d9be88b71$export$7859f96cd8cff034({ onClose: onClose = ()=>{}, ...props } = {}) {
    // If the modal trigger is in an iframe and the user has preview panels enabled, send a message to open modal to the parent product
    if ((0, $lJsUk.expValEquals)('platform_hover_card_preview_panel_modal', 'cohort', 'test')) {
        if (props.isInPreviewPanel) {
            (0, $D7QEG.openEmbedModalInParent)({
                onClose: onClose,
                ...props
            });
            return;
        }
    }
    let popupMountPoint;
    popupMountPoint = document.getElementById($ba5af06d9be88b71$var$POPUP_MOUNT_POINT_ID);
    if (!popupMountPoint) {
        popupMountPoint = document.createElement('div');
        popupMountPoint.id = $ba5af06d9be88b71$var$POPUP_MOUNT_POINT_ID;
        popupMountPoint.setAttribute('data-testid', 'preview-modal');
        document.body.appendChild(popupMountPoint);
    }
    let Modal = await (parcelRequire("kmFL9"));
    (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).render(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: "en",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Modal.default, {
            ...props,
            iframeName: $ba5af06d9be88b71$var$IFRAME_NAME,
            onClose: (_context)=>{
                if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).unmountComponentAtNode(popupMountPoint);
                if (onClose) onClose(_context);
            },
            showModal: true
        })
    }), popupMountPoint);
}

});
parcelRegister("kmFL9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("15phN"),
    $ewTvA("6Fw2s"),
    $ewTvA("4W6s5")
]).then(()=>parcelRequire('8CjoA'));

});


parcelRegister("lv4qg", function(module, exports) {
$parcel$export(module.exports, "extractIsSupportTheming", () => $282c87d347b10013$export$38d755f52cdf4acb);

var $i78Zr = parcelRequire("i78Zr");
const $282c87d347b10013$export$38d755f52cdf4acb = (meta)=>{
    return Boolean(meta?.key && (0, $i78Zr.PROVIDER_KEYS_WITH_THEMING).includes(meta.key));
};

});
parcelRegister("i78Zr", function(module, exports) {
$parcel$export(module.exports, "CONFLUENCE_GENERATOR_ID", () => $1f5e0e929569f781$export$cee224b5de4d6d66);
$parcel$export(module.exports, "JIRA_GENERATOR_ID", () => $1f5e0e929569f781$export$f654d825189934a7);
$parcel$export(module.exports, "JIRA_TASK", () => $1f5e0e929569f781$export$84a73a0383f58180);
$parcel$export(module.exports, "JIRA_SUB_TASK", () => $1f5e0e929569f781$export$c6c83963a9378a67);
$parcel$export(module.exports, "JIRA_STORY", () => $1f5e0e929569f781$export$58af3c426c111a6d);
$parcel$export(module.exports, "JIRA_BUG", () => $1f5e0e929569f781$export$ac9898a63417219e);
$parcel$export(module.exports, "JIRA_EPIC", () => $1f5e0e929569f781$export$54db5e3fb12e39cd);
$parcel$export(module.exports, "JIRA_INCIDENT", () => $1f5e0e929569f781$export$2f54a5a217202c85);
$parcel$export(module.exports, "JIRA_SERVICE_REQUEST", () => $1f5e0e929569f781$export$d097371052bfc411);
$parcel$export(module.exports, "JIRA_CHANGE", () => $1f5e0e929569f781$export$efd9452ad16c6676);
$parcel$export(module.exports, "JIRA_PROBLEM", () => $1f5e0e929569f781$export$2e7e70abb5d81f67);
$parcel$export(module.exports, "JIRA_CUSTOM_TASK_TYPE", () => $1f5e0e929569f781$export$ce25cfc40b280dbc);
$parcel$export(module.exports, "PROVIDER_KEYS_WITH_THEMING", () => $1f5e0e929569f781$export$fe44ce30fd8d131b);
const $1f5e0e929569f781$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $1f5e0e929569f781$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $1f5e0e929569f781$export$84a73a0383f58180 = 'JiraTask';
const $1f5e0e929569f781$export$c6c83963a9378a67 = 'JiraSubTask';
const $1f5e0e929569f781$export$58af3c426c111a6d = 'JiraStory';
const $1f5e0e929569f781$export$ac9898a63417219e = 'JiraBug';
const $1f5e0e929569f781$export$54db5e3fb12e39cd = 'JiraEpic';
const $1f5e0e929569f781$export$2f54a5a217202c85 = 'JiraIncident';
const $1f5e0e929569f781$export$d097371052bfc411 = 'JiraServiceRequest';
const $1f5e0e929569f781$export$efd9452ad16c6676 = 'JiraChange';
const $1f5e0e929569f781$export$2e7e70abb5d81f67 = 'JiraProblem';
const $1f5e0e929569f781$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
const $1f5e0e929569f781$export$fe44ce30fd8d131b = [
    'jira-object-provider',
    'confluence-object-provider',
    'watermelon-object-provider',
    'legion-object-provider'
];

});


parcelRegister("5htly", function(module, exports) {
$parcel$export(module.exports, "extractIsTrusted", () => $bc1e3314d9f5addd$export$4f3ffbb500daac5a);
const $bc1e3314d9f5addd$export$4f3ffbb500daac5a = (meta)=>{
    return Boolean(meta?.key && meta.key !== 'iframely-object-provider');
};

});

parcelRegister("SREp6", function(module, exports) {
$parcel$export(module.exports, "extractLinkIcon", () => $9f6deb5c5eefb1d5$export$43612bed147eae48);
$parcel$export(module.exports, "extractErrorIcon", () => $9f6deb5c5eefb1d5$export$bdd29be9b0395931);
$parcel$export(module.exports, "extractSmartLinkIcon", () => $9f6deb5c5eefb1d5$export$35040aed9264b11c);

var $eyXxY = parcelRequire("eyXxY");

var $4D53f = parcelRequire("4D53f");

var $asKgH = parcelRequire("asKgH");

var $aGWun = parcelRequire("aGWun");

var $53LXD = parcelRequire("53LXD");
const $9f6deb5c5eefb1d5$export$43612bed147eae48 = (response, renderers)=>{
    const data = response.data;
    const render = (0, $asKgH.default)(data, renderers);
    return {
        ...(0, $aGWun.default)(data),
        render: render
    };
};
const $9f6deb5c5eefb1d5$export$bdd29be9b0395931 = (response, status)=>{
    // Try to get provider icon first.
    if (response) {
        const data = response.data;
        const { icon: icon, url: url } = (0, $53LXD.default)(data) || {};
        if (icon || url) return {
            icon: icon,
            url: url
        };
    }
    // Otherwise, use fallback icon for each status.
    switch(status){
        case (0, $4D53f.SmartLinkStatus).Forbidden:
        case (0, $4D53f.SmartLinkStatus).Unauthorized:
            return {
                icon: (0, $4D53f.IconType).Forbidden
            };
        case (0, $4D53f.SmartLinkStatus).NotFound:
            return {
                icon: (0, $4D53f.IconType).Error
            };
        case (0, $4D53f.SmartLinkStatus).Errored:
        case (0, $4D53f.SmartLinkStatus).Fallback:
        default:
            return {
                icon: (0, $4D53f.IconType).Default
            };
    }
};
const $9f6deb5c5eefb1d5$export$35040aed9264b11c = (response, renderers)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $eyXxY.isEntityPresent)(response)) return (0, $eyXxY.extractEntityIcon)(response);
    return $9f6deb5c5eefb1d5$export$43612bed147eae48(response, renderers);
};

});
parcelRegister("asKgH", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce8e26158908298c$export$2e2bcd8739ae039);
const $ce8e26158908298c$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $ce8e26158908298c$var$extractIconRenderer = (data, renderers)=>{
    const prefix = data['atlassian:titlePrefix'];
    if (prefix?.['@type'] === 'atlassian:Emoji') {
        const emojiId = $ce8e26158908298c$var$sanitizeEmojiValue(prefix['text']);
        const emojiRenderer = renderers?.emoji;
        if (emojiId && emojiRenderer) return ()=>emojiRenderer(emojiId);
    }
};
var $ce8e26158908298c$export$2e2bcd8739ae039 = $ce8e26158908298c$var$extractIconRenderer;

});

parcelRegister("aGWun", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a40f308ecea2202$export$2e2bcd8739ae039);

var $44MAo = parcelRequire("44MAo");

var $4D53f = parcelRequire("4D53f");

var $kX1RM = parcelRequire("kX1RM");

var $8YjRy = parcelRequire("8YjRy");

var $fsIch = parcelRequire("fsIch");

var $i78Zr = parcelRequire("i78Zr");

var $e3lcJ = parcelRequire("e3lcJ");

var $dAezZ = parcelRequire("dAezZ");

var $eYsFJ = parcelRequire("eYsFJ");

var $53LXD = parcelRequire("53LXD");

var $4rvjp = parcelRequire("4rvjp");
const $1a40f308ecea2202$var$extractTask = (data, label)=>{
    const { id: id, icon: url } = (0, $fsIch.extractTaskType)(data) || {};
    const taskType = id?.split('#').pop();
    const taskIcon = url ? {
        label: label,
        url: url
    } : undefined;
    return {
        taskType: taskType,
        taskIcon: taskIcon
    };
};
const $1a40f308ecea2202$var$extractType = (jsonLd)=>{
    const type = jsonLd['@type'];
    return Array.isArray(type) ? type.sort((a, b)=>(0, $8YjRy.extractorPriorityMap)[b] - (0, $8YjRy.extractorPriorityMap)[a])[0] : type;
};
const $1a40f308ecea2202$var$isJiraProvider = (provider)=>provider === (0, $i78Zr.JIRA_GENERATOR_ID);
function $1a40f308ecea2202$var$chooseIcon({ urlIcon: urlIcon, type: type, label: label, data: data, providerIcon: providerIcon }) {
    const providerId = data.generator?.['@id'];
    const fileFormat = data?.['schema:fileFormat'];
    const fileFormatIcon = (0, $dAezZ.default)(fileFormat);
    const documentTypeIcon = $1a40f308ecea2202$var$typeToIconDescriptor({
        type: type,
        label: label,
        providerId: providerId,
        data: data
    }) || (0, $e3lcJ.default)(type, label, providerId);
    return (0, $kX1RM.prioritiseIcon)({
        fileFormatIcon: fileFormatIcon,
        documentTypeIcon: documentTypeIcon,
        urlIcon: urlIcon,
        providerIcon: providerIcon
    });
}
function $1a40f308ecea2202$var$typeToIconDescriptor({ type: type, label: label, providerId: providerId, data: data }) {
    switch(type){
        case 'atlassian:Goal':
            return {
                icon: (0, $4D53f.IconType).Task,
                label: label || 'Goal'
            };
        case 'atlassian:Project':
            return {
                icon: (0, $4D53f.IconType).Project,
                label: label || 'Project'
            };
        case 'atlassian:SourceCodeCommit':
            return {
                icon: (0, $4D53f.IconType).Commit,
                label: label || 'Commit'
            };
        case 'atlassian:SourceCodePullRequest':
            return {
                icon: (0, $4D53f.IconType).PullRequest,
                label: label || 'Pull request'
            };
        case 'atlassian:SourceCodeReference':
            return {
                icon: (0, $4D53f.IconType).Branch,
                label: label || 'Reference'
            };
        case 'atlassian:SourceCodeRepository':
            return {
                icon: (0, $4D53f.IconType).Repo,
                label: label || 'Repository'
            };
        case 'atlassian:Task':
            const taskLabel = label || 'Task';
            const taskIconDescriptor = {
                icon: (0, $4D53f.IconType).Task,
                label: taskLabel
            };
            if ($1a40f308ecea2202$var$isJiraProvider(providerId)) {
                const { taskType: taskType, taskIcon: taskIcon } = $1a40f308ecea2202$var$extractTask(data);
                return taskType === 'JiraCustomTaskType' ? taskIcon || taskIconDescriptor : (0, $eYsFJ.default)(taskType, taskLabel);
            }
            return taskIconDescriptor;
        default:
            return undefined;
    }
}
/**
 * Return the icon object given a JSON-LD data object.
 */ const $1a40f308ecea2202$var$extractJsonldDataIcon = (data)=>{
    const label = (0, $44MAo.extractTitle)(data);
    const type = $1a40f308ecea2202$var$extractType(data);
    const urlIcon = (0, $4rvjp.default)(data.icon, label);
    const providerIcon = (0, $53LXD.default)(data);
    return $1a40f308ecea2202$var$chooseIcon({
        urlIcon: urlIcon,
        providerIcon: providerIcon,
        type: type,
        label: label,
        data: data
    });
};
var $1a40f308ecea2202$export$2e2bcd8739ae039 = $1a40f308ecea2202$var$extractJsonldDataIcon;

});
parcelRegister("kX1RM", function(module, exports) {
$parcel$export(module.exports, "prioritiseIcon", () => $c5dfbba6b59bdb94$export$65e47eb22a387a86);
/**
 * Options required to prioritise which icon to show
 */ function $c5dfbba6b59bdb94$export$65e47eb22a387a86({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon }) {
    return urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
}

});

parcelRegister("8YjRy", function(module, exports) {
$parcel$export(module.exports, "extractorPriorityMap", () => $ccb3601c0db0d4e0$export$e0deaeb4a2dfe2b4);
const $ccb3601c0db0d4e0$export$e0deaeb4a2dfe2b4 = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};

});

parcelRegister("fsIch", function(module, exports) {
$parcel$export(module.exports, "extractTaskType", () => $7c5d7a2570e4d476$export$ed3fd59180514d27);

var $1Wm8X = parcelRequire("1Wm8X");
const $7c5d7a2570e4d476$export$ed3fd59180514d27 = (jsonLd)=>{
    // TODO: Remove once Jira migrate to the correct type.
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $1Wm8X.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};

});

parcelRegister("e3lcJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $9930a13cc9e2da58$export$2e2bcd8739ae039);

var $fC4nI = parcelRequire("fC4nI");

var $4D53f = parcelRequire("4D53f");
/**
 * Computes the relevant icon for a document type.
 *
 * @remark Note that document icons can vary based on the provider. E.g., a
 * provider may choose to re-use one of these document types in their domain,
 * but offer a different SVG icon on the frontend (to map to this type in their
 * domain). See `schema:digitalDocument` for an example of this behaviour. This
 * mechanism will be superseded by backend-driven icon URLs as part of
 * go/j/MODES-5864. Do not add more!
 *
 * @param documentType JSON-LD document type
 * @param label human-readable label to be displayed on the icon
 * @param providerId JSON-LD provider (generator ID)
 * @returns an icon descriptor representing the document type
 */ const $9930a13cc9e2da58$var$extractDocumentTypeIcon = (documentType, label, providerId)=>{
    switch(documentType){
        case 'schema:BlogPosting':
            return {
                icon: (0, $4D53f.IconType).Blog,
                label: label || 'Blog'
            };
        case 'schema:DigitalDocument':
            if (providerId && (0, $fC4nI.isConfluenceGenerator)(providerId)) return {
                icon: (0, $4D53f.IconType).LiveDocument,
                label: label || 'Live Document'
            };
            else return {
                icon: (0, $4D53f.IconType).File,
                label: label || 'File'
            };
        case 'schema:TextDigitalDocument':
            return {
                icon: (0, $4D53f.IconType).Document,
                label: label || 'Document'
            };
        case 'schema:PresentationDigitalDocument':
            return {
                icon: (0, $4D53f.IconType).Presentation,
                label: label || 'Presentation'
            };
        case 'schema:SpreadsheetDigitalDocument':
            return {
                icon: (0, $4D53f.IconType).Spreadsheet,
                label: label || 'Spreadsheet'
            };
        case 'atlassian:Template':
            return {
                icon: (0, $4D53f.IconType).Template,
                label: label || 'Template'
            };
        case 'atlassian:UndefinedLink':
            return {
                icon: (0, $4D53f.IconType).Document,
                label: label || 'Undefined link'
            };
        default:
            return undefined;
    }
};
var $9930a13cc9e2da58$export$2e2bcd8739ae039 = $9930a13cc9e2da58$var$extractDocumentTypeIcon;

});

parcelRegister("eYsFJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $027b61fa9abbc0cb$export$2e2bcd8739ae039);

var $4D53f = parcelRequire("4D53f");
const $027b61fa9abbc0cb$var$extractJiraTaskIcon = (taskType, label = 'Task')=>{
    switch(taskType){
        case 'JiraBug':
            return {
                icon: (0, $4D53f.IconType).Bug,
                label: label
            };
        case 'JiraChange':
            return {
                icon: (0, $4D53f.IconType).Change,
                label: label
            };
        case 'JiraEpic':
            return {
                icon: (0, $4D53f.IconType).Epic,
                label: label
            };
        case 'JiraIncident':
            return {
                icon: (0, $4D53f.IconType).Incident,
                label: label
            };
        case 'JiraProblem':
            return {
                icon: (0, $4D53f.IconType).Problem,
                label: label
            };
        case 'JiraServiceRequest':
            return {
                icon: (0, $4D53f.IconType).ServiceRequest,
                label: label
            };
        case 'JiraStory':
            return {
                icon: (0, $4D53f.IconType).Story,
                label: label
            };
        case 'JiraSubTask':
            return {
                icon: (0, $4D53f.IconType).SubTask,
                label: label
            };
        case 'JiraTask':
        default:
            return {
                icon: (0, $4D53f.IconType).Task,
                label: label
            };
    }
};
var $027b61fa9abbc0cb$export$2e2bcd8739ae039 = $027b61fa9abbc0cb$var$extractJiraTaskIcon;

});

parcelRegister("53LXD", function(module, exports) {
$parcel$export(module.exports, "default", () => $7391783864f1a607$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extractSmartLinkProviderIcon", () => $7391783864f1a607$export$5def189f04eea025);

var $eyXxY = parcelRequire("eyXxY");
var $44MAo = parcelRequire("44MAo");

var $4D53f = parcelRequire("4D53f");

var $i78Zr = parcelRequire("i78Zr");

var $4rvjp = parcelRequire("4rvjp");
/**
 * Extracts the provider icon and label from the given JSON-LD data.
 *
 * If the data is from Confluence, the icon will be the Confluence icon and the label will be 'Confluence'.
 * If the data is from Jira, the icon will be the Jira icon and the label will be 'Jira'.
 * If the data is from another provider, the icon and label will be extracted from the generator object.
 *
 * @param data - The JSON-LD data to extract the provider icon and label from.
 * @returns IconDescriptor with optional icon string name, url and label, or `undefined` if the data is not provided.
 */ const $7391783864f1a607$var$extractProviderIcon = (data)=>{
    if (!data) return undefined;
    const generator = data.generator;
    const provider = generator?.['@id'];
    const icon = generator?.icon;
    const label = generator?.name || (0, $44MAo.extractTitle)(data);
    if (provider === (0, $i78Zr.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $4D53f.IconType).Confluence,
        label: label || 'Confluence'
    };
    if (provider === (0, $i78Zr.JIRA_GENERATOR_ID)) return {
        icon: (0, $4D53f.IconType).Jira,
        label: label || 'Jira'
    };
    return (0, $4rvjp.default)(icon, label);
};
var $7391783864f1a607$export$2e2bcd8739ae039 = $7391783864f1a607$var$extractProviderIcon;
const $7391783864f1a607$export$5def189f04eea025 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $eyXxY.isEntityPresent)(response)) {
        const provider = (0, $eyXxY.extractEntityProvider)(response);
        if (!provider) return undefined;
        switch(provider.id){
            case 0, $i78Zr.CONFLUENCE_GENERATOR_ID:
                return {
                    icon: (0, $4D53f.IconType).Confluence,
                    label: provider.text || 'Confluence'
                };
            case 0, $i78Zr.JIRA_GENERATOR_ID:
                return {
                    icon: (0, $4D53f.IconType).Jira,
                    label: provider.text || 'Jira'
                };
            default:
                const { generator: generator } = response.meta;
                if (!generator) return undefined;
                return {
                    label: generator.name || (0, $eyXxY.extractEntity)(response)?.displayName,
                    url: generator.icon?.url
                };
        }
    }
    return $7391783864f1a607$var$extractProviderIcon(response.data);
};

});
parcelRegister("4rvjp", function(module, exports) {
$parcel$export(module.exports, "default", () => $206b38ffee80462b$export$2e2bcd8739ae039);

var $1Wm8X = parcelRequire("1Wm8X");
/**
 * Extracts the URL icon from the given icon or link object.
 *
 * @param icon - The icon or link object from which to extract the URL icon.
 * @param label - The label for the URL icon.
 * @returns IconDescriptor, which will contain label and url, or undefined
 */ const $206b38ffee80462b$var$extractUrlIcon = (icon, label)=>{
    const url = icon && (0, $1Wm8X.extractUrlFromIconJsonLd)(icon);
    return url ? {
        label: label,
        url: url
    } : undefined;
};
var $206b38ffee80462b$export$2e2bcd8739ae039 = $206b38ffee80462b$var$extractUrlIcon;

});




parcelRegister("fANC5", function(module, exports) {
$parcel$export(module.exports, "extractInvokeViewAction", () => $7768aab49581c425$export$88c5813cfbbe4e4c);

var $cC7lh = parcelRequire("cC7lh");

var $iV3IT = parcelRequire("iV3IT");

var $75Eqs = parcelRequire("75Eqs");

var $cHEjl = parcelRequire("cHEjl");

var $29QD7 = parcelRequire("29QD7");

var $c3Kzd = parcelRequire("c3Kzd");
const $7768aab49581c425$export$88c5813cfbbe4e4c = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response }, force)=>{
    if (!(0, $29QD7.canShowAction)((0, $iV3IT.CardAction).ViewAction, actionOptions)) return;
    const data = response.data;
    if (!data) return;
    const url = (0, $cC7lh.extractLink)(data);
    const viewActionExists = (0, $c3Kzd.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'ViewAction');
    if (url && (viewActionExists || force)) return {
        actionFn: async ()=>(0, $cHEjl.openUrl)(url),
        actionSubjectId: 'shortcutGoToLink',
        actionType: 'ViewAction',
        definitionId: (0, $75Eqs.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $75Eqs.getExtensionKey)(response),
        id: id,
        resourceType: (0, $75Eqs.getResourceType)(response)
    };
};

});



parcelRegister("jltTd", function(module, exports) {
$parcel$export(module.exports, "extractViewRelatedLinksAction", () => $41b46e382077e3be$export$debae7424a0231b9);

var $aybSF = parcelRequire("aybSF");
const $41b46e382077e3be$export$debae7424a0231b9 = (response)=>{
    if (!response?.meta?.supportedFeature?.includes('RelatedLinks')) return;
    const ari = (0, $aybSF.extractSmartLinkAri)(response);
    if (!ari) return;
    return {
        ari: ari
    };
};

});


parcelRegister("d1A7Q", function(module, exports) {
$parcel$export(module.exports, "extractPersonsUpdatedBy", () => $f0e80d98c9ed8f8d$export$216e4f6aa7c169b8);

var $kwcBW = parcelRequire("kwcBW");
var $6aZLo = parcelRequire("6aZLo");
const $f0e80d98c9ed8f8d$export$216e4f6aa7c169b8 = (jsonLd)=>{
    if (jsonLd['@type'] === 'atlassian:Project') {
        const members = (0, $kwcBW.extractMembers)(jsonLd);
        if (members && members.length !== 0) return members;
    }
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) {
        const extractedPersons = (0, $6aZLo.extractPersonFromJsonLd)(updatedBy);
        return extractedPersons ? [
            extractedPersons
        ] : undefined;
    }
};

});
parcelRegister("kwcBW", function(module, exports) {
$parcel$export(module.exports, "extractMembers", () => $c805e0083a813fe9$export$6281d080d62a0719);

var $6aZLo = parcelRequire("6aZLo");
const $c805e0083a813fe9$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>(0, $6aZLo.extractPersonFromJsonLd)(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = (0, $6aZLo.extractPersonFromJsonLd)(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
};

});


parcelRegister("fL4Mn", function(module, exports) {
$parcel$export(module.exports, "default", () => $df9a290b0eca8818$export$2e2bcd8739ae039);

var $aybSF = parcelRequire("aybSF");

var $4D53f = parcelRequire("4D53f");
const $df9a290b0eca8818$var$extractLinkTitle = (status, propUrl, response, onClick)=>{
    const responseUrl = (0, $aybSF.extractSmartLinkUrl)(response);
    const url = status === (0, $4D53f.SmartLinkStatus).Resolved ? responseUrl ?? propUrl : propUrl;
    const name = (0, $aybSF.extractSmartLinkTitle)(response);
    const text = status === (0, $4D53f.SmartLinkStatus).Resolved ? name ?? responseUrl ?? propUrl : propUrl;
    return {
        onClick: onClick,
        text: text,
        url: url
    };
};
var $df9a290b0eca8818$export$2e2bcd8739ae039 = $df9a290b0eca8818$var$extractLinkTitle;

});

parcelRegister("i7cso", function(module, exports) {
$parcel$export(module.exports, "default", () => $b954d41984c5e759$export$2e2bcd8739ae039);

var $1Wm8X = parcelRequire("1Wm8X");

var $4D53f = parcelRequire("4D53f");
const $b954d41984c5e759$var$priorityMapper = {
    blocker: (0, $4D53f.IconType).PriorityBlocker,
    critical: (0, $4D53f.IconType).PriorityCritical,
    high: (0, $4D53f.IconType).PriorityHigh,
    highest: (0, $4D53f.IconType).PriorityHighest,
    low: (0, $4D53f.IconType).PriorityLow,
    lowest: (0, $4D53f.IconType).PriorityLowest,
    major: (0, $4D53f.IconType).PriorityMajor,
    medium: (0, $4D53f.IconType).PriorityMedium,
    minor: (0, $4D53f.IconType).PriorityMinor,
    trivial: (0, $4D53f.IconType).PriorityTrivial,
    undefined: (0, $4D53f.IconType).PriorityUndefined
};
const $b954d41984c5e759$var$extractPriority = (data)=>{
    const priority = data['atlassian:priority'];
    if (priority) {
        if (typeof priority === 'string') {
            const icon = $b954d41984c5e759$var$priorityMapper[priority.toLowerCase()];
            if (icon) return {
                icon: icon,
                label: priority
            };
        } else if (priority['@type'] === 'Object') return {
            label: priority.name,
            url: priority.icon && (0, $1Wm8X.extractUrlFromIconJsonLd)(priority.icon)
        };
    }
};
var $b954d41984c5e759$export$2e2bcd8739ae039 = $b954d41984c5e759$var$extractPriority;

});

parcelRegister("3X5rD", function(module, exports) {
$parcel$export(module.exports, "default", () => $19cfc74fc3306627$export$2e2bcd8739ae039);

var $cC7lh = parcelRequire("cC7lh");

var $75Eqs = parcelRequire("75Eqs");

var $29QD7 = parcelRequire("29QD7");

var $iV3IT = parcelRequire("iV3IT");

var $MP4Yt = parcelRequire("MP4Yt");

var $9QWQI = parcelRequire("9QWQI");

var $iptMY = parcelRequire("iptMY");
const $19cfc74fc3306627$var$toInvokeRequest = (extensionKey, resourceIdentifiers, actionType, details)=>{
    if (!actionType) return;
    return {
        action: {
            actionType: actionType,
            resourceIdentifiers: resourceIdentifiers
        },
        providerKey: extensionKey,
        details: details
    };
};
const $19cfc74fc3306627$var$extractAction = (response, id, actionOptions, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel)=>{
    const extensionKey = (0, $75Eqs.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $iptMY.default)(data);
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>item?.name === 'UpdateAction' && item?.refField === 'tag');
    if (!action || !action.resourceIdentifiers) return;
    const read = $19cfc74fc3306627$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataRetrievalAction?.name);
    const url = (0, $cC7lh.extractLink)(data);
    const invokePreviewAction = response ? (0, $MP4Yt.extractInvokePreviewAction)({
        actionOptions: actionOptions,
        appearance: appearance,
        fireEvent: fireEvent,
        id: id,
        onClose: resolve ? ()=>url && resolve(url, true) : undefined,
        origin: origin,
        response: response,
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        openPreviewPanel: openPreviewPanel
    })?.invokeAction : undefined;
    const details = {
        id: id,
        url: url,
        invokePreviewAction: invokePreviewAction
    };
    const update = $19cfc74fc3306627$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataUpdateAction?.name, details);
    return read || update ? {
        read: read,
        update: update
    } : undefined;
};
const $19cfc74fc3306627$var$extractState = (response, actionOptions, id, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel)=>{
    if (!response || !response.data) return;
    const lozenge = (0, $9QWQI.extractLozenge)(response?.data);
    if (!lozenge) return;
    if (!(0, $29QD7.canShowAction)((0, $iV3IT.CardAction).ChangeStatusAction, actionOptions)) return lozenge;
    const action = $19cfc74fc3306627$var$extractAction(response, id, actionOptions, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel);
    return {
        ...lozenge,
        action: action
    };
};
var $19cfc74fc3306627$export$2e2bcd8739ae039 = $19cfc74fc3306627$var$extractState;

});
parcelRegister("9QWQI", function(module, exports) {
$parcel$export(module.exports, "extractLozenge", () => $d7b53236ad36b3c7$export$e5da155556a77bca);

var $9Xp5L = parcelRequire("9Xp5L");

var $iPgky = parcelRequire("iPgky");

var $8HQEt = parcelRequire("8HQEt");

var $dIhA3 = parcelRequire("dIhA3");

var $fsIch = parcelRequire("fsIch");
const $d7b53236ad36b3c7$export$e5da155556a77bca = (jsonLd)=>{
    const type = (0, $9Xp5L.extractType)(jsonLd);
    if (type) {
        if (type.includes('atlassian:Task')) {
            const jsonLdTask = jsonLd;
            const lozengeFromTag = (0, $8HQEt.extractTag)(jsonLdTask);
            const lozengeFromStatus = (0, $dIhA3.extractTaskStatus)(jsonLdTask);
            const lozengeFromTaskType = $d7b53236ad36b3c7$var$extractLozengeFromTaskType(jsonLdTask);
            return lozengeFromTag || lozengeFromStatus || lozengeFromTaskType;
        }
        if (type.includes('atlassian:UndefinedLink')) return {
            text: 'UNDEFINED',
            appearance: 'inprogress'
        };
        // casting it because `extractState` can safely handle missing properties
        return (0, $iPgky.extractState)(jsonLd);
    }
};
const $d7b53236ad36b3c7$var$extractLozengeFromTaskType = (jsonLdTask)=>{
    const taskType = (0, $fsIch.extractTaskType)(jsonLdTask);
    if (taskType && taskType.name) return {
        text: taskType.name,
        appearance: 'success'
    };
};

});
parcelRegister("iPgky", function(module, exports) {
$parcel$export(module.exports, "extractState", () => $1910d6407e892b1d$export$5e4074cbce6574c7);

var $d5Ibe = parcelRequire("d5Ibe");
// Maps accent color short names to their corresponding background and text colors
const $1910d6407e892b1d$var$lozengeAccentStyles = {
    blue: {
        backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        color: "var(--ds-text-accent-blue, #0055CC)"
    },
    gray: {
        backgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        color: "var(--ds-text-accent-gray, #44546F)"
    },
    green: {
        backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        color: "var(--ds-text-accent-green, #216E4E)"
    },
    lime: {
        backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        color: "var(--ds-text-accent-lime, #4C6B1F)"
    },
    magenta: {
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        color: "var(--ds-text-accent-magenta, #943D73)"
    },
    orange: {
        backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
        color: "var(--ds-text-accent-orange, #A54800)"
    },
    purple: {
        backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        color: "var(--ds-text-accent-purple, #5E4DB2)"
    },
    red: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    teal: {
        backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        color: "var(--ds-text-accent-teal, #206A83)"
    },
    yellow: {
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        color: "var(--ds-text-accent-yellow, #7F5F01)"
    }
};
const $1910d6407e892b1d$export$5e4074cbce6574c7 = (jsonLd)=>{
    const state = jsonLd['atlassian:state'];
    if (state) {
        if (typeof state === 'string') {
            const linkState = state.toLowerCase();
            if (!(0, $d5Ibe.OMIT_STATES).includes(linkState)) return {
                text: linkState,
                appearance: (0, $d5Ibe.VALID_STATES)[linkState] || 'default'
            };
        } else if (state['@type'] === 'Link' || state['@type'] === 'Object') {
            if (state.name) {
                const accent = state.accent;
                return {
                    text: state.name,
                    appearance: state.appearance || 'default',
                    style: accent ? $1910d6407e892b1d$var$lozengeAccentStyles[accent] : undefined
                };
            }
        }
    }
};

});
parcelRegister("d5Ibe", function(module, exports) {
$parcel$export(module.exports, "isValidAppearance", () => $930747d98faa95c6$export$ce6b5b303f8e3c99);
$parcel$export(module.exports, "VALID_STATES", () => $930747d98faa95c6$export$7b1deaaad25d1dc1);
$parcel$export(module.exports, "OMIT_STATES", () => $930747d98faa95c6$export$772610da74ddbc07);
const $930747d98faa95c6$var$VALID_APPEARANCES = [
    'default',
    'success',
    'removed',
    'inprogress',
    'new',
    'moved'
];
const $930747d98faa95c6$export$ce6b5b303f8e3c99 = (appearance)=>{
    return $930747d98faa95c6$var$VALID_APPEARANCES.indexOf(appearance) !== -1;
};
const $930747d98faa95c6$export$7b1deaaad25d1dc1 = {
    open: 'inprogress',
    merged: 'success',
    declined: 'removed',
    closed: 'success',
    draft: 'inprogress',
    archived: 'default'
};
const $930747d98faa95c6$export$772610da74ddbc07 = [
    'current'
];

});


parcelRegister("8HQEt", function(module, exports) {
$parcel$export(module.exports, "extractTag", () => $90a5a9606c8036fb$export$962a8da34cf78a4f);

var $d5Ibe = parcelRequire("d5Ibe");
const $90a5a9606c8036fb$export$962a8da34cf78a4f = (jsonLd)=>{
    const tag = jsonLd.tag;
    if (tag) {
        if (typeof tag === 'string') return {
            text: tag,
            appearance: 'default'
        };
        else if (Array.isArray(tag)) {
            const tags = tag.map($90a5a9606c8036fb$var$extractTagItem).filter((item)=>!!item);
            if (tags.length > 0) return tags.shift();
        } else return $90a5a9606c8036fb$var$extractTagItem(tag);
    }
};
const $90a5a9606c8036fb$var$extractTagItem = (tag)=>{
    if (typeof tag === 'string') return {
        text: tag,
        appearance: 'default'
    };
    else if (tag['@type'] === 'Link') {
        if (tag.name) return {
            text: tag.name,
            appearance: 'default'
        };
    } else if (tag.name) {
        const appearance = tag.appearance;
        return {
            text: tag.name,
            // Jira currently uses tag.appearance to set the lozenge color. Remove this
            // once we migrate them away from using this old spec.
            appearance: (0, $d5Ibe.isValidAppearance)(appearance) && appearance || 'default'
        };
    }
};

});

parcelRegister("dIhA3", function(module, exports) {
$parcel$export(module.exports, "extractTaskStatus", () => $f398fd90b1710152$export$7698df1946deda72);
const $f398fd90b1710152$export$7698df1946deda72 = (jsonLd)=>{
    const taskStatus = jsonLd['atlassian:taskStatus'];
    if (taskStatus && taskStatus.name) return {
        text: taskStatus.name,
        appearance: 'success'
    };
};

});



parcelRegister("kRENZ", function(module, exports) {
$parcel$export(module.exports, "extractLatestCommit", () => $b0885714237e10b6$export$f222392162cff0d8);
const $b0885714237e10b6$export$f222392162cff0d8 = (jsonLd)=>{
    const latestCommit = jsonLd['atlassian:latestCommit'];
    if (typeof latestCommit === 'string') return latestCommit;
    if (latestCommit) //todo: change the properties to latestCommit.hash when BE is ready
    return latestCommit ? latestCommit.name : undefined;
};

});




parcelRegister("7H3El", function(module, exports) {
$parcel$export(module.exports, "getSimulatedBetterMetadata", () => $5d674634a5e06291$export$f87d357259b3b7c8);
$parcel$export(module.exports, "FlexibleCardUiOptions", () => $5d674634a5e06291$export$22ebf74c8bee4708);
$parcel$export(module.exports, "titleBlockOptions", () => $5d674634a5e06291$export$45bdb4108909a713);
$parcel$export(module.exports, "PreviewBlockOptions", () => $5d674634a5e06291$export$9671929f11bd4ad8);

var $4D53f = parcelRequire("4D53f");

var $1YNHg = parcelRequire("1YNHg");

var $75Eqs = parcelRequire("75Eqs");
const $5d674634a5e06291$var$baseTopMetadata = [
    {
        name: (0, $4D53f.ElementName).ModifiedOn
    },
    {
        name: (0, $4D53f.ElementName).AttachmentCount
    },
    {
        name: (0, $4D53f.ElementName).SubscriberCount
    },
    {
        name: (0, $4D53f.ElementName).VoteCount
    },
    {
        name: (0, $4D53f.ElementName).DueOn
    },
    {
        name: (0, $4D53f.ElementName).ReadTime
    }
];
const $5d674634a5e06291$var$baseBottomMetaData = [
    {
        name: (0, $4D53f.ElementName).ReactCount
    },
    {
        name: (0, $4D53f.ElementName).CommentCount
    },
    {
        name: (0, $4D53f.ElementName).ViewCount
    },
    {
        name: (0, $4D53f.ElementName).Priority
    },
    {
        name: (0, $4D53f.ElementName).SubTasksProgress
    },
    {
        name: (0, $4D53f.ElementName).ChecklistProgress
    }
];
const $5d674634a5e06291$export$f87d357259b3b7c8 = (cardDetails)=>{
    const extensionKey = (0, $75Eqs.getExtensionKey)(cardDetails) ?? '';
    const data = cardDetails?.data;
    const defaultTitleMetadata = [
        {
            name: (0, $4D53f.ElementName).State
        }
    ];
    const defaultTopMetadata = [
        {
            name: (0, $4D53f.ElementName).AuthorGroup
        },
        {
            name: (0, $4D53f.ElementName).CreatedBy
        },
        ...$5d674634a5e06291$var$baseTopMetadata
    ];
    const defaultBottomMetadata = $5d674634a5e06291$var$baseBottomMetaData;
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            const isFile = data['@type'].includes('schema:DigitalDocument');
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: isFile ? [
                    {
                        name: (0, $4D53f.ElementName).LatestCommit
                    },
                    {
                        name: (0, $4D53f.ElementName).CollaboratorGroup
                    },
                    {
                        name: (0, $4D53f.ElementName).ModifiedOn
                    }
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'dragonfruit-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $1YNHg.extractOwnedBy)(data) ? [
                    {
                        name: (0, $4D53f.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $4D53f.ElementName).OwnedBy
                    },
                    ...$5d674634a5e06291$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: [
                    {
                        name: (0, $4D53f.ElementName).AppliedToComponentsCount
                    },
                    ...$5d674634a5e06291$var$baseBottomMetaData
                ]
            };
        case 'integration-passionfruit-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $1YNHg.extractOwnedBy)(data) ? [
                    {
                        name: (0, $4D53f.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $4D53f.ElementName).OwnedBy
                    },
                    ...$5d674634a5e06291$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: [
                    {
                        name: (0, $4D53f.ElementName).AppliedToComponentsCount
                    },
                    ...$5d674634a5e06291$var$baseBottomMetaData
                ]
            };
        case 'confluence-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $1YNHg.extractOwnedBy)(data) ? [
                    {
                        name: (0, $4D53f.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $4D53f.ElementName).OwnedBy
                    },
                    ...$5d674634a5e06291$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'jira-object-provider':
            const isJiraTask = data['@type']?.includes('atlassian:Task') ?? false;
            const isJiraPlan = data['atlassian:ownedBy'] ? true : false;
            let topMetadata = [
                {
                    name: (0, $4D53f.ElementName).AuthorGroup
                },
                {
                    name: (0, $4D53f.ElementName).CreatedBy
                },
                {
                    name: (0, $4D53f.ElementName).ModifiedOn
                }
            ];
            if (isJiraTask) topMetadata = [
                {
                    name: (0, $4D53f.ElementName).AssignedToGroup
                },
                {
                    name: (0, $4D53f.ElementName).AssignedTo
                },
                {
                    name: (0, $4D53f.ElementName).ModifiedOn
                }
            ];
            else if (isJiraPlan) topMetadata = [
                {
                    name: (0, $4D53f.ElementName).OwnedByGroup
                },
                {
                    name: (0, $4D53f.ElementName).OwnedBy
                }
            ];
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: topMetadata,
                bottomMetadata: [
                    {
                        name: (0, $4D53f.ElementName).StoryPoints
                    },
                    {
                        name: (0, $4D53f.ElementName).Priority
                    },
                    {
                        name: (0, $4D53f.ElementName).SubTasksProgress
                    }
                ]
            };
        case 'slack-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $4D53f.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $4D53f.ElementName).SentOn
                    }
                ],
                bottomMetadata: [
                    {
                        name: (0, $4D53f.ElementName).ReactCount
                    },
                    {
                        name: (0, $4D53f.ElementName).CommentCount
                    }
                ]
            };
        case 'trello-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $4D53f.ElementName).CollaboratorGroup
                    },
                    ...$5d674634a5e06291$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        case 'legion-object-provider':
        case 'people-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $4D53f.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $4D53f.ElementName).TeamMemberCount
                    },
                    {
                        name: (0, $4D53f.ElementName).UserAttributes
                    },
                    ...$5d674634a5e06291$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        default:
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
    }
};
const $5d674634a5e06291$export$22ebf74c8bee4708 = {
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true
};
const $5d674634a5e06291$export$45bdb4108909a713 = {
    anchorTarget: '_self',
    position: (0, $4D53f.SmartLinkPosition).Center,
    hideRetry: true,
    size: (0, $4D53f.SmartLinkSize).Large
};
const $5d674634a5e06291$export$9671929f11bd4ad8 = {
    placement: (0, $4D53f.MediaPlacement).Right,
    ignoreContainerPadding: true
};

});


parcelRegister("TVYgn", function(module, exports) {
$parcel$export(module.exports, "withFlexibleUIBlockCardStyle", () => $59a72b100ab1e2cf$export$36ce1a3a446661ab);
/* withFlexibleUIBlockCardStyle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $59a72b100ab1e2cf$var$flexibleBlockCardStyle = null;
const $59a72b100ab1e2cf$export$36ce1a3a446661ab = (FlexibleBlockCardView)=>(props)=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            className: (0, $hcewu.default)([
                "_1g961mok _1qo31x13"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(FlexibleBlockCardView, {
                ...props
            })
        });
    };

});


parcelRegister("cf7hR", function(module, exports) {
$parcel$export(module.exports, "default", () => $84750c2ccd887353$export$2e2bcd8739ae039);
/* ForbiddenView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $aqlRB = parcelRequire("aqlRB");

var $8WSiy = parcelRequire("8WSiy");

var $cHxQu = parcelRequire("cHxQu");

var $aybSF = parcelRequire("aybSF");

var $j0zes = parcelRequire("j0zes");

var $9o0WU = parcelRequire("9o0WU");

var $cafmZ = parcelRequire("cafmZ");

var $f1Nvs = parcelRequire("f1Nvs");

var $5pSar = parcelRequire("5pSar");

var $asDdI = parcelRequire("asDdI");

var $hono7 = parcelRequire("hono7");

var $4LtOu = parcelRequire("4LtOu");

var $TVYgn = parcelRequire("TVYgn");
const $84750c2ccd887353$var$textStyles = null;
/**
 * This view represent a Block Card with the 'Forbidden' status.
 * It should have a "Try another account" button that will allow a user to connect another account and view the block card.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $84750c2ccd887353$var$ForbiddenView = ({ testId: testId = 'smart-block-forbidden-view', ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $aqlRB.useAnalyticsEvents)();
    const intl = (0, $lRq8t.default)();
    const { cardState: cardState, onAuthorize: onAuthorize, url: url } = props;
    const details = cardState?.details;
    const cardMetadata = details?.meta ?? (0, $5pSar.getForbiddenJsonLd)().meta;
    const provider = (0, $aybSF.extractSmartLinkProvider)(details);
    const providerName = provider?.text || '';
    const messageContext = (0, $eJOHy.useMemo)(()=>{
        const hostname = /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
            children: (0, $9o0WU.default)(url)
        });
        return {
            product: providerName,
            hostname: hostname
        };
    }, [
        providerName,
        url
    ]);
    const requestAccessContext = (0, $eJOHy.useMemo)(()=>{
        return (0, $j0zes.extractRequestAccessContextImproved)({
            jsonLd: cardMetadata,
            url: url,
            product: providerName,
            createAnalyticsEvent: createAnalyticsEvent
        });
    }, [
        cardMetadata,
        providerName,
        url,
        createAnalyticsEvent
    ]);
    const title = (0, $eJOHy.useMemo)(()=>{
        const descriptor = (0, $f1Nvs.toMessage)((0, $cafmZ.messages).invalid_permissions, requestAccessContext?.titleMessageKey);
        return intl.formatMessage(descriptor, {
            product: providerName
        });
    }, [
        intl,
        providerName,
        requestAccessContext?.titleMessageKey
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>{
        let actionFromAccessContext = [];
        const tryAnotherAccountAction = onAuthorize ? [
            (0, $hono7.ForbiddenAction)(onAuthorize, 'try_another_account')
        ] : [];
        if (requestAccessContext) {
            const { action: action, callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            actionFromAccessContext = action && callToActionMessageKey ? [
                (0, $hono7.ForbiddenAction)(action.promise, callToActionMessageKey, messageContext, requestAccessContext?.buttonDisabled)
            ] : [];
        }
        return [
            ...tryAnotherAccountAction,
            ...actionFromAccessContext
        ];
    }, [
        onAuthorize,
        requestAccessContext,
        messageContext
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $4LtOu.default), {
        ...props,
        actions: actions,
        showPreview: true,
        testId: testId,
        title: title,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8WSiy))), {
                label: "forbidden-lock-icon",
                color: "var(--ds-icon-danger, #C9372C)",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($cHxQu))),
                LEGACY_size: "small",
                testId: `${testId}-lock-icon`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $asDdI.default), {
                maxLines: 3,
                message: {
                    descriptor: (0, $f1Nvs.toMessage)((0, $cafmZ.messages).invalid_permissions_description, requestAccessContext?.descriptiveMessageKey),
                    values: messageContext
                },
                className: (0, $hcewu.default)([
                    "_syaz1fxt"
                ])
            })
        ]
    });
};
var $84750c2ccd887353$export$2e2bcd8739ae039 = (0, $TVYgn.withFlexibleUIBlockCardStyle)($84750c2ccd887353$var$ForbiddenView);

});
parcelRegister("8WSiy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b170729cb10fdaa6c208ecbe5722b466>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $683ddc05d84dfb7b$var$_react = $683ddc05d84dfb7b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $683ddc05d84dfb7b$var$_baseNew = $683ddc05d84dfb7b$var$_interopRequireDefault((parcelRequire("leD6h")));
function $683ddc05d84dfb7b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $683ddc05d84dfb7b$var$LockLockedIcon = (props)=>/*#__PURE__*/ $683ddc05d84dfb7b$var$_react.default.createElement($683ddc05d84dfb7b$var$_baseNew.default, Object.assign({
        name: "LockLockedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$683ddc05d84dfb7b$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $683ddc05d84dfb7b$var$_default = module.exports.default = $683ddc05d84dfb7b$var$LockLockedIcon;

});

parcelRegister("cHxQu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $93f3c13a6894157f$var$_react = $93f3c13a6894157f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4RAp5 = parcelRequire("4RAp5");
function $93f3c13a6894157f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $93f3c13a6894157f$var$LockIcon = (props)=>/*#__PURE__*/ $93f3c13a6894157f$var$_react.default.createElement($4RAp5.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props));
$93f3c13a6894157f$var$LockIcon.displayName = 'LockIcon';
var $93f3c13a6894157f$var$_default = module.exports.default = $93f3c13a6894157f$var$LockIcon;

});

parcelRegister("f1Nvs", function(module, exports) {
$parcel$export(module.exports, "toMessage", () => $2b1b6ef52d40fe01$export$d14c2a6dee946f52);

var $cafmZ = parcelRequire("cafmZ");
const $2b1b6ef52d40fe01$export$d14c2a6dee946f52 = (defaultMessage, key)=>{
    try {
        if (key !== undefined && key in (0, $cafmZ.messages)) return (0, $cafmZ.messages)[key];
        return defaultMessage;
    } catch  {
        return defaultMessage;
    }
};

});

parcelRegister("hono7", function(module, exports) {
$parcel$export(module.exports, "ForbiddenAction", () => $656b56f84d183c2a$export$59f8830fb5467e35);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $4D53f = parcelRequire("4D53f");

var $cafmZ = parcelRequire("cafmZ");
const $656b56f84d183c2a$export$59f8830fb5467e35 = (onClick, content, context, isDisabled)=>({
        name: (0, $4D53f.ActionName).CustomAction,
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $cafmZ.messages)[content],
            values: context
        }),
        onClick: onClick,
        testId: 'smart-action-connect-other-account',
        isDisabled: isDisabled
    });

});


parcelRegister("eTJs3", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4d5ceab6ab5914a$export$2e2bcd8739ae039);
/* NotFoundView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $8WSiy = parcelRequire("8WSiy");

var $cHxQu = parcelRequire("cHxQu");

var $aybSF = parcelRequire("aybSF");

var $cafmZ = parcelRequire("cafmZ");

var $asDdI = parcelRequire("asDdI");

var $4LtOu = parcelRequire("4LtOu");

var $TVYgn = parcelRequire("TVYgn");
const $a4d5ceab6ab5914a$var$textStyles = null;
/**
 * This view represents a Block Card with a 'Not_Found' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $a4d5ceab6ab5914a$var$NotFoundView = ({ testId: testId = 'smart-block-not-found-view', ...props })=>{
    const intl = (0, $lRq8t.default)();
    const { cardState: { details: details } } = props;
    const product = (0, $eJOHy.useMemo)(()=>{
        const provider = (0, $aybSF.extractSmartLinkProvider)(details);
        return provider?.text ?? '';
    }, [
        details
    ]);
    const title = (0, $eJOHy.useMemo)(()=>intl.formatMessage((0, $cafmZ.messages).not_found_title, {
            product: product
        }), [
        intl,
        product
    ]);
    const description = (0, $eJOHy.useMemo)(()=>({
            descriptor: (0, $cafmZ.messages).not_found_description
        }), []);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $4LtOu.default), {
        ...props,
        testId: testId,
        title: title,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8WSiy))), {
                label: "not-found-lock-icon",
                color: "var(--ds-icon-danger, #C9372C)",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($cHxQu))),
                LEGACY_size: "small",
                testId: `${testId}-lock-icon`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $asDdI.default), {
                message: description,
                testId: `${testId}-message`,
                maxLines: 3,
                className: (0, $hcewu.default)([
                    "_syaz1fxt"
                ])
            })
        ]
    });
};
var $a4d5ceab6ab5914a$export$2e2bcd8739ae039 = (0, $TVYgn.withFlexibleUIBlockCardStyle)($a4d5ceab6ab5914a$var$NotFoundView);

});

parcelRegister("fwAOH", function(module, exports) {
$parcel$export(module.exports, "default", () => $83ade61271e1f874$export$2e2bcd8739ae039);
/* ResolvedView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $heSeW = parcelRequire("heSeW");

var $kePQU = parcelRequire("kePQU");

var $lJsUk = parcelRequire("lJsUk");

var $4D53f = parcelRequire("4D53f");

var $9ztRN = parcelRequire("9ztRN");

var $gx2wH = parcelRequire("gx2wH");
var $er7te = parcelRequire("er7te");
var $2u0se = parcelRequire("2u0se");
var $9vcc4 = parcelRequire("9vcc4");
var $4RQt4 = parcelRequire("4RQt4");

var $7H3El = parcelRequire("7H3El");

var $TVYgn = parcelRequire("TVYgn");
const $83ade61271e1f874$var$titleBlockCss = null;
const $83ade61271e1f874$var$footerBlockCss = null;
const $83ade61271e1f874$var$footerBlockSafariStyles = null;
/**
 * This view represents a Block card that has an 'Resolved' status.
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $83ade61271e1f874$var$ResolvedView = ({ cardState: cardState, onClick: onClick, onError: onError, onResolve: onResolve, actionOptions: actionOptions, testId: testId = 'smart-block-resolved-view', url: url, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const [isPreviewBlockErrored, setIsPreviewBlockErrored] = (0, $eJOHy.useState)(false);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $eJOHy.useMemo)(()=>(0, $heSeW.browser)(), []);
    (0, $eJOHy.useEffect)(()=>{
        setIsPreviewBlockErrored(false);
    }, [
        url,
        cardState
    ]);
    const { titleMetadata: titleMetadata, topMetadata: topMetadata, bottomMetadata: bottomMetadata } = (0, $7H3El.getSimulatedBetterMetadata)(cardState.details);
    const footerActions = (0, $eJOHy.useMemo)(()=>[
            {
                name: (0, $4D53f.ActionName).FollowAction,
                hideIcon: true
            },
            {
                name: (0, $4D53f.ActionName).PreviewAction,
                hideIcon: true
            },
            {
                name: (0, $4D53f.ActionName).DownloadAction,
                hideIcon: true
            }
        ], []);
    const uiOptions = (0, $7H3El.FlexibleCardUiOptions);
    if ((0, $kePQU.fg)('cc-ai-linking-platform-snippet-renderer')) uiOptions.enableSnippetRenderer = true;
    if ((0, $lJsUk.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true)) uiOptions.hideLoadingSkeleton = hideIconLoadingSkeleton;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9ztRN.default), {
        appearance: "block",
        cardState: cardState,
        onClick: onClick,
        onError: onError,
        onResolve: onResolve,
        origin: "smartLinkCard",
        actionOptions: actionOptions,
        testId: testId,
        ui: uiOptions,
        url: url,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4RQt4.default), {
                ...(0, $7H3El.titleBlockOptions),
                metadata: titleMetadata,
                subtitle: [
                    {
                        name: (0, $4D53f.ElementName).Location
                    }
                ],
                metadataPosition: (0, $4D53f.SmartLinkPosition).Top,
                CompetitorPrompt: CompetitorPrompt,
                url: url,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _13mh1pd9 _2yhz14q2"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $er7te.default), {
                primary: topMetadata,
                maxLines: 1
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9vcc4.default), {}),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $er7te.default), {
                primary: bottomMetadata,
                maxLines: 1
            }),
            !isPreviewBlockErrored ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2u0se.default), {
                ...(0, $7H3El.PreviewBlockOptions),
                onError: ()=>{
                    setIsPreviewBlockErrored(true);
                }
            }) : null,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gx2wH.default), {
                actions: footerActions,
                className: (0, $hcewu.default)([
                    "_4t3i1k8s _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb",
                    safari && "_4t3i1osq"
                ])
            })
        ]
    });
};
var $83ade61271e1f874$export$2e2bcd8739ae039 = (0, $TVYgn.withFlexibleUIBlockCardStyle)($83ade61271e1f874$var$ResolvedView);

});

parcelRegister("7gHy8", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4668ef445170d31$export$2e2bcd8739ae039);
/* UnauthorisedView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $aybSF = parcelRequire("aybSF");

var $5RpiZ = parcelRequire("5RpiZ");

var $cafmZ = parcelRequire("cafmZ");

var $75Eqs = parcelRequire("75Eqs");

var $kPwer = parcelRequire("kPwer");

var $9F8Qf = parcelRequire("9F8Qf");

var $4LtOu = parcelRequire("4LtOu");

var $TVYgn = parcelRequire("TVYgn");
const $f4668ef445170d31$var$contentStyles = null;
/**
 * This view represents a Block card that has an 'Unauthorized' status .
 * It should have a "Connect" button that will allow a user to connect their account and view the block card.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $f4668ef445170d31$var$UnauthorisedView = ({ testId: testId = 'smart-block-unauthorized-view', ...props })=>{
    const { cardState: cardState, onAuthorize: onAuthorize } = props;
    const providerName = (0, $aybSF.extractSmartLinkProvider)(cardState.details)?.text;
    const isProductIntegrationSupported = (0, $75Eqs.hasAuthScopeOverrides)(cardState.details);
    const { fireEvent: fireEvent } = (0, $5RpiZ.useAnalyticsEvents)();
    const handleAuthorize = (0, $eJOHy.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const content = (0, $eJOHy.useMemo)(()=>onAuthorize ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kPwer.default), {
            providerName: providerName,
            isProductIntegrationSupported: isProductIntegrationSupported,
            testId: testId
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $cafmZ.messages)[providerName ? 'unauthorised_account_description' : 'unauthorised_account_description_no_provider'],
            values: {
                context: providerName
            }
        }), [
        isProductIntegrationSupported,
        onAuthorize,
        providerName,
        testId
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>onAuthorize ? [
            (0, $9F8Qf.AuthorizeAction)(handleAuthorize, providerName)
        ] : [], [
        handleAuthorize,
        onAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4LtOu.default), {
        ...props,
        actions: actions,
        testId: testId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": `${testId}-content`,
            className: (0, $hcewu.default)([
                "_11c8dcr7 _syaz1fxt _19pku2gc"
            ]),
            children: content
        })
    });
};
var $f4668ef445170d31$export$2e2bcd8739ae039 = (0, $TVYgn.withFlexibleUIBlockCardStyle)($f4668ef445170d31$var$UnauthorisedView);

});
parcelRegister("9F8Qf", function(module, exports) {
$parcel$export(module.exports, "AuthorizeAction", () => $a7be626adcc2cd49$export$34cef2b72294bd84);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $4D53f = parcelRequire("4D53f");

var $cafmZ = parcelRequire("cafmZ");
const $a7be626adcc2cd49$export$34cef2b72294bd84 = (onAuthorize, providerName)=>({
        appearance: 'primary',
        name: (0, $4D53f.ActionName).CustomAction,
        content: providerName ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $cafmZ.messages).connect_unauthorised_account_action,
            values: {
                context: providerName
            }
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $cafmZ.messages).connect_link_account_card
        }),
        onClick: onAuthorize,
        testId: 'smart-action-connect-account'
    });

});



parcelRegister("aAVNA", function(module, exports) {
$parcel$export(module.exports, "EmbedCard", () => $bb29e68ec9f3194e$export$6789d7ecdc77631b);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aqlRB = parcelRequire("aqlRB");

var $kePQU = parcelRequire("kePQU");

var $lUdvR = parcelRequire("lUdvR");

var $j0zes = parcelRequire("j0zes");

var $7SjNn = parcelRequire("7SjNn");

var $9wIH6 = parcelRequire("9wIH6");

var $75Eqs = parcelRequire("75Eqs");

var $juXY2 = parcelRequire("juXY2");

var $5pSar = parcelRequire("5pSar");

var $lRukN = parcelRequire("lRukN");

var $fwAOH = parcelRequire("fwAOH");

var $b7hOH = parcelRequire("b7hOH");

var $6Tmil = parcelRequire("6Tmil");

var $byjM0 = parcelRequire("byjM0");

var $8HfZa = parcelRequire("8HfZa");

var $cPJjA = parcelRequire("cPJjA");

var $iJ40f = parcelRequire("iJ40f");
const $bb29e68ec9f3194e$var$UFOLoadHoldWrapper = ({ children: children })=>{
    return (0, $kePQU.fg)('platform_renderer_blindspots') ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lUdvR.default), {
                name: "smart-card-embed-card"
            }),
            children
        ]
    }) : children;
};
const $bb29e68ec9f3194e$export$6789d7ecdc77631b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleErrorRetry: handleErrorRetry, handleFrameClick: handleFrameClick, isSelected: isSelected, frameStyle: frameStyle, platform: platform, onResolve: onResolve, onError: onError, testId: testId, inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, iframeUrlType: iframeUrlType, actionOptions: actionOptions, renderers: renderers, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton }, iframeRef)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $aqlRB.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $75Eqs.getExtensionKey)(details);
    const isProductIntegrationSupported = (0, $75Eqs.hasAuthScopeOverrides)(details);
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $juXY2.useControlDataExportConfig)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($bb29e68ec9f3194e$var$UFOLoadHoldWrapper, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fwAOH.default), {
                    url: url,
                    cardState: cardState,
                    onClick: handleFrameClick,
                    onError: onError,
                    onResolve: onResolve,
                    renderers: renderers,
                    actionOptions: actionOptions,
                    testId: testId ? `${testId}-resolving-view` : 'embed-card-resolving-view'
                })
            });
        case 'resolved':
            const resolvedViewProps = (0, $7SjNn.extractEmbedProps)(details, platform, iframeUrlType);
            if (onResolve) onResolve({
                title: resolvedViewProps.title,
                url: url,
                aspectRatio: resolvedViewProps.preview?.aspectRatio
            });
            if ((0, $lRukN.getIsDataExportEnabled)(shouldControlDataExport, cardState.details)) {
                const unauthViewProps = (0, $7SjNn.extractEmbedProps)(details, platform);
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iJ40f.default), {
                    context: unauthViewProps.context,
                    extensionKey: extensionKey,
                    frameStyle: frameStyle,
                    isProductIntegrationSupported: isProductIntegrationSupported,
                    inheritDimensions: inheritDimensions,
                    isSelected: isSelected,
                    onAuthorize: handleAuthorize,
                    onClick: handleFrameClick,
                    testId: testId,
                    url: unauthViewProps.link
                });
            }
            if (resolvedViewProps.preview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cPJjA.EmbedCardResolvedView), {
                ...resolvedViewProps,
                isSelected: isSelected,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                testId: testId,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton,
                extensionKey: extensionKey
            });
            else {
                if (platform === 'mobile') {
                    const resolvedInlineViewProps = (0, $9wIH6.extractInlineProps)(details);
                    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b7hOH.InlineCardResolvedView), {
                        ...resolvedInlineViewProps,
                        isSelected: isSelected,
                        testId: testId,
                        onClick: handleFrameClick
                    });
                }
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fwAOH.default), {
                    url: url,
                    cardState: cardState,
                    onClick: handleFrameClick,
                    onError: onError,
                    onResolve: onResolve,
                    renderers: renderers,
                    actionOptions: actionOptions,
                    testId: testId
                });
            }
        case 'unauthorized':
            if (onError) onError({
                url: url,
                status: status
            });
            const unauthorisedViewProps = (0, $7SjNn.extractEmbedProps)(details, platform);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iJ40f.default), {
                context: unauthorisedViewProps.context,
                extensionKey: extensionKey,
                frameStyle: frameStyle,
                isProductIntegrationSupported: isProductIntegrationSupported,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                testId: testId,
                url: unauthorisedViewProps.link
            });
        case 'forbidden':
            if (onError) onError({
                url: url,
                status: status
            });
            const forbiddenViewProps = (0, $7SjNn.extractEmbedProps)(details, platform);
            const cardMetadata = details?.meta ?? (0, $5pSar.getForbiddenJsonLd)().meta;
            if (forbiddenViewProps.preview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cPJjA.EmbedCardResolvedView), {
                ...forbiddenViewProps,
                title: forbiddenViewProps.link,
                frameStyle: frameStyle,
                isSelected: isSelected,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef,
                extensionKey: extensionKey
            });
            const forbiddenAccessContext = (0, $j0zes.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: forbiddenViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $byjM0.default), {
                context: forbiddenViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                accessContext: forbiddenAccessContext,
                url: forbiddenViewProps.link
            });
        case 'not_found':
            if (onError) onError({
                url: url,
                status: status
            });
            const notFoundViewProps = (0, $7SjNn.extractEmbedProps)(details, platform);
            const notFoundAccessContext = details?.meta ? (0, $j0zes.extractRequestAccessContextImproved)({
                jsonLd: details?.meta,
                url: url,
                product: notFoundViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            }) : undefined;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8HfZa.default), {
                context: notFoundViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onClick: handleFrameClick,
                accessContext: notFoundAccessContext,
                url: notFoundViewProps.link
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Tmil.EmbedCardErroredView), {
                onRetry: handleErrorRetry,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected
            });
    }
});

});
parcelRegister("7SjNn", function(module, exports) {
$parcel$export(module.exports, "extractEmbedProps", () => $bbd6f195249df9f2$export$d6cf81ca6e68bcc3);

var $aybSF = parcelRequire("aybSF");
var $9Xp5L = parcelRequire("9Xp5L");

var $5pSar = parcelRequire("5pSar");

var $b7WoD = parcelRequire("b7WoD");

var $lv4qg = parcelRequire("lv4qg");

var $5htly = parcelRequire("5htly");
const $bbd6f195249df9f2$export$d6cf81ca6e68bcc3 = (response, platform, iframeUrlType)=>{
    const meta = response?.meta;
    const jsonLd = response?.data || (0, $5pSar.getEmptyJsonLd)();
    return {
        link: (0, $aybSF.extractSmartLinkUrl)(response) || '',
        title: (0, $aybSF.extractSmartLinkTitle)(response),
        context: (0, $b7WoD.extractSmartLinkContext)(response),
        preview: (0, $aybSF.extractSmartLinkEmbed)(response, iframeUrlType),
        isTrusted: (0, $5htly.extractIsTrusted)(meta),
        isSupportTheming: (0, $lv4qg.extractIsSupportTheming)(meta),
        type: (0, $9Xp5L.extractType)(jsonLd)
    };
};

});
parcelRegister("b7WoD", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkContext", () => $b6d453831f891313$export$6ec4b6b24dec9156);

var $eyXxY = parcelRequire("eyXxY");
var $fC4nI = parcelRequire("fC4nI");
var $1Wm8X = parcelRequire("1Wm8X");

var $5pSar = parcelRequire("5pSar");

var $kX1RM = parcelRequire("kX1RM");

var $j0zes = parcelRequire("j0zes");
function $b6d453831f891313$export$8dcb07487061d3c1(jsonLd) {
    const provider = (0, $fC4nI.extractProvider)(jsonLd);
    if (!provider) return undefined;
    // If no icon is supplied, return existing context
    if (!jsonLd.icon) return provider;
    const generator = jsonLd.generator;
    const icon = (0, $kX1RM.prioritiseIcon)({
        fileFormatIcon: undefined,
        documentTypeIcon: undefined,
        urlIcon: (0, $1Wm8X.extractUrlFromIconJsonLd)(jsonLd.icon),
        // We still attempt to follow the icon priority function even if no generator (and therefore provider icon) is defined
        providerIcon: generator && typeof generator !== 'string' && generator['@type'] !== 'Link' && (0, $fC4nI.extractProviderIcon)(generator.icon)
    });
    return {
        ...provider,
        icon: icon ? icon : provider.icon
    };
}
function $b6d453831f891313$export$6ec4b6b24dec9156(response) {
    if ((0, $eyXxY.isEntityPresent)(response)) return (0, $eyXxY.extractEntityProvider)(response);
    return $b6d453831f891313$export$8dcb07487061d3c1(response?.data || (0, $5pSar.getEmptyJsonLd)());
}

});


parcelRegister("9wIH6", function(module, exports) {
$parcel$export(module.exports, "extractInlineProps", () => $a8dcb8b47cb54dc1$export$68e1703c529dc7e0);

var $eyXxY = parcelRequire("eyXxY");
var $fC4nI = parcelRequire("fC4nI");
var $aybSF = parcelRequire("aybSF");
var $9Xp5L = parcelRequire("9Xp5L");

var $5pSar = parcelRequire("5pSar");

var $786U2 = parcelRequire("786U2");

var $9QWQI = parcelRequire("9QWQI");

var $o3Uls = parcelRequire("o3Uls");

var $8TCik = parcelRequire("8TCik");

var $i78Zr = parcelRequire("i78Zr");
const $a8dcb8b47cb54dc1$var$extractInlineIcon = (jsonLd, showIconLabel = true)=>{
    const provider = (0, $fC4nI.extractProvider)(jsonLd);
    if (provider && provider.id) {
        if (provider.id === (0, $i78Zr.CONFLUENCE_GENERATOR_ID) || provider.id === (0, $i78Zr.JIRA_GENERATOR_ID)) return (0, $786U2.extractIcon)(jsonLd, 'type', showIconLabel);
    }
    return (0, $786U2.extractIcon)(jsonLd, 'provider', showIconLabel);
};
/**
 * Should be moved to the smart link-extractor when jsonld is deprecated
 */ const $a8dcb8b47cb54dc1$var$extractSmartLinkInlineIcon = (response, showLabel = true)=>{
    if ((0, $eyXxY.isEntityPresent)(response)) {
        const provider = (0, $eyXxY.extractEntityProvider)(response);
        if (provider) return provider.icon;
    // We don't need this for design entities,
    // but we can add it back when we support more entities
    // it requires extractInlineIcon to be moved to the smart link extractor package.
    // see: https://product-fabric.atlassian.net/browse/EDM-12375
    // return extractSmartLinkIcon(response);
    }
    return $a8dcb8b47cb54dc1$var$extractInlineIcon(response?.data || (0, $5pSar.getEmptyJsonLd)(), showLabel);
};
const $a8dcb8b47cb54dc1$export$68e1703c529dc7e0 = (response, renderers, removeTextHighlightingFromTitle, showLabel = true)=>{
    const jsonLd = response?.data || (0, $5pSar.getEmptyJsonLd)();
    return {
        link: (0, $aybSF.extractSmartLinkUrl)(response),
        title: (0, $aybSF.extractSmartLinkTitle)(response, removeTextHighlightingFromTitle),
        icon: $a8dcb8b47cb54dc1$var$extractSmartLinkInlineIcon(response, showLabel),
        // As we migrate to support more entities we can incorporate these fields
        lozenge: (0, $9QWQI.extractLozenge)(jsonLd),
        titleTextColor: (0, $o3Uls.extractTitleTextColor)(jsonLd),
        titlePrefix: (0, $8TCik.extractTitlePrefix)(jsonLd, renderers, 'inline'),
        type: (0, $9Xp5L.extractType)(jsonLd)
    };
};

});
parcelRegister("786U2", function(module, exports) {
$parcel$export(module.exports, "extractIcon", () => $4695d8769e06e6ab$export$64bdf1f5e49e8626);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $45GAa = parcelRequire("45GAa");

var $i7zzM = parcelRequire("i7zzM");

var $7YIyA = parcelRequire("7YIyA");

var $3Jg3U = parcelRequire("3Jg3U");

var $hvosn = parcelRequire("hvosn");

var $5tCr0 = parcelRequire("5tCr0");

var $fC4nI = parcelRequire("fC4nI");
var $44MAo = parcelRequire("44MAo");
var $1Wm8X = parcelRequire("1Wm8X");

var $cHEjl = parcelRequire("cHEjl");

var $fsIch = parcelRequire("fsIch");

var $kzKaK = parcelRequire("kzKaK");

var $eU9co = parcelRequire("eU9co");

var $k7omp = parcelRequire("k7omp");

var $kX1RM = parcelRequire("kX1RM");

var $8YjRy = parcelRequire("8YjRy");
const $4695d8769e06e6ab$export$64bdf1f5e49e8626 = (jsonLd, priority = 'type', showIconLabel = true)=>{
    const type = jsonLd['@type'];
    const opts = {
        title: (0, $44MAo.extractTitle)(jsonLd),
        provider: (0, $fC4nI.extractProvider)(jsonLd),
        fileFormat: (0, $kzKaK.extractFileFormat)(jsonLd),
        taskType: (0, $fsIch.extractTaskType)(jsonLd),
        icon: jsonLd.icon && (0, $1Wm8X.extractUrlFromIconJsonLd)(jsonLd.icon),
        priority: priority,
        showIconLabel: showIconLabel
    };
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $8YjRy.extractorPriorityMap)[b] - (0, $8YjRy.extractorPriorityMap)[a])[0];
        return $4695d8769e06e6ab$var$extractIconByType(highestPriorityType, opts);
    } else return $4695d8769e06e6ab$var$extractIconByType(type, opts);
};
function $4695d8769e06e6ab$var$typeToIcon(type, opts) {
    switch(type){
        case 'atlassian:SourceCodeCommit':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7YIyA.default), {
                label: opts.title || 'commit',
                testId: "commit-icon"
            });
        case 'atlassian:Project':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5tCr0))), {
                label: opts.title || 'project',
                LEGACY_size: "small",
                testId: "project-icon",
                color: "currentColor"
            });
        case 'atlassian:SourceCodePullRequest':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3Jg3U.default), {
                label: opts.title || 'pullRequest',
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $45GAa.default), {
                label: opts.title || 'reference',
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i7zzM.default), {
                label: opts.title || 'repository',
                testId: "repo-icon"
            });
        case 'atlassian:Goal':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hvosn.default), {
                label: opts.title || 'goal',
                testId: "task-icon"
            });
        case 'atlassian:Task':
            return (0, $k7omp.extractIconFromTask)(opts);
        default:
            return undefined;
    }
}
function $4695d8769e06e6ab$var$standardisedExtractIcon(type, opts) {
    const iconFromType = $4695d8769e06e6ab$var$typeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $cHEjl.getIconForFileType)(opts.fileFormat) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $kX1RM.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
}
/**
 * Extracts an icon based on the given type.
 *
 * Some types return hardcoded icons, while others follow a priority list on how to pick the icon.
 * If type is not recognized, it will return the icon from the provider, or `undefined` if no icon is found.
 *
 * @param type - The type of the object.
 * @param opts - Options for the icon extraction.
 * @returns The extracted icon as a React node, or `undefined` if no icon is found.
 */ const $4695d8769e06e6ab$var$extractIconByType = (type, opts)=>{
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return (0, $eU9co.extractIconFromDocument)(type, opts);
        default:
            return $4695d8769e06e6ab$var$standardisedExtractIcon(type, opts);
    }
};

});
parcelRegister("45GAa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $5c43363808833e04$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::57895ef0b52fd8c4c74cfb41dd495e36>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hGUis = parcelRequire("hGUis");

var $4U1IF = parcelRequire("4U1IF");

var $dpSPE = parcelRequire("dpSPE");
/**
 * __16px `branch` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $5c43363808833e04$var$Branch16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hGUis.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4U1IF))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dpSPE.default), {
            label: label,
            testId: testId
        })
    });
};
$5c43363808833e04$var$Branch16Icon.displayName = 'Branch16Icon';
var $5c43363808833e04$export$2e2bcd8739ae039 = $5c43363808833e04$var$Branch16Icon;

});
parcelRegister("4U1IF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5d8d971bf9def65ea3fd98a53d2a797b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $391db9d2beb29995$var$_react = $391db9d2beb29995$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $391db9d2beb29995$var$_baseNew = $391db9d2beb29995$var$_interopRequireDefault((parcelRequire("leD6h")));
function $391db9d2beb29995$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $391db9d2beb29995$var$BranchIcon = (props)=>/*#__PURE__*/ $391db9d2beb29995$var$_react.default.createElement($391db9d2beb29995$var$_baseNew.default, Object.assign({
        name: "BranchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$391db9d2beb29995$var$BranchIcon.displayName = 'BranchIcon';
var $391db9d2beb29995$var$_default = module.exports.default = $391db9d2beb29995$var$BranchIcon;

});

parcelRegister("dpSPE", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5090d3142316e5f$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::625730c3236ac1826cad47b39a1764d5>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4RAp5 = parcelRequire("4RAp5");
const $b5090d3142316e5f$var$Branch16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4RAp5.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M10 8.732v.28A1.993 1.993 0 0 1 8.002 11l-.004 2A3.995 3.995 0 0 0 12 9.007v-.274a2 2 0 1 0-2 0m-4-3a2 2 0 1 0-2 0v4.536a2 2 0 1 0 2 0zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$b5090d3142316e5f$var$Branch16Icon.displayName = 'Branch16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b5090d3142316e5f$export$2e2bcd8739ae039 = $b5090d3142316e5f$var$Branch16Icon;

});


parcelRegister("i7zzM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $074fdc6003428551$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8e82b283fed135d161349bed7f64fbf0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hGUis = parcelRequire("hGUis");

var $9LLVK = parcelRequire("9LLVK");

var $i98rn = parcelRequire("i98rn");
/**
 * __16px `code` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $074fdc6003428551$var$Code16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hGUis.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9LLVK))),
        appearance: "purpleBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i98rn.default), {
            label: label,
            testId: testId
        })
    });
};
$074fdc6003428551$var$Code16Icon.displayName = 'Code16Icon';
var $074fdc6003428551$export$2e2bcd8739ae039 = $074fdc6003428551$var$Code16Icon;

});
parcelRegister("9LLVK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1091d7b3916e42e9c126eb0a1ee5598a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $71cdaed80383ae97$var$_react = $71cdaed80383ae97$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $71cdaed80383ae97$var$_baseNew = $71cdaed80383ae97$var$_interopRequireDefault((parcelRequire("leD6h")));
function $71cdaed80383ae97$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $71cdaed80383ae97$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $71cdaed80383ae97$var$_react.default.createElement($71cdaed80383ae97$var$_baseNew.default, Object.assign({
        name: "AngleBracketsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$71cdaed80383ae97$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $71cdaed80383ae97$var$_default = module.exports.default = $71cdaed80383ae97$var$AngleBracketsIcon;

});

parcelRegister("i98rn", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb73458e6b04f280$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d003ccf13a9ed7b17e1f0e343e52054d>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4RAp5 = parcelRequire("4RAp5");
const $fb73458e6b04f280$var$Code16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4RAp5.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554c0" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2.92 4.72L2.34 7.3a1 1 0 0 0 0 1.414l2.58 2.578a1 1 0 0 0 1.414-1.416L4.46 8.006l1.873-1.871A1 1 0 1 0 4.92 4.72m4.792 0a1 1 0 0 0 0 1.415l1.874 1.87-1.873 1.87a1 1 0 1 0 1.414 1.416l2.58-2.58a1 1 0 0 0 0-1.414L11.126 4.72a1 1 0 0 0-.706-.292 1 1 0 0 0-.708.293"/></svg>`,
        ...props,
        size: "small"
    });
$fb73458e6b04f280$var$Code16Icon.displayName = 'Code16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fb73458e6b04f280$export$2e2bcd8739ae039 = $fb73458e6b04f280$var$Code16Icon;

});


parcelRegister("7YIyA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $db09d221d2fa0753$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f2c30ba9921a6754c4914a2815ab1ac6>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hGUis = parcelRequire("hGUis");

var $gtXxh = parcelRequire("gtXxh");

var $3OtP0 = parcelRequire("3OtP0");
/**
 * __16px `commit` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $db09d221d2fa0753$var$Commit16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hGUis.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gtXxh))),
        appearance: "orangeBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3OtP0.default), {
            label: label,
            testId: testId
        })
    });
};
$db09d221d2fa0753$var$Commit16Icon.displayName = 'Commit16Icon';
var $db09d221d2fa0753$export$2e2bcd8739ae039 = $db09d221d2fa0753$var$Commit16Icon;

});
parcelRegister("gtXxh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ab489d2a38e8a0acc1962f05ff04e40>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bffd89571aa85aa7$var$_react = $bffd89571aa85aa7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $bffd89571aa85aa7$var$_baseNew = $bffd89571aa85aa7$var$_interopRequireDefault((parcelRequire("leD6h")));
function $bffd89571aa85aa7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Commit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for commits in Jira or Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bffd89571aa85aa7$var$CommitIcon = (props)=>/*#__PURE__*/ $bffd89571aa85aa7$var$_react.default.createElement($bffd89571aa85aa7$var$_baseNew.default, Object.assign({
        name: "CommitIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 5.354a2.751 2.751 0 0 0 0 5.292V16h1.5v-5.353a2.751 2.751 0 0 0 0-5.293V0h-1.5zM8 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5" clip-rule="evenodd"/>`
    }, props));
$bffd89571aa85aa7$var$CommitIcon.displayName = 'CommitIcon';
var $bffd89571aa85aa7$var$_default = module.exports.default = $bffd89571aa85aa7$var$CommitIcon;

});

parcelRegister("3OtP0", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7fe936b49905666$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::14dd3b796d1706ede7eb831d28deffaa>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4RAp5 = parcelRequire("4RAp5");
const $a7fe936b49905666$var$Commit16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4RAp5.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-.986 1.834a3.001 3.001 0 0 1 0-5.668A1 1 0 0 1 7 5V3a1 1 0 1 1 2 0v2q0 .085-.014.166a3.001 3.001 0 0 1 0 5.668Q9 10.915 9 11v2a1 1 0 0 1-2 0v-2q0-.085.014-.166"/></svg>`,
        ...props,
        size: "small"
    });
$a7fe936b49905666$var$Commit16Icon.displayName = 'Commit16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a7fe936b49905666$export$2e2bcd8739ae039 = $a7fe936b49905666$var$Commit16Icon;

});


parcelRegister("3Jg3U", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $c716bb6ba93743dc$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2fa1578bca00f96f8398b8ab3053f83>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hGUis = parcelRequire("hGUis");

var $9dRIs = parcelRequire("9dRIs");

var $8BHw1 = parcelRequire("8BHw1");
/**
 * __16px `pull-request` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $c716bb6ba93743dc$var$PullRequest16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hGUis.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9dRIs))),
        appearance: "greenBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8BHw1.default), {
            label: label,
            testId: testId
        })
    });
};
$c716bb6ba93743dc$var$PullRequest16Icon.displayName = 'PullRequest16Icon';
var $c716bb6ba93743dc$export$2e2bcd8739ae039 = $c716bb6ba93743dc$var$PullRequest16Icon;

});
parcelRegister("9dRIs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::baa34f3217bb36f9859c9b6bddb020ad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b6efed2d1d05548$var$_react = $6b6efed2d1d05548$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $6b6efed2d1d05548$var$_baseNew = $6b6efed2d1d05548$var$_interopRequireDefault((parcelRequire("leD6h")));
function $6b6efed2d1d05548$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PullRequest".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6b6efed2d1d05548$var$PullRequestIcon = (props)=>/*#__PURE__*/ $6b6efed2d1d05548$var$_react.default.createElement($6b6efed2d1d05548$var$_baseNew.default, Object.assign({
        name: "PullRequestIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 2 3.25m6-.75h1.75a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8zM4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$6b6efed2d1d05548$var$PullRequestIcon.displayName = 'PullRequestIcon';
var $6b6efed2d1d05548$var$_default = module.exports.default = $6b6efed2d1d05548$var$PullRequestIcon;

});

parcelRegister("8BHw1", function(module, exports) {
$parcel$export(module.exports, "default", () => $146377792f8cea95$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a228b6a8cc996f7aacfdd22dc7d2cc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4RAp5 = parcelRequire("4RAp5");
const $146377792f8cea95$var$PullRequest16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4RAp5.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M6.417 6H9a1 1 0 0 1 1 1v1a1 1 0 0 0 2 0V7a3 3 0 0 0-3-3H6.415l.294-.295a1 1 0 1 0-1.413-1.414l-2.003 2a1 1 0 0 0 .001 1.415l2.002 2.001a1 1 0 0 0 1.414-.002 1 1 0 0 0-.001-1.413zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m9 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`,
        ...props,
        size: "small"
    });
$146377792f8cea95$var$PullRequest16Icon.displayName = 'PullRequest16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$146377792f8cea95$export$2e2bcd8739ae039 = $146377792f8cea95$var$PullRequest16Icon;

});


parcelRegister("hvosn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $6c57fec058657704$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e3cfaee41b098df8ae4032fe4210963>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hGUis = parcelRequire("hGUis");

var $4yIOY = parcelRequire("4yIOY");

var $4hYNc = parcelRequire("4hYNc");
/**
 * __16px `task` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $6c57fec058657704$var$Task16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hGUis.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4yIOY))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4hYNc.default), {
            label: label,
            testId: testId
        })
    });
};
$6c57fec058657704$var$Task16Icon.displayName = 'Task16Icon';
var $6c57fec058657704$export$2e2bcd8739ae039 = $6c57fec058657704$var$Task16Icon;

});
parcelRegister("4yIOY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::511501585faa18257c05d7a2687e12c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $351d1af53a0534db$var$_react = $351d1af53a0534db$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $351d1af53a0534db$var$_baseNew = $351d1af53a0534db$var$_interopRequireDefault((parcelRequire("leD6h")));
function $351d1af53a0534db$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $351d1af53a0534db$var$TaskIcon = (props)=>/*#__PURE__*/ $351d1af53a0534db$var$_react.default.createElement($351d1af53a0534db$var$_baseNew.default, Object.assign({
        name: "TaskIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm9.326 2.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>`
    }, props));
$351d1af53a0534db$var$TaskIcon.displayName = 'TaskIcon';
var $351d1af53a0534db$var$_default = module.exports.default = $351d1af53a0534db$var$TaskIcon;

});

parcelRegister("4hYNc", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e7bb903609abfbd$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c287ed46a4f0bca8d14d4f24a4bb3c80>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4RAp5 = parcelRequire("4RAp5");
const $2e7bb903609abfbd$var$Task16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4RAp5.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zM4.667 3C3.747 3 3 3.746 3 4.667v6.666C3 12.253 3.746 13 4.667 13h6.666c.92 0 1.667-.746 1.667-1.667V4.667C13 3.747 12.254 3 11.333 3zM5 5v6h6V5z"/></svg>`,
        ...props,
        size: "small"
    });
$2e7bb903609abfbd$var$Task16Icon.displayName = 'Task16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2e7bb903609abfbd$export$2e2bcd8739ae039 = $2e7bb903609abfbd$var$Task16Icon;

});


parcelRegister("5tCr0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::68ed51f9e1612abe38768085b9e3fc4c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3fcd797cd68fd666$var$_react = $3fcd797cd68fd666$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $3fcd797cd68fd666$var$_peopleGroup = $3fcd797cd68fd666$var$_interopRequireDefault((parcelRequire("dqqui")));

var $3fcd797cd68fd666$var$_peopleGroup2 = $3fcd797cd68fd666$var$_interopRequireDefault((parcelRequire("9Sc6c")));
function $3fcd797cd68fd666$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleGroupIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3fcd797cd68fd666$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $3fcd797cd68fd666$var$_react.default.createElement($3fcd797cd68fd666$var$_peopleGroup.default, Object.assign({
        name: "PeopleGroupIcon",
        LEGACY_fallbackIcon: $3fcd797cd68fd666$var$_peopleGroup2.default
    }, props));
$3fcd797cd68fd666$var$PeopleGroupIcon.displayName = 'PeopleGroupIconMigration';
var $3fcd797cd68fd666$var$_default = module.exports.default = $3fcd797cd68fd666$var$PeopleGroupIcon;

});
parcelRegister("9Sc6c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $73028ad54cacbc48$var$_react = $73028ad54cacbc48$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4RAp5 = parcelRequire("4RAp5");
function $73028ad54cacbc48$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $73028ad54cacbc48$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $73028ad54cacbc48$var$_react.default.createElement($4RAp5.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M8.13 10H4a2 2 0 0 0-2 2v3.73c0 1.31 1.87 2.05 4 2.23V15a3 3 0 0 1 3-3h.35a4 4 0 0 1-1.23-2m7.75 0H20c1.11 0 2 .89 2 2v3.73c0 1.31-1.87 2.05-4 2.23V15a3 3 0 0 0-3-3h-.35a4 4 0 0 0 1.23-2M9.97 5.55a3 3 0 1 0-1.96 3.27 4 4 0 0 1 1.96-3.27M16 8.83a3 3 0 1 0-1.96-3.28A4 4 0 0 1 16 8.83"/><path d="M7 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><circle cx="12" cy="9" r="3"/></g></svg>`
    }, props));
$73028ad54cacbc48$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $73028ad54cacbc48$var$_default = module.exports.default = $73028ad54cacbc48$var$PeopleGroupIcon;

});


parcelRegister("kzKaK", function(module, exports) {
$parcel$export(module.exports, "extractFileFormat", () => $cdb8addaa6e811bf$export$f2d65f02f6888b60);
const $cdb8addaa6e811bf$export$f2d65f02f6888b60 = (jsonLd)=>{
    return jsonLd['schema:fileFormat'];
};

});

parcelRegister("eU9co", function(module, exports) {
$parcel$export(module.exports, "extractIconFromDocument", () => $ea038f28f92f89d7$export$25c24c7f577936d3);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1Uc1A = parcelRequire("1Uc1A");

var $fC4nI = parcelRequire("fC4nI");

var $aBOSm = parcelRequire("aBOSm");

var $2mToj = parcelRequire("2mToj");

var $ig6Hl = parcelRequire("ig6Hl");

var $7HHiz = parcelRequire("7HHiz");

var $34IUI = parcelRequire("34IUI");

var $1Ap9j = parcelRequire("1Ap9j");

var $cHEjl = parcelRequire("cHEjl");

var $kX1RM = parcelRequire("kX1RM");
const $ea038f28f92f89d7$export$25c24c7f577936d3 = (type, opts)=>{
    const iconFromType = $ea038f28f92f89d7$var$documentTypeToIcon(type, opts);
    const iconFromFileFormat = $ea038f28f92f89d7$var$documentFileFormatToIcon(opts);
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $kX1RM.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $ea038f28f92f89d7$var$documentFileFormatToIcon = (opts)=>{
    if (opts.fileFormat) return (0, $cHEjl.getIconForFileType)(opts.fileFormat);
};
const $ea038f28f92f89d7$var$documentTypeToIcon = (type, opts)=>{
    switch(type){
        case 'schema:BlogPosting':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aBOSm.default), {
                label: opts.showIconLabel ? opts.title || 'blog' : '',
                testId: "blog-icon"
            });
        case 'schema:DigitalDocument':
            return $ea038f28f92f89d7$var$digitalDocumentToIcon(opts);
        case 'schema:TextDigitalDocument':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1Ap9j.default), {
                label: opts.showIconLabel ? opts.title || 'document' : '',
                testId: "document-icon"
            });
        case 'schema:PresentationDigitalDocument':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2mToj.default), {
                label: opts.showIconLabel ? opts.title || 'presentation' : '',
                testId: "presentation-icon"
            });
        case 'schema:SpreadsheetDigitalDocument':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7HHiz.default), {
                label: opts.showIconLabel ? opts.title || 'spreadsheet' : '',
                testId: "spreadsheet-icon"
            });
        case 'atlassian:Template':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1Uc1A))), {
                color: "currentColor",
                label: opts.showIconLabel ? opts.title || 'template' : '',
                testId: "document-filled-icon"
            });
        case 'atlassian:UndefinedLink':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1Ap9j.default), {
                label: opts.showIconLabel ? opts.title || 'undefinedLink' : '',
                testId: "document-icon"
            });
    }
};
/**
 * Enables providers to represent `schema:DigitalDocument` in a manner which
 * aligns with their customers when representing provider-specific types, which
 * do not apply across multiple providers.
 * @example Confluence digital documents represent 'live documents', specific to Confluence.
 * @remark This mechanism will be superseded by backend-driven icon URLs as part
 * of go/j/MODES-5864. Do not add more!
 */ const $ea038f28f92f89d7$var$digitalDocumentToIcon = (opts)=>{
    if (opts.provider?.id && (0, $fC4nI.isConfluenceGenerator)(opts.provider.id)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $34IUI.default), {
        label: "live-doc",
        testId: "live-doc-icon"
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ig6Hl.default), {
        label: opts.showIconLabel ? opts.title || 'file' : '',
        testId: "file-icon"
    });
};

});
parcelRegister("1Uc1A", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2a76a3f4404ba59acd822415adfff8b7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1634593b1b06409b$var$_react = $1634593b1b06409b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $1634593b1b06409b$var$_file = $1634593b1b06409b$var$_interopRequireDefault((parcelRequire("4K4cF")));

var $1634593b1b06409b$var$_documentFilled = $1634593b1b06409b$var$_interopRequireDefault((parcelRequire("5OKNx")));
function $1634593b1b06409b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FileIcon.
 * This component is FileIcon, with `UNSAFE_fallbackIcon` set to "DocumentFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1634593b1b06409b$var$FileIcon = (props)=>/*#__PURE__*/ $1634593b1b06409b$var$_react.default.createElement($1634593b1b06409b$var$_file.default, Object.assign({
        name: "FileIcon",
        LEGACY_fallbackIcon: $1634593b1b06409b$var$_documentFilled.default
    }, props));
$1634593b1b06409b$var$FileIcon.displayName = 'FileIconMigration';
var $1634593b1b06409b$var$_default = module.exports.default = $1634593b1b06409b$var$FileIcon;

});
parcelRegister("4K4cF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::51c2fad80696a752d051082f1f9faaf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $373eb7ff959663a4$var$_react = $373eb7ff959663a4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $373eb7ff959663a4$var$_baseNew = $373eb7ff959663a4$var$_interopRequireDefault((parcelRequire("leD6h")));
function $373eb7ff959663a4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $373eb7ff959663a4$var$FileIcon = (props)=>/*#__PURE__*/ $373eb7ff959663a4$var$_react.default.createElement($373eb7ff959663a4$var$_baseNew.default, Object.assign({
        name: "FileIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$373eb7ff959663a4$var$FileIcon.displayName = 'FileIcon';
var $373eb7ff959663a4$var$_default = module.exports.default = $373eb7ff959663a4$var$FileIcon;

});

parcelRegister("5OKNx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $43c5ec64eb32e94c$var$_react = $43c5ec64eb32e94c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4RAp5 = parcelRequire("4RAp5");
function $43c5ec64eb32e94c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $43c5ec64eb32e94c$var$DocumentFilledIcon = (props)=>/*#__PURE__*/ $43c5ec64eb32e94c$var$_react.default.createElement($4RAp5.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m18.99 8.99.01 1.015V19a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.275c.469 0 .922.164 1.282.464L18.631 7.7c.227.19.359.471.359.768zM12.02 5 12 8.192a.99.99 0 0 0 .994.991h4z"/></svg>`
    }, props));
$43c5ec64eb32e94c$var$DocumentFilledIcon.displayName = 'DocumentFilledIcon';
var $43c5ec64eb32e94c$var$_default = module.exports.default = $43c5ec64eb32e94c$var$DocumentFilledIcon;

});


parcelRegister("2mToj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $adcb483f880e0119$export$2e2bcd8739ae039);

var $2YCMy = parcelRequire("2YCMy");

var $yc7dT = parcelRequire("yc7dT");

var $5ZLJP = parcelRequire("5ZLJP");

var $ipfnM = parcelRequire("ipfnM");
const $adcb483f880e0119$var$ChartBarIconWithColor = (0, $ipfnM.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($5ZLJP))), 'purpleBold', (0, $ipfnM.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($2YCMy))), (0, (/*@__PURE__*/$parcel$interopDefault($yc7dT)))));
$adcb483f880e0119$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $adcb483f880e0119$export$2e2bcd8739ae039 = $adcb483f880e0119$var$ChartBarIconWithColor;

});
parcelRegister("2YCMy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $22af44b4cd78de53$var$_react = $22af44b4cd78de53$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4RAp5 = parcelRequire("4RAp5");
function $22af44b4cd78de53$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $22af44b4cd78de53$var$Presentation16Icon = (props)=>/*#__PURE__*/ $22af44b4cd78de53$var$_react.default.createElement($4RAp5.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m10 3a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1M8 6a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1M4 9a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'small'
    }));
$22af44b4cd78de53$var$Presentation16Icon.displayName = 'Presentation16Icon';
var $22af44b4cd78de53$var$_default = module.exports.default = $22af44b4cd78de53$var$Presentation16Icon;

});

parcelRegister("yc7dT", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $066c92fa1b8c8579$var$_react = $066c92fa1b8c8579$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4RAp5 = parcelRequire("4RAp5");
function $066c92fa1b8c8579$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $066c92fa1b8c8579$var$Presentation24Icon = (props)=>/*#__PURE__*/ $066c92fa1b8c8579$var$_react.default.createElement($4RAp5.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$066c92fa1b8c8579$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $066c92fa1b8c8579$var$_default = module.exports.default = $066c92fa1b8c8579$var$Presentation24Icon;

});

parcelRegister("5ZLJP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25c5fc21ffe3de28c11b1ff576772f32>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $45d7ae0d73bceec2$var$_react = $45d7ae0d73bceec2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $45d7ae0d73bceec2$var$_baseNew = $45d7ae0d73bceec2$var$_interopRequireDefault((parcelRequire("leD6h")));
function $45d7ae0d73bceec2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Bar charts; Reports in JSM, Space Analytics in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $45d7ae0d73bceec2$var$ChartBarIcon = (props)=>/*#__PURE__*/ $45d7ae0d73bceec2$var$_react.default.createElement($45d7ae0d73bceec2$var$_baseNew.default, Object.assign({
        name: "ChartBarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="m5.25 8.5.077.004A.75.75 0 0 1 6 9.25v2.5a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 .75-.75zm4-3.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-6A.75.75 0 0 1 8.25 5zm4-3a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 .75-.75z"/>`
    }, props));
$45d7ae0d73bceec2$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $45d7ae0d73bceec2$var$_default = module.exports.default = $45d7ae0d73bceec2$var$ChartBarIcon;

});


parcelRegister("ig6Hl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $d3b72f5610e77f3f$export$2e2bcd8739ae039);

var $ePePV = parcelRequire("ePePV");

var $xfJd5 = parcelRequire("xfJd5");

var $4K4cF = parcelRequire("4K4cF");

var $ipfnM = parcelRequire("ipfnM");
const $d3b72f5610e77f3f$var$FileIconWithColor = (0, $ipfnM.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($4K4cF))), 'grayBold', (0, $ipfnM.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($ePePV))), (0, (/*@__PURE__*/$parcel$interopDefault($xfJd5)))));
$d3b72f5610e77f3f$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $d3b72f5610e77f3f$export$2e2bcd8739ae039 = $d3b72f5610e77f3f$var$FileIconWithColor;

});
parcelRegister("ePePV", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $acb15654b6ac1394$var$_react = $acb15654b6ac1394$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4RAp5 = parcelRequire("4RAp5");
function $acb15654b6ac1394$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $acb15654b6ac1394$var$Generic16Icon = (props)=>/*#__PURE__*/ $acb15654b6ac1394$var$_react.default.createElement($4RAp5.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M8 3H5.333C4.597 3 4 3.617 4 4.378v7.244C4 12.382 4.597 13 5.333 13h5.334c.736 0 1.333-.617 1.333-1.378V8h-1.333v3.622H5.333V4.378H8v1.414c0 .736.597 1.333 1.333 1.333h2.334c.184 0 .333-.15.333-.333v-.903a.33.33 0 0 0-.093-.231l-2.164-2.25A1.33 1.33 0 0 0 8.782 3zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006z"/></svg>`
    }, props, {
        size: 'small'
    }));
$acb15654b6ac1394$var$Generic16Icon.displayName = 'Generic16Icon';
var $acb15654b6ac1394$var$_default = module.exports.default = $acb15654b6ac1394$var$Generic16Icon;

});

parcelRegister("xfJd5", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $063f487944f4f1f6$var$_react = $063f487944f4f1f6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4RAp5 = parcelRequire("4RAp5");
function $063f487944f4f1f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $063f487944f4f1f6$var$Generic24Icon = (props)=>/*#__PURE__*/ $063f487944f4f1f6$var$_react.default.createElement($4RAp5.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M12 4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6.995h-2V18H8V6h4v2a2 2 0 0 0 2 2h3.5a.5.5 0 0 0 .5-.5V8.213a.5.5 0 0 0-.145-.352L14.61 4.59A2 2 0 0 0 13.19 4zM3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`
    }, props, {
        size: 'medium'
    }));
$063f487944f4f1f6$var$Generic24Icon.displayName = 'Generic24Icon';
var $063f487944f4f1f6$var$_default = module.exports.default = $063f487944f4f1f6$var$Generic24Icon;

});


parcelRegister("7HHiz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $b43d55d344f37cb0$export$2e2bcd8739ae039);

var $kHjnp = parcelRequire("kHjnp");

var $04dM9 = parcelRequire("04dM9");

var $h6kpZ = parcelRequire("h6kpZ");

var $ipfnM = parcelRequire("ipfnM");
const $b43d55d344f37cb0$var$ListBulletedIconWithColor = (0, $ipfnM.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($h6kpZ))), 'greenBold', (0, $ipfnM.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($kHjnp))), (0, (/*@__PURE__*/$parcel$interopDefault($04dM9)))));
$b43d55d344f37cb0$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $b43d55d344f37cb0$export$2e2bcd8739ae039 = $b43d55d344f37cb0$var$ListBulletedIconWithColor;

});
parcelRegister("kHjnp", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $f116da91c135b67f$var$_react = $f116da91c135b67f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4RAp5 = parcelRequire("4RAp5");
function $f116da91c135b67f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f116da91c135b67f$var$Spreadsheet16Icon = (props)=>/*#__PURE__*/ $f116da91c135b67f$var$_react.default.createElement($4RAp5.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 4a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2zm5-8a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$f116da91c135b67f$var$Spreadsheet16Icon.displayName = 'Spreadsheet16Icon';
var $f116da91c135b67f$var$_default = module.exports.default = $f116da91c135b67f$var$Spreadsheet16Icon;

});

parcelRegister("04dM9", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $00cb0f652441b92a$var$_react = $00cb0f652441b92a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4RAp5 = parcelRequire("4RAp5");
function $00cb0f652441b92a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $00cb0f652441b92a$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $00cb0f652441b92a$var$_react.default.createElement($4RAp5.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$00cb0f652441b92a$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $00cb0f652441b92a$var$_default = module.exports.default = $00cb0f652441b92a$var$Spreadsheet24Icon;

});

parcelRegister("h6kpZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::94ba737f8eb536b5803fd14d2e86416d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c732d5d4509a3e6d$var$_react = $c732d5d4509a3e6d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c732d5d4509a3e6d$var$_baseNew = $c732d5d4509a3e6d$var$_interopRequireDefault((parcelRequire("leD6h")));
function $c732d5d4509a3e6d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c732d5d4509a3e6d$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $c732d5d4509a3e6d$var$_react.default.createElement($c732d5d4509a3e6d$var$_baseNew.default, Object.assign({
        name: "ListBulletedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$c732d5d4509a3e6d$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $c732d5d4509a3e6d$var$_default = module.exports.default = $c732d5d4509a3e6d$var$ListBulletedIcon;

});



parcelRegister("k7omp", function(module, exports) {
$parcel$export(module.exports, "extractIconFromTask", () => $89d5a98c719c0135$export$321256ed044e3100);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hXyKU = parcelRequire("hXyKU");

var $grbnW = parcelRequire("grbnW");

var $59o0k = parcelRequire("59o0k");

var $jwxtN = parcelRequire("jwxtN");

var $78tct = parcelRequire("78tct");

var $fNFMk = parcelRequire("fNFMk");

var $9zla4 = parcelRequire("9zla4");

var $3iybf = parcelRequire("3iybf");

var $hvosn = parcelRequire("hvosn");

var $i78Zr = parcelRequire("i78Zr");
const $89d5a98c719c0135$var$TaskIcon = (0, $hvosn.default);
const $89d5a98c719c0135$export$321256ed044e3100 = (opts)=>{
    // Render Atlaskit icons for all supported Jira issue types.
    const { taskType: taskType, provider: provider } = opts;
    const taskLabel = opts.title || 'task';
    const defaultIcon = /*#__PURE__*/ (0, $gt9Am.jsx)($89d5a98c719c0135$var$TaskIcon, {
        label: taskLabel,
        testId: "default-task-icon"
    });
    if (provider && provider.id === (0, $i78Zr.JIRA_GENERATOR_ID) && taskType && taskType.id) {
        const taskTypeId = taskType.id;
        const taskTypeName = taskTypeId.split('#').pop();
        switch(taskTypeName){
            case 0, $i78Zr.JIRA_TASK:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hvosn.default), {
                    label: taskLabel,
                    testId: "jira-task-icon"
                });
            case 0, $i78Zr.JIRA_SUB_TASK:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3iybf.default), {
                    label: taskLabel,
                    testId: "jira-subtask-icon"
                });
            case 0, $i78Zr.JIRA_STORY:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9zla4.default), {
                    label: taskLabel,
                    testId: "jira-story-icon"
                });
            case 0, $i78Zr.JIRA_BUG:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hXyKU.default), {
                    label: taskLabel,
                    testId: "jira-bug-icon"
                });
            case 0, $i78Zr.JIRA_EPIC:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $59o0k.default), {
                    label: taskLabel,
                    testId: "jira-epic-icon"
                });
            case 0, $i78Zr.JIRA_INCIDENT:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jwxtN.default), {
                    label: taskLabel,
                    testId: "jira-incident-icon"
                });
            case 0, $i78Zr.JIRA_SERVICE_REQUEST:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $78tct.default), {
                    label: taskLabel,
                    testId: "jira-service-request-icon"
                });
            case 0, $i78Zr.JIRA_CHANGE:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $grbnW.default), {
                    label: taskLabel,
                    testId: "jira-change-icon"
                });
            case 0, $i78Zr.JIRA_PROBLEM:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fNFMk.default), {
                    label: taskLabel,
                    testId: "jira-problem-icon"
                });
            case 0, $i78Zr.JIRA_CUSTOM_TASK_TYPE:
                return taskType.icon || opts.icon || provider.icon || defaultIcon;
        }
    }
    return defaultIcon;
};

});
parcelRegister("hXyKU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $ce9e8c3fc94e3552$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1b3eace3db32e909d8e4c2d548565af4>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hGUis = parcelRequire("hGUis");

var $boAm1 = parcelRequire("boAm1");

var $d6ns0 = parcelRequire("d6ns0");
/**
 * __16px `bug` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $ce9e8c3fc94e3552$var$Bug16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hGUis.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($boAm1))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d6ns0.default), {
            label: label,
            testId: testId
        })
    });
};
$ce9e8c3fc94e3552$var$Bug16Icon.displayName = 'Bug16Icon';
var $ce9e8c3fc94e3552$export$2e2bcd8739ae039 = $ce9e8c3fc94e3552$var$Bug16Icon;

});
parcelRegister("boAm1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1c065f0aa91b3c3f089345b7ec72ae8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $84be22ca232bd32c$var$_react = $84be22ca232bd32c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $84be22ca232bd32c$var$_baseNew = $84be22ca232bd32c$var$_interopRequireDefault((parcelRequire("leD6h")));
function $84be22ca232bd32c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Bug".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Request types in JSM, bugs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $84be22ca232bd32c$var$BugIcon = (props)=>/*#__PURE__*/ $84be22ca232bd32c$var$_react.default.createElement($84be22ca232bd32c$var$_baseNew.default, Object.assign({
        name: "BugIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 2.5A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 8 2.5m3 1.52V4a3 3 0 0 0-6 0v.02c-.29.05-.553.182-.761.372l-.887-.633-.917-2.064-1.37.61.944 2.125c.09.204.234.38.416.51l1.325.946V7H.5v1.5h3.25v1.149l-1.15.958a1.25 1.25 0 0 0-.318.401L1.08 13.415l1.342.67 1.18-2.36.46-.383A4.25 4.25 0 0 0 8.001 14h.249A4 4 0 0 0 12 11.393l.4.333 1.18 2.36 1.34-.671-1.202-2.407a1.25 1.25 0 0 0-.318-.401l-1.15-.958V8.5h3.25V7h-3.25V5.886l1.325-.946a1.25 1.25 0 0 0 .416-.51l.944-2.125-1.37-.61-.917 2.064-.887.633A1.5 1.5 0 0 0 11 4.02M10.75 10V5.5h-5.5v4.443l.035.226A2.75 2.75 0 0 0 8 12.5h.249a2.5 2.5 0 0 0 2.5-2.5" clip-rule="evenodd"/>`
    }, props));
$84be22ca232bd32c$var$BugIcon.displayName = 'BugIcon';
var $84be22ca232bd32c$var$_default = module.exports.default = $84be22ca232bd32c$var$BugIcon;

});

parcelRegister("d6ns0", function(module, exports) {
$parcel$export(module.exports, "default", () => $178c7dcb6fc6efe8$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a6b2aaa54dc8ca05673d473e302061ba>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4RAp5 = parcelRequire("4RAp5");
const $178c7dcb6fc6efe8$var$Bug16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4RAp5.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`,
        ...props,
        size: "small"
    });
$178c7dcb6fc6efe8$var$Bug16Icon.displayName = 'Bug16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$178c7dcb6fc6efe8$export$2e2bcd8739ae039 = $178c7dcb6fc6efe8$var$Bug16Icon;

});


parcelRegister("grbnW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $21ecc8c89c60610d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::505d8909c8998f8492f66eab6e38980b>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hGUis = parcelRequire("hGUis");

var $cJTk0 = parcelRequire("cJTk0");

var $kQHAk = parcelRequire("kQHAk");
/**
 * __16px `changes` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $21ecc8c89c60610d$var$Changes16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hGUis.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cJTk0))),
        appearance: "orangeBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kQHAk.default), {
            label: label,
            testId: testId
        })
    });
};
$21ecc8c89c60610d$var$Changes16Icon.displayName = 'Changes16Icon';
var $21ecc8c89c60610d$export$2e2bcd8739ae039 = $21ecc8c89c60610d$var$Changes16Icon;

});
parcelRegister("cJTk0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c248cb8ff46f92a14313d2de4318df80>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $946499bce74497fa$var$_react = $946499bce74497fa$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $946499bce74497fa$var$_baseNew = $946499bce74497fa$var$_interopRequireDefault((parcelRequire("leD6h")));
function $946499bce74497fa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Changes".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for changes in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $946499bce74497fa$var$ChangesIcon = (props)=>/*#__PURE__*/ $946499bce74497fa$var$_react.default.createElement($946499bce74497fa$var$_baseNew.default, Object.assign({
        name: "ChangesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 4.22 11.53.97l-1.06 1.06L12.44 4H2v1.5h10.44l-1.97 1.97 1.06 1.06 3.25-3.25a.75.75 0 0 0 0-1.06M3.56 10.5l1.97-1.97-1.06-1.06-3.25 3.25a.75.75 0 0 0 0 1.06l3.25 3.25 1.06-1.06L3.56 12H14v-1.5z" clip-rule="evenodd"/>`
    }, props));
$946499bce74497fa$var$ChangesIcon.displayName = 'ChangesIcon';
var $946499bce74497fa$var$_default = module.exports.default = $946499bce74497fa$var$ChangesIcon;

});

parcelRegister("kQHAk", function(module, exports) {
$parcel$export(module.exports, "default", () => $216bce843a94a68b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43edfd1c3679c7345c2a442459999c85>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4RAp5 = parcelRequire("4RAp5");
const $216bce843a94a68b$var$Changes16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4RAp5.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M10.58 7H5.467l.866-.865A1 1 0 1 0 4.92 4.72L2.34 7.3a1 1 0 0 0 0 1.414l2.58 2.578a1 1 0 0 0 1.414-1.416L5.456 9h5.134l-.877.876a1 1 0 1 0 1.414 1.415l2.58-2.58a1 1 0 0 0 0-1.414L11.126 4.72a1 1 0 0 0-.706-.292.999.999 0 0 0-.707 1.707zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$216bce843a94a68b$var$Changes16Icon.displayName = 'Changes16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$216bce843a94a68b$export$2e2bcd8739ae039 = $216bce843a94a68b$var$Changes16Icon;

});


parcelRegister("59o0k", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $f948d1d496101bfd$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ef3c8ed5e57f17047733a8020ce784d5>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hGUis = parcelRequire("hGUis");

var $ltdfu = parcelRequire("ltdfu");

var $6kybX = parcelRequire("6kybX");
/**
 * __16px `epic` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $f948d1d496101bfd$var$Epic16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hGUis.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ltdfu))),
        appearance: "purpleBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6kybX.default), {
            label: label,
            testId: testId
        })
    });
};
$f948d1d496101bfd$var$Epic16Icon.displayName = 'Epic16Icon';
var $f948d1d496101bfd$export$2e2bcd8739ae039 = $f948d1d496101bfd$var$Epic16Icon;

});
parcelRegister("ltdfu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::27415f759dcf84731b49eedf76030531>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fa169558867cbd6b$var$_react = $fa169558867cbd6b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fa169558867cbd6b$var$_baseNew = $fa169558867cbd6b$var$_interopRequireDefault((parcelRequire("leD6h")));
function $fa169558867cbd6b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Epic".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for epics in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fa169558867cbd6b$var$EpicIcon = (props)=>/*#__PURE__*/ $fa169558867cbd6b$var$_react.default.createElement($fa169558867cbd6b$var$_baseNew.default, Object.assign({
        name: "EpicIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.271.05a.75.75 0 0 1 .479.7v4.635l3.147.63a.75.75 0 0 1 .407 1.24l-7.75 8.5a.75.75 0 0 1-1.304-.505v-4.635l-3.147-.63a.75.75 0 0 1-.407-1.24l7.75-8.5A.75.75 0 0 1 10.27.05M3.698 8.776l3.052.61v3.93l5.552-6.09-3.052-.61v-3.93z" clip-rule="evenodd"/>`
    }, props));
$fa169558867cbd6b$var$EpicIcon.displayName = 'EpicIcon';
var $fa169558867cbd6b$var$_default = module.exports.default = $fa169558867cbd6b$var$EpicIcon;

});

parcelRegister("6kybX", function(module, exports) {
$parcel$export(module.exports, "default", () => $85dcfe2e4091e6bf$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::142d10bfd50eb509af7927d7baa82685>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4RAp5 = parcelRequire("4RAp5");
const $85dcfe2e4091e6bf$var$Epic16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4RAp5.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554c0" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m9.912 7.767A.5.5 0 0 0 12 7.5a.5.5 0 0 0-.5-.5H9V3.5a.495.495 0 0 0-.872-.327l-.002-.001-3.977 4.973-.008.009-.028.036.002.004A.5.5 0 0 0 4 8.5a.5.5 0 0 0 .5.5c.028 0 .051-.011.077-.016H7V12.5a.5.5 0 0 0 .5.5c.124 0 .234-.05.321-.124l.004.001.007-.009c.03-.027.051-.059.074-.092l3.934-4.913c.019-.018.031-.039.047-.06l.027-.033z"/></svg>`,
        ...props,
        size: "small"
    });
$85dcfe2e4091e6bf$var$Epic16Icon.displayName = 'Epic16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$85dcfe2e4091e6bf$export$2e2bcd8739ae039 = $85dcfe2e4091e6bf$var$Epic16Icon;

});


parcelRegister("jwxtN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $2a367c448488ee4d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ede68a79193f0a8a70fa374ba104253c>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hGUis = parcelRequire("hGUis");

var $lltma = parcelRequire("lltma");

var $kofpK = parcelRequire("kofpK");
/**
 * __16px `incident` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $2a367c448488ee4d$var$Incident16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hGUis.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lltma))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kofpK.default), {
            label: label,
            testId: testId
        })
    });
};
$2a367c448488ee4d$var$Incident16Icon.displayName = 'Incident16Icon';
var $2a367c448488ee4d$export$2e2bcd8739ae039 = $2a367c448488ee4d$var$Incident16Icon;

});
parcelRegister("lltma", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f39860ce7f984391648fef01b18ffad3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f8a254bac64517d8$var$_react = $f8a254bac64517d8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f8a254bac64517d8$var$_baseNew = $f8a254bac64517d8$var$_interopRequireDefault((parcelRequire("leD6h")));
function $f8a254bac64517d8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Incident".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for incidents in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f8a254bac64517d8$var$IncidentIcon = (props)=>/*#__PURE__*/ $f8a254bac64517d8$var$_react.default.createElement($f8a254bac64517d8$var$_baseNew.default, Object.assign({
        name: "IncidentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1a.75.75 0 0 1 .696.471l2.2 5.5 2.612 6.529H15V15H1v-1.5h1.492L7.304 1.471A.75.75 0 0 1 8 1M4.108 13.5h7.784l-.8-2H4.908zm1.4-3.5h4.984l-.8-2H6.308zm1.4-3.5h2.184L8 3.77z" clip-rule="evenodd"/>`
    }, props));
$f8a254bac64517d8$var$IncidentIcon.displayName = 'IncidentIcon';
var $f8a254bac64517d8$var$_default = module.exports.default = $f8a254bac64517d8$var$IncidentIcon;

});

parcelRegister("kofpK", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8be8b4373051c9a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b29b882c898f601323f622b31bfeccd>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4RAp5 = parcelRequire("4RAp5");
const $f8be8b4373051c9a$var$Incident16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4RAp5.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M4.785 10h6.43L10.5 8H5.499zM4 11a1 1 0 0 0-1 1v1h10v-1a1 1 0 0 0-1-1zm1.856-4h4.288L8.942 3.632a1 1 0 0 0-1.884 0zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$f8be8b4373051c9a$var$Incident16Icon.displayName = 'Incident16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f8be8b4373051c9a$export$2e2bcd8739ae039 = $f8be8b4373051c9a$var$Incident16Icon;

});


parcelRegister("78tct", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $ef47a17d811726af$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f51ecb48642a229c7b6d1a69d64d867>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hGUis = parcelRequire("hGUis");

var $HojOz = parcelRequire("HojOz");

var $80Dfz = parcelRequire("80Dfz");
/**
 * __16px `issue` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $ef47a17d811726af$var$Issue16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hGUis.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($HojOz))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $80Dfz.default), {
            label: label,
            testId: testId
        })
    });
};
$ef47a17d811726af$var$Issue16Icon.displayName = 'Issue16Icon';
var $ef47a17d811726af$export$2e2bcd8739ae039 = $ef47a17d811726af$var$Issue16Icon;

});
parcelRegister("HojOz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5af16ea80f1d58312eb2e017eb04c22b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0826e16ec7d27338$var$_react = $0826e16ec7d27338$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0826e16ec7d27338$var$_baseNew = $0826e16ec7d27338$var$_interopRequireDefault((parcelRequire("leD6h")));
function $0826e16ec7d27338$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0826e16ec7d27338$var$WorkItemIcon = (props)=>/*#__PURE__*/ $0826e16ec7d27338$var$_react.default.createElement($0826e16ec7d27338$var$_baseNew.default, Object.assign({
        name: "WorkItemIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 4a.5.5 0 0 0-.4-.49L14 3.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zm-2.927 1.983-4 4.75a.75.75 0 0 1-1.146 0l-2-2.375 1.146-.966L7 9.085l3.427-4.068zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 4z"/>`
    }, props));
$0826e16ec7d27338$var$WorkItemIcon.displayName = 'WorkItemIcon';
var $0826e16ec7d27338$var$_default = module.exports.default = $0826e16ec7d27338$var$WorkItemIcon;

});

parcelRegister("80Dfz", function(module, exports) {
$parcel$export(module.exports, "default", () => $763ffcf5f13e2bad$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe2288302fb4009a8dfaa99b181ad17d>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4RAp5 = parcelRequire("4RAp5");
const $763ffcf5f13e2bad$var$Issue16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4RAp5.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm1 2v4h8V6z"/></svg>`,
        ...props,
        size: "small"
    });
$763ffcf5f13e2bad$var$Issue16Icon.displayName = 'Issue16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$763ffcf5f13e2bad$export$2e2bcd8739ae039 = $763ffcf5f13e2bad$var$Issue16Icon;

});


parcelRegister("fNFMk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $b1a375748d9c00de$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45711362ad054d9d0de581c03f164950>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hGUis = parcelRequire("hGUis");

var $fueet = parcelRequire("fueet");

var $bgsUb = parcelRequire("bgsUb");
/**
 * __16px `problem` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $b1a375748d9c00de$var$Problem16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hGUis.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fueet))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bgsUb.default), {
            label: label,
            testId: testId
        })
    });
};
$b1a375748d9c00de$var$Problem16Icon.displayName = 'Problem16Icon';
var $b1a375748d9c00de$export$2e2bcd8739ae039 = $b1a375748d9c00de$var$Problem16Icon;

});
parcelRegister("fueet", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c3166f2fe0f47ea82d95571c4b7ab84>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b464b29ed00bcf2b$var$_react = $b464b29ed00bcf2b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $b464b29ed00bcf2b$var$_baseNew = $b464b29ed00bcf2b$var$_interopRequireDefault((parcelRequire("leD6h")));
function $b464b29ed00bcf2b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Problem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for problem work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b464b29ed00bcf2b$var$ProblemIcon = (props)=>/*#__PURE__*/ $b464b29ed00bcf2b$var$_react.default.createElement($b464b29ed00bcf2b$var$_baseNew.default, Object.assign({
        name: "ProblemIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.343 2.343a8 8 0 1 1 11.314 11.315A8 8 0 0 1 2.343 2.343m.561 1.622a6.5 6.5 0 0 0 9.13 9.13zm9.693-.562a6.5 6.5 0 0 0-8.632-.499l9.13 9.13a6.5 6.5 0 0 0-.498-8.63"/>`
    }, props));
$b464b29ed00bcf2b$var$ProblemIcon.displayName = 'ProblemIcon';
var $b464b29ed00bcf2b$var$_default = module.exports.default = $b464b29ed00bcf2b$var$ProblemIcon;

});

parcelRegister("bgsUb", function(module, exports) {
$parcel$export(module.exports, "default", () => $34895864887627c3$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::22fd64be1230cdfa956ed09821e612ad>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4RAp5 = parcelRequire("4RAp5");
const $34895864887627c3$var$Problem16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4RAp5.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="m5.968 11.446 5.478-5.478a4 4 0 0 1-5.478 5.478m-1.414-1.414a4 4 0 0 1 5.478-5.478zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12"/></svg>`,
        ...props,
        size: "small"
    });
$34895864887627c3$var$Problem16Icon.displayName = 'Problem16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$34895864887627c3$export$2e2bcd8739ae039 = $34895864887627c3$var$Problem16Icon;

});


parcelRegister("9zla4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $45f5439fff776b2a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::544b9f71dc9f7001702597ba0216e61f>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hGUis = parcelRequire("hGUis");

var $9eS4x = parcelRequire("9eS4x");

var $eoWfq = parcelRequire("eoWfq");
/**
 * __16px `story` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $45f5439fff776b2a$var$Story16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hGUis.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9eS4x))),
        appearance: "greenBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eoWfq.default), {
            label: label,
            testId: testId
        })
    });
};
$45f5439fff776b2a$var$Story16Icon.displayName = 'Story16Icon';
var $45f5439fff776b2a$export$2e2bcd8739ae039 = $45f5439fff776b2a$var$Story16Icon;

});
parcelRegister("9eS4x", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c7bb68234d60992450ed6f02b59a5e8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b9f5d7a5c433119$var$_react = $6b9f5d7a5c433119$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $6b9f5d7a5c433119$var$_baseNew = $6b9f5d7a5c433119$var$_interopRequireDefault((parcelRequire("leD6h")));
function $6b9f5d7a5c433119$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Story".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for story work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6b9f5d7a5c433119$var$StoryIcon = (props)=>/*#__PURE__*/ $6b9f5d7a5c433119$var$_react.default.createElement($6b9f5d7a5c433119$var$_baseNew.default, Object.assign({
        name: "StoryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.518 3a.5.5 0 0 0-.5-.5H4.983a.5.5 0 0 0-.5.5v9.806L8 10.333l.431.304 3.087 2.169zm1.5 11.202a.776.776 0 0 1-1.122.694l-.099-.06L8 12.166l-3.796 2.67a.775.775 0 0 1-1.22-.634V3a2 2 0 0 1 2-2h6.035a2 2 0 0 1 2 2z"/>`
    }, props));
$6b9f5d7a5c433119$var$StoryIcon.displayName = 'StoryIcon';
var $6b9f5d7a5c433119$var$_default = module.exports.default = $6b9f5d7a5c433119$var$StoryIcon;

});

parcelRegister("eoWfq", function(module, exports) {
$parcel$export(module.exports, "default", () => $243ef6a946767401$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::888e49ac8aee51ec38f43bede32963e9>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4RAp5 = parcelRequire("4RAp5");
const $243ef6a946767401$var$Story16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4RAp5.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 11-2.863 1.822c-.42.38-1.137.111-1.137-.427v-8.19C4 3.54 4.596 3 5.333 3h5.334C11.403 3 12 3.539 12 4.206v8.19c0 .537-.719.806-1.139.426zm0-2.371 2 1.274V5H6v4.902z"/></svg>`,
        ...props,
        size: "small"
    });
$243ef6a946767401$var$Story16Icon.displayName = 'Story16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$243ef6a946767401$export$2e2bcd8739ae039 = $243ef6a946767401$var$Story16Icon;

});


parcelRegister("3iybf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $f23f34363e3bb23d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a4f42caad88ed71da33903f9c7053102>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hGUis = parcelRequire("hGUis");

var $6OiEb = parcelRequire("6OiEb");

var $5Mm1e = parcelRequire("5Mm1e");
/**
 * __16px `subtask` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $f23f34363e3bb23d$var$Subtask16Icon = ({ label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hGUis.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6OiEb))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5Mm1e.default), {
            label: label,
            testId: testId
        })
    });
};
$f23f34363e3bb23d$var$Subtask16Icon.displayName = 'Subtask16Icon';
var $f23f34363e3bb23d$export$2e2bcd8739ae039 = $f23f34363e3bb23d$var$Subtask16Icon;

});
parcelRegister("6OiEb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c160a9f26591f77220765c2e9d99939c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f55e080ddd0ec93$var$_react = $4f55e080ddd0ec93$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4f55e080ddd0ec93$var$_baseNew = $4f55e080ddd0ec93$var$_interopRequireDefault((parcelRequire("leD6h")));
function $4f55e080ddd0ec93$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Subtasks".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for subtask work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4f55e080ddd0ec93$var$SubtasksIcon = (props)=>/*#__PURE__*/ $4f55e080ddd0ec93$var$_react.default.createElement($4f55e080ddd0ec93$var$_baseNew.default, Object.assign({
        name: "SubtasksIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 9.25a.5.5 0 0 0-.5-.5H8.75V13a.5.5 0 0 0 .5.5H13a.5.5 0 0 0 .5-.5zM7.25 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v3.75a.5.5 0 0 0 .5.5h4.25zm1.5 4.25H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H9.25a2 2 0 0 1-2-2V8.75H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3.75a2 2 0 0 1 2 2z"/>`
    }, props));
$4f55e080ddd0ec93$var$SubtasksIcon.displayName = 'SubtasksIcon';
var $4f55e080ddd0ec93$var$_default = module.exports.default = $4f55e080ddd0ec93$var$SubtasksIcon;

});

parcelRegister("5Mm1e", function(module, exports) {
$parcel$export(module.exports, "default", () => $c496849d2002380d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d77b8a2607635762876eadf6c30777eb>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4RAp5 = parcelRequire("4RAp5");
const $c496849d2002380d$var$Subtask16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4RAp5.Icon), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M9 7V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zM9 9h2v2H9zM5 5h2v2H5z"/></svg>`,
        ...props,
        size: "small"
    });
$c496849d2002380d$var$Subtask16Icon.displayName = 'Subtask16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c496849d2002380d$export$2e2bcd8739ae039 = $c496849d2002380d$var$Subtask16Icon;

});




parcelRegister("o3Uls", function(module, exports) {
$parcel$export(module.exports, "extractTitleTextColor", () => $55613d83c50a38e2$export$a2afc198e9dada1);


var $8YjRy = parcelRequire("8YjRy");
const $55613d83c50a38e2$export$a2afc198e9dada1 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $8YjRy.extractorPriorityMap)[b] - (0, $8YjRy.extractorPriorityMap)[a])[0];
        switch(highestPriorityType){
            case 'atlassian:UndefinedLink':
                return `var(--ds-text-danger, ${0, $15543b40efbda8c4$export$2837b5a1a71d5c02})`;
            default:
                return undefined;
        }
    }
};

});
var $15543b40efbda8c4$exports = {};
$parcel$export($15543b40efbda8c4$exports, "R50", () => $15543b40efbda8c4$export$4b84fd0e2c617bd);
$parcel$export($15543b40efbda8c4$exports, "R75", () => $15543b40efbda8c4$export$b34b069eff244586);
$parcel$export($15543b40efbda8c4$exports, "R100", () => $15543b40efbda8c4$export$be802dd0d8b57f35);
$parcel$export($15543b40efbda8c4$exports, "R200", () => $15543b40efbda8c4$export$60847d42f9da92a6);
$parcel$export($15543b40efbda8c4$exports, "R300", () => $15543b40efbda8c4$export$4a7404f376229999);
$parcel$export($15543b40efbda8c4$exports, "R400", () => $15543b40efbda8c4$export$2010d0fb4295b346);
$parcel$export($15543b40efbda8c4$exports, "R500", () => $15543b40efbda8c4$export$2837b5a1a71d5c02);
$parcel$export($15543b40efbda8c4$exports, "Y50", () => $15543b40efbda8c4$export$8d9596b529bbb9cf);
$parcel$export($15543b40efbda8c4$exports, "Y75", () => $15543b40efbda8c4$export$41060a744ab0b7ae);
$parcel$export($15543b40efbda8c4$exports, "Y100", () => $15543b40efbda8c4$export$1cc05bbbf340e559);
$parcel$export($15543b40efbda8c4$exports, "Y200", () => $15543b40efbda8c4$export$5aae31392d72caaa);
$parcel$export($15543b40efbda8c4$exports, "Y300", () => $15543b40efbda8c4$export$c6930421db9fa514);
$parcel$export($15543b40efbda8c4$exports, "Y400", () => $15543b40efbda8c4$export$59619663aa6500fb);
$parcel$export($15543b40efbda8c4$exports, "Y500", () => $15543b40efbda8c4$export$874739ea9e379ab6);
$parcel$export($15543b40efbda8c4$exports, "G50", () => $15543b40efbda8c4$export$8a6341c32b6a3ee6);
$parcel$export($15543b40efbda8c4$exports, "G75", () => $15543b40efbda8c4$export$69a3bf21b9686c2b);
$parcel$export($15543b40efbda8c4$exports, "G100", () => $15543b40efbda8c4$export$afbce1382ec95f73);
$parcel$export($15543b40efbda8c4$exports, "G200", () => $15543b40efbda8c4$export$747d86715d4175de);
$parcel$export($15543b40efbda8c4$exports, "G300", () => $15543b40efbda8c4$export$940e1f69e873f202);
$parcel$export($15543b40efbda8c4$exports, "G400", () => $15543b40efbda8c4$export$a49394138f7b8e85);
$parcel$export($15543b40efbda8c4$exports, "G500", () => $15543b40efbda8c4$export$6fa04827ac68a4fb);
$parcel$export($15543b40efbda8c4$exports, "B50", () => $15543b40efbda8c4$export$226de0355ed012f8);
$parcel$export($15543b40efbda8c4$exports, "B75", () => $15543b40efbda8c4$export$8c13c2ee36917869);
$parcel$export($15543b40efbda8c4$exports, "B100", () => $15543b40efbda8c4$export$ecfc1dff386a3e7a);
$parcel$export($15543b40efbda8c4$exports, "B200", () => $15543b40efbda8c4$export$215b7063051591f1);
$parcel$export($15543b40efbda8c4$exports, "B300", () => $15543b40efbda8c4$export$e62e8919cca44969);
$parcel$export($15543b40efbda8c4$exports, "B400", () => $15543b40efbda8c4$export$b3de0ae08da2ce64);
$parcel$export($15543b40efbda8c4$exports, "B500", () => $15543b40efbda8c4$export$a6ee3d71bc067634);
$parcel$export($15543b40efbda8c4$exports, "B600", () => $15543b40efbda8c4$export$67f15409e87642a1);
$parcel$export($15543b40efbda8c4$exports, "B700", () => $15543b40efbda8c4$export$f0539dbc42dbb067);
$parcel$export($15543b40efbda8c4$exports, "P50", () => $15543b40efbda8c4$export$363e4475840015bb);
$parcel$export($15543b40efbda8c4$exports, "P75", () => $15543b40efbda8c4$export$4b0a4417ed59760f);
$parcel$export($15543b40efbda8c4$exports, "P100", () => $15543b40efbda8c4$export$6011520a64d9a187);
$parcel$export($15543b40efbda8c4$exports, "P200", () => $15543b40efbda8c4$export$a7175d4e9206bc80);
$parcel$export($15543b40efbda8c4$exports, "P300", () => $15543b40efbda8c4$export$b48405b95304b5a1);
$parcel$export($15543b40efbda8c4$exports, "P400", () => $15543b40efbda8c4$export$c71e4279dd54a18d);
$parcel$export($15543b40efbda8c4$exports, "P500", () => $15543b40efbda8c4$export$147899de772240ec);
$parcel$export($15543b40efbda8c4$exports, "T50", () => $15543b40efbda8c4$export$2cf711fe14c66f06);
$parcel$export($15543b40efbda8c4$exports, "T75", () => $15543b40efbda8c4$export$7a8f4d33f6f9772c);
$parcel$export($15543b40efbda8c4$exports, "T100", () => $15543b40efbda8c4$export$776c9c497ef08533);
$parcel$export($15543b40efbda8c4$exports, "T200", () => $15543b40efbda8c4$export$69cb3ca10c1e330e);
$parcel$export($15543b40efbda8c4$exports, "T300", () => $15543b40efbda8c4$export$9dc1ef0f3f48059b);
$parcel$export($15543b40efbda8c4$exports, "T400", () => $15543b40efbda8c4$export$7c835c78b6fcdef8);
$parcel$export($15543b40efbda8c4$exports, "T500", () => $15543b40efbda8c4$export$6036577f95c3877e);
$parcel$export($15543b40efbda8c4$exports, "N0", () => $15543b40efbda8c4$export$29a4f05edc054374);
$parcel$export($15543b40efbda8c4$exports, "N10", () => $15543b40efbda8c4$export$e655ef011c4aa1a2);
$parcel$export($15543b40efbda8c4$exports, "N20", () => $15543b40efbda8c4$export$9fdfb749e33cdf97);
$parcel$export($15543b40efbda8c4$exports, "N30", () => $15543b40efbda8c4$export$3e51e8f1440314ba);
$parcel$export($15543b40efbda8c4$exports, "N40", () => $15543b40efbda8c4$export$1ce2d1575d444ceb);
$parcel$export($15543b40efbda8c4$exports, "N50", () => $15543b40efbda8c4$export$8754fc7e6d8b3000);
$parcel$export($15543b40efbda8c4$exports, "N60", () => $15543b40efbda8c4$export$c2e91cbeada39b8b);
$parcel$export($15543b40efbda8c4$exports, "N70", () => $15543b40efbda8c4$export$5f71e19f3a7ad9de);
$parcel$export($15543b40efbda8c4$exports, "N80", () => $15543b40efbda8c4$export$eaa8c8a70ac22806);
$parcel$export($15543b40efbda8c4$exports, "N90", () => $15543b40efbda8c4$export$7c87d337fb91a97d);
$parcel$export($15543b40efbda8c4$exports, "N100", () => $15543b40efbda8c4$export$d6447c357493214f);
$parcel$export($15543b40efbda8c4$exports, "N200", () => $15543b40efbda8c4$export$f563ee71e9ee74cd);
$parcel$export($15543b40efbda8c4$exports, "N300", () => $15543b40efbda8c4$export$e2ef2124cf4024b1);
$parcel$export($15543b40efbda8c4$exports, "N400", () => $15543b40efbda8c4$export$eece5f492e429f08);
$parcel$export($15543b40efbda8c4$exports, "N500", () => $15543b40efbda8c4$export$c39c0fe0f26207ae);
$parcel$export($15543b40efbda8c4$exports, "N600", () => $15543b40efbda8c4$export$7090862dc3038a9f);
$parcel$export($15543b40efbda8c4$exports, "N700", () => $15543b40efbda8c4$export$ad0bacf983b7ddaa);
$parcel$export($15543b40efbda8c4$exports, "N800", () => $15543b40efbda8c4$export$7d61b15e0da132af);
$parcel$export($15543b40efbda8c4$exports, "N900", () => $15543b40efbda8c4$export$fbda843f0a27fe96);
$parcel$export($15543b40efbda8c4$exports, "N10A", () => $15543b40efbda8c4$export$791e57b27ca738ef);
$parcel$export($15543b40efbda8c4$exports, "N20A", () => $15543b40efbda8c4$export$8d43898f60b96a82);
$parcel$export($15543b40efbda8c4$exports, "N30A", () => $15543b40efbda8c4$export$920c0d5c49070351);
$parcel$export($15543b40efbda8c4$exports, "N40A", () => $15543b40efbda8c4$export$46987b49aab6d1a8);
$parcel$export($15543b40efbda8c4$exports, "N50A", () => $15543b40efbda8c4$export$7d3359664e8bb0e5);
$parcel$export($15543b40efbda8c4$exports, "N60A", () => $15543b40efbda8c4$export$d2d3bedfb276cac0);
$parcel$export($15543b40efbda8c4$exports, "N70A", () => $15543b40efbda8c4$export$6e5e7499ff054f6d);
$parcel$export($15543b40efbda8c4$exports, "N80A", () => $15543b40efbda8c4$export$59264b346c877fa7);
$parcel$export($15543b40efbda8c4$exports, "N90A", () => $15543b40efbda8c4$export$d092757d7c64925c);
$parcel$export($15543b40efbda8c4$exports, "N100A", () => $15543b40efbda8c4$export$486ab785e4bac3c6);
$parcel$export($15543b40efbda8c4$exports, "N200A", () => $15543b40efbda8c4$export$fba592bbc6419fea);
$parcel$export($15543b40efbda8c4$exports, "N300A", () => $15543b40efbda8c4$export$13609db0e6812ab8);
$parcel$export($15543b40efbda8c4$exports, "N400A", () => $15543b40efbda8c4$export$fbae4efaa892d883);
$parcel$export($15543b40efbda8c4$exports, "N500A", () => $15543b40efbda8c4$export$f13946d26f440ce6);
$parcel$export($15543b40efbda8c4$exports, "N600A", () => $15543b40efbda8c4$export$19f58225ac52a306);
$parcel$export($15543b40efbda8c4$exports, "N700A", () => $15543b40efbda8c4$export$6384f09da70e7b62);
$parcel$export($15543b40efbda8c4$exports, "N800A", () => $15543b40efbda8c4$export$d0dccc730683edc2);
$parcel$export($15543b40efbda8c4$exports, "DN900", () => $15543b40efbda8c4$export$2f6319cf7d736c2a);
$parcel$export($15543b40efbda8c4$exports, "DN800", () => $15543b40efbda8c4$export$95126bc8884d6634);
$parcel$export($15543b40efbda8c4$exports, "DN700", () => $15543b40efbda8c4$export$8338d8c35d44ff1);
$parcel$export($15543b40efbda8c4$exports, "DN600", () => $15543b40efbda8c4$export$5368d76ae4fbbda7);
$parcel$export($15543b40efbda8c4$exports, "DN500", () => $15543b40efbda8c4$export$9f0a771d16ec8d36);
$parcel$export($15543b40efbda8c4$exports, "DN400", () => $15543b40efbda8c4$export$abcf8c38338b4aa5);
$parcel$export($15543b40efbda8c4$exports, "DN300", () => $15543b40efbda8c4$export$97e81faa16a182c7);
$parcel$export($15543b40efbda8c4$exports, "DN200", () => $15543b40efbda8c4$export$bfe21c59123ecf33);
$parcel$export($15543b40efbda8c4$exports, "DN100", () => $15543b40efbda8c4$export$ee82aa2ea6a1558);
$parcel$export($15543b40efbda8c4$exports, "DN90", () => $15543b40efbda8c4$export$682927c6ed76be02);
$parcel$export($15543b40efbda8c4$exports, "DN80", () => $15543b40efbda8c4$export$91fd9994c5be9757);
$parcel$export($15543b40efbda8c4$exports, "DN70", () => $15543b40efbda8c4$export$d281fbfe3cff2df6);
$parcel$export($15543b40efbda8c4$exports, "DN60", () => $15543b40efbda8c4$export$3902c91d8b98a753);
$parcel$export($15543b40efbda8c4$exports, "DN50", () => $15543b40efbda8c4$export$8e8133c1ba5845b5);
$parcel$export($15543b40efbda8c4$exports, "DN40", () => $15543b40efbda8c4$export$33ff357f6620b39);
$parcel$export($15543b40efbda8c4$exports, "DN30", () => $15543b40efbda8c4$export$633847cf062b69e0);
$parcel$export($15543b40efbda8c4$exports, "DN20", () => $15543b40efbda8c4$export$9776a6e503bdbf76);
$parcel$export($15543b40efbda8c4$exports, "DN10", () => $15543b40efbda8c4$export$6c813d5160dff5db);
$parcel$export($15543b40efbda8c4$exports, "DN0", () => $15543b40efbda8c4$export$3d4f271a500072a);
$parcel$export($15543b40efbda8c4$exports, "DN800A", () => $15543b40efbda8c4$export$fe151285c22759ec);
$parcel$export($15543b40efbda8c4$exports, "DN700A", () => $15543b40efbda8c4$export$a101c6190d0da34);
$parcel$export($15543b40efbda8c4$exports, "DN600A", () => $15543b40efbda8c4$export$4b16f52932fda51);
$parcel$export($15543b40efbda8c4$exports, "DN500A", () => $15543b40efbda8c4$export$a74bcd7b9845b0d8);
$parcel$export($15543b40efbda8c4$exports, "DN400A", () => $15543b40efbda8c4$export$9209c179316d1751);
$parcel$export($15543b40efbda8c4$exports, "DN300A", () => $15543b40efbda8c4$export$88f55133f636c8dd);
$parcel$export($15543b40efbda8c4$exports, "DN200A", () => $15543b40efbda8c4$export$51126f85d1009512);
$parcel$export($15543b40efbda8c4$exports, "DN100A", () => $15543b40efbda8c4$export$a069b547bd23af78);
$parcel$export($15543b40efbda8c4$exports, "DN90A", () => $15543b40efbda8c4$export$40cce05af3b2600a);
$parcel$export($15543b40efbda8c4$exports, "DN80A", () => $15543b40efbda8c4$export$b78942185925a0d);
$parcel$export($15543b40efbda8c4$exports, "DN70A", () => $15543b40efbda8c4$export$e058fb44b8eaafca);
$parcel$export($15543b40efbda8c4$exports, "DN60A", () => $15543b40efbda8c4$export$92b0b8de26920c18);
$parcel$export($15543b40efbda8c4$exports, "DN50A", () => $15543b40efbda8c4$export$67564f7459d3fc9e);
$parcel$export($15543b40efbda8c4$exports, "DN40A", () => $15543b40efbda8c4$export$77868e1ca884ffa3);
$parcel$export($15543b40efbda8c4$exports, "DN30A", () => $15543b40efbda8c4$export$2afd71d7d3ea2cd5);
$parcel$export($15543b40efbda8c4$exports, "DN20A", () => $15543b40efbda8c4$export$f2a0acaab9972c70);
$parcel$export($15543b40efbda8c4$exports, "DN10A", () => $15543b40efbda8c4$export$9ab70e67d6475361);
$parcel$export($15543b40efbda8c4$exports, "T30", () => $15543b40efbda8c4$export$d2adc5dedf09fced);
$parcel$export($15543b40efbda8c4$exports, "L50", () => $15543b40efbda8c4$export$f51762073d2bb381);
$parcel$export($15543b40efbda8c4$exports, "L75", () => $15543b40efbda8c4$export$95e26d54def96891);
// Reds
const $15543b40efbda8c4$export$4b84fd0e2c617bd = '#FFEBE6';
const $15543b40efbda8c4$export$b34b069eff244586 = '#FFBDAD';
const $15543b40efbda8c4$export$be802dd0d8b57f35 = '#FF8F73';
const $15543b40efbda8c4$export$60847d42f9da92a6 = '#FF7452';
const $15543b40efbda8c4$export$4a7404f376229999 = '#FF5630';
const $15543b40efbda8c4$export$2010d0fb4295b346 = '#DE350B';
const $15543b40efbda8c4$export$2837b5a1a71d5c02 = '#BF2600';
const $15543b40efbda8c4$export$8d9596b529bbb9cf = '#FFFAE6';
const $15543b40efbda8c4$export$41060a744ab0b7ae = '#FFF0B3';
const $15543b40efbda8c4$export$1cc05bbbf340e559 = '#FFE380';
const $15543b40efbda8c4$export$5aae31392d72caaa = '#FFC400';
const $15543b40efbda8c4$export$c6930421db9fa514 = '#FFAB00';
const $15543b40efbda8c4$export$59619663aa6500fb = '#FF991F';
const $15543b40efbda8c4$export$874739ea9e379ab6 = '#FF8B00';
const $15543b40efbda8c4$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $15543b40efbda8c4$export$69a3bf21b9686c2b = '#ABF5D1';
const $15543b40efbda8c4$export$afbce1382ec95f73 = '#79F2C0';
const $15543b40efbda8c4$export$747d86715d4175de = '#57D9A3';
const $15543b40efbda8c4$export$940e1f69e873f202 = '#36B37E';
const $15543b40efbda8c4$export$a49394138f7b8e85 = '#00875A';
const $15543b40efbda8c4$export$6fa04827ac68a4fb = '#006644';
const $15543b40efbda8c4$export$226de0355ed012f8 = '#DEEBFF';
const $15543b40efbda8c4$export$8c13c2ee36917869 = '#B3D4FF';
const $15543b40efbda8c4$export$ecfc1dff386a3e7a = '#4C9AFF';
const $15543b40efbda8c4$export$215b7063051591f1 = '#2684FF';
const $15543b40efbda8c4$export$e62e8919cca44969 = '#0065FF';
const $15543b40efbda8c4$export$b3de0ae08da2ce64 = '#0052CC';
const $15543b40efbda8c4$export$a6ee3d71bc067634 = '#0747A6';
const $15543b40efbda8c4$export$67f15409e87642a1 = '#669DF1';
const $15543b40efbda8c4$export$f0539dbc42dbb067 = '#8FB8F6';
const $15543b40efbda8c4$export$363e4475840015bb = '#EAE6FF';
const $15543b40efbda8c4$export$4b0a4417ed59760f = '#C0B6F2';
const $15543b40efbda8c4$export$6011520a64d9a187 = '#998DD9';
const $15543b40efbda8c4$export$a7175d4e9206bc80 = '#8777D9';
const $15543b40efbda8c4$export$b48405b95304b5a1 = '#6554C0';
const $15543b40efbda8c4$export$c71e4279dd54a18d = '#5243AA';
const $15543b40efbda8c4$export$147899de772240ec = '#403294';
const $15543b40efbda8c4$export$2cf711fe14c66f06 = '#E6FCFF';
const $15543b40efbda8c4$export$7a8f4d33f6f9772c = '#B3F5FF';
const $15543b40efbda8c4$export$776c9c497ef08533 = '#79E2F2';
const $15543b40efbda8c4$export$69cb3ca10c1e330e = '#00C7E6';
const $15543b40efbda8c4$export$9dc1ef0f3f48059b = '#00B8D9';
const $15543b40efbda8c4$export$7c835c78b6fcdef8 = '#00A3BF';
const $15543b40efbda8c4$export$6036577f95c3877e = '#008DA6';
const $15543b40efbda8c4$export$29a4f05edc054374 = '#FFFFFF';
const $15543b40efbda8c4$export$e655ef011c4aa1a2 = '#FAFBFC';
const $15543b40efbda8c4$export$9fdfb749e33cdf97 = '#F4F5F7';
const $15543b40efbda8c4$export$3e51e8f1440314ba = '#EBECF0';
const $15543b40efbda8c4$export$1ce2d1575d444ceb = '#DFE1E6';
const $15543b40efbda8c4$export$8754fc7e6d8b3000 = '#C1C7D0';
const $15543b40efbda8c4$export$c2e91cbeada39b8b = '#B3BAC5';
const $15543b40efbda8c4$export$5f71e19f3a7ad9de = '#A5ADBA';
const $15543b40efbda8c4$export$eaa8c8a70ac22806 = '#97A0AF';
const $15543b40efbda8c4$export$7c87d337fb91a97d = '#8993A4';
const $15543b40efbda8c4$export$d6447c357493214f = '#7A869A';
const $15543b40efbda8c4$export$f563ee71e9ee74cd = '#6B778C';
const $15543b40efbda8c4$export$e2ef2124cf4024b1 = '#5E6C84';
const $15543b40efbda8c4$export$eece5f492e429f08 = '#505F79';
const $15543b40efbda8c4$export$c39c0fe0f26207ae = '#42526E';
const $15543b40efbda8c4$export$7090862dc3038a9f = '#344563';
const $15543b40efbda8c4$export$ad0bacf983b7ddaa = '#253858';
const $15543b40efbda8c4$export$7d61b15e0da132af = '#172B4D';
const $15543b40efbda8c4$export$fbda843f0a27fe96 = '#091E42';
const $15543b40efbda8c4$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $15543b40efbda8c4$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $15543b40efbda8c4$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $15543b40efbda8c4$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $15543b40efbda8c4$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $15543b40efbda8c4$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $15543b40efbda8c4$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $15543b40efbda8c4$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $15543b40efbda8c4$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $15543b40efbda8c4$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $15543b40efbda8c4$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $15543b40efbda8c4$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $15543b40efbda8c4$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $15543b40efbda8c4$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $15543b40efbda8c4$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $15543b40efbda8c4$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $15543b40efbda8c4$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $15543b40efbda8c4$export$2f6319cf7d736c2a = '#E6EDFA';
const $15543b40efbda8c4$export$95126bc8884d6634 = '#DCE5F5';
const $15543b40efbda8c4$export$8338d8c35d44ff1 = '#CED9EB';
const $15543b40efbda8c4$export$5368d76ae4fbbda7 = '#B8C7E0';
const $15543b40efbda8c4$export$9f0a771d16ec8d36 = '#ABBBD6';
const $15543b40efbda8c4$export$abcf8c38338b4aa5 = '#9FB0CC';
const $15543b40efbda8c4$export$97e81faa16a182c7 = '#8C9CB8';
const $15543b40efbda8c4$export$bfe21c59123ecf33 = '#7988A3';
const $15543b40efbda8c4$export$ee82aa2ea6a1558 = '#67758F';
const $15543b40efbda8c4$export$682927c6ed76be02 = '#56637A';
const $15543b40efbda8c4$export$91fd9994c5be9757 = '#455166';
const $15543b40efbda8c4$export$d281fbfe3cff2df6 = '#3B475C';
const $15543b40efbda8c4$export$3902c91d8b98a753 = '#313D52';
const $15543b40efbda8c4$export$8e8133c1ba5845b5 = '#283447';
const $15543b40efbda8c4$export$33ff357f6620b39 = '#202B3D';
const $15543b40efbda8c4$export$633847cf062b69e0 = '#1B2638';
const $15543b40efbda8c4$export$9776a6e503bdbf76 = '#121A29';
const $15543b40efbda8c4$export$6c813d5160dff5db = '#0E1624';
const $15543b40efbda8c4$export$3d4f271a500072a = '#0D1424';
const $15543b40efbda8c4$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $15543b40efbda8c4$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $15543b40efbda8c4$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $15543b40efbda8c4$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $15543b40efbda8c4$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $15543b40efbda8c4$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $15543b40efbda8c4$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $15543b40efbda8c4$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $15543b40efbda8c4$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $15543b40efbda8c4$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $15543b40efbda8c4$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $15543b40efbda8c4$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $15543b40efbda8c4$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $15543b40efbda8c4$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $15543b40efbda8c4$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $15543b40efbda8c4$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $15543b40efbda8c4$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $15543b40efbda8c4$export$d2adc5dedf09fced = '#292A2E';
const $15543b40efbda8c4$export$f51762073d2bb381 = '#94C748';
const $15543b40efbda8c4$export$95e26d54def96891 = '#B3DF72';


parcelRegister("8TCik", function(module, exports) {
$parcel$export(module.exports, "extractTitlePrefix", () => $f4036dd9d0e4c2b6$export$58d9bc37318dfb32);
const $f4036dd9d0e4c2b6$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $f4036dd9d0e4c2b6$export$58d9bc37318dfb32 = (jsonLd, renderers, type)=>{
    const prefix = jsonLd['atlassian:titlePrefix'];
    if (prefix) // extract and return Emoji Title Prefix
    {
        if (prefix['@type'] === 'atlassian:Emoji') {
            const emojiId = $f4036dd9d0e4c2b6$var$sanitizeEmojiValue(prefix['text']);
            const hasEmojiPrefix = emojiId.length !== 0;
            const emojiRenderer = renderers?.emoji;
            if (hasEmojiPrefix && emojiRenderer) return emojiRenderer(emojiId, type);
        }
    }
    return undefined;
};

});


parcelRegister("b7hOH", function(module, exports) {
$parcel$export(module.exports, "InlineCardResolvedView", () => $b04e585d87acc542$export$6d5912cb4b56390e);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kePQU = parcelRequire("kePQU");

var $lJsUk = parcelRequire("lJsUk");

var $4GHj0 = parcelRequire("4GHj0");

var $5NGdQ = parcelRequire("5NGdQ");

var $7mpQ5 = parcelRequire("7mpQ5");

var $9m1Bc = parcelRequire("9m1Bc");
class $b04e585d87acc542$export$6d5912cb4b56390e extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    renderLozenge() {
        const { lozenge: lozenge } = this.props;
        if (!lozenge) return null;
        const appearance = lozenge.appearance || 'default';
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5NGdQ.default), {
            testId: "inline-card-resolved-view-lozenge",
            appearance: appearance,
            style: {
                backgroundColor: lozenge?.style?.backgroundColor,
                color: lozenge?.style?.color
            },
            isBold: (0, $kePQU.fg)('platform-component-visual-refresh') ? lozenge.isBold !== false : lozenge.isBold,
            children: lozenge.text
        });
    }
    render() {
        const { id: id, title: title = '', isSelected: isSelected, isHovered: isHovered, onClick: onClick, icon: icon, link: link, testId: testId = 'inline-card-resolved-view', titleTextColor: titleTextColor, titlePrefix: titlePrefix, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, truncateInline: truncateInline, type: type, hideIconLoadingSkeleton: hideIconLoadingSkeleton } = this.props;
        const inlineCardResolvedView = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $7mpQ5.Frame), {
            testId: testId,
            link: link,
            isSelected: isSelected,
            isHovered: isHovered,
            onClick: onClick,
            truncateInline: truncateInline,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9m1Bc.IconAndTitleLayout), {
                    emoji: titlePrefix,
                    icon: icon,
                    title: title,
                    titleTextColor: titleTextColor,
                    type: type,
                    hideIconLoadingSkeleton: (0, $lJsUk.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && hideIconLoadingSkeleton
                }),
                this.renderLozenge()
            ]
        });
        if (showHoverPreview && link) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4GHj0.HoverCard), {
            id: id,
            url: link,
            actionOptions: actionOptions,
            hoverPreviewOptions: hoverPreviewOptions,
            children: inlineCardResolvedView
        });
        return inlineCardResolvedView;
    }
}

});
parcelRegister("5NGdQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e7f5f49f790255b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $apq7L = parcelRequire("apq7L");
const $7e7f5f49f790255b$var$wrapperStyles = null;
const $7e7f5f49f790255b$var$InlineLozenge = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_1e0c1o8l _s7n4t94y _19pkidpf _2hwx1b66 _otyridpf _18u0v77o _p12f1osq"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $apq7L.default), {
            ...props
        })
    });
var $7e7f5f49f790255b$export$2e2bcd8739ae039 = $7e7f5f49f790255b$var$InlineLozenge;

});

parcelRegister("9m1Bc", function(module, exports) {
$parcel$export(module.exports, "IconAndTitleLayout", () => $6f096d898a2fc3ba$export$d34be4d513116847);
$parcel$export(module.exports, "IconTitleWrapper", () => $6f096d898a2fc3ba$export$c73a53738ef9e3f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $2HNHt = parcelRequire("2HNHt");

var $g0IEj = parcelRequire("g0IEj");

var $9vwg9 = parcelRequire("9vwg9");

var $lJsUk = parcelRequire("lJsUk");

var $cHEjl = parcelRequire("cHEjl");

var $dm6HG = parcelRequire("dm6HG");
const $6f096d898a2fc3ba$var$iconWrapperStyle = null;
const $6f096d898a2fc3ba$var$iconImageStyle = null;
const $6f096d898a2fc3ba$var$styles = {
    iconEmptyStyle: "_1bsb7vkz _4t3i1osq _1e0c1o8l _tzy4idpf",
    iconOuterWrapperStyle: "_1e0c1o8l _2hwx1b66 _kqswh2mm",
    iconTitleWrapperStyle: "_o5721jtm _1nmz9jpi _16d9qvcn _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66",
    linkStyle: "_2rkolb4i",
    noLinkAppearanceStyle: "_syaz131l _18u01b66",
    roundImageStyle: "_2rko1rr0"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled,@atlaskit/design-system/no-html-anchor -- Ignored via go/DSP-18766
const $6f096d898a2fc3ba$var$LinkAppearance = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1y58 _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});
const $6f096d898a2fc3ba$export$d34be4d513116847 = ({ icon: icon, emoji: emoji, defaultIcon: defaultIcon, onClick: onClick, children: children, title: title, titleColor: titleColor, titleTextColor: titleTextColor, link: link, rightSide: rightSide, testId: testId = 'inline-card-icon-and-title', type: type, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eJOHy.useState)(false);
    const renderAtlaskitIcon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        if (emoji) return emoji;
        if (!icon || typeof icon === 'string') return null;
        return icon;
    }, [
        emoji,
        icon
    ]);
    const profileType = (0, $cHEjl.isProfileType)(type);
    const renderImageIcon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((errored, testId)=>{
        (0, $gRw8I.di)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))));
        if (!icon || typeof icon !== 'string') return null;
        if ((0, $lJsUk.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && hideIconLoadingSkeleton) {
            if (hasImageErrored) return errored;
            return /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
                src: icon,
                "data-testid": `${testId}-image`,
                alt: "",
                onError: ()=>setHasImageErrored(true),
                className: (0, $hcewu.default)([
                    "_c71l7vkz _p12f7vkz _1bsb1osq",
                    profileType && $6f096d898a2fc3ba$var$styles.roundImageStyle
                ])
            });
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))), {
            src: icon,
            loaded: /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
                src: icon,
                "data-testid": `${testId}-image`,
                alt: "",
                className: (0, $hcewu.default)([
                    "_c71l7vkz _p12f7vkz _1bsb1osq",
                    profileType && $6f096d898a2fc3ba$var$styles.roundImageStyle
                ])
            }),
            errored: errored,
            loading: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dm6HG.Shimmer), {
                testId: `${testId}-loading`
            })
        });
    }, [
        icon,
        profileType,
        hideIconLoadingSkeleton,
        hasImageErrored
    ]);
    const renderIconPlaceholder = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((testId)=>{
        return defaultIcon || /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g0IEj))), {
            label: "link",
            LEGACY_size: "small",
            testId: `${testId}-default`,
            color: "currentColor"
        });
    }, [
        defaultIcon
    ]);
    const renderIcon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((testId)=>{
        const icon = renderAtlaskitIcon();
        if (icon) return icon;
        const placeholder = renderIconPlaceholder(testId);
        const image = renderImageIcon(placeholder, testId);
        return image || placeholder;
    }, [
        renderAtlaskitIcon,
        renderIconPlaceholder,
        renderImageIcon
    ]);
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    // maybe consider memoising this after clean up
    const titlePart = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9vwg9.default), {
                as: "span",
                // EDM-12119: This is set here to help with the positioning of the icon to be in the middle of inline display.
                // We cannot set the fix font because inline is taking the parent container font size into account.
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                style: {
                    lineHeight: `1`
                },
                xcss: $6f096d898a2fc3ba$var$styles.iconOuterWrapperStyle,
                testId: "icon-position-wrapper",
                children: children || /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9vwg9.default), {
                            as: "span",
                            xcss: $6f096d898a2fc3ba$var$styles.iconEmptyStyle,
                            testId: "icon-empty-wrapper"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            "data-testId": "icon-wrapper",
                            className: (0, $hcewu.default)([
                                "_11c81o8v _2rkolb4i _1e0c116y _kqswstnw _2hwx1b66 _4t3i7vkz _1bsb7vkz _154i1ssb _1ltv1ssb _t9ec1ooe _uiztglyw"
                            ]),
                            children: renderIcon(testId)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9vwg9.default), {
                as: "span",
                style: {
                    color: titleTextColor
                },
                children: title
            })
        ]
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)($6f096d898a2fc3ba$export$c73a53738ef9e3f, {
            style: {
                color: titleColor
            },
            testId: testId,
            children: [
                link ? /*#__PURE__*/ (0, $gt9Am.jsx)($6f096d898a2fc3ba$var$LinkAppearance, {
                    href: link,
                    onClick: handleClick,
                    onKeyPress: handleKeyPress,
                    className: (0, $hcewu.default)([
                        $6f096d898a2fc3ba$var$styles.linkStyle
                    ]),
                    children: titlePart
                }) : titlePart,
                rightSide ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9vwg9.default), {
                    as: "span",
                    xcss: $6f096d898a2fc3ba$var$styles.noLinkAppearanceStyle,
                    children: rightSide
                }) : null
            ]
        })
    });
};
const $6f096d898a2fc3ba$export$c73a53738ef9e3f = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9vwg9.default), {
        as: "span",
        xcss: $6f096d898a2fc3ba$var$styles.iconTitleWrapperStyle,
        ...props
    });
};

});
parcelRegister("dm6HG", function(module, exports) {
$parcel$export(module.exports, "Shimmer", () => $bc802fe01cfd4fa8$export$809644b82cfe94b1);
/* Icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $11usL = parcelRequire("11usL");
const $bc802fe01cfd4fa8$export$f04a61298a47a40f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkolb4i _4t3i7vkz _1bsb7vkz _2hwx1b66 _uiztglyw _kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe",
            __cmplp.className
        ])
    });
});
const $bc802fe01cfd4fa8$export$809644b82cfe94b1 = ({ testId: testId })=>{
    const skeletonCustomStyles = {
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        top: '50%',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        left: '50%',
        transform: 'translate(-50%, -50%)',
        marginRight: "var(--ds-space-050, 4px)"
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $11usL.SpanSkeleton), {
        width: 16,
        height: 16,
        borderRadius: 2,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: skeletonCustomStyles
    });
};

});
parcelRegister("11usL", function(module, exports) {
$parcel$export(module.exports, "SpanSkeleton", () => $8fbc0fe28088c9b8$export$85d5658002cae6ce);
$parcel$export(module.exports, "Skeleton", () => $8fbc0fe28088c9b8$export$8f31e4c4a37b8e9c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

const $8fbc0fe28088c9b8$var$placeholderShimmer = null;
const $8fbc0fe28088c9b8$var$appearanceValues = {
    darkGray: {
        animation: `var(--ds-background-accent-gray-subtle, ${(0, $15543b40efbda8c4$export$c2e91cbeada39b8b)})`
    },
    gray: {
        animation: `var(--ds-skeleton, ${(0, $15543b40efbda8c4$export$1ce2d1575d444ceb)})`
    },
    blue: {
        animation: "var(--ds-background-information-hovered, #cce0ff)"
    }
};
const $8fbc0fe28088c9b8$var$spanSkeletonStyles = null;
const $8fbc0fe28088c9b8$var$spanSkeletonBackgroundStyleMap = {
    gray: "_bfhk1cs6",
    blue: "_bfhk1hdx",
    darkGray: "_bfhk1gk7"
};
const $8fbc0fe28088c9b8$export$85d5658002cae6ce = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$8fbc0fe28088c9b8$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $hcewu.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $8fbc0fe28088c9b8$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
const $8fbc0fe28088c9b8$export$8f31e4c4a37b8e9c = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$8fbc0fe28088c9b8$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $hcewu.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $8fbc0fe28088c9b8$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
var $8fbc0fe28088c9b8$export$2e2bcd8739ae039 = $8fbc0fe28088c9b8$export$8f31e4c4a37b8e9c;

});




parcelRegister("6Tmil", function(module, exports) {
$parcel$export(module.exports, "EmbedCardErroredView", () => $ca1c2641f4bdbbf7$export$6819d845957344e);
/* ErroredView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $3JpAh = parcelRequire("3JpAh");

var $7aL0y = parcelRequire("7aL0y");

var $9vwg9 = parcelRequire("9vwg9");
var $aNYtN = parcelRequire("aNYtN");


var $cafmZ = parcelRequire("cafmZ");

var $Rfu8s = parcelRequire("Rfu8s");
const $ca1c2641f4bdbbf7$var$styles = {
    boxStyles: "_19bv1b66 _u5f31b66"
};
const $ca1c2641f4bdbbf7$export$6819d845957344e = ({ onRetry: onRetry, isSelected: isSelected = false, testId: testId = 'embed-card-errored-view', inheritDimensions: inheritDimensions })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $Rfu8s.Frame), {
        inheritDimensions: inheritDimensions,
        compact: true,
        isSelected: isSelected,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7aL0y))), {
                LEGACY_size: "small",
                color: `var(--ds-icon-danger, ${(0, $15543b40efbda8c4$export$4a7404f376229999)})`,
                label: "error-icon"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9vwg9.default), {
                xcss: $ca1c2641f4bdbbf7$var$styles.boxStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aNYtN.default), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $cafmZ.messages).could_not_load_link
                    })
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3JpAh.default), {
                testId: "err-view-retry",
                spacing: "compact",
                onClick: onRetry,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $cafmZ.messages).try_again
                })
            })
        ]
    });

});
parcelRegister("Rfu8s", function(module, exports) {
$parcel$export(module.exports, "Frame", () => $ee3de6ca7c4f82f4$export$b89a827e9254211a);
/* ErrorFrame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");
const $ee3de6ca7c4f82f4$export$b89a827e9254211a = (props = {
    isSelected: false,
    isHoverable: false,
    isFluidHeight: false
})=>props.compact ? /*#__PURE__*/ (0, $gt9Am.jsx)($ee3de6ca7c4f82f4$export$f862a410248f4f00, {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($ee3de6ca7c4f82f4$export$7b360cd785b6c366, {
        ...props
    });
const $ee3de6ca7c4f82f4$var$sharedBaseFrameStyles = null;
const $ee3de6ca7c4f82f4$var$sharedFrameStyles = null;
const $ee3de6ca7c4f82f4$var$expandedFrameHoverStyles = null;
const $ee3de6ca7c4f82f4$var$expandedFrameFluidHeightTrueStyles = null;
const $ee3de6ca7c4f82f4$var$expandedFrameFluidHeightFalseStyles = null;
const $ee3de6ca7c4f82f4$var$expandedFrameSelectedStyles = null;
const $ee3de6ca7c4f82f4$var$expandedFrameNotSelectedStyles = null;
const $ee3de6ca7c4f82f4$var$expandedFrameStyles = null;
const $ee3de6ca7c4f82f4$export$7b360cd785b6c366 = ({ children: children, isSelected: isSelected, isHoverable: isHoverable, testId: testId, className: className, isFluidHeight: isFluidHeight })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1bsb1osq _1e0c1txw",
            "_p12fukw8 _bfhkhp5a",
            isHoverable && "_irr3k6hx _d0altlke",
            isFluidHeight ? "_1tkeidpf" : "_1tke68cl",
            isSelected ? "_2rkofajl _1h6d1can _1dqonqa1 _189e1dm9" : "_2rko1lya _1h6d3acm _1dqonqa1 _189e1dm9",
            "_1reo15vq _18m915vq _1bah1yb4 _16qs1os1",
            className
        ]),
        "data-trello-do-not-use-override": testId,
        children: children
    });
};
const $ee3de6ca7c4f82f4$var$compactFrameHoverStyles = null;
const $ee3de6ca7c4f82f4$var$compactFrameInheritDimensionsTrueStyles = null;
const $ee3de6ca7c4f82f4$var$compactFrameInheritDimensionsFalseStyles = null;
const $ee3de6ca7c4f82f4$var$compactFrameAlignStyles = null;
const $ee3de6ca7c4f82f4$var$compactFrameStyles = null;
const $ee3de6ca7c4f82f4$var$compactFrameNotSelectedStyles = null;
const $ee3de6ca7c4f82f4$export$f862a410248f4f00 = ({ children: children, isHoverable: isHoverable, isSelected: isSelected, testId: testId, className: className, inheritDimensions: inheritDimensions })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1bsb1osq _1e0c1txw",
            "_p12fukw8 _bfhkhp5a",
            isHoverable && "_irr3yw9d",
            isSelected && "_2rkofajl _1h6d1can _1dqonqa1 _189e1dm9",
            !isSelected && "_2rko1lya",
            "_1bah1h6o _4cvr1h6o _bfhkiw92",
            inheritDimensions ? "_4t3i1osq" : "_4t3i1ylp",
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq",
            className
        ]),
        children: children
    });
};

});


parcelRegister("byjM0", function(module, exports) {
$parcel$export(module.exports, "default", () => $495f7bd3bfb298f7$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $3JpAh = parcelRequire("3JpAh");

var $cafmZ = parcelRequire("cafmZ");

var $f1Nvs = parcelRequire("f1Nvs");

var $hdYNe = parcelRequire("hdYNe");

var $bJEnQ = parcelRequire("bJEnQ");
const $495f7bd3bfb298f7$var$ForbiddenView = ({ context: context, onAuthorize: onAuthorize, accessContext: accessContext, testId: testId = 'embed-card-forbidden-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { accessType: accessType, hostname: hostname, titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey, callToActionMessageKey: callToActionMessageKey, action: action } = accessContext ?? {};
    const values = (0, $eJOHy.useMemo)(()=>{
        const product = context?.text ?? '';
        return {
            context: product,
            product: product,
            hostname: /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
                children: hostname
            })
        };
    }, [
        hostname,
        context?.text
    ]);
    /**
	 * if there is a request access context, but no action to perform, do not show any button.
	 * By default, a "Try another account" button shows, but with request access context, we don't
	 * want to encourage users to try another account, if their request is already pending, etc.
	 */ const button = (0, $eJOHy.useMemo)(()=>{
        const onEmbedCardClick = action?.promise ?? onAuthorize;
        if (!onEmbedCardClick) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3JpAh.default), {
            testId: `button-${action?.id || 'connect-other-account'}`,
            appearance: "primary",
            onClick: onEmbedCardClick,
            isDisabled: accessType === 'PENDING_REQUEST_EXISTS',
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $f1Nvs.toMessage)((0, $cafmZ.messages).try_another_account, callToActionMessageKey),
                values: values
            })
        });
    }, [
        accessType,
        action?.id,
        action?.promise,
        callToActionMessageKey,
        onAuthorize,
        values
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hdYNe.default), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bJEnQ.ForbiddenSVG), {}),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $f1Nvs.toMessage)((0, $cafmZ.messages).invalid_permissions, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $f1Nvs.toMessage)((0, $cafmZ.messages).invalid_permissions_description, descriptiveMessageKey),
            values: values
        }),
        button: button
    });
};
var $495f7bd3bfb298f7$export$2e2bcd8739ae039 = $495f7bd3bfb298f7$var$ForbiddenView;

});
parcelRegister("hdYNe", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa3e34f987b4a77b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6Tcuf = parcelRequire("6Tcuf");

var $g0IEj = parcelRequire("g0IEj");

var $7kKh8 = parcelRequire("7kKh8");

var $dAVKw = parcelRequire("dAVKw");
const $fa3e34f987b4a77b$var$containerStyles = null;
const $fa3e34f987b4a77b$var$contentStyles = null;
const $fa3e34f987b4a77b$var$descriptionStyles = null;
const $fa3e34f987b4a77b$var$imageStyles = null;
const $fa3e34f987b4a77b$var$UnresolvedView = ({ button: button, description: description, frameStyle: frameStyle, icon: iconUrlOrElement, image: imageUrlOrElement, inheritDimensions: inheritDimensions, isSelected: isSelected, onClick: onClick, testId: testId, text: text, title: title, url: url })=>{
    const icon = (0, $eJOHy.useMemo)(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(iconUrlOrElement)) return iconUrlOrElement;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dAVKw.ImageIcon), {
            src: typeof iconUrlOrElement === 'string' ? iconUrlOrElement : undefined,
            default: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g0IEj))), {
                label: "icon",
                LEGACY_size: "small",
                testId: "embed-card-fallback-icon",
                color: "currentColor"
            })
        });
    }, [
        iconUrlOrElement
    ]);
    const image = (0, $eJOHy.useMemo)(()=>{
        if (!imageUrlOrElement) return null;
        const imageTestId = `${testId}-unresolved-image`;
        if (typeof imageUrlOrElement === 'string') return /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
            "data-testid": imageTestId,
            src: imageUrlOrElement,
            alt: "",
            className: (0, $hcewu.default)([
                "_4t3i68cl _1bsbmgvx _5ral1f51 _rsufaqso"
            ])
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": imageTestId,
            className: (0, $hcewu.default)([
                "_4t3i68cl _1bsbmgvx _5ral1f51 _rsufaqso"
            ]),
            children: imageUrlOrElement
        });
    }, [
        imageUrlOrElement,
        testId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7kKh8.ExpandedFrame), {
        // Scroll bar must be shown for unresolved views to display the connect account button
        allowScrollBar: true,
        setOverflow: true,
        // EDM-9259: Fix embed frame showing on unresolved views when frameStyle is set to hide.
        // Set fallback to 'show' here to maintain the current behaviour when platform.editor.show-embed-card-frame-renderer is OFF.
        // Remove 'show' on platform.editor.show-embed-card-frame-renderer cleanup as frameStyle will be set to 'show' both in renderer and editor.
        // We want all views to be consistent and respect frameStyle instead of
        // having resolved view default to showOnHover and unresolved view default to show.
        // Default frameStyle is set inside <ExpandedFrame />
        frameStyle: frameStyle ?? 'show',
        href: url,
        icon: icon,
        inheritDimensions: inheritDimensions,
        isSelected: isSelected,
        onClick: onClick,
        testId: testId,
        text: text,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": `${testId}-unresolved-container`,
            className: (0, $hcewu.default)([
                "_1e0c11p5 _4t3i1kw7"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                className: (0, $hcewu.default)([
                    "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulpv47k _1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o _4cvr1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _p12f1kdj"
                ]),
                children: [
                    image,
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Tcuf.default), {
                        size: "large",
                        testId: `${testId}-unresolved-title`,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                        "data-testid": `${testId}-unresolved-description`,
                        className: (0, $hcewu.default)([
                            "_11c82smr _y3gn1h6o"
                        ]),
                        children: description
                    }),
                    button
                ]
            })
        })
    });
};
var $fa3e34f987b4a77b$export$2e2bcd8739ae039 = $fa3e34f987b4a77b$var$UnresolvedView;

});
parcelRegister("7kKh8", function(module, exports) {
$parcel$export(module.exports, "ExpandedFrame", () => $a314cc5f7bc457b4$export$7b360cd785b6c366);
/* ExpandedFrame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kePQU = parcelRequire("kePQU");

var $pB3Jh = parcelRequire("pB3Jh");

var $jAPxw = parcelRequire("jAPxw");

var $9WNF0 = parcelRequire("9WNF0");

var $7SmAl = parcelRequire("7SmAl");
const $a314cc5f7bc457b4$export$7b360cd785b6c366 = ({ isPlaceholder: isPlaceholder = false, children: children, onClick: onClick, icon: icon, text: text, isSelected: isSelected, frameStyle: frameStyle = 'showOnHover', href: href, minWidth: minWidth, maxWidth: maxWidth, testId: testId = 'expanded-frame', inheritDimensions: inheritDimensions, allowScrollBar: allowScrollBar = false, setOverflow: setOverflow = true, CompetitorPrompt: CompetitorPrompt })=>{
    const isInteractive = ()=>!isPlaceholder && (Boolean(href) || Boolean(onClick));
    const handleClick = (event)=>(0, $9WNF0.handleClickCommon)(event, onClick);
    const handleMouseDown = (0, $jAPxw.useMouseDownEvent)();
    // Note: cleanup fg based on results of prompt_whiteboard_competitor_link experiment
    const CompetitorPromptComponent = CompetitorPrompt && href && (0, $kePQU.fg)('prompt_whiteboard_competitor_link_gate') ? /*#__PURE__*/ (0, $gt9Am.jsx)(CompetitorPrompt, {
        sourceUrl: href,
        linkType: "embed"
    }) : null;
    const renderHeader = ()=>{
        return frameStyle !== 'hide' && /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            className: (0, $hcewu.default)([
                $a314cc5f7bc457b4$var$styles.header,
                "embed-header"
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                    className: (0, $hcewu.default)([
                        $a314cc5f7bc457b4$var$styles.leftSection
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                $a314cc5f7bc457b4$var$styles.headerIcon
                            ]),
                            children: icon
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                $a314cc5f7bc457b4$var$styles.tooltipWrapper
                            ]),
                            children: !isPlaceholder && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $pB3Jh.default), {
                                content: text,
                                hideTooltipOnMouseDown: true,
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
                                    href: href,
                                    onClick: handleClick,
                                    onMouseDown: handleMouseDown,
                                    className: (0, $hcewu.default)([
                                        $a314cc5f7bc457b4$var$styles.headerAnchor
                                    ]),
                                    children: text
                                })
                            })
                        })
                    ]
                }),
                CompetitorPromptComponent
            ]
        });
    };
    const interactive = isInteractive();
    const showBackgroundAlways = frameStyle === 'show' || isSelected && frameStyle !== 'hide';
    const showBackgroundOnHover = interactive && frameStyle !== 'hide';
    const renderContent = ()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": "embed-content-wrapper",
            // This fixes an issue with input fields in cross domain iframes (ie. databases and jira fields from different domains)
            // See: HOT-107830
            contentEditable: false,
            className: (0, $hcewu.default)([
                $a314cc5f7bc457b4$var$styles.contentStyle,
                setOverflow && allowScrollBar && $a314cc5f7bc457b4$var$styles.contentOverflowAuto,
                interactive && !showBackgroundAlways && !showBackgroundOnHover && $a314cc5f7bc457b4$var$styles.contentInteractiveActiveBorder
            ]),
            children: children
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            $a314cc5f7bc457b4$var$styles.linkWrapper,
            inheritDimensions && $a314cc5f7bc457b4$var$styles.linkWrapperInheritDimensions,
            isSelected && frameStyle !== 'hide' && $a314cc5f7bc457b4$var$styles.linkWrapperSelected,
            showBackgroundAlways && $a314cc5f7bc457b4$var$styles.linkWrapperBorderAndBackground,
            showBackgroundOnHover && !showBackgroundAlways && $a314cc5f7bc457b4$var$styles.linkWrapperInteractiveNotHidden,
            (0, $7SmAl.className)
        ]),
        style: {
            minWidth: minWidth ? `${minWidth}px` : '',
            maxWidth: maxWidth ? `${maxWidth}px` : ''
        },
        "data-testid": testId,
        "data-trello-do-not-use-override": testId,
        // Due to limitations of testing library, we can't assert ::after
        "data-is-selected": isSelected,
        ...(isPlaceholder || !href) && {
            'data-wrapper-type': 'default',
            'data-is-interactive': isInteractive()
        },
        children: [
            renderHeader(),
            renderContent()
        ]
    });
};
const $a314cc5f7bc457b4$var$styles = {
    linkWrapper: "_zulpu2gc _kqswh2mm _1e0c1txw _2lx21bp4 _4t3ik5xz _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _uiztglyw _qc5o94zs _14mjpb1k _aetrb3bt _18postnw _15l2idpf _32rxidpf _1x88idpf _19doidpf _1hfk18uv _1bqqidpf _u94kidpf _1ifiidpf",
    linkWrapperInheritDimensions: "_4t3i1osq",
    linkWrapperSelected: "_8x3u92p9",
    linkWrapperBorderAndBackground: "_1tqz7r9e _1hfkhp5a _1ifikb7n",
    linkWrapperInteractiveNotHidden: "_hcgv7r9e _4tpuhp5a _x148kb7n",
    header: "_11c8140y _zulp1b66 _1e0c1txw _4cvr1h6o _1bah1yb4 _4t3igktf _1pbykb7n",
    leftSection: "_zulp1b66 _1e0c1txw _4cvr1h6o _1ul9idpf",
    tooltipWrapper: "_1reo15vq _18m915vq",
    headerAnchor: "_11c8140y _1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c _9oik18uv _1bnxglyw _jf4cnqa1",
    headerIcon: "_11c8140y _1bsb7vkz _4t3i7vkz",
    contentStyle: "_19ity6g5 _2rko12b0 _1reo15vq _18m915vq _v56414au _bfhkhp5a _16jlkb7n _4t3i1osq _1pbykb7n",
    contentInteractiveActiveBorder: "_1jhm1ips",
    contentOverflowAuto: "_1reo1wug _18m91wug"
};

});
parcelRegister("7SmAl", function(module, exports) {
$parcel$export(module.exports, "className", () => $3b598b06e85774be$export$2913c0c0b5623090);
$parcel$export(module.exports, "embedHeaderHeight", () => $3b598b06e85774be$export$8f5a73ba0d077b01);
$parcel$export(module.exports, "Image", () => $3b598b06e85774be$export$3e431a229df88919);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $3b598b06e85774be$export$2913c0c0b5623090 = 'media-card-frame';
const $3b598b06e85774be$export$8f5a73ba0d077b01 = 32;
const $3b598b06e85774be$var$getSizeWithUnit = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `${value}${unit}`;
};
const $3b598b06e85774be$export$3e431a229df88919 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_rcxkve": (0, $awdRS.default)($3b598b06e85774be$var$getSizeWithUnit(__cmplp.size))
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _1reo15vq _18m915vq _1bsb17ym _4t3i17ym",
            __cmplp.className
        ])
    });
});
const $3b598b06e85774be$export$1cd1efc78cb52ca5 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_13orr8u": (0, $awdRS.default)(`url(${__cmplp.src})`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _1bsbckbl _4t3ickbl _1aaxusic _19pk1b66 _2hwxidpf _otyrutpp _18u0utpp _bfhkqrzy _1lrw1dfr _1itk2pcs",
            __cmplp.className
        ])
    });
});

});


parcelRegister("dAVKw", function(module, exports) {
$parcel$export(module.exports, "ImageIcon", () => $3dec022675ecfa1d$export$4a122bafaa48b23d);
/* ImageIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $2HNHt = parcelRequire("2HNHt");

var $lJsUk = parcelRequire("lJsUk");

var $7SmAl = parcelRequire("7SmAl");
const $3dec022675ecfa1d$var$styles = {
    roundedImage: "_2rko1rr0"
};
const $3dec022675ecfa1d$export$4a122bafaa48b23d = ({ alt: alt = '', src: src, size: size = 16, title: title, default: defaultIcon, appearance: appearance = 'square', hideLoadingSkeleton: hideLoadingSkeleton })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eJOHy.useState)(false);
    // If url changes, reset state
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $lJsUk.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true)) setHasImageErrored(false);
    }, [
        src
    ]);
    const handleError = (0, $eJOHy.useCallback)(()=>{
        if ((0, $lJsUk.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true)) setHasImageErrored(true);
    }, []);
    // TODO: do we need this?
    if (!src) return defaultIcon || null;
    if ((0, $lJsUk.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && hasImageErrored) return defaultIcon;
    const LoadedImageComponent = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7SmAl.Image), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            appearance === 'round' && $3dec022675ecfa1d$var$styles.roundedImage,
            "smart-link-icon"
        ]),
        src: src,
        alt: alt,
        size: size,
        title: title,
        ...hideLoadingSkeleton && (0, $lJsUk.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) ? {
            onError: handleError
        } : undefined
    });
    if ((0, $lJsUk.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && hideLoadingSkeleton) return LoadedImageComponent;
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))), {
        src: src,
        loading: defaultIcon,
        loaded: LoadedImageComponent,
        errored: defaultIcon
    });
};

});


parcelRegister("bJEnQ", function(module, exports) {
$parcel$export(module.exports, "ForbiddenSVG", () => $858a9a5dcfc626f3$export$f51768a4e7ff128);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $858a9a5dcfc626f3$export$f51768a4e7ff128 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        viewBox: "0 0 168.8372 221.4874",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "forbidden-svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                id: "a",
                gradientUnits: "userSpaceOnUse",
                x1: "49.4199",
                x2: "122.662",
                y1: "59.7673",
                y2: "59.7673",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: "0",
                        stopColor: "#0065ff"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: ".2188",
                        stopColor: "#0b6cff"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: ".5999",
                        stopColor: "#2780ff"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: "1",
                        stopColor: "#4c9aff"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m122.662 119.5347h-73.242v-82.9141a36.6211 36.6211 0 0 1 73.2422 0zm-61.2422-12h49.2422v-70.9141a24.6211 24.6211 0 0 0 -49.2422 0z",
                fill: "url(#a)"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m160.3239 111.17a65.4958 65.4958 0 0 1 -5.657-46.1172l.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-130.6932a5.0533 5.0533 0 0 0 -4.9038 6.273l.0015.0057a66.1488 66.1488 0 0 1 -5.7847 46.3674 75.4908 75.4908 0 0 0 65.21 110.0468c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0027c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0032c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0031c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0652-.0009.0977 0h.0023c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024a75.491 75.491 0 0 0 68.8626-110.2939z",
                fill: "#de350b"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m154.6669 65.0531.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-112.8264a5.0533 5.0533 0 0 0 -4.9039 6.273l.0014.0057a66.1491 66.1491 0 0 1 -5.7845 46.3674 75.4854 75.4854 0 1 0 134.072-.2471 65.4957 65.4957 0 0 1 -5.6569-46.1172z",
                fill: "#ff5630"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m93.3523 213.6q-.8454 0-1.6973-.0205a67.6029 67.6029 0 0 1 -58.3963-98.5383 74.3762 74.3762 0 0 0 7.2113-48.3823h105.7618a73.488 73.488 0 0 0 7.0986 48.16 67.6006 67.6006 0 0 1 -59.9755 98.7811z",
                fill: "#ff7452"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m90.0071 176.8851a16.3079 16.3079 0 0 1 -16.1149-18.8193l2.23-14.3217a24.1482 24.1482 0 0 1 16.087-41.053c.3821-.0176.7658-.0265 1.1435-.0265a24.1491 24.1491 0 0 1 17.229 41.0809l2.2312 14.32a16.31 16.31 0 0 1 -16.1149 18.8193z",
                fill: "#ff5630"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m108.481 126.8237a15.0613 15.0613 0 0 1 -4.83 11.0676 7.2219 7.2219 0 0 0 -2.1218 6.4121l2.3594 15.1531a7.2783 7.2783 0 0 1 -7.1916 8.3981h-6.69a7.2783 7.2783 0 0 1 -7.1916-8.3981l2.3872-15.3318a7.2321 7.2321 0 0 0 -2.2684-6.345 15.0639 15.0639 0 0 1 -4.6905-11.7523 15.1293 15.1293 0 0 1 30.2376.7963z",
                fill: "#de350b"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m82.8151 159.4565a7.2565 7.2565 0 1 0 14.3328 0l-2.3594-15.1531a7.2215 7.2215 0 0 1 2.1217-6.4121 15.1041 15.1041 0 0 0 -6.9452-25.804 15.2678 15.2678 0 0 0 -11.7216 13.94 15.0634 15.0634 0 0 0 4.6906 11.7527 7.232 7.232 0 0 1 2.2683 6.3449z",
                fill: "#344563"
            })
        ]
    });

});


parcelRegister("8HfZa", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e677e1309f5a3ef$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $cafmZ = parcelRequire("cafmZ");

var $f1Nvs = parcelRequire("f1Nvs");

var $hdYNe = parcelRequire("hdYNe");

var $bV6jl = parcelRequire("bV6jl");
const $1e677e1309f5a3ef$var$NotFoundView = ({ context: context, accessContext: accessContext, testId: testId = 'embed-card-not-found-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey } = accessContext ?? {};
    const values = (0, $eJOHy.useMemo)(()=>({
            product: text
        }), [
        text
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hdYNe.default), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bV6jl.NotFoundSVG), {}),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $f1Nvs.toMessage)((0, $cafmZ.messages).not_found_title, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $f1Nvs.toMessage)((0, $cafmZ.messages).not_found_description, descriptiveMessageKey),
            values: values
        })
    });
};
var $1e677e1309f5a3ef$export$2e2bcd8739ae039 = $1e677e1309f5a3ef$var$NotFoundView;

});
parcelRegister("bV6jl", function(module, exports) {
$parcel$export(module.exports, "NotFoundSVG", () => $dfd551e2bff033c8$export$80542c1714a314c8);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $dfd551e2bff033c8$export$80542c1714a314c8 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 200.55 269.99",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "not-found-svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient",
                        x1: "1316.98",
                        y1: "230.66",
                        x2: "1396.36",
                        y2: "230.66",
                        gradientTransform: "matrix(-1, 0, 0, 1, 1517.54, 0)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#344563"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#6c798f"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-2",
                        x1: "170.3",
                        y1: "897.49",
                        x2: "365.15",
                        y2: "897.49",
                        gradientTransform: "translate(-125.06 -762.9) rotate(4.81)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#fff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.69",
                                stopColor: "#fff",
                                stopOpacity: "0.1"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("title", {
                children: "Search error"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                id: "Layer_2",
                "data-name": "Layer 2",
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                    id: "Objects",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#cfd4db",
                            d: "M126.84,210.1l-9.51-9.39,13-13.23,9.52,9.39a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            id: "_Path_",
                            "data-name": "<Path>",
                            fill: "url(#linear-gradient)",
                            d: "M126.84,210.1l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#091e42",
                            opacity: 0.1,
                            d: "M131.63,218.46a18,18,0,0,0-4.79-8.36l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.41,4.68,79.1,79.1,0,0,1-7.72,9.12A77.4,77.4,0,0,1,131.63,218.46Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#344563",
                            d: "M155.47,145.8A77.74,77.74,0,0,0,22.41,91.7,77.24,77.24,0,0,0,0,146.82H0a77.22,77.22,0,0,0,23.13,54.81h0A77.74,77.74,0,0,0,155.47,145.8Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            id: "_Clipping_Path_",
                            "data-name": "<Clipping Path>",
                            fill: "#deebff",
                            d: "M35.62,104.74a59.17,59.17,0,1,1-17.06,42A58.81,58.81,0,0,1,35.62,104.74Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            id: "_Path_2",
                            "data-name": "<Path>",
                            fill: "#b2d4ff",
                            d: "M39.54,101.12A59.19,59.19,0,1,0,82.69,87.36,58.82,58.82,0,0,0,39.54,101.12Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#cce0ff",
                            d: "M78.09,94.6a59.17,59.17,0,0,0-52.5,23.71,59.2,59.2,0,0,0,99.68,63.28,59.2,59.2,0,0,0-47.18-87Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "url(#linear-gradient-2)",
                            d: "M72.77,205.3A59.25,59.25,0,0,0,133.92,165a59.2,59.2,0,0,1-6.42.62c-19.4.74-33.31-8.64-40-13.32-20.19-14-20.75-28.19-33.7-41.34A56,56,0,0,0,40,100.76l-.44.36A59.18,59.18,0,0,0,72.77,205.3Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("polygon", {
                            id: "_Path_3",
                            "data-name": "<Path>",
                            fill: "#5e6c84",
                            points: "105.15 132.36 94.03 121.33 78.7 136.79 63.24 121.45 52.22 132.57 67.68 147.9 52.34 163.35 63.45 174.38 78.79 158.92 94.24 174.26 105.27 163.15 89.81 147.81 105.15 132.36"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#ffc400",
                            d: "M82.29,29.4,72.12.45A.68.68,0,0,0,70.81.6L67.53,28.65l-6.48-.75a.67.67,0,0,0-.72.89l10.17,29a.68.68,0,0,0,1.31-.15l3.28-28.05,6.48.76A.68.68,0,0,0,82.29,29.4Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#ffc400",
                            d: "M50.28,47.8,37.64,39.17a.29.29,0,0,0-.42.39l7,12.21-2.84,1.62a.29.29,0,0,0,0,.5L54,62.52a.3.3,0,0,0,.43-.39l-7-12.21,2.84-1.62A.29.29,0,0,0,50.28,47.8Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#344563",
                            d: "M104.31,36.05c-.7,2.07-9.75-1-10.44,1.11s8.35,5.11,7.66,7.18-9.75-1-10.44,1.12,8.35,5.11,7.66,7.18-9.75-1-10.44,1.12S96.66,58.87,96,61"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#5e6c84",
                            d: "M125.53,59.72c-1.59,1.49-7.85-5.2-9.45-3.71s4.66,8.19,3.06,9.69-7.86-5.21-9.46-3.72c-.74.7.21,2.51,1.28,4.4"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#5e6c84",
                            d: "M20.83,59.86c2.17.27,1.06,9.37,3.23,9.63s3.28-8.83,5.46-8.57,1.05,9.37,3.22,9.63c1,.13,1.79-1.76,2.56-3.8"
                        })
                    ]
                })
            })
        ]
    });

});


parcelRegister("cPJjA", function(module, exports) {
$parcel$export(module.exports, "EmbedCardResolvedView", () => $2c9bd300dc24ef37$export$30f3c6c32b384a8b);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $g0IEj = parcelRequire("g0IEj");

var $kePQU = parcelRequire("kePQU");

var $8Ku1L = parcelRequire("8Ku1L");

var $cHEjl = parcelRequire("cHEjl");

var $7kKh8 = parcelRequire("7kKh8");

var $80z5l = parcelRequire("80z5l");

var $dAVKw = parcelRequire("dAVKw");

var $8MTiL = parcelRequire("8MTiL");
const $2c9bd300dc24ef37$export$30f3c6c32b384a8b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ link: link, context: context, onClick: onClick, isSelected: isSelected, frameStyle: frameStyle, preview: preview, title: title, isTrusted: isTrusted, testId: testId = 'embed-card-resolved-view', inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, isSupportTheming: isSupportTheming, type: type, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton, extensionKey: extensionKey }, embedIframeRef)=>{
    const iconFromContext = context?.icon;
    const src = typeof iconFromContext === 'string' ? iconFromContext : undefined;
    const text = title || context?.text;
    const linkGlyph = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g0IEj))), {
            label: "icon",
            LEGACY_size: "small",
            testId: "embed-card-fallback-icon",
            color: "currentColor"
        }), []);
    let icon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(iconFromContext)) return iconFromContext;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dAVKw.ImageIcon), {
            src: src,
            default: linkGlyph,
            appearance: (0, $cHEjl.isProfileType)(type) ? 'round' : 'square',
            hideLoadingSkeleton: hideIconLoadingSkeleton
        });
    }, [
        iconFromContext,
        src,
        linkGlyph,
        type,
        hideIconLoadingSkeleton
    ]);
    if ((0, $kePQU.fg)('ptc-enable-embed-team-smart-links')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $8MTiL.useEmbedResolvePostMessageListener)({
        url: link,
        embedIframeRef: embedIframeRef
    });
    const themeState = (0, $8Ku1L.default)();
    let previewUrl = preview?.src;
    if (previewUrl && isSupportTheming) previewUrl = (0, $cHEjl.getPreviewUrlWithTheme)(previewUrl, themeState);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7kKh8.ExpandedFrame), {
        isSelected: isSelected,
        frameStyle: frameStyle,
        href: link,
        testId: testId,
        icon: icon,
        text: text,
        onClick: onClick,
        inheritDimensions: inheritDimensions,
        setOverflow: false,
        CompetitorPrompt: CompetitorPrompt,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $80z5l.Frame), {
            url: previewUrl,
            isTrusted: isTrusted,
            testId: testId,
            ref: embedIframeRef,
            onIframeDwell: onIframeDwell,
            onIframeFocus: onIframeFocus,
            title: text,
            extensionKey: extensionKey
        })
    });
});

});
parcelRegister("80z5l", function(module, exports) {
$parcel$export(module.exports, "Frame", () => $d12bc24d32f6eb5e$export$b89a827e9254211a);
/* Frame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $cHEjl = parcelRequire("cHEjl");

var $1xHc7 = parcelRequire("1xHc7");

var $2oVoc = parcelRequire("2oVoc");
function $d12bc24d32f6eb5e$var$mergeRefs(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}
const $d12bc24d32f6eb5e$var$iframeStyles = null;
const $d12bc24d32f6eb5e$export$b89a827e9254211a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ url: url, isTrusted: isTrusted = false, testId: testId, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, title: title, extensionKey: extensionKey }, iframeRef)=>{
    (0, $gRw8I.di)((0, $1xHc7.IFrame));
    const [isIframeLoaded, setIframeLoaded] = (0, $eJOHy.useState)(false);
    const [isMouseOver, setMouseOver] = (0, $eJOHy.useState)(false);
    const [isWindowFocused, setWindowFocused] = (0, $eJOHy.useState)(true);
    const ref = (0, $eJOHy.useRef)();
    const mergedRef = $d12bc24d32f6eb5e$var$mergeRefs([
        iframeRef,
        ref
    ]);
    const [percentVisible, setPercentVisible] = (0, $eJOHy.useState)(0);
    /**
   * These are the 'percent visible' thresholds at which the intersectionObserver will
   * trigger a state change. Eg. when the user scrolls and moves from 74% to 76%, or
   * vice versa. It's in a state object so that its static for the useEffect
   */ const [threshold] = (0, $eJOHy.useState)([
        0.75,
        0.8,
        0.85,
        0.9,
        0.95,
        1
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!ref || !ref.current) return;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                setPercentVisible(entry?.intersectionRatio);
            });
        }, {
            threshold: threshold
        });
        observer.observe(ref.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        threshold,
        mergedRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const onBlur = ()=>{
            setWindowFocused(false);
            if (document.activeElement === ref.current) onIframeFocus && onIframeFocus();
        };
        const onFocus = ()=>{
            setWindowFocused(true);
        };
        window.addEventListener('blur', onBlur);
        window.addEventListener('focus', onFocus);
        return ()=>{
            window.removeEventListener('blur', onBlur);
            window.removeEventListener('focus', onFocus);
        };
    }, [
        ref,
        onIframeFocus
    ]);
    if (!url) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2oVoc.IframeDwellTracker), {
                isIframeLoaded: isIframeLoaded,
                isMouseOver: isMouseOver,
                isWindowFocused: isWindowFocused,
                iframePercentVisible: percentVisible,
                onIframeDwell: onIframeDwell
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1xHc7.IFrame), {
                childRef: mergedRef,
                src: url,
                "data-testid": `${testId}-frame`,
                "data-iframe-loaded": isIframeLoaded,
                onMouseEnter: ()=>setMouseOver(true),
                onMouseLeave: ()=>setMouseOver(false),
                allowFullScreen: true,
                scrolling: "yes",
                allow: "autoplay; encrypted-media; clipboard-write",
                onLoad: ()=>{
                    setIframeLoaded(true);
                },
                sandbox: (0, $cHEjl.getIframeSandboxAttribute)(isTrusted),
                title: title,
                extensionKey: extensionKey,
                className: (0, $hcewu.default)([
                    "_19itidpf _1reo15vq _18m915vq _2rkofajl _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _kqswh2mm"
                ])
            })
        ]
    });
});

});
parcelRegister("1xHc7", function(module, exports) {
$parcel$export(module.exports, "IFrame", () => $f95477859357b00d$export$b32b5f1ee4493319);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $cvUak = parcelRequire("cvUak");

var $kePQU = parcelRequire("kePQU");

var $bCZso = parcelRequire("bCZso");
const $f95477859357b00d$export$b32b5f1ee4493319 = ({ childRef: childRef, className: className, extensionKey: extensionKey, ...props })=>{
    const confluencePageData = (0, $kePQU.fg)('platform_deprecate_lp_cc_embed') ? (0, $bCZso.useConfluencePageData)(props.src || '', extensionKey || '') : undefined;
    // Conditional rendering: Page component for lp-cc-embed URLs, iframe for everything else
    return confluencePageData && (0, $kePQU.fg)('platform_deprecate_lp_cc_embed') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cvUak.Page), {
        hostname: confluencePageData.hostname,
        spaceKey: confluencePageData.spaceKey,
        contentId: confluencePageData.contentId,
        parentProduct: confluencePageData.parentProduct,
        hash: confluencePageData.hash,
        mode: confluencePageData.mode,
        locale: confluencePageData.locale
    }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, $gt9Am.jsx)("iframe", {
        className: className,
        ...props,
        ref: childRef,
        title: props.title
    });
};

});
parcelRegister("cvUak", function(module, exports) {
$parcel$export(module.exports, "Page", () => $a5c1b73ffbcfdc83$export$6955bcca4cd3539f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1gG7v = parcelRequire("1gG7v");

var $99glD = parcelRequire("99glD");

var $eByDj = parcelRequire("eByDj");
const $a5c1b73ffbcfdc83$export$6955bcca4cd3539f = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $1gG7v.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $99glD.default),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eByDj.Page), {
            ...props
        })
    });

});
parcelRegister("1gG7v", function(module, exports) {
$parcel$export(module.exports, "I18nProvider", () => $3e77b3937e025ace$export$a54013f0d02a8f82);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4nehu = parcelRequire("4nehu");

var $kg2bG = parcelRequire("kg2bG");
const $3e77b3937e025ace$export$a54013f0d02a8f82 = ({ children: children, locale: incomingLocale = (0, $kg2bG.DEFAULT_LOCALE), fetchTranslations: fetchTranslations })=>{
    const [messages, setMessages] = (0, $eJOHy.useState)();
    const locale = (0, $eJOHy.useMemo)(()=>(0, $kg2bG.normalizeLocale)(incomingLocale), [
        incomingLocale
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const loadTranslations = async ()=>{
            const localeMessages = await fetchTranslations(locale);
            setMessages(localeMessages);
        };
        loadTranslations();
    }, [
        fetchTranslations,
        locale
    ]);
    if (!messages) return null;
    // Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
    // They will not function correctly due to a lack of I18n context.
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: locale,
        messages: messages,
        defaultLocale: (0, $kg2bG.DEFAULT_LOCALE),
        children: children
    });
};

});
parcelRegister("kg2bG", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_LOCALE", () => $7cecad96cc1133fc$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "normalizeLocale", () => $7cecad96cc1133fc$export$dca0327c9b9c6498);
const $7cecad96cc1133fc$var$DEFAULT_LANGUAGE = 'en';
const $7cecad96cc1133fc$var$DEFAULT_REGION = 'US';
const $7cecad96cc1133fc$export$1af4c7e47ad72f44 = `${$7cecad96cc1133fc$var$DEFAULT_LANGUAGE}-${$7cecad96cc1133fc$var$DEFAULT_REGION}`;
const $7cecad96cc1133fc$var$languageToLongLocaleCode = {
    cs: 'cs-CZ',
    da: 'da-DK',
    de: 'de-DE',
    en: 'en-US',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hu: 'hu-HU',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    // Both `no` and `nb` language codes refer to Norwegian. Refer both to long locale code as `no-NO`
    no: 'no-NO',
    nb: 'no-NO',
    nl: 'nl-NL',
    pl: 'pl-PL',
    ru: 'ru-RU',
    sv: 'sv-SE',
    th: 'th-TH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    vi: 'vi-VN',
    zh: 'zh-CN'
};
const $7cecad96cc1133fc$export$dca0327c9b9c6498 = (locale)=>{
    if (!locale) return $7cecad96cc1133fc$export$1af4c7e47ad72f44;
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from the supplied locale.');
    const [, language, region] = match;
    const normalizedLanguage = (language ?? '').toLowerCase();
    const normalizedRegion = (region ?? '').toUpperCase();
    if (normalizedLanguage && normalizedRegion) return [
        normalizedLanguage,
        normalizedRegion
    ].join('-');
    const longLocaleCode = $7cecad96cc1133fc$var$languageToLongLocaleCode[normalizedLanguage];
    return longLocaleCode ?? $7cecad96cc1133fc$export$1af4c7e47ad72f44;
};

});


parcelRegister("99glD", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a650ce3142dcda1$export$2e2bcd8739ae039);

var $aSd4B = parcelRequire("aSd4B");

var $2M2Vq = parcelRequire("2M2Vq");
const $5a650ce3142dcda1$var$fetchTranslations = async (locale)=>{
    switch(locale){
        case 'en-GB':
            return 0, $aSd4B.default;
        case 'en-US':
        default:
            return 0, $2M2Vq.default;
    }
};
var $5a650ce3142dcda1$export$2e2bcd8739ae039 = $5a650ce3142dcda1$var$fetchTranslations;

});
parcelRegister("aSd4B", function(module, exports) {
$parcel$export(module.exports, "default", () => $e32889130008ee02$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $e32889130008ee02$export$2e2bcd8739ae039 = {
    'my.test.no-translate': 'My Test'
};

});

parcelRegister("2M2Vq", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3534fd7e06d95b3$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $a3534fd7e06d95b3$export$2e2bcd8739ae039 = {
    'my.test.no-translate': 'My Test'
};

});


parcelRegister("eByDj", function(module, exports) {
$parcel$export(module.exports, "Page", () => $0df6ee0ec3e3fca8$export$6955bcca4cd3539f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kyTR5 = parcelRequire("kyTR5");

var $lRq8t = parcelRequire("lRq8t");

var $aeJ8v = parcelRequire("aeJ8v");

var $kciqD = parcelRequire("kciqD");
const $0df6ee0ec3e3fca8$var$ViewComponent = (props)=>{
    const { locale: locale } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aeJ8v.ViewPage), {
        locale: locale,
        ...props
    });
};
const $0df6ee0ec3e3fca8$var$EditComponent = (props)=>{
    const { locale: locale } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kciqD.EditPage), {
        locale: locale,
        ...props
    });
};
const $0df6ee0ec3e3fca8$export$6955bcca4cd3539f = (props)=>{
    const { locale: locale } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kyTR5.Page), {
        locale: locale,
        ...props,
        viewComponent: $0df6ee0ec3e3fca8$var$ViewComponent,
        editComponent: $0df6ee0ec3e3fca8$var$EditComponent
    });
};

});
parcelRegister("kyTR5", function(module, exports) {
$parcel$export(module.exports, "Page", () => $cb1c78179ae6b509$export$6955bcca4cd3539f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $H5ipJ = parcelRequire("H5ipJ");

var $7kpAG = parcelRequire("7kpAG");

var $1gG7v = parcelRequire("1gG7v");

var $9Mevf = parcelRequire("9Mevf");
const $cb1c78179ae6b509$export$6955bcca4cd3539f = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $1gG7v.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $9Mevf.default),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
            fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7kpAG.PageNotFoundEmptyState), {}),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $H5ipJ.Page), {
                ...props
            })
        })
    });

});
parcelRegister("H5ipJ", function(module, exports) {
$parcel$export(module.exports, "Page", () => $351124f44e383a5c$export$6955bcca4cd3539f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $geAAj = parcelRequire("geAAj");

var $7r9mh = parcelRequire("7r9mh");

var $3c33i = parcelRequire("3c33i");

var $5WPl6 = parcelRequire("5WPl6");

var $lRq8t = parcelRequire("lRq8t");

var $kePQU = parcelRequire("kePQU");
const $351124f44e383a5c$var$EDIT_PAGE_CLOSE = 'edit-page/close';
const $351124f44e383a5c$var$EDIT_PAGE_PUBLISH = 'edit-page/publish';
const $351124f44e383a5c$export$6955bcca4cd3539f = (props)=>{
    const { viewComponent: ViewComponent, editComponent: EditComponent } = props;
    const { mode: mode, allowedFeatures: allowedFeatures, draftShareId: draftShareId, navigationPolicy: navigationPolicy, spaceKey: spaceKey, showFooter: showFooter, ...passThroughProps } = (0, $7r9mh.parsePageProps)(props);
    const { onModeChange: onModeChange } = props;
    const [currentMode, setCurrentMode] = (0, $eJOHy.useState)(mode);
    (0, $eJOHy.useEffect)(()=>{
        setCurrentMode(mode);
    }, [
        mode
    ]);
    const [currentSpaceKey, setCurrentSpaceKey] = (0, $eJOHy.useState)(spaceKey);
    const switchToViewPage = (0, $eJOHy.useCallback)(()=>{
        setCurrentMode((0, $5WPl6.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE);
    }, [
        setCurrentMode
    ]);
    const pageNavigationPolicy = (0, $eJOHy.useMemo)(()=>({
            navigate (url, modifiers, defaultNavigate) {
                /**
				 * Below is for switching from View to Edit and we assume parent product doesn't have this situation in their navigationPolicy.
				 */ if (currentMode === (0, $5WPl6.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE && (modifiers.routeName === 'EDIT_PAGE_EMBED' || url?.includes('/edit-embed/') && passThroughProps.contentId === modifiers.contentId) && ((0, $kePQU.fg)('platform_deprecate_lp_cc_embed') ? passThroughProps.contentId === modifiers.contentId : true)) {
                    setCurrentMode((0, $5WPl6.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
                    onModeChange?.((0, $5WPl6.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
                    return;
                }
                return navigationPolicy?.navigate ? navigationPolicy.navigate(url, modifiers, defaultNavigate) : defaultNavigate(url, modifiers);
            },
            shimUrl: navigationPolicy?.shimUrl,
            domainNamesToReplace: navigationPolicy?.domainNamesToReplace,
            spaceKeyFilter: navigationPolicy?.spaceKeyFilter
        }), [
        currentMode,
        passThroughProps.contentId,
        navigationPolicy,
        onModeChange
    ]);
    const experienceTracker = (0, $3c33i.useExperienceTracker)();
    (0, $eJOHy.useEffect)(()=>experienceTracker.subscribe((event)=>{
            const { name: name, action: action, attributes: attributes } = event;
            /**
				 * Using experienceTracker, we can switch from Edit to View page.
				 * 1. When the user clicks the Publish button and task success, it can switch to the View page.
				 *    a. If the `publish-modal` is added to the allowedFeatures, the Publish Modal may be used to
				 *          change the spaceKey during publish.
				 *          In that case, a new spaceKey will be added to the success event and tracked here.
				 * 2. If the page is not unpublished draft, when the user clicks Close button and task success, it can switch to the View page.
				 */ const isClosingPublishedEditPage = !draftShareId && name === $351124f44e383a5c$var$EDIT_PAGE_CLOSE;
            const isPublishingDraft = name === $351124f44e383a5c$var$EDIT_PAGE_PUBLISH;
            if (action === 'taskSuccess' && (isClosingPublishedEditPage || isPublishingDraft)) {
                if (allowedFeatures.edit?.includes('publish-modal')) {
                    const newSpaceKey = attributes?.newSpaceKey;
                    setCurrentSpaceKey(newSpaceKey || spaceKey);
                }
                switchToViewPage();
            }
        }), [
        draftShareId,
        experienceTracker,
        switchToViewPage,
        allowedFeatures.edit,
        spaceKey
    ]);
    const { locale: locale } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $geAAj.ExperienceTrackerContext).Provider, {
        value: experienceTracker,
        children: currentMode === (0, $5WPl6.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE ? /*#__PURE__*/ (0, $gt9Am.jsx)(ViewComponent, {
            navigationPolicy: pageNavigationPolicy,
            allowedFeatures: allowedFeatures.view,
            locale: locale,
            spaceKey: currentSpaceKey,
            showFooter: showFooter,
            ...passThroughProps
        }) : currentMode === (0, $5WPl6.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE ? /*#__PURE__*/ (0, $gt9Am.jsx)(EditComponent, {
            navigationPolicy: pageNavigationPolicy,
            allowedFeatures: allowedFeatures.edit,
            draftShareId: draftShareId,
            locale: locale,
            spaceKey: currentSpaceKey,
            ...passThroughProps
        }) : null
    });
};

});
parcelRegister("7r9mh", function(module, exports) {
$parcel$export(module.exports, "parsePageProps", () => $2737529c8269f5ae$export$41eb0a358b69a9df);
$parcel$export(module.exports, "parseUrl", () => $2737529c8269f5ae$export$7a5253c0f62e0150);
parcelRequire("3rarS");
var $ddbcJ = parcelRequire("ddbcJ");

var $d2tn7 = parcelRequire("d2tn7");

var $6KRcO = parcelRequire("6KRcO");

var $5WPl6 = parcelRequire("5WPl6");

var $81XbN = parcelRequire("81XbN");
function $2737529c8269f5ae$export$41eb0a358b69a9df(props) {
    let { contentId: contentId = '', hostname: hostname, parentProduct: parentProduct = '', spaceKey: spaceKey, url: url, allowedFeatures: allowedFeatures, mode: mode, draftShareId: draftShareId, hash: hash, themeState: themeState, showFooter: showFooter, ...passThroughProps } = props;
    const parsedAllowedFeatures = $2737529c8269f5ae$export$350c411f568eceb9(allowedFeatures);
    if (!url) return {
        contentId: contentId,
        hostname: hostname,
        parentProduct: parentProduct,
        spaceKey: spaceKey,
        protocol: 'https:',
        mode: mode ?? (0, $5WPl6.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        allowedFeatures: parsedAllowedFeatures,
        draftShareId: draftShareId,
        hash: hash,
        themeState: themeState,
        showFooter: showFooter,
        ...passThroughProps
    };
    const parsedProps = $2737529c8269f5ae$export$7a5253c0f62e0150(url);
    if (!parsedProps) return {
        hostname: hostname,
        contentId: contentId,
        spaceKey: spaceKey,
        parentProduct: parentProduct,
        mode: mode,
        protocol: 'https:',
        allowedFeatures: parsedAllowedFeatures,
        draftShareId: draftShareId,
        hash: hash,
        themeState: themeState,
        showFooter: showFooter,
        ...passThroughProps
    };
    const themeStateParsedObject = parsedProps.themeState ? (0, $d2tn7.themeStringToObject)(decodeURIComponent(parsedProps.themeState)) : undefined;
    const previewPanels = $2737529c8269f5ae$var$parseQueryParam(parsedProps.query, 'previewPanels');
    // Override with URL-extracted props
    contentId = contentId || parsedProps.contentId;
    parentProduct = parentProduct || parsedProps.parentProduct || '';
    hostname = hostname || parsedProps.hostname || window.location.hostname;
    spaceKey = spaceKey || parsedProps.spaceKey;
    draftShareId = draftShareId || parsedProps.draftShareId;
    hash = hash || parsedProps.hash;
    themeState = themeState || themeStateParsedObject;
    let modeFromUrl;
    switch(parsedProps.route){
        case (0, $81XbN.VIEW_PAGE).name:
        case (0, $81XbN.VIEW_BLOG).name:
        case (0, $81XbN.VIEW_BLOG_DATE_LEGACY).name:
            modeFromUrl = (0, $5WPl6.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE;
            break;
        case (0, $81XbN.EDIT_PAGE_EMBED).name:
        case (0, $81XbN.EDIT_PAGE_V2).name:
            modeFromUrl = (0, $5WPl6.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE;
            break;
        case (0, $81XbN.WHITEBOARD).name:
    }
    const contentSlug = parsedProps.route === (0, $81XbN.VIEW_BLOG_DATE_LEGACY).name ? undefined : parsedProps.contentSlug;
    return {
        allowedFeatures: parsedAllowedFeatures,
        contentId: contentId,
        draftShareId: draftShareId,
        hash: hash,
        hostname: hostname,
        mode: mode || modeFromUrl,
        parentProduct: parentProduct,
        protocol: parsedProps.protocol,
        spaceKey: spaceKey,
        themeState: themeState,
        contentSlug: contentSlug,
        showFooter: showFooter,
        previewPanels: previewPanels,
        ...passThroughProps
    };
}
function $2737529c8269f5ae$export$7a5253c0f62e0150(url) {
    if (!url) return null;
    const matchedRoute = $2737529c8269f5ae$var$findAndMatchRoute((0, $81XbN.namedRoutes), url);
    if (!matchedRoute) return null;
    const { routeName: routeName, ...match } = matchedRoute;
    const { year: year, month: month, day: day, contentId: contentId } = match.params;
    // Validate date parameters
    const isValidYear = /^\d+$/.test(year || '');
    const isValidMonth = /^\d+$/.test(month || '');
    const isValidDay = /^\d+$/.test(day || '');
    const isValidContentId = /^\d+$/.test(contentId || '');
    // If route requires validation, and any parameter is invalid, return null
    if (routeName === (0, $81XbN.VIEW_BLOG_DATE_LEGACY).name && (!isValidYear || !isValidMonth || !isValidDay || !isValidContentId)) return null;
    return {
        route: routeName,
        hostname: match.host,
        protocol: match.protocol,
        contentId: contentId || '',
        spaceKey: match.params.spaceKey || '',
        hash: match.hash || '',
        // EP currently supports only 1 parent product, no more than 1 parent product should be passed in
        parentProduct: Array.isArray(match.query.parentProduct) ? match.query.parentProduct[0] : match.query.parentProduct || '',
        draftShareId: Array.isArray(match.query.draftShareId) ? match.query.draftShareId[0] : match.query.draftShareId,
        themeState: match.query.themeState,
        contentSlug: match.params.contentSlug || undefined,
        query: match.query
    };
}
function $2737529c8269f5ae$var$findAndMatchRoute(routes, url) {
    for (const routeKey of Object.keys(routes)){
        const route = routes[routeKey];
        const match = $2737529c8269f5ae$var$matchUrl(route.pattern, url);
        if (match) return {
            routeName: route.name,
            ...match
        };
    }
    return null;
}
function $2737529c8269f5ae$var$isValidURL(url) {
    try {
        new URL(url, window.location.origin);
        return true;
    } catch  {
        return false;
    }
}
function $2737529c8269f5ae$var$matchUrl(pattern, url) {
    if (!$2737529c8269f5ae$var$isValidURL(url)) return null;
    const parsed = new URL(url, window.location.origin);
    const pathname = parsed.pathname || '';
    const search = parsed.search || '';
    let match = (0, $ddbcJ.matchPath)({
        path: pattern,
        end: true
    }, pathname);
    // If initial match fails and the route requires query parameters, attempt to match including search
    // some of our routes need query params to match
    if (!match && search) match = (0, $ddbcJ.matchPath)({
        path: pattern,
        end: true
    }, `${pathname}${search}`);
    if (!match) return null;
    // URI decode params
    const decodedParams = {};
    if (match.params) {
        for (const [key, value] of Object.entries(match.params))if (value !== undefined) decodedParams[key] = value;
    }
    return {
        url: url,
        protocol: parsed.protocol,
        host: parsed.host,
        pathname: pathname,
        search: parsed.search,
        hash: parsed.hash,
        pattern: pattern,
        params: decodedParams,
        query: Object.fromEntries(parsed.searchParams.entries())
    };
}
function $2737529c8269f5ae$export$350c411f568eceb9(allowedFeatures) {
    let parsedAllowedFeatures = {
        view: allowedFeatures?.view,
        edit: allowedFeatures?.edit
    };
    if (!allowedFeatures?.view) parsedAllowedFeatures.view = [
        ...(0, $6KRcO.DEFAULT_ALLOWED_FEATURES).view,
        'edit'
    ];
    else if (Array.isArray(allowedFeatures.view)) parsedAllowedFeatures.view = [
        ...allowedFeatures.view,
        'edit'
    ];
    return parsedAllowedFeatures;
}
function $2737529c8269f5ae$var$parseQueryParam(query, keyName) {
    for (const [key, value] of Object.entries(query)){
        if (key === keyName) return Array.isArray(value) ? value.join(',') : value;
    }
    return undefined;
}

});
parcelRegister("3rarS", function(module, exports) {
$parcel$export(module.exports, "matchPath", () => (parcelRequire("ddbcJ")).matchPath);
/**
 * React Router v6.28.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $ddbcJ = parcelRequire("ddbcJ");
function $280bff9ae18a48cd$var$_extends() {
    $280bff9ae18a48cd$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $280bff9ae18a48cd$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $280bff9ae18a48cd$export$3add0d5dce533e2e = /*#__PURE__*/ $eJOHy.createContext(null);
const $280bff9ae18a48cd$export$145dfa71566a64dc = /*#__PURE__*/ $eJOHy.createContext(null);
const $280bff9ae18a48cd$var$AwaitContext = /*#__PURE__*/ $eJOHy.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $280bff9ae18a48cd$export$26749e8557646306 = /*#__PURE__*/ $eJOHy.createContext(null);
const $280bff9ae18a48cd$export$c7914228fb69b0f5 = /*#__PURE__*/ $eJOHy.createContext(null);
const $280bff9ae18a48cd$export$9072aa6dd1f93057 = /*#__PURE__*/ $eJOHy.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $280bff9ae18a48cd$var$RouteErrorContext = /*#__PURE__*/ $eJOHy.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $280bff9ae18a48cd$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$280bff9ae18a48cd$export$9c954a9d03d32f4a() && (0, $ddbcJ.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $eJOHy.useContext($280bff9ae18a48cd$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $280bff9ae18a48cd$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $ddbcJ.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $280bff9ae18a48cd$export$9c954a9d03d32f4a() {
    return $eJOHy.useContext($280bff9ae18a48cd$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $280bff9ae18a48cd$export$45d76561a5302f2b() {
    !$280bff9ae18a48cd$export$9c954a9d03d32f4a() && (0, $ddbcJ.UNSAFE_invariant)(false);
    return $eJOHy.useContext($280bff9ae18a48cd$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $280bff9ae18a48cd$export$1b3f31771c5d07c() {
    return $eJOHy.useContext($280bff9ae18a48cd$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $280bff9ae18a48cd$export$6c330e8992e8a295(pattern) {
    !$280bff9ae18a48cd$export$9c954a9d03d32f4a() && (0, $ddbcJ.UNSAFE_invariant)(false);
    let { pathname: pathname } = $280bff9ae18a48cd$export$45d76561a5302f2b();
    return $eJOHy.useMemo(()=>(0, $ddbcJ.matchPath)(pattern, (0, $ddbcJ.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $280bff9ae18a48cd$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $280bff9ae18a48cd$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $eJOHy.useContext($280bff9ae18a48cd$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $eJOHy.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $280bff9ae18a48cd$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $eJOHy.useContext($280bff9ae18a48cd$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $280bff9ae18a48cd$var$useNavigateStable() : $280bff9ae18a48cd$var$useNavigateUnstable();
}
function $280bff9ae18a48cd$var$useNavigateUnstable() {
    !$280bff9ae18a48cd$export$9c954a9d03d32f4a() && (0, $ddbcJ.UNSAFE_invariant)(false);
    let dataRouterContext = $eJOHy.useContext($280bff9ae18a48cd$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $eJOHy.useContext($280bff9ae18a48cd$export$26749e8557646306);
    let { matches: matches } = $eJOHy.useContext($280bff9ae18a48cd$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $280bff9ae18a48cd$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $ddbcJ.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $eJOHy.useRef(false);
    $280bff9ae18a48cd$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $eJOHy.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $ddbcJ.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $ddbcJ.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $280bff9ae18a48cd$var$OutletContext = /*#__PURE__*/ $eJOHy.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $280bff9ae18a48cd$export$4138103a3ae699cc() {
    return $eJOHy.useContext($280bff9ae18a48cd$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $280bff9ae18a48cd$export$a3be3530d8e40d0b(context) {
    let outlet = $eJOHy.useContext($280bff9ae18a48cd$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $eJOHy.createElement($280bff9ae18a48cd$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $280bff9ae18a48cd$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $eJOHy.useContext($280bff9ae18a48cd$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $280bff9ae18a48cd$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $eJOHy.useContext($280bff9ae18a48cd$export$26749e8557646306);
    let { matches: matches } = $eJOHy.useContext($280bff9ae18a48cd$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $280bff9ae18a48cd$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $ddbcJ.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $eJOHy.useMemo(()=>(0, $ddbcJ.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $280bff9ae18a48cd$export$5d3fca4a98652595(routes, locationArg) {
    return $280bff9ae18a48cd$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $280bff9ae18a48cd$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$280bff9ae18a48cd$export$9c954a9d03d32f4a() && (0, $ddbcJ.UNSAFE_invariant)(false);
    let { navigator: navigator } = $eJOHy.useContext($280bff9ae18a48cd$export$26749e8557646306);
    let { matches: parentMatches } = $eJOHy.useContext($280bff9ae18a48cd$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $280bff9ae18a48cd$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $ddbcJ.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $ddbcJ.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $ddbcJ.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $280bff9ae18a48cd$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $ddbcJ.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $ddbcJ.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $eJOHy.createElement($280bff9ae18a48cd$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $280bff9ae18a48cd$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $ddbcJ.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $280bff9ae18a48cd$var$DefaultErrorComponent() {
    let error = $280bff9ae18a48cd$export$ed527bf60f6e05f2();
    let message = (0, $ddbcJ.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $eJOHy.createElement($eJOHy.Fragment, null, /*#__PURE__*/ $eJOHy.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $eJOHy.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $eJOHy.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $280bff9ae18a48cd$var$defaultErrorElement = /*#__PURE__*/ $eJOHy.createElement($280bff9ae18a48cd$var$DefaultErrorComponent, null);
class $280bff9ae18a48cd$var$RenderErrorBoundary extends $eJOHy.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $eJOHy.createElement($280bff9ae18a48cd$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $eJOHy.createElement($280bff9ae18a48cd$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $280bff9ae18a48cd$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $eJOHy.useContext($280bff9ae18a48cd$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $eJOHy.createElement($280bff9ae18a48cd$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $280bff9ae18a48cd$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $ddbcJ.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $280bff9ae18a48cd$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $280bff9ae18a48cd$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $eJOHy.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $eJOHy.createElement($280bff9ae18a48cd$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $eJOHy.createElement($280bff9ae18a48cd$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $280bff9ae18a48cd$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($280bff9ae18a48cd$var$DataRouterHook || {});
var $280bff9ae18a48cd$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($280bff9ae18a48cd$var$DataRouterStateHook || {});
function $280bff9ae18a48cd$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $280bff9ae18a48cd$var$useDataRouterContext(hookName) {
    let ctx = $eJOHy.useContext($280bff9ae18a48cd$export$3add0d5dce533e2e);
    !ctx && (0, $ddbcJ.UNSAFE_invariant)(false);
    return ctx;
}
function $280bff9ae18a48cd$var$useDataRouterState(hookName) {
    let state = $eJOHy.useContext($280bff9ae18a48cd$export$145dfa71566a64dc);
    !state && (0, $ddbcJ.UNSAFE_invariant)(false);
    return state;
}
function $280bff9ae18a48cd$var$useRouteContext(hookName) {
    let route = $eJOHy.useContext($280bff9ae18a48cd$export$9072aa6dd1f93057);
    !route && (0, $ddbcJ.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $280bff9ae18a48cd$var$useCurrentRouteId(hookName) {
    let route = $280bff9ae18a48cd$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $ddbcJ.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $280bff9ae18a48cd$export$5fc8298006ad9e58() {
    return $280bff9ae18a48cd$var$useCurrentRouteId($280bff9ae18a48cd$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $280bff9ae18a48cd$export$d0fd4b7106de2769() {
    let state = $280bff9ae18a48cd$var$useDataRouterState($280bff9ae18a48cd$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $280bff9ae18a48cd$export$600dc272ed516c15() {
    let dataRouterContext = $280bff9ae18a48cd$var$useDataRouterContext($280bff9ae18a48cd$var$DataRouterHook.UseRevalidator);
    let state = $280bff9ae18a48cd$var$useDataRouterState($280bff9ae18a48cd$var$DataRouterStateHook.UseRevalidator);
    return $eJOHy.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $280bff9ae18a48cd$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $280bff9ae18a48cd$var$useDataRouterState($280bff9ae18a48cd$var$DataRouterStateHook.UseMatches);
    return $eJOHy.useMemo(()=>matches.map((m)=>(0, $ddbcJ.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $280bff9ae18a48cd$export$1448a5050d252c4d() {
    let state = $280bff9ae18a48cd$var$useDataRouterState($280bff9ae18a48cd$var$DataRouterStateHook.UseLoaderData);
    let routeId = $280bff9ae18a48cd$var$useCurrentRouteId($280bff9ae18a48cd$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $280bff9ae18a48cd$export$fd5d37484eab868d(routeId) {
    let state = $280bff9ae18a48cd$var$useDataRouterState($280bff9ae18a48cd$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $280bff9ae18a48cd$export$fdc00f3f26066d5e() {
    let state = $280bff9ae18a48cd$var$useDataRouterState($280bff9ae18a48cd$var$DataRouterStateHook.UseActionData);
    let routeId = $280bff9ae18a48cd$var$useCurrentRouteId($280bff9ae18a48cd$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $280bff9ae18a48cd$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $eJOHy.useContext($280bff9ae18a48cd$var$RouteErrorContext);
    let state = $280bff9ae18a48cd$var$useDataRouterState($280bff9ae18a48cd$var$DataRouterStateHook.UseRouteError);
    let routeId = $280bff9ae18a48cd$var$useCurrentRouteId($280bff9ae18a48cd$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $280bff9ae18a48cd$export$78a72ddb39bdd145() {
    let value = $eJOHy.useContext($280bff9ae18a48cd$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $280bff9ae18a48cd$export$17f53340677d5831() {
    let value = $eJOHy.useContext($280bff9ae18a48cd$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $280bff9ae18a48cd$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $280bff9ae18a48cd$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $280bff9ae18a48cd$var$useDataRouterContext($280bff9ae18a48cd$var$DataRouterHook.UseBlocker);
    let state = $280bff9ae18a48cd$var$useDataRouterState($280bff9ae18a48cd$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $eJOHy.useState("");
    let blockerFunction = $eJOHy.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $280bff9ae18a48cd$var$_extends({}, currentLocation, {
                pathname: (0, $ddbcJ.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $280bff9ae18a48cd$var$_extends({}, nextLocation, {
                pathname: (0, $ddbcJ.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $eJOHy.useEffect(()=>{
        let key = String(++$280bff9ae18a48cd$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $eJOHy.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $ddbcJ.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $280bff9ae18a48cd$var$useNavigateStable() {
    let { router: router } = $280bff9ae18a48cd$var$useDataRouterContext($280bff9ae18a48cd$var$DataRouterHook.UseNavigateStable);
    let id = $280bff9ae18a48cd$var$useCurrentRouteId($280bff9ae18a48cd$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $eJOHy.useRef(false);
    $280bff9ae18a48cd$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $eJOHy.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $280bff9ae18a48cd$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $280bff9ae18a48cd$var$alreadyWarned$1 = {};
function $280bff9ae18a48cd$var$warningOnce(key, cond, message) {
    if (!cond && !$280bff9ae18a48cd$var$alreadyWarned$1[key]) $280bff9ae18a48cd$var$alreadyWarned$1[key] = true;
}
const $280bff9ae18a48cd$var$alreadyWarned = {};
function $280bff9ae18a48cd$var$warnOnce(key, message) {
    if (!$280bff9ae18a48cd$var$alreadyWarned[message]) {
        $280bff9ae18a48cd$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}
const $280bff9ae18a48cd$var$logDeprecation = (flag, msg, link)=>$280bff9ae18a48cd$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $280bff9ae18a48cd$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if (!(renderFuture != null && renderFuture.v7_startTransition)) $280bff9ae18a48cd$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if (!(renderFuture != null && renderFuture.v7_relativeSplatPath) && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $280bff9ae18a48cd$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (!routerFuture.v7_fetcherPersist) $280bff9ae18a48cd$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (!routerFuture.v7_normalizeFormMethod) $280bff9ae18a48cd$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (!routerFuture.v7_partialHydration) $280bff9ae18a48cd$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (!routerFuture.v7_skipActionErrorRevalidation) $280bff9ae18a48cd$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $280bff9ae18a48cd$var$START_TRANSITION = "startTransition";
const $280bff9ae18a48cd$var$startTransitionImpl = $eJOHy[$280bff9ae18a48cd$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $280bff9ae18a48cd$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $eJOHy.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eJOHy.useCallback((newState)=>{
        if (v7_startTransition && $280bff9ae18a48cd$var$startTransitionImpl) $280bff9ae18a48cd$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $eJOHy.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $eJOHy.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $eJOHy.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $eJOHy.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $eJOHy.useEffect(()=>$280bff9ae18a48cd$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $eJOHy.createElement($eJOHy.Fragment, null, /*#__PURE__*/ $eJOHy.createElement($280bff9ae18a48cd$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $eJOHy.createElement($280bff9ae18a48cd$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $eJOHy.createElement($280bff9ae18a48cd$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $eJOHy.createElement($280bff9ae18a48cd$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $280bff9ae18a48cd$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $280bff9ae18a48cd$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $280bff9ae18a48cd$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $eJOHy.useRef();
    if (historyRef.current == null) historyRef.current = (0, $ddbcJ.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eJOHy.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eJOHy.useCallback((newState)=>{
        v7_startTransition && $280bff9ae18a48cd$var$startTransitionImpl ? $280bff9ae18a48cd$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eJOHy.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $eJOHy.useEffect(()=>$280bff9ae18a48cd$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $eJOHy.createElement($280bff9ae18a48cd$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $280bff9ae18a48cd$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$280bff9ae18a48cd$export$9c954a9d03d32f4a() && (0, $ddbcJ.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $eJOHy.useContext($280bff9ae18a48cd$export$26749e8557646306);
    let { matches: matches } = $eJOHy.useContext($280bff9ae18a48cd$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $280bff9ae18a48cd$export$45d76561a5302f2b();
    let navigate = $280bff9ae18a48cd$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $ddbcJ.resolveTo)(to, (0, $ddbcJ.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $eJOHy.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $280bff9ae18a48cd$export$910ae8079b2c2852(props) {
    return $280bff9ae18a48cd$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $280bff9ae18a48cd$export$e7b0ac011bb776c6(_props) {
    (0, $ddbcJ.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $280bff9ae18a48cd$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $ddbcJ.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$280bff9ae18a48cd$export$9c954a9d03d32f4a() && (0, $ddbcJ.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $eJOHy.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $280bff9ae18a48cd$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $ddbcJ.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $eJOHy.useMemo(()=>{
        let trailingPathname = (0, $ddbcJ.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $eJOHy.createElement($280bff9ae18a48cd$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $eJOHy.createElement($280bff9ae18a48cd$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $280bff9ae18a48cd$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $280bff9ae18a48cd$export$5d3fca4a98652595($280bff9ae18a48cd$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $280bff9ae18a48cd$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $eJOHy.createElement($280bff9ae18a48cd$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $eJOHy.createElement($280bff9ae18a48cd$var$ResolveAwait, null, children));
}
var $280bff9ae18a48cd$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($280bff9ae18a48cd$var$AwaitRenderStatus || {});
const $280bff9ae18a48cd$var$neverSettledPromise = new Promise(()=>{});
class $280bff9ae18a48cd$var$AwaitErrorBoundary extends $eJOHy.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $280bff9ae18a48cd$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $280bff9ae18a48cd$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $280bff9ae18a48cd$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $280bff9ae18a48cd$var$AwaitRenderStatus.error : "_data" in promise ? $280bff9ae18a48cd$var$AwaitRenderStatus.success : $280bff9ae18a48cd$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $280bff9ae18a48cd$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $280bff9ae18a48cd$var$AwaitRenderStatus.error && promise._error instanceof (0, $ddbcJ.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $280bff9ae18a48cd$var$neverSettledPromise;
        if (status === $280bff9ae18a48cd$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $280bff9ae18a48cd$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $eJOHy.createElement($280bff9ae18a48cd$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $280bff9ae18a48cd$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $eJOHy.createElement($280bff9ae18a48cd$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $280bff9ae18a48cd$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $280bff9ae18a48cd$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $eJOHy.createElement($eJOHy.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $280bff9ae18a48cd$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $eJOHy.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $eJOHy.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $eJOHy.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $280bff9ae18a48cd$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $280bff9ae18a48cd$export$e7b0ac011bb776c6) && (0, $ddbcJ.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $ddbcJ.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $280bff9ae18a48cd$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $280bff9ae18a48cd$export$daf73786167a7f72(matches) {
    return $280bff9ae18a48cd$var$_renderMatches(matches);
}
function $280bff9ae18a48cd$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $eJOHy.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $eJOHy.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $eJOHy.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $280bff9ae18a48cd$export$f30f7e456d254e83(routes, opts) {
    return (0, $ddbcJ.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $280bff9ae18a48cd$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $ddbcJ.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $280bff9ae18a48cd$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});
parcelRegister("ddbcJ", function(module, exports) {
$parcel$export(module.exports, "Action", () => $99e52e32e89932ac$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $99e52e32e89932ac$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $99e52e32e89932ac$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $99e52e32e89932ac$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "UNSAFE_invariant", () => $99e52e32e89932ac$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $99e52e32e89932ac$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $99e52e32e89932ac$export$b69e3301ce081aa3);
$parcel$export(module.exports, "UNSAFE_decodePath", () => $99e52e32e89932ac$export$30d21fd6d7295f52);
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", () => $99e52e32e89932ac$export$b3fac024fad9e8ff);
$parcel$export(module.exports, "joinPaths", () => $99e52e32e89932ac$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $99e52e32e89932ac$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", () => $99e52e32e89932ac$export$a5784978eca585fa);
$parcel$export(module.exports, "resolveTo", () => $99e52e32e89932ac$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $99e52e32e89932ac$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "isRouteErrorResponse", () => $99e52e32e89932ac$export$972111febbeef05b);
$parcel$export(module.exports, "IDLE_BLOCKER", () => $99e52e32e89932ac$export$386d57f03f0b2883);
$parcel$export(module.exports, "createRouter", () => $99e52e32e89932ac$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.21.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $99e52e32e89932ac$var$_extends() {
    $99e52e32e89932ac$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $99e52e32e89932ac$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $99e52e32e89932ac$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($99e52e32e89932ac$export$e19cd5f9376f8cee || ($99e52e32e89932ac$export$e19cd5f9376f8cee = {}));
const $99e52e32e89932ac$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $99e52e32e89932ac$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $99e52e32e89932ac$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $99e52e32e89932ac$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $99e52e32e89932ac$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $99e52e32e89932ac$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $99e52e32e89932ac$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $99e52e32e89932ac$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $99e52e32e89932ac$export$fe53371bee54353d(to);
    }
    return $99e52e32e89932ac$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $99e52e32e89932ac$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $99e52e32e89932ac$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $99e52e32e89932ac$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $99e52e32e89932ac$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $99e52e32e89932ac$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $99e52e32e89932ac$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $99e52e32e89932ac$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $99e52e32e89932ac$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $99e52e32e89932ac$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $99e52e32e89932ac$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $99e52e32e89932ac$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $99e52e32e89932ac$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $99e52e32e89932ac$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $99e52e32e89932ac$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $99e52e32e89932ac$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $99e52e32e89932ac$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $99e52e32e89932ac$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($99e52e32e89932ac$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Push;
        let location = $99e52e32e89932ac$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $99e52e32e89932ac$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $99e52e32e89932ac$export$e19cd5f9376f8cee.Replace;
        let location = $99e52e32e89932ac$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $99e52e32e89932ac$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $99e52e32e89932ac$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $99e52e32e89932ac$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($99e52e32e89932ac$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($99e52e32e89932ac$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $99e52e32e89932ac$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($99e52e32e89932ac$var$ResultType || ($99e52e32e89932ac$var$ResultType = {}));
const $99e52e32e89932ac$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $99e52e32e89932ac$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $99e52e32e89932ac$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $99e52e32e89932ac$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $99e52e32e89932ac$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($99e52e32e89932ac$var$isIndexRoute(route)) {
            let indexRoute = $99e52e32e89932ac$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $99e52e32e89932ac$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $99e52e32e89932ac$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $99e52e32e89932ac$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $99e52e32e89932ac$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $99e52e32e89932ac$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $99e52e32e89932ac$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $99e52e32e89932ac$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $99e52e32e89932ac$var$flattenRoutes(routes);
    $99e52e32e89932ac$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $99e52e32e89932ac$export$30d21fd6d7295f52(pathname);
        matches = $99e52e32e89932ac$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $99e52e32e89932ac$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $99e52e32e89932ac$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $99e52e32e89932ac$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $99e52e32e89932ac$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $99e52e32e89932ac$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $99e52e32e89932ac$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $99e52e32e89932ac$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $99e52e32e89932ac$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $99e52e32e89932ac$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $99e52e32e89932ac$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $99e52e32e89932ac$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $99e52e32e89932ac$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $99e52e32e89932ac$var$paramRe = /^:[\w-]+$/;
const $99e52e32e89932ac$var$dynamicSegmentValue = 3;
const $99e52e32e89932ac$var$indexRouteValue = 2;
const $99e52e32e89932ac$var$emptySegmentValue = 1;
const $99e52e32e89932ac$var$staticSegmentValue = 10;
const $99e52e32e89932ac$var$splatPenalty = -2;
const $99e52e32e89932ac$var$isSplat = (s)=>s === "*";
function $99e52e32e89932ac$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($99e52e32e89932ac$var$isSplat)) initialScore += $99e52e32e89932ac$var$splatPenalty;
    if (index) initialScore += $99e52e32e89932ac$var$indexRouteValue;
    return segments.filter((s)=>!$99e52e32e89932ac$var$isSplat(s)).reduce((score, segment)=>score + ($99e52e32e89932ac$var$paramRe.test(segment) ? $99e52e32e89932ac$var$dynamicSegmentValue : segment === "" ? $99e52e32e89932ac$var$emptySegmentValue : $99e52e32e89932ac$var$staticSegmentValue), initialScore);
}
function $99e52e32e89932ac$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $99e52e32e89932ac$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $99e52e32e89932ac$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $99e52e32e89932ac$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $99e52e32e89932ac$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $99e52e32e89932ac$export$a5c6d149b50c1d86($99e52e32e89932ac$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $99e52e32e89932ac$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $99e52e32e89932ac$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $99e52e32e89932ac$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $99e52e32e89932ac$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $99e52e32e89932ac$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $99e52e32e89932ac$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $99e52e32e89932ac$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $99e52e32e89932ac$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $99e52e32e89932ac$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $99e52e32e89932ac$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $99e52e32e89932ac$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $99e52e32e89932ac$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $99e52e32e89932ac$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $99e52e32e89932ac$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $99e52e32e89932ac$var$normalizeSearch(search),
        hash: $99e52e32e89932ac$var$normalizeHash(hash)
    };
}
function $99e52e32e89932ac$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $99e52e32e89932ac$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $99e52e32e89932ac$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $99e52e32e89932ac$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $99e52e32e89932ac$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $99e52e32e89932ac$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $99e52e32e89932ac$export$8ccf933b0513f8d0(toArg);
    else {
        to = $99e52e32e89932ac$var$_extends({}, toArg);
        $99e52e32e89932ac$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $99e52e32e89932ac$var$getInvalidPathError("?", "pathname", "search", to));
        $99e52e32e89932ac$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $99e52e32e89932ac$var$getInvalidPathError("#", "pathname", "hash", to));
        $99e52e32e89932ac$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $99e52e32e89932ac$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $99e52e32e89932ac$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $99e52e32e89932ac$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $99e52e32e89932ac$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $99e52e32e89932ac$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $99e52e32e89932ac$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $99e52e32e89932ac$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $99e52e32e89932ac$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $99e52e32e89932ac$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $99e52e32e89932ac$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $99e52e32e89932ac$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $99e52e32e89932ac$export$4051a07651545597(data, init) {
    return new $99e52e32e89932ac$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $99e52e32e89932ac$export$42a99a7a4bc0e76a extends Error {
}
class $99e52e32e89932ac$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $99e52e32e89932ac$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $99e52e32e89932ac$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $99e52e32e89932ac$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $99e52e32e89932ac$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $99e52e32e89932ac$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $99e52e32e89932ac$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $99e52e32e89932ac$var$unwrapTrackedPromise(value) {
    if (!$99e52e32e89932ac$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $99e52e32e89932ac$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $99e52e32e89932ac$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $99e52e32e89932ac$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $99e52e32e89932ac$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $99e52e32e89932ac$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $99e52e32e89932ac$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $99e52e32e89932ac$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $99e52e32e89932ac$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $99e52e32e89932ac$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $99e52e32e89932ac$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $99e52e32e89932ac$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $99e52e32e89932ac$var$validMutationMethods = new Set($99e52e32e89932ac$var$validMutationMethodsArr);
const $99e52e32e89932ac$var$validRequestMethodsArr = [
    "get",
    ...$99e52e32e89932ac$var$validMutationMethodsArr
];
const $99e52e32e89932ac$var$validRequestMethods = new Set($99e52e32e89932ac$var$validRequestMethodsArr);
const $99e52e32e89932ac$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $99e52e32e89932ac$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $99e52e32e89932ac$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $99e52e32e89932ac$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $99e52e32e89932ac$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $99e52e32e89932ac$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $99e52e32e89932ac$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $99e52e32e89932ac$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $99e52e32e89932ac$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $99e52e32e89932ac$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $99e52e32e89932ac$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $99e52e32e89932ac$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $99e52e32e89932ac$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $99e52e32e89932ac$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $99e52e32e89932ac$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $99e52e32e89932ac$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $99e52e32e89932ac$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$99e52e32e89932ac$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$99e52e32e89932ac$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $99e52e32e89932ac$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $99e52e32e89932ac$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $99e52e32e89932ac$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $99e52e32e89932ac$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$99e52e32e89932ac$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($99e52e32e89932ac$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $99e52e32e89932ac$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $99e52e32e89932ac$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $99e52e32e89932ac$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $99e52e32e89932ac$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $99e52e32e89932ac$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $99e52e32e89932ac$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $99e52e32e89932ac$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($99e52e32e89932ac$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $99e52e32e89932ac$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $99e52e32e89932ac$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $99e52e32e89932ac$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $99e52e32e89932ac$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $99e52e32e89932ac$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $99e52e32e89932ac$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $99e52e32e89932ac$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $99e52e32e89932ac$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $99e52e32e89932ac$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $99e52e32e89932ac$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $99e52e32e89932ac$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $99e52e32e89932ac$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $99e52e32e89932ac$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $99e52e32e89932ac$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $99e52e32e89932ac$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $99e52e32e89932ac$var$findNearestBoundary(matches).route.id,
            {
                type: $99e52e32e89932ac$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $99e52e32e89932ac$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($99e52e32e89932ac$var$isErrorResult(result) && $99e52e32e89932ac$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $99e52e32e89932ac$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $99e52e32e89932ac$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $99e52e32e89932ac$var$_extends({
            matches: updatedMatches || matches
        }, $99e52e32e89932ac$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $99e52e32e89932ac$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $99e52e32e89932ac$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $99e52e32e89932ac$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $99e52e32e89932ac$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $99e52e32e89932ac$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $99e52e32e89932ac$var$ResultType.error,
            error: $99e52e32e89932ac$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($99e52e32e89932ac$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $99e52e32e89932ac$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($99e52e32e89932ac$var$isDeferredResult(result)) throw $99e52e32e89932ac$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($99e52e32e89932ac$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $99e52e32e89932ac$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $99e52e32e89932ac$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $99e52e32e89932ac$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $99e52e32e89932ac$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($99e52e32e89932ac$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $99e52e32e89932ac$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $99e52e32e89932ac$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $99e52e32e89932ac$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $99e52e32e89932ac$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $99e52e32e89932ac$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $99e52e32e89932ac$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $99e52e32e89932ac$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $99e52e32e89932ac$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $99e52e32e89932ac$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $99e52e32e89932ac$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$99e52e32e89932ac$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $99e52e32e89932ac$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $99e52e32e89932ac$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $99e52e32e89932ac$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $99e52e32e89932ac$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $99e52e32e89932ac$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $99e52e32e89932ac$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $99e52e32e89932ac$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $99e52e32e89932ac$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $99e52e32e89932ac$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $99e52e32e89932ac$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $99e52e32e89932ac$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $99e52e32e89932ac$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($99e52e32e89932ac$var$isRedirectResult(actionResult) || $99e52e32e89932ac$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $99e52e32e89932ac$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($99e52e32e89932ac$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $99e52e32e89932ac$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $99e52e32e89932ac$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($99e52e32e89932ac$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($99e52e32e89932ac$var$isDeferredResult(actionResult)) throw $99e52e32e89932ac$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $99e52e32e89932ac$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $99e52e32e89932ac$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $99e52e32e89932ac$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $99e52e32e89932ac$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $99e52e32e89932ac$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $99e52e32e89932ac$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $99e52e32e89932ac$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $99e52e32e89932ac$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $99e52e32e89932ac$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $99e52e32e89932ac$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $99e52e32e89932ac$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $99e52e32e89932ac$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $99e52e32e89932ac$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $99e52e32e89932ac$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $99e52e32e89932ac$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $99e52e32e89932ac$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($99e52e32e89932ac$var$isDeferredResult(result)) result = await $99e52e32e89932ac$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $99e52e32e89932ac$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($99e52e32e89932ac$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $99e52e32e89932ac$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($99e52e32e89932ac$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $99e52e32e89932ac$export$3e9cee6b33872309(!$99e52e32e89932ac$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $99e52e32e89932ac$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $99e52e32e89932ac$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $99e52e32e89932ac$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $99e52e32e89932ac$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($99e52e32e89932ac$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $99e52e32e89932ac$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $99e52e32e89932ac$export$e19cd5f9376f8cee.Replace : $99e52e32e89932ac$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $99e52e32e89932ac$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($99e52e32e89932ac$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $99e52e32e89932ac$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $99e52e32e89932ac$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $99e52e32e89932ac$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $99e52e32e89932ac$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $99e52e32e89932ac$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($99e52e32e89932ac$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $99e52e32e89932ac$var$ResultType.redirect,
                response: $99e52e32e89932ac$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $99e52e32e89932ac$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $99e52e32e89932ac$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $99e52e32e89932ac$var$ResultType.error,
                    error: $99e52e32e89932ac$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $99e52e32e89932ac$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $99e52e32e89932ac$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $99e52e32e89932ac$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $99e52e32e89932ac$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $99e52e32e89932ac$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $99e52e32e89932ac$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $99e52e32e89932ac$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $99e52e32e89932ac$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $99e52e32e89932ac$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $99e52e32e89932ac$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $99e52e32e89932ac$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $99e52e32e89932ac$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $99e52e32e89932ac$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $99e52e32e89932ac$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$99e52e32e89932ac$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $99e52e32e89932ac$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $99e52e32e89932ac$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $99e52e32e89932ac$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $99e52e32e89932ac$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $99e52e32e89932ac$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $99e52e32e89932ac$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $99e52e32e89932ac$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $99e52e32e89932ac$export$4d0306f8f6a4585b = Symbol("deferred");
function $99e52e32e89932ac$export$3336b097a6fbc59a(routes, opts) {
    $99e52e32e89932ac$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $99e52e32e89932ac$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $99e52e32e89932ac$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $99e52e32e89932ac$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $99e52e32e89932ac$var$createLocation("", $99e52e32e89932ac$export$fe53371bee54353d(url), null, "default");
        let matches = $99e52e32e89932ac$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$99e52e32e89932ac$var$isValidMethod(method) && method !== "HEAD") {
            let error = $99e52e32e89932ac$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $99e52e32e89932ac$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $99e52e32e89932ac$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $99e52e32e89932ac$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($99e52e32e89932ac$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $99e52e32e89932ac$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $99e52e32e89932ac$var$createLocation("", $99e52e32e89932ac$export$fe53371bee54353d(url), null, "default");
        let matches = $99e52e32e89932ac$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$99e52e32e89932ac$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $99e52e32e89932ac$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $99e52e32e89932ac$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $99e52e32e89932ac$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $99e52e32e89932ac$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $99e52e32e89932ac$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($99e52e32e89932ac$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$99e52e32e89932ac$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $99e52e32e89932ac$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($99e52e32e89932ac$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $99e52e32e89932ac$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $99e52e32e89932ac$var$isResponse(result) ? result : $99e52e32e89932ac$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($99e52e32e89932ac$var$isDataStrategyResult(e) && $99e52e32e89932ac$var$isResponse(e.result)) {
                if (e.type === $99e52e32e89932ac$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($99e52e32e89932ac$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $99e52e32e89932ac$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $99e52e32e89932ac$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $99e52e32e89932ac$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($99e52e32e89932ac$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($99e52e32e89932ac$var$isDeferredResult(result)) {
            let error = $99e52e32e89932ac$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $99e52e32e89932ac$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($99e52e32e89932ac$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($99e52e32e89932ac$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $99e52e32e89932ac$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $99e52e32e89932ac$var$_extends({}, context, {
                statusCode: $99e52e32e89932ac$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $99e52e32e89932ac$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $99e52e32e89932ac$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $99e52e32e89932ac$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $99e52e32e89932ac$var$isErrorResult(pendingActionResult[1]) ? $99e52e32e89932ac$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $99e52e32e89932ac$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $99e52e32e89932ac$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $99e52e32e89932ac$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $99e52e32e89932ac$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $99e52e32e89932ac$var$callDataStrategyImpl(dataStrategy || $99e52e32e89932ac$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($99e52e32e89932ac$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $99e52e32e89932ac$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($99e52e32e89932ac$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $99e52e32e89932ac$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $99e52e32e89932ac$export$fec11da027c70692(routes, context, error) {
    let newContext = $99e52e32e89932ac$var$_extends({}, context, {
        statusCode: $99e52e32e89932ac$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $99e52e32e89932ac$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $99e52e32e89932ac$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $99e52e32e89932ac$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $99e52e32e89932ac$export$cae722b0cc860f13(to ? to : ".", $99e52e32e89932ac$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $99e52e32e89932ac$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $99e52e32e89932ac$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $99e52e32e89932ac$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $99e52e32e89932ac$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $99e52e32e89932ac$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$99e52e32e89932ac$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$99e52e32e89932ac$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $99e52e32e89932ac$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $99e52e32e89932ac$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $99e52e32e89932ac$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$99e52e32e89932ac$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$99e52e32e89932ac$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $99e52e32e89932ac$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $99e52e32e89932ac$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $99e52e32e89932ac$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $99e52e32e89932ac$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $99e52e32e89932ac$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($99e52e32e89932ac$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $99e52e32e89932ac$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $99e52e32e89932ac$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $99e52e32e89932ac$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $99e52e32e89932ac$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $99e52e32e89932ac$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $99e52e32e89932ac$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $99e52e32e89932ac$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $99e52e32e89932ac$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $99e52e32e89932ac$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $99e52e32e89932ac$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($99e52e32e89932ac$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $99e52e32e89932ac$var$shouldRevalidateLoader(match, $99e52e32e89932ac$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $99e52e32e89932ac$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $99e52e32e89932ac$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $99e52e32e89932ac$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $99e52e32e89932ac$var$shouldRevalidateLoader(fetcherMatch, $99e52e32e89932ac$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $99e52e32e89932ac$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $99e52e32e89932ac$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $99e52e32e89932ac$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $99e52e32e89932ac$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $99e52e32e89932ac$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $99e52e32e89932ac$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$99e52e32e89932ac$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $99e52e32e89932ac$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $99e52e32e89932ac$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$99e52e32e89932ac$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $99e52e32e89932ac$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $99e52e32e89932ac$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $99e52e32e89932ac$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$99e52e32e89932ac$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $99e52e32e89932ac$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $99e52e32e89932ac$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $99e52e32e89932ac$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $99e52e32e89932ac$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $99e52e32e89932ac$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $99e52e32e89932ac$var$ResultType.data,
                result: undefined
            });
        };
        return $99e52e32e89932ac$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $99e52e32e89932ac$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $99e52e32e89932ac$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $99e52e32e89932ac$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $99e52e32e89932ac$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $99e52e32e89932ac$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $99e52e32e89932ac$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $99e52e32e89932ac$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($99e52e32e89932ac$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $99e52e32e89932ac$var$ResultType.error,
                error: e
            };
        }
        if (type === $99e52e32e89932ac$var$ResultType.error) return {
            type: $99e52e32e89932ac$var$ResultType.error,
            error: new $99e52e32e89932ac$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $99e52e32e89932ac$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $99e52e32e89932ac$var$ResultType.error) {
        if ($99e52e32e89932ac$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $99e52e32e89932ac$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown data() to ErrorResponse instances
            result = new $99e52e32e89932ac$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $99e52e32e89932ac$var$ResultType.error,
            error: result,
            statusCode: $99e52e32e89932ac$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($99e52e32e89932ac$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $99e52e32e89932ac$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($99e52e32e89932ac$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $99e52e32e89932ac$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $99e52e32e89932ac$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $99e52e32e89932ac$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $99e52e32e89932ac$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$99e52e32e89932ac$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $99e52e32e89932ac$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $99e52e32e89932ac$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($99e52e32e89932ac$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $99e52e32e89932ac$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $99e52e32e89932ac$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($99e52e32e89932ac$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $99e52e32e89932ac$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $99e52e32e89932ac$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $99e52e32e89932ac$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $99e52e32e89932ac$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $99e52e32e89932ac$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $99e52e32e89932ac$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $99e52e32e89932ac$export$3e9cee6b33872309(!$99e52e32e89932ac$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($99e52e32e89932ac$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $99e52e32e89932ac$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $99e52e32e89932ac$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($99e52e32e89932ac$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $99e52e32e89932ac$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $99e52e32e89932ac$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $99e52e32e89932ac$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($99e52e32e89932ac$var$isErrorResult(result)) {
            let boundaryMatch = $99e52e32e89932ac$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $99e52e32e89932ac$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($99e52e32e89932ac$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $99e52e32e89932ac$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($99e52e32e89932ac$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $99e52e32e89932ac$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $99e52e32e89932ac$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $99e52e32e89932ac$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $99e52e32e89932ac$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $99e52e32e89932ac$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $99e52e32e89932ac$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $99e52e32e89932ac$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $99e52e32e89932ac$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $99e52e32e89932ac$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $99e52e32e89932ac$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $99e52e32e89932ac$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($99e52e32e89932ac$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $99e52e32e89932ac$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $99e52e32e89932ac$export$8ccf933b0513f8d0(path) : path;
    return $99e52e32e89932ac$export$fe53371bee54353d($99e52e32e89932ac$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $99e52e32e89932ac$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $99e52e32e89932ac$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $99e52e32e89932ac$var$ResultType.data || result.type === $99e52e32e89932ac$var$ResultType.error);
}
function $99e52e32e89932ac$var$isRedirectDataStrategyResultResult(result) {
    return $99e52e32e89932ac$var$isResponse(result.result) && $99e52e32e89932ac$var$redirectStatusCodes.has(result.result.status);
}
function $99e52e32e89932ac$var$isDeferredResult(result) {
    return result.type === $99e52e32e89932ac$var$ResultType.deferred;
}
function $99e52e32e89932ac$var$isErrorResult(result) {
    return result.type === $99e52e32e89932ac$var$ResultType.error;
}
function $99e52e32e89932ac$var$isRedirectResult(result) {
    return (result && result.type) === $99e52e32e89932ac$var$ResultType.redirect;
}
function $99e52e32e89932ac$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $99e52e32e89932ac$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $99e52e32e89932ac$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $99e52e32e89932ac$var$isRedirectResponse(result) {
    if (!$99e52e32e89932ac$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $99e52e32e89932ac$var$isValidMethod(method) {
    return $99e52e32e89932ac$var$validRequestMethods.has(method.toLowerCase());
}
function $99e52e32e89932ac$var$isMutationMethod(method) {
    return $99e52e32e89932ac$var$validMutationMethods.has(method.toLowerCase());
}
async function $99e52e32e89932ac$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$99e52e32e89932ac$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($99e52e32e89932ac$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $99e52e32e89932ac$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $99e52e32e89932ac$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($99e52e32e89932ac$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $99e52e32e89932ac$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $99e52e32e89932ac$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $99e52e32e89932ac$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $99e52e32e89932ac$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $99e52e32e89932ac$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $99e52e32e89932ac$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $99e52e32e89932ac$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $99e52e32e89932ac$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $99e52e32e89932ac$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $99e52e32e89932ac$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $99e52e32e89932ac$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $99e52e32e89932ac$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $99e52e32e89932ac$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $99e52e32e89932ac$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $99e52e32e89932ac$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $99e52e32e89932ac$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $99e52e32e89932ac$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $99e52e32e89932ac$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($99e52e32e89932ac$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $99e52e32e89932ac$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($99e52e32e89932ac$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $99e52e32e89932ac$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});


parcelRegister("6KRcO", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_ALLOWED_FEATURES", () => $e3a8bb51920e727f$export$a33327ada3a6ee4a);
$parcel$export(module.exports, "getAllowedFeatures", () => $e3a8bb51920e727f$export$3207c60940c4a9b0);

var $jzt0g = parcelRequire("jzt0g");
var $5WPl6 = parcelRequire("5WPl6");
var $e3a8bb51920e727f$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $e3a8bb51920e727f$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share',
        'enable-redirection',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        'template-browser',
        'inline-comments',
        'disable-publish-close-buttons'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $e3a8bb51920e727f$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $e3a8bb51920e727f$var$pageAllowedFeatures = {
    [(0, $5WPl6.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $e3a8bb51920e727f$export$a3fda3dcee62e1cc.edit,
    [(0, $5WPl6.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $e3a8bb51920e727f$export$a3fda3dcee62e1cc.view
};
const $e3a8bb51920e727f$var$blogPostAllowedFeatures = {
    [(0, $5WPl6.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $e3a8bb51920e727f$export$a3fda3dcee62e1cc.edit,
    [(0, $5WPl6.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $e3a8bb51920e727f$export$a3fda3dcee62e1cc.view
};
const $e3a8bb51920e727f$var$whiteboardAllowedFeatures = {
    [(0, $5WPl6.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $e3a8bb51920e727f$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $5WPl6.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $e3a8bb51920e727f$export$a3fda3dcee62e1cc.whiteboard
};
const $e3a8bb51920e727f$var$contentTypeAllowedFeatures = {
    [(0, $jzt0g.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $e3a8bb51920e727f$var$pageAllowedFeatures,
    [(0, $jzt0g.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $e3a8bb51920e727f$var$blogPostAllowedFeatures,
    [(0, $jzt0g.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $e3a8bb51920e727f$var$whiteboardAllowedFeatures
};
const $e3a8bb51920e727f$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $5WPl6.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$e3a8bb51920e727f$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];

});
parcelRegister("jzt0g", function(module, exports) {
$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_CONTENT_TYPE", () => $e5fe8223f0c65bdb$export$942a5fac9b8c9dc2);
var $e5fe8223f0c65bdb$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});

});

parcelRegister("5WPl6", function(module, exports) {
$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_MODE", () => $e681171854d313ef$export$816ef638e478449a);
var $e681171854d313ef$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});

});


parcelRegister("81XbN", function(module, exports) {
$parcel$export(module.exports, "EDIT_PAGE_EMBED", () => $c3f5e7982c761811$export$e63a462ee45b57cf);
$parcel$export(module.exports, "EDIT_PAGE_V2", () => $c3f5e7982c761811$export$7b1285e36c635f1f);
$parcel$export(module.exports, "VIEW_PAGE", () => $c3f5e7982c761811$export$9257b5b55c8e2555);
$parcel$export(module.exports, "VIEW_BLOG", () => $c3f5e7982c761811$export$91f49e7b30a9d34);
$parcel$export(module.exports, "VIEW_BLOG_DATE_LEGACY", () => $c3f5e7982c761811$export$bd2c9bb170b3681d);
$parcel$export(module.exports, "WHITEBOARD", () => $c3f5e7982c761811$export$fbefbcc1445e8d74);
$parcel$export(module.exports, "namedRoutes", () => $c3f5e7982c761811$export$d4971375353d0454);
$parcel$export(module.exports, "EMBEDDED_PARENT_PRODUCTS", () => $c3f5e7982c761811$export$5c59aa0922e65f1a);
const $c3f5e7982c761811$export$e63a462ee45b57cf = {
    name: 'EDIT_PAGE_EMBED',
    pattern: '/wiki/spaces/:spaceKey/pages/edit-embed/:contentId/:contentSlug?'
};
const $c3f5e7982c761811$export$7b1285e36c635f1f = {
    name: 'EDIT_PAGE_V2',
    pattern: '/wiki/spaces/:spaceKey/pages/edit-v2/:contentId/:contentSlug?'
};
const $c3f5e7982c761811$export$65b723bb995d4fb6 = {
    name: 'SPACE_OVERVIEW',
    pattern: '/wiki/spaces/:spaceKey/overview'
};
const $c3f5e7982c761811$export$9257b5b55c8e2555 = {
    name: 'VIEW_PAGE',
    pattern: '/wiki/spaces/:spaceKey/pages/:contentId/:contentSlug?'
};
const $c3f5e7982c761811$export$91f49e7b30a9d34 = {
    name: 'VIEW_BLOG',
    pattern: '/wiki/spaces/:spaceKey/blog/:contentId/:contentSlug?'
};
const $c3f5e7982c761811$export$bd2c9bb170b3681d = {
    name: 'VIEW_BLOG_DATE_LEGACY',
    pattern: '/wiki/spaces/:spaceKey/blog/:year/:month/:day/:contentId/:contentSlug?'
};
const $c3f5e7982c761811$export$fbefbcc1445e8d74 = {
    name: 'WHITEBOARD',
    pattern: '/wiki/spaces/:spaceKey/whiteboard/:contentId/:contentSlug?'
};
const $c3f5e7982c761811$export$d4971375353d0454 = {
    EDIT_PAGE_EMBED: $c3f5e7982c761811$export$e63a462ee45b57cf,
    EDIT_PAGE_V2: $c3f5e7982c761811$export$7b1285e36c635f1f,
    SPACE_OVERVIEW: $c3f5e7982c761811$export$65b723bb995d4fb6,
    VIEW_PAGE: $c3f5e7982c761811$export$9257b5b55c8e2555,
    VIEW_BLOG: $c3f5e7982c761811$export$91f49e7b30a9d34,
    VIEW_BLOG_DATE_LEGACY: $c3f5e7982c761811$export$bd2c9bb170b3681d,
    WHITEBOARD: $c3f5e7982c761811$export$fbefbcc1445e8d74
};
const $c3f5e7982c761811$export$5c59aa0922e65f1a = {
    JSM_PORTAL: 'JSM-Portal',
    JSM: 'JSM',
    JSW: 'JSW',
    JWM: 'JWM'
};

});


parcelRegister("3c33i", function(module, exports) {
$parcel$export(module.exports, "useExperienceTracker", () => $f5cfc2501c693147$export$cdefb2a8b53f879f);

var $eJOHy = parcelRequire("eJOHy");

var $g526Y = parcelRequire("g526Y");
var $geAAj = parcelRequire("geAAj");

var $fvZrx = parcelRequire("fvZrx");

var $duSZr = parcelRequire("duSZr");
function $f5cfc2501c693147$export$cdefb2a8b53f879f() {
    const embeddedConfluenceETRef = (0, $eJOHy.useRef)();
    if (!embeddedConfluenceETRef.current) embeddedConfluenceETRef.current = new (0, $g526Y.ExperienceTracker)();
    (0, $fvZrx.useAnalytics)(embeddedConfluenceETRef.current);
    $f5cfc2501c693147$var$useExperiencesForwarding(embeddedConfluenceETRef.current);
    return embeddedConfluenceETRef.current;
}
const $f5cfc2501c693147$var$useExperiencesForwarding = (experienceTracker)=>{
    const unsubscribeRef = (0, $eJOHy.useRef)();
    // Make sure the Embeddable Pages ExperienceTrackerAPI instance forwards experence events to the embedding product.
    const embeddingProductETRef = (0, $eJOHy.useRef)();
    const embeddingProductET = (0, $eJOHy.useContext)((0, $geAAj.ExperienceTrackerContext));
    if (embeddingProductETRef.current !== embeddingProductET) {
        // Cancel the old forwarding on embedding product ExperienceTrackerAPI instance change.
        if (unsubscribeRef.current) unsubscribeRef.current();
        embeddingProductETRef.current = embeddingProductET;
        // Set the new forwarding up.
        unsubscribeRef.current = (0, $duSZr.setExperiencesForwarding)(experienceTracker, embeddingProductETRef.current);
    }
    // Cancel the forwarding on unmount.
    (0, $eJOHy.useEffect)(()=>unsubscribeRef.current, []);
};

});
parcelRegister("fvZrx", function(module, exports) {
$parcel$export(module.exports, "useAnalytics", () => $a77eb8f0177c8908$export$e955abb82869dc84);

var $eJOHy = parcelRequire("eJOHy");

var $aqlRB = parcelRequire("aqlRB");

var $9N1gM = parcelRequire("9N1gM");

var $2reEA = parcelRequire("2reEA");

var $9qgTd = parcelRequire("9qgTd");
const $a77eb8f0177c8908$export$e955abb82869dc84 = (experienceTracker)=>{
    const unsubscribeRef = (0, $eJOHy.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $aqlRB.useAnalyticsEvents)();
    if (!unsubscribeRef.current && experienceTracker) unsubscribeRef.current = experienceTracker.subscribe((event)=>{
        if (event.name.startsWith((0, $9N1gM.EXPERIENCE_NAME_PREFIX))) // Fire the analytic event to dedicated ANALYTICS_CHANNEL channel for EP analytics.
        createAnalyticsEvent((0, $2reEA.createExperienceTrackerAnalyticsEventPayload)(event)).fire((0, $9qgTd.ANALYTICS_CHANNEL));
    });
    (0, $eJOHy.useEffect)(()=>unsubscribeRef.current, []);
};

});
parcelRegister("9N1gM", function(module, exports) {
$parcel$export(module.exports, "EXPERIENCE_NAME_PREFIX", () => $2fa8ab61992ce35b$export$b9fadc635fed6276);
$parcel$export(module.exports, "ExperienceNames", () => $2fa8ab61992ce35b$export$312b1a9f1141bdaa);
$parcel$export(module.exports, "ExperienceReasons", () => $2fa8ab61992ce35b$export$db5add30a8721c38);
$parcel$export(module.exports, "SupportedExperienceNames", () => $2fa8ab61992ce35b$export$ce9b20b2ad3e7bc6);
const $2fa8ab61992ce35b$export$b9fadc635fed6276 = 'embedded-confluence/';
var $2fa8ab61992ce35b$export$312b1a9f1141bdaa = /*#__PURE__*/ function(ExperienceNames) {
    ExperienceNames["VIEW_PAGE"] = "embedded-confluence/view-page";
    ExperienceNames["CC_VIEW_PAGE"] = "view-page";
    ExperienceNames["EDIT_PAGE"] = "embedded-confluence/edit-page";
    ExperienceNames["CC_EDIT_PAGE_EMBED"] = "edit-page-embed";
    ExperienceNames["WHITEBOARD"] = "embedded-confluence/whiteboard";
    ExperienceNames["CC_WHITEBOARD"] = "whiteboard-page";
    ExperienceNames["LOGIN_PAGE"] = "embedded-confluence/login-page";
    ExperienceNames["STORAGE_ACCESS_PAGE"] = "embedded-confluence/storage-access-page";
    ExperienceNames["PAGE_NOT_FOUND"] = "not-found";
    return ExperienceNames;
}({});
var $2fa8ab61992ce35b$export$db5add30a8721c38 = /*#__PURE__*/ function(ExperienceReasons) {
    ExperienceReasons["UNABLE_TO_DISPLAY_CONTENT"] = "Unable to display page content";
    ExperienceReasons["STORAGE_ACCESS_ERROR"] = "Error when obtaining Storage access";
    ExperienceReasons["STORAGE_ACCESS_NOT_SUPPORTED"] = "Storage access API is not supported";
    ExperienceReasons["STORAGE_ACCESS_REJECTED"] = "Storage access is rejected";
    return ExperienceReasons;
}({});
var $2fa8ab61992ce35b$export$ce9b20b2ad3e7bc6 = /*#__PURE__*/ function(SupportedExperienceNames) {
    SupportedExperienceNames["ADD_COMMENT"] = "add-page-comment";
    SupportedExperienceNames["DELETE_COMMENT"] = "delete-page-comment";
    SupportedExperienceNames["DELETE_PAGE"] = "delete-page";
    SupportedExperienceNames["DELETE_DRAFT"] = "edit-page/revert-draft";
    SupportedExperienceNames["EDIT_CLOSE"] = "edit-page/close";
    SupportedExperienceNames["EDIT_LOAD"] = "edit-page/load";
    SupportedExperienceNames["EDIT_PAGE_EMBED"] = "embedded-confluence/edit-page";
    SupportedExperienceNames["EDIT_PUBLISH"] = "edit-page/publish";
    SupportedExperienceNames["LOGIN_PAGE"] = "embedded-confluence/login-page";
    SupportedExperienceNames["STORAGE_ACCESS_PAGE"] = "embedded-confluence/storage-access-page";
    SupportedExperienceNames["VIEW_CONTENT"] = "view-content";
    SupportedExperienceNames["VIEW_EDIT"] = "view-page/edit";
    SupportedExperienceNames["VIEW_PAGE"] = "embedded-confluence/view-page";
    return SupportedExperienceNames;
}({});

});

parcelRegister("2reEA", function(module, exports) {
$parcel$export(module.exports, "createExperienceTrackerAnalyticsEventPayload", () => $1779501cc53ddceb$export$9c05e7ef9f2c8895);
const $1779501cc53ddceb$export$9c05e7ef9f2c8895 = (event)=>({
        // Events should match the schema defined here:
        // https://hello.atlassian.net/wiki/spaces/BIZOPS/pages/387788554/Analytics+Event+Schema+for+SLA
        source: 'ui',
        actionSubject: 'ui',
        action: event.action,
        eventType: 'operational',
        attributes: $1779501cc53ddceb$var$createExperienceTrackerAnalyticsAttributes(event)
    });
function $1779501cc53ddceb$var$createExperienceTrackerAnalyticsAttributes(event) {
    const { action: action, name: name, id: id, attributes: experienceAttributes, ...rest } = event;
    const attributes = {
        ...experienceAttributes,
        ...rest,
        task: name,
        taskId: id
    };
    if (attributes.error) {
        let error;
        if (typeof attributes.error === 'string') error = new Error(attributes.error);
        else error = attributes.error;
        delete attributes.error;
        attributes.errorName = error.name;
        if (!attributes.traceId && error.traceId) attributes.traceId = error.traceId;
        attributes.errorMessage = error.message;
    }
    attributes.browserInfo = window.navigator.userAgent;
    // Matches the analytics-web-client's apdex event
    attributes.isActiveTab = document.visibilityState === 'visible';
    return attributes;
}

});

parcelRegister("9qgTd", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $7d1b4ceb35a6fd50$export$85183a312807388d);

var $fvZrx = parcelRequire("fvZrx");
const $7d1b4ceb35a6fd50$export$85183a312807388d = 'embeddedConfluence';

});


parcelRegister("duSZr", function(module, exports) {
$parcel$export(module.exports, "setExperiencesForwarding", () => $fe5fa4a0cc6aa6ba$export$7ecf150f65423c3f);
function $fe5fa4a0cc6aa6ba$export$7ecf150f65423c3f(fromExperienceTracker, toExperienceTracker) {
    if (!fromExperienceTracker || !toExperienceTracker) return;
    const cancelExperiencesForwarding = fromExperienceTracker.subscribe(({ action: action, ...options })=>{
        switch(action){
            case 'taskAbort':
                toExperienceTracker.abort({
                    ...options,
                    checkForTimeout: false
                });
                break;
            case 'taskFail':
                toExperienceTracker.fail(options);
                break;
            case 'taskStart':
                toExperienceTracker.start(options);
                break;
            case 'taskSuccess':
                toExperienceTracker.succeed(options);
                break;
        }
    });
    return cancelExperiencesForwarding;
}

});



parcelRegister("7kpAG", function(module, exports) {
$parcel$export(module.exports, "PageNotFoundEmptyState", () => $5b24ecadfa2de768$export$d3ec4d3c4e3e468c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $aMums = parcelRequire("aMums");

var $lRq8t = parcelRequire("lRq8t");

var $7xdAQ = parcelRequire("7xdAQ");

var $6BPRi = parcelRequire("6BPRi");
const $5b24ecadfa2de768$export$d3ec4d3c4e3e468c = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aMums.default), {
        header: formatMessage((0, $7xdAQ.default).emptyStateHeader),
        description: formatMessage((0, $7xdAQ.default).emptyStateDescription),
        renderImage: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $6BPRi.PageNotFoundSVG), {})
    });
};

});
parcelRegister("7xdAQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $5eafee9cbc1832a5$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $5eafee9cbc1832a5$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    emptyStateHeader: {
        defaultMessage: "We couldn't find what you're looking for",
        id: 'embedded-confluence-common.src.content.empty-state-header',
        description: 'The header message in the empty state error screen shown to the user when there is no page to render'
    },
    emptyStateDescription: {
        defaultMessage: "We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it \uD83D\uDE09",
        id: 'embedded-confluence-common.src.content.empty-state-description',
        description: 'The description message in the empty state error screen shown to the user when there is no page to render'
    }
});

});

parcelRegister("6BPRi", function(module, exports) {
$parcel$export(module.exports, "PageNotFoundSVG", () => $a9a99ed59fbfdb2b$export$7cd49dc959d58823);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ const $a9a99ed59fbfdb2b$var$styles = `{
  cls4: { fill: '#b3f5ff' },
  cls50: { fill: '#79e2f2' },
  cls228: { fill: 'url(#radial-gradient-7)' },
  cls230: { fill: 'url(#radial-gradient-9)' },
  cls240: { fill: '#c1c7d0' },
  cls242: { fill: '#dfe1e5' },
  cls245: { fill: '#172b4d' },
  cls247: { fill: '#00c7e5' },
  cls249: { fill: 'none' },
  cls250: { fill: '#72594b' },
  cls261: { opacity: 0.6 },
  cls262: { fill: '#ff8b00' },
  cls263: { fill: '#ecc19c' },
}`;
const $a9a99ed59fbfdb2b$export$7cd49dc959d58823 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "476.06",
        height: "482.63",
        viewBox: "0 0 476.06 482.63",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient",
                        x1: "319.98",
                        y1: "322.55",
                        x2: "426.85",
                        y2: "215.68",
                        gradientTransform: "translate(-227.29)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#b3f5ff",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".06",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".1"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".27",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".45",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".67"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".6",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".85"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".72",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".96"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".79",
                                stopColor: "#b3f5ff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-2",
                        x1: "7261.66",
                        y1: "168.49",
                        x2: "7391.94",
                        y2: "38.21",
                        gradientTransform: "matrix(-1 0 0 1 7632.29 0)",
                        xlinkHref: "#linear-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-3",
                        x1: "146.17",
                        y1: "164.89",
                        x2: "239.99",
                        y2: "71.07",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#00c7e5"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#b3f5ff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-4",
                        x1: "782.51",
                        y1: "-1187.31",
                        x2: "790.62",
                        y2: "-1204.87",
                        gradientTransform: "rotate(-24.78 3495.39 868.508)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".25",
                                stopColor: "#00b8d9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#79e2f2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-5",
                        x1: "5.81",
                        y1: "472.52",
                        x2: "5.81",
                        y2: "284.67",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".43",
                                stopColor: "#b3f5ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#79e2f2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-6",
                        x1: "8.47",
                        y1: "472.52",
                        x2: "8.47",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-7",
                        x1: "69.15",
                        y1: "472.52",
                        x2: "69.15",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-8",
                        x1: "63.61",
                        y1: "472.52",
                        x2: "63.61",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-9",
                        x1: "67.33",
                        y1: "472.52",
                        x2: "67.33",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-10",
                        x1: "68.21",
                        y1: "472.52",
                        x2: "68.21",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-11",
                        x1: "68.78",
                        y1: "472.52",
                        x2: "68.78",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-12",
                        x1: "69.36",
                        y1: "472.52",
                        x2: "69.36",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-13",
                        x1: "52.51",
                        y1: "472.52",
                        x2: "52.51",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-14",
                        x1: "56.67",
                        y1: "472.52",
                        x2: "56.67",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-15",
                        x1: "54.47",
                        y1: "472.52",
                        x2: "54.47",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-16",
                        x1: "60.3",
                        y1: "472.52",
                        x2: "60.3",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-17",
                        x1: "62.16",
                        y1: "472.52",
                        x2: "62.16",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-18",
                        x1: "58.5",
                        y1: "472.52",
                        x2: "58.5",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-19",
                        x1: "66.35",
                        y1: "472.52",
                        x2: "66.35",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-20",
                        x1: "3.23",
                        y1: "472.52",
                        x2: "3.23",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-21",
                        x1: "160.2",
                        y1: "472.52",
                        x2: "160.2",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-22",
                        x1: "71.2",
                        y1: "472.52",
                        x2: "71.2",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-23",
                        x1: "271.02",
                        y1: "472.52",
                        x2: "271.02",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-24",
                        x1: "4.82",
                        y1: "472.52",
                        x2: "4.82",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-25",
                        x1: "69.36",
                        y1: "472.52",
                        x2: "69.36",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-26",
                        x1: "195.3",
                        y1: "472.52",
                        x2: "195.3",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-27",
                        x1: "3.53",
                        y1: "472.52",
                        x2: "3.53",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-28",
                        x1: "3.37",
                        y1: "472.52",
                        x2: "3.37",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-29",
                        x1: "4.07",
                        y1: "472.52",
                        x2: "4.07",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-30",
                        x1: "273.13",
                        y1: "472.52",
                        x2: "273.13",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-31",
                        x1: "273.13",
                        y1: "462.4",
                        x2: "273.13",
                        y2: "337.02",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".31",
                                stopColor: "#b3f5ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".79",
                                stopColor: "#79e2f2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-32",
                        x1: "220.7",
                        y1: "472.52",
                        x2: "220.7",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-33",
                        x1: "220.7",
                        y1: "462.4",
                        x2: "220.7",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-34",
                        x1: "185.46",
                        y1: "472.52",
                        x2: "185.46",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-35",
                        x1: "185.46",
                        y1: "402.18",
                        x2: "185.46",
                        y2: "337.02",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#b3f5ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".05",
                                stopColor: "#abf2fd"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".22",
                                stopColor: "#95ebf8"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".4",
                                stopColor: "#85e6f5"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".61",
                                stopColor: "#7ce3f3"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".91",
                                stopColor: "#79e2f2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-36",
                        x1: "148.26",
                        y1: "472.52",
                        x2: "148.26",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-37",
                        x1: "148.26",
                        y1: "402.18",
                        x2: "148.26",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-38",
                        x1: "186.02",
                        y1: "472.52",
                        x2: "186.02",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-39",
                        x1: "186.02",
                        y1: "462.4",
                        x2: "186.02",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-40",
                        x1: "186.02",
                        y1: "402.18",
                        x2: "186.02",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-41",
                        x1: "214.14",
                        y1: "472.52",
                        x2: "214.14",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-42",
                        x1: "214.14",
                        y1: "462.4",
                        x2: "214.14",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-43",
                        x1: "214.14",
                        y1: "402.18",
                        x2: "214.14",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-44",
                        x1: "185.54",
                        y1: "402.18",
                        x2: "185.54",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-45",
                        x1: "338.36",
                        y1: "472.52",
                        x2: "338.36",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-46",
                        x1: "338.36",
                        y1: "402.18",
                        x2: "338.36",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-47",
                        x1: "283.93",
                        y1: "472.52",
                        x2: "283.93",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-48",
                        x1: "283.93",
                        y1: "462.4",
                        x2: "283.93",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-49",
                        x1: "283.93",
                        y1: "402.18",
                        x2: "283.93",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-50",
                        x1: "403.38",
                        y1: "472.52",
                        x2: "403.38",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-51",
                        x1: "396.98",
                        y1: "411.33",
                        x2: "409.97",
                        y2: "305.52",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#b3f5ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".96"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".02",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".78"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".05",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".61"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".07",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".47"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".1",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".34"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".13",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".23"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".17",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".15"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".21",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".08"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".26",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".03"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".33",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".01"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".52",
                                stopColor: "#b3f5ff",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".67",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".01"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".74",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".04"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".79",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".09"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".83",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".16"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".86",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".25"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".9",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".36"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".93",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".49"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".95",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".65"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".98",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".82"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#b3f5ff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-52",
                        x1: "2.42",
                        y1: "362.88",
                        x2: "15.41",
                        y2: "257.07",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-53",
                        x1: "3.3",
                        y1: "362.99",
                        x2: "16.29",
                        y2: "257.18",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-54",
                        x1: "4.38",
                        y1: "363.12",
                        x2: "17.37",
                        y2: "257.31",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-55",
                        x1: "1.14",
                        y1: "362.72",
                        x2: "14.13",
                        y2: "256.91",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-56",
                        x1: "5.69",
                        y1: "363.28",
                        x2: "18.68",
                        y2: "257.47",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-57",
                        x1: "1.05",
                        y1: "362.71",
                        x2: "14.04",
                        y2: "256.9",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-58",
                        x1: "10.57",
                        y1: "363.88",
                        x2: "11.95",
                        y2: "352.66",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-59",
                        x1: "1.74",
                        y1: "362.79",
                        x2: "14.73",
                        y2: "256.99",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-60",
                        x1: "171.14",
                        y1: "472.52",
                        x2: "171.14",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-61",
                        x1: "165.11",
                        y1: "382.85",
                        x2: "178.1",
                        y2: "277.05",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-62",
                        x1: "251.72",
                        y1: "472.52",
                        x2: "251.72",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-63",
                        x1: "251.72",
                        y1: "462.4",
                        x2: "251.72",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-64",
                        x1: "249.31",
                        y1: "393.2",
                        x2: "262.3",
                        y2: "287.39",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-65",
                        x1: "237.87",
                        y1: "472.52",
                        x2: "237.87",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-66",
                        x1: "237.87",
                        y1: "462.4",
                        x2: "237.87",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-67",
                        x1: "235.86",
                        y1: "391.55",
                        x2: "248.85",
                        y2: "285.74",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-68",
                        x1: "153.84",
                        y1: "472.52",
                        x2: "153.84",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-69",
                        x1: "153.84",
                        y1: "402.18",
                        x2: "153.84",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-70",
                        x1: "152.5",
                        y1: "381.31",
                        x2: "165.5",
                        y2: "275.5",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-71",
                        x1: "172.27",
                        y1: "472.52",
                        x2: "172.27",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-72",
                        x1: "172.27",
                        y1: "462.4",
                        x2: "172.27",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-73",
                        x1: "172.27",
                        y1: "402.18",
                        x2: "172.27",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-74",
                        x1: "168.95",
                        y1: "383.33",
                        x2: "181.94",
                        y2: "277.52",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-75",
                        x1: "221.37",
                        y1: "472.52",
                        x2: "221.37",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-76",
                        x1: "221.37",
                        y1: "462.4",
                        x2: "221.37",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-77",
                        x1: "221.37",
                        y1: "402.18",
                        x2: "221.37",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-78",
                        x1: "218.94",
                        y1: "389.47",
                        x2: "231.93",
                        y2: "283.66",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-79",
                        x1: "187.52",
                        y1: "472.52",
                        x2: "187.52",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-80",
                        x1: "187.52",
                        y1: "462.4",
                        x2: "187.52",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-81",
                        x1: "187.52",
                        y1: "402.18",
                        x2: "187.52",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-82",
                        x1: "184.77",
                        y1: "385.27",
                        x2: "197.76",
                        y2: "279.47",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-83",
                        x1: "180.43",
                        y1: "402.18",
                        x2: "180.43",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-84",
                        x1: "178.58",
                        y1: "384.51",
                        x2: "191.57",
                        y2: "278.7",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-85",
                        x1: "193.4",
                        y1: "402.18",
                        x2: "193.4",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-86",
                        x1: "191.37",
                        y1: "386.08",
                        x2: "204.37",
                        y2: "280.28",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-87",
                        x1: "240.98",
                        y1: "392.17",
                        x2: "253.97",
                        y2: "286.37",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-88",
                        x1: "333.44",
                        y1: "472.52",
                        x2: "333.44",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-89",
                        x1: "333.44",
                        y1: "402.18",
                        x2: "333.44",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-90",
                        x1: "329.79",
                        y1: "403.08",
                        x2: "342.78",
                        y2: "297.27",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-91",
                        x1: "283.96",
                        y1: "472.52",
                        x2: "283.96",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-92",
                        x1: "283.96",
                        y1: "462.4",
                        x2: "283.96",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-93",
                        x1: "283.96",
                        y1: "402.18",
                        x2: "283.96",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-94",
                        x1: "279.87",
                        y1: "396.95",
                        x2: "292.86",
                        y2: "291.14",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-95",
                        x1: "204.11",
                        y1: "472.52",
                        x2: "204.11",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-96",
                        x1: "184.3",
                        y1: "387.71",
                        x2: "228.81",
                        y2: "265.4",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-97",
                        x1: "197.55",
                        y1: "386.84",
                        x2: "210.54",
                        y2: "281.03",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-98",
                        x1: "375.18",
                        y1: "472.52",
                        x2: "375.18",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-99",
                        x1: "339.82",
                        y1: "444.31",
                        x2: "384.34",
                        y2: "322.01",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-100",
                        x1: "367.74",
                        y1: "407.74",
                        x2: "380.74",
                        y2: "301.93",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-101",
                        x1: "154.96",
                        y1: "472.52",
                        x2: "154.96",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-102",
                        x1: "154.96",
                        y1: "402.18",
                        x2: "154.96",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-103",
                        x1: "148.01",
                        y1: "374.5",
                        x2: "192.52",
                        y2: "252.19",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-104",
                        x1: "151.79",
                        y1: "381.22",
                        x2: "164.78",
                        y2: "275.42",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-105",
                        x1: "202.83",
                        y1: "472.52",
                        x2: "202.83",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-106",
                        x1: "202.83",
                        y1: "462.4",
                        x2: "202.83",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-107",
                        x1: "202.83",
                        y1: "402.18",
                        x2: "202.83",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-108",
                        x1: "190.53",
                        y1: "389.97",
                        x2: "235.04",
                        y2: "267.67",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-109",
                        x1: "199.1",
                        y1: "387.03",
                        x2: "212.09",
                        y2: "281.22",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-110",
                        x1: "170.79",
                        y1: "472.52",
                        x2: "170.79",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-111",
                        x1: "170.79",
                        y1: "462.4",
                        x2: "170.79",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-112",
                        x1: "170.79",
                        y1: "402.18",
                        x2: "170.79",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-113",
                        x1: "161.27",
                        y1: "379.33",
                        x2: "205.79",
                        y2: "257.02",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-114",
                        x1: "166.95",
                        y1: "383.08",
                        x2: "179.94",
                        y2: "277.28",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-115",
                        x1: "188.51",
                        y1: "472.52",
                        x2: "188.51",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-116",
                        x1: "188.51",
                        y1: "462.4",
                        x2: "188.51",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-117",
                        x1: "188.51",
                        y1: "402.18",
                        x2: "188.51",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-118",
                        x1: "177.1",
                        y1: "385.09",
                        x2: "221.61",
                        y2: "262.78",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-119",
                        x1: "184.49",
                        y1: "385.24",
                        x2: "197.49",
                        y2: "279.43",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-120",
                        x1: "181.55",
                        y1: "402.18",
                        x2: "181.55",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-121",
                        x1: "171.4",
                        y1: "383.01",
                        x2: "215.92",
                        y2: "260.71",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-122",
                        x1: "178.12",
                        y1: "384.46",
                        x2: "191.11",
                        y2: "278.65",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-123",
                        x1: "195.05",
                        y1: "402.18",
                        x2: "195.05",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-124",
                        x1: "183.47",
                        y1: "387.41",
                        x2: "227.99",
                        y2: "265.1",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-125",
                        x1: "191.39",
                        y1: "386.09",
                        x2: "204.38",
                        y2: "280.28",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-126",
                        x1: "227.14",
                        y1: "403.3",
                        x2: "271.66",
                        y2: "281",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-127",
                        x1: "240.77",
                        y1: "392.15",
                        x2: "253.76",
                        y2: "286.34",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-128",
                        x1: "334.77",
                        y1: "472.52",
                        x2: "334.77",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-129",
                        x1: "334.77",
                        y1: "402.18",
                        x2: "334.77",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-130",
                        x1: "306.53",
                        y1: "432.19",
                        x2: "351.04",
                        y2: "309.89",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-131",
                        x1: "328.83",
                        y1: "402.96",
                        x2: "341.82",
                        y2: "297.15",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-132",
                        x1: "305.41",
                        y1: "472.52",
                        x2: "305.41",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-133",
                        x1: "305.41",
                        y1: "462.4",
                        x2: "305.41",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-134",
                        x1: "305.41",
                        y1: "402.18",
                        x2: "305.41",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-135",
                        x1: "280.29",
                        y1: "422.65",
                        x2: "324.81",
                        y2: "300.34",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-136",
                        x1: "299.79",
                        y1: "399.4",
                        x2: "312.78",
                        y2: "293.59",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-137",
                        x1: "237.39",
                        y1: "472.52",
                        x2: "237.39",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-138",
                        x1: "94.24",
                        y1: "336.36",
                        x2: "382.66",
                        y2: "336.36",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-139",
                        x1: "215.63",
                        y1: "399.11",
                        x2: "260.14",
                        y2: "276.81",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-140",
                        x1: "231.06",
                        y1: "390.96",
                        x2: "244.05",
                        y2: "285.15",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-141",
                        x1: "154.66",
                        y1: "472.52",
                        x2: "154.66",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-142",
                        x1: "154.66",
                        y1: "402.18",
                        x2: "154.66",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-143",
                        x1: "94.24",
                        y1: "347.55",
                        x2: "382.66",
                        y2: "347.55",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-144",
                        x1: "146.2",
                        y1: "373.84",
                        x2: "190.71",
                        y2: "251.53",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-145",
                        x1: "150.91",
                        y1: "381.12",
                        x2: "163.9",
                        y2: "275.31",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-146",
                        x1: "168.62",
                        y1: "472.52",
                        x2: "168.62",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-147",
                        x1: "168.62",
                        y1: "462.4",
                        x2: "168.62",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-148",
                        x1: "168.62",
                        y1: "402.18",
                        x2: "168.62",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-149",
                        x1: "94.24",
                        y1: "348.31",
                        x2: "382.66",
                        y2: "348.31",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-150",
                        x1: "157.53",
                        y1: "377.96",
                        x2: "202.04",
                        y2: "255.66",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-151",
                        x1: "164.09",
                        y1: "382.73",
                        x2: "177.09",
                        y2: "276.93",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-152",
                        x1: "188.58",
                        y1: "472.52",
                        x2: "188.58",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-153",
                        x1: "188.58",
                        y1: "462.4",
                        x2: "188.58",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-154",
                        x1: "188.58",
                        y1: "402.18",
                        x2: "188.58",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-155",
                        x1: "94.24",
                        y1: "350.99",
                        x2: "382.66",
                        y2: "350.99",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-156",
                        x1: "176.21",
                        y1: "384.76",
                        x2: "220.72",
                        y2: "262.46",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-157",
                        x1: "184.32",
                        y1: "385.22",
                        x2: "197.31",
                        y2: "279.41",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-158",
                        x1: "181.71",
                        y1: "402.18",
                        x2: "181.71",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-159",
                        x1: "94.24",
                        y1: "349.53",
                        x2: "382.66",
                        y2: "349.53",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-160",
                        x1: "170.01",
                        y1: "382.51",
                        x2: "214.52",
                        y2: "260.2",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-161",
                        x1: "177.73",
                        y1: "384.41",
                        x2: "190.72",
                        y2: "278.6",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-162",
                        x1: "193.08",
                        y1: "402.18",
                        x2: "193.08",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-163",
                        x1: "94.24",
                        y1: "352.21",
                        x2: "382.66",
                        y2: "352.21",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-164",
                        x1: "180.71",
                        y1: "386.4",
                        x2: "225.23",
                        y2: "264.1",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-165",
                        x1: "189.02",
                        y1: "385.79",
                        x2: "202.01",
                        y2: "279.99",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-166",
                        x1: "94.24",
                        y1: "349.07",
                        x2: "382.66",
                        y2: "349.07",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-167",
                        x1: "225.04",
                        y1: "402.53",
                        x2: "269.55",
                        y2: "280.23",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-168",
                        x1: "240.19",
                        y1: "392.08",
                        x2: "253.18",
                        y2: "286.27",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-169",
                        x1: "335.09",
                        y1: "472.52",
                        x2: "335.09",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-170",
                        x1: "335.09",
                        y1: "402.18",
                        x2: "335.09",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-171",
                        x1: "94.24",
                        y1: "346.43",
                        x2: "382.66",
                        y2: "346.43",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-172",
                        x1: "305.17",
                        y1: "431.7",
                        x2: "349.68",
                        y2: "309.4",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-173",
                        x1: "328.53",
                        y1: "402.92",
                        x2: "341.52",
                        y2: "297.12",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-174",
                        x1: "314.18",
                        y1: "472.52",
                        x2: "314.18",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-175",
                        x1: "314.18",
                        y1: "462.4",
                        x2: "314.18",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-176",
                        x1: "314.18",
                        y1: "402.18",
                        x2: "314.18",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-177",
                        x1: "94.24",
                        y1: "347.82",
                        x2: "382.66",
                        y2: "347.82",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-178",
                        x1: "286.17",
                        y1: "424.78",
                        x2: "330.68",
                        y2: "302.48",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-179",
                        x1: "307.73",
                        y1: "400.37",
                        x2: "320.72",
                        y2: "294.56",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-180",
                        x1: "238.45",
                        y1: "472.52",
                        x2: "238.45",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-181",
                        x1: "94.24",
                        y1: "336.66",
                        x2: "382.66",
                        y2: "336.66",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-182",
                        x1: "120.57",
                        y1: "336.66",
                        x2: "356.32",
                        y2: "336.66",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-183",
                        x1: "216.19",
                        y1: "399.31",
                        x2: "260.7",
                        y2: "277.01",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-184",
                        x1: "231.95",
                        y1: "391.07",
                        x2: "244.94",
                        y2: "285.26",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-185",
                        x1: "154.01",
                        y1: "472.52",
                        x2: "154.01",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-186",
                        x1: "154.01",
                        y1: "402.18",
                        x2: "154.01",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-187",
                        x1: "94.24",
                        y1: "340.77",
                        x2: "382.66",
                        y2: "340.77",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-188",
                        x1: "120.57",
                        y1: "340.77",
                        x2: "356.32",
                        y2: "340.77",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-189",
                        x1: "143.55",
                        y1: "372.88",
                        x2: "188.07",
                        y2: "250.57",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-190",
                        x1: "149.49",
                        y1: "380.94",
                        x2: "162.48",
                        y2: "275.13",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-191",
                        x1: "164.37",
                        y1: "472.52",
                        x2: "164.37",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-192",
                        x1: "164.37",
                        y1: "462.4",
                        x2: "164.37",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-193",
                        x1: "164.37",
                        y1: "402.18",
                        x2: "164.37",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-194",
                        x1: "94.24",
                        y1: "341.24",
                        x2: "382.66",
                        y2: "341.24",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-195",
                        x1: "120.57",
                        y1: "341.24",
                        x2: "356.32",
                        y2: "341.24",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-196",
                        x1: "151.77",
                        y1: "375.87",
                        x2: "196.28",
                        y2: "253.56",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-197",
                        x1: "159.34",
                        y1: "382.15",
                        x2: "172.34",
                        y2: "276.34",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-198",
                        x1: "94.24",
                        y1: "341.91",
                        x2: "382.66",
                        y2: "341.91",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-199",
                        x1: "120.57",
                        y1: "341.91",
                        x2: "356.32",
                        y2: "341.91",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-200",
                        x1: "221.5",
                        y1: "401.25",
                        x2: "266.01",
                        y2: "278.94",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-201",
                        x1: "238.15",
                        y1: "391.83",
                        x2: "251.14",
                        y2: "286.02",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-202",
                        x1: "335.78",
                        y1: "472.52",
                        x2: "335.78",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-203",
                        x1: "335.78",
                        y1: "402.18",
                        x2: "335.78",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-204",
                        x1: "94.24",
                        y1: "340.23",
                        x2: "382.66",
                        y2: "340.23",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-205",
                        x1: "120.57",
                        y1: "340.23",
                        x2: "356.32",
                        y2: "340.23",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-206",
                        x1: "303.69",
                        y1: "431.16",
                        x2: "348.2",
                        y2: "308.86",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-207",
                        x1: "328.42",
                        y1: "402.91",
                        x2: "341.41",
                        y2: "297.1",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-208",
                        x1: "326.47",
                        y1: "472.52",
                        x2: "326.47",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-209",
                        x1: "326.47",
                        y1: "462.4",
                        x2: "326.47",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-210",
                        x1: "326.47",
                        y1: "402.18",
                        x2: "326.47",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-211",
                        x1: "94.24",
                        y1: "340.83",
                        x2: "382.66",
                        y2: "340.83",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-212",
                        x1: "120.57",
                        y1: "340.83",
                        x2: "356.32",
                        y2: "340.83",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-213",
                        x1: "294.77",
                        y1: "427.92",
                        x2: "339.28",
                        y2: "305.61",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-214",
                        x1: "318.99",
                        y1: "401.75",
                        x2: "331.98",
                        y2: "295.94",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-215",
                        x1: "105.04",
                        y1: "472.52",
                        x2: "105.04",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-216",
                        x1: "134.74",
                        y1: "472.52",
                        x2: "134.74",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-217",
                        x1: "134.74",
                        y1: "402.18",
                        x2: "134.74",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-218",
                        x1: "115.09",
                        y1: "282.96",
                        x2: "376",
                        y2: "282.96",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#b3bac5"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".85",
                                stopColor: "#ebecf0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".95",
                                stopColor: "#edeef1"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".98",
                                stopColor: "#f4f5f7"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#fafbfc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-219",
                        x1: "163.83",
                        y1: "347.6",
                        x2: "279.38",
                        y2: "232.05",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#c1c7d0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".14",
                                stopColor: "#c9ced6"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".68",
                                stopColor: "#e2e4e9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#ebecf0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-220",
                        x1: "291.34",
                        y1: "337.73",
                        x2: "291.34",
                        y2: "198.21",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".21",
                                stopColor: "#ebecf0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#fafbfc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-221",
                        x1: "219.34",
                        y1: "215.53",
                        x2: "331.33",
                        y2: "215.53",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#091e42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".18",
                                stopColor: "#091e42",
                                stopOpacity: ".85"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".5",
                                stopColor: "#091e42",
                                stopOpacity: ".45"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".66",
                                stopColor: "#091e42",
                                stopOpacity: ".2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-222",
                        x1: "4697.25",
                        y1: "308.96",
                        x2: "4793.78",
                        y2: "308.96",
                        gradientTransform: "matrix(-1 0 0 1 4935.69 0)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#091e42",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".88",
                                stopColor: "#091e42"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-223",
                        x1: "-10103.77",
                        y1: "-1179.29",
                        x2: "-10103.77",
                        y2: "-1247.52",
                        gradientTransform: "matrix(.99 -.11 .11 .99 10362.66 390.81)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".37",
                                stopColor: "#00a3bf"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".88",
                                stopColor: "#00c7e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-224",
                        x1: "197.02",
                        y1: "184.01",
                        x2: "293.47",
                        y2: "87.57",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#091e42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".13",
                                stopColor: "#091e42",
                                stopOpacity: ".85"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".36",
                                stopColor: "#091e42",
                                stopOpacity: ".45"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".48",
                                stopColor: "#091e42",
                                stopOpacity: ".2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-225",
                        x1: "294.7",
                        y1: "238.16",
                        x2: "334.79",
                        y2: "238.16",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#0065ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".12",
                                stopColor: "#0d6eff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".49",
                                stopColor: "#2f86ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".8",
                                stopColor: "#4495ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4c9aff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-226",
                        x1: "245.55",
                        y1: "299.49",
                        x2: "376",
                        y2: "299.49",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#ebecf0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".47",
                                stopColor: "#f5f6f8"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#fafbfc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-227",
                        x1: "153.96",
                        y1: "321.19",
                        x2: "337.13",
                        y2: "321.19",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#ebecf0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#dfe1e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-228",
                        x1: "115.09",
                        y1: "299.49",
                        x2: "245.55",
                        y2: "299.49",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#ebecf0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".66",
                                stopColor: "#edeef1"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".9",
                                stopColor: "#f4f5f7"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#fafbfc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-229",
                        x1: "251.12",
                        y1: "196.75",
                        x2: "347.56",
                        y2: "100.3",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#ff991f"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".08",
                                stopColor: "#ffa219"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".33",
                                stopColor: "#ffbb07"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".48",
                                stopColor: "#ffc400"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-230",
                        x1: "-2946.9",
                        y1: "-501.86",
                        x2: "-2929.95",
                        y2: "-501.86",
                        gradientTransform: "matrix(-.75 .66 .66 .75 -1698.92 2528.01)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".54",
                                stopColor: "#00b8d9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".66",
                                stopColor: "#00bddd"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#00c7e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-231",
                        x1: "913.18",
                        y1: "236.51",
                        x2: "936.34",
                        y2: "213.36",
                        gradientTransform: "matrix(-1 0 0 1 1111.25 0)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#00a3bf"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".62",
                                stopColor: "#00c7e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-232",
                        x1: "2869.84",
                        y1: "1497.87",
                        x2: "2882.64",
                        y2: "1491.62",
                        gradientTransform: "matrix(-.9 -.43 -.43 .9 3435.48 110.98)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#00a3bf"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".26",
                                stopColor: "#00a8c5"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".6",
                                stopColor: "#00b8d5"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".84",
                                stopColor: "#00c7e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "New_Gradient_Swatch_13",
                        x1: "-6136.21",
                        y1: "5146.38",
                        x2: "-6130.92",
                        y2: "5141.09",
                        gradientTransform: "matrix(1 0 0 1.52 6291.96 -7637.21)",
                        xlinkHref: "#linear-gradient-3"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "New_Gradient_Swatch_13-2",
                        x1: "-6135.75",
                        y1: "5139.64",
                        x2: "-6131.37",
                        y2: "5135.26",
                        gradientTransform: "matrix(1 0 0 1.52 6301.53 -7627.42)",
                        xlinkHref: "#linear-gradient-3"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "New_Gradient_Swatch_13-3",
                        x1: "-6135.24",
                        y1: "5133.66",
                        x2: "-6131.89",
                        y2: "5130.31",
                        gradientTransform: "matrix(1 0 0 1.52 6309.67 -7619.1)",
                        xlinkHref: "#linear-gradient-3"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-233",
                        x1: "177.32",
                        y1: "462.13",
                        x2: "177.32",
                        y2: "382.62",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".31",
                                stopColor: "#79e2f2",
                                stopOpacity: ".3"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".79",
                                stopColor: "#79e2f2",
                                stopOpacity: ".6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("linearGradient", {
                        id: "linear-gradient-234",
                        x1: "303.59",
                        y1: "388.02",
                        x2: "303.59",
                        y2: "380.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-235",
                        x1: "310.94",
                        y1: "133.6",
                        x2: "337.06",
                        y2: "186.14",
                        gradientTransform: "matrix(1 0 0 -1 0 582.59)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".31",
                                stopColor: "#79e2f2",
                                stopOpacity: ".2"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".79",
                                stopColor: "#79e2f2",
                                stopOpacity: ".6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("radialGradient", {
                        id: "radial-gradient",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        gradientTransform: "matrix(1 0 0 .19 0 315.55)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".11",
                                stopColor: "#e6fcff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".31",
                                stopColor: "#e6fcff",
                                stopOpacity: ".73"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".56",
                                stopColor: "#e6fcff",
                                stopOpacity: ".42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".77",
                                stopColor: "#e6fcff",
                                stopOpacity: ".19"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: ".92",
                                stopColor: "#e6fcff",
                                stopOpacity: ".05"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#e6fcff",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-2",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-3",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-4",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-5",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-6",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-7",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-8",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-9",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-10",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-12",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-13",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("radialGradient", {
                        id: "radial-gradient-15",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("style", {
                        children: $a9a99ed59fbfdb2b$var$styles
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                style: {
                    isolation: 'isolate'
                },
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                    id: "Layer_2",
                    "data-name": "Layer 2",
                    children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                        id: "Layer_1-2",
                        "data-name": "Layer 1",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M166.11 212.89a42.69 42.69 0 00-23.17 17.18 32 32 0 00-19.06 0c-12.17 3.89-17.61 14-18.68 16.07a27.91 27.91 0 00-12.7-.75c-11.75 2.16-15.82 11.61-28.77 19.43a62.31 62.31 0 01-20.93 7.85h199.54c.21-1.14 2-11.54-5.62-19.8-8.13-8.86-19.65-7.25-20.55-7.1-.24-2.07-2.67-20.34-19.14-29.79-13.75-7.89-27.59-4.07-30.92-3.09z",
                                fill: "url(#linear-gradient)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M281.14 34.8a52.1 52.1 0 0128.24 21 39 39 0 0123.23 0c14.84 4.75 21.47 17 22.77 19.59a34 34 0 0115.49-.91c14.31 2.63 19.27 14.11 35.07 23.68a75.76 75.76 0 0025.5 9.57H188.21c-.26-1.39-2.41-14.07 6.84-24.14 9.92-10.8 24-8.83 25-8.66.3-2.52 3.26-24.78 23.34-36.3 16.82-9.63 33.68-5.02 37.75-3.83z",
                                fill: "url(#linear-gradient-2)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-4",
                                d: "M118.71 264.49l-2.65-2.66a509.36 509.36 0 0070.25-87.4 509.23 509.23 0 0057.44-125.07l3.6 1.1a513.26 513.26 0 01-57.87 126 513.28 513.28 0 01-70.77 88.03z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.24 165.66l-88.64.34a6.53 6.53 0 01-5.13-3.07 91.69 91.69 0 01-.57-89.34 6.53 6.53 0 015.1-3.1l89.05-.34c1.84 0 2.49 1.36 1.53 3.07a91.74 91.74 0 00.16 89.34c.97 1.72.33 3.1-1.5 3.1z",
                                fill: "url(#linear-gradient-3)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M149.52 159.55a91.75 91.75 0 01-.5-82.63l81.91-.32a91.72 91.72 0 00.17 82.63z",
                                fill: "#e6fcff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M152 139.06a217.27 217.27 0 0116.17-19.35 270.57 270.57 0 0021.13 19.19z",
                                fill: "url(#linear-gradient-4)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M165.12 139a226.29 226.29 0 0121.82-25.16 264.7 264.7 0 0026.61 25z",
                                fill: "#0052cc"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M175.27 99.13c-.75 3.6-4 6.57-7.49 6.58a5.26 5.26 0 01-5.28-6.53 8.62 8.62 0 018-6.5c3.5-.02 5.5 2.84 4.77 6.45z",
                                fill: "#ffab00"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-4",
                                d: "M476.06 385.69c0-19-35.86-35.51-88-43.44a91.08 91.08 0 01-34.27-12.67C320.42 309 251 294.77 170.65 294.77 57.91 294.77 0 322.73 0 357.22c0 17 22.25 32.45 58.32 43.71 7.08 2.21 10.11 16.77 5.82 27a16 16 0 00-1.29 6.21c0 26.77 37.45 48.47 124.94 48.47 86.36 0 156.58-21.15 158.39-47.44a2.18 2.18 0 011.81-1.93 8.39 8.39 0 011-.06c59.22-3.84 127.07-27.68 127.07-47.49z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M476.06 385.69c0-19-35.86-35.51-88-43.44a91.08 91.08 0 01-34.27-12.67C320.42 309 251 294.77 170.65 294.77 57.91 294.77 0 322.73 0 357.22c0 17 22.25 32.45 58.32 43.71 7.08 2.21 10.11 16.77 5.82 27a16 16 0 00-1.29 6.21c0 26.77 37.45 48.47 124.94 48.47 86.36 0 156.58-21.15 158.39-47.44a2.18 2.18 0 011.81-1.93 8.39 8.39 0 011-.06c59.22-3.84 127.07-27.68 127.07-47.49z",
                                opacity: ".4",
                                fill: "#79e2f2"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M6.25 358.05z",
                                fill: "url(#linear-gradient-5)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M10.57 363.88a34.13 34.13 0 01-4.19-5.61 34.13 34.13 0 004.19 5.61z",
                                fill: "url(#linear-gradient-6)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M69.18 403.31c0-.11 0-.21-.05-.32.02.11.03.21.05.32z",
                                fill: "url(#linear-gradient-7)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M63.81 392.36l-.39-.3z",
                                fill: "url(#linear-gradient-8)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M67.44 397l-.22-.43z",
                                fill: "url(#linear-gradient-9)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M68.24 399l-.06-.19z",
                                fill: "url(#linear-gradient-10)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M68.83 401.28c0-.17-.07-.33-.1-.5.03.22.07.33.1.5z",
                                fill: "url(#linear-gradient-11)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M69.36 405.62z",
                                fill: "url(#linear-gradient-12)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M52.78 387.47l-.54-.15z",
                                fill: "url(#linear-gradient-13)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M56.85 388.76l-.36-.12z",
                                fill: "url(#linear-gradient-14)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M54.69 388l-.45-.13z",
                                fill: "url(#linear-gradient-15)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M60.44 390.25l-.28-.13z",
                                fill: "url(#linear-gradient-16)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M62.35 391.32l-.38-.23z",
                                fill: "url(#linear-gradient-17)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M58.76 389.5l-.51-.21z",
                                fill: "url(#linear-gradient-18)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M66.5 395.35l-.3-.44z",
                                fill: "url(#linear-gradient-19)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M3.16 347.11a20.58 20.58 0 00.13 2.24 20.58 20.58 0 01-.13-2.24z",
                                fill: "url(#linear-gradient-20)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M261.42 301.27a609.78 609.78 0 00-90.77-6.5c-46.73 0-84 4.81-111.68 12.89 51-4.09 112.85-6.49 179.48-6.49q11.55 0 22.97.1z",
                                fill: "url(#linear-gradient-21)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M72.61 389.43c13.52 1.46 23-7.28 24.46-8.66a31.57 31.57 0 0018.2 9.25 28.77 28.77 0 006.33.13L131.82 373c-46.35-1.93-87.72-5.09-121.25-9.13a59.82 59.82 0 0010.28 8.71 120.25 120.25 0 0022.79 12.05 68.6 68.6 0 006.89 2.19 39.55 39.55 0 006.15-4.29 30.07 30.07 0 0015.93 6.9z",
                                fill: "url(#linear-gradient-22)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M155.07 392.74c2.57 1.87 4.48 3.74 4.48 5.61a412.84 412.84 0 01-90.34 11.72 28.54 28.54 0 01-1.91 7.77 16 16 0 00-1.3 6.21c0 26.77 37.45 48.47 124.94 48.47s158.43-21.7 158.43-48.47v-.78c63.6-3.54 113.92-18.7 126.69-38-.21-7.4-5.85-14.4-15.75-20.65-29.28 3.34-64.08 6-102.68 7.86l17.73 29.73L301.4 385l-56.53 77.4-48.33-66.17.86-13.31z",
                                fill: "url(#linear-gradient-23)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M5.12 355.81q-.33-.71-.6-1.44.27.74.6 1.44z",
                                fill: "url(#linear-gradient-24)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M69.37 407.61v.37c-.01-.13-.01-.25 0-.37z",
                                fill: "url(#linear-gradient-25)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M192.24 426.24a32 32 0 004.63-3.2 31.16 31.16 0 003.95-3.93q-1.92-3.23-3.81-6.79c-.87-1.64-1.68-3.25-2.46-4.83-.25.51-.53 1.05-.88 1.63-.56.89-1.11 1.81-1.67 2.75q-1.16 2-2.22 3.85a33.81 33.81 0 011.82 5.95 34.18 34.18 0 01.64 4.57z",
                                fill: "url(#linear-gradient-26)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M3.67 351.54q-.17-.74-.27-1.5.11.77.27 1.5z",
                                fill: "url(#linear-gradient-27)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M3.31 344.19c0-.32.08-.63.12-.95-.04.32-.09.63-.12.95z",
                                fill: "url(#linear-gradient-28)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M4.27 353.68c-.15-.46-.29-.92-.41-1.39.14.47.26.93.41 1.39z",
                                fill: "url(#linear-gradient-29)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 375.15v87.25L301.4 385l-42.82-9.94q-6.82.07-13.71.09z",
                                fill: "url(#linear-gradient-30)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 375.15v87.25L301.4 385l-42.82-9.94q-6.82.07-13.71.09z",
                                fill: "url(#linear-gradient-31)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 375.16h-7.57l-33.48 7.77c-.25 4.19-.56 9.21-.86 13.31l48.33 66.17v-87.26z",
                                fill: "url(#linear-gradient-32)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 375.16h-7.57l-33.48 7.77c-.25 4.19-.56 9.21-.86 13.31l48.33 66.17v-87.26z",
                                fill: "url(#linear-gradient-33)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.45 381.74l.15-.48-.28-.39c.04.29.09.58.13.87z",
                                fill: "url(#linear-gradient-34)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.45 381.74l.15-.48-.28-.39c.04.29.09.58.13.87z",
                                fill: "url(#linear-gradient-35)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M131.82 373l-10.22 17.15c11.14-.95 18.69-8 19.85-9.09 0 3.89 8.26 7.79 13.62 11.68l18.15-4.21c.43-5 1-9.48 1.7-14.12q-22.15-.52-43.1-1.41z",
                                fill: "url(#linear-gradient-36)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M131.82 373l-10.22 17.15c11.14-.95 18.69-8 19.85-9.09 0 3.89 8.26 7.79 13.62 11.68l18.15-4.21c.43-5 1-9.48 1.7-14.12q-22.15-.52-43.1-1.41z",
                                fill: "url(#linear-gradient-37)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.32 380.87l.28.39c.7-2.2 1.39-4.4 2.06-6.58l-3.28-.06c.31 2.08.62 4.17.94 6.25z",
                                fill: "url(#linear-gradient-38)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.32 380.87l.28.39c.7-2.2 1.39-4.4 2.06-6.58l-3.28-.06c.31 2.08.62 4.17.94 6.25z",
                                fill: "url(#linear-gradient-39)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.32 380.87l.28.39c.7-2.2 1.39-4.4 2.06-6.58l-3.28-.06c.31 2.08.62 4.17.94 6.25z",
                                fill: "url(#linear-gradient-40)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M197.86 375c-.07 1.14-.24 4.2-.46 7.93l33.48-7.77q-16.74 0-33-.29a.57.57 0 00-.02.13z",
                                fill: "url(#linear-gradient-41)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M197.86 375c-.07 1.14-.24 4.2-.46 7.93l33.48-7.77q-16.74 0-33-.29a.57.57 0 00-.02.13z",
                                fill: "url(#linear-gradient-42)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M197.86 375c-.07 1.14-.24 4.2-.46 7.93l33.48-7.77q-16.74 0-33-.29a.57.57 0 00-.02.13z",
                                fill: "url(#linear-gradient-43)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M197.86 375a.57.57 0 010-.13 1679 1679 0 01-10.21-.18c-.67 2.18-1.36 4.38-2.06 6.58l-.15.48c0-.29-.09-.58-.13-.87-.31-2.08-.63-4.17-.94-6.25-3.17-.06-6.33-.13-9.46-.21-.67 4.64-1.27 9.14-1.7 14.12l24.18-5.61c.23-3.74.4-6.8.47-7.93z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M197.86 375a.57.57 0 010-.13 1679 1679 0 01-10.21-.18c-.67 2.18-1.36 4.38-2.06 6.58l-.15.48c0-.29-.09-.58-.13-.87-.31-2.08-.63-4.17-.94-6.25-3.17-.06-6.33-.13-9.46-.21-.67 4.64-1.27 9.14-1.7 14.12l24.18-5.61c.23-3.74.4-6.8.47-7.93z",
                                fill: "url(#linear-gradient-44)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M301.4 385l73.93 17.16-17.73-29.71q-23.31 1.11-48.32 1.78z",
                                fill: "url(#linear-gradient-45)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M301.4 385l73.93 17.16-17.73-29.71q-23.31 1.11-48.32 1.78z",
                                fill: "url(#linear-gradient-46)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M258.58 375.08L301.4 385l7.88-10.79c-16.45.46-33.39.79-50.7.87z",
                                fill: "url(#linear-gradient-47)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M258.58 375.08L301.4 385l7.88-10.79c-16.45.46-33.39.79-50.7.87z",
                                fill: "url(#linear-gradient-48)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M258.58 375.08L301.4 385l7.88-10.79c-16.45.46-33.39.79-50.7.87z",
                                fill: "url(#linear-gradient-49)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M357.6 372.45c38.6-1.83 73.4-4.52 102.68-7.86-12.11-7.65-30.58-14.18-53.33-18.94-12.88 3.28-33.93 6.1-60.46 8.17z",
                                fill: "url(#linear-gradient-50)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M357.6 372.45c38.6-1.83 73.4-4.52 102.68-7.86-12.11-7.65-30.58-14.18-53.33-18.94-12.88 3.28-33.93 6.1-60.46 8.17z",
                                fill: "url(#linear-gradient-51)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M3.86 352.29c-.07-.25-.14-.5-.19-.75.05.25.12.46.19.75z",
                                fill: "url(#linear-gradient-52)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M4.52 354.37z",
                                fill: "url(#linear-gradient-53)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M5.36 356.36l-.24-.55z",
                                fill: "url(#linear-gradient-54)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M3.16 347.11z",
                                fill: "url(#linear-gradient-55)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M6.38 358.27c0-.08-.08-.15-.13-.22s.08.14.13.22z",
                                fill: "url(#linear-gradient-56)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M3.44 343.18v.06a.64.64 0 000-.07z",
                                fill: "url(#linear-gradient-57)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                fill: "url(#linear-gradient-58)",
                                opacity: ".9",
                                d: "M10.57 363.88z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M3.4 350c0-.22-.08-.45-.11-.68.03.27.07.5.11.68z",
                                fill: "url(#linear-gradient-59)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M142.74 354.71c-52.13-3.42-86.87-9.55-86.87-16.55 0-10.73 81.74-19.43 182.58-19.43 37.22 0 71.81 1.19 100.68 3.23-19.64-8.77-46.39-15.93-77.71-20.69q-11.38-.11-23-.1c-66.63 0-128.45 2.4-179.48 6.49-29.73 8.69-48.32 21.15-55.52 35.51a.64.64 0 010 .07c0 .32-.09.63-.12.95-.09 1-.15 1.94-.15 2.92a20.58 20.58 0 00.13 2.24c0 .23.07.46.11.68q.11.76.27 1.5c.05.25.12.5.19.75.12.47.26.93.41 1.39.08.23.16.46.25.69q.27.74.6 1.44l.24.55c.28.57.58 1.13.89 1.69 0 .07.08.14.13.22a34.13 34.13 0 004.19 5.61c33.53 4 74.9 7.2 121.25 9.13z",
                                fill: "url(#linear-gradient-60)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M142.74 354.71c-52.13-3.42-86.87-9.55-86.87-16.55 0-10.73 81.74-19.43 182.58-19.43 37.22 0 71.81 1.19 100.68 3.23-19.64-8.77-46.39-15.93-77.71-20.69q-11.38-.11-23-.1c-66.63 0-128.45 2.4-179.48 6.49-29.73 8.69-48.32 21.15-55.52 35.51a.64.64 0 010 .07c0 .32-.09.63-.12.95-.09 1-.15 1.94-.15 2.92a20.58 20.58 0 00.13 2.24c0 .23.07.46.11.68q.11.76.27 1.5c.05.25.12.5.19.75.12.47.26.93.41 1.39.08.23.16.46.25.69q.27.74.6 1.44l.24.55c.28.57.58 1.13.89 1.69 0 .07.08.14.13.22a34.13 34.13 0 004.19 5.61c33.53 4 74.9 7.2 121.25 9.13z",
                                fill: "url(#linear-gradient-61)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 375.15q6.88 0 13.71-.07l-13.71-3.18z",
                                fill: "url(#linear-gradient-62)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 375.15q6.88 0 13.71-.07l-13.71-3.18z",
                                fill: "url(#linear-gradient-63)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 375.15q6.88 0 13.71-.07l-13.71-3.18z",
                                fill: "url(#linear-gradient-64)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M230.88 375.15h14v-3.25z",
                                fill: "url(#linear-gradient-65)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M230.88 375.15h14v-3.25z",
                                fill: "url(#linear-gradient-66)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M230.88 375.15h14v-3.25z",
                                fill: "url(#linear-gradient-67)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M175.85 367.91l-8.66-11.85c-8.5-.39-16.67-.84-24.45-1.35L131.82 373q20.91.87 43.1 1.4c.3-2.1.62-4.24.93-6.49z",
                                fill: "url(#linear-gradient-68)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M175.85 367.91l-8.66-11.85c-8.5-.39-16.67-.84-24.45-1.35L131.82 373q20.91.87 43.1 1.4c.3-2.1.62-4.24.93-6.49z",
                                fill: "url(#linear-gradient-69)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M175.85 367.91l-8.66-11.85c-8.5-.39-16.67-.84-24.45-1.35L131.82 373q20.91.87 43.1 1.4c.3-2.1.62-4.24.93-6.49z",
                                fill: "url(#linear-gradient-70)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.36 356.48q-5.16-.19-10.17-.42l8.66 11.85a2.36 2.36 0 000-.28c.48-3.06.98-6.81 1.51-11.15z",
                                fill: "url(#linear-gradient-71)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.36 356.48q-5.16-.19-10.17-.42l8.66 11.85a2.36 2.36 0 000-.28c.48-3.06.98-6.81 1.51-11.15z",
                                fill: "url(#linear-gradient-72)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.36 356.48q-5.16-.19-10.17-.42l8.66 11.85a2.36 2.36 0 000-.28c.48-3.06.98-6.81 1.51-11.15z",
                                fill: "url(#linear-gradient-73)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.36 356.48q-5.16-.19-10.17-.42l8.66 11.85a2.36 2.36 0 000-.28c.48-3.06.98-6.81 1.51-11.15z",
                                fill: "url(#linear-gradient-74)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M206.52 357.3l-7.39-.16-1.26 17.72q16.26.24 33 .29l14-3.25z",
                                fill: "url(#linear-gradient-75)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M206.52 357.3l-7.39-.16-1.26 17.72q16.26.24 33 .29l14-3.25z",
                                fill: "url(#linear-gradient-76)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M206.52 357.3l-7.39-.16-1.26 17.72q16.26.24 33 .29l14-3.25z",
                                fill: "url(#linear-gradient-77)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M206.52 357.3l-7.39-.16-1.26 17.72q16.26.24 33 .29l14-3.25z",
                                fill: "url(#linear-gradient-78)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M190.78 356.92l-5-.15a53.37 53.37 0 01.08 8.34 45.13 45.13 0 01-1.57 8.64c.05.29.09.58.13.87l3.28.06.55-1.75q1.25-8.01 2.53-16.01z",
                                fill: "url(#linear-gradient-79)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M190.78 356.92l-5-.15a53.37 53.37 0 01.08 8.34 45.13 45.13 0 01-1.57 8.64c.05.29.09.58.13.87l3.28.06.55-1.75q1.25-8.01 2.53-16.01z",
                                fill: "url(#linear-gradient-80)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M190.78 356.92l-5-.15a53.37 53.37 0 01.08 8.34 45.13 45.13 0 01-1.57 8.64c.05.29.09.58.13.87l3.28.06.55-1.75q1.25-8.01 2.53-16.01z",
                                fill: "url(#linear-gradient-81)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M190.78 356.92l-5-.15a53.37 53.37 0 01.08 8.34 45.13 45.13 0 01-1.57 8.64c.05.29.09.58.13.87l3.28.06.55-1.75q1.25-8.01 2.53-16.01z",
                                fill: "url(#linear-gradient-82)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M185.82 365.11a53.37 53.37 0 00-.08-8.34l-8.38-.29c-.53 4.34-1 8.09-1.47 11.15a2.36 2.36 0 010 .28c-.31 2.25-.63 4.39-.93 6.5 3.13.08 6.29.15 9.46.21 0-.29-.08-.58-.13-.87a45.13 45.13 0 001.53-8.64z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.82 365.11a53.37 53.37 0 00-.08-8.34l-8.38-.29c-.53 4.34-1 8.09-1.47 11.15a2.36 2.36 0 010 .28c-.31 2.25-.63 4.39-.93 6.5 3.13.08 6.29.15 9.46.21 0-.29-.08-.58-.13-.87a45.13 45.13 0 001.53-8.64z",
                                fill: "url(#linear-gradient-83)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.82 365.11a53.37 53.37 0 00-.08-8.34l-8.38-.29c-.53 4.34-1 8.09-1.47 11.15a2.36 2.36 0 010 .28c-.31 2.25-.63 4.39-.93 6.5 3.13.08 6.29.15 9.46.21 0-.29-.08-.58-.13-.87a45.13 45.13 0 001.53-8.64z",
                                fill: "url(#linear-gradient-84)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M190.78 356.92q-1.28 8-2.57 16l-.55 1.75c3.39.07 6.78.13 10.21.18l1.26-17.72z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M190.78 356.92q-1.28 8-2.57 16l-.55 1.75c3.39.07 6.78.13 10.21.18l1.26-17.72z",
                                fill: "url(#linear-gradient-85)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M190.78 356.92q-1.28 8-2.57 16l-.55 1.75c3.39.07 6.78.13 10.21.18l1.26-17.72z",
                                fill: "url(#linear-gradient-86)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M206.52 357.3l38.35 14.6 39.18-14.9c-14.58.4-29.86.61-45.6.61-10.89-.02-21.56-.12-31.93-.31z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M206.52 357.3l38.35 14.6 39.18-14.9c-14.58.4-29.86.61-45.6.61-10.89-.02-21.56-.12-31.93-.31z",
                                fill: "url(#linear-gradient-87)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M323.05 355.38l-13.77 18.85q25-.66 48.32-1.78l-11.11-18.63c-7.41.58-15.24 1.11-23.44 1.56z",
                                fill: "url(#linear-gradient-88)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M323.05 355.38l-13.77 18.85q25-.66 48.32-1.78l-11.11-18.63c-7.41.58-15.24 1.11-23.44 1.56z",
                                fill: "url(#linear-gradient-89)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M323.05 355.38l-13.77 18.85q25-.66 48.32-1.78l-11.11-18.63c-7.41.58-15.24 1.11-23.44 1.56z",
                                fill: "url(#linear-gradient-90)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 371.9l13.71 3.18c17.31-.13 34.25-.41 50.7-.85l13.77-18.85c-12.25.69-25.31 1.23-39 1.6z",
                                fill: "url(#linear-gradient-91)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 371.9l13.71 3.18c17.31-.13 34.25-.41 50.7-.85l13.77-18.85c-12.25.69-25.31 1.23-39 1.6z",
                                fill: "url(#linear-gradient-92)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 371.9l13.71 3.18c17.31-.13 34.25-.41 50.7-.85l13.77-18.85c-12.25.69-25.31 1.23-39 1.6z",
                                fill: "url(#linear-gradient-93)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 371.9l13.71 3.18c17.31-.13 34.25-.41 50.7-.85l13.77-18.85c-12.25.69-25.31 1.23-39 1.6z",
                                fill: "url(#linear-gradient-94)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M55.87 338.16c0 7 34.74 13.13 86.87 16.55l2.86-4.81c-31.4-2.81-51.36-7-51.36-11.74 0-8.47 64.56-15.34 144.21-15.34 46.32 0 87.52 2.32 113.9 5.94a125.83 125.83 0 00-13.22-6.8c-28.87-2-63.46-3.23-100.68-3.23-100.84 0-182.58 8.7-182.58 19.43z",
                                fill: "url(#linear-gradient-95)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M55.87 338.16c0 7 34.74 13.13 86.87 16.55l2.86-4.81c-31.4-2.81-51.36-7-51.36-11.74 0-8.47 64.56-15.34 144.21-15.34 46.32 0 87.52 2.32 113.9 5.94a125.83 125.83 0 00-13.22-6.8c-28.87-2-63.46-3.23-100.68-3.23-100.84 0-182.58 8.7-182.58 19.43z",
                                fill: "url(#linear-gradient-96)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M55.87 338.16c0 7 34.74 13.13 86.87 16.55l2.86-4.81c-31.4-2.81-51.36-7-51.36-11.74 0-8.47 64.56-15.34 144.21-15.34 46.32 0 87.52 2.32 113.9 5.94a125.83 125.83 0 00-13.22-6.8c-28.87-2-63.46-3.23-100.68-3.23-100.84 0-182.58 8.7-182.58 19.43z",
                                fill: "url(#linear-gradient-97)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M346.49 353.82c26.53-2.07 47.58-4.89 60.46-8.17q-9-1.89-18.93-3.4c-2.52-.38-5-.89-7.47-1.49-4.88 3-18.12 5.77-37.13 7.92z",
                                fill: "url(#linear-gradient-98)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M346.49 353.82c26.53-2.07 47.58-4.89 60.46-8.17q-9-1.89-18.93-3.4c-2.52-.38-5-.89-7.47-1.49-4.88 3-18.12 5.77-37.13 7.92z",
                                fill: "url(#linear-gradient-99)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M346.49 353.82c26.53-2.07 47.58-4.89 60.46-8.17q-9-1.89-18.93-3.4c-2.52-.38-5-.89-7.47-1.49-4.88 3-18.12 5.77-37.13 7.92z",
                                fill: "url(#linear-gradient-100)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M163.71 351.29q-9.57-.62-18.11-1.39l-2.86 4.81c7.78.51 15.95 1 24.45 1.35z",
                                fill: "url(#linear-gradient-101)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M163.71 351.29q-9.57-.62-18.11-1.39l-2.86 4.81c7.78.51 15.95 1 24.45 1.35z",
                                fill: "url(#linear-gradient-102)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M163.71 351.29q-9.57-.62-18.11-1.39l-2.86 4.81c7.78.51 15.95 1 24.45 1.35z",
                                fill: "url(#linear-gradient-103)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M163.71 351.29q-9.57-.62-18.11-1.39l-2.86 4.81c7.78.51 15.95 1 24.45 1.35z",
                                fill: "url(#linear-gradient-104)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z",
                                fill: "url(#linear-gradient-105)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z",
                                fill: "url(#linear-gradient-106)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z",
                                fill: "url(#linear-gradient-107)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z",
                                fill: "url(#linear-gradient-108)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z",
                                fill: "url(#linear-gradient-109)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z",
                                fill: "url(#linear-gradient-110)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z",
                                fill: "url(#linear-gradient-111)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z",
                                fill: "url(#linear-gradient-112)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z",
                                fill: "url(#linear-gradient-113)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z",
                                fill: "url(#linear-gradient-114)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z",
                                fill: "url(#linear-gradient-115)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z",
                                fill: "url(#linear-gradient-116)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z",
                                fill: "url(#linear-gradient-117)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z",
                                fill: "url(#linear-gradient-118)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z",
                                fill: "url(#linear-gradient-119)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M177.87 352.09c-.17 1.52-.34 3-.51 4.39l8.38.29c-.08-1.29-.15-2.69-.19-4.33z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-.17 1.52-.34 3-.51 4.39l8.38.29c-.08-1.29-.15-2.69-.19-4.33z",
                                fill: "url(#linear-gradient-120)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-.17 1.52-.34 3-.51 4.39l8.38.29c-.08-1.29-.15-2.69-.19-4.33z",
                                fill: "url(#linear-gradient-121)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M177.87 352.09c-.17 1.52-.34 3-.51 4.39l8.38.29c-.08-1.29-.15-2.69-.19-4.33z",
                                fill: "url(#linear-gradient-122)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M194.68 352.79l-3.21-.12-.69 4.25 8.35.22c.07-.86.13-1.73.19-2.59z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l-3.21-.12-.69 4.25 8.35.22c.07-.86.13-1.73.19-2.59z",
                                fill: "url(#linear-gradient-123)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l-3.21-.12-.69 4.25 8.35.22c.07-.86.13-1.73.19-2.59z",
                                fill: "url(#linear-gradient-124)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l-3.21-.12-.69 4.25 8.35.22c.07-.86.13-1.73.19-2.59z",
                                fill: "url(#linear-gradient-125)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M194.68 352.79l4.64 1.76 7.2 2.75c10.37.19 21 .29 31.93.29 15.74 0 31-.21 45.6-.61l12.54-4.77c-17.79.83-37.45 1.3-58.14 1.3-15.26 0-29.96-.26-43.77-.72z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l4.64 1.76 7.2 2.75c10.37.19 21 .29 31.93.29 15.74 0 31-.21 45.6-.61l12.54-4.77c-17.79.83-37.45 1.3-58.14 1.3-15.26 0-29.96-.26-43.77-.72z",
                                fill: "url(#linear-gradient-126)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l4.64 1.76 7.2 2.75c10.37.19 21 .29 31.93.29 15.74 0 31-.21 45.6-.61l12.54-4.77c-17.79.83-37.45 1.3-58.14 1.3-15.26 0-29.96-.26-43.77-.72z",
                                fill: "url(#linear-gradient-127)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M323.05 355.38c8.2-.45 16-1 23.44-1.56l-3.07-5.14q-7.73.87-16.65 1.61z",
                                fill: "url(#linear-gradient-128)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M323.05 355.38c8.2-.45 16-1 23.44-1.56l-3.07-5.14q-7.73.87-16.65 1.61z",
                                fill: "url(#linear-gradient-129)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M323.05 355.38c8.2-.45 16-1 23.44-1.56l-3.07-5.14q-7.73.87-16.65 1.61z",
                                fill: "url(#linear-gradient-130)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M323.05 355.38c8.2-.45 16-1 23.44-1.56l-3.07-5.14q-7.73.87-16.65 1.61z",
                                fill: "url(#linear-gradient-131)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z",
                                fill: "url(#linear-gradient-132)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z",
                                fill: "url(#linear-gradient-133)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z",
                                fill: "url(#linear-gradient-134)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z",
                                fill: "url(#linear-gradient-135)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z",
                                fill: "url(#linear-gradient-136)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M94.24 338.16c0 4.71 20 8.93 51.36 11.74l3.64-6.1c-17.85-1.51-28.67-3.48-28.67-5.64 0-4.77 52.78-8.64 117.88-8.64s117.87 3.87 117.87 8.64c0 1.61-6.05 3.12-16.55 4.41l3.65 6.11c19-2.15 32.25-4.88 37.13-7.92a91.39 91.39 0 01-26.8-11.18c-.45-.28-.93-.55-1.4-.82-26.38-3.62-67.58-5.94-113.9-5.94-79.65 0-144.21 6.87-144.21 15.34z",
                                fill: "url(#linear-gradient-137)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M94.24 338.16c0 4.71 20 8.93 51.36 11.74l3.64-6.1c-17.85-1.51-28.67-3.48-28.67-5.64 0-4.77 52.78-8.64 117.88-8.64s117.87 3.87 117.87 8.64c0 1.61-6.05 3.12-16.55 4.41l3.65 6.11c19-2.15 32.25-4.88 37.13-7.92a91.39 91.39 0 01-26.8-11.18c-.45-.28-.93-.55-1.4-.82-26.38-3.62-67.58-5.94-113.9-5.94-79.65 0-144.21 6.87-144.21 15.34z",
                                fill: "url(#linear-gradient-138)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M94.24 338.16c0 4.71 20 8.93 51.36 11.74l3.64-6.1c-17.85-1.51-28.67-3.48-28.67-5.64 0-4.77 52.78-8.64 117.88-8.64s117.87 3.87 117.87 8.64c0 1.61-6.05 3.12-16.55 4.41l3.65 6.11c19-2.15 32.25-4.88 37.13-7.92a91.39 91.39 0 01-26.8-11.18c-.45-.28-.93-.55-1.4-.82-26.38-3.62-67.58-5.94-113.9-5.94-79.65 0-144.21 6.87-144.21 15.34z",
                                fill: "url(#linear-gradient-139)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M94.24 338.16c0 4.71 20 8.93 51.36 11.74l3.64-6.1c-17.85-1.51-28.67-3.48-28.67-5.64 0-4.77 52.78-8.64 117.88-8.64s117.87 3.87 117.87 8.64c0 1.61-6.05 3.12-16.55 4.41l3.65 6.11c19-2.15 32.25-4.88 37.13-7.92a91.39 91.39 0 01-26.8-11.18c-.45-.28-.93-.55-1.4-.82-26.38-3.62-67.58-5.94-113.9-5.94-79.65 0-144.21 6.87-144.21 15.34z",
                                fill: "url(#linear-gradient-140)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z",
                                fill: "url(#linear-gradient-141)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z",
                                fill: "url(#linear-gradient-142)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z",
                                fill: "url(#linear-gradient-143)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z",
                                fill: "url(#linear-gradient-144)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z",
                                fill: "url(#linear-gradient-145)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-146)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-147)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-148)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-149)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-150)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-151)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-152)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-153)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-154)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-155)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-156)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-157)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z",
                                fill: "url(#linear-gradient-158)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z",
                                fill: "url(#linear-gradient-159)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z",
                                fill: "url(#linear-gradient-160)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z",
                                fill: "url(#linear-gradient-161)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z",
                                fill: "url(#linear-gradient-162)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z",
                                fill: "url(#linear-gradient-163)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z",
                                fill: "url(#linear-gradient-164)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z",
                                fill: "url(#linear-gradient-165)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M238.45 346.8c-23.18 0-44.78-.49-63-1.34l3 1.15 7.06 2.69 6.1 2.33 3.05 1.16c13.81.46 28.51.72 43.77.72 20.69 0 40.35-.47 58.14-1.3l19.88-7.58c-20.77 1.37-48.07 2.17-78 2.17z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 346.8c-23.18 0-44.78-.49-63-1.34l3 1.15 7.06 2.69 6.1 2.33 3.05 1.16c13.81.46 28.51.72 43.77.72 20.69 0 40.35-.47 58.14-1.3l19.88-7.58c-20.77 1.37-48.07 2.17-78 2.17z",
                                fill: "url(#linear-gradient-166)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 346.8c-23.18 0-44.78-.49-63-1.34l3 1.15 7.06 2.69 6.1 2.33 3.05 1.16c13.81.46 28.51.72 43.77.72 20.69 0 40.35-.47 58.14-1.3l19.88-7.58c-20.77 1.37-48.07 2.17-78 2.17z",
                                fill: "url(#linear-gradient-167)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 346.8c-23.18 0-44.78-.49-63-1.34l3 1.15 7.06 2.69 6.1 2.33 3.05 1.16c13.81.46 28.51.72 43.77.72 20.69 0 40.35-.47 58.14-1.3l19.88-7.58c-20.77 1.37-48.07 2.17-78 2.17z",
                                fill: "url(#linear-gradient-168)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z",
                                fill: "url(#linear-gradient-169)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z",
                                fill: "url(#linear-gradient-170)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z",
                                fill: "url(#linear-gradient-171)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z",
                                fill: "url(#linear-gradient-172)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z",
                                fill: "url(#linear-gradient-173)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-174)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-175)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-176)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-177)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-178)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-179)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z",
                                fill: "url(#linear-gradient-180)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z",
                                fill: "url(#linear-gradient-181)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z",
                                fill: "url(#linear-gradient-182)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z",
                                fill: "url(#linear-gradient-183)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z",
                                fill: "url(#linear-gradient-184)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-185)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-186)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-187)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-188)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-189)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-190)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-191)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-192)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-193)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-194)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-195)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-196)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-197)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z",
                                fill: "url(#linear-gradient-198)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z",
                                fill: "url(#linear-gradient-199)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z",
                                fill: "url(#linear-gradient-200)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z",
                                fill: "url(#linear-gradient-201)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-202)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-203)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-204)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-205)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-206)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-207)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-208)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-209)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-210)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-211)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-212)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-213)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-214)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M68.73 400.78z",
                                fill: "url(#radial-gradient)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M69.21 410.07z",
                                fill: "url(#radial-gradient-2)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M69.36 405.46c0-.72-.09-1.44-.18-2.15.09.69.15 1.43.18 2.15z",
                                fill: "url(#radial-gradient-3)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M69.13 403q-.12-.87-.3-1.71.17.83.3 1.71z",
                                fill: "url(#radial-gradient-4)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M69.36 405.62v2c.03-.68.03-1.34 0-2z",
                                fill: "url(#radial-gradient-5)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M63.81 392.36a12.87 12.87 0 011.23 1.1 13.64 13.64 0 011.16 1.45 13.64 13.64 0 00-1.2-1.45 12.87 12.87 0 00-1.19-1.1z",
                                fill: "url(#radial-gradient-6)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                className: "cls-228",
                                d: "M56.49 388.64z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M50.53 386.83l1.71.49-1.71-.49z",
                                fill: "url(#radial-gradient-8)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-230",
                                d: "M62 391.09q-.73-.45-1.53-.84.77.39 1.53.84z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M60.16 390.12z",
                                fill: "url(#radial-gradient-10)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                className: "cls-230",
                                d: "M58.25 389.29l-1.4-.53z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M68.18 398.84a15.81 15.81 0 00-.74-1.8 15.81 15.81 0 01.74 1.8z",
                                fill: "url(#radial-gradient-12)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M67.22 396.61a14.16 14.16 0 00-.72-1.26 14.16 14.16 0 01.72 1.26z",
                                fill: "url(#radial-gradient-13)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                className: "cls-228",
                                d: "M54.24 387.91l-1.46-.44z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M63.42 392.06z",
                                fill: "url(#radial-gradient-15)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M159.55 398.35c0-1.87-1.91-3.74-4.48-5.61l-40.65 9.44 7.18-12a28.77 28.77 0 01-6.33-.13 31.57 31.57 0 01-18.2-9.25c-1.46 1.38-10.94 10.12-24.46 8.66a30.07 30.07 0 01-15.93-6.89 39.55 39.55 0 01-6.15 4.29l1.71.49.54.15 1.46.44.45.13c.6.19 1.21.39 1.8.6l.36.12 1.4.53.51.21c.48.2.94.4 1.4.62l.28.13q.8.39 1.53.84l.38.23c.37.24.73.49 1.07.74l.39.3a12.87 12.87 0 011.23 1.1 13.64 13.64 0 011.16 1.45l.3.44a14.16 14.16 0 01.72 1.26l.22.43a15.81 15.81 0 01.74 1.8l.06.19c.18.57.35 1.15.49 1.75 0 .17.07.33.1.5q.18.84.3 1.71c0 .11 0 .21.05.32.09.71.15 1.43.18 2.15V408.02c0 .7-.07 1.4-.14 2.09a412.84 412.84 0 0090.33-11.76z",
                                fill: "url(#linear-gradient-215)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M141.45 381.06c-1.16 1.11-8.71 8.14-19.85 9.09l-7.18 12 40.65-9.44c-5.36-3.86-13.62-7.71-13.62-11.65z",
                                fill: "url(#linear-gradient-216)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M141.45 381.06c-1.16 1.11-8.71 8.14-19.85 9.09l-7.18 12 40.65-9.44c-5.36-3.86-13.62-7.71-13.62-11.65z",
                                fill: "url(#linear-gradient-217)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-230",
                                d: "M141.45 381.06c-1.16 1.11-8.71 8.14-19.85 9.09l-7.18 12 40.65-9.44c-5.36-3.86-13.62-7.71-13.62-11.65z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                fill: "url(#linear-gradient-218)",
                                d: "M245.54 265.79l-130.45-4.54 130.46 43.41L376 261.25l-130.46 4.54z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M239.61 200.11L154 337.73h91.59V198.21H243a4 4 0 00-3.39 1.9z",
                                fill: "url(#linear-gradient-219)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-240",
                                d: "M205.28 255.28l-3.12 5h43.39v-5h-40.27zM199.08 265.23l-3.11 5h49.58v-5h-46.47zM245.55 275.18h-52.66l-3.12 5h55.78v-5z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M251.49 200.11a4 4 0 00-3.41-1.9h-2.53v139.52h91.58z",
                                fill: "url(#linear-gradient-220)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-242",
                                d: "M245.55 255.28h20.27v5.01h-20.27zM245.55 265.23h20.27v5.01h-20.27zM245.55 275.18h4.98v5.01h-4.98z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M246.9 226.91a41 41 0 0120.1 4.17 34.66 34.66 0 004.89 1.76l-20.36-32.73a4 4 0 00-3.41-1.9h-2.53V227c.41 0 .85-.06 1.31-.09z",
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                style: {
                                    mixBlendMode: 'multiply'
                                },
                                fill: "url(#linear-gradient-221)",
                                opacity: ".1"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("ellipse", {
                                cx: "190.18",
                                cy: "308.96",
                                rx: "48.27",
                                ry: "5.8",
                                fill: "url(#linear-gradient-222)",
                                opacity: ".1"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M185.7 301.74a14 14 0 01.43 3.35 14.28 14.28 0 01-.31 3l-1.61.68-.34-.66-.57 1.09a14.39 14.39 0 01-3.08 1.26 8.93 8.93 0 01-2.56.42c-1.39 0-3.44-.35-3.53-1.06-.06-.44.67-.68 2.25-1.89a15.9 15.9 0 002.73-2.66 11.3 11.3 0 001.8-3.36l.3-.87z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M174.84 236.19c0 1.93-.39 5.85-.31 9.29.3 12.41.56 19.91 2 30.32.89 6.27 2.08 15.42 3.16 26.77a8.92 8.92 0 006.88-1c-.18-1.82-.4-4.76-.41-8.4 0-6.72.73-9.48.3-14.85a45.06 45.06 0 00-1.57-8.63q1.4-9.27 2.78-18.54a11.6 11.6 0 007-6.47 11.37 11.37 0 00-2.1-11.53z",
                                fill: "url(#linear-gradient-223)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-247",
                                d: "M196.05 302a13.43 13.43 0 00-.57 3.33 14 14 0 00.19 3l1.57.75.37-.65c.18.37.36.74.53 1.11a14.08 14.08 0 003 1.38 9.27 9.27 0 002.55.53c1.39.07 3.45-.21 3.57-.91.08-.44-.64-.71-2.18-2a16.49 16.49 0 01-2.62-2.77 11.21 11.21 0 01-1.65-3.44l-.27-.88zM192.04 238.74l-.09 4.58-8.74-4.11 8.83-.47zM191.79 237.53l1.88-.45 1.62-.19-1.63 2.37-1.87-1.73z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-247",
                                d: "M177.85 236.91q1.92 5.47 3.8 11.05 3.84 11.43 7.23 22.54l5.25 32.69 6.81-.95q-1.2-16.9-2.41-33.8c-.2-3.54-1.43-25.55-2-28.67-.1-.56-.25-1.09-.25-1.09a16.4 16.4 0 00-1.92-4.36l-1.25.63z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-4",
                                d: "M201.33 28.18l-16.94.27a13.73 13.73 0 00-13.51 13.94 13.73 13.73 0 0013.94 13.51h.78a8.27 8.27 0 018.09 5.82v.09c0 .06.11.06.12 0v-.09a8.28 8.28 0 017.9-6.08 13.71 13.71 0 0013.56-13.94 13.74 13.74 0 00-13.94-13.52zM384.25 141.53l-16.93.26a13.74 13.74 0 00-13.52 13.94 13.73 13.73 0 0013.94 13.51h.78a8.27 8.27 0 018.09 5.83v.08a.07.07 0 00.13 0v-.09a8.26 8.26 0 017.9-6.07A13.73 13.73 0 00398.19 155a13.73 13.73 0 00-13.94-13.47z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M228.71 128.46a89.94 89.94 0 00-10.59 37.28l20.12-.08c1.83 0 2.47-1.38 1.5-3.1a91.86 91.86 0 01-11.03-34.1z",
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                style: {
                                    mixBlendMode: 'multiply'
                                },
                                fill: "url(#linear-gradient-224)",
                                opacity: ".1"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-249",
                                d: "M238.24 165.66l-88.64.34a6.53 6.53 0 01-5.13-3.07 91.69 91.69 0 01-.57-89.34 6.53 6.53 0 015.1-3.1l89.05-.34c1.84 0 2.49 1.36 1.53 3.07a91.74 91.74 0 00.16 89.34c.97 1.72.33 3.1-1.5 3.1z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-242",
                                d: "M192.09 291.26l-3.44-1.53a612 612 0 0040.22-125.5A612.62 612.62 0 00241.27 45H245a615.38 615.38 0 01-12.47 120 615.64 615.64 0 01-40.44 126.26z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-250",
                                d: "M342.5 235.7c.15-.74.44-1 1.47-2.24l.88-1c2-2.42 2.53-3.68 3.34-3.68.57 0 .92 1 2 2.06 1.33 1.24 1.26 2 1.14 2.62-.18.85-2.92 4.06-4.43 4.51-.45.13-3 1.24-3.43 1-.93-.5-1.19-2.08-1-3.24"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M299.43 243.7c.3.22.77.55 1.34.92 1.68 1.08 8.57 2.84 10.74 3.75s12.52 3.33 14.57 3.06a6.65 6.65 0 001.78-.49l16.46-11.48-1.32-4.81c-7 3.08-11.64 5.5-18.65 8.58l-22.71-6.32-2.13 3.22z",
                                fill: "#2684ff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M308.31 220.59c.57-.87 1.3-2.19.83-2.85s-1.42-.18-3.85-.08c-3.5.13-3.88-.47-5.65.09a6.82 6.82 0 00-3.52 2.44c-1.68 2.39-.9 5.38-.66 6.28a10 10 0 004.55 5.8l1.9 1.21 5.37-9.24z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M302.16 236.73h7.25a13.5 13.5 0 01-.78-8.17l-4.42-.21c-.06.26-.14.63-.27 1.08a3.75 3.75 0 01-.48 1.23 2.58 2.58 0 01-1.94.84c.21 1.74.42 3.49.64 5.23",
                                fill: "#543e36"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M302.9 314.33c0-.14-2.25-.5-2.26-.65-.29-4.21-1-23.6-1.6-28.34-.89-7.08-1.73-13.77-1.27-16.81.12-.84.81-4 1.21-5.72a13.39 13.39 0 01.55-1.84 15.28 15.28 0 01.92-2l.32-.58.64.19a14.22 14.22 0 001.59.4c.45.09.82.14 1.09.17h.24c1.39.21 4.13.54 11.84 1.13h.35l.22.27a21.75 21.75 0 011.48 2.08 24.5 24.5 0 013.11 7.49c4.6 18.9 5.37 21.45 5.48 21.76v.2c.3 1.71 2.17 11.12 2.46 12.86-2.31 1.89-4.35 1.51-7.73 1.29-1.63-3.1-6.21-12.94-7.84-16.07l-3.58-6.91c0 5.11.16 22.38.13 27.49-3.05 1.27-4.25 4.1-7.41 3.55",
                                fill: "#091e42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M300.94 274.09a11.32 11.32 0 01-2.37-5 15 15 0 01.41-6.31 14.78 14.78 0 01.55-1.84 15.28 15.28 0 01.92-2l.32-.59.64.2c.52.16 1 .3 1.59.41s.82.13 1.09.16h.24c1.39.21 4.13.54 11.84 1.13h.35l.22.27a21.75 21.75 0 011.48 2.08c2.66 4.2 3.58 9.74 4.87 14.53q1.46 5.37 2.73 10.79c.21.9 2.63 8.75 1.94 9.31-2.31 1.9-5.73 2.44-9.12 2.22-1.62-3.1-3.25-6.19-4.88-9.32-2-3.78-3.64-7.36-6.79-10.31a57.06 57.06 0 01-6-5.8",
                                fill: "#253858"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-250",
                                d: "M308.31 220.59c.35.8.69 1.59 1 2.39l3.09 1.9c-.25.44-.5.88-.76 1.32l.27 4.75a11.78 11.78 0 01-3 1.6c-.42.14-.6.14-4.32.27-1.59.06-2.39.08-2.75-.36a2.08 2.08 0 01-.13-2c.24-.59.54-.54.82-1.12.43-.9-.11-1.42.17-2.27s.91-.67 1.9-1.71.9-1.95 2-3.35a6.5 6.5 0 011.69-1.45"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M311.67 226.2a1.23 1.23 0 01.4.53 1.14 1.14 0 010 .73 4.73 4.73 0 01-1.2.42 4.66 4.66 0 01-.92.09c0 .24.06.57.11 1 .14 1 .22 1.13.31 1.18.33.18 1-.2 1.28-.75a1.45 1.45 0 00.14-.64 2.26 2.26 0 01.7 1.13 2.29 2.29 0 01-.28 1.63 3 3 0 01-2.26 1.29h-.15c-4 .2-4.31.2-4.56.13-2.28-.69-2.12-7.66-2.12-8l2.54-1.52a3.32 3.32 0 00-.32 2.85c.09.21.55 1.39 1.5 1.58s1.5-.89 3.4-1.42a6.35 6.35 0 011.4-.24"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-250",
                                d: "M343 230.84s1.53 1.69.62 3.1c-.64 1 1.8 1.33 1.8 1.33a2.2 2.2 0 00.24-3.06c-1.29-1.77-2.66-2.34-2.66-1.37"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-4",
                                d: "M372.38 264.49a513.32 513.32 0 01-70.76-88 512.55 512.55 0 01-57.87-126l3.59-1.1a508.92 508.92 0 0057.45 125.07A509.3 509.3 0 00375 261.83z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-250",
                                d: "M348 228.66s-1.78 3.06-1.21 3.71 1.21-.08 1.21-.08-.73 1-.4 1.45 1.12-.32 1.12-.32-.64 1 0 1.37 1.05-.49 1.05-.49-.56 2.1 0 1.86 1.21-1 1.61-2.74-2-5.32-3.38-4.76M330.15 211.75c.29-.72-.1-1.12 0-3.88v-.51c0-1.44-.95-2-3.35-4.71-.59-.66-1.52-1.73-1.9-1.53a.67.67 0 00-.28.37c-.08.26.06.42 0 .53s-.55-.09-.73 0 .18 1.12.62 2.24c.8 2 .82 2.67.69 3.21 0 .13-.24.93-.7 1-.13 0-.3 0-.7-.34a8 8 0 01-1.14-1.27c-.52-.6-1.3-1.16-1.5-1s.13.53.27 1.39a13.9 13.9 0 010 1.62c.08.62.44 1 2.56 2.79a9.87 9.87 0 002.38 1.73 3.49 3.49 0 003.74-1.69"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M325.44 212.82c1.91 6.66 1 18.09 1 18.09s-13.3 3.32-16.49 3.61c0 0-6.81.64-10.54 2.5-.88.44-1.74.95-1.74.95-.47.28-.77.48-.77.48l-.1.06a4.93 4.93 0 00-1.9 5.56c.37 1.21.72 2.47 1.05 3.79a74.38 74.38 0 012.19 16.19 30.77 30.77 0 0021.17-1.62 99.26 99.26 0 01-1.49-11.3c-.18-2.33-.26-4.56-.28-6.67 2.38-.56 9.65-4.62 14.18-7.35a6.26 6.26 0 002.93-6.54c-1.15-6.13-2.93-16.42-4.23-19.47-3.12 1.12-4.98 1.72-4.98 1.72z",
                                fill: "url(#linear-gradient-225)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                fill: "url(#linear-gradient-226)",
                                d: "M376 261.25l-38.87 76.48-91.58-33.07L376 261.25z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-242",
                                d: "M318.63 280.34l-5 1.67v35.67h5v-37.34zM328.59 277.03l-5.01 1.66v38.99h5.01v-40.65zM338.54 273.72l-5.01 1.66v27h5.01v-28.66z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                fill: "url(#linear-gradient-227)",
                                d: "M337.13 337.73H153.96l91.59-33.07 91.58 33.07z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                fill: "url(#linear-gradient-228)",
                                d: "M245.55 304.66l-91.59 33.07-38.87-76.48 130.46 43.41z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M245.55 0a5 5 0 015 5v201.67h-5V0z",
                                fill: "#fafbfc"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                className: "cls-242",
                                d: "M245.54 0v206.67h-5V5a5 5 0 015-5z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M250 101.43a90.13 90.13 0 000 94.19h98.7a90.13 90.13 0 010-94.19z",
                                fill: "url(#linear-gradient-229)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                                className: "cls-261",
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                    className: "cls-262",
                                    d: "M306.75 128.62a6.3 6.3 0 01-5.66-3.1c-.89-1.2-1.45-2-3.23-2s-2.81.78-4.33 2c-1.75 1.38-3.86 3.1-7.17 3.1a6.29 6.29 0 01-5.66-3.1c-.89-1.2-1.45-2-3.24-2s-2.8.78-4.32 2c-1.75 1.38-3.86 3.1-7.18 3.1a6.28 6.28 0 01-5.65-3.1c-.89-1.2-1.45-2-3.23-2 .37-1.27.76-2.52 1.18-3.77 3.31 0 4.46 1.68 5.44 3 .85 1.19 1.44 2 3.22 2s2.78-.79 4.34-2c1.78-1.37 4.06-3 7.38-3s4.47 1.68 5.45 3c.85 1.19 1.44 2 3.22 2s2.78-.79 4.34-2c1.78-1.37 4.06-3 7.38-3a5.86 5.86 0 015.45 3c.85 1.19 1.44 2 3.22 2s2.79-.79 4.35-2c1.78-1.37 4.07-3 7.38-3-.42 1.25-.81 2.5-1.17 3.77-1.78 0-2.82.78-4.34 2-1.74 1.38-3.85 3.1-7.17 3.1z"
                                })
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                                className: "cls-261",
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                    className: "cls-262",
                                    d: "M304.88 140.51a7.32 7.32 0 01-6.08-3.15c-1.05-1.22-1.72-2-3.51-2s-2.7.8-4.05 2c-1.56 1.4-3.44 3.15-6.75 3.15a7.35 7.35 0 01-6.08-3.15c-1.05-1.22-1.72-2-3.51-2s-2.69.8-4 2c-1.56 1.4-3.44 3.15-6.75 3.15a7.35 7.35 0 01-6.08-3.15c-1-1.22-1.72-2-3.5-2 .19-1.3.41-2.58.66-3.87 3.31 0 4.7 1.73 5.86 3.13 1 1.22 1.71 2 3.49 2s2.68-.81 4.07-2c1.59-1.4 3.64-3.13 7-3.13s4.7 1.73 5.87 3.13c1 1.22 1.71 2 3.49 2s2.68-.81 4.07-2c1.6-1.4 3.64-3.13 7-3.13s4.71 1.73 5.87 3.13c1 1.22 1.71 2 3.49 2s2.69-.81 4.08-2c1.6-1.4 3.64-3.13 7-3.13-.24 1.29-.46 2.57-.65 3.87-1.78 0-2.71.8-4.06 2-1.73 1.4-3.61 3.15-6.93 3.15z"
                                })
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                                className: "cls-261",
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                    className: "cls-262",
                                    d: "M304.61 152.52c-3.31 0-5.11-1.75-6.5-3.16-1.21-1.23-2-2-3.78-2s-2.58.81-3.78 2c-1.37 1.41-3 3.16-6.33 3.16s-5.11-1.75-6.5-3.16c-1.22-1.23-2-2-3.78-2s-2.59.81-3.78 2c-1.37 1.41-3 3.16-6.33 3.16s-5.11-1.75-6.5-3.16c-1.21-1.23-2-2-3.77-2 0-1.3.06-2.61.14-3.91 3.31 0 4.93 1.76 6.28 3.17 1.18 1.23 2 2 3.76 2s2.57-.81 3.8-2.05c1.41-1.4 3.22-3.16 6.54-3.16s4.93 1.76 6.29 3.16c1.18 1.24 2 2.05 3.76 2.05s2.57-.81 3.8-2.05c1.41-1.4 3.22-3.16 6.54-3.16s4.94 1.76 6.29 3.16c1.18 1.24 2 2.05 3.77 2.05s2.57-.81 3.8-2.05c1.41-1.41 3.22-3.16 6.54-3.16-.07 1.3-.12 2.61-.13 3.91-1.78 0-2.6.81-3.79 2-1.37 1.45-3.02 3.2-6.34 3.2z"
                                })
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                                className: "cls-261",
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                    className: "cls-262",
                                    d: "M306 164.48c-3.32 0-5.35-1.74-6.92-3.13-1.38-1.23-2.27-2-4.06-2s-2.48.81-3.51 2c-1.18 1.4-2.59 3.14-5.91 3.14s-5.34-1.74-6.92-3.13c-1.38-1.23-2.27-2-4.05-2s-2.48.81-3.51 2c-1.18 1.4-2.59 3.14-5.91 3.14s-5.34-1.74-6.92-3.14c-1.38-1.22-2.26-2-4-2-.16-1.29-.29-2.59-.38-3.89 3.31 0 5.16 1.75 6.7 3.16 1.34 1.22 2.26 2 4 2s2.47-.81 3.53-2c1.22-1.41 2.8-3.16 6.12-3.16s5.17 1.75 6.71 3.16c1.34 1.22 2.25 2 4 2s2.46-.81 3.54-2a7.4 7.4 0 016.11-3.16c3.32 0 5.17 1.75 6.71 3.16 1.35 1.22 2.26 2 4 2s2.47-.81 3.53-2c1.22-1.41 2.8-3.16 6.12-3.16.1 1.3.23 2.6.38 3.89-1.78 0-2.48.81-3.51 2-1.18 1.38-2.59 3.12-5.85 3.12z"
                                })
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                                className: "cls-261",
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                    className: "cls-262",
                                    d: "M297.21 171.16c-1.78 0-2.37.8-3.24 2-1 1.37-2.17 3.06-5.48 3.06s-5.58-1.69-7.35-3.06c-1.54-1.19-2.53-2-4.32-2s-2.37.8-3.24 2c-1 1.37-2.17 3.06-5.48 3.06s-5.58-1.69-7.34-3.06c-1.55-1.19-2.54-2-4.32-2-.33-1.27-.63-2.54-.91-3.82 3.32 0 5.4 1.72 7.14 3.1 1.5 1.2 2.52 2 4.3 2s2.35-.79 3.26-2a6.38 6.38 0 015.69-3.1c3.31 0 5.4 1.73 7.13 3.1 1.51 1.2 2.53 2 4.31 2s2.35-.79 3.26-2a6.38 6.38 0 015.69-3.1"
                                })
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M182.26 189.82c-3.63 5.16 4.34 17.38 9.25 16.82 3.35-.38 5.2-6.62 5.37-7.19.51-1.71 1.53-5.17-.43-8.4a8.93 8.93 0 00-5.3-3.83c-3.29-.83-7.22.24-8.89 2.6z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M183 208.52l4.17 1 2.6-10.5-8.24-2.02c-.79.44-4 2.37-4.69 6-.18.92-.55 2.8.6 4.25s3.33 1.91 5.56 1.27z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M185 214.79c-3.72 1.33-6.9 2.27-9.32 2.92a48.24 48.24 0 01-6.84 1.37c-2.58.33-3.87.5-4.44.12-1.92-1.27-.92-5.22.43-16 .35-2.79.6-5.06.75-6.44.08-.62.17-1.24.25-1.86l4.48.28c-.36.73-.73 1.45-1.09 2.17q.09 7.35.17 14.7l11.43-4.33a6.71 6.71 0 011.79.42 5 5 0 012.6 2.17 5.08 5.08 0 01-.21 4.48z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M170.77 211.15l12.4-4.57a5.61 5.61 0 014 3.4 5.46 5.46 0 01-.66 4.76l-14 3.69a7.85 7.85 0 00-1.74-7.28z",
                                fill: "url(#linear-gradient-230)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M175 217c.55-2.31 1.68-1.93 3.36-5.75a8.35 8.35 0 011.9-3.26 6.41 6.41 0 012.65-1.45h5.5a4.58 4.58 0 001.57 1.64c1.52.92 2.8.45 4.8.91h.1a6 6 0 012.88 1.68 5.09 5.09 0 011.45 3 15.48 15.48 0 01-1.72 8.3 33.5 33.5 0 00-2.49 10.49c.45 1.24 1 4.27 1.48 5.52a34.78 34.78 0 01-22.07.15c2-9.74 1.61-13.49 1.16-15.16-1.11-4.31-.89-4.72-.57-6.07z",
                                fill: "url(#linear-gradient-231)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M183.33 208.07a10.5 10.5 0 003.56.61 10.74 10.74 0 004.19-.87 8.4 8.4 0 01-1-2.18 7.87 7.87 0 01-.26-2.87l-6.77.9z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M183.82 190.38a22.9 22.9 0 00-1.07 2.16 22.06 22.06 0 00-1.08 3c-.11.14-.31.4-.58.71-.83.92-1.62 1.41-1.47 1.7 0 0 .75.45.87.58s-.3 2.64.09 3.7c.79 2.16 7.2 3.64 9.76 1a4.13 4.13 0 001.07-2.3 3.3 3.3 0 00-.32-.18 3.38 3.38 0 00-2.45-.1 4.19 4.19 0 00.05-2.92c-.35-.86-.82-.95-2.89-3.07a6.6 6.6 0 01-1.62-2.1 5.08 5.08 0 01-.36-2.18z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M191 210.05a4.52 4.52 0 004.83-.1 4.18 4.18 0 001.41-3c.12-1.79-.95-2.42-1.07-4.33a6.26 6.26 0 01.73-3.2 19.22 19.22 0 01-3.22-.73 20.07 20.07 0 01-4.09-1.86 5.26 5.26 0 01-.24 2.62c-1 2.6-3.62 2.62-4.52 5a4.53 4.53 0 00.6 4.25c1.11 1.49 3.31 1.99 5.57 1.35z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M200.34 250.5c-.18 1.21-.3 2.37-.43 3.57s-.23 2.66-.47 3.74a1.2 1.2 0 01-.67.84c-.22.1-.05-.37-.18-.24s0 .54-.24.73a.16.16 0 01-.17.07c-.13 0-.19-.43-.31-.42s-.17.38-.26.48-.21.31-.4.31-.11-.31-.32-.31-.2.69-.41.65-.29-.36-.31-.77c-.08-1.29.37-2.64.42-4.14a13.93 13.93 0 00-.26-2.58 7.75 7.75 0 00-.91 1.73 3.64 3.64 0 01-.74 1.27.89.89 0 01-.66.31c-.19 0-.46 0-.45-.14a14.18 14.18 0 01.73-2.6c.51-1.55 1.32-4.23 2.95-4.6s2.28 1.16 3.09 2.1z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M199.33 214.4c.9 4.85 1.91 8.62 2.45 14.62a80.48 80.48 0 01-1.44 21.89 21 21 0 01-3-.27c.2-6.68.5-13.68-1.15-20.08-1.24-4.83-3.2-9.14-4.74-13.52-.84-2.4-.6-3.89 1-5.53a2.41 2.41 0 011.84-.89c2.56.08 4.42.49 5.04 3.78z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M192.31 211.52a4.9 4.9 0 011.81-.94 4.37 4.37 0 015.16 3.47l1.82 8.67a8.3 8.3 0 00-3.41.68 9 9 0 00-3.26 1.74c-1-2.44-1.82-4.9-2.8-7.34a6 6 0 01-.45-4.56 4 4 0 011.13-1.72z",
                                fill: "url(#linear-gradient-232)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M156.83 188.77H160a.49.49 0 01.49.49v9.65h-4.14v-9.65a.49.49 0 01.48-.49z",
                                transform: "rotate(91.28 158.41 193.83)",
                                fill: "url(#New_Gradient_Swatch_13)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M166.94 189.54H169a.5.5 0 01.5.5v8.51h-3.08V190a.5.5 0 01.52-.46z",
                                transform: "rotate(91.28 167.981 194.045)",
                                fill: "url(#New_Gradient_Swatch_13-2)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                transform: "rotate(91.28 176.118 194.226)",
                                fill: "url(#New_Gradient_Swatch_13-3)",
                                d: "M175.15 190.6h1.92v7.27h-1.92z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-247",
                                x: "178.59",
                                y: "193.96",
                                width: "3.06",
                                height: ".74",
                                rx: ".3",
                                transform: "rotate(91.28 180.12 194.325)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-247",
                                x: "150.26",
                                y: "193.12",
                                width: "4.96",
                                height: "1.2",
                                rx: ".49",
                                transform: "rotate(91.28 152.736 193.71)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M168 194.23h1.47a.73.73 0 00.73-.73V192a1 1 0 00-.21-.52 1 1 0 00-.64-.36l-1.35-.02a.76.76 0 00-.56.24.85.85 0 00-.18.69v1.47a.74.74 0 00.74.73z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                x: "166.04",
                                y: "191.29",
                                width: "1.47",
                                height: "2.35",
                                rx: ".73",
                                transform: "rotate(180 166.77 192.47)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                x: "169.9",
                                y: "191.29",
                                width: "1.47",
                                height: "2.35",
                                rx: ".73",
                                transform: "rotate(-180 170.63 192.47)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-249",
                                d: "M186.39 387.41l.65-2.09-.93.22c.1.62.19 1.24.28 1.87zM197.57 400.68c-.29 4.12-.58 7.54-.79 8.63-.1.55-.25 1.09-.25 1.09l-.14.48.38.12c-.45 1.24-1 4.28-1.48 5.52.14 1.52.35 2.89.59 4.14.22-.71.43-1.42.61-2.14 1.46-5.69 1.4-11.84 1.22-17.83zM344.22 423.89c-6-2.63-10-4.71-16-7.35l-2.05.57c2.65 1.35 6 3.24 8.38 4.69a5.4 5.4 0 012.52 5.62c-.48 2.55-1.08 5.92-1.7 9q4.68-5.9 9.55-11.63v-.06c-.31-.35-.54-.62-.7-.84z"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M200.61 398.16h-.05c-.15-1.06-.26-2.09-.38-3.15s-.23-2.66-.47-3.74a1.2 1.2 0 00-.67-.84c-.22-.1 0 .36-.18.24s0-.55-.24-.73a.14.14 0 00-.17-.07c-.09 0-.14.19-.2.31.18-3 .33-5.72.44-7.56l-1.29.3-10.4 2.4-.65 2.09c-.09-.63-.18-1.25-.28-1.87L175.36 388c-.27 4.63-.41 9.51-.56 15.57-.05 2.44.1 5.11.21 7.15l-.31.09c2.05 9.75 1.61 13.5 1.16 15.17-.84 3.19-.93 4.24-.8 5.11a49.27 49.27 0 00-5.92-1.13c-2.58-.33-3.87-.49-4.44-.12-1.92 1.28-.92 5.23.43 16.05.35 2.79.6 5.06.75 6.43.05.4.11.79.16 1.19h-2.31a.5.5 0 00-.5-.48l-9.65.22a.47.47 0 00-.48-.43h-.23a.5.5 0 00-.48.5l.09 4a.49.49 0 00.5.47h.23a.48.48 0 00.46-.44l9.64-.21a.5.5 0 00.48-.51l2.51-.06v.44a.73.73 0 00.73.73.69.69 0 00.55-.26.9.9 0 00.14.22.81.81 0 00.56.24l1.35-.05a1 1 0 00.64-.36l.05-.09a.7.7 0 00.57.3.73.73 0 00.74-.73v-.56h.65a.52.52 0 00.49-.52v-.07l7.26-.16v.3a.3.3 0 00.3.29h.14a.31.31 0 00.3-.31l-.06-2.46a.29.29 0 00-.3-.29h-.14a.3.3 0 00-.3.31v.27l-7.27.17v1-1a.5.5 0 00-.51-.49h-1.86l-.84-1.68q.09-7.35.17-14.69l1.57.59a2.88 2.88 0 01-.22.27l7.91 2.91a3.91 3.91 0 00-1.24 1c-1.15 1.44-.78 3.32-.6 4.25a8.52 8.52 0 003 4.84l-.25.16c-.15.28.64.78 1.47 1.7.27.3.47.56.58.71-.53 2.19-.45 4.27.59 5.76 1.67 2.36 5.6 3.43 8.89 2.59a8.85 8.85 0 005.3-3.82c2-3.23.94-6.69.43-8.41-.05-.17-.26-.86-.61-1.75a5.53 5.53 0 01-.12-1.44c.12-1.91 1.19-2.55 1.08-4.33a4.5 4.5 0 00-1.1-2.67 6.4 6.4 0 001.63-1.21 5.13 5.13 0 001.44-2.92c0-.09.06-.18.08-.28l1.82-8.67h-.15c.33-1.89.62-3.93.83-6.32a80.51 80.51 0 00-1.38-21.92zm-4.12 20.36c-.18.72-.39 1.43-.61 2.14-.24-1.25-.45-2.62-.59-4.14.45-1.24 1-4.28 1.48-5.52l-.38-.12c.05-.17.11-.34.14-.48s.15-.54.25-1.09c.21-1.09.5-4.51.79-8.63h.14c.18 6 .29 12.15-1.22 17.84z",
                                fill: "url(#linear-gradient-233)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                fill: "url(#linear-gradient-234)",
                                d: "M301.4 385.02l4.39 1.02"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                                d: "M327.83 451.92c.16.11.51-.12.63 0s0 .23 0 .45a.61.61 0 00.24.32c.32.17 1.12-.75 1.63-1.31 2.06-2.31 2.85-2.82 2.88-4.05v-.44a18.86 18.86 0 01.07-2.53q6.66-8.68 13.75-17c.64.85 1 1.38 1.39 1.56l.08.14c1 .4 2.55-1.6 2.88-3.17a1.68 1.68 0 000-.91 4.62 4.62 0 00-.76-1.83q9.87-11.32 20.49-21.94l-3.69-.86q-10.01 10.16-19.42 20.93a2 2 0 00-.41-.18c-.29-.09-1.56-.63-2.35-.82l.13-.5-14.14-9.86a5.44 5.44 0 00-1.53-.42c-1-.14-4.17.44-7.13 1.13 0-.3 0-.58.05-.88a85.6 85.6 0 011.28-9.71l-.86-.37a21.52 21.52 0 002.58-6.27c.11-.48.23-.94.34-1.4l.3-1.21-20.47-4.79a41.87 41.87 0 00-.41 8.76c.09.56.46 2.3.78 3.74l-.43.11a63.72 63.72 0 01-1.88 13.92c-.28 1.12-.58 2.21-.91 3.25a4.26 4.26 0 001.64 4.78h.09l.66.41s.73.44 1.5.82a14.06 14.06 0 002.25.86l-.27 2.27-1.49.95a8.58 8.58 0 00-3.91 5c-.21.78-.88 3.35.56 5.4a5.72 5.72 0 003 2.09c1.52.49 1.85 0 4.85.09 2.09.08 2.95.43 3.31-.07s-.22-1.71-.71-2.45c.29-.69.59-1.37.88-2.06l2.66-1.63c-.22-.38-.44-.76-.65-1.14a1.06 1.06 0 00.34-.45 1 1 0 000-.63l-.29-.13v-1a1.82 1.82 0 00.6-1 1.9 1.9 0 00-.24-1.4 2.56 2.56 0 00-1.94-1.11h-.13l-1.22-.06a12.75 12.75 0 01.27-1.55l1.08.12c2.74.26 14.17 3.11 14.17 3.11s.75 9.78-.88 15.51l-1.22 1c-1.82 1.5-2.13 1.86-2.2 2.4a9.91 9.91 0 010 1.39c-.12.73-.36 1.1-.23 1.2s.62-.21 1-.62q-5.31 7.17-10.32 14.54 3-1.26 5.7-2.58 2.89-4.12 5.86-8.2a.26.26 0 00.17.28zm-1.62-34.81l2.05-.57c6 2.64 10 4.72 16 7.35.16.22.39.49.72.87v.06q-4.87 5.73-9.55 11.63c.62-3.11 1.22-6.48 1.7-9a5.4 5.4 0 00-2.52-5.62c-2.43-1.48-5.75-3.37-8.4-4.72z",
                                fill: "url(#linear-gradient-235)"
                            })
                        ]
                    })
                })
            })
        ]
    });

});


parcelRegister("9Mevf", function(module, exports) {
$parcel$export(module.exports, "default", () => $881bbf06a71ba65a$export$2e2bcd8739ae039);

var $iFRRO = parcelRequire("iFRRO");
var $aMklv = parcelRequire("aMklv");
var $ePsaW = parcelRequire("ePsaW");
var $icRac = parcelRequire("icRac");
var $fr9wL = parcelRequire("fr9wL");
var $fJA2G = parcelRequire("fJA2G");
var $6MFb2 = parcelRequire("6MFb2");
var $aKq6e = parcelRequire("aKq6e");
var $6ZoAA = parcelRequire("6ZoAA");
var $iV4qD = parcelRequire("iV4qD");
var $6fQb4 = parcelRequire("6fQb4");
var $aj7IW = parcelRequire("aj7IW");
var $1CIXI = parcelRequire("1CIXI");
var $eH7fu = parcelRequire("eH7fu");
var $l7lfL = parcelRequire("l7lfL");
var $kVt9O = parcelRequire("kVt9O");
var $3y1AS = parcelRequire("3y1AS");
var $4Acex = parcelRequire("4Acex");
var $58fJs = parcelRequire("58fJs");
var $bx5pz = parcelRequire("bx5pz");
var $51Th6 = parcelRequire("51Th6");
var $as5hN = parcelRequire("as5hN");
var $j2XGC = parcelRequire("j2XGC");
var $7Jhnh = parcelRequire("7Jhnh");
var $4c8fI = parcelRequire("4c8fI");
const $881bbf06a71ba65a$var$localeToTranslations = {
    'cs-CZ': $iFRRO.default,
    'da-DK': $aMklv.default,
    'de-DE': $ePsaW.default,
    'en-US': $icRac.default,
    'en-GB': $fr9wL.default,
    'en-ZZ': $fJA2G.default,
    'es-ES': $6MFb2.default,
    'fi-FI': $aKq6e.default,
    'fr-FR': $6ZoAA.default,
    'hu-HU': $iV4qD.default,
    'it-IT': $6fQb4.default,
    'ja-JP': $aj7IW.default,
    'ko-KR': $1CIXI.default,
    'no-NO': $eH7fu.default,
    'nl-NL': $l7lfL.default,
    'pl-PL': $kVt9O.default,
    'pt-BR': $3y1AS.default,
    'ru-RU': $4Acex.default,
    'sv-SE': $58fJs.default,
    'tr-TR': $51Th6.default,
    'th-TH': $bx5pz.default,
    'uk-UA': $as5hN.default,
    'vi-VN': $j2XGC.default,
    'zh-TW': $4c8fI.default,
    'zh-CN': $7Jhnh.default
};
const $881bbf06a71ba65a$var$fetchTranslations = async (locale)=>$881bbf06a71ba65a$var$localeToTranslations[locale] ?? $icRac.default;
var $881bbf06a71ba65a$export$2e2bcd8739ae039 = $881bbf06a71ba65a$var$fetchTranslations;

});
parcelRegister("iFRRO", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0e36b127e44515b$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $86zeU = parcelRequire("86zeU");
var $a0e36b127e44515b$export$2e2bcd8739ae039 = (0, $86zeU.default);

});
parcelRegister("86zeU", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8813ea85494e9a0$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $f8813ea85494e9a0$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Hledali jsme v\u0161ude, ale tato polo\u017Eka neexistuje. Mohla b\xfdt odstran\u011Bna. Pokud ov\u0161em nem\xe1te p\u0159eklep v\xa0adrese URL.",
    'embedded-confluence-common.src.content.empty-state-header': "Nem\u016F\u017Eeme naj\xedt, co hled\xe1te",
    'embedded.confluence.already-logged-in-paragraph': "Jste ji\u017E p\u0159ihl\xe1\u0161eni? Zkuste obnovit str\xe1nku.",
    'embedded.confluence.footer.hover.text': "Zobrazit v\xa0Confluence",
    'embedded.confluence.footer.prefix': "Pou\u017E\xedv\xe1 technologii",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "P\u0159ihlaste se do Confluence",
    'embedded.confluence.login-page.login-button': "P\u0159ihl\xe1sit se do Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "Tla\u010D\xedtko p\u0159ihl\xe1\u0161en\xed",
    'embedded.confluence.login-page.login-text': "Chcete-li zobrazit tuto str\xe1nku, mus\xedte b\xfdt p\u0159ihl\xe1\u0161eni.",
    'embedded.confluence.login-page.refresh-page-banner': "Po p\u0159ihl\xe1\u0161en\xed by se tato str\xe1nka m\u011Bla automaticky obnovit. Pokud ne, m\u016F\u017Eete ji obnovit kliknut\xedm zde.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Obnovit str\xe1nku",
    'embedded.confluence.need-to-log-in-paragraph': "Chcete-li zobrazit tuto str\xe1nku, mus\xedte b\xfdt p\u0159ihl\xe1\u0161eni.",
    'embedded.confluence.still-having-trouble-paragraph': "Po\u0159\xe1d m\xe1te pot\xed\u017Ee? Ujist\u011Bte se, \u017Ee jsou povoleny soubory cookies t\u0159et\xedch stran, nebo {link}",
    'embedded.confluence.troubleshooting-link-text': "se pod\xedvejte se do pr\u016Fvodce \u0159e\u0161en\xedm probl\xe9m\u016F.",
    'embedded.confluence.troubleshooting-link.aria-label': "odkaz na pr\u016Fvodce \u0159e\u0161en\xedm probl\xe9m\u016F"
};

});


parcelRegister("aMklv", function(module, exports) {
$parcel$export(module.exports, "default", () => $34eb75439b23d65b$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $iCo1l = parcelRequire("iCo1l");
var $34eb75439b23d65b$export$2e2bcd8739ae039 = (0, $iCo1l.default);

});
parcelRegister("iCo1l", function(module, exports) {
$parcel$export(module.exports, "default", () => $e04985d3e12bc10d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $e04985d3e12bc10d$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Vi har ledt overalt, men den eksisterer ikke. Den er muligvis blevet slettet. Medmindre der er en sl\xe5fejl i webadressen, selvf\xf8lgelig \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Vi kunne ikke finde det, du leder efter',
    'embedded.confluence.already-logged-in-paragraph': "Er du allerede logget ind? Pr\xf8v at genindl\xe6se.",
    'embedded.confluence.footer.hover.text': 'Vis i Confluence',
    'embedded.confluence.footer.prefix': 'Drevet af',
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Log p\xe5 Confluence",
    'embedded.confluence.login-page.login-button': "Log ind p\xe5 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': 'Loginknap',
    'embedded.confluence.login-page.login-text': "Du skal v\xe6re logget ind for at kunne se denne side",
    'embedded.confluence.login-page.refresh-page-banner': "N\xe5r du har logget ind, b\xf8r denne side genindl\xe6ses automatisk. Hvis ikke, kan du klikke her for at genindl\xe6se",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Genindl\xe6s siden",
    'embedded.confluence.need-to-log-in-paragraph': "Du skal v\xe6re logget ind for at kunne se denne side",
    'embedded.confluence.still-having-trouble-paragraph': "Har du stadig problemer? S\xf8rg for, at tredjepartscookies er aktiveret, eller {link}",
    'embedded.confluence.troubleshooting-link-text': 'se denne fejlfindingsvejledning.',
    'embedded.confluence.troubleshooting-link.aria-label': 'link til fejlfindingsvejledning'
};

});


parcelRegister("ePsaW", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c45236328d7a8c0$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $OKt1m = parcelRequire("OKt1m");
var $7c45236328d7a8c0$export$2e2bcd8739ae039 = (0, $OKt1m.default);

});
parcelRegister("OKt1m", function(module, exports) {
$parcel$export(module.exports, "default", () => $4268ac55a57b7b64$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $4268ac55a57b7b64$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Wir haben \xfcberall gesucht, aber sie existiert nicht. Sie k\xf6nnte gel\xf6scht worden sein. Es sei denn, in der URL ist ein Tippfehler enthalten \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Wir konnten nicht finden, wonach Sie suchen',
    'embedded.confluence.already-logged-in-paragraph': 'Bereits eingeloggt? Aktualisieren Sie die Seite.',
    'embedded.confluence.footer.hover.text': 'In Confluence anzeigen',
    'embedded.confluence.footer.prefix': 'Bereitgestellt von',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Bei Confluence einloggen',
    'embedded.confluence.login-page.login-button': 'Bei Confluence einloggen',
    'embedded.confluence.login-page.login-button.aria-label': "Login-Schaltfl\xe4che",
    'embedded.confluence.login-page.login-text': "Sie m\xfcssen eingeloggt sein, damit diese Seite angezeigt wird.",
    'embedded.confluence.login-page.refresh-page-banner': "Nach dem Einloggen sollte diese Seite automatisch aktualisiert werden. Wenn dies nicht der Fall ist, k\xf6nnen Sie zum Aktualisieren hier klicken.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Seite aktualisieren',
    'embedded.confluence.need-to-log-in-paragraph': "Sie m\xfcssen eingeloggt sein, damit diese Seite angezeigt wird.",
    'embedded.confluence.still-having-trouble-paragraph': 'Besteht das Problem weiterhin? Vergewissern Sie sich, dass Cookies von Drittanbietern aktiviert sind, oder {link}',
    'embedded.confluence.troubleshooting-link-text': 'lesen Sie den Leitfaden zur Fehlerbehebung.',
    'embedded.confluence.troubleshooting-link.aria-label': 'Link zum Leitfaden zur Fehlerbehebung'
};

});


parcelRegister("icRac", function(module, exports) {
$parcel$export(module.exports, "default", () => $aaa6fc079e2baaa9$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $fa9oE = parcelRequire("fa9oE");
var $aaa6fc079e2baaa9$export$2e2bcd8739ae039 = (0, $fa9oE.default);

});
parcelRegister("fa9oE", function(module, exports) {
$parcel$export(module.exports, "default", () => $e00759fdb5dd3dbf$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $e00759fdb5dd3dbf$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "We couldn't find what you're looking for",
    'embedded.confluence.already-logged-in-paragraph': 'Already logged in? Try refreshing.',
    'embedded.confluence.footer.hover.text': 'View in Confluence',
    'embedded.confluence.footer.prefix': 'Powered by',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Log in to Confluence',
    'embedded.confluence.login-page.login-button': 'Log in to Confluence',
    'embedded.confluence.login-page.login-button.aria-label': 'Login Button',
    'embedded.confluence.login-page.login-text': 'You need to be logged in to view this page',
    'embedded.confluence.login-page.refresh-page-banner': 'After logging in, this page should refresh automatically. If not, you can click here to refresh',
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Refresh page',
    'embedded.confluence.need-to-log-in-paragraph': 'You need to be logged in to view this page',
    'embedded.confluence.still-having-trouble-paragraph': 'Still having trouble? Make sure 3rd party cookies are enabled, or {link}',
    'embedded.confluence.troubleshooting-link-text': 'refer to this troubleshooting guide.',
    'embedded.confluence.troubleshooting-link.aria-label': 'troubleshooting guide link'
};

});


parcelRegister("fr9wL", function(module, exports) {
$parcel$export(module.exports, "default", () => $74bab1fca41e2f7d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $4SI1O = parcelRequire("4SI1O");
var $74bab1fca41e2f7d$export$2e2bcd8739ae039 = (0, $4SI1O.default);

});
parcelRegister("4SI1O", function(module, exports) {
$parcel$export(module.exports, "default", () => $9591cf622278f558$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $9591cf622278f558$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "We couldn't find what you're looking for",
    'embedded.confluence.already-logged-in-paragraph': 'Already logged in? Try refreshing.',
    'embedded.confluence.footer.hover.text': 'View in Confluence',
    'embedded.confluence.footer.prefix': 'Powered by',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Log in to Confluence',
    'embedded.confluence.login-page.login-button': 'Log in to Confluence',
    'embedded.confluence.login-page.login-button.aria-label': 'Login Button',
    'embedded.confluence.login-page.login-text': 'You need to be logged in to view this page',
    'embedded.confluence.login-page.refresh-page-banner': 'After logging in, this page should refresh automatically. If not, you can click here to refresh',
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Refresh page',
    'embedded.confluence.need-to-log-in-paragraph': 'You need to be logged in to view this page',
    'embedded.confluence.still-having-trouble-paragraph': 'Still having trouble? Make sure 3rd party cookies are enabled, or {link}',
    'embedded.confluence.troubleshooting-link-text': 'refer to this troubleshooting guide.',
    'embedded.confluence.troubleshooting-link.aria-label': 'troubleshooting guide link'
};

});


parcelRegister("fJA2G", function(module, exports) {
$parcel$export(module.exports, "default", () => $d964474c495f7ad0$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $iUxRF = parcelRequire("iUxRF");
var $d964474c495f7ad0$export$2e2bcd8739ae039 = (0, $iUxRF.default);

});
parcelRegister("iUxRF", function(module, exports) {
$parcel$export(module.exports, "default", () => $2695162625fbad9d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $2695162625fbad9d$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u2063\u2062We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it \uD83D\uDE09\u206A\x81\u206C\u2061\u200D\u2060\u061C\u206E\u2061\x9d\u2061\u2061\u206F\x8f\u206F\u206A\u2061\u206E\u206E\u206B\u2060\u2061\u061C\u206B\x9d\x8f\u206E\x9d\x81\u200D\x8d\u206F\u2063\u2064",
    'embedded-confluence-common.src.content.empty-state-header': "\u2063\u2062We couldn't find what you're looking for\u2061\u200C\u206E\x81\x8f\u206E\u206C\u206A\u206C\u061C\u206B\u206B\u200C\u206D\x8d\x8f\u206A\u200D\u2061\u2061\x8d\u200C\u200D\u2061\u206C\x8f\u206F\u206D\u206F\u2061\u206D\u206D\u2063\u2064",
    'embedded.confluence.already-logged-in-paragraph': "\u2063\u2062Already logged in? Try refreshing.\x90\x90\u206A\x8f\u200D\u206C\u200D\x9d\u206A\x8f\x81\x8f\u200C\x9d\x8d\u206C\x8f\u2060\x90\x90\u206D\x81\u061C\x8d\u2061\x81\u206E\u206D\x90\u2060\u200D\u206F\u2063\u2064",
    'embedded.confluence.footer.hover.text': "\u2063\u2062View in Confluence\u200C\u206D\u200D\x90\u200D\u2061\u206C\u206D\x9d\u2060\x9d\x9d\u206A\u2061\u2061\u061C\u2060\u2060\u2060\u200D\u206E\x90\x81\u200C\x8f\u2060\u2060\u206D\u2060\u2060\u206C\u206F\u2063\u2064",
    'embedded.confluence.footer.prefix': "\u2063\u2062Powered by\u206C\x8f\u206B\u206E\u206B\u200C\x8d\x90\u206C\x81\x8f\u206C\x8f\u200C\x8d\x9d\u206F\u061C\u206E\x9d\u206D\x9d\u206F\x90\u061C\u061C\u200C\x8f\u200C\u206B\u206F\u200C\u2063\u2064",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u2063\u2062Log in to Confluence\u061C\u2060\u2060\u206F\x8d\u2061\u206E\x81\x9d\x90\x8f\u206E\x81\x8d\x8f\x90\u206F\u2061\u061C\x8d\u206C\u206D\u206A\x81\u206D\x9d\u206A\x8f\u206E\x81\u206E\u206D\u2063\u2064",
    'embedded.confluence.login-page.login-button': "\u2063\u2062Log in to Confluence\u206D\u206A\u206A\x8d\u206F\u061C\u200C\u061C\u206C\u206B\u2061\u061C\u200C\x90\u206A\u206D\u206A\u206B\u200D\u061C\u206B\x8f\x90\u200C\u206B\u206E\u206C\u206A\u2061\x81\u206A\x90\u2063\u2064",
    'embedded.confluence.login-page.login-button.aria-label': "\u2063\u2062Login Button\x8d\x90\u206E\x90\u206D\x8d\u061C\u200C\u206E\x90\x8d\u061C\u2060\u200D\u206F\x8d\u206D\u2061\x81\u200D\x90\x8d\x90\x90\x9d\u061C\u206F\x81\u206E\u200C\x9d\x90\u2063\u2064",
    'embedded.confluence.login-page.login-text': "\u2063\u2062You need to be logged in to view this page\u206F\u206A\u200C\x8d\u206E\x81\x81\u2061\x81\x90\u206F\u2060\x8d\u206E\x8f\x9d\x90\u2061\u2061\u206F\u200D\x81\x90\u206C\u206D\u206B\x90\u206A\u206E\u2060\u2061\x90\u2063\u2064",
    'embedded.confluence.login-page.refresh-page-banner': "\u2063\u2062After logging in, this page should refresh automatically. If not, you can click here to refresh\u200C\x81\u200D\u200D\u206F\u206D\x90\u200C\u206D\x81\u2060\u206A\u2061\x8d\u206C\u200C\x90\x8d\x8f\x8f\u2061\x9d\u206E\x9d\u2060\u2061\u2060\u061C\x8f\u206C\u206D\u2061\u2063\u2064",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u2063\u2062Refresh page\u2060\x90\u2061\u061C\u200D\u206E\x8d\x90\u200D\x9d\u2060\u206A\u2061\x90\x8d\x8f\u206E\x8d\x9d\u206A\x9d\u061C\u206B\x8f\u206B\u200D\u061C\u206E\u206A\u206C\u206A\x90\u2063\u2064",
    'embedded.confluence.need-to-log-in-paragraph': "\u2063\u2062You need to be logged in to view this page\u200D\u061C\u206D\u206C\u206E\u206D\u206F\x8d\u206F\x8d\u061C\u206E\u206A\u206F\u206E\u206C\u206F\u200D\x90\u2061\x81\x90\x81\u206E\x8d\x8f\x8f\x90\u206D\x90\u206C\u206F\u2063\u2064",
    'embedded.confluence.still-having-trouble-paragraph': "\u2063\u2062Still having trouble? Make sure 3rd party cookies are enabled, or {link}\x90\x90\u061C\u206E\x90\u206D\x90\x8f\u200D\x8d\x8d\u061C\u206D\x9d\x9d\x90\u061C\u206D\x8d\x8f\u061C\u200C\u2061\u206E\u206A\x9d\x9d\u206F\x81\u206F\u2061\u206F\u2063\u2064",
    'embedded.confluence.troubleshooting-link-text': "\u2063\u2062refer to this troubleshooting guide.\u206C\u206A\x90\u206D\u2061\x81\x8d\x8f\u206F\x9d\u206B\u206C\x81\u206A\u206B\u206C\u200D\u200C\x8d\u206B\u200C\x90\u206C\u061C\u061C\x8f\u2061\x9d\u2060\u206A\u2060\u061C\u2063\u2064",
    'embedded.confluence.troubleshooting-link.aria-label': "\u2063\u2062troubleshooting guide link\u200C\x90\u206C\u206D\u206E\x9d\u206D\u200D\x90\x8f\u200D\x8f\x90\u206A\u206D\x90\u206D\u200C\u200D\u206F\u206A\x90\u206F\x90\u200C\u2061\x90\u206E\u200D\x8d\u206C\u206A\u2063\u2064"
};

});


parcelRegister("6MFb2", function(module, exports) {
$parcel$export(module.exports, "default", () => $b005063dd24d5254$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $OyaMN = parcelRequire("OyaMN");
var $b005063dd24d5254$export$2e2bcd8739ae039 = (0, $OyaMN.default);

});
parcelRegister("OyaMN", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8002adc7390303d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $d8002adc7390303d$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Hemos buscado en todas partes, pero no existe. Puede que se haya borrado. A no ser que la URL contenga un error \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'No hemos podido encontrar lo que buscas.',
    'embedded.confluence.already-logged-in-paragraph': "\xbfHas iniciado sesi\xf3n? Prueba a actualizar.",
    'embedded.confluence.footer.hover.text': 'Ver en Confluence',
    'embedded.confluence.footer.prefix': "Con tecnolog\xeda de",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Iniciar sesi\xf3n en Confluence",
    'embedded.confluence.login-page.login-button': "Iniciar sesi\xf3n en Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "Bot\xf3n de inicio de sesi\xf3n",
    'embedded.confluence.login-page.login-text': "Tienes que iniciar sesi\xf3n para poder ver esta p\xe1gina",
    'embedded.confluence.login-page.refresh-page-banner': "Tras iniciar sesi\xf3n, esta p\xe1gina deber\xeda actualizarse autom\xe1ticamente. Si no, puedes hacer clic aqu\xed para actualizar.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Actualizar p\xe1gina",
    'embedded.confluence.need-to-log-in-paragraph': "Tienes que iniciar sesi\xf3n para poder ver esta p\xe1gina",
    'embedded.confluence.still-having-trouble-paragraph': "\xbfSigues teniendo problemas? Aseg\xfarate de que las cookies de terceros est\xe1n habilitadas o {link}",
    'embedded.confluence.troubleshooting-link-text': "consulta esta gu\xeda de soluci\xf3n de problemas.",
    'embedded.confluence.troubleshooting-link.aria-label': "enlace a la gu\xeda de soluci\xf3n de problemas"
};

});


parcelRegister("aKq6e", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb5677a194306f9d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $k8GmK = parcelRequire("k8GmK");
var $eb5677a194306f9d$export$2e2bcd8739ae039 = (0, $k8GmK.default);

});
parcelRegister("k8GmK", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf006fcc6db4a0c7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Finnish
var $bf006fcc6db4a0c7$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Etsimme kaikkialta, mutta sit\xe4 ei ole olemassa. Se on saatettu poistaa. Paitsi tietenkin jos URL-osoitteessa on kirjoitusvirhe \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Emme l\xf6yt\xe4neet etsim\xe4\xe4si",
    'embedded.confluence.already-logged-in-paragraph': "Oletko jo kirjautuneena sis\xe4\xe4n? Kokeile p\xe4ivitt\xe4\xe4.",
    'embedded.confluence.footer.hover.text': "N\xe4yt\xe4 Confluencessa",
    'embedded.confluence.footer.prefix': 'Palvelun tarjoaa',
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Kirjaudu sis\xe4\xe4n Confluenceen",
    'embedded.confluence.login-page.login-button': "Kirjaudu sis\xe4\xe4n Confluenceen",
    'embedded.confluence.login-page.login-button.aria-label': 'Kirjautumispainike',
    'embedded.confluence.login-page.login-text': "Sinun on oltava kirjautuneena sis\xe4\xe4n, jotta voit tarkastella t\xe4t\xe4 sivua",
    'embedded.confluence.login-page.refresh-page-banner': "T\xe4m\xe4n sivun tulisi p\xe4ivitty\xe4 automaattisesti sis\xe4\xe4nkirjautumisen j\xe4lkeen. Jos n\xe4in ei tapahdu, voit p\xe4ivitt\xe4\xe4 sivun napsauttamalla t\xe4t\xe4.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "P\xe4ivit\xe4 sivu",
    'embedded.confluence.need-to-log-in-paragraph': "Sinun on oltava kirjautuneena sis\xe4\xe4n, jotta voit katsoa t\xe4t\xe4 sivua",
    'embedded.confluence.still-having-trouble-paragraph': "Onko sinulla viel\xe4 ongelmia? Varmista, ett\xe4 kolmansien osapuolten ev\xe4steet ovat k\xe4yt\xf6ss\xe4, tai {link}",
    'embedded.confluence.troubleshooting-link-text': "katso t\xe4m\xe4 ongelmanratkaisuopas.",
    'embedded.confluence.troubleshooting-link.aria-label': 'ongelmanratkaisuoppaan linkki'
};

});


parcelRegister("6ZoAA", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ac589bb45a43a98$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $97WrX = parcelRequire("97WrX");
var $8ac589bb45a43a98$export$2e2bcd8739ae039 = (0, $97WrX.default);

});
parcelRegister("97WrX", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad3ccc23c0718289$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $ad3ccc23c0718289$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Nous avons cherch\xe9 partout, mais ce contenu n'existe pas. Il a peut-\xeatre \xe9t\xe9 supprim\xe9. Il est possible que l'URL contienne une faute de frappe. V\xe9rifiez bien \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Impossible de trouver ce que vous recherchez',
    'embedded.confluence.already-logged-in-paragraph': "D\xe9j\xe0 connect\xe9\xa0? Essayez d'actualiser.",
    'embedded.confluence.footer.hover.text': 'Afficher dans Confluence',
    'embedded.confluence.footer.prefix': "Optimis\xe9 par",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Connexion \xe0 Confluence",
    'embedded.confluence.login-page.login-button': "Connexion \xe0 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': 'Bouton de connexion',
    'embedded.confluence.login-page.login-text': "Vous devez \xeatre connect\xe9 pour voir cette page",
    'embedded.confluence.login-page.refresh-page-banner': "Apr\xe8s la connexion, cette page devrait s'actualiser automatiquement. Si ce n'est pas le cas, cliquez ici pour l'actualiser.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Actualiser la page',
    'embedded.confluence.need-to-log-in-paragraph': "Vous devez \xeatre connect\xe9 pour voir cette page",
    'embedded.confluence.still-having-trouble-paragraph': "Vous rencontrez toujours des probl\xe8mes\xa0? Assurez-vous que les cookies tiers sont activ\xe9s, ou {link}.",
    'embedded.confluence.troubleshooting-link-text': "reportez-vous \xe0 ce guide de d\xe9pannage",
    'embedded.confluence.troubleshooting-link.aria-label': "lien vers le guide de d\xe9pannage"
};

});


parcelRegister("iV4qD", function(module, exports) {
$parcel$export(module.exports, "default", () => $7040c1ece2828376$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $1uArQ = parcelRequire("1uArQ");
var $7040c1ece2828376$export$2e2bcd8739ae039 = (0, $1uArQ.default);

});
parcelRegister("1uArQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e95b01e8c12f0776$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Hungarian
var $e95b01e8c12f0776$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Megpr\xf3b\xe1ltuk megkeresni, de nincs ilyen oldal. Lehet, hogy t\xf6r\xf6lt\xe9k. Az is lehet, hogy csak el\xedrtad az URL-t \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Nem tal\xe1ltuk meg, amit keresel",
    'embedded.confluence.already-logged-in-paragraph': "M\xe1r bejelentkezt\xe9l? Pr\xf3b\xe1lj meg friss\xedteni.",
    'embedded.confluence.footer.hover.text': "Megtekint\xe9s a Confluence-ben",
    'embedded.confluence.footer.prefix': "Szolg\xe1ltat\xf3:",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Bejelentkez\xe9s a Confluence-be",
    'embedded.confluence.login-page.login-button': "Bejelentkez\xe9s a Confluence-be",
    'embedded.confluence.login-page.login-button.aria-label': "Bejelentkez\xe9s gomb",
    'embedded.confluence.login-page.login-text': "Az oldal megtekint\xe9s\xe9hez be kell jelentkezned",
    'embedded.confluence.login-page.refresh-page-banner': "Bejelentkez\xe9s ut\xe1n az oldal automatikusan friss\xfcl. Ha nem, kattints ide a friss\xedt\xe9shez.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Oldal friss\xedt\xe9se",
    'embedded.confluence.need-to-log-in-paragraph': "Az oldal megtekint\xe9s\xe9hez be kell jelentkezned",
    'embedded.confluence.still-having-trouble-paragraph': "M\xe9g mindig probl\xe9m\xe1ba \xfctk\xf6z\xf6l? Gy\u0151z\u0151dj meg r\xf3la, hogy enged\xe9lyezted a harmadik felekt\u0151l sz\xe1rmaz\xf3 s\xfctiket, vagy {link}",
    'embedded.confluence.troubleshooting-link-text': "olvasd el ezt a hibaelh\xe1r\xedt\xe1si \xfatmutat\xf3t.",
    'embedded.confluence.troubleshooting-link.aria-label': "hibaelh\xe1r\xedt\xe1si \xfatmutat\xf3 linkje"
};

});


parcelRegister("6fQb4", function(module, exports) {
$parcel$export(module.exports, "default", () => $0bd0d6d88aba59fa$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $7MLET = parcelRequire("7MLET");
var $0bd0d6d88aba59fa$export$2e2bcd8739ae039 = (0, $7MLET.default);

});
parcelRegister("7MLET", function(module, exports) {
$parcel$export(module.exports, "default", () => $08a304e9615ca1cb$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $08a304e9615ca1cb$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Abbiamo cercato ovunque, ma la pagina non esiste. Potrebbe essere stata eliminata, o forse hai sbagliato a scrivere l'URL \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Non siamo riusciti a trovare la pagina cercata',
    'embedded.confluence.already-logged-in-paragraph': "Hai gi\xe0 effettuato l'accesso? Prova ad aggiornare la pagina.",
    'embedded.confluence.footer.hover.text': 'Visualizza in Confluence',
    'embedded.confluence.footer.prefix': 'Offerto da',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Accedi a Confluence',
    'embedded.confluence.login-page.login-button': 'Accedi a Confluence',
    'embedded.confluence.login-page.login-button.aria-label': 'Pulsante di accesso',
    'embedded.confluence.login-page.login-text': "Per visualizzare questa pagina devi avere effettuato l'accesso.",
    'embedded.confluence.login-page.refresh-page-banner': "Dopo l'accesso, questa pagina dovrebbe aggiornarsi automaticamente. In caso contrario, clicca qui per aggiornarla",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Aggiorna la pagina',
    'embedded.confluence.need-to-log-in-paragraph': "Deve avere effettuato l'accesso per visualizzare questa pagina",
    'embedded.confluence.still-having-trouble-paragraph': 'Riscontri ancora problemi? Assicurati che i cookie di terze parti siano abilitati, oppure {link}',
    'embedded.confluence.troubleshooting-link-text': 'consulta questa guida alla risoluzione dei problemi.',
    'embedded.confluence.troubleshooting-link.aria-label': 'link alla guida alla risoluzione dei problemi'
};

});


parcelRegister("aj7IW", function(module, exports) {
$parcel$export(module.exports, "default", () => $5bfd3b3f4acaa267$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $fRbOB = parcelRequire("fRbOB");
var $5bfd3b3f4acaa267$export$2e2bcd8739ae039 = (0, $fRbOB.default);

});
parcelRegister("fRbOB", function(module, exports) {
$parcel$export(module.exports, "default", () => $e13736617ad05247$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $e13736617ad05247$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u304A\u63A2\u3057\u306E\u30DA\u30FC\u30B8\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002\u524A\u9664\u3055\u308C\u305F\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002URL \u306B\u5165\u529B\u30DF\u30B9\u304C\u306A\u3044\u304B\u3001\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u304A\u63A2\u3057\u306E\u3082\u306E\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F",
    'embedded.confluence.already-logged-in-paragraph': "\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u3044\u307E\u3059\u304B?\u66F4\u65B0\u3057\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002",
    'embedded.confluence.footer.hover.text': "Confluence \u3067\u8868\u793A",
    'embedded.confluence.footer.prefix': "\u4F7F\u7528\u30BD\u30EA\u30E5\u30FC\u30B7\u30E7\u30F3: ",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Confluence \u306B\u30ED\u30B0\u30A4\u30F3",
    'embedded.confluence.login-page.login-button': "Confluence \u306B\u30ED\u30B0\u30A4\u30F3",
    'embedded.confluence.login-page.login-button.aria-label': "\u30ED\u30B0\u30A4\u30F3 \u30DC\u30BF\u30F3",
    'embedded.confluence.login-page.login-text': "\u3053\u306E\u30DA\u30FC\u30B8\u3092\u8868\u793A\u3059\u308B\u306B\u306F\u3001\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059",
    'embedded.confluence.login-page.refresh-page-banner': "\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u3068\u3001\u3053\u306E\u30DA\u30FC\u30B8\u306F\u81EA\u52D5\u3067\u66F4\u65B0\u3055\u308C\u307E\u3059\u3002\u66F4\u65B0\u3055\u308C\u306A\u3044\u5834\u5408\u306F\u3001\u3053\u3053\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u66F4\u65B0\u3067\u304D\u307E\u3059",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u30DA\u30FC\u30B8\u3092\u66F4\u65B0",
    'embedded.confluence.need-to-log-in-paragraph': "\u3053\u306E\u30DA\u30FC\u30B8\u3092\u8868\u793A\u3059\u308B\u306B\u306F\u3001\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002",
    'embedded.confluence.still-having-trouble-paragraph': "\u554F\u984C\u304C\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u3001\u30B5\u30FC\u30C9\u30D1\u30FC\u30C6\u30A3 Cookie \u304C\u6709\u52B9\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u307E\u305F\u306F\u3001{link}",
    'embedded.confluence.troubleshooting-link-text': "\u3053\u306E\u30C8\u30E9\u30D6\u30EB\u30B7\u30E5\u30FC\u30C6\u30A3\u30F3\u30B0 \u30AC\u30A4\u30C9\u3092\u53C2\u7167\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'embedded.confluence.troubleshooting-link.aria-label': "\u30C8\u30E9\u30D6\u30EB\u30B7\u30E5\u30FC\u30C6\u30A3\u30F3\u30B0 \u30AC\u30A4\u30C9\u306E\u30EA\u30F3\u30AF"
};

});


parcelRegister("1CIXI", function(module, exports) {
$parcel$export(module.exports, "default", () => $a39d0d3b60f726a4$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $bZXf1 = parcelRequire("bZXf1");
var $a39d0d3b60f726a4$export$2e2bcd8739ae039 = (0, $bZXf1.default);

});
parcelRegister("bZXf1", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ef766d79add86b1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $1ef766d79add86b1$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\uC790\uC138\uD788 \uB458\uB7EC\uBCF4\uC558\uC9C0\uB9CC \uCC3E\uC744 \uC218\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4. \uC0AD\uC81C\uB418\uC5C8\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4. URL\uC5D0 \uC785\uB825 \uC624\uB958\uAC00 \uC788\uB294\uC9C0 \uD655\uC778\uD574\uBCF4\uC138\uC694 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\uC6D0\uD558\uB294 \uD56D\uBAA9\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
    'embedded.confluence.already-logged-in-paragraph': "\uC774\uBBF8 \uB85C\uADF8\uC778\uD558\uC168\uC2B5\uB2C8\uAE4C? \uC0C8\uB85C \uACE0\uCCD0 \uBCF4\uC138\uC694.",
    'embedded.confluence.footer.hover.text': "Confluence\uC5D0\uC11C \uBCF4\uAE30",
    'embedded.confluence.footer.prefix': "\uC81C\uACF5:",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Confluence\uC5D0 \uB85C\uADF8\uC778",
    'embedded.confluence.login-page.login-button': "Confluence\uC5D0 \uB85C\uADF8\uC778",
    'embedded.confluence.login-page.login-button.aria-label': "\uB85C\uADF8\uC778 \uBC84\uD2BC",
    'embedded.confluence.login-page.login-text': "\uC774 \uD398\uC774\uC9C0\uB97C \uBCF4\uB824\uBA74 \uB85C\uADF8\uC778\uD574\uC57C \uD569\uB2C8\uB2E4",
    'embedded.confluence.login-page.refresh-page-banner': "\uB85C\uADF8\uC778\uD558\uBA74 \uC774 \uD398\uC774\uC9C0\uAC00 \uC790\uB3D9\uC73C\uB85C \uC0C8\uB85C \uACE0\uCCD0\uC9D1\uB2C8\uB2E4. \uADF8\uB807\uC9C0 \uC54A\uC740 \uACBD\uC6B0 \uC5EC\uAE30\uB97C \uD074\uB9AD\uD558\uC5EC \uC0C8\uB85C \uACE0\uCE60 \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\uD398\uC774\uC9C0 \uC0C8\uB85C \uACE0\uCE58\uAE30",
    'embedded.confluence.need-to-log-in-paragraph': "\uC774 \uD398\uC774\uC9C0\uB97C \uBCF4\uB824\uBA74 \uB85C\uADF8\uC778\uD574\uC57C \uD569\uB2C8\uB2E4",
    'embedded.confluence.still-having-trouble-paragraph': "\uC544\uC9C1 \uBB38\uC81C\uAC00 \uC788\uC2B5\uB2C8\uAE4C? \uD0C0\uC0AC \uCFE0\uD0A4\uB97C \uC0AC\uC6A9\uC73C\uB85C \uC124\uC815\uD588\uB294\uC9C0 \uD655\uC778\uD558\uAC70\uB098 {link}",
    'embedded.confluence.troubleshooting-link-text': "\uBB38\uC81C \uD574\uACB0 \uAC00\uC774\uB4DC\uB97C \uCC38\uC870\uD558\uC138\uC694.",
    'embedded.confluence.troubleshooting-link.aria-label': "\uBB38\uC81C \uD574\uACB0 \uAC00\uC774\uB4DC \uB9C1\uD06C"
};

});


parcelRegister("eH7fu", function(module, exports) {
$parcel$export(module.exports, "default", () => $7330580a4a4d58c7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $6njdR = parcelRequire("6njdR");
var $7330580a4a4d58c7$export$2e2bcd8739ae039 = (0, $6njdR.default);

});
parcelRegister("6njdR", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebcf052d0bd9e2ed$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Norwegian (Bokmål)
var $ebcf052d0bd9e2ed$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Vi har sett overalt, men dette innholdet eksisterer ikke. Det kan ha blitt slettet. Med mindre nettadressen har en skrivefeil \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Vi finner ikke det du leter etter',
    'embedded.confluence.already-logged-in-paragraph': "Er du allerede logget p\xe5? Pr\xf8v \xe5 oppdatere.",
    'embedded.confluence.footer.hover.text': 'Vis i Confluence',
    'embedded.confluence.footer.prefix': 'Levert av',
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Logg p\xe5 Confluence",
    'embedded.confluence.login-page.login-button': "Logg p\xe5 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "P\xe5loggingsknapp",
    'embedded.confluence.login-page.login-text': "Du m\xe5 v\xe6re logget p\xe5 for \xe5 se denne siden",
    'embedded.confluence.login-page.refresh-page-banner': "Etter p\xe5logging skal denne siden oppdateres automatisk. Hvis ikke, kan du klikke her for \xe5 oppdatere",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Oppdater siden',
    'embedded.confluence.need-to-log-in-paragraph': "Du m\xe5 v\xe6re logget p\xe5 for \xe5 se denne siden",
    'embedded.confluence.still-having-trouble-paragraph': 'Har du fortsatt problemer? Kontroller at tredjeparts informasjonskapsler er aktivert, eller {link}',
    'embedded.confluence.troubleshooting-link-text': "se denne feils\xf8kingsveiledningen.",
    'embedded.confluence.troubleshooting-link.aria-label': "kobling til feils\xf8kingsveiledning"
};

});


parcelRegister("l7lfL", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c1d040700f00b70$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $3lN6l = parcelRequire("3lN6l");
var $7c1d040700f00b70$export$2e2bcd8739ae039 = (0, $3lN6l.default);

});
parcelRegister("3lN6l", function(module, exports) {
$parcel$export(module.exports, "default", () => $758a1d2aec1019fe$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $758a1d2aec1019fe$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "We hebben overal gezocht, maar de pagina bestaat niet. Het kan zijn dat deze verwijderd is. Tenzij de URL een typefout bevat \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'We konden niet vinden wat je zocht',
    'embedded.confluence.already-logged-in-paragraph': 'Al ingelogd? Probeer te vernieuwen.',
    'embedded.confluence.footer.hover.text': 'Weergeven in Confluence',
    'embedded.confluence.footer.prefix': 'Mogelijk gemaakt door',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Inloggen bij Confluence',
    'embedded.confluence.login-page.login-button': 'Inloggen bij Confluence',
    'embedded.confluence.login-page.login-button.aria-label': 'Login-knop',
    'embedded.confluence.login-page.login-text': 'Je moet ingelogd zijn om deze pagina te bekijken',
    'embedded.confluence.login-page.refresh-page-banner': 'Nadat je bent ingelogd, moet deze pagina automatisch vernieuwen. Als dit niet gebeurt, kun je hier klikken om te vernieuwen',
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Pagina vernieuwen',
    'embedded.confluence.need-to-log-in-paragraph': 'Je moet ingelogd zijn om deze pagina te bekijken',
    'embedded.confluence.still-having-trouble-paragraph': 'Nog steeds niet gelukt? Zorg ervoor dat cookies van derden zijn ingeschakeld of {link}',
    'embedded.confluence.troubleshooting-link-text': 'raadpleeg deze handleiding voor probleemoplossing.',
    'embedded.confluence.troubleshooting-link.aria-label': 'link naar handleiding voor probleemoplossing'
};

});


parcelRegister("kVt9O", function(module, exports) {
$parcel$export(module.exports, "default", () => $59190d84e18fa7cf$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $3eKOc = parcelRequire("3eKOc");
var $59190d84e18fa7cf$export$2e2bcd8739ae039 = (0, $3eKOc.default);

});
parcelRegister("3eKOc", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4da433e029a4a52$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Polish (Poland)
var $c4da433e029a4a52$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Szukali\u015Bmy tej strony wsz\u0119dzie, ale nigdzie jej nie ma. Mo\u017Cliwe, \u017Ce\xa0zosta\u0142a usuni\u0119ta. O\xa0ile, oczywi\u015Bcie, do\xa0adresu URL nie wkrad\u0142a si\u0119 liter\xf3wka \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Nie mo\u017Cna znale\u017A\u0107 tego, czego szukasz",
    'embedded.confluence.already-logged-in-paragraph': "Ju\u017C przeprowadzono logowanie? Spr\xf3buj od\u015Bwie\u017Cy\u0107.",
    'embedded.confluence.footer.hover.text': "Wy\u015Bwietl w Confluence",
    'embedded.confluence.footer.prefix': "Obs\u0142ugiwane przez",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Zaloguj si\u0119 w Confluence",
    'embedded.confluence.login-page.login-button': "Zaloguj si\u0119 w systemie Confluence",
    'embedded.confluence.login-page.login-button.aria-label': 'Przycisk logowania',
    'embedded.confluence.login-page.login-text': "Musisz si\u0119 zalogowa\u0107, aby wy\u015Bwietli\u0107 t\u0119 stron\u0119.",
    'embedded.confluence.login-page.refresh-page-banner': "Po zalogowaniu ta strona powinna od\u015Bwie\u017Cy\u0107 si\u0119 automatycznie. Je\u015Bli tak si\u0119 nie stanie, kliknij tutaj, aby od\u015Bwie\u017Cy\u0107.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Od\u015Bwie\u017C stron\u0119",
    'embedded.confluence.need-to-log-in-paragraph': "Musisz si\u0119 zalogowa\u0107, aby wy\u015Bwietli\u0107 t\u0119 stron\u0119.",
    'embedded.confluence.still-having-trouble-paragraph': "Nadal masz problem? Upewnij si\u0119, \u017Ce obs\u0142uga plik\xf3w cookie innych firm jest w\u0142\u0105czona lub {link}.",
    'embedded.confluence.troubleshooting-link-text': "zapoznaj si\u0119 z tym przewodnikiem rozwi\u0105zywania problem\xf3w",
    'embedded.confluence.troubleshooting-link.aria-label': "\u0142\u0105cze do przewodnika rozwi\u0105zywania problem\xf3w"
};

});


parcelRegister("3y1AS", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ab2a9e1d0cdcb98$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $Z01Pj = parcelRequire("Z01Pj");
var $3ab2a9e1d0cdcb98$export$2e2bcd8739ae039 = (0, $Z01Pj.default);

});
parcelRegister("Z01Pj", function(module, exports) {
$parcel$export(module.exports, "default", () => $f98b0e2c7a5a4e37$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $f98b0e2c7a5a4e37$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "A gente procurou em todo lugar, mas ela n\xe3o existe. Talvez tenha sido exclu\xedda. A menos, \xe9 claro, que o URL contenha um erro de digita\xe7\xe3o \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "N\xe3o foi poss\xedvel encontrar o que voc\xea est\xe1 procurando",
    'embedded.confluence.already-logged-in-paragraph': "J\xe1 entrou? Experimente atualizar.",
    'embedded.confluence.footer.hover.text': 'Visualizar no Confluence',
    'embedded.confluence.footer.prefix': "Distribu\xeddo por",
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Entrar no Confluence',
    'embedded.confluence.login-page.login-button': 'Entrar no Confluence',
    'embedded.confluence.login-page.login-button.aria-label': "Bot\xe3o Entrar",
    'embedded.confluence.login-page.login-text': "Voc\xea precisa entrar para ver esta p\xe1gina",
    'embedded.confluence.login-page.refresh-page-banner': "Depois do login, a atualiza\xe7\xe3o da p\xe1gina \xe9 autom\xe1tica. Se isso n\xe3o acontecer, voc\xea pode clicar aqui para atualizar",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Atualizar p\xe1gina",
    'embedded.confluence.need-to-log-in-paragraph': "Voc\xea precisa entrar para ver esta p\xe1gina",
    'embedded.confluence.still-having-trouble-paragraph': "Ainda est\xe1 tendo problemas? Verifique se os cookies de terceiros est\xe3o habilitados ou {link}",
    'embedded.confluence.troubleshooting-link-text': "consulte este guia de solu\xe7\xe3o de problemas.",
    'embedded.confluence.troubleshooting-link.aria-label': "link do guia de solu\xe7\xe3o de problemas"
};

});


parcelRegister("4Acex", function(module, exports) {
$parcel$export(module.exports, "default", () => $d362b357a0285c12$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $5ak3O = parcelRequire("5ak3O");
var $d362b357a0285c12$export$2e2bcd8739ae039 = (0, $5ak3O.default);

});
parcelRegister("5ak3O", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d90428c652fb203$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $4d90428c652fb203$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u041C\u044B \u0438\u0441\u043A\u0430\u043B\u0438 \u043F\u043E\u0432\u0441\u044E\u0434\u0443, \u043D\u043E \u0442\u0430\u043A\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442. \u0412\u043E\u0437\u043C\u043E\u0436\u043D\u043E, \u043E\u043D\u0430 \u0431\u044B\u043B\u0430 \u0443\u0434\u0430\u043B\u0435\u043D\u0430. \u0415\u0441\u043B\u0438, \u043A\u043E\u043D\u0435\u0447\u043D\u043E, URL-\u0430\u0434\u0440\u0435\u0441 \u0443\u043A\u0430\u0437\u0430\u043D \u0432\u0435\u0440\u043D\u043E \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043D\u0430\u0439\u0442\u0438 \u0442\u043E, \u0447\u0442\u043E \u0432\u044B \u0438\u0449\u0435\u0442\u0435",
    'embedded.confluence.already-logged-in-paragraph': "\u0412\u044B \u0443\u0436\u0435 \u0432\u043E\u0448\u043B\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443? \u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443.",
    'embedded.confluence.footer.hover.text': "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0432 Confluence",
    'embedded.confluence.footer.prefix': "\u041F\u0440\u0438 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0435",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u0412\u043E\u0439\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.login-page.login-button': "\u0412\u043E\u0439\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u041A\u043D\u043E\u043F\u043A\u0430 \u0432\u0445\u043E\u0434\u0430",
    'embedded.confluence.login-page.login-text': "\u0414\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u044D\u0442\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
    'embedded.confluence.login-page.refresh-page-banner': "\u041F\u043E\u0441\u043B\u0435 \u0432\u0445\u043E\u0434\u0430 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C\u0441\u044F. \u0415\u0441\u043B\u0438 \u044D\u0442\u043E\u0433\u043E \u043D\u0435 \u043F\u0440\u043E\u0438\u0437\u043E\u0439\u0434\u0435\u0442, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u0437\u0434\u0435\u0441\u044C, \u0447\u0442\u043E\u0431\u044B \u0435\u0435 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443",
    'embedded.confluence.need-to-log-in-paragraph': "\u0414\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u044D\u0442\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
    'embedded.confluence.still-having-trouble-paragraph': "\u041F\u0440\u043E\u0431\u043B\u0435\u043C\u0430 \u043D\u0435 \u0438\u0441\u0447\u0435\u0437\u043B\u0430? \u0423\u0431\u0435\u0434\u0438\u0442\u0435\u0441\u044C, \u0447\u0442\u043E \u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0438\u0435 \u0444\u0430\u0439\u043B\u044B cookie \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u044B, \u0438\u043B\u0438 {link}",
    'embedded.confluence.troubleshooting-link-text': "\u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u043A \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u0443 \u043F\u043E \u0443\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u044E \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A.",
    'embedded.confluence.troubleshooting-link.aria-label': "\u0441\u0441\u044B\u043B\u043A\u0430 \u043D\u0430 \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u043E \u043F\u043E \u0443\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u044E \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A"
};

});


parcelRegister("58fJs", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ccd764260524525$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $eiLYJ = parcelRequire("eiLYJ");
var $7ccd764260524525$export$2e2bcd8739ae039 = (0, $eiLYJ.default);

});
parcelRegister("eiLYJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d587b136dfe8dd7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $4d587b136dfe8dd7$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Vi tittade \xf6verallt, men den finns bara inte. Den kan ha raderats. S\xe5vida webbadressen inte inneh\xe5ller n\xe5got stavfel \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Vi hittar inte det du letar efter',
    'embedded.confluence.already-logged-in-paragraph': "\xc4r du redan inloggad? Uppdatera sidan.",
    'embedded.confluence.footer.hover.text': 'Visa i Confluence',
    'embedded.confluence.footer.prefix': 'Drivs av',
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Logga in p\xe5 Confluence",
    'embedded.confluence.login-page.login-button': "Logga in p\xe5 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': 'Inloggningsknapp',
    'embedded.confluence.login-page.login-text': "Du m\xe5ste vara inloggad f\xf6r att visa den h\xe4r sidan",
    'embedded.confluence.login-page.refresh-page-banner': "Den h\xe4r sidan b\xf6r uppdateras automatiskt efter inloggningen. Annars kan du klicka h\xe4r f\xf6r att uppdatera den",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Uppdatera sidan',
    'embedded.confluence.need-to-log-in-paragraph': "Du m\xe5ste vara inloggad f\xf6r att visa den h\xe4r sidan",
    'embedded.confluence.still-having-trouble-paragraph': "Har du fortfarande problem? Se till att cookies f\xf6r tredje parter \xe4r aktiverade, eller {link}",
    'embedded.confluence.troubleshooting-link-text': "kolla in den h\xe4r fels\xf6kningsguiden.",
    'embedded.confluence.troubleshooting-link.aria-label': "l\xe4nk till fels\xf6kningsguide"
};

});


parcelRegister("bx5pz", function(module, exports) {
$parcel$export(module.exports, "default", () => $3120bf23cb5625af$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $aT0sX = parcelRequire("aT0sX");
var $3120bf23cb5625af$export$2e2bcd8739ae039 = (0, $aT0sX.default);

});
parcelRegister("aT0sX", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b61e557bbfdc46d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Thai (Thailand)
var $9b61e557bbfdc46d$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u0E40\u0E23\u0E32\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E17\u0E38\u0E01\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27 \u0E41\u0E15\u0E48\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23 \u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2D\u0E32\u0E08\u0E16\u0E39\u0E01\u0E25\u0E1A\u0E2D\u0E2D\u0E01\u0E44\u0E1B\u0E41\u0E25\u0E49\u0E27 \u0E2B\u0E23\u0E37\u0E2D\u0E2D\u0E32\u0E08\u0E21\u0E35\u0E01\u0E32\u0E23\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E1C\u0E34\u0E14\u0E43\u0E19 URL \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E2A\u0E34\u0E48\u0E07\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E04\u0E49\u0E19\u0E2B\u0E32",
    'embedded.confluence.already-logged-in-paragraph': "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E41\u0E25\u0E49\u0E27\u0E43\u0E0A\u0E48\u0E44\u0E2B\u0E21 \u0E25\u0E2D\u0E07\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E2B\u0E19\u0E49\u0E32",
    'embedded.confluence.footer.hover.text': "\u0E14\u0E39\u0E43\u0E19 Confluence",
    'embedded.confluence.footer.prefix': "\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19\u0E42\u0E14\u0E22",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A Confluence",
    'embedded.confluence.login-page.login-button': "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u0E1B\u0E38\u0E48\u0E21\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A",
    'embedded.confluence.login-page.login-text': "\u0E04\u0E38\u0E13\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E39\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49",
    'embedded.confluence.login-page.refresh-page-banner': "\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E41\u0E25\u0E49\u0E27 \u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E19\u0E35\u0E49\u0E04\u0E27\u0E23\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34 \u0E2B\u0E32\u0E01\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34 \u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E04\u0E25\u0E34\u0E01\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
    'embedded.confluence.need-to-log-in-paragraph': "\u0E04\u0E38\u0E13\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E39\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49",
    'embedded.confluence.still-having-trouble-paragraph': "\u0E22\u0E31\u0E07\u0E04\u0E07\u0E21\u0E35\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E43\u0E0A\u0E48\u0E44\u0E2B\u0E21 \u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E04\u0E38\u0E01\u0E01\u0E35\u0E49\u0E02\u0E2D\u0E07\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21\u0E2D\u0E22\u0E39\u0E48 \u0E2B\u0E23\u0E37\u0E2D {link}",
    'embedded.confluence.troubleshooting-link-text': "\u0E14\u0E39\u0E17\u0E35\u0E48\u0E04\u0E39\u0E48\u0E21\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E19\u0E35\u0E49",
    'embedded.confluence.troubleshooting-link.aria-label': "\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E04\u0E39\u0E48\u0E21\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32"
};

});


parcelRegister("51Th6", function(module, exports) {
$parcel$export(module.exports, "default", () => $3821fef51ef12bba$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $fx6jl = parcelRequire("fx6jl");
var $3821fef51ef12bba$export$2e2bcd8739ae039 = (0, $fx6jl.default);

});
parcelRegister("fx6jl", function(module, exports) {
$parcel$export(module.exports, "default", () => $695eab6677f02e30$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Turkish (Turkey)
var $695eab6677f02e30$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Her yere bakt\u0131k fakat bulamad\u0131k. Silinmi\u015F olabilir. Tabii e\u011Fer URL'de bir yaz\u0131m hatas\u0131 yoksa \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Arad\u0131\u011F\u0131n\u0131z bulunamad\u0131",
    'embedded.confluence.already-logged-in-paragraph': "Oturumunuz zaten a\xe7\u0131k m\u0131? Sayfay\u0131 yenilemeyi deneyin.",
    'embedded.confluence.footer.hover.text': "Confluence'ta g\xf6r\xfcnt\xfcleyin",
    'embedded.confluence.footer.prefix': "Sa\u011Flayan:",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Confluence'ta oturum a\xe7",
    'embedded.confluence.login-page.login-button': "Confluence'ta oturum a\xe7",
    'embedded.confluence.login-page.login-button.aria-label': "Oturum A\xe7ma D\xfc\u011Fmesi",
    'embedded.confluence.login-page.login-text': "Bu sayfay\u0131 g\xf6r\xfcnt\xfclemek i\xe7in oturum a\xe7man\u0131z gerekir",
    'embedded.confluence.login-page.refresh-page-banner': "Oturum a\xe7t\u0131ktan sonra bu sayfa otomatik olarak yenilenmelidir. Yenilenmezse buraya t\u0131klayarak yenileyebilirsiniz",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Sayfay\u0131 yenile",
    'embedded.confluence.need-to-log-in-paragraph': "Bu sayfay\u0131 g\xf6r\xfcnt\xfclemek i\xe7in oturum a\xe7man\u0131z gerekir",
    'embedded.confluence.still-having-trouble-paragraph': "Sorun ya\u015Famaya devam m\u0131 ediyorsunuz? \xdc\xe7\xfcnc\xfc taraf \xe7erezlerinin etkinle\u015Ftirildi\u011Finden emin olun ya da {link}",
    'embedded.confluence.troubleshooting-link-text': "bu sorun giderme k\u0131lavuzuna ba\u015Fvurun",
    'embedded.confluence.troubleshooting-link.aria-label': "sorun giderme k\u0131lavuzu ba\u011Flant\u0131s\u0131"
};

});


parcelRegister("as5hN", function(module, exports) {
$parcel$export(module.exports, "default", () => $260840fde2c1280c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $ll0mb = parcelRequire("ll0mb");
var $260840fde2c1280c$export$2e2bcd8739ae039 = (0, $ll0mb.default);

});
parcelRegister("ll0mb", function(module, exports) {
$parcel$export(module.exports, "default", () => $bca0ed95888e2625$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Ukrainian (Ukraine)
var $bca0ed95888e2625$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u041D\u0430 \u0436\u0430\u043B\u044C, \u043D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E. \u041C\u043E\u0436\u043B\u0438\u0432\u043E, \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0431\u0443\u043B\u043E \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E. \u042F\u043A\u0449\u043E, \u0437\u0432\u0456\u0441\u043D\u043E, \u0432 URL-\u0430\u0434\u0440\u0435\u0441\u0456 \u043D\u0435\u043C\u0430\u0454 \u043F\u043E\u043C\u0438\u043B\u043A\u0438 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u041D\u0430 \u0436\u0430\u043B\u044C, \u0437\u0430 \u0432\u0430\u0448\u0438\u043C \u0437\u0430\u043F\u0438\u0442\u043E\u043C \u043D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    'embedded.confluence.already-logged-in-paragraph': "\u0423\u0436\u0435 \u0432\u0432\u0456\u0439\u0448\u043B\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443? \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043E\u043D\u043E\u0432\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443.",
    'embedded.confluence.footer.hover.text': "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.footer.prefix': "\u041D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0456",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u0423\u0432\u0456\u0439\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.login-page.login-button': "\u0423\u0432\u0456\u0439\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u041A\u043D\u043E\u043F\u043A\u0430 \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0443",
    'embedded.confluence.login-page.login-text': "\u0429\u043E\u0431 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0446\u044E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443, \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0432\u0456\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
    'embedded.confluence.login-page.refresh-page-banner': "\u041F\u0456\u0441\u043B\u044F \u0432\u0445\u043E\u0434\u0443 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443 \u0446\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430 \u043E\u043D\u043E\u0432\u043B\u044E\u0432\u0430\u0442\u0438\u043C\u0435\u0442\u044C\u0441\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E. \u042F\u043A\u0449\u043E \u043D\u0456, \u0432\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u043D\u0430\u0442\u0438\u0441\u043D\u0443\u0442\u0438 \u0442\u0443\u0442, \u0449\u043E\u0431 \u043E\u043D\u043E\u0432\u0438\u0442\u0438 \u0457\u0457",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u041E\u043D\u043E\u0432\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443",
    'embedded.confluence.need-to-log-in-paragraph': "\u0429\u043E\u0431 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0446\u044E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443, \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0432\u0456\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
    'embedded.confluence.still-having-trouble-paragraph': "\u0414\u043E\u0441\u0456 \u0432\u0438\u043D\u0438\u043A\u0430\u044E\u0442\u044C \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0438? \u041F\u0435\u0440\u0435\u043A\u043E\u043D\u0430\u0439\u0442\u0435\u0441\u044F, \u0449\u043E \u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0456 \u0444\u0430\u0439\u043B\u0438 cookie \u0432\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u043E, \u0430\u0431\u043E {link}.",
    'embedded.confluence.troubleshooting-link-text': "\u0441\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u0439\u0442\u0435\u0441\u044F \u0446\u0438\u043C \u043F\u043E\u0441\u0456\u0431\u043D\u0438\u043A\u043E\u043C \u0437 \u0443\u0441\u0443\u043D\u0435\u043D\u043D\u044F \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A",
    'embedded.confluence.troubleshooting-link.aria-label': "\u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043D\u0430 \u043F\u043E\u0441\u0456\u0431\u043D\u0438\u043A \u0437 \u0443\u0441\u0443\u043D\u0435\u043D\u043D\u044F \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A"
};

});


parcelRegister("j2XGC", function(module, exports) {
$parcel$export(module.exports, "default", () => $059c2748b9112f30$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $b6xoa = parcelRequire("b6xoa");
var $059c2748b9112f30$export$2e2bcd8739ae039 = (0, $b6xoa.default);

});
parcelRegister("b6xoa", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6d3e0f1c67bfee9$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Vietnamese (Vietnam)
var $d6d3e0f1c67bfee9$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Ch\xfang t\xf4i \u0111\xe3 t\xecm kh\u1EAFp n\u01A1i nh\u01B0ng n\u1ED9i dung n\xe0y kh\xf4ng t\u1ED3n t\u1EA1i. N\u1ED9i dung n\xe0y c\xf3 th\u1EC3 \u0111\xe3 b\u1ECB x\xf3a. Tr\u1EEB phi c\xf3 l\u1ED7i \u0111\xe1nh m\xe1y trong URL \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Ch\xfang t\xf4i kh\xf4ng t\xecm \u0111\u01B0\u1EE3c nh\u1EEFng g\xec b\u1EA1n mu\u1ED1n",
    'embedded.confluence.already-logged-in-paragraph': "B\u1EA1n \u0111\xe3 \u0111\u0103ng nh\u1EADp? H\xe3y th\u1EED l\xe0m m\u1EDBi.",
    'embedded.confluence.footer.hover.text': 'Xem trong Confluence',
    'embedded.confluence.footer.prefix': "\u0110\u01B0\u1EE3c h\u1ED7 tr\u1EE3 b\u1EDFi",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u0110\u0103ng nh\u1EADp v\xe0o Confluence",
    'embedded.confluence.login-page.login-button': "\u0110\u0103ng nh\u1EADp v\xe0o Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "N\xfat \u0110\u0103ng nh\u1EADp",
    'embedded.confluence.login-page.login-text': "B\u1EA1n c\u1EA7n \u0111\u0103ng nh\u1EADp \u0111\u1EC3 xem trang n\xe0y",
    'embedded.confluence.login-page.refresh-page-banner': "Sau khi \u0111\u0103ng nh\u1EADp, trang n\xe0y s\u1EBD t\u1EF1 \u0111\u1ED9ng l\xe0m m\u1EDBi. N\u1EBFu kh\xf4ng, b\u1EA1n c\xf3 th\u1EC3 b\u1EA5m v\xe0o \u0111\xe2y \u0111\u1EC3 l\xe0m m\u1EDBi",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "L\xe0m m\u1EDBi trang",
    'embedded.confluence.need-to-log-in-paragraph': "B\u1EA1n c\u1EA7n \u0111\u0103ng nh\u1EADp \u0111\u1EC3 xem trang n\xe0y",
    'embedded.confluence.still-having-trouble-paragraph': "B\u1EA1n v\u1EABn g\u1EB7p s\u1EF1 c\u1ED1? \u0110\u1EA3m b\u1EA3o b\u1EA1n \u0111\xe3 b\u1EADt c\xe1c cookie c\u1EE7a b\xean th\u1EE9 3 ho\u1EB7c {link}",
    'embedded.confluence.troubleshooting-link-text': "tham kh\u1EA3o h\u01B0\u1EDBng d\u1EABn kh\u1EAFc ph\u1EE5c s\u1EF1 c\u1ED1 n\xe0y.",
    'embedded.confluence.troubleshooting-link.aria-label': "li\xean k\u1EBFt h\u01B0\u1EDBng d\u1EABn kh\u1EAFc ph\u1EE5c s\u1EF1 c\u1ED1"
};

});


parcelRegister("7Jhnh", function(module, exports) {
$parcel$export(module.exports, "default", () => $a82f2f9d22e068f9$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $d1LQj = parcelRequire("d1LQj");
var $a82f2f9d22e068f9$export$2e2bcd8739ae039 = (0, $d1LQj.default);

});
parcelRegister("d1LQj", function(module, exports) {
$parcel$export(module.exports, "default", () => $de006bcaad3f1476$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Simplified)
var $de006bcaad3f1476$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u6211\u4EEC\u5DF2\u56DB\u5904\u5BFB\u627E\uFF0C\u4F46\u5B83\u5E76\u4E0D\u5B58\u5728\u3002\u5B83\u53EF\u80FD\u5DF2\u88AB\u5220\u9664\u3002\u9664\u975E\u60A8\u7684 URL \u5305\u542B\u9519\u522B\u5B57 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u672A\u627E\u5230\u60A8\u8981\u67E5\u627E\u7684\u9875\u9762",
    'embedded.confluence.already-logged-in-paragraph': "\u5DF2\u767B\u5F55\uFF1F\u8BF7\u5C1D\u8BD5\u5237\u65B0\u3002",
    'embedded.confluence.footer.hover.text': "\u5728 Confluence \u4E2D\u67E5\u770B",
    'embedded.confluence.footer.prefix': "\u6280\u672F\u652F\u6301\uFF1A",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u767B\u5F55\u5230 Confluence",
    'embedded.confluence.login-page.login-button': "\u767B\u5F55 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u767B\u5F55\u6309\u94AE",
    'embedded.confluence.login-page.login-text': "\u60A8\u9700\u8981\u767B\u5F55\u624D\u80FD\u67E5\u770B\u6B64\u9875\u9762",
    'embedded.confluence.login-page.refresh-page-banner': "\u767B\u5F55\u540E\uFF0C\u6B64\u9875\u9762\u5E94\u4F1A\u81EA\u52A8\u5237\u65B0\u3002\u5982\u679C\u672A\u5237\u65B0\uFF0C\u60A8\u53EF\u4EE5\u70B9\u51FB\u6B64\u5904\u8FDB\u884C\u5237\u65B0",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u5237\u65B0\u9875\u9762",
    'embedded.confluence.need-to-log-in-paragraph': "\u60A8\u9700\u8981\u767B\u5F55\u624D\u80FD\u67E5\u770B\u6B64\u9875\u9762",
    'embedded.confluence.still-having-trouble-paragraph': "\u4ECD\u6709\u95EE\u9898\uFF1F\u8BF7\u786E\u4FDD\u5DF2\u542F\u7528\u7B2C\u4E09\u65B9 Cookie\uFF0C\u6216{link}",
    'embedded.confluence.troubleshooting-link-text': "\u53C2\u9605\u6B64\u6545\u969C\u6392\u9664\u6307\u5357\u3002",
    'embedded.confluence.troubleshooting-link.aria-label': "\u6545\u969C\u6392\u9664\u6307\u5357\u94FE\u63A5"
};

});


parcelRegister("4c8fI", function(module, exports) {
$parcel$export(module.exports, "default", () => $63ee6546956b609d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $8sNnA = parcelRequire("8sNnA");
var $63ee6546956b609d$export$2e2bcd8739ae039 = (0, $8sNnA.default);

});
parcelRegister("8sNnA", function(module, exports) {
$parcel$export(module.exports, "default", () => $986beac2870673da$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $986beac2870673da$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u6211\u5011\u5DF2\u627E\u904D\u56DB\u8655\uFF0C\u4F46\u8A72\u7DB2\u9801\u4F3C\u4E4E\u4E0D\u5B58\u5728\uFF0C\u53EF\u80FD\u5DF2\u906D\u5230\u522A\u9664\u3002\u7576\u7136\uFF0C\u9664\u975E URL \u4E2D\u6709\u932F\u5B57 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u6211\u5011\u627E\u4E0D\u5230\u60A8\u8981\u5C0B\u627E\u7684\u5167\u5BB9",
    'embedded.confluence.already-logged-in-paragraph': "\u5DF2\u7D93\u767B\u5165\u4E86\u55CE\uFF1F\u8ACB\u5617\u8A66\u91CD\u65B0\u6574\u7406\u3002",
    'embedded.confluence.footer.hover.text': "\u5728 Confluence \u4E2D\u6AA2\u8996",
    'embedded.confluence.footer.prefix': "\u7531\u4EE5\u4E0B\u6280\u8853\u652F\u63F4\uFF1A",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u767B\u5165 Confluence",
    'embedded.confluence.login-page.login-button': "\u767B\u5165 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u767B\u5165\u6309\u9215",
    'embedded.confluence.login-page.login-text': "\u60A8\u9700\u8981\u767B\u5165\u624D\u80FD\u6AA2\u8996\u6B64\u9801\u9762",
    'embedded.confluence.login-page.refresh-page-banner': "\u767B\u5165\u5F8C\uFF0C\u6B64\u9801\u9762\u61C9\u8A72\u6703\u81EA\u52D5\u91CD\u65B0\u6574\u7406\u3002\u5982\u679C\u6C92\u6709\uFF0C\u60A8\u53EF\u4EE5\u6309\u4E00\u4E0B\u9019\u88E1\u9032\u884C\u91CD\u65B0\u6574\u7406",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u91CD\u65B0\u6574\u7406\u9801\u9762",
    'embedded.confluence.need-to-log-in-paragraph': "\u60A8\u9700\u8981\u767B\u5165\u624D\u80FD\u6AA2\u8996\u6B64\u9801\u9762",
    'embedded.confluence.still-having-trouble-paragraph': "\u4ECD\u7136\u6709\u554F\u984C\u55CE\uFF1F\u8ACB\u78BA\u5B9A\u60A8\u5DF2\u555F\u7528\u7B2C\u4E09\u65B9 Cookie\uFF0C\u6216{link}",
    'embedded.confluence.troubleshooting-link-text': "\u53C3\u95B1\u6B64\u7591\u96E3\u6392\u89E3\u6307\u5357\u3002",
    'embedded.confluence.troubleshooting-link.aria-label': "\u7591\u96E3\u6392\u89E3\u6307\u5357\u9023\u7D50"
};

});




parcelRegister("aeJ8v", function(module, exports) {
$parcel$export(module.exports, "ViewPage", () => $3780e01b489408ad$export$767e3006bdbb424a);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1gG7v = parcelRequire("1gG7v");

var $99glD = parcelRequire("99glD");

var $6ygIj = parcelRequire("6ygIj");
const $3780e01b489408ad$export$767e3006bdbb424a = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $1gG7v.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $99glD.default),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6ygIj.ViewPage), {
            ...props
        })
    });

});
parcelRegister("6ygIj", function(module, exports) {
$parcel$export(module.exports, "ViewPage", () => $5fbbf37f93ee9e46$export$767e3006bdbb424a);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $WKodS = parcelRequire("WKodS");

var $lRq8t = parcelRequire("lRq8t");
const $5fbbf37f93ee9e46$export$767e3006bdbb424a = (props)=>{
    const { locale: locale } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $WKodS.ViewPage), {
        locale: locale,
        ...props
    });
};

});
parcelRegister("WKodS", function(module, exports) {
$parcel$export(module.exports, "ViewPage", () => $e67592022b9d7732$export$767e3006bdbb424a);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $kpku5 = parcelRequire("kpku5");

var $7kpAG = parcelRequire("7kpAG");

var $1gG7v = parcelRequire("1gG7v");

var $9Mevf = parcelRequire("9Mevf");

var $a9hHS = parcelRequire("a9hHS");
const $e67592022b9d7732$export$767e3006bdbb424a = (props)=>{
    const { markIframeLoadMetrics: markIframeLoadMetrics } = (0, $a9hHS.usePerformanceMetrics)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        markIframeLoadMetrics('lazy-load-end');
        markIframeLoadMetrics('common-load-start');
    }, [
        markIframeLoadMetrics
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1gG7v.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $9Mevf.default),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
            fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7kpAG.PageNotFoundEmptyState), {}),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kpku5.ViewPage), {
                ...props
            })
        })
    });
};

});
parcelRegister("kpku5", function(module, exports) {
$parcel$export(module.exports, "ViewPage", () => $ebe14439aa1e5e9f$export$767e3006bdbb424a);
/* ViewPage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $9N1gM = parcelRequire("9N1gM");

var $jzt0g = parcelRequire("jzt0g");
var $5WPl6 = parcelRequire("5WPl6");
var $j4H4E = parcelRequire("j4H4E");

var $dtPPP = parcelRequire("dtPPP");

var $h4N1w = parcelRequire("h4N1w");
const $ebe14439aa1e5e9f$var$embeddedPageContainerSytles = null;
const $ebe14439aa1e5e9f$var$StyledEmbeddedPageContainer = ({ children: children, containerHeight: containerHeight })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testId": "styled-embedded-page-container-id",
        style: {
            height: containerHeight
        },
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4"
        ]),
        children: children
    });
};
const $ebe14439aa1e5e9f$export$767e3006bdbb424a = (props)=>{
    const { hasFooterLogo: shouldShowFooter, isHeightSetFromContent: isHeightSetFromContent, showFooter: showFooter = true } = props;
    const { height: height } = (0, $j4H4E.useContentSize)();
    (0, $h4N1w.useGetCurrentScrollPosition)(isHeightSetFromContent);
    const contentConfiguration = (0, $eJOHy.useMemo)(()=>({
            experiences: {
                experience: (0, $9N1gM.ExperienceNames).VIEW_PAGE,
                ccExperience: (0, $9N1gM.ExperienceNames).CC_VIEW_PAGE
            },
            getWrapperElement: (children)=>/*#__PURE__*/ (0, $gt9Am.jsx)($ebe14439aa1e5e9f$var$StyledEmbeddedPageContainer, {
                    containerHeight: isHeightSetFromContent ? `${height}px` : '100%',
                    children: children
                }),
            hasFooter: showFooter
        }), [
        isHeightSetFromContent,
        height,
        showFooter
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dtPPP.Content), {
        ...props,
        contentType: (0, $jzt0g.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE,
        mode: (0, $5WPl6.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        contentConfiguration: contentConfiguration,
        isHeightSetFromContent: isHeightSetFromContent,
        shouldShowFooter: shouldShowFooter
    });
};

});
parcelRegister("j4H4E", function(module, exports) {
$parcel$export(module.exports, "useContentSize", () => $565b545c009fdb0d$export$7e7123f55b1139c9);

var $eJOHy = parcelRequire("eJOHy");

var $ihJU2 = parcelRequire("ihJU2");

var $fVw6Q = parcelRequire("fVw6Q");
const $565b545c009fdb0d$var$MESSAGE_TYPE = 'contentSize';
const $565b545c009fdb0d$export$7e7123f55b1139c9 = ()=>{
    // The initial height is arbitrarily set to 1000
    const [height, setHeight] = (0, $eJOHy.useState)(1000);
    /* This visible height refers to the portion of the confluence page that is visible within the iframe without having to scroll.
		When isHeightSetFromContent is true, the embedded page container height toggles between the visible height and the content height
		depending on whether media viewer is open or close.
		This updated was added as a resolution to the bug explained in this ticket: https://hello.jira.atlassian.cloud/browse/CBT-3636
	*/ const { isMediaOpen: isMediaOpen } = (0, $ihJU2.useMediaViewerListener)();
    const { visibleHeight: visibleHeight } = (0, $fVw6Q.useIframeVisibleHeight)();
    (0, $eJOHy.useEffect)(()=>{
        const contentSizeHandler = (postMessage)=>{
            const data = postMessage.data;
            if (data?.type === $565b545c009fdb0d$var$MESSAGE_TYPE && data?.height) setHeight(data.height);
        };
        window.addEventListener('message', contentSizeHandler);
        return ()=>{
            window.removeEventListener('message', contentSizeHandler);
        };
    }, []);
    return {
        height: isMediaOpen ? visibleHeight : height
    };
};

});
parcelRegister("ihJU2", function(module, exports) {
$parcel$export(module.exports, "useMediaViewerListener", () => $223d49139d2165db$export$6d8905296959d5f5);

var $eJOHy = parcelRequire("eJOHy");
const $223d49139d2165db$export$6d8905296959d5f5 = ()=>{
    const [isMediaOpen, setIsMediaOpen] = (0, $eJOHy.useState)(false);
    const mediaMessageListener = (0, $eJOHy.useCallback)((messageEvent)=>{
        const { source: source, event: event } = messageEvent.data ?? {};
        if (!source || !event) return;
        if (source === 'media') switch(event){
            case 'mediaViewerOpened':
                setIsMediaOpen(true);
                break;
            case 'mediaViewerClosed':
                setIsMediaOpen(false);
                break;
            default:
                return;
        }
    }, [
        setIsMediaOpen
    ]);
    (0, $eJOHy.useEffect)(()=>{
        window.addEventListener('message', mediaMessageListener);
        return ()=>window.removeEventListener('message', mediaMessageListener);
    }, [
        mediaMessageListener
    ]);
    return {
        isMediaOpen: isMediaOpen
    };
};

});

parcelRegister("fVw6Q", function(module, exports) {
$parcel$export(module.exports, "useIframeVisibleHeight", () => $7f075dc8231a92d9$export$4b9c38587bbe6e8b);

var $eJOHy = parcelRequire("eJOHy");
const $7f075dc8231a92d9$var$MESSAGE_TYPE = 'embeddedConfluenceVisibleHeight';
const $7f075dc8231a92d9$export$4b9c38587bbe6e8b = ()=>{
    // The initial height is arbitrarily set to 1000
    const [visibleHeight, setVisibleHeight] = (0, $eJOHy.useState)(1000);
    (0, $eJOHy.useEffect)(()=>{
        const contentSizeHandler = (postMessage)=>{
            const data = postMessage.data;
            if (data?.type === $7f075dc8231a92d9$var$MESSAGE_TYPE && data?.value) setVisibleHeight(data.value);
        };
        window.addEventListener('message', contentSizeHandler);
        return ()=>{
            window.removeEventListener('message', contentSizeHandler);
        };
    }, []);
    return {
        visibleHeight: visibleHeight
    };
};

});


parcelRegister("dtPPP", function(module, exports) {
$parcel$export(module.exports, "Content", () => $d5b0b2e5a63ee9d1$export$7c6e2c02157bb7d2);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $leZB9 = parcelRequire("leZB9");
var $geAAj = parcelRequire("geAAj");

var $3c33i = parcelRequire("3c33i");
var $1fDM7 = parcelRequire("1fDM7");

var $dsTxx = parcelRequire("dsTxx");

var $9NPzp = parcelRequire("9NPzp");
var $9T5AC = parcelRequire("9T5AC");
var $j4H4E = parcelRequire("j4H4E");
var $kTRk0 = parcelRequire("kTRk0");
var $dLxPe = parcelRequire("dLxPe");

var $7kpAG = parcelRequire("7kpAG");

var $86oLZ = parcelRequire("86oLZ");

var $lRq8t = parcelRequire("lRq8t");
const $d5b0b2e5a63ee9d1$var$IframeWrapper = ({ children: children, wrapper: wrapper })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: wrapper?.(children) ?? children
    });
// helper to merge iframe refs
function $d5b0b2e5a63ee9d1$var$mergeIframeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (!ref) return;
            if (typeof ref === 'function') ref(value);
            else ref.current = value;
        });
    };
}
const $d5b0b2e5a63ee9d1$export$7c6e2c02157bb7d2 = (props)=>{
    const { spaceKey: spaceKey, contentId: contentId, contentConfiguration: contentConfiguration, navigationPolicy: navigationPolicy, iframeRef: externalIframeRef, onLoad: onLoad, ...passThroughProps } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const experienceTracker = (0, $3c33i.useExperienceTracker)();
    const { experience: experience, ccExperience: ccExperience } = contentConfiguration.experiences;
    (0, $1fDM7.useSetUpExperience)({
        experienceTracker: experienceTracker,
        contentId: contentId,
        spaceKey: spaceKey,
        experience: experience,
        ccExperience: ccExperience
    });
    const { embeddedConfluenceUrl: embeddedConfluenceUrl, standaloneConfluenceUrl: standaloneConfluenceUrl } = (0, $dLxPe.useUrl)(props);
    /**
	 * The difference between hasFooter and hasFooterLogo can be found here
	 * https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/40212/cbt-2587-docs-changeset-ux-add-embedded#comment-428798112
	 *
	 * EDIT 7/17: hasFooterLogo property has been renamed internally for clarity as is now aliased as shouldShowFooter when used internally. Externally, the API remains unchanged.
	 */ const shouldShowFooter = props.hasFooterLogo ?? true;
    const { showFooter: showFooter, footerUrl: footerUrl } = (0, $kTRk0.useFooter)({
        experienceTracker: experienceTracker,
        hasFooter: contentConfiguration.hasFooter,
        shouldShowFooter: shouldShowFooter,
        parentProduct: props.parentProduct,
        standaloneConfluenceUrl: standaloneConfluenceUrl
    });
    const { height: height } = (0, $j4H4E.useContentSize)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $geAAj.ExperienceTrackerContext).Provider, {
        value: experienceTracker,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $leZB9.Experience), {
            name: experience,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9T5AC.PageLoadValidation), {
                ...props,
                children: ({ iframeRef: iframeRef, handleIframeOnLoad: handleIframeOnLoad, handleContentLoadStarted: handleContentLoadStarted, navigationPolicy: navigationPolicy, handleIframeUnload: handleIframeUnload, redirectedToLogin: redirectedToLogin })=>/*#__PURE__*/ (0, $gt9Am.jsxs)($d5b0b2e5a63ee9d1$var$IframeWrapper, {
                        wrapper: contentConfiguration.getWrapperElement,
                        children: [
                            embeddedConfluenceUrl ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dsTxx.Iframe), {
                                ref: $d5b0b2e5a63ee9d1$var$mergeIframeRefs(iframeRef, externalIframeRef),
                                // https://hello.atlassian.net/wiki/spaces/~142157567/pages/2224394268/Spike+on+CBT-1814
                                src: redirectedToLogin ? '' : embeddedConfluenceUrl,
                                ...passThroughProps,
                                navigationPolicy: navigationPolicy,
                                style: {
                                    flex: passThroughProps.isHeightSetFromContent ? `1 0 ${height}px` : '0 1 100%'
                                },
                                onLoad: (e)=>{
                                    handleIframeOnLoad();
                                    onLoad?.(e);
                                },
                                onUnload: handleIframeUnload,
                                onContentLoadStarted: handleContentLoadStarted
                            }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7kpAG.PageNotFoundEmptyState), {}),
                            showFooter && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9NPzp.Footer), {
                                url: footerUrl,
                                linkTooltip: formatMessage((0, $86oLZ.default).viewInConfluence),
                                label: formatMessage((0, $86oLZ.default).poweredBy)
                            })
                        ]
                    })
            })
        })
    });
};

});
parcelRegister("leZB9", function(module, exports) {
$parcel$export(module.exports, "Experience", () => $73ea8c65d9f4cbf9$export$c90b54e658fc4d7c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $71EtM = parcelRequire("71EtM");
function $73ea8c65d9f4cbf9$export$c90b54e658fc4d7c({ children: children, name: name }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $71EtM.ExperienceContext).Provider, {
        value: name,
        children: children
    });
}

});
parcelRegister("71EtM", function(module, exports) {
$parcel$export(module.exports, "ExperienceContext", () => $3c5fdf424c90d492$export$fb99266658f5da06);

var $eJOHy = parcelRequire("eJOHy");
const $3c5fdf424c90d492$var$defaultExperienceContextValue = undefined;
const $3c5fdf424c90d492$export$fb99266658f5da06 = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext($3c5fdf424c90d492$var$defaultExperienceContextValue);

});


parcelRegister("1fDM7", function(module, exports) {
$parcel$export(module.exports, "useSetUpExperience", () => $db6399570e8fe124$export$48d5d434479c259e);

var $eJOHy = parcelRequire("eJOHy");

var $bqu9G = parcelRequire("bqu9G");
const $db6399570e8fe124$export$48d5d434479c259e = ({ experienceTracker: experienceTracker, contentId: contentId, spaceKey: spaceKey, experience: experience, ccExperience: ccExperience })=>{
    const idRef = (0, $eJOHy.useRef)();
    const ccExperienceStartedRef = (0, $eJOHy.useRef)(false);
    const id = `${spaceKey}-${contentId}`;
    /**
	 * Start experience as close to the user action as possible.
	 * Our approximation is component's first render.
	 *
	 * Addition to starting experience on first render, embedding products may do SPA transition e.g. view different contents without remounting component.
	 * We need to re-start experience if `contentId` or `spaceKey` has changed.
	 * In this case, experience will abort the current ongoing one and start a new experience (by checking experience id)
	 */ if (idRef.current !== id) {
        experienceTracker.start({
            name: experience,
            id: id,
            collect (events, experience) {
                if (events.find((event)=>event.action === 'taskStart' && event.name === ccExperience && event.id === contentId)) ccExperienceStartedRef.current = true;
                /**
				 * We have experience forwarding from confluence-frontend
				 * With the forwarding experience set up, EP experience will be concluded following CC experience, either "succeed", "fail" or "abort"
				 */ experience.stopOn(events.find((event)=>(0, $bqu9G.isStop)(event) && event.name === ccExperience && event.id === contentId));
            }
        });
        idRef.current = id;
    }
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            /**
			 * User can navigates away (EP component unmount) before CC experience started
			 * In this case, we want to abort EP experience as the conclusion.
			 */ if (idRef.current && !ccExperienceStartedRef.current) experienceTracker.abort({
                name: experience,
                reason: 'User navigated away before starting to load'
            });
        };
    }, [
        experienceTracker,
        experience
    ]);
};

});
parcelRegister("bqu9G", function(module, exports) {
$parcel$export(module.exports, "isStop", () => $0238ef0add021078$export$16e3f1b03b231b35);
$parcel$export(module.exports, "hasName", () => $0238ef0add021078$export$57069f5b2ecc9128);
const $0238ef0add021078$export$16e3f1b03b231b35 = (event)=>event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail';
const $0238ef0add021078$export$57069f5b2ecc9128 = (event, ...names)=>names.includes(event.name);

});


parcelRegister("dsTxx", function(module, exports) {
$parcel$export(module.exports, "Iframe", () => $3a7d265748869da5$export$5137ec99f248330b);
/* Iframe.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $aE7Ld = parcelRequire("aE7Ld");

var $jY4xY = parcelRequire("jY4xY");

var $a9hHS = parcelRequire("a9hHS");
const $3a7d265748869da5$var$iframeStyles = null;
const $3a7d265748869da5$export$5137ec99f248330b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ src: src, onLoad: onLoad, onUnload: onUnload, onContentLoadStarted: onContentLoadStarted, ...passThroughProps }, ref)=>{
    const { markIframeLoadMetrics: markIframeLoadMetrics } = (0, $a9hHS.usePerformanceMetrics)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        markIframeLoadMetrics('common-load-end');
        markIframeLoadMetrics('iframe-content-initialized-start');
    }, [
        markIframeLoadMetrics
    ]);
    const iframeOnLoad = (0, $eJOHy.useCallback)((event)=>{
        onLoad && onLoad(event);
    }, [
        onLoad
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const handler = (e)=>{
            if (e.data.type === 'windowUnload') onUnload?.();
        };
        window.addEventListener('message', handler);
        return ()=>{
            window.removeEventListener('message', handler);
        };
    }, [
        onUnload
    ]);
    (0, $jY4xY.useHostOffsetOverride)();
    const channel = (0, $aE7Ld.useIframeCommunicationChannel)(src, {
        ...passThroughProps,
        onContentLoadStarted: onContentLoadStarted
    });
    // implementation because cleaner index export is not possible with forwardRef
    return /*#__PURE__*/ (0, $gt9Am.jsx)("iframe", {
        ref: ref,
        title: "confluence-article-iframe",
        "data-testid": "confluence-page-iframe",
        name: channel.name,
        src: src,
        onLoad: iframeOnLoad,
        // Grant features to iframe (Currently the same as smart card iframe's granted features)
        allow: "autoplay; fullscreen; encrypted-media; clipboard-write",
        // Same as "fullscreen" in "allow" attribute but it's considered a legacy attribute. https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe#attr-allowfullscreen
        // Need it in case the browser doesn't support "fullscreen" feature policy.
        allowFullScreen: true,
        ...passThroughProps,
        className: (0, $hcewu.default)([
            "_19itglyw _1bsb1osq _4t3i1osq"
        ])
    });
});

});
parcelRegister("aE7Ld", function(module, exports) {
$parcel$export(module.exports, "useIframeCommunicationChannel", () => $887acbdea6e2eddb$export$c745b3af35ea8585);

var $eJOHy = parcelRequire("eJOHy");

var $geAAj = parcelRequire("geAAj");

var $iNJIt = parcelRequire("iNJIt");

var $kePQU = parcelRequire("kePQU");
let $887acbdea6e2eddb$var$host = null;

// simple-xdm relies on window object. It is not available in SSR.
if (typeof window !== 'undefined') $887acbdea6e2eddb$var$host = (parcelRequire("818E2"));
function $887acbdea6e2eddb$var$defineModule(name, module) {
    $887acbdea6e2eddb$var$host.defineModule(name, module);
}
const $887acbdea6e2eddb$var$useExperienceForwardingModule = ()=>{
    const experienceTrackerRef = (0, $eJOHy.useRef)();
    const experienceTracker = (0, $eJOHy.useContext)((0, $geAAj.ExperienceTrackerContext));
    if (experienceTrackerRef.current !== experienceTracker) {
        $887acbdea6e2eddb$var$defineModule((0, $iNJIt.EXPERIENCE_FORWARDING_MODULE_NAME), {
            start (options) {
                experienceTracker.start(options);
            },
            abort (options) {
                experienceTracker.abort(options);
            },
            succeed (options) {
                experienceTracker.succeed(options);
            },
            fail (options) {
                experienceTracker.fail(options);
            }
        });
        experienceTrackerRef.current = experienceTracker;
    }
};
const $887acbdea6e2eddb$var$usePassThroughPropsModule = (props, uniqueKey)=>{
    const { onContentLoadStarted: onContentLoadStarted, ...passThroughProps } = props;
    const dispatchPropsUpdated = (0, $eJOHy.useCallback)(()=>{
        $887acbdea6e2eddb$var$host.dispatch((0, $iNJIt.PROPS_UPDATED), {
            addon_key: (0, $kePQU.fg)('platform_deprecate_lp_cc_embed') ? uniqueKey : (0, $iNJIt.CHANNEL_NAME),
            ...(0, $kePQU.fg)('platform_deprecate_lp_cc_embed') && {
                key: uniqueKey
            }
        }, {
            message: JSON.stringify(passThroughProps)
        });
    /**
		 * Disable react-hooks/exhaustive-deps linting, the dependency has passThroughProps spreading on its keys and values
		 * This should be able to handle any changes to the `passThroughProps` would recall the effect function.
		 **/ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // eslint-disable-next-line react-hooks/exhaustive-deps
        ...Object.keys(passThroughProps),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        ...Object.values(passThroughProps),
        uniqueKey
    ]);
    const dispatchPropsUpdatedRef = (0, $eJOHy.useRef)();
    if (dispatchPropsUpdatedRef.current !== dispatchPropsUpdated) {
        $887acbdea6e2eddb$var$defineModule((0, $iNJIt.PASSTHROUGH_PROPS_MODULE_NAME), {
            getProps: ()=>{
                onContentLoadStarted?.();
                dispatchPropsUpdated();
            },
            navigationPolicyNavigate: passThroughProps.navigationPolicy?.navigate,
            onPublish: passThroughProps?.onPublish
        });
        dispatchPropsUpdatedRef.current = dispatchPropsUpdated;
    }
    (0, $eJOHy.useEffect)(dispatchPropsUpdated, [
        dispatchPropsUpdated
    ]);
};
function $887acbdea6e2eddb$export$c745b3af35ea8585(iframeSrc, passThroughProps) {
    const channelRef = (0, $eJOHy.useRef)();
    const uniqueKey = (0, $eJOHy.useRef)((0, $iNJIt.createUniqueKey)()).current;
    $887acbdea6e2eddb$var$useExperienceForwardingModule();
    $887acbdea6e2eddb$var$usePassThroughPropsModule(passThroughProps, uniqueKey);
    if (channelRef.current?.src !== iframeSrc) channelRef.current = $887acbdea6e2eddb$var$host.create({
        addon_key: (0, $kePQU.fg)('platform_deprecate_lp_cc_embed') ? uniqueKey : (0, $iNJIt.CHANNEL_NAME),
        key: (0, $kePQU.fg)('platform_deprecate_lp_cc_embed') ? uniqueKey : (0, $iNJIt.CHANNEL_NAME),
        url: iframeSrc,
        options: {
            globalOptions: {},
            hostFrameOffset: 1,
            hostOrigin: window.location.origin
        }
    });
    return channelRef.current;
}

});
parcelRegister("iNJIt", function(module, exports) {
$parcel$export(module.exports, "CHANNEL_NAME", () => $16e7fc7c2e84a1a9$export$ab9998995666ebe3);
$parcel$export(module.exports, "createUniqueKey", () => $16e7fc7c2e84a1a9$export$f2fe03976fe13de);
$parcel$export(module.exports, "PASSTHROUGH_PROPS_MODULE_NAME", () => $16e7fc7c2e84a1a9$export$45b0adb7f9689286);
$parcel$export(module.exports, "PROPS_UPDATED", () => $16e7fc7c2e84a1a9$export$78cada8c8749e264);
$parcel$export(module.exports, "EXPERIENCE_FORWARDING_MODULE_NAME", () => $16e7fc7c2e84a1a9$export$b75934a6b56fd9ba);

var $aXKmr = parcelRequire("aXKmr");
const $16e7fc7c2e84a1a9$export$ab9998995666ebe3 = 'embedded-confluence-iframe';
const $16e7fc7c2e84a1a9$export$f2fe03976fe13de = ()=>{
    return `${$16e7fc7c2e84a1a9$export$ab9998995666ebe3}-${(0, $aXKmr.v4)()}`;
};
const $16e7fc7c2e84a1a9$export$45b0adb7f9689286 = 'passThroughProps';
const $16e7fc7c2e84a1a9$export$78cada8c8749e264 = 'propsUpdated';
const $16e7fc7c2e84a1a9$export$b75934a6b56fd9ba = 'experienceForwarding';

});

parcelRegister("818E2", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _util = _dereq_("./util");
                var _util2 = _interopRequireDefault(_util);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                var PostMessage = function() {
                    function PostMessage(data) {
                        _classCallCheck(this, PostMessage);
                        var d = data || {};
                        this._registerListener(d.listenOn);
                    }
                    _createClass(PostMessage, [
                        {
                            key: "_registerListener",
                            value: function _registerListener(listenOn) {
                                if (!listenOn || !listenOn.addEventListener) listenOn = window;
                                listenOn.addEventListener("message", _util2.default._bind(this, this._receiveMessage), false);
                            }
                        },
                        {
                            key: "_receiveMessage",
                            value: function _receiveMessage(event) {
                                var handler = this._messageHandlers[event.data.type], extensionId = event.data.eid, reg = void 0;
                                if (extensionId && this._registeredExtensions) reg = this._registeredExtensions[extensionId];
                                if (!handler || !this._checkOrigin(event, reg)) return false;
                                handler.call(this, event, reg);
                            }
                        }
                    ]);
                    return PostMessage;
                }();
                exports.default = PostMessage;
                module1.exports = exports["default"];
            },
            {
                "./util": 2
            }
        ],
        2: [
            function(_dereq_, module1, exports) {
                "use strict";
                var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function(obj) {
                    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
                };
                var LOG_PREFIX = "[Simple-XDM] ";
                var nativeBind = Function.prototype.bind;
                var util = {
                    locationOrigin: function locationOrigin() {
                        if (!window.location.origin) return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
                        else return window.location.origin;
                    },
                    randomString: function randomString() {
                        return Math.floor(Math.random() * 1000000000).toString(16);
                    },
                    isString: function isString(str) {
                        return typeof str === "string" || str instanceof String;
                    },
                    argumentsToArray: function argumentsToArray(arrayLike) {
                        return Array.prototype.slice.call(arrayLike);
                    },
                    argumentNames: function argumentNames(fn) {
                        return fn.toString().replace(/((\/\/.*$)|(\/\*[^]*?\*\/))/mg, '') // strip comments
                        .replace(/[^(]+\(([^)]*)[^]+/, '$1') // get signature
                        .match(/([^\s,]+)/g) || [];
                    },
                    hasCallback: function hasCallback(args) {
                        var length = args.length;
                        return length > 0 && typeof args[length - 1] === 'function';
                    },
                    error: function error(msg) {
                        if (window.console && window.console.error) {
                            var outputError = [];
                            if (typeof msg === "string") {
                                outputError.push(LOG_PREFIX + msg);
                                outputError = outputError.concat(Array.prototype.slice.call(arguments, 1));
                            } else {
                                outputError.push(LOG_PREFIX);
                                outputError = outputError.concat(Array.prototype.slice.call(arguments));
                            }
                            window.console.error.apply(null, outputError);
                        }
                    },
                    warn: function warn(msg) {
                        if (window.console) console.warn(LOG_PREFIX + msg);
                    },
                    log: function log(msg) {
                        if (window.console) window.console.log(LOG_PREFIX + msg);
                    },
                    _bind: function _bind(thisp, fn) {
                        if (nativeBind && fn.bind === nativeBind) return fn.bind(thisp);
                        return function() {
                            return fn.apply(thisp, arguments);
                        };
                    },
                    throttle: function throttle(func, wait, context) {
                        var previous = 0;
                        return function() {
                            var now = Date.now();
                            if (now - previous > wait) {
                                previous = now;
                                func.apply(context, arguments);
                            }
                        };
                    },
                    each: function each(list, iteratee) {
                        var length;
                        var key;
                        if (list) {
                            length = list.length;
                            if (length != null && typeof list !== 'function') {
                                key = 0;
                                while(key < length){
                                    if (iteratee.call(list[key], key, list[key]) === false) break;
                                    key += 1;
                                }
                            } else {
                                for(key in list)if (list.hasOwnProperty(key)) {
                                    if (iteratee.call(list[key], key, list[key]) === false) break;
                                }
                            }
                        }
                    },
                    extend: function extend(dest) {
                        var args = arguments;
                        var srcs = [].slice.call(args, 1, args.length);
                        srcs.forEach(function(source) {
                            if ((typeof source === "undefined" ? "undefined" : _typeof(source)) === "object") Object.getOwnPropertyNames(source).forEach(function(name) {
                                dest[name] = source[name];
                            });
                        });
                        return dest;
                    },
                    sanitizeStructuredClone: function sanitizeStructuredClone(object) {
                        var whiteList = [
                            Boolean,
                            String,
                            Date,
                            RegExp,
                            Blob,
                            File,
                            FileList,
                            ArrayBuffer
                        ];
                        var blackList = [
                            Error,
                            Node
                        ];
                        var warn = util.warn;
                        var visitedObjects = [];
                        function _clone(value) {
                            if (typeof value === 'function') {
                                warn("A function was detected and removed from the message.");
                                return null;
                            }
                            if (blackList.some(function(t) {
                                if (value instanceof t) {
                                    warn(t.name + " object was detected and removed from the message.");
                                    return true;
                                }
                                return false;
                            })) return {};
                            if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object' && whiteList.every(function(t) {
                                return !(value instanceof t);
                            })) {
                                var newValue = void 0;
                                if (Array.isArray(value)) newValue = value.map(function(element) {
                                    return _clone(element);
                                });
                                else {
                                    if (visitedObjects.indexOf(value) > -1) {
                                        warn("A circular reference was detected and removed from the message.");
                                        return null;
                                    }
                                    visitedObjects.push(value);
                                    newValue = {};
                                    for(var name in value)if (value.hasOwnProperty(name)) {
                                        var clonedValue = _clone(value[name]);
                                        if (clonedValue !== null) newValue[name] = clonedValue;
                                    }
                                    visitedObjects.pop();
                                }
                                return newValue;
                            }
                            return value;
                        }
                        return _clone(object);
                    },
                    getOrigin: function getOrigin(url, base) {
                        // everything except IE11
                        if (typeof URL === 'function') try {
                            return new URL(url, base).origin;
                        } catch (e) {}
                        // ie11 + safari 10
                        var doc = document.implementation.createHTMLDocument('');
                        if (base) {
                            var baseElement = doc.createElement('base');
                            baseElement.href = base;
                            doc.head.appendChild(baseElement);
                        }
                        var anchorElement = doc.createElement('a');
                        anchorElement.href = url;
                        doc.body.appendChild(anchorElement);
                        var origin = anchorElement.protocol + '//' + anchorElement.hostname;
                        //ie11, only include port if referenced in initial URL
                        if (url.match(/\/\/[^/]+:[0-9]+\//)) origin += anchorElement.port ? ':' + anchorElement.port : '';
                        return origin;
                    }
                };
                exports.default = util;
                module1.exports = exports["default"];
            },
            {}
        ],
        3: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _xdmrpc = _dereq_('./xdmrpc');
                var _xdmrpc2 = _interopRequireDefault(_xdmrpc);
                var _util = _dereq_('../common/util');
                var _util2 = _interopRequireDefault(_util);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                var Connect = function() {
                    function Connect() {
                        _classCallCheck(this, Connect);
                        this._xdm = new _xdmrpc2.default();
                    }
                    /**
   * Send a message to iframes matching the targetSpec. This message is added to
   *  a message queue for delivery to ensure the message is received if an iframe
   *  has not yet loaded
   *
   * @param type The name of the event type
   * @param targetSpec The spec to match against extensions when sending this event
   * @param event The event payload
   * @param callback A callback to be executed when the remote iframe calls its callback
   */ _createClass(Connect, [
                        {
                            key: 'dispatch',
                            value: function dispatch(type, targetSpec, event, callback) {
                                this._xdm.queueEvent(type, targetSpec, event, callback);
                                return this.getExtensions(targetSpec);
                            }
                        },
                        {
                            key: 'broadcast',
                            value: function broadcast(type, targetSpec, event) {
                                this._xdm.dispatch(type, targetSpec, event, null, null);
                                return this.getExtensions(targetSpec);
                            }
                        },
                        {
                            key: '_createId',
                            value: function _createId(extension) {
                                if (!extension.addon_key || !extension.key) throw Error('Extensions require addon_key and key');
                                return extension.addon_key + '__' + extension.key + '__' + _util2.default.randomString();
                            }
                        },
                        {
                            key: 'create',
                            value: function create(extension, initCallback, unloadCallback) {
                                var extension_id = this.registerExtension(extension, initCallback, unloadCallback);
                                var options = extension.options || {};
                                var data = {
                                    extension_id: extension_id,
                                    api: this._xdm.getApiSpec(extension.addon_key),
                                    origin: _util2.default.locationOrigin(),
                                    options: options
                                };
                                return {
                                    id: extension_id,
                                    name: JSON.stringify(data),
                                    src: extension.url
                                };
                            }
                        },
                        {
                            key: 'registerRequestNotifier',
                            value: function registerRequestNotifier(callback) {
                                this._xdm.registerRequestNotifier(callback);
                            }
                        },
                        {
                            key: 'registerExtension',
                            value: function registerExtension(extension, initCallback, unloadCallback) {
                                var extension_id = this._createId(extension);
                                this._xdm.registerExtension(extension_id, {
                                    extension: extension,
                                    initCallback: initCallback,
                                    unloadCallback: unloadCallback
                                });
                                return extension_id;
                            }
                        },
                        {
                            key: 'registerKeyListener',
                            value: function registerKeyListener(extension_id, key, modifiers, callback) {
                                this._xdm.registerKeyListener(extension_id, key, modifiers, callback);
                            }
                        },
                        {
                            key: 'unregisterKeyListener',
                            value: function unregisterKeyListener(extension_id, key, modifiers, callback) {
                                this._xdm.unregisterKeyListener(extension_id, key, modifiers, callback);
                            }
                        },
                        {
                            key: 'registerClickHandler',
                            value: function registerClickHandler(callback) {
                                this._xdm.registerClickHandler(callback);
                            }
                        },
                        {
                            key: 'unregisterClickHandler',
                            value: function unregisterClickHandler() {
                                this._xdm.unregisterClickHandler();
                            }
                        },
                        {
                            key: 'defineModule',
                            value: function defineModule(moduleName, module1, options) {
                                this._xdm.defineAPIModule(module1, moduleName, options);
                            }
                        },
                        {
                            key: 'isModuleDefined',
                            value: function isModuleDefined(moduleName) {
                                return this._xdm.isAPIModuleDefined(moduleName);
                            }
                        },
                        {
                            key: 'defineGlobals',
                            value: function defineGlobals(module1) {
                                this._xdm.defineAPIModule(module1);
                            }
                        },
                        {
                            key: 'getExtensions',
                            value: function getExtensions(filter) {
                                return this._xdm.getRegisteredExtensions(filter);
                            }
                        },
                        {
                            key: 'unregisterExtension',
                            value: function unregisterExtension(filter) {
                                return this._xdm.unregisterExtension(filter);
                            }
                        },
                        {
                            key: 'returnsPromise',
                            value: function returnsPromise(wrappedMethod) {
                                wrappedMethod.returnsPromise = true;
                            }
                        },
                        {
                            key: 'setFeatureFlagGetter',
                            value: function setFeatureFlagGetter(getBooleanFeatureFlag) {
                                this._xdm.setFeatureFlagGetter(getBooleanFeatureFlag);
                            }
                        },
                        {
                            key: 'registerExistingExtension',
                            value: function registerExistingExtension(extension_id, data) {
                                return this._xdm.registerExtension(extension_id, data);
                            }
                        }
                    ]);
                    return Connect;
                }();
                exports.default = Connect;
                module1.exports = exports['default'];
            },
            {
                "../common/util": 2,
                "./xdmrpc": 5
            }
        ],
        4: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _connect = _dereq_('./connect');
                var _connect2 = _interopRequireDefault(_connect);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                exports.default = new _connect2.default();
                module1.exports = exports['default'];
            },
            {
                "./connect": 3
            }
        ],
        5: [
            function(_dereq_, module1, exports) {
                'use strict';
                var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function(obj) {
                    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
                };
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _util = _dereq_('../common/util');
                var _util2 = _interopRequireDefault(_util);
                var _postmessage = _dereq_('../common/postmessage');
                var _postmessage2 = _interopRequireDefault(_postmessage);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _possibleConstructorReturn(self, call) {
                    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return call && ((typeof call === "undefined" ? "undefined" : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof2(superClass)));
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                } /**
  * Postmessage format:
  *
  * Initialization
  * --------------
  * {
  *   type: 'init',
  *   eid: 'my-addon__my-module-xyz'  // the extension identifier, unique across iframes
  * }
  *
  * Request
  * -------
  * {
  *   type: 'req',
  *   eid: 'my-addon__my-module-xyz',  // the extension identifier, unique for iframe
  *   mid: 'xyz',  // a unique message identifier, required for callbacks
  *   mod: 'cookie',  // the module name
  *   fn: 'read',  // the method name
  *   args: [arguments]  // the method arguments
  * }
  *
  * Response
  * --------
  * {
  *   type: 'resp'
  *   eid: 'my-addon__my-module-xyz',  // the extension identifier, unique for iframe
  *   mid: 'xyz',  // a unique message identifier, obtained from the request
  *   args: [arguments]  // the callback arguments
  * }
  *
  * Event
  * -----
  * {
  *   type: 'evt',
  *   etyp: 'some-event',
  *   evnt: { ... }  // the event data
  *   mid: 'xyz', // a unique message identifier for the event
  * }
  **/ 
                var VALID_EVENT_TIME_MS = 30000; //30 seconds
                var XDMRPC = function(_PostMessage) {
                    _inherits(XDMRPC, _PostMessage);
                    _createClass(XDMRPC, [
                        {
                            key: '_padUndefinedArguments',
                            value: function _padUndefinedArguments(array, length) {
                                return array.length >= length ? array : array.concat(new Array(length - array.length));
                            }
                        }
                    ]);
                    function XDMRPC(config) {
                        _classCallCheck(this, XDMRPC);
                        config = config || {};
                        var _this = _possibleConstructorReturn(this, (XDMRPC.__proto__ || Object.getPrototypeOf(XDMRPC)).call(this, config));
                        _this._registeredExtensions = config.extensions || {};
                        _this._registeredAPIModules = {};
                        _this._registeredAPIModules._globals = {};
                        _this._pendingCallbacks = {};
                        _this._keycodeCallbacks = {};
                        _this._clickHandler = null;
                        _this._pendingEvents = {};
                        _this._messageHandlers = {
                            init: _this._handleInit,
                            req: _this._handleRequest,
                            resp: _this._handleResponse,
                            broadcast: _this._handleBroadcast,
                            event_query: _this._handleEventQuery,
                            key_triggered: _this._handleKeyTriggered,
                            addon_clicked: _this._handleAddonClick,
                            get_host_offset: _this._getHostOffset,
                            unload: _this._handleUnload,
                            sub: _this._handleSubInit
                        };
                        return _this;
                    }
                    _createClass(XDMRPC, [
                        {
                            key: '_verifyAPI',
                            value: function _verifyAPI(event, reg) {
                                var untrustedTargets = event.data.targets;
                                if (!untrustedTargets) return;
                                var trustedSpec = this.getApiSpec();
                                var tampered = false;
                                function check(trusted, untrusted) {
                                    Object.getOwnPropertyNames(untrusted).forEach(function(name) {
                                        if (_typeof(untrusted[name]) === 'object' && trusted[name]) check(trusted[name], untrusted[name]);
                                        else if (untrusted[name] === 'parent' && trusted[name]) tampered = true;
                                    });
                                }
                                check(trustedSpec, untrustedTargets);
                                event.source.postMessage({
                                    type: 'api_tamper',
                                    tampered: tampered
                                }, reg.extension.url);
                            }
                        },
                        {
                            key: '_handleInit',
                            value: function _handleInit(event, reg) {
                                event.source.postMessage({
                                    type: 'init_received'
                                }, reg.extension.url);
                                this._registeredExtensions[reg.extension_id].source = event.source;
                                if (reg.initCallback) {
                                    reg.initCallback(event.data.eid);
                                    delete reg.initCallback;
                                }
                                if (event.data.targets) this._verifyAPI(event, reg);
                            }
                        },
                        {
                            key: '_handleSubInit',
                            value: function _handleSubInit(event, reg) {
                                var blocked = reg.extension.options.noSub || this._getBooleanFeatureFlag && this._getBooleanFeatureFlag('com.atlassian.connect.resolve_inner_iframe_url');
                                var data = event.data;
                                if (blocked) _util2.default.error("Sub-Extension requested by [" + reg.extension.addon_key + "] but feature is disabled");
                                else this.registerExtension(data.ext.id, {
                                    extension: data.ext
                                });
                                if (this._registeredRequestNotifier) this._registeredRequestNotifier.call(null, {
                                    sub: data.ext,
                                    type: data.type,
                                    addon_key: reg.extension.addon_key,
                                    key: reg.extension.key,
                                    extension_id: reg.extension_id,
                                    blocked: blocked
                                });
                            }
                        },
                        {
                            key: '_getHostOffset',
                            value: function _getHostOffset(event, _window) {
                                var hostWindow = event.source;
                                var hostFrameOffset = null;
                                var windowReference = _window || window; // For testing
                                if (windowReference === windowReference.top && typeof windowReference.getHostOffsetFunctionOverride === 'function') hostFrameOffset = windowReference.getHostOffsetFunctionOverride(hostWindow);
                                if (typeof hostFrameOffset !== 'number') {
                                    hostFrameOffset = 0;
                                    // Find the closest frame that has the same origin as event source
                                    while(!this._hasSameOrigin(hostWindow)){
                                        // Climb up the iframe tree 1 layer
                                        hostFrameOffset++;
                                        hostWindow = hostWindow.parent;
                                    }
                                }
                                event.source.postMessage({
                                    hostFrameOffset: hostFrameOffset
                                }, event.origin);
                            }
                        },
                        {
                            key: '_hasSameOrigin',
                            value: function _hasSameOrigin(window1) {
                                if (window1 === window1.top) return true;
                                try {
                                    // Try set & read a variable on the given window
                                    // If we can successfully read the value then it means the given window has the same origin
                                    // as the window that is currently executing the script
                                    var testVariableName = 'test_var_' + Math.random().toString(16).substr(2);
                                    window1[testVariableName] = true;
                                    return window1[testVariableName];
                                } catch (e) {
                                // A exception will be thrown if the windows doesn't have the same origin
                                }
                                return false;
                            }
                        },
                        {
                            key: '_handleResponse',
                            value: function _handleResponse(event) {
                                var data = event.data;
                                var pendingCallback = this._pendingCallbacks[data.mid];
                                if (pendingCallback) {
                                    delete this._pendingCallbacks[data.mid];
                                    pendingCallback.apply(window, data.args);
                                }
                            }
                        },
                        {
                            key: 'registerRequestNotifier',
                            value: function registerRequestNotifier(cb) {
                                this._registeredRequestNotifier = cb;
                            }
                        },
                        {
                            key: '_handleRequest',
                            value: function _handleRequest(event, reg) {
                                function sendResponse() {
                                    var args = _util2.default.sanitizeStructuredClone(_util2.default.argumentsToArray(arguments));
                                    event.source.postMessage({
                                        mid: event.data.mid,
                                        type: 'resp',
                                        forPlugin: true,
                                        args: args
                                    }, reg.extension.url);
                                }
                                var data = event.data;
                                var module1 = this._registeredAPIModules[data.mod];
                                var extension = this.getRegisteredExtensions(reg.extension)[0];
                                if (module1) {
                                    var fnName = data.fn;
                                    if (data._cls) {
                                        var Cls = module1[data._cls];
                                        var ns = data.mod + '-' + data._cls + '-';
                                        sendResponse._id = data._id;
                                        if (fnName === 'constructor') {
                                            if (!Cls._construct) {
                                                Cls.constructor.prototype._destroy = function() {
                                                    delete this._context._proxies[ns + this._id];
                                                };
                                                Cls._construct = function() {
                                                    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                                                    var inst = new (Function.prototype.bind.apply(Cls.constructor, [
                                                        null
                                                    ].concat(args)))();
                                                    var callback = args[args.length - 1];
                                                    inst._id = callback._id;
                                                    inst._context = callback._context;
                                                    inst._context._proxies[ns + inst._id] = inst;
                                                    return inst;
                                                };
                                            }
                                            module1 = Cls;
                                            fnName = '_construct';
                                        } else module1 = extension._proxies[ns + data._id];
                                    }
                                    var method = module1[fnName];
                                    if (method) {
                                        var methodArgs = data.args;
                                        var padLength = method.length - 1;
                                        if (fnName === '_construct') padLength = module1.constructor.length - 1;
                                        sendResponse._context = extension;
                                        methodArgs = this._padUndefinedArguments(methodArgs, padLength);
                                        methodArgs.push(sendResponse);
                                        var promiseResult = method.apply(module1, methodArgs);
                                        if (method.returnsPromise) {
                                            if (!((typeof promiseResult === 'undefined' ? 'undefined' : _typeof(promiseResult)) === 'object' || typeof promiseResult === 'function') || typeof promiseResult.then !== 'function') sendResponse('Defined module method did not return a promise.');
                                            else promiseResult.then(function(result) {
                                                sendResponse(undefined, result);
                                            }).catch(function(err) {
                                                err = err instanceof Error ? err.message : err;
                                                sendResponse(err);
                                            });
                                        }
                                        if (this._registeredRequestNotifier) this._registeredRequestNotifier.call(null, {
                                            module: data.mod,
                                            fn: data.fn,
                                            type: data.type,
                                            addon_key: reg.extension.addon_key,
                                            key: reg.extension.key,
                                            extension_id: reg.extension_id
                                        });
                                    }
                                }
                            }
                        },
                        {
                            key: '_handleBroadcast',
                            value: function _handleBroadcast(event, reg) {
                                var event_data = event.data;
                                var targetSpec = function targetSpec(r) {
                                    return r.extension.addon_key === reg.extension.addon_key && r.extension_id !== reg.extension_id;
                                };
                                this.dispatch(event_data.etyp, targetSpec, event_data.evnt, null, null);
                            }
                        },
                        {
                            key: '_handleKeyTriggered',
                            value: function _handleKeyTriggered(event, reg) {
                                var eventData = event.data;
                                var keycodeEntry = this._keycodeKey(eventData.keycode, eventData.modifiers, reg.extension_id);
                                var listeners = this._keycodeCallbacks[keycodeEntry];
                                if (listeners) listeners.forEach(function(listener) {
                                    listener.call(null, {
                                        addon_key: reg.extension.addon_key,
                                        key: reg.extension.key,
                                        extension_id: reg.extension_id,
                                        keycode: eventData.keycode,
                                        modifiers: eventData.modifiers
                                    });
                                }, this);
                            }
                        },
                        {
                            key: 'defineAPIModule',
                            value: function defineAPIModule(module1, moduleName) {
                                moduleName = moduleName || '_globals';
                                this._registeredAPIModules[moduleName] = _util2.default.extend({}, this._registeredAPIModules[moduleName] || {}, module1);
                                return this._registeredAPIModules;
                            }
                        },
                        {
                            key: 'isAPIModuleDefined',
                            value: function isAPIModuleDefined(moduleName) {
                                return typeof this._registeredAPIModules[moduleName] !== 'undefined';
                            }
                        },
                        {
                            key: '_pendingEventKey',
                            value: function _pendingEventKey(targetSpec, time) {
                                var key = targetSpec.addon_key || 'global';
                                if (targetSpec.key) key = key + '@@' + targetSpec.key;
                                key = key + '@@' + time;
                                return key;
                            }
                        },
                        {
                            key: 'queueEvent',
                            value: function queueEvent(type, targetSpec, event, callback) {
                                var loaded_frame, targets = this._findRegistrations(targetSpec);
                                loaded_frame = targets.some(function(target) {
                                    return target.registered_events !== undefined;
                                }, this);
                                if (loaded_frame) this.dispatch(type, targetSpec, event, callback);
                                else {
                                    this._cleanupInvalidEvents();
                                    var time = new Date().getTime();
                                    this._pendingEvents[this._pendingEventKey(targetSpec, time)] = {
                                        type: type,
                                        targetSpec: targetSpec,
                                        event: event,
                                        callback: callback,
                                        time: time,
                                        uid: _util2.default.randomString()
                                    };
                                }
                            }
                        },
                        {
                            key: '_cleanupInvalidEvents',
                            value: function _cleanupInvalidEvents() {
                                var _this2 = this;
                                var now = new Date().getTime();
                                var keys = Object.keys(this._pendingEvents);
                                keys.forEach(function(index) {
                                    var element = _this2._pendingEvents[index];
                                    var eventIsValid = now - element.time <= VALID_EVENT_TIME_MS;
                                    if (!eventIsValid) delete _this2._pendingEvents[index];
                                });
                            }
                        },
                        {
                            key: '_handleEventQuery',
                            value: function _handleEventQuery(message, extension) {
                                var _this3 = this;
                                var executed = {};
                                var now = new Date().getTime();
                                var keys = Object.keys(this._pendingEvents);
                                keys.forEach(function(index) {
                                    var element = _this3._pendingEvents[index];
                                    var eventIsValid = now - element.time <= VALID_EVENT_TIME_MS;
                                    var isSameTarget = !element.targetSpec || _this3._findRegistrations(element.targetSpec).length !== 0;
                                    if (isSameTarget && element.targetSpec.key) isSameTarget = element.targetSpec.addon_key === extension.extension.addon_key && element.targetSpec.key === extension.extension.key;
                                    if (eventIsValid && isSameTarget) {
                                        executed[index] = element;
                                        element.targetSpec = element.targetSpec || {};
                                        _this3.dispatch(element.type, element.targetSpec, element.event, element.callback, message.source);
                                    } else if (!eventIsValid) delete _this3._pendingEvents[index];
                                });
                                this._registeredExtensions[extension.extension_id].registered_events = message.data.args;
                                return executed;
                            }
                        },
                        {
                            key: '_handleUnload',
                            value: function _handleUnload(event, reg) {
                                if (!reg) return;
                                if (reg.extension_id && this._registeredExtensions[reg.extension_id]) delete this._registeredExtensions[reg.extension_id].source;
                                if (reg.unloadCallback) reg.unloadCallback(event.data.eid);
                            }
                        },
                        {
                            key: 'dispatch',
                            value: function dispatch(type, targetSpec, event, callback, source) {
                                function sendEvent(reg, evnt) {
                                    if (reg.source && reg.source.postMessage) {
                                        var mid;
                                        if (callback) {
                                            mid = _util2.default.randomString();
                                            this._pendingCallbacks[mid] = callback;
                                        }
                                        reg.source.postMessage({
                                            type: 'evt',
                                            mid: mid,
                                            etyp: type,
                                            evnt: evnt
                                        }, reg.extension.url);
                                    }
                                }
                                var registrations = this._findRegistrations(targetSpec || {});
                                registrations.forEach(function(reg) {
                                    if (source && !reg.source) reg.source = source;
                                    if (reg.source) _util2.default._bind(this, sendEvent)(reg, event);
                                }, this);
                            }
                        },
                        {
                            key: '_findRegistrations',
                            value: function _findRegistrations(targetSpec) {
                                var _this4 = this;
                                if (this._registeredExtensions.length === 0) {
                                    _util2.default.error('no registered extensions', this._registeredExtensions);
                                    return [];
                                }
                                var keys = Object.getOwnPropertyNames(targetSpec);
                                var registrations = Object.getOwnPropertyNames(this._registeredExtensions).map(function(key) {
                                    return _this4._registeredExtensions[key];
                                });
                                if (targetSpec instanceof Function) return registrations.filter(targetSpec);
                                else return registrations.filter(function(reg) {
                                    return keys.every(function(key) {
                                        return reg.extension[key] === targetSpec[key];
                                    });
                                });
                            }
                        },
                        {
                            key: 'registerExtension',
                            value: function registerExtension(extension_id, data) {
                                data._proxies = {};
                                data.extension_id = extension_id;
                                this._registeredExtensions[extension_id] = data;
                            }
                        },
                        {
                            key: '_keycodeKey',
                            value: function _keycodeKey(key, modifiers, extension_id) {
                                var code = key;
                                if (modifiers) {
                                    if (typeof modifiers === "string") modifiers = [
                                        modifiers
                                    ];
                                    modifiers.sort();
                                    modifiers.forEach(function(modifier) {
                                        code += '$$' + modifier;
                                    }, this);
                                }
                                return code + '__' + extension_id;
                            }
                        },
                        {
                            key: 'registerKeyListener',
                            value: function registerKeyListener(extension_id, key, modifiers, callback) {
                                if (typeof modifiers === "string") modifiers = [
                                    modifiers
                                ];
                                var reg = this._registeredExtensions[extension_id];
                                var keycodeEntry = this._keycodeKey(key, modifiers, extension_id);
                                if (!this._keycodeCallbacks[keycodeEntry]) {
                                    this._keycodeCallbacks[keycodeEntry] = [];
                                    reg.source.postMessage({
                                        type: 'key_listen',
                                        keycode: key,
                                        modifiers: modifiers,
                                        action: 'add'
                                    }, reg.extension.url);
                                }
                                this._keycodeCallbacks[keycodeEntry].push(callback);
                            }
                        },
                        {
                            key: 'unregisterKeyListener',
                            value: function unregisterKeyListener(extension_id, key, modifiers, callback) {
                                var keycodeEntry = this._keycodeKey(key, modifiers, extension_id);
                                var potentialCallbacks = this._keycodeCallbacks[keycodeEntry];
                                var reg = this._registeredExtensions[extension_id];
                                if (potentialCallbacks) {
                                    if (callback) {
                                        var index = potentialCallbacks.indexOf(callback);
                                        this._keycodeCallbacks[keycodeEntry].splice(index, 1);
                                    } else delete this._keycodeCallbacks[keycodeEntry];
                                    if (reg.source && reg.source.postMessage) reg.source.postMessage({
                                        type: 'key_listen',
                                        keycode: key,
                                        modifiers: modifiers,
                                        action: 'remove'
                                    }, reg.extension.url);
                                }
                            }
                        },
                        {
                            key: 'registerClickHandler',
                            value: function registerClickHandler(callback) {
                                if (typeof callback !== 'function') throw new Error('callback must be a function');
                                if (this._clickHandler !== null) throw new Error('ClickHandler already registered');
                                this._clickHandler = callback;
                            }
                        },
                        {
                            key: '_handleAddonClick',
                            value: function _handleAddonClick(event, reg) {
                                if (typeof this._clickHandler === 'function') this._clickHandler({
                                    addon_key: reg.extension.addon_key,
                                    key: reg.extension.key,
                                    extension_id: reg.extension_id
                                });
                            }
                        },
                        {
                            key: 'unregisterClickHandler',
                            value: function unregisterClickHandler() {
                                this._clickHandler = null;
                            }
                        },
                        {
                            key: 'getApiSpec',
                            value: function getApiSpec(addonKey) {
                                var _this5 = this;
                                function getModuleDefinition(mod) {
                                    return Object.getOwnPropertyNames(mod).reduce(function(accumulator, memberName) {
                                        var member = mod[memberName];
                                        switch(typeof member === 'undefined' ? 'undefined' : _typeof(member)){
                                            case 'function':
                                                accumulator[memberName] = {
                                                    args: _util2.default.argumentNames(member),
                                                    returnsPromise: member.returnsPromise || false
                                                };
                                                break;
                                            case 'object':
                                                if (member.hasOwnProperty('constructor')) accumulator[memberName] = getModuleDefinition(member);
                                                break;
                                        }
                                        return accumulator;
                                    }, {});
                                }
                                return Object.getOwnPropertyNames(this._registeredAPIModules).reduce(function(accumulator, moduleName) {
                                    var module1 = _this5._registeredAPIModules[moduleName];
                                    if (typeof module1.addonKey === 'undefined' || module1.addonKey === addonKey) accumulator[moduleName] = getModuleDefinition(module1);
                                    return accumulator;
                                }, {});
                            }
                        },
                        {
                            key: '_originEqual',
                            value: function _originEqual(url, origin) {
                                function strCheck(str) {
                                    return typeof str === 'string' && str.length > 0;
                                }
                                var urlOrigin = _util2.default.getOrigin(url);
                                // check strings are strings and they contain something
                                if (!strCheck(url) || !strCheck(origin) || !strCheck(urlOrigin)) return false;
                                return origin === urlOrigin;
                            }
                        },
                        {
                            key: '_checkOrigin',
                            value: function _checkOrigin(event, reg) {
                                var no_source_types = [
                                    'init'
                                ];
                                var isNoSourceType = reg && !reg.source && no_source_types.indexOf(event.data.type) > -1;
                                var sourceTypeMatches = reg && event.source === reg.source;
                                var hasExtensionUrl = reg && this._originEqual(reg.extension.url, event.origin);
                                var isValidOrigin = hasExtensionUrl && (isNoSourceType || sourceTypeMatches);
                                // get_host_offset fires before init
                                if (event.data.type === 'get_host_offset' && window === window.top) isValidOrigin = true;
                                // check undefined for chromium (Issue 395010)
                                if (event.data.type === 'unload' && (sourceTypeMatches || event.source === undefined)) isValidOrigin = true;
                                return isValidOrigin;
                            }
                        },
                        {
                            key: 'getRegisteredExtensions',
                            value: function getRegisteredExtensions(filter) {
                                if (filter) return this._findRegistrations(filter);
                                return this._registeredExtensions;
                            }
                        },
                        {
                            key: 'unregisterExtension',
                            value: function unregisterExtension(filter) {
                                var registrations = this._findRegistrations(filter);
                                if (registrations.length !== 0) registrations.forEach(function(registration) {
                                    var _this6 = this;
                                    var keys = Object.keys(this._pendingEvents);
                                    keys.forEach(function(index) {
                                        var element = _this6._pendingEvents[index];
                                        var targetSpec = element.targetSpec || {};
                                        if (targetSpec.addon_key === registration.extension.addon_key && targetSpec.key === registration.extension.key) delete _this6._pendingEvents[index];
                                    });
                                    delete this._registeredExtensions[registration.extension_id];
                                }, this);
                            }
                        },
                        {
                            key: 'setFeatureFlagGetter',
                            value: function setFeatureFlagGetter(getBooleanFeatureFlag) {
                                this._getBooleanFeatureFlag = getBooleanFeatureFlag;
                            }
                        }
                    ]);
                    return XDMRPC;
                }(_postmessage2.default);
                exports.default = XDMRPC;
                module1.exports = exports['default'];
            },
            {
                "../common/postmessage": 1,
                "../common/util": 2
            }
        ]
    }, {}, [
        4
    ])(4);
});

});


parcelRegister("jY4xY", function(module, exports) {
$parcel$export(module.exports, "useHostOffsetOverride", () => $ccd2fce9d917053e$export$db5957f3934e2c38);

var $eJOHy = parcelRequire("eJOHy");
function $ccd2fce9d917053e$var$isSameOrigin(targetWindow, currentWindow = window) {
    let isSameOrigin1;
    try {
        isSameOrigin1 = targetWindow?.location.origin === currentWindow?.location.origin;
    } catch (e) {
        // catch the DOM exception, mark the resolution to "false"
        isSameOrigin1 = false;
    }
    return isSameOrigin1;
}
const $ccd2fce9d917053e$export$28f1b4bd74242643 = (hostWindow, offset = 0)=>{
    let currentWindow = hostWindow;
    let hostFrameOffset = 0;
    while(currentWindow && currentWindow !== window.top){
        hostFrameOffset += 1;
        currentWindow = currentWindow.parent;
    }
    return hostFrameOffset - offset;
};
const $ccd2fce9d917053e$var$attachHostOffsetOverride = (window1)=>{
    if (window1.top) {
        if ($ccd2fce9d917053e$var$isSameOrigin(window1.top)) {
            const containerDepth = $ccd2fce9d917053e$export$28f1b4bd74242643(window1);
            // @ts-ignore https://hello.atlassian.net/browse/TYPEF-946
            window1.top.getHostOffsetFunctionOverride = (hostWindow)=>$ccd2fce9d917053e$export$28f1b4bd74242643(hostWindow, containerDepth + 1);
        }
    }
};
const $ccd2fce9d917053e$var$detachHostOffsetOverride = ()=>{
    if (window.top) {
        if ($ccd2fce9d917053e$var$isSameOrigin(window.top)) // @ts-ignore https://hello.atlassian.net/browse/TYPEF-946
        delete window.top.getHostOffsetFunctionOverride;
    }
};
function $ccd2fce9d917053e$export$db5957f3934e2c38() {
    (0, $eJOHy.useEffect)(()=>{
        $ccd2fce9d917053e$var$attachHostOffsetOverride(window);
        return ()=>{
            $ccd2fce9d917053e$var$detachHostOffsetOverride();
        };
    }, []);
}

});

parcelRegister("a9hHS", function(module, exports) {
$parcel$export(module.exports, "usePerformanceMetrics", () => $11b5d4430fbe14bc$export$865423e6f8e2e839);
$parcel$export(module.exports, "PerformanceMetricsProvider", () => $11b5d4430fbe14bc$export$c6f19d9afc6c86c8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $cJwOd = parcelRequire("cJwOd");


var $kePQU = parcelRequire("kePQU");
// PerformanceMetricsProvider is only applied to internal EP
// Methods provided by PerformanceMetricsContext are defined by default as () => {}
// This allows instances not wrapped in provider (ie embedded-confluence public) to opperate without errors
const $11b5d4430fbe14bc$var$PerformanceMetricsContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    isInitialized: false,
    cancelIframeLoadMetrics: ()=>{},
    markIframeLoadMetrics: ()=>{},
    setContentType: ()=>{}
});
// calculate timestamp from iframe's performance metric post message
// relative to parent's window.performance.now() adjusted for post message latency
const $11b5d4430fbe14bc$var$adjustedPerformanceTimestamp = (timestamp)=>typeof timestamp === 'number' ? window.performance.now() - (Date.now() - timestamp) : undefined;
const $11b5d4430fbe14bc$var$Provider = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const [currentContentType, setCurrentContentType] = (0, $eJOHy.useState)(contentType);
    const isInitialized = (0, $eJOHy.useRef)(true);
    const iframeLoadMetrics = (0, $eJOHy.useRef)();
    const embeddedViewToEditTransitionTimer = (0, $eJOHy.useRef)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        // TODO: Currently EP does not work with more that one instance per parent window
        // When this limitation is fixed we will also need to find a way to serialize post messages
        // this is because post message listeners will pick up on all messages coming to the parent window
        // triggering any callback listening to a given data.type message
        // therefore messages will need to be scoped to the particular instance they are intended for
        embeddedViewToEditTransitionTimer.current?.cancel();
        embeddedViewToEditTransitionTimer.current = (0, $cJwOd.embeddedViewToEditTransitionMetric)();
        // Setup iframe post message handling
        const handler = (e)=>{
            switch(e.data.type){
                case (0, $485f6ccefa6a28c8$export$ad3f29048eb3061) + (0, $485f6ccefa6a28c8$export$e5b04c2a3cc97ddc):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $11b5d4430fbe14bc$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $485f6ccefa6a28c8$export$ad3f29048eb3061) + (0, $485f6ccefa6a28c8$export$9f8bbf62fac57d48):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $11b5d4430fbe14bc$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    embeddedViewToEditTransitionTimer.current?.stop({
                        stopTime: $11b5d4430fbe14bc$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $485f6ccefa6a28c8$export$ad3f29048eb3061) + (0, $485f6ccefa6a28c8$export$e08d2ab8ef653595):
                    embeddedViewToEditTransitionTimer.current?.start({
                        startTime: $11b5d4430fbe14bc$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp)
                    });
                    break;
                case (0, $485f6ccefa6a28c8$export$ad3f29048eb3061) + (0, $485f6ccefa6a28c8$export$73b982309451f084):
                    iframeLoadMetrics.current?.mark('iframe-content-initialized-end', $11b5d4430fbe14bc$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp));
                    break;
            }
        };
        window.addEventListener('message', handler);
        const currentTransitionTimer = embeddedViewToEditTransitionTimer.current;
        return ()=>{
            window.removeEventListener('message', handler);
            currentTransitionTimer.cancel();
        };
    }, [
        embeddedViewToEditTransitionTimer,
        sourceComponent
    ]);
    // Set load metric based on content type
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (currentContentType) {
            // cancel current Embedded Confluence iframe load metric if necessary
            iframeLoadMetrics.current?.cancel();
            iframeLoadMetrics.current = (0, $cJwOd.embeddedConfluenceIframeLoadMetrics)(currentContentType);
            // start Embedded Confluence iframe load metric
            iframeLoadMetrics.current?.start();
            iframeLoadMetrics.current?.mark('lazy-load-start');
        }
        return ()=>{
            iframeLoadMetrics.current?.cancel();
        };
    }, [
        currentContentType,
        sourceComponent
    ]);
    const cancelIframeLoadMetrics = (0, $eJOHy.useCallback)(()=>{
        iframeLoadMetrics.current?.cancel();
    }, []);
    const markIframeLoadMetrics = (0, $eJOHy.useCallback)((markName)=>{
        iframeLoadMetrics.current?.mark(markName);
    }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($11b5d4430fbe14bc$var$PerformanceMetricsContext.Provider, {
        value: {
            cancelIframeLoadMetrics: cancelIframeLoadMetrics,
            markIframeLoadMetrics: markIframeLoadMetrics,
            isInitialized: isInitialized.current,
            setContentType: setCurrentContentType
        },
        children: children
    });
};
const $11b5d4430fbe14bc$export$865423e6f8e2e839 = ()=>{
    return (0, $eJOHy.useContext)($11b5d4430fbe14bc$var$PerformanceMetricsContext);
};
const $11b5d4430fbe14bc$export$2ba0c6357609a3dd = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const { isInitialized: isInitialized, setContentType: setContentType } = $11b5d4430fbe14bc$export$865423e6f8e2e839();
    (0, $eJOHy.useLayoutEffect)(()=>{
        // Update contentType when Page component replaces ViewPage with EditPage or vice versa
        isInitialized && contentType && setContentType(contentType);
    }, [
        isInitialized,
        contentType,
        setContentType
    ]);
    return !isInitialized ? /*#__PURE__*/ (0, $gt9Am.jsx)($11b5d4430fbe14bc$var$Provider, {
        contentType: contentType,
        sourceComponent: sourceComponent,
        children: children
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};
const $11b5d4430fbe14bc$export$c6f19d9afc6c86c8 = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>(0, $kePQU.fg)('embedded-confluence-performance-markers') ? /*#__PURE__*/ (0, $gt9Am.jsx)($11b5d4430fbe14bc$export$2ba0c6357609a3dd, {
        contentType: contentType,
        sourceComponent: sourceComponent,
        children: children
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });

});
parcelRegister("cJwOd", function(module, exports) {
$parcel$export(module.exports, "embeddedViewToEditTransitionMetric", () => $eb4912bb329655e4$export$4de078c3b9971f9b);
$parcel$export(module.exports, "embeddedConfluenceIframeLoadMetrics", () => $eb4912bb329655e4$export$a23245993532c751);

var $d3eK0 = parcelRequire("d3eK0");

var $li8Rh = parcelRequire("li8Rh");
const $eb4912bb329655e4$export$4de078c3b9971f9b = ()=>(0, $d3eK0.metrics).interaction({
        key: 'embedded-confluence-view-to-edit-transition'
    });
const $eb4912bb329655e4$var$timings = [
    {
        key: 'lazy-load',
        startMark: 'lazy-load-start',
        endMark: 'lazy-load-end'
    },
    {
        key: 'common-load',
        startMark: 'common-load-start',
        endMark: 'common-load-end'
    },
    {
        key: 'iframe-content-initialized',
        startMark: 'iframe-content-initialized-start',
        endMark: 'iframe-content-initialized-end'
    }
];
const $eb4912bb329655e4$var$loadingMetricsConfig = {
    viewPage: {
        key: 'embedded-confluence-view-page-iframe',
        type: (0, $li8Rh.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $eb4912bb329655e4$var$timings
    },
    editPage: {
        key: 'embedded-confluence-edit-page-iframe',
        type: (0, $li8Rh.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $eb4912bb329655e4$var$timings
    }
};
const $eb4912bb329655e4$export$a23245993532c751 = (contentType)=>(0, $d3eK0.metrics).pageSegmentLoad($eb4912bb329655e4$var$loadingMetricsConfig[contentType]);

});

const $485f6ccefa6a28c8$export$ad3f29048eb3061 = 'embedded-confluence-metrics.';
const $485f6ccefa6a28c8$export$e5b04c2a3cc97ddc = 'embedded-view-tti';
const $485f6ccefa6a28c8$export$9f8bbf62fac57d48 = 'embedded-editor-tti';
const $485f6ccefa6a28c8$export$e08d2ab8ef653595 = 'embedded-edit-click';
const $485f6ccefa6a28c8$export$73b982309451f084 = 'embedded-iframe-content-initialized';



parcelRegister("9NPzp", function(module, exports) {
$parcel$export(module.exports, "Footer", () => $6ad1a889b837e343$export$a06f1c675e846f6f);
/* Footer.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-html-anchor */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $aqlRB = parcelRequire("aqlRB");

var $7AXbt = parcelRequire("7AXbt");

var $pB3Jh = parcelRequire("pB3Jh");

var $9qgTd = parcelRequire("9qgTd");
const $6ad1a889b837e343$var$FOOTER_CONTENT_HEIGHT = 52;
const $6ad1a889b837e343$var$FOOTER_BORDER_PX = 2;
const $6ad1a889b837e343$export$a2dd5f25b5a4e5d2 = $6ad1a889b837e343$var$FOOTER_CONTENT_HEIGHT + $6ad1a889b837e343$var$FOOTER_BORDER_PX;
const $6ad1a889b837e343$var$containerStyles = null;
const $6ad1a889b837e343$var$contentWrapperStyles = null;
const $6ad1a889b837e343$var$logoWrapperSyles = null;
const $6ad1a889b837e343$var$linkStyles = null;
const $6ad1a889b837e343$export$a06f1c675e846f6f = ({ url: url, linkTooltip: linkTooltip, label: label })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": "footer-container",
        className: (0, $hcewu.default)([
            "_11c8dcr7 _16jlidpf _1o9zidpf _i0dl1ex1 _x3dowsm2 _4t3i1ex1 _syaz1n3s _1e0c1txw _4cvr1h6o _1bah1h6o"
        ]),
        children: url ? /*#__PURE__*/ (0, $gt9Am.jsx)($6ad1a889b837e343$var$ContentAction, {
            tooltipText: linkTooltip,
            href: url,
            children: ({ isHovered: isHovered })=>/*#__PURE__*/ (0, $gt9Am.jsx)($6ad1a889b837e343$var$Content, {
                    isHovered: isHovered,
                    label: label
                })
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)($6ad1a889b837e343$var$Content, {
            label: label
        })
    });
const $6ad1a889b837e343$var$Content = ({ isHovered: isHovered, label: label })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        className: (0, $hcewu.default)([
            "_4t3i7vkz _1e0c1txw _1bah1h6o _4cvresu3"
        ]),
        children: [
            label,
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_1e0c1txw _2lx21bp4 _1bah1h6o _19pkidpf _2hwxidpf _otyridpf _18u0u2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7AXbt.ConfluenceLogo), {
                    appearance: isHovered ? 'brand' : 'neutral',
                    size: "xxsmall"
                })
            })
        ]
    });
const $6ad1a889b837e343$var$ContentAction = ({ children: children, tooltipText: tooltipText, href: href })=>{
    const [isHovered, setIsHovered] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $aqlRB.useAnalyticsEvents)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'confluenceFooter',
            source: 'embeddedConfluenceViewPageScreen',
            eventType: 'ui'
        }).fire((0, $9qgTd.ANALYTICS_CHANNEL));
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $pB3Jh.default), {
        content: tooltipText,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
            href: href,
            target: "_blank",
            onMouseEnter: ()=>{
                setIsHovered(true);
            },
            onMouseLeave: ()=>{
                setIsHovered(false);
            },
            onClick: handleClick,
            "data-testid": "link",
            className: (0, $hcewu.default)([
                "_12ji1r31 _1qu2glyw _12y31o36 _4bfu18uv _1hmsglyw _ajmmnqa1 _syaz1kw7 _16qsglyw _1q5t1r31 _nt751r31 _1dit1r31 _1ohyglyw _49pcglyw _ksodglyw _1r9x1o36 _1hvw1o36 _4hz81o36 _1nrm18uv _1a3b18uv _9oik18uv _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _9h8h1kw7 _f8pj1kw7 _30l31kw7 _180dglyw _7ehiglyw _1dbzglyw"
            ]),
            children: children({
                isHovered: isHovered
            })
        })
    });
};

});

parcelRegister("9T5AC", function(module, exports) {
$parcel$export(module.exports, "PageLoadValidation", () => $50f574b23d2dc30e$export$3b0759108d92fe77);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $h6zKQ = parcelRequire("h6zKQ");

var $lgMhR = parcelRequire("lgMhR");

var $leoH9 = parcelRequire("leoH9");

var $aqlRB = parcelRequire("aqlRB");

var $dLxPe = parcelRequire("dLxPe");

var $jn71q = parcelRequire("jn71q");

var $9qgTd = parcelRequire("9qgTd");
const $50f574b23d2dc30e$var$noop = ()=>{};
const $50f574b23d2dc30e$export$3b0759108d92fe77 = (props)=>{
    const { standaloneConfluenceUrl: standaloneConfluenceUrl, embeddedConfluenceUrl: embeddedConfluenceUrl } = (0, $dLxPe.useUrl)(props);
    const isEmbeddedUrlOnSameDomain = embeddedConfluenceUrl ? window.location.origin === new URL(embeddedConfluenceUrl).origin : false;
    const unusedIframeRef = (0, $eJOHy.useRef)(null);
    return isEmbeddedUrlOnSameDomain ? props.children({
        iframeRef: unusedIframeRef,
        handleIframeOnLoad: $50f574b23d2dc30e$var$noop,
        handleContentLoadStarted: $50f574b23d2dc30e$var$noop,
        handleIframeUnload: $50f574b23d2dc30e$var$noop,
        navigationPolicy: props.navigationPolicy
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($50f574b23d2dc30e$var$CrossDomainErrorValidation, {
        standaloneConfluenceUrl: standaloneConfluenceUrl,
        embeddedConfluenceUrl: embeddedConfluenceUrl,
        allowedFeatures: props.allowedFeatures,
        ...props
    }, embeddedConfluenceUrl || props.contentId);
};
const $50f574b23d2dc30e$var$CrossDomainErrorValidation = ({ allowedFeatures: allowedFeatures, children: children, contentId: contentId, embeddedConfluenceUrl: embeddedConfluenceUrl, navigationPolicy: navigationPolicy, parentProduct: parentProduct, spaceKey: spaceKey, standaloneConfluenceUrl: standaloneConfluenceUrl })=>{
    const { state: state, dispatch: dispatch } = (0, $jn71q.useValidationState)();
    const { iframeLoaded: iframeLoaded, contentLoadStarted: contentLoadStarted, shouldAskStorageAccess: shouldAskStorageAccess, shouldAskToLogin: shouldAskToLogin, redirectedToLogin: redirectedToLogin, iframeUnloaded: iframeUnloaded } = state;
    const iframeRef = (0, $eJOHy.useRef)(null);
    /* This ref is specifically used for the purpose of recoding whether or not a delayed dispatch of the iframe occured.
		This recorded value is later used to fire analytics if contentLoadStarted arrives after the delayed dispatch, and reset
		once the event has fired or if the users needs to go through login flow.
	*/ const iframeLoadedWithDelayRef = (0, $eJOHy.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $aqlRB.useAnalyticsEvents)();
    const isLoginFlowDisabled = (0, $eJOHy.useMemo)(()=>allowedFeatures?.includes('disable-login-flow') ?? false, [
        allowedFeatures
    ]);
    const reloadEP = (0, $eJOHy.useCallback)(()=>{
        dispatch({
            subject: (0, $jn71q.Subjects).CONTENT_LOAD,
            status: (0, $jn71q.LoadingStatus).RELOAD_EP
        });
    }, [
        dispatch
    ]);
    const failToLoad = (0, $eJOHy.useMemo)(()=>iframeLoaded && !contentLoadStarted || /*
      If anonymous access is permitted globally but restricted on a content's parent space,
      the iframe will attempt a login redirect which we intercept.
      To avoid an error in the iframe, we need to wait for the iframe window to unload
      before unmouting the Iframe component.
    */ iframeUnloaded && redirectedToLogin, [
        contentLoadStarted,
        iframeLoaded,
        iframeUnloaded,
        redirectedToLogin
    ]);
    const pageNavigationPolicy = (0, $eJOHy.useMemo)(()=>({
            navigate (url, modifiers, defaultNavigate) {
                // modifiy the navigationPolicy to intercept login redirects
                // so that login can be handled outside of the iframe
                if (url.includes('/login?application=confluence')) {
                    dispatch({
                        subject: (0, $jn71q.Subjects).CONTENT_LOAD,
                        status: (0, $jn71q.LoadingStatus).REDIRECTED_TO_LOGIN
                    });
                    return;
                }
                return navigationPolicy?.navigate ? navigationPolicy.navigate(url, modifiers, defaultNavigate) : defaultNavigate(url, modifiers);
            },
            shimUrl: navigationPolicy?.shimUrl,
            domainNamesToReplace: navigationPolicy?.domainNamesToReplace,
            spaceKeyFilter: navigationPolicy?.spaceKeyFilter
        }), [
        navigationPolicy,
        dispatch
    ]);
    const handleIframeOnLoad = (0, $eJOHy.useCallback)(()=>{
        const dispatchNow = ()=>{
            dispatch({
                subject: (0, $jn71q.Subjects).CONTENT_LOAD,
                status: (0, $jn71q.LoadingStatus).IFRAME_LOADED
            });
        };
        const totalNumberOfTries = 2;
        const iframeOfDispatch = iframeRef.current;
        const iframeSrcOfDispatch = iframeOfDispatch?.src;
        let tries = 0;
        const dispatchWithDelay = ()=>{
            /* We verify whether the iframeRef is current, as our intent is to invoke this only for the Iframe component created within the Content component (embedded-confluence-common/src/content/Content.tsx).
			It's important to note that the same Iframe component is also used by the StorageAccessPage component; however, we do not need to perform that check in this context.
			Additionally, the src of the iframe may change during transitions between view/edit modes or other redirects. Therefore, we must ensure that our invocation is limited to the current src of the iframe.
			*/ if (iframeRef.current !== iframeOfDispatch || iframeOfDispatch?.src !== iframeSrcOfDispatch) return;
            ++tries;
            if (contentLoadStarted || tries > totalNumberOfTries) {
                // If content load arrived after a timeout, failure to load was prevented by the delay
                if (contentLoadStarted && iframeLoadedWithDelayRef.current) {
                    createAnalyticsEvent({
                        action: 'delayedDispatch',
                        actionSubject: 'iframeOnLoad',
                        actionSubjectId: 'crossDomainErrorValidation',
                        source: 'pageLoadValidation',
                        eventType: 'track'
                    }).fire((0, $9qgTd.ANALYTICS_CHANNEL));
                    //reset the ref for now. If the delayed dispatch is triggered again, the event will get fired too
                    iframeLoadedWithDelayRef.current = false;
                }
                dispatchNow();
            } else {
                /* This determines whether to fire a track analytics event
				to log instances where iframe load is delayed to wait for the confluence content to load.*/ if (!iframeLoadedWithDelayRef.current) iframeLoadedWithDelayRef.current = true;
                setTimeout(dispatchWithDelay, 1000);
            }
        };
        dispatchWithDelay();
    }, [
        contentLoadStarted,
        createAnalyticsEvent,
        dispatch
    ]);
    const handleContentLoadStarted = (0, $eJOHy.useCallback)(()=>{
        dispatch({
            subject: (0, $jn71q.Subjects).CONTENT_LOAD,
            status: (0, $jn71q.LoadingStatus).CONTENT_LOAD_STARTED
        });
    }, [
        dispatch
    ]);
    const handleIframeUnload = (0, $eJOHy.useCallback)(()=>{
        dispatch({
            subject: (0, $jn71q.Subjects).CONTENT_LOAD,
            status: (0, $jn71q.LoadingStatus).IFRAME_UNLOADED
        });
    }, [
        dispatch
    ]);
    if (!failToLoad) return children({
        iframeRef: iframeRef,
        handleIframeOnLoad: handleIframeOnLoad,
        handleContentLoadStarted: handleContentLoadStarted,
        handleIframeUnload: handleIframeUnload,
        navigationPolicy: pageNavigationPolicy,
        redirectedToLogin: redirectedToLogin
    });
    if (!isLoginFlowDisabled) {
        if (shouldAskStorageAccess) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $leoH9.StorageAccessPage), {
            url: embeddedConfluenceUrl,
            contentId: contentId,
            spaceKey: spaceKey,
            parentProduct: parentProduct
        });
        if (shouldAskToLogin) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMhR.LoginPage), {
            contentId: contentId,
            reloadEP: reloadEP,
            spaceKey: spaceKey,
            url: embeddedConfluenceUrl
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h6zKQ.ErrorScreen), {
        standaloneConfluenceUrl: standaloneConfluenceUrl
    });
};

});
parcelRegister("h6zKQ", function(module, exports) {
$parcel$export(module.exports, "ErrorScreen", () => $19b1ca4a193f379e$export$42f84e610f279c31);
/* ErrorScreen.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $crYRn = parcelRequire("crYRn");

var $6Tcuf = parcelRequire("6Tcuf");

var $lqd8A = parcelRequire("lqd8A");

var $7AXbt = parcelRequire("7AXbt");

var $b1Jzm = parcelRequire("b1Jzm");

var $9vwg9 = parcelRequire("9vwg9");
var $8CJjp = parcelRequire("8CJjp");
var $7YsrN = parcelRequire("7YsrN");

var $71EtM = parcelRequire("71EtM");
var $geAAj = parcelRequire("geAAj");

var $9N1gM = parcelRequire("9N1gM");

var $fWr3F = parcelRequire("fWr3F");

var $bv7KK = parcelRequire("bv7KK");

var $a9hHS = parcelRequire("a9hHS");
const $19b1ca4a193f379e$var$LOGIN_ISSUES_RELATED_TO_BROWSER_COOKIES = 'https://support.atlassian.com/atlassian-account/docs/login-issues-related-to-browser-cookies/';
const $19b1ca4a193f379e$var$styles = {
    loginButtonWrapper: "_19pkxy5q _otyrpxbi",
    mainWrapper: "_1e0c1n7u _4cvr1h6o _6a6z1h6o _y3gn1h6o"
};
const $19b1ca4a193f379e$export$42f84e610f279c31 = ({ standaloneConfluenceUrl: standaloneConfluenceUrl })=>{
    const experienceTracker = (0, $eJOHy.useContext)((0, $geAAj.ExperienceTrackerContext));
    const experience = (0, $eJOHy.useContext)((0, $71EtM.ExperienceContext));
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { cancelIframeLoadMetrics: cancelIframeLoadMetrics } = (0, $a9hHS.usePerformanceMetrics)();
    (0, $eJOHy.useEffect)(()=>{
        cancelIframeLoadMetrics();
    }, [
        cancelIframeLoadMetrics
    ]);
    (0, $eJOHy.useEffect)(()=>{
        experienceTracker.abort({
            name: experience,
            reason: (0, $9N1gM.ExperienceReasons).UNABLE_TO_DISPLAY_CONTENT
        });
    }, [
        experience,
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": "error-screen-container",
        className: (0, $hcewu.default)([
            $19b1ca4a193f379e$var$styles.mainWrapper
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8CJjp.default), {
                space: "space.250",
                alignInline: "center",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7AXbt.ConfluenceLogo), {
                        size: "large",
                        appearance: "brand"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fWr3F.LoginToConfluenceIcon), {}),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Tcuf.default), {
                        as: "h2",
                        size: "large",
                        children: formatMessage((0, $bv7KK.default).paragraphLogin)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9vwg9.default), {
                xcss: $19b1ca4a193f379e$var$styles.loginButtonWrapper,
                // data tag for JSM KB to target for excluding LinkButton from global styles
                // used instead of className as the className prop is not allowed
                // suggested by #help-design-system https://atlassian.slack.com/archives/CFJ9DU39U/p1746963980938489
                "data-embedded-confluence-no-global-styles-link-button": "true",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $crYRn.default), {
                    appearance: "primary",
                    "aria-label": formatMessage((0, $bv7KK.default).buttonLoginToConfluenceNewTab),
                    iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($b1Jzm))),
                    href: standaloneConfluenceUrl ?? '',
                    target: "_blank",
                    children: formatMessage((0, $bv7KK.default).buttonLoginToConfluenceNewTab)
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8CJjp.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7YsrN.default), {
                        as: "p",
                        children: formatMessage((0, $bv7KK.default).paragraphAlreadyLoggedIn)
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7YsrN.default), {
                        as: "p",
                        children: formatMessage((0, $bv7KK.default).paragraphStillHavingTrouble, {
                            link: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lqd8A.default), {
                                href: $19b1ca4a193f379e$var$LOGIN_ISSUES_RELATED_TO_BROWSER_COOKIES,
                                target: "_blank",
                                "aria-label": formatMessage((0, $bv7KK.default).linkAriaLabel),
                                children: formatMessage((0, $bv7KK.default).linkTroubleshootingText)
                            })
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("fWr3F", function(module, exports) {
$parcel$export(module.exports, "LoginToConfluenceIcon", () => $db4b232a72e94d78$export$ae31f6824db63a1c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $db4b232a72e94d78$export$ae31f6824db63a1c = ({ className: className })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        width: "148",
        height: "160",
        viewBox: "0 0 148 160",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                clipPath: "url(#clip0_499_12980)",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                        width: "147.652",
                        height: "160",
                        transform: "translate(0.174194)",
                        fill: "var(--ds-icon-inverse, white)",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M90.3627 138.196C90.4862 138.281 90.9631 138.59 91.4435 138.436C91.6734 138.36 91.8243 138.206 92.0268 137.993C92.2944 137.715 92.4625 137.437 92.562 137.245L93.557 137.465C93.6325 137.482 93.7183 137.455 93.7594 137.386C93.8246 137.283 93.78 137.153 93.6737 137.108L92.7438 136.734C92.6718 136.707 92.5929 136.703 92.5208 136.731L91.6253 137.046L90.3558 137.52L90.3627 138.196Z",
                        fill: "var(--ds-icon-accent-yellow, #72594B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93.2825 137.273L93.7526 137.492C93.8384 137.534 93.8864 137.63 93.8624 137.722C93.8384 137.825 93.7354 137.894 93.6291 137.873L92.411 137.647L91.6974 138.004L91.7969 137.427L92.5414 137.084L93.2825 137.273Z",
                        fill: "var(--ds-icon-accent-yellow, #72594B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93.7457 138.22C93.708 138.312 93.6051 138.357 93.5124 138.326C93.2757 138.22 93.0355 138.11 92.7988 138.004C92.4419 137.99 92.0851 137.973 91.7283 137.959L91.8175 137.578L92.9223 137.582L93.66 137.973C93.7457 138.021 93.7835 138.127 93.7457 138.22Z",
                        fill: "var(--ds-icon-accent-yellow, #72594B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93.1281 138.642C93.0767 138.697 92.9943 138.7 92.936 138.655L92.4247 138.257C92.2257 138.209 92.0302 138.161 91.8312 138.113C91.8655 138.014 91.9032 137.911 91.9375 137.811C92.1949 137.87 92.4556 137.931 92.713 137.99L93.1281 138.45C93.1796 138.504 93.1796 138.59 93.1281 138.642Z",
                        fill: "var(--ds-icon-accent-yellow, #72594B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.7",
                        d: "M132.434 20.5211L60.2655 23.3826V136.799L132.434 139.664V44.1953V20.5211Z",
                        fill: "url(#paint0_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            opacity: "0.6",
                            d: "M147.826 44.9982H121.774V46.1167H147.826V44.9982Z",
                            fill: "url(#paint1_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            opacity: "0.6",
                            d: "M147.826 47.9763H121.774V49.0948H147.826V47.9763Z",
                            fill: "url(#paint2_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            opacity: "0.6",
                            d: "M141.564 50.951H121.774V52.0696H141.564V50.951Z",
                            fill: "url(#paint3_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            opacity: "0.6",
                            d: "M82.238 0H56.186V1.11852H82.238V0Z",
                            fill: "url(#paint4_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            opacity: "0.6",
                            d: "M82.238 2.97815H56.186V4.09667H82.238V2.97815Z",
                            fill: "url(#paint5_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            opacity: "0.6",
                            d: "M75.9763 5.95288H56.186V7.0714H75.9763V5.95288Z",
                            fill: "url(#paint6_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.7",
                        d: "M138.058 26.0039L65.889 22.6929V136.11L138.058 132.799V47.2249V26.0039Z",
                        fill: "url(#paint7_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M139.286 108.401L118.151 103.576C117.746 103.484 117.485 103.052 117.571 102.609L122.052 79.5694C122.138 79.1268 122.536 78.8455 122.94 78.9381L144.076 83.7622C144.481 83.8548 144.741 84.2871 144.656 84.7297L140.175 107.769C140.089 108.208 139.691 108.493 139.286 108.401Z",
                        fill: "url(#paint8_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M119.791 101.72L123.75 81.3536L142.436 85.6149L138.476 105.985L119.791 101.72Z",
                        fill: "var(--ds-icon-inverse, white)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M122.813 97.2153L128.169 93.4069L131.652 99.2328L122.813 97.2153Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #99C1FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M125.912 97.9221L132.866 92.978L137.389 100.54L125.912 97.9221Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #CCE0FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M130.421 88.2318C130.435 87.3034 129.754 86.5407 128.902 86.5283C128.049 86.5158 127.347 87.2583 127.333 88.1868C127.32 89.1152 128 89.8779 128.853 89.8903C129.705 89.9028 130.407 89.1603 130.421 88.2318Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #99C1FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M46.2531 49.0468L28.5798 55.9261C28.2401 56.0564 27.8421 55.8712 27.6878 55.5109L19.6248 36.6264C19.4704 36.2627 19.6179 35.8647 19.9576 35.7309L37.6309 28.8517C37.9706 28.7213 38.3686 28.9066 38.523 29.2668L46.586 48.1513C46.7404 48.515 46.5928 48.9164 46.2531 49.0468Z",
                        fill: "url(#paint9_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M28.8577 53.7782L21.728 37.0862L37.353 31.0029L44.4827 47.6984L28.8577 53.7782Z",
                        fill: "var(--ds-background-accent-yellow-subtlest, #FFFAE5)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M35.4488 43.9346H31.2698V48.1136H35.4488V43.9346Z",
                        fill: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M34.8141 35.8716L33.4142 40.6099L38.7254 38.7983L34.8141 35.8716Z",
                        fill: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M29.6298 42.0365C30.4614 41.1853 30.4147 39.7911 29.5256 38.9225C28.6364 38.0538 27.2415 38.0397 26.4099 38.8909C25.5783 39.7421 25.625 41.1363 26.5141 42.005C27.4033 42.8736 28.7982 42.8878 29.6298 42.0365Z",
                        fill: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.7",
                        d: "M124.872 12.64L49.6259 22.6929V136.11L124.872 146.163V39.1722V12.64Z",
                        fill: "url(#paint10_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M94.0374 10.6705L42.3109 22.6929V136.11L117.557 153.292V34.6295L94.0374 10.6705Z",
                        fill: "url(#paint11_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M79.1715 90.5898L79.1198 91.8823L109.851 93.1125L109.903 91.82L79.1715 90.5898Z",
                        fill: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M47.6972 89.3282L47.6455 90.6207L79.1207 91.8807L79.1725 90.5882L47.6972 89.3282Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M47.704 92.8613L47.6342 94.1528L109.838 97.5169L109.908 96.2253L47.704 92.8613Z",
                        fill: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M71.0629 97.9737L70.9751 99.2642L109.831 101.909L109.919 100.618L71.0629 97.9737Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M47.7211 96.3936L47.6332 97.6841L70.9859 99.2758L71.0739 97.9853L47.7211 96.3936Z",
                        fill: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M47.723 99.9274L47.6171 101.216L94.2916 105.052L94.3976 103.763L47.723 99.9274Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.2",
                        d: "M42.3109 91.2761L60.2759 95.7056C61.4664 96.0006 62.7291 95.8257 63.7961 95.2184C64.8632 94.6111 66.1224 94.4395 67.3164 94.7312L67.7899 94.8478L67.8791 94.4807L69.7078 94.9302C69.9514 94.9919 70.1813 94.786 70.147 94.5356L70.0098 93.4754C69.9892 93.3279 69.8828 93.2078 69.7387 93.1735L68.2839 92.8166L68.3594 92.5147L67.7178 92.3569C66.6267 92.0892 65.6661 91.4442 65.0004 90.5384L64.9181 90.4286C64.2525 89.5228 63.2918 88.8812 62.2007 88.6102L45.2033 84.4209L42.9148 83.8547C42.9148 83.8547 42.9148 83.8547 42.9148 83.8582L42.3109 83.7106V91.2761Z",
                        fill: "var(--ds-background-accent-gray-subtle, #6C798F)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M75.5989 27.5788L47.6736 32.9175V28.5326L75.5989 22.7067V27.5788Z",
                        fill: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M84.4022 32.8103L47.093 38.827L47.2989 40.1039L84.6082 34.0873L84.4022 32.8103Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M84.4182 36.8671L47.1039 42.3507L47.292 43.6305L84.6063 38.1469L84.4182 36.8671Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M75.6704 42.0758L47.1106 45.8759L47.2812 47.1582L75.8411 43.3581L75.6704 42.0758Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M60.7905 75.4418V84.1979L47.6702 83.9851V75.6614L60.7905 75.4418Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M60.7905 66.6859V75.4419L47.6702 75.6615V67.3412L60.7905 66.6859Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M60.7905 57.9298V66.6858L47.6702 67.3412V59.0209L60.7905 57.9298Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M60.7905 49.1772V57.9298L47.6702 59.0209V50.7006L60.7905 49.1772Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M75.3519 47.4857V56.7221L60.7905 57.9298V49.1772L75.3519 47.4857Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M91.6115 45.5986V55.3737L75.3518 56.7221V47.4857L91.6115 45.5986Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M109.878 43.4748V53.8571L91.6116 55.3737V45.5986L109.878 43.4748Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M109.879 53.8571V84.9939L60.7905 84.1979V57.9298L109.879 53.8571Z",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M109.879 74.6116L91.6116 74.9204L75.3519 75.1948L60.7905 75.4419",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M109.879 64.2326L91.6116 65.1453L75.3519 65.9584L60.7905 66.6858",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M91.6116 84.6954V74.9203V65.1453V55.3737",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M75.3518 84.4312V75.1948V65.9584V56.722",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.2",
                        d: "M94.0374 10.6705L101.28 46.024L117.557 34.6295L94.0374 10.6705Z",
                        fill: "url(#paint12_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M53.8528 13.7208L47.2858 15.1858C46.4829 15.3642 45.8345 16.3043 45.8345 17.2822V23.6262C45.8345 24.604 46.4864 25.2525 47.2858 25.0741L48.9087 24.7138L50.1267 26.5288C50.3429 26.8514 50.7958 26.7519 51.0119 26.3298L52.2299 23.9727L53.8528 23.6125C54.6557 23.434 55.3042 22.4939 55.3042 21.5161V15.1687C55.3042 14.1908 54.6557 13.5423 53.8528 13.7208Z",
                        fill: "url(#paint13_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M53.1976 13.8683L46.6305 15.3333C45.8277 15.5117 45.1792 16.4518 45.1792 17.4297V23.7737C45.1792 24.7516 45.8311 25.4 46.6305 25.2216L48.2534 24.8613L49.4714 26.6764C49.6876 26.9989 50.1405 26.8994 50.3566 26.4774L51.5747 24.1202L53.1976 23.76C54.0004 23.5816 54.6489 22.6415 54.6489 21.6636V15.3127C54.6523 14.3349 54.0004 13.6864 53.1976 13.8683Z",
                        fill: "url(#paint14_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M105.302 76.9652L98.5595 77.4181C97.7361 77.473 97.067 78.3102 97.067 79.2881V85.6321C97.067 86.6099 97.7361 87.3579 98.5595 87.303L100.224 87.1898L101.476 89.1901C101.699 89.5469 102.162 89.516 102.385 89.1283L103.637 86.9599L105.302 86.8467C106.125 86.7918 106.794 85.9546 106.794 84.9767V78.6327C106.794 77.6583 106.125 76.9103 105.302 76.9652Z",
                        fill: "url(#paint15_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M104.632 77.0099L97.8904 77.4628C97.067 77.5177 96.3979 78.3548 96.3979 79.3327V85.6767C96.3979 86.6545 97.067 87.4025 97.8904 87.3476L99.5545 87.2344L100.807 89.2347C101.03 89.5915 101.493 89.5606 101.716 89.1729L102.968 87.0045L104.632 86.8913C105.456 86.8364 106.125 85.9992 106.125 85.0214V78.6773C106.122 77.7029 105.456 76.955 104.632 77.0099Z",
                        fill: "url(#paint16_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.2",
                        d: "M94.1334 142.388L113.55 146.139V119.318L94.1334 117.369V142.388Z",
                        fill: "var(--ds-background-accent-gray-subtle, #6C798F)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M48.1231 128.537L63.8029 131.564C64.1461 131.629 64.4617 131.368 64.4617 131.018V107.313C64.4617 107.028 64.2456 106.788 63.9608 106.76L48.2809 105.189C47.9549 105.155 47.6702 105.412 47.6702 105.741V127.992C47.6736 128.259 47.8623 128.486 48.1231 128.537ZM49.1078 106.942L63.0275 108.339V123.501V129.728L58.1314 128.784L49.5641 127.131L49.1078 127.041V106.942Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M66.4312 132.071L84.7392 135.605C85.0823 135.67 85.398 135.41 85.398 135.06V109.413C85.398 109.128 85.1818 108.888 84.8971 108.86L66.589 107.025C66.2631 106.99 65.9783 107.248 65.9783 107.577V131.526C65.9817 131.793 66.1704 132.02 66.4312 132.071ZM67.4159 118.766V108.781L83.9638 110.442V121.332V133.773L69.2103 130.925L67.4159 130.579V118.766Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M54.92 121.349L59.6514 127.141L63.0275 123.501V108.339L49.1078 106.942V127.041L49.5641 127.131L54.92 121.349Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M54.92 121.349L59.6514 127.141L63.0275 123.501V108.339L49.1078 106.942V127.041L49.5641 127.131L54.92 121.349Z",
                        fill: "url(#paint17_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M73.8628 125.902L81.219 117.966L83.9638 121.325V110.439L67.4159 108.778V118.766L67.7453 118.409L73.8628 125.902Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M73.8628 125.902L81.219 117.966L83.9638 121.325V110.439L67.4159 108.778V118.766L67.7453 118.409L73.8628 125.902Z",
                        fill: "url(#paint18_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M49.5641 127.131L58.1314 128.784L49.5641 127.131Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M59.6514 127.141L54.92 121.349L49.5641 127.131L58.1314 128.784L59.6514 127.141Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M69.2103 130.922L67.4159 130.575L69.2103 130.922Z",
                        fill: "var(--ds-background-accent-gray-bolder, #42526E)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M73.8628 125.902L67.7453 118.409L67.4159 118.766V130.575L69.2103 130.922L73.8628 125.902Z",
                        fill: "var(--ds-background-accent-gray-bolder, #42526E)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M58.1315 128.784L63.0276 129.728L58.1315 128.784Z",
                        fill: "var(--ds-background-accent-gray-bolder, #42526E)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M58.1315 128.784L63.0276 129.728V123.501L59.6514 127.141L58.1315 128.784Z",
                        fill: "var(--ds-background-accent-gray-bolder, #42526E)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M69.2103 130.922L83.9638 133.77L69.2103 130.922Z",
                        fill: "var(--ds-background-accent-gray-subtle, #5E6C84)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M73.8628 125.902L69.2103 130.922L83.9638 133.77V121.325L81.219 117.966L73.8628 125.902Z",
                        fill: "var(--ds-background-accent-gray-subtle, #5E6C84)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M87.3125 129.824C87.4464 129.8 87.9404 129.694 88.1429 129.292C88.2389 129.1 88.2355 128.908 88.2286 128.644C88.2218 128.301 88.1497 128.023 88.0914 127.837L88.8565 127.343C88.9148 127.306 88.9492 127.234 88.9354 127.165C88.9114 127.059 88.8016 127.007 88.7056 127.045L87.8855 127.398C87.8238 127.426 87.7723 127.474 87.7449 127.535L87.3812 128.301L86.8837 129.398L87.3125 129.824Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M88.5614 127.402L88.9937 127.244C89.0726 127.213 89.1653 127.247 89.2099 127.319C89.2613 127.402 89.2373 127.508 89.1584 127.559L88.2492 128.187L88.0262 128.863L87.7277 128.438L87.9781 127.755L88.5614 127.402Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M89.45 127.704C89.4843 127.786 89.45 127.879 89.3711 127.92C89.1549 128.002 88.9354 128.084 88.7192 128.167C88.4859 128.383 88.2526 128.599 88.0193 128.815L87.834 128.52L88.5305 127.827L89.2407 127.604C89.3265 127.58 89.4191 127.621 89.45 127.704Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M89.3333 128.359C89.3368 128.424 89.2887 128.479 89.2235 128.489L88.6505 128.561C88.4962 128.654 88.3418 128.75 88.1874 128.846C88.1462 128.76 88.105 128.675 88.0638 128.589C88.2628 128.462 88.4653 128.338 88.6643 128.211L89.2167 128.239C89.2784 128.239 89.3299 128.294 89.3333 128.359Z",
                        fill: "var(--ds-icon-accent-yellow, #72594B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M78.4398 136.71C79.7779 136.213 81.2052 135.739 82.7183 135.31C83.2536 135.159 83.7785 135.019 84.3001 134.888C84.5848 134.247 84.825 133.728 84.9863 133.379C85.4597 132.363 85.7171 131.872 86.3106 130.63C86.568 130.088 86.7738 129.649 86.9042 129.368C87.1581 129.491 87.412 129.615 87.6659 129.738C87.4841 130.96 87.1238 132.486 86.393 134.126C86.0602 134.878 85.6965 135.544 85.3397 136.123C84.8524 136.47 83.3634 137.509 81.9772 138.031C81.7233 138.127 81.3322 138.257 80.8278 138.288C80.399 138.316 79.8568 138.347 79.3422 138.031C78.6079 137.578 78.4604 136.83 78.4398 136.71Z",
                        fill: "url(#paint19_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M91.0009 111.708L86.5851 136.686C86.5062 137.132 86.7979 137.561 87.2439 137.647L107.563 141.637C108.019 141.726 108.461 141.424 108.54 140.965L113.296 114.069C113.382 113.592 113.042 113.146 112.558 113.098L91.9033 111.025C91.471 110.981 91.0764 111.279 91.0009 111.708ZM107.298 139.867L106.598 139.729L88.1188 136.099L89.4501 128.565L92.2498 112.727L111.748 114.683L107.298 139.867Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M89.4535 128.568L93.2414 134.363L99.4584 128.808L106.598 139.733L107.298 139.87L111.752 114.69L92.2532 112.734L89.4535 128.568ZM102.231 117.918C103.397 117.918 104.149 118.996 103.915 120.323C103.682 121.651 102.546 122.729 101.38 122.729C100.213 122.729 99.4619 121.651 99.6952 120.323C99.9285 118.996 101.064 117.918 102.231 117.918Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M89.4535 128.568L93.2414 134.363L99.4584 128.808L106.598 139.733L107.298 139.87L111.752 114.69L92.2532 112.734L89.4535 128.568ZM102.231 117.918C103.397 117.918 104.149 118.996 103.915 120.323C103.682 121.651 102.546 122.729 101.38 122.729C100.213 122.729 99.4619 121.651 99.6952 120.323C99.9285 118.996 101.064 117.918 102.231 117.918Z",
                        fill: "url(#paint20_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M106.598 139.729L88.1222 136.103L106.598 139.729Z",
                        fill: "var(--ds-background-accent-gray-subtle, #5E6C84)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93.2413 134.36L89.4534 128.568L88.1222 136.103L106.598 139.729L99.4584 128.805L93.2413 134.36Z",
                        fill: "var(--ds-background-accent-gray-subtle, #5E6C84)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M101.38 122.732C102.546 122.732 103.679 121.655 103.915 120.327C104.149 118.999 103.397 117.922 102.231 117.922C101.064 117.922 99.9319 118.999 99.6952 120.327C99.4584 121.655 100.213 122.732 101.38 122.732Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M101.38 122.732C102.546 122.732 103.679 121.655 103.915 120.327C104.149 118.999 103.397 117.922 102.231 117.922C101.064 117.922 99.9319 118.999 99.6952 120.327C99.4584 121.655 100.213 122.732 101.38 122.732Z",
                        fill: "url(#paint21_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M101.38 122.732C102.546 122.732 103.679 121.655 103.915 120.327C104.149 118.999 103.397 117.922 102.231 117.922C101.064 117.922 99.9319 118.999 99.6952 120.327C99.4584 121.655 100.213 122.732 101.38 122.732Z",
                        fill: "url(#paint22_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.2",
                        d: "M28.1132 148.904C43.5435 148.904 56.0522 147.858 56.0522 146.567C56.0522 145.277 43.5435 144.231 28.1132 144.231C12.6829 144.231 0.174194 145.277 0.174194 146.567C0.174194 147.858 12.6829 148.904 28.1132 148.904Z",
                        fill: "url(#paint23_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M43.3951 146.149C43.1481 146.149 42.9147 145.998 42.8221 145.754L29.6435 111.015C29.5234 110.699 29.6812 110.346 30.0003 110.226C30.3159 110.106 30.6693 110.264 30.7894 110.579L43.9681 145.319C44.0882 145.634 43.9303 145.988 43.6112 146.108C43.5426 146.135 43.4671 146.149 43.3951 146.149Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M54.8514 146.149C54.6044 146.149 54.371 145.998 54.2784 145.754L41.0998 111.015C40.9797 110.699 41.1375 110.346 41.4566 110.226C41.7722 110.106 42.1256 110.264 42.2457 110.579L55.4244 145.319C55.5445 145.634 55.3866 145.988 55.0675 146.108C54.9989 146.135 54.9234 146.149 54.8514 146.149Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M43.3642 115.866H31.908C31.5717 115.866 31.2972 115.592 31.2972 115.256C31.2972 114.92 31.5717 114.645 31.908 114.645H43.3642C43.7005 114.645 43.975 114.92 43.975 115.256C43.975 115.592 43.7005 115.866 43.3642 115.866Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M45.265 120.879H33.8087C33.4725 120.879 33.198 120.605 33.198 120.269C33.198 119.932 33.4725 119.658 33.8087 119.658H45.265C45.6012 119.658 45.8757 119.932 45.8757 120.269C45.8757 120.605 45.6047 120.879 45.265 120.879Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M47.1659 125.892H35.7096C35.3734 125.892 35.0989 125.618 35.0989 125.281C35.0989 124.945 35.3734 124.671 35.7096 124.671H47.1659C47.5021 124.671 47.7766 124.945 47.7766 125.281C47.7766 125.618 47.5055 125.892 47.1659 125.892Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M49.07 130.905H37.6138C37.2775 130.905 37.0031 130.63 37.0031 130.294C37.0031 129.958 37.2775 129.683 37.6138 129.683H49.07C49.4063 129.683 49.6808 129.958 49.6808 130.294C49.6808 130.63 49.4063 130.905 49.07 130.905Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M50.9709 135.918H39.5147C39.1784 135.918 38.9039 135.643 38.9039 135.307C38.9039 134.971 39.1784 134.696 39.5147 134.696H50.9709C51.3072 134.696 51.5816 134.971 51.5816 135.307C51.5816 135.643 51.3072 135.918 50.9709 135.918Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M52.8717 140.927H41.4154C41.0792 140.927 40.8047 140.652 40.8047 140.316C40.8047 139.98 41.0792 139.705 41.4154 139.705H52.8717C53.2079 139.705 53.4824 139.98 53.4824 140.316C53.4824 140.652 53.2114 140.927 52.8717 140.927Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M24.5484 146.149C24.4763 146.149 24.4043 146.135 24.3322 146.108C24.0166 145.988 23.8587 145.634 23.9754 145.319L37.154 110.579C37.2741 110.264 37.6275 110.106 37.9432 110.226C38.2588 110.346 38.4167 110.699 38.3 111.015L25.1214 145.754C25.0253 145.998 24.7954 146.149 24.5484 146.149Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M13.0921 146.149C13.02 146.149 12.948 146.135 12.8759 146.108C12.5603 145.988 12.4024 145.634 12.5191 145.319L25.6978 110.579C25.8178 110.264 26.1712 110.106 26.4869 110.226C26.8026 110.346 26.9604 110.699 26.8437 111.015L13.6616 145.754C13.569 145.998 13.3391 146.149 13.0921 146.149Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M42.6025 111.283H25.5536C24.8091 111.283 24.2052 110.679 24.2052 109.934C24.2052 109.19 24.8091 108.586 25.5536 108.586H42.6025C43.347 108.586 43.9509 109.19 43.9509 109.934C43.9509 110.679 43.347 111.283 42.6025 111.283Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M42.6025 111.283H39.2915C38.547 111.283 37.9431 110.679 37.9431 109.934C37.9431 109.19 38.547 108.586 39.2915 108.586H42.6025C43.347 108.586 43.9509 109.19 43.9509 109.934C43.9509 110.679 43.347 111.283 42.6025 111.283Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M36.0355 115.866H24.5792C24.243 115.866 23.9685 115.592 23.9685 115.256C23.9685 114.92 24.243 114.645 24.5792 114.645H36.0355C36.3717 114.645 36.6462 114.92 36.6462 115.256C36.6462 115.592 36.3717 115.866 36.0355 115.866Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M34.1347 120.879H22.6785C22.3422 120.879 22.0677 120.605 22.0677 120.269C22.0677 119.932 22.3422 119.658 22.6785 119.658H34.1347C34.471 119.658 34.7455 119.932 34.7455 120.269C34.7455 120.605 34.471 120.879 34.1347 120.879Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M32.2339 125.892H20.7742C20.4379 125.892 20.1635 125.618 20.1635 125.281C20.1635 124.945 20.4379 124.671 20.7742 124.671H32.2304C32.5667 124.671 32.8412 124.945 32.8412 125.281C32.8412 125.618 32.5701 125.892 32.2339 125.892Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M30.3297 130.905H18.8734C18.5372 130.905 18.2627 130.63 18.2627 130.294C18.2627 129.958 18.5372 129.683 18.8734 129.683H30.3297C30.6659 129.683 30.9404 129.958 30.9404 130.294C30.9404 130.63 30.6694 130.905 30.3297 130.905Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M28.4288 135.918H16.9725C16.6363 135.918 16.3618 135.643 16.3618 135.307C16.3618 134.971 16.6363 134.696 16.9725 134.696H28.4288C28.765 134.696 29.0395 134.971 29.0395 135.307C29.0395 135.643 28.7685 135.918 28.4288 135.918Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M26.528 140.927H15.0718C14.7355 140.927 14.4611 140.652 14.4611 140.316C14.4611 139.98 14.7355 139.705 15.0718 139.705H26.528C26.8643 139.705 27.1388 139.98 27.1388 140.316C27.1388 140.652 26.8643 140.927 26.528 140.927Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M40.2832 79.2538C42.033 79.6003 43.7829 79.9503 45.5327 80.2968C47.5605 80.4787 49.5882 80.6571 51.616 80.8389C51.6125 81.1443 51.6057 81.4497 51.6022 81.755C49.8558 81.906 47.8967 81.9815 45.7626 81.9197C43.4158 81.8511 41.2851 81.6246 39.4152 81.3296C39.7034 80.6365 39.9916 79.9434 40.2832 79.2538Z",
                        fill: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M67.5497 93.7637L67.9408 94.0553L69.3784 92.1339L68.8501 91.7394C67.9511 91.0669 67.3164 90.0993 67.0556 89.0048L67.0247 88.871C66.764 87.7765 66.1292 86.8124 65.2303 86.1365L30.6248 60.2492C29.0019 59.0346 26.6996 59.3674 25.4851 60.9903C24.2705 62.6132 24.6033 64.9154 26.2262 66.13L60.6876 91.9143C61.6723 92.6486 62.8972 92.9814 64.1186 92.8407C65.3401 92.6966 66.5684 93.0294 67.5497 93.7637Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M47.7216 82.2113C47.104 80.3311 46.4281 77.775 45.9066 75.8158C45.3679 73.7778 44.8979 72.052 44.4724 70.611L41.7825 68.5969C42.5579 70.7585 43.4294 74.0386 44.0298 76.3133C44.4278 77.8127 44.7778 79.1199 45.0969 80.2488L47.7216 82.2113Z",
                        fill: "var(--ds-icon-brand, #0065FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M31.8119 61.1344C34.9513 71.3349 36.6531 73.3455 38.3 73.1053C39.7754 72.8892 40.1631 70.9129 40.5748 68.8234C40.6297 68.5386 40.6983 68.1886 40.7772 67.8421L39.0857 66.576C38.9279 67.1387 38.8009 67.7769 38.6671 68.446C38.5196 69.2008 38.2588 70.5217 37.9878 71.057C37.552 70.6418 36.461 69.0636 34.495 63.1416L31.8119 61.1344Z",
                        fill: "var(--ds-icon-brand, #0065FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M49.324 74.2376C49.1525 78.8249 48.8849 81.4257 48.6378 82.8941L50.3533 84.1774C50.7239 82.6094 51.019 79.9949 51.2145 75.6512L49.324 74.2376Z",
                        fill: "var(--ds-icon-brand, #0065FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M70.2362 94.6901L70.5209 93.6608C70.5621 93.5201 70.5072 93.3657 70.3905 93.2765L69.1931 92.381L68.1672 93.75L69.6769 94.8788C69.8793 95.0332 70.1675 94.9337 70.2362 94.6901Z",
                        fill: "var(--ds-icon-brand, #0065FF)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M29.1598 105.645C28.9573 105.711 28.6828 105.824 28.3946 106.023C28.103 106.218 27.8971 106.431 27.7599 106.596C27.8045 106.719 27.856 106.846 27.9143 106.973C28.2368 107.673 28.676 108.198 29.0774 108.572C29.5852 108.575 30.093 108.579 30.6008 108.582C30.6077 108.538 30.6077 108.493 30.6008 108.459C30.5356 108.068 29.846 107.92 29.8048 107.913C29.7327 107.759 29.6195 107.467 29.6229 107.083C29.6229 106.706 29.7362 106.417 29.8082 106.266C29.5921 106.061 29.3759 105.851 29.1598 105.645Z",
                        fill: "var(--ds-icon, #344563)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M35.1091 84.3146C36.7729 84.3146 38.1216 82.9659 38.1216 81.3021C38.1216 79.6384 36.7729 78.2897 35.1091 78.2897C33.4454 78.2897 32.0967 79.6384 32.0967 81.3021C32.0967 82.9659 33.4454 84.3146 35.1091 84.3146Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M36.0046 85.6938C37.0202 84.8429 39.3739 85.2409 40.0842 86.4521C40.8253 87.7147 39.7548 89.8145 38.4784 92.2814C38.125 92.9608 37.5863 93.9558 35.1572 97.8329C33.8088 99.9841 33.5309 100.382 32.68 101.768C31.4585 103.755 30.515 105.391 29.918 106.448C29.4822 106.242 29.0465 106.04 28.6073 105.834C29.242 104.348 29.7087 103.124 30.014 102.29C30.6591 100.526 30.9233 99.5758 31.6163 98.0696C32.0727 97.078 32.505 96.2992 32.7897 95.8085C33.0608 95.0057 33.3319 94.1891 33.596 93.3622C34.1107 91.753 34.591 90.1679 35.0337 88.6171C35.0028 88.2705 34.9993 87.6907 35.2224 87.0319C35.3047 86.778 35.538 86.0815 36.0046 85.6938Z",
                        fill: "var(--ds-background-accent-teal-subtle, #00B8D9)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M38.523 106.716C38.4646 106.929 38.4098 107.155 38.3617 107.399C38.3 107.725 38.2588 108.033 38.2382 108.315C38.2279 108.459 38.3411 108.582 38.4852 108.582C39.5351 108.579 40.585 108.572 41.6349 108.569C41.6452 108.442 41.6349 108.274 41.532 108.15C41.4051 108.003 41.2163 108.013 40.9933 107.975C40.9933 107.975 40.3414 107.869 39.8233 107.361C39.6964 107.237 39.518 107.025 39.3842 106.685C39.096 106.695 38.8078 106.706 38.523 106.716Z",
                        fill: "var(--ds-icon, #344563)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M37.902 84.4107C38.0015 84.3832 39.0857 84.1156 39.9538 84.7126C40.7258 85.241 41.086 86.2771 41.0345 90.1577C41.0071 92.0893 40.887 94.1823 40.5508 97.3217C40.2969 99.6822 40.1768 100.235 39.9881 102.334C39.8131 104.283 39.7273 105.882 39.6827 106.942C39.1612 106.973 38.6362 107.004 38.1147 107.032C37.7716 105.083 37.5452 103.436 37.3976 102.17C37.2432 100.869 37.1815 100.08 37.2913 99.1093C37.4217 97.9667 37.7682 96.8105 37.8025 96.6972C37.878 96.4502 37.9535 96.2203 38.0255 96.0145C37.9294 95.4895 37.7716 94.6729 37.5452 93.6779C37.2673 92.4393 37.0202 91.3482 36.6222 89.9792C35.9532 87.677 35.6787 87.4368 35.8434 86.682C36.0458 85.7659 36.7663 84.7092 37.902 84.4107Z",
                        fill: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M41.2335 76.1109C41.3399 76.4231 41.5595 77.0613 41.2918 77.8161C41.2164 78.0289 40.9659 78.6396 40.3963 78.9518C40.3071 78.9999 40.1081 79.1096 39.8199 79.144C39.7273 79.1543 39.4253 79.192 39.2641 79.1028C38.6431 78.7665 39.3464 76.1212 40.2419 75.459C40.4684 75.2943 40.6228 75.3115 40.6605 75.3183C40.9796 75.3767 41.1374 75.8399 41.2335 76.1109Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M35.1091 87.2653C35.4419 87.5226 36.7663 88.497 38.6706 88.3838C40.2866 88.2877 41.3674 87.4677 41.7276 87.1692C41.5904 86.9565 41.3948 86.6202 41.2404 86.1776C41.134 85.8654 40.7463 84.6302 41.1787 83.275C41.3845 82.6265 41.5869 82.5544 41.5972 82.0535C41.6007 81.827 41.5595 81.7241 41.261 80.6365C41.0414 79.8405 41.0345 79.789 40.9591 79.6861C40.887 79.5866 40.5439 79.1646 39.271 79.1028C37.854 79.0307 36.6325 79.5077 35.8468 79.9194C35.936 80.8801 36.0733 81.6521 36.183 82.1942C36.4267 83.3985 36.6428 83.9097 36.4061 84.6233C36.2928 84.963 36.1968 84.9905 35.8159 85.711C35.4728 86.356 35.2464 86.9016 35.1091 87.2653Z",
                        fill: "var(--ds-background-accent-teal-subtle, #79E2F2)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M41.1684 77.106C41.1547 77.13 41.117 77.1574 41.0449 77.2158C40.9831 77.2638 40.9282 77.2981 40.8871 77.3221C40.8871 77.4285 40.8836 77.5417 40.8768 77.6584C40.8631 77.8848 40.8356 78.0907 40.8013 78.2794C40.6435 78.3206 40.4239 78.3686 40.1563 78.396C39.8818 78.4235 39.4666 78.4647 38.9794 78.348C38.7804 78.3 38.4888 78.2313 38.228 78.0495C37.6996 77.679 37.2364 76.7869 37.5864 75.9394C37.9501 75.0611 39.1167 74.6836 39.8372 74.9993C39.9298 75.0405 40.3999 75.2463 40.5954 75.6992C40.6812 75.8948 40.6366 75.9188 40.7739 76.2516C40.8082 76.3306 40.8493 76.4335 40.918 76.5639C41.0861 76.8727 41.2199 76.9996 41.1684 77.106Z",
                        fill: "var(--ds-background-accent-orange-subtler, #CEA28B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M38.1216 77.4971C38.2074 77.6412 38.3515 77.9362 38.372 78.3377C38.3961 78.77 38.2657 79.0959 38.1936 79.2503C38.4853 79.4425 38.7838 79.6483 39.0857 79.8576C39.518 80.163 39.9297 80.4649 40.3243 80.7669C40.1493 80.3208 39.9778 79.8782 39.8028 79.4322C39.7994 79.2881 39.8062 79.1303 39.8199 78.9621C39.8405 78.7494 39.8714 78.5573 39.9092 78.3891C39.3122 78.0906 38.7186 77.7921 38.1216 77.4971Z",
                        fill: "var(--ds-background-accent-orange-subtler, #CEA28B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M35.8777 69.9248C35.9772 69.8424 36.3409 69.5165 36.3238 69.0807C36.3135 68.8714 36.2174 68.7136 36.087 68.494C35.9155 68.2092 35.7233 68.0068 35.5861 67.8799L35.9944 67.101C36.0253 67.0393 36.0218 66.9638 35.9738 66.9157C35.9052 66.8368 35.7851 66.8471 35.7233 66.926L35.2018 67.6122C35.1606 67.6637 35.1435 67.7289 35.1469 67.7941L35.315 69.7738L35.8777 69.9248Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M35.7714 67.2897L36.0596 66.9501C36.1145 66.8883 36.2037 66.8711 36.2758 66.9089C36.3581 66.9535 36.389 67.053 36.3478 67.1353L35.8812 68.096L36.015 68.7719L35.5587 68.5592L35.442 67.8627L35.7714 67.2897Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M36.6669 67.1182C36.7321 67.1697 36.7492 67.2657 36.7012 67.3378C36.5571 67.5128 36.4164 67.6843 36.2723 67.8593C36.1797 68.1509 36.087 68.446 35.9944 68.7377L35.6993 68.5764L35.9532 67.6603L36.4473 67.1354C36.5022 67.0702 36.5983 67.0633 36.6669 67.1182Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M36.8762 67.7254C36.9105 67.7803 36.8968 67.849 36.8453 67.8867L36.3993 68.2229C36.3135 68.3773 36.2277 68.5283 36.1454 68.6827C36.0699 68.6312 35.9944 68.5763 35.9189 68.5249C36.0287 68.3224 36.1351 68.12 36.2449 67.921L36.7218 67.6808C36.7733 67.65 36.8453 67.6705 36.8762 67.7254Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M35.5587 68.9949C35.5072 68.9949 35.3116 69.3346 35.2773 69.29L34.7421 68.0651C34.6837 67.9896 34.6975 67.8833 34.7695 67.825C34.845 67.7666 34.9514 67.7804 35.0097 67.8524L35.6925 68.717C35.7508 68.7925 35.7371 68.8989 35.665 68.9572C35.6341 68.9847 35.5964 68.9949 35.5587 68.9949Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M40.0224 76.5982C39.8474 76.8143 39.7548 76.7079 39.5867 76.9001C39.2298 77.3015 39.5901 77.8162 39.2573 78.1867C39.0995 78.3651 38.9416 78.2416 38.8113 78.4132C38.6225 78.6671 38.9245 78.9518 38.8113 79.391C38.7255 79.7204 38.4407 80.0223 38.125 80.1081C37.7442 80.2145 37.5726 79.94 37.2879 80.0464C36.8796 80.2008 37.0546 80.8664 36.6531 81.2644C36.1247 81.7893 34.8964 81.8339 34.0936 81.182C33.2907 80.5301 33.2495 79.4596 33.4245 78.8009C33.5961 78.1456 34.0661 77.5794 34.5945 77.2706C35.14 76.9516 35.4694 77.0716 35.9944 76.6359C36.2311 76.4403 36.2551 76.4403 36.6806 75.785C36.8761 75.4796 37.2295 74.9375 37.7854 74.6287C38.4235 74.2753 39.0754 74.3645 39.3499 74.3989C39.693 74.4469 40.3484 74.5327 40.5714 74.9821C40.592 75.0233 40.7395 75.339 40.6091 75.5929C40.5679 75.6752 40.5268 75.6855 40.4479 75.7713C40.1631 76.0663 40.2489 76.3202 40.0224 76.5982Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M38.1216 80.7943C37.7236 79.0548 37.3256 77.3152 36.9276 75.5757C36.6909 73.5548 36.4507 71.5339 36.2139 69.5096C35.9086 69.5233 35.6032 69.537 35.3013 69.5508C35.2018 71.3006 35.1812 73.2597 35.3047 75.3904C35.442 77.7338 35.7267 79.8576 36.0767 81.7207C36.756 81.4119 37.4388 81.1031 38.1216 80.7943Z",
                        fill: "var(--ds-background-accent-teal-subtle, #79E2F2)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.2",
                        d: "M72.9364 160C81.113 160 87.7414 159.161 87.7414 158.127C87.7414 157.092 81.113 156.253 72.9364 156.253C64.7599 156.253 58.1315 157.092 58.1315 158.127C58.1315 159.161 64.7599 160 72.9364 160Z",
                        fill: "url(#paint24_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M77.5306 136.604C78.5198 136.604 79.3216 135.802 79.3216 134.813C79.3216 133.824 78.5198 133.022 77.5306 133.022C76.5415 133.022 75.7396 133.824 75.7396 134.813C75.7396 135.802 76.5415 136.604 77.5306 136.604Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M69.2892 157.228C71.5571 157.444 74.9333 157.66 77.2012 157.876C77.3865 157.866 78.2271 157.794 78.7417 157.125C79.0848 156.682 79.1191 156.192 79.1397 155.872C79.1877 155.176 78.9613 154.534 78.8412 154.202C78.8103 154.112 78.7829 154.04 78.7623 153.992C77.9217 151.889 77.5237 151.144 77.0948 150.026C76.4086 148.235 76.6659 148.307 76.2096 147.384C75.7258 146.406 74.8509 145.229 73.1491 144.159C72.933 144.461 72.655 144.907 72.4011 145.483C72.209 145.919 71.9757 146.451 71.9105 147.137C71.8762 147.497 71.8796 147.981 72.1061 148.842C72.2193 149.275 72.583 150.537 73.6981 152.284C74.0858 152.891 74.645 153.68 75.4136 154.538C74.5524 154.332 73.6432 154.14 72.6859 153.972C71.9585 153.841 70.1401 153.735 69.4607 153.649C69.4024 154.84 69.3441 156.034 69.2892 157.228Z",
                        fill: "url(#paint25_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M73.3208 143.932C73.0634 144.245 72.7272 144.715 72.4356 145.336C72.0582 146.145 71.5847 147.164 71.8969 148.348C71.9484 148.547 72.1679 149.71 73.2419 150.252C73.5644 150.414 73.8526 150.554 74.1957 150.681C74.1957 150.681 74.8716 150.928 75.6642 151.059C77.3179 151.333 79.7883 151.021 79.9496 151C79.4315 151.446 78.8894 151.951 78.3404 152.524C77.6062 153.285 76.9851 154.03 76.4636 154.723C77.5684 155.402 78.6732 156.082 79.778 156.765C80.5534 155.941 81.3597 155.015 82.1729 153.982C83.1164 152.781 83.9261 151.618 84.6158 150.527C84.6741 150.328 84.7908 149.844 84.6055 149.299C84.2727 148.324 83.2811 148.015 83.1747 147.984C81.9567 147.659 80.7387 147.333 79.5207 147.01C78.6183 146.773 77.7125 146.537 76.8101 146.3C76.1617 145.936 75.472 145.511 74.7618 145.017C74.2403 144.656 73.76 144.289 73.3208 143.932Z",
                        fill: "var(--ds-background-accent-yellow-subtle, #FFAB00)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M79.2805 143.325C78.8585 143.747 78.4433 144.166 78.0796 144.619C77.7434 145.041 77.3591 145.61 77.0263 146.358C76.3881 146.169 75.623 145.885 74.7995 145.449C74.0962 145.078 73.5129 144.68 73.0428 144.317C73.4752 143.562 73.7908 142.917 74.0035 142.443C74.4358 141.486 74.5422 141.061 74.9368 140.296C75.3211 139.544 75.7225 138.964 76.021 138.577C76.021 138.577 76.8513 137.345 77.4483 136.885C77.4689 136.868 77.86 136.569 77.86 136.569L79.6888 138.264C79.8535 138.415 79.9701 138.607 80.0319 138.824C80.0593 139.218 80.1245 139.829 80.3167 140.556C80.5019 141.27 80.6323 141.431 80.574 141.785C80.4951 142.234 80.2172 142.388 79.2805 143.325Z",
                        fill: "url(#paint26_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M79.6201 138.748C79.6201 138.669 79.6098 138.57 79.5824 138.456C79.5481 138.319 79.5 138.209 79.4554 138.131C79.4486 137.829 79.4863 137.352 79.7299 136.851C79.8123 136.686 79.9015 136.545 79.9907 136.425L78.7315 135.626L77.86 136.569L78.2992 137.091C78.5805 137.427 78.8104 137.805 79.0231 138.185C79.0609 138.254 79.1089 138.323 79.1672 138.395C79.3285 138.59 79.5103 138.693 79.6201 138.748Z",
                        fill: "var(--ds-background-accent-orange-subtler, #CEA28B)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M82.8796 158.734C82.8796 158.734 82.6257 158.226 81.9258 157.962C81.2705 157.715 80.9033 158.013 80.0867 157.705C79.8603 157.619 79.3182 157.413 79.2873 157.053C79.2702 156.864 79.404 156.696 79.5069 156.596C78.9682 156.264 78.4295 155.931 77.8909 155.598C77.8909 155.598 77.4723 156.089 77.2458 157.077C77.016 158.065 77.1052 159.033 77.1052 159.033L82.8796 158.734Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M69.4128 154.562C69.2 154.486 68.9015 154.407 68.5378 154.387C68.109 154.363 67.7556 154.428 67.5154 154.493C67.6286 155.643 67.7418 156.792 67.8585 157.941C67.8585 157.979 67.8516 158.24 68.0575 158.429C68.2153 158.573 68.3972 158.586 68.4486 158.59C68.9804 158.542 69.5123 158.49 70.0406 158.442C70.0029 158.37 69.9343 158.257 69.821 158.147C69.4574 157.794 69.0696 157.886 68.8981 157.574C68.8055 157.406 68.826 157.217 68.8363 157.152C68.8569 156.967 68.9393 156.84 69.0045 156.737C69.0628 156.648 69.1623 156.511 69.327 156.384C69.3579 155.776 69.3853 155.169 69.4128 154.562Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M78.7624 135.694L80.2823 136.655C80.4916 136.786 80.7421 136.834 80.9857 136.782C81.195 136.738 81.3837 136.621 81.5209 136.456L82.0905 135.76L82.3066 135.918C82.389 135.979 82.5056 135.918 82.5022 135.815L82.4782 135.125L82.6017 134.758C82.7595 134.288 82.8144 133.787 82.7664 133.293C82.7012 132.641 82.3512 132.047 81.8126 131.673C81.2224 131.265 80.4745 131.162 79.7951 131.395L79.6613 131.443C79.5138 131.495 79.3765 131.577 79.2564 131.68C78.6148 132.253 78.3609 133.142 78.5977 133.969L78.7383 134.452L78.7624 135.694Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M90.3627 138.196C90.4862 138.282 90.9631 138.59 91.4435 138.436C91.6734 138.36 91.8243 138.206 92.0268 137.993C92.2944 137.715 92.4625 137.437 92.562 137.245L93.557 137.465C93.6325 137.482 93.7183 137.455 93.7594 137.386C93.8246 137.283 93.78 137.153 93.6737 137.108L92.7438 136.734C92.6718 136.707 92.5929 136.703 92.5208 136.731L91.6253 137.046L90.3558 137.52L90.3627 138.196Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93.2825 137.273L93.7526 137.492C93.8384 137.534 93.8864 137.63 93.8624 137.722C93.8384 137.825 93.7354 137.894 93.6291 137.873L92.411 137.647L91.6974 138.004L91.7969 137.427L92.5414 137.084L93.2825 137.273Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93.7457 138.22C93.708 138.312 93.6051 138.357 93.5124 138.326C93.2757 138.22 93.0355 138.11 92.7988 138.004C92.4419 137.99 92.0851 137.973 91.7283 137.959L91.8175 137.578L92.9223 137.582L93.66 137.973C93.7457 138.021 93.7835 138.127 93.7457 138.22Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93.1281 138.642C93.0767 138.697 92.9943 138.7 92.936 138.655L92.4247 138.257C92.2257 138.209 92.0302 138.161 91.8312 138.113C91.8655 138.014 91.9032 137.911 91.9375 137.811C92.1949 137.87 92.4556 137.932 92.713 137.99L93.1281 138.45C93.1796 138.505 93.1796 138.59 93.1281 138.642Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M77.8566 136.58C79.3114 137.249 80.8176 138.01 82.3616 138.879C82.9071 139.184 83.4355 139.493 83.9502 139.801C84.6844 139.52 85.2883 139.301 85.6966 139.153C86.8803 138.728 87.4738 138.546 88.9355 138.031C89.5702 137.808 90.0849 137.623 90.4108 137.506C90.5137 137.805 90.6167 138.107 90.7196 138.405C89.6011 139.228 88.1017 140.148 86.2181 140.869C85.3569 141.198 84.5403 141.435 83.7923 141.61C83.4629 141.555 82.7939 141.435 82.0219 141.243C81.4283 141.095 80.5809 140.872 79.6133 140.443C78.9168 140.134 77.9527 139.623 76.9165 138.782C77.2253 138.048 77.541 137.314 77.8566 136.58Z",
                        fill: "url(#paint27_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M78.2649 132.733C78.1757 133.317 78.4845 133.619 78.5908 134.799C78.6286 135.2 78.6251 135.533 78.6183 135.749C79.0677 135.458 79.3525 135.135 79.5138 134.919C79.6819 134.693 79.7986 134.538 79.8878 134.288C80.073 133.766 79.9427 133.368 80.2 133.217C80.224 133.204 80.3269 133.142 80.4196 133.18C80.6735 133.282 80.4127 133.948 80.7078 134.226C80.9994 134.5 81.6547 134.233 81.9944 134.096C82.3856 133.938 82.7767 133.78 82.9071 133.413C83.0512 133.011 82.7973 132.596 82.6841 132.408C82.1694 131.56 80.8141 130.665 79.5618 131.2C78.9579 131.454 78.3712 132.044 78.2649 132.733Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M90.4519 33.2228L117.557 34.6295L94.0374 10.6705L90.4519 33.2228Z",
                        fill: "url(#paint28_linear_499_12980)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint0_linear_499_12980",
                        x1: "50.6701",
                        y1: "127.204",
                        x2: "144.895",
                        y2: "32.9795",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.2415",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFF)",
                                stopOpacity: "0.7585"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.4317",
                                stopColor: "var(--ds-background-accent-blue-bolder, #59A1FF)",
                                stopOpacity: "0.5683"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6043",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AABFF)",
                                stopOpacity: "0.3957"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7666",
                                stopColor: "var(--ds-background-accent-blue-subtle, #81B8FF)",
                                stopOpacity: "0.2334"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9202",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #9FC9FF)",
                                stopOpacity: "0.0798"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint1_linear_499_12980",
                        x1: "121.776",
                        y1: "45.5575",
                        x2: "147.826",
                        y2: "45.5575",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint2_linear_499_12980",
                        x1: "121.776",
                        y1: "48.5346",
                        x2: "147.826",
                        y2: "48.5346",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint3_linear_499_12980",
                        x1: "121.776",
                        y1: "51.5113",
                        x2: "141.565",
                        y2: "51.5113",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint4_linear_499_12980",
                        x1: "56.1854",
                        y1: "0.55854",
                        x2: "82.2361",
                        y2: "0.55854",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint5_linear_499_12980",
                        x1: "56.1854",
                        y1: "3.53525",
                        x2: "82.2361",
                        y2: "3.53525",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint6_linear_499_12980",
                        x1: "56.1854",
                        y1: "6.51231",
                        x2: "75.9746",
                        y2: "6.51231",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint7_linear_499_12980",
                        x1: "54.7482",
                        y1: "124.969",
                        x2: "145.885",
                        y2: "33.833",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #2684FF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3613",
                                stopColor: "var(--ds-background-accent-blue-subtle, #2986FF)",
                                stopOpacity: "0.6387"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6457",
                                stopColor: "var(--ds-background-accent-blue-subtle, #338CFF)",
                                stopOpacity: "0.3543"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9031",
                                stopColor: "var(--ds-background-accent-blue-subtle, #4495FF)",
                                stopOpacity: "0.0969"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-blue-subtle, #4C9AFF)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint8_linear_499_12980",
                        x1: "132.434",
                        y1: "109.023",
                        x2: "129.764",
                        y2: "78.307",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-subtlest, #99C1FF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7911",
                                stopColor: "var(--ds-background-accent-blue-subtle, #66A3FF)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint9_linear_499_12980",
                        x1: "23.785",
                        y1: "51.7314",
                        x2: "42.402",
                        y2: "33.1132",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.2089",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint10_linear_499_12980",
                        x1: "42.596",
                        y1: "129.08",
                        x2: "141.953",
                        y2: "29.7225",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint11_linear_499_12980",
                        x1: "37.0626",
                        y1: "130.862",
                        x2: "125.647",
                        y2: "42.2776",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DEEBFF)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6383",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #EBF1FA)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #F4F5F7)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint12_linear_499_12980",
                        x1: "94.0388",
                        y1: "28.347",
                        x2: "117.556",
                        y2: "28.347",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-gray-subtle, #6E7C93)",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtle, #6C798F)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint13_linear_499_12980",
                        x1: "50.5705",
                        y1: "26.7136",
                        x2: "49.861",
                        y2: "13.9285",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.2629",
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6568",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7051",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC607)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7745",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFCA1A)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8568",
                                stopColor: "var(--ds-background-accent-yellow-subtler, #FFD239)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9483",
                                stopColor: "var(--ds-background-accent-yellow-subtler, #FFDC64)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint14_linear_499_12980",
                        x1: "45.5246",
                        y1: "24.8807",
                        x2: "54.0025",
                        y2: "13.9733",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.321",
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.766",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint15_linear_499_12980",
                        x1: "101.929",
                        y1: "89.445",
                        x2: "103.151",
                        y2: "76.738",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.2629",
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6568",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7051",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC607)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7745",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFCA1A)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8568",
                                stopColor: "var(--ds-background-accent-yellow-subtler, #FFD239)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9483",
                                stopColor: "var(--ds-background-accent-yellow-subtler, #FFDC64)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint16_linear_499_12980",
                        x1: "96.7524",
                        y1: "86.8327",
                        x2: "105.46",
                        y2: "77.236",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.321",
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.766",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint17_linear_499_12980",
                        x1: "46.7436",
                        y1: "124.678",
                        x2: "85.5786",
                        y2: "85.843",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1228",
                                stopColor: "var(--ds-background-accent-teal-subtle, #2FD3EC)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.286",
                                stopColor: "var(--ds-background-accent-teal-subtle, #67E2F4)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.4263",
                                stopColor: "var(--ds-background-accent-teal-subtler, #90ECFA)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5367",
                                stopColor: "var(--ds-background-accent-teal-subtler, #AAF3FE)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6033",
                                stopColor: "var(--ds-background-accent-teal-subtlest, #B3F5FF)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint18_linear_499_12980",
                        x1: "55.645",
                        y1: "135.098",
                        x2: "94.1816",
                        y2: "96.5612",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1228",
                                stopColor: "var(--ds-background-accent-teal-subtle, #2FD3EC)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.286",
                                stopColor: "var(--ds-background-accent-teal-subtle, #67E2F4)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.4263",
                                stopColor: "var(--ds-background-accent-teal-subtler, #90ECFA)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5367",
                                stopColor: "var(--ds-background-accent-teal-subtler, #AAF3FE)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6033",
                                stopColor: "var(--ds-background-accent-teal-subtlest, #B3F5FF)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint19_linear_499_12980",
                        x1: "82.9016",
                        y1: "129.529",
                        x2: "83.3365",
                        y2: "138.118",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFAB00)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint20_linear_499_12980",
                        x1: "66.7271",
                        y1: "153.359",
                        x2: "112.794",
                        y2: "115.971",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1228",
                                stopColor: "var(--ds-background-accent-teal-subtle, #2FD3EC)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.286",
                                stopColor: "var(--ds-background-accent-teal-subtle, #67E2F4)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.4263",
                                stopColor: "var(--ds-background-accent-teal-subtler, #90ECFA)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5367",
                                stopColor: "var(--ds-background-accent-teal-subtler, #AAF3FE)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6033",
                                stopColor: "var(--ds-background-accent-teal-subtlest, #B3F5FF)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint21_linear_499_12980",
                        x1: "64.8985",
                        y1: "150.541",
                        x2: "110.859",
                        y2: "113.239",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1228",
                                stopColor: "var(--ds-background-accent-teal-subtle, #2FD3EC)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.286",
                                stopColor: "var(--ds-background-accent-teal-subtle, #67E2F4)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.4263",
                                stopColor: "var(--ds-background-accent-teal-subtler, #90ECFA)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5367",
                                stopColor: "var(--ds-background-accent-teal-subtler, #AAF3FE)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6033",
                                stopColor: "var(--ds-background-accent-teal-subtlest, #B3F5FF)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint22_linear_499_12980",
                        x1: "99.6982",
                        y1: "120.33",
                        x2: "103.749",
                        y2: "121.161",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.766",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint23_linear_499_12980",
                        x1: "0.174194",
                        y1: "146.568",
                        x2: "56.0521",
                        y2: "146.568",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-icon, #091E42)",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-icon, #091E42)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint24_linear_499_12980",
                        x1: "58.1309",
                        y1: "158.125",
                        x2: "87.7433",
                        y2: "158.125",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-icon, #091E42)",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-icon, #091E42)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint25_linear_499_12980",
                        x1: "78.6253",
                        y1: "150.658",
                        x2: "68.697",
                        y2: "151.584",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.452",
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint26_linear_499_12980",
                        x1: "79.3893",
                        y1: "142.265",
                        x2: "75.8395",
                        y2: "140.601",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3539",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFB500)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7017",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFAB00)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint27_linear_499_12980",
                        x1: "76.9238",
                        y1: "139.183",
                        x2: "90.7241",
                        y2: "138.741",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFAB00)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7262",
                                stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint28_linear_499_12980",
                        x1: "90.4515",
                        y1: "22.6491",
                        x2: "117.556",
                        y2: "22.6491",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.0346",
                                stopColor: "var(--ds-icon-inverse, white)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3965",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #F7F7F8)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9604",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #E1E3E6)"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("clipPath", {
                        id: "clip0_499_12980",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                            width: "147.652",
                            height: "160",
                            fill: "var(--ds-icon-inverse, white)",
                            transform: "translate(0.174194)"
                        })
                    })
                ]
            })
        ]
    });

});

parcelRegister("bv7KK", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ece46894cb27d47$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $2ece46894cb27d47$var$messages = (0, $7qGN1.defineMessages)({
    buttonLoginToConfluenceNewTab: {
        id: 'embedded.confluence.generic-error-page.login-to-confluence-button',
        description: 'The text inside the login to Confluence button',
        defaultMessage: 'Log in to Confluence'
    },
    paragraphLogin: {
        id: 'embedded.confluence.need-to-log-in-paragraph',
        description: 'The text inside embedded confluence that tell user they need to be logged in to view this page',
        defaultMessage: 'You need to be logged in to view this page'
    },
    paragraphAlreadyLoggedIn: {
        id: 'embedded.confluence.already-logged-in-paragraph',
        description: 'The text inside embedded confluence that asks the user if they have logged in and refresh if so.',
        defaultMessage: 'Already logged in? Try refreshing.'
    },
    paragraphStillHavingTrouble: {
        id: 'embedded.confluence.still-having-trouble-paragraph',
        description: 'The text inside embedded confluence that asks the user if still having trouble and how they can enable third party cookies if so.',
        defaultMessage: 'Still having trouble? Make sure 3rd party cookies are enabled, or {link}'
    },
    linkTroubleshootingText: {
        id: 'embedded.confluence.troubleshooting-link-text',
        description: 'the name of the placeholder {link} used in embedded.confluence.still-having-trouble-paragraph. Please translate these two as a single sentence',
        defaultMessage: 'refer to this troubleshooting guide.'
    },
    linkAriaLabel: {
        id: 'embedded.confluence.troubleshooting-link.aria-label',
        description: 'The aria label for troubleshooting link.',
        defaultMessage: 'troubleshooting guide link'
    },
    loginAriaLabel: {
        id: 'embedded.confluence.login-page.login-button.aria-label',
        description: 'The aria label for login button',
        defaultMessage: 'Login Button'
    },
    loginText: {
        id: 'embedded.confluence.login-page.login-text',
        description: 'Text to display before login button',
        defaultMessage: 'You need to be logged in to view this page'
    },
    loginButton: {
        id: 'embedded.confluence.login-page.login-button',
        description: 'The label for login button',
        defaultMessage: 'Log in to Confluence'
    },
    refreshBanner: {
        id: 'embedded.confluence.login-page.refresh-page-banner',
        description: 'The banner displayed prompting a user to refresh the page',
        defaultMessage: 'After logging in, this page should refresh automatically. If not, you can click here to refresh'
    },
    refreshBannerLink: {
        id: 'embedded.confluence.login-page.refresh-page-banner-refresh-link',
        description: 'A link to refresh the page',
        defaultMessage: 'Refresh page'
    }
});
var $2ece46894cb27d47$export$2e2bcd8739ae039 = $2ece46894cb27d47$var$messages;

});


parcelRegister("lgMhR", function(module, exports) {
$parcel$export(module.exports, "LoginPage", () => $986de4489d083127$export$f14c0e3f98d164c0);
/* LoginPage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $9vwg9 = parcelRequire("9vwg9");
var $8CJjp = parcelRequire("8CJjp");

var $lRq8t = parcelRequire("lRq8t");

var $6Tcuf = parcelRequire("6Tcuf");

var $3JpAh = parcelRequire("3JpAh");

var $7AXbt = parcelRequire("7AXbt");

var $6z405 = parcelRequire("6z405");

var $fWr3F = parcelRequire("fWr3F");

var $9N1gM = parcelRequire("9N1gM");

var $jCaGb = parcelRequire("jCaGb");

var $bv7KK = parcelRequire("bv7KK");

var $a9hHS = parcelRequire("a9hHS");
const $986de4489d083127$var$fadeIn = null;
const $986de4489d083127$var$styles = {
    loginButtonWrapper: "_19pkxy5q",
    parentDiv: "_1e0c1n7u _4cvr1h6o _6a6z1h6o",
    refreshBannerFade: "_ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k _j7hq1wwu _5sagi11n"
};
const $986de4489d083127$var$SUCCESS_URL_SUFFIX = '/wiki/embed/login-confirmation';
const $986de4489d083127$export$f14c0e3f98d164c0 = ({ contentId: contentId, reloadEP: reloadEP, spaceKey: spaceKey, url: url })=>{
    const { locale: locale, formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { cancelIframeLoadMetrics: cancelIframeLoadMetrics } = (0, $a9hHS.usePerformanceMetrics)();
    (0, $eJOHy.useEffect)(()=>{
        cancelIframeLoadMetrics();
    }, [
        cancelIframeLoadMetrics
    ]);
    const loginUrl = (0, $eJOHy.useMemo)(()=>{
        const origin = url ? new URL(url).origin : window?.location?.origin;
        return `${origin}/login?application=confluence&dest-url=${encodeURIComponent(`${$986de4489d083127$var$SUCCESS_URL_SUFFIX}?locale=${locale}`)}`;
    }, [
        url,
        locale
    ]);
    const handleClick = ()=>{
        $986de4489d083127$var$openLoginPopup(loginUrl);
        setDisplayRefreshBanner(!displayRefreshBanner);
    };
    const [displayRefreshBanner, setDisplayRefreshBanner] = (0, $eJOHy.useState)(false);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": "login-page-test-id",
        className: (0, $hcewu.default)([
            $986de4489d083127$var$styles.parentDiv
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6z405.ExperienceStart), {
                name: (0, $9N1gM.ExperienceNames).LOGIN_PAGE,
                id: `${spaceKey}-${contentId}`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8CJjp.default), {
                space: "space.250",
                alignInline: "center",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7AXbt.ConfluenceLogo), {
                        size: "large",
                        appearance: "brand"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fWr3F.LoginToConfluenceIcon), {}),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Tcuf.default), {
                        as: "h2",
                        size: "large",
                        children: formatMessage((0, $bv7KK.default).loginText)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9vwg9.default), {
                xcss: $986de4489d083127$var$styles.loginButtonWrapper,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3JpAh.default), {
                    testId: "login-button",
                    "aria-label": formatMessage((0, $bv7KK.default).loginAriaLabel),
                    appearance: "primary",
                    onClick: handleClick,
                    children: formatMessage((0, $bv7KK.default).loginButton)
                })
            }),
            displayRefreshBanner && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    $986de4489d083127$var$styles.refreshBannerFade
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jCaGb.default), {
                    reloadEP: reloadEP,
                    title: formatMessage((0, $bv7KK.default).refreshBanner),
                    actionLabel: formatMessage((0, $bv7KK.default).refreshBannerLink)
                })
            })
        ]
    });
};
function $986de4489d083127$var$openLoginPopup(loginUrl) {
    const windowFeatures = 'popup=yes,left=100,top=100,width=640,height=640';
    window.open(loginUrl, '_blank', windowFeatures);
}

});
parcelRegister("6z405", function(module, exports) {
$parcel$export(module.exports, "ExperienceStart", () => $2483464491b32571$export$f20b867e738a222c);

var $eJOHy = parcelRequire("eJOHy");

var $geAAj = parcelRequire("geAAj");
function $2483464491b32571$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $eJOHy.useContext)((0, $geAAj.ExperienceTrackerContext));
    const wasCalledRef = (0, $eJOHy.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}

});

parcelRegister("jCaGb", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd653bd054936e56$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bFxsm = parcelRequire("bFxsm");

var $1h5YY = parcelRequire("1h5YY");

const $cd653bd054936e56$var$RefreshBanner = ({ reloadEP: reloadEP, title: title, actionLabel: actionLabel })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $bFxsm.default), {
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1h5YY))), {
            spacing: "spacious",
            color: `var(--ds-icon-information, ${(0, $15543b40efbda8c4$export$e62e8919cca44969)})`,
            label: "Info"
        }),
        id: "refreshBanner",
        title: title,
        actions: [
            {
                content: actionLabel,
                onClick: reloadEP
            }
        ]
    });
var $cd653bd054936e56$export$2e2bcd8739ae039 = $cd653bd054936e56$var$RefreshBanner;

});


parcelRegister("leoH9", function(module, exports) {
$parcel$export(module.exports, "StorageAccessPage", () => $1d7559d591e001ff$export$64a8a56a2c35628c);
/* StorageAccessPage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6z405 = parcelRequire("6z405");

var $9N1gM = parcelRequire("9N1gM");

var $lRq8t = parcelRequire("lRq8t");

var $a9hHS = parcelRequire("a9hHS");
const $1d7559d591e001ff$var$iframeStyles = null;
const $1d7559d591e001ff$export$64a8a56a2c35628c = ({ contentId: contentId, spaceKey: spaceKey, url: url, parentProduct: parentProduct })=>{
    const { locale: locale } = (0, $lRq8t.default)();
    const iframeRef = (0, $eJOHy.useRef)(null);
    const { cancelIframeLoadMetrics: cancelIframeLoadMetrics } = (0, $a9hHS.usePerformanceMetrics)();
    (0, $eJOHy.useEffect)(()=>{
        cancelIframeLoadMetrics();
    }, [
        cancelIframeLoadMetrics
    ]);
    const src = (0, $eJOHy.useMemo)(()=>{
        const path = `/wiki/embed/storage-access?parentProduct=${parentProduct}&locale=${locale}`;
        const origin = url ? new URL(url).origin : window.location.origin;
        return [
            origin,
            path
        ].join('');
    }, [
        locale,
        parentProduct,
        url
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6z405.ExperienceStart), {
                name: (0, $9N1gM.ExperienceNames).STORAGE_ACCESS_PAGE,
                id: `${spaceKey}-${contentId}`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("iframe", {
                "data-testid": "storage-access-page-iframe",
                title: "storage-access-iframe",
                src: src,
                ref: iframeRef,
                className: (0, $hcewu.default)([
                    "_19itglyw _1bsb1osq _4t3i1osq"
                ])
            })
        ]
    });
};

});

parcelRegister("dLxPe", function(module, exports) {
$parcel$export(module.exports, "themeStateObjectToQueryString", () => $47ebc9911e5b2dbf$export$6e43e60d51b79331);
$parcel$export(module.exports, "useUrl", () => $47ebc9911e5b2dbf$export$305222dff575c4e3);

var $eJOHy = parcelRequire("eJOHy");

var $d2tn7 = parcelRequire("d2tn7");

var $jzt0g = parcelRequire("jzt0g");
var $5WPl6 = parcelRequire("5WPl6");

var $6KRcO = parcelRequire("6KRcO");

var $lRq8t = parcelRequire("lRq8t");

var $ikv8E = parcelRequire("ikv8E");
const $47ebc9911e5b2dbf$export$6e43e60d51b79331 = (themeState)=>{
    const themeString = (0, $d2tn7.themeObjectToString)(themeState);
    return encodeURIComponent(themeString);
};
const $47ebc9911e5b2dbf$var$STARGATE_CONFLUENCE_PROXY = '/gateway/api/ex/confluence/';
const $47ebc9911e5b2dbf$var$nonAllFeatures = [
    'modern-header',
    'disable-help-button',
    'disable-title-toolbar'
];
const $47ebc9911e5b2dbf$export$305222dff575c4e3 = ({ allowedFeatures: allowedFeatures, contentId: contentId, contentType: contentType, contentConfiguration: contentConfiguration, draftShareId: draftShareId, hash: hash, hostname: hostname, mode: mode, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, parentProductContentId: parentProductContentId, previewPanels: previewPanels, protocol: protocol, spaceKey: spaceKey, template: template, themeState: themeState, embeddedConfluenceSource: embeddedConfluenceSource })=>{
    const initialAllowedFeaturesRef = (0, $eJOHy.useRef)(undefined);
    // Keep `initialAllowedFeatures` to only contain the initial allowed feature values for cc-frontend SSR rendering
    // Store this value using `useRef` to avoid the iframe url gets updated when `allowedFeatures` React props updated by parent products.
    // If allowedFeatures is equal to 'all' for view mode it must be converted to an array so that 'edit' can be removed.
    const features = (0, $eJOHy.useMemo)(()=>allowedFeatures === 'all' ? (0, $6KRcO.getAllowedFeatures)({
            contentType: contentType,
            mode: mode
        }) : allowedFeatures, [
        allowedFeatures,
        contentType,
        mode
    ]);
    if (!initialAllowedFeaturesRef.current) initialAllowedFeaturesRef.current = Array.isArray(features) ? features.map((feature)=>{
        if (typeof feature !== 'string') return JSON.stringify(feature);
        else return feature;
    })// 'edit' can not be included as an initialAllowedFeature because it requires the navigation policy, which does not work with SSR.
    // 'enable-redirection' should not be included in initial allowed features unless a parent has passed this in as an allowedFeature in the correct format.
    .filter((feature)=>feature !== 'edit' && feature !== 'enable-redirection')// 'modern-header' should not be included in initial allowed features when allowedFeatures is 'all'
    .filter((feature)=>!$47ebc9911e5b2dbf$var$nonAllFeatures.includes(feature)).join('.') : features;
    // check whether re-direction is enabled
    const enableRedirectionFeature = features && features !== 'all' ? features.find((feature)=>(0, $ikv8E.isRedirectionEnabled)(feature)) : undefined;
    const crossSiteTenantId = enableRedirectionFeature ? (0, $ikv8E.getCrossSiteTenantIdFromAllowedFeature)(enableRedirectionFeature) : undefined;
    const { locale: locale } = (0, $lRq8t.default)();
    const queryParams = (0, $eJOHy.useMemo)(()=>{
        const query = {};
        if (parentProduct) query.parentProduct = parentProduct;
        if (parentProductContentContainerId) query.parentProductContentContainerId = parentProductContentContainerId;
        if (parentProductContentId) query.parentProductContentId = parentProductContentId;
        if (initialAllowedFeaturesRef.current !== undefined) query.initialAllowedFeatures = initialAllowedFeaturesRef.current;
        if (template) query.insertTemplateWithKey = template;
        if (themeState) query.themeState = $47ebc9911e5b2dbf$export$6e43e60d51b79331(themeState);
        if (draftShareId) query.draftShareId = draftShareId;
        if (embeddedConfluenceSource) query.embeddedConfluenceSource = embeddedConfluenceSource;
        if (previewPanels) query.previewPanels = previewPanels;
        if (hostname && hostname !== window.location.host) query.isCrossDomain = true;
        query.locale = locale;
        const { isCrossDomain: isCrossDomain, ...restQuery } = query;
        return `?${new URLSearchParams({
            ...isCrossDomain ? {
                isCrossDomain: `${isCrossDomain}`
            } : {},
            ...restQuery,
            ...contentConfiguration?.queryParams
        }).toString()}`;
    }, [
        contentConfiguration,
        draftShareId,
        locale,
        parentProduct,
        parentProductContentContainerId,
        parentProductContentId,
        previewPanels,
        themeState,
        hostname,
        embeddedConfluenceSource,
        template
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            ...$47ebc9911e5b2dbf$var$constructUrl(mode, {
                contentId: contentId,
                contentType: contentType,
                hash: hash,
                hostname: hostname,
                protocol: protocol,
                spaceKey: spaceKey,
                queryParams: queryParams,
                crossSiteTenantId: crossSiteTenantId
            })
        }), [
        contentId,
        contentType,
        hash,
        hostname,
        mode,
        protocol,
        spaceKey,
        queryParams,
        crossSiteTenantId
    ]);
};
const $47ebc9911e5b2dbf$var$CONTEXT_PATH = '/wiki/spaces';
const $47ebc9911e5b2dbf$var$invalidUrls = {
    standaloneConfluenceUrl: null,
    embeddedConfluenceUrl: null
};
function $47ebc9911e5b2dbf$var$constructUrl(mode = (0, $5WPl6.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE, { contentId: contentId, contentType: contentType, hash: hash = '', hostname: hostname, protocol: protocol, spaceKey: spaceKey, queryParams: queryParams, crossSiteTenantId: crossSiteTenantId }) {
    if (contentType !== (0, $jzt0g.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE && !contentId) {
        /* eslint-disable-next-line no-console */ console.error('Content ID is undefined');
        return $47ebc9911e5b2dbf$var$invalidUrls;
    }
    if (!spaceKey) {
        /* eslint-disable-next-line no-console */ console.error('Space key is undefined');
        return $47ebc9911e5b2dbf$var$invalidUrls;
    }
    if (/^\d+$/.test(spaceKey)) /* eslint-disable-next-line no-console */ console.warn('A numeric "spaceKey" is passed into the Embedded Confluence component. Verify that it is the correct "spaceKey" and not the "spaceId." Disregard this warning if it is correct.');
    const prefix = `${protocol || window.location.protocol}//${hostname || window.location.host}${$47ebc9911e5b2dbf$var$CONTEXT_PATH}`;
    const prefixWithStargate = crossSiteTenantId ? `${protocol || window.location.protocol}//${window.location.host //take the parent site because want don't want it to be cross-site EP
    }${$47ebc9911e5b2dbf$var$STARGATE_CONFLUENCE_PROXY}${crossSiteTenantId}${$47ebc9911e5b2dbf$var$CONTEXT_PATH}` : undefined;
    let base;
    const pageUrl = {
        [(0, $5WPl6.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: contentId ? `${spaceKey}/pages/${contentId}` : `${spaceKey}/overview`,
        [(0, $5WPl6.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const blogpostUrl = {
        [(0, $5WPl6.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/pages/${contentId}`,
        [(0, $5WPl6.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const whiteboardUrl = {
        [(0, $5WPl6.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/whiteboard/${contentId}`,
        [(0, $5WPl6.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/whiteboard/${contentId}`
    };
    const contentTypeUrl = {
        [(0, $jzt0g.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: pageUrl,
        [(0, $jzt0g.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: blogpostUrl,
        [(0, $jzt0g.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: whiteboardUrl
    };
    base = contentTypeUrl[contentType]?.[mode];
    if (!base) {
        /* eslint-disable-next-line no-console */ console.error('URL is not yet supported');
        return $47ebc9911e5b2dbf$var$invalidUrls;
    }
    const standaloneConfluenceUrl = `${prefix}/${base}${hash}`;
    const embeddedConfluenceUrl = `${prefixWithStargate ?? prefix}/${base}${queryParams}${hash}`;
    return {
        standaloneConfluenceUrl: standaloneConfluenceUrl,
        embeddedConfluenceUrl: embeddedConfluenceUrl
    };
}

});
parcelRegister("ikv8E", function(module, exports) {
$parcel$export(module.exports, "isRedirectionEnabled", () => $e4da5b1ba7c7a4d7$export$51abd16148027412);
$parcel$export(module.exports, "getCrossSiteTenantIdFromAllowedFeature", () => $e4da5b1ba7c7a4d7$export$243fbba563b8aa8e);
const $e4da5b1ba7c7a4d7$export$51abd16148027412 = (feature)=>{
    if (typeof feature === 'object') return 'enable-redirection' in feature;
    if (typeof feature === 'string') try {
        const parsedFeature = JSON.parse(feature);
        return parsedFeature && typeof parsedFeature === 'object' && 'enable-redirection' in parsedFeature;
    } catch (error) {
        return false;
    }
    return false;
};
const $e4da5b1ba7c7a4d7$export$243fbba563b8aa8e = (feature)=>{
    if (!feature) return undefined;
    if (typeof feature === 'string') try {
        const parsed = JSON.parse(feature);
        return parsed['enable-redirection']?.['cross-site-tenant-id'];
    } catch (error) {
        return undefined;
    }
    return feature['enable-redirection']?.['cross-site-tenant-id'];
};

});


parcelRegister("jn71q", function(module, exports) {
$parcel$export(module.exports, "Subjects", () => $03b4e4b3c6b1d7cb$export$29953e2fb702813a);
$parcel$export(module.exports, "LoadingStatus", () => $03b4e4b3c6b1d7cb$export$19d37de7e9a4af59);
$parcel$export(module.exports, "useValidationState", () => $03b4e4b3c6b1d7cb$export$1faa35b5a06780c0);

var $eJOHy = parcelRequire("eJOHy");

var $geAAj = parcelRequire("geAAj");

var $9N1gM = parcelRequire("9N1gM");
var $03b4e4b3c6b1d7cb$export$29953e2fb702813a = /*#__PURE__*/ function(Subjects) {
    Subjects["STORAGE_ACCESS"] = "storage-access";
    Subjects["LOGIN_CONFIRMATION"] = "login-confirmation";
    Subjects["CONTENT_LOAD"] = "content-load";
    return Subjects;
}({});
var $03b4e4b3c6b1d7cb$export$19d37de7e9a4af59 = /*#__PURE__*/ function(LoadingStatus) {
    LoadingStatus["IFRAME_LOADED"] = "iframe-loaded";
    LoadingStatus["IFRAME_UNLOADED"] = "iframe-unloaded";
    LoadingStatus["CONTENT_LOAD_STARTED"] = "content-load-started";
    LoadingStatus["REDIRECTED_TO_LOGIN"] = "redirected-to-login";
    LoadingStatus["RELOAD_EP"] = "reload-ep";
    return LoadingStatus;
}({});
var $03b4e4b3c6b1d7cb$export$12bf62de6f1fdb01 = /*#__PURE__*/ function(StorageAccessStatus) {
    StorageAccessStatus["GRANTED"] = "granted";
    StorageAccessStatus["REJECTED"] = "rejected";
    StorageAccessStatus["NOT_SUPPORTED"] = "not-supported";
    StorageAccessStatus["ERROR"] = "error";
    return StorageAccessStatus;
}({});
var $03b4e4b3c6b1d7cb$export$889a6bd688f4360e = /*#__PURE__*/ function(UserLoginStatus) {
    UserLoginStatus["SUCCESS"] = "success";
    return UserLoginStatus;
}({});
/* NOTE: (Refer this table for understanding the behavior
  on different browsers: https://hello.atlassian.net/wiki/spaces/~288141084/pages/2154391293/Conditions+to+load+EP)
*/ function $03b4e4b3c6b1d7cb$var$pageLoadValidationReducer(state, action) {
    //NOTE: We assume that storage access and user login is required at the load of the PageLoadValidation component
    switch(action.subject){
        case "storage-access":
            switch(action.status){
                case "granted":
                    /*If storage access is granted, refresh app, if user is logged in, try to load EP. If not, load Login CTA
					 */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskStorageAccess: false
                    };
                case "rejected":
                    /*If storage access is reject, it could mean either of the two things:
          1. (For Safari): User has storage access but may not be logged in, Try loggin user in
          2. (For Firefox, Edge): User may be logged in but storage access is not yet granted by the browser
          In both these case, ask user to login.
          */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskStorageAccess: false,
                        shouldAskToLogin: true
                    };
                case "not-supported":
                    /* This case is specific for Chrome where storage access is not supported. 
          So we can skip asking for storage access and direct user to the Login CTA. 
          */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskToLogin: true,
                        shouldAskStorageAccess: false
                    };
                case "error":
                    /** To catch any other errors while requesting storage access */ return {
                        ...state
                    };
            }
            break;
        case "login-confirmation":
            switch(action.status){
                case "success":
                    /*
          If user has logged in, it means that storage access is granted. Refresh app, Try loading EP
          */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskToLogin: false,
                        iframeUnloaded: false,
                        redirectedToLogin: false
                    };
            }
            break;
        case "content-load":
            //These states are set only when the user has navigated throught the storage access and login flows. So try to load EP
            switch(action.status){
                case "iframe-loaded":
                    return {
                        ...state,
                        iframeLoaded: true
                    };
                case "content-load-started":
                    return {
                        ...state,
                        contentLoadStarted: true
                    };
                case "iframe-unloaded":
                    return {
                        ...state,
                        iframeUnloaded: true
                    };
                case "redirected-to-login":
                    return {
                        ...state,
                        redirectedToLogin: true
                    };
                case "reload-ep":
                    return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false
                    };
            }
            break;
    }
}
const $03b4e4b3c6b1d7cb$export$1faa35b5a06780c0 = ()=>{
    const initialState = {
        iframeLoaded: false,
        contentLoadStarted: false,
        shouldAskStorageAccess: true,
        shouldAskToLogin: true,
        redirectedToLogin: false,
        iframeUnloaded: false
    };
    const [state, dispatch] = (0, $eJOHy.useReducer)($03b4e4b3c6b1d7cb$var$pageLoadValidationReducer, initialState);
    const experienceTracker = (0, $eJOHy.useContext)((0, $geAAj.ExperienceTrackerContext));
    const messageListener = (0, $eJOHy.useCallback)((messageEvent)=>{
        const { subject: subject, result: result } = messageEvent.data ?? {};
        if (!subject || !result) return;
        switch(subject){
            case "storage-access":
                switch(result){
                    case "granted":
                        experienceTracker.succeed({
                            name: (0, $9N1gM.ExperienceNames).STORAGE_ACCESS_PAGE
                        });
                        dispatch({
                            subject: "storage-access",
                            status: "granted"
                        });
                        break;
                    case "rejected":
                        experienceTracker.abort({
                            name: (0, $9N1gM.ExperienceNames).STORAGE_ACCESS_PAGE,
                            reason: (0, $9N1gM.ExperienceReasons).STORAGE_ACCESS_REJECTED
                        });
                        dispatch({
                            subject: "storage-access",
                            status: "rejected"
                        });
                        break;
                    case "not-supported":
                        experienceTracker.abort({
                            name: (0, $9N1gM.ExperienceNames).STORAGE_ACCESS_PAGE,
                            reason: (0, $9N1gM.ExperienceReasons).STORAGE_ACCESS_NOT_SUPPORTED
                        });
                        dispatch({
                            subject: "storage-access",
                            status: "not-supported"
                        });
                        break;
                    case "error":
                        experienceTracker.fail({
                            name: (0, $9N1gM.ExperienceNames).STORAGE_ACCESS_PAGE,
                            error: new Error((0, $9N1gM.ExperienceReasons).STORAGE_ACCESS_ERROR)
                        });
                        dispatch({
                            subject: "storage-access",
                            status: "error"
                        });
                        break;
                }
                break;
            case "login-confirmation":
                switch(result){
                    case "success":
                        experienceTracker.succeed({
                            name: (0, $9N1gM.ExperienceNames).LOGIN_PAGE
                        });
                        dispatch({
                            subject: "login-confirmation",
                            status: "success"
                        });
                        break;
                }
                break;
        }
    }, [
        experienceTracker
    ]);
    (0, $eJOHy.useEffect)(()=>{
        window.addEventListener('message', messageListener);
        return ()=>window.removeEventListener('message', messageListener);
    }, [
        messageListener
    ]);
    return {
        state: state,
        dispatch: dispatch
    };
};

});


parcelRegister("kTRk0", function(module, exports) {
$parcel$export(module.exports, "useFooter", () => $a74b462104d18662$export$d07da6ac6fc160b0);

var $eJOHy = parcelRequire("eJOHy");

var $9N1gM = parcelRequire("9N1gM");

var $81XbN = parcelRequire("81XbN");
const $a74b462104d18662$export$d07da6ac6fc160b0 = ({ experienceTracker: experienceTracker, hasFooter: hasFooter, shouldShowFooter: shouldShowFooter, parentProduct: parentProduct, standaloneConfluenceUrl: standaloneConfluenceUrl })=>{
    const [footerUrl, setFooterUrl] = (0, $eJOHy.useState)(standaloneConfluenceUrl);
    (0, $eJOHy.useEffect)(()=>{
        setFooterUrl(standaloneConfluenceUrl);
    }, [
        standaloneConfluenceUrl
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const unsubscribe = experienceTracker.subscribe((event)=>{
            const { name: name, action: action } = event;
            if (name === (0, $9N1gM.ExperienceNames).PAGE_NOT_FOUND && action === 'taskStart') setFooterUrl(standaloneConfluenceUrl ? `${new URL(standaloneConfluenceUrl).origin}/wiki/home` : standaloneConfluenceUrl);
        });
        return ()=>unsubscribe();
    }, [
        experienceTracker,
        standaloneConfluenceUrl
    ]);
    /**
	 * Currently footer is hidden for the JSM Portal view which passes
	 * shouldShowFooter (externally, showFooterLogo) prop as false and shown for all other views
	 *
	 * JSM portal view will provide "JSM-Portal" as the parent product eventually
	 * However, team is still testing this product type for Atlassian and anonymous users so the "JSM-Portal" parentProduct is being feature-flagged
	 * We need to support these two parent product keys to keep backward compatible for the time being.
	 *
	 * Clean-up task in backlog: https://hello.atlassian.net/browse/CBT-1278 to remove "JSM" from the logic
	 *
	 * EDIT 7/17: showFooterLogo has been renamed internally for clarity and is now aliased as shouldShowFooter when used internally.
	 * External API remains unchanged.
	 */ const showFooter = (0, $eJOHy.useMemo)(()=>{
        const parentProducts = [
            (0, $81XbN.EMBEDDED_PARENT_PRODUCTS).JSM_PORTAL,
            (0, $81XbN.EMBEDDED_PARENT_PRODUCTS).JSM,
            (0, $81XbN.EMBEDDED_PARENT_PRODUCTS).JSW,
            (0, $81XbN.EMBEDDED_PARENT_PRODUCTS).JWM
        ];
        return !!hasFooter && !(parentProducts.includes(parentProduct) && !shouldShowFooter);
    }, [
        parentProduct,
        shouldShowFooter,
        hasFooter
    ]);
    return {
        showFooter: showFooter,
        footerUrl: footerUrl
    };
};

});

parcelRegister("86oLZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $43cc0083d2400f65$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $43cc0083d2400f65$var$messages = (0, $7qGN1.defineMessages)({
    viewInConfluence: {
        id: 'embedded.confluence.footer.hover.text',
        description: 'Hover text on Confluence Footer Content',
        defaultMessage: 'View in Confluence'
    },
    poweredBy: {
        id: 'embedded.confluence.footer.prefix',
        description: 'Prefix label on Confluence Logo',
        defaultMessage: 'Powered by'
    }
});
var $43cc0083d2400f65$export$2e2bcd8739ae039 = $43cc0083d2400f65$var$messages;

});


parcelRegister("h4N1w", function(module, exports) {
$parcel$export(module.exports, "useGetCurrentScrollPosition", () => $11610ffe5a1df4df$export$4d8f561c32665bbe);

var $eJOHy = parcelRequire("eJOHy");

var $ihJU2 = parcelRequire("ihJU2");
// Add debounce to the scroll handler to ensure that it is executed only once after X ms of delay
const $11610ffe5a1df4df$var$handleScrollDeboubced = (scrollHandler, delay)=>{
    let timeoutId;
    return (...args)=>{
        if (timeoutId) clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
            scrollHandler(...args);
        }, delay);
    };
};
const $11610ffe5a1df4df$export$4d8f561c32665bbe = (isHeightSetFromContent)=>{
    const [scrollPosition, setScrollPosition] = (0, $eJOHy.useState)(0);
    const defaultScrollPosition = (0, $eJOHy.useRef)(0); // mutable ref to 0 - return this value when the media is open
    const prevScrollPosition = (0, $eJOHy.useRef)(0);
    const { isMediaOpen: isMediaOpen } = (0, $ihJU2.useMediaViewerListener)();
    (0, $eJOHy.useEffect)(()=>{
        const handleScroll = $11610ffe5a1df4df$var$handleScrollDeboubced(()=>{
            if (!isMediaOpen) {
                /*
					Saving the previous scroll position is essential because, by the time we receive the state of the media viewer,
					it may already have been opened or closed, and we do not have control over the actions that occur
					just before the media viewer is activated (which happens in a different package that we do not manage).
					Consequently, it is possible for the variable isMediaOpen to be false even when the media viewer is indeed open.
					This situation results in saving of an incorrect value for the scroll position when the media viewer is already active,
					which is misleading since the container height will have been reduced at this point.
					To mitigate this inaccuracy, we continuously track the scroll position when the media viewer is not open.
					When the media is subsequently clicked to open, retrieving the previous scroll position helps to offset the
					inaccuracies associated with saving the scroll position under the conditions of a condensed height.
				*/ prevScrollPosition.current = scrollPosition;
                setScrollPosition(window.scrollY);
            }
        }, 100); // Call the handler only once scroll event has stopped firing for a delay of 100ms.
        window.addEventListener('scroll', handleScroll);
        return ()=>{
            window.removeEventListener('scroll', handleScroll);
        };
    }, [
        isMediaOpen,
        scrollPosition
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isHeightSetFromContent) // Restore the scroll position back to the value saved before any media file was open
        window.scrollTo(0, isMediaOpen ? defaultScrollPosition.current : prevScrollPosition.current);
    }, [
        isHeightSetFromContent,
        isMediaOpen
    ]);
};

});





parcelRegister("kciqD", function(module, exports) {
$parcel$export(module.exports, "EditPage", () => $7a98277094a8d6a8$export$1fea75498367c4ac);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1gG7v = parcelRequire("1gG7v");

var $99glD = parcelRequire("99glD");

var $aGsKv = parcelRequire("aGsKv");
const $7a98277094a8d6a8$export$1fea75498367c4ac = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $1gG7v.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $99glD.default),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aGsKv.EditPage), {
            ...props
        })
    });

});
parcelRegister("aGsKv", function(module, exports) {
$parcel$export(module.exports, "EditPage", () => $eda7f30722f58c8e$export$1fea75498367c4ac);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fiD4y = parcelRequire("fiD4y");

var $lRq8t = parcelRequire("lRq8t");
const $eda7f30722f58c8e$export$1fea75498367c4ac = (props)=>{
    const { locale: locale } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fiD4y.EditPage), {
        locale: locale,
        ...props
    });
};

});
parcelRegister("fiD4y", function(module, exports) {
$parcel$export(module.exports, "EditPage", () => $b12bbe73f7bfba49$export$1fea75498367c4ac);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $hbwAb = parcelRequire("hbwAb");

var $7kpAG = parcelRequire("7kpAG");

var $1gG7v = parcelRequire("1gG7v");

var $9Mevf = parcelRequire("9Mevf");

var $a9hHS = parcelRequire("a9hHS");
const $b12bbe73f7bfba49$export$1fea75498367c4ac = (props)=>{
    const { markIframeLoadMetrics: markIframeLoadMetrics } = (0, $a9hHS.usePerformanceMetrics)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        markIframeLoadMetrics('lazy-load-end');
        markIframeLoadMetrics('common-load-start');
    }, [
        markIframeLoadMetrics
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1gG7v.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $9Mevf.default),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
            fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7kpAG.PageNotFoundEmptyState), {}),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hbwAb.EditPage), {
                ...props
            })
        })
    });
};

});
parcelRegister("hbwAb", function(module, exports) {
$parcel$export(module.exports, "EditPage", () => $24b93d351bc826c7$export$1fea75498367c4ac);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $9N1gM = parcelRequire("9N1gM");

var $jzt0g = parcelRequire("jzt0g");
var $5WPl6 = parcelRequire("5WPl6");

var $dtPPP = parcelRequire("dtPPP");
const $24b93d351bc826c7$var$IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED = 'auto_closed';
const $24b93d351bc826c7$export$1fea75498367c4ac = (props)=>{
    const { allowedFeatures: allowedFeatures } = props;
    const contentConfiguration = (0, $eJOHy.useMemo)(()=>{
        const isTemplateBrowserEnabled = allowedFeatures === 'all' || allowedFeatures?.find((feature)=>feature === 'template-browser' || feature.hasOwnProperty('template-browser')) !== undefined;
        const queryParams = isTemplateBrowserEnabled ? {
            inEditorTemplatesPanel: $24b93d351bc826c7$var$IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED
        } : undefined;
        return {
            experiences: {
                experience: (0, $9N1gM.ExperienceNames).EDIT_PAGE,
                ccExperience: (0, $9N1gM.ExperienceNames).CC_EDIT_PAGE_EMBED
            },
            queryParams: queryParams
        };
    }, [
        allowedFeatures
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dtPPP.Content), {
        ...props,
        contentType: (0, $jzt0g.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE,
        mode: (0, $5WPl6.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE,
        contentConfiguration: contentConfiguration
    });
};

});






parcelRegister("bCZso", function(module, exports) {
$parcel$export(module.exports, "useConfluencePageData", () => $ec8f48be5aef3a51$export$10fb2803bc7b79fc);

var $eJOHy = parcelRequire("eJOHy");

var $kePQU = parcelRequire("kePQU");

var $c7Uyr = parcelRequire("c7Uyr");
var $d2tn7 = parcelRequire("d2tn7");
var $ec8f48be5aef3a51$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $ec8f48be5aef3a51$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
var $ec8f48be5aef3a51$export$dc091dbfc779121b = /*#__PURE__*/ function(CONFLUENCE_EXTENSION_KEYS) {
    CONFLUENCE_EXTENSION_KEYS["PAGE"] = "integration-confluence-object-provider";
    CONFLUENCE_EXTENSION_KEYS["CANVAS"] = "canvas-native-object-provider";
    return CONFLUENCE_EXTENSION_KEYS;
}({});
const $ec8f48be5aef3a51$export$10fb2803bc7b79fc = (url, extensionKey)=>{
    const parsedData = (0, $eJOHy.useMemo)(()=>{
        if (!(0, $kePQU.fg)('platform_deprecate_lp_cc_embed')) return undefined;
        if (!url || typeof url !== 'string' || !url.startsWith('http://') && !url.startsWith('https://') || !extensionKey || !Object.values($ec8f48be5aef3a51$export$dc091dbfc779121b).find((key)=>key === extensionKey)) return undefined;
        let urlObj;
        try {
            urlObj = new URL(url);
        } catch  {
            return undefined;
        }
        const { searchParams: searchParams, hash: hash } = urlObj;
        const hostname = searchParams?.get('hostname') || '';
        const contentId = searchParams?.get('contentId') || '';
        const spaceKey = searchParams?.get('spaceKey') || '';
        // Early return for invalid URLs
        if (!contentId || !hostname) return undefined;
        const themeState = searchParams?.get('themeState') || '';
        const themeMode = searchParams?.get('themeMode');
        const enableInlineComments = searchParams?.get('enableInlineComments') === 'true';
        const enablePageComments = searchParams?.get('enablePageComments') === 'true';
        const userId = searchParams?.get('userId') || '';
        const userIdType = searchParams?.get('userInfo') || undefined;
        const parentProduct = searchParams?.get('parentProduct') || '';
        const inlineComments = enableInlineComments ? [
            'inline-comments'
        ] : [];
        const pageComments = enablePageComments ? [
            'page-comments'
        ] : [];
        // Calculate theme state object here
        let calculatedThemeStateObject;
        if (themeState) calculatedThemeStateObject = (0, $d2tn7.themeStringToObject)(decodeURIComponent(themeState));
        else if (themeMode) calculatedThemeStateObject = {
            colorMode: themeMode
        };
        return {
            hostname: hostname,
            spaceKey: spaceKey,
            contentId: contentId,
            parentProduct: parentProduct,
            userId: userId,
            userIdType: userIdType,
            hash: hash || '',
            enableInlineComments: enableInlineComments,
            enablePageComments: enablePageComments,
            themeStateObject: calculatedThemeStateObject,
            allowedFeatures: {
                edit: [
                    'delete-draft'
                ],
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-reactions',
                    ...pageComments,
                    ...inlineComments
                ]
            },
            mode: "view",
            locale: 'en'
        };
    }, [
        url,
        extensionKey
    ]);
    // Handle theme side effect - only when theme object changes
    (0, $eJOHy.useEffect)(()=>{
        if (parsedData?.themeStateObject) (0, $c7Uyr.default)(parsedData.themeStateObject);
    }, [
        parsedData?.themeStateObject
    ]);
    return parsedData;
};

});


parcelRegister("2oVoc", function(module, exports) {
$parcel$export(module.exports, "IframeDwellTracker", () => $faaf6ef7929ce8f3$export$e3cb965901aecabd);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");
/**
 * A kind of cheap logarithmic backoff. Fire analytics after the user has
 * dwelled for 5 seconds, then 10 seconds, and so on.
 */ const $faaf6ef7929ce8f3$var$INTERVALS_TO_LOG = [
    5,
    10,
    15,
    20,
    25,
    30,
    45,
    60,
    90,
    120,
    180
];
const $faaf6ef7929ce8f3$export$e3cb965901aecabd = ({ isIframeLoaded: isIframeLoaded, isMouseOver: isMouseOver, isWindowFocused: isWindowFocused, iframePercentVisible: iframePercentVisible, onIframeDwell: onIframeDwell })=>{
    const [dwell, setDwell] = (0, $eJOHy.useState)({
        time: 0,
        percentVisible: 0
    });
    const dwellTimeoutId = (0, $eJOHy.useRef)();
    // fire analytics when the dwell timer reaches 5 seconds
    (0, $eJOHy.useEffect)(()=>{
        if (dwell.time > 0 && $faaf6ef7929ce8f3$var$INTERVALS_TO_LOG.includes(dwell.time)) onIframeDwell && onIframeDwell(dwell.time, dwell.percentVisible);
    }, [
        dwell,
        onIframeDwell
    ]);
    // start and stop tracking dwell time
    (0, $eJOHy.useEffect)(()=>{
        const incrementDwellTime = ()=>{
            // callback is called on dwell state changes, so change percentVisible and time together
            setDwell(({ time: time })=>{
                return {
                    time: time + 1,
                    // snapshot of percent visible, rounded down to nearest 5%
                    percentVisible: Math.floor((iframePercentVisible || 0) * 20) * 5
                };
            });
        };
        if (isIframeLoaded && isMouseOver && isWindowFocused && iframePercentVisible > 0.75) {
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
            dwellTimeoutId.current = setInterval(incrementDwellTime, 1000);
        }
        return ()=>{
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
        };
    }, [
        setDwell,
        isMouseOver,
        isWindowFocused,
        isIframeLoaded,
        iframePercentVisible
    ]);
    return null;
};

});


parcelRegister("8MTiL", function(module, exports) {
$parcel$export(module.exports, "useEmbedResolvePostMessageListener", () => $026a8327cc47b4a0$export$50ac35a9a8f2ebaa);

var $eJOHy = parcelRequire("eJOHy");

var $7rZ1M = parcelRequire("7rZ1M");
const $026a8327cc47b4a0$export$50ac35a9a8f2ebaa = ({ url: url, embedIframeRef: embedIframeRef })=>{
    const resolve = (0, $7rZ1M.default)();
    (0, $eJOHy.useEffect)(()=>{
        const messageCallback = (event)=>{
            if (typeof embedIframeRef === 'function') return;
            const isFromExpectedIframe = embedIframeRef && event.source === embedIframeRef.current?.contentWindow;
            if (event.data === 'force-resolve-smart-link' && isFromExpectedIframe) resolve(url, true);
        };
        window.addEventListener('message', messageCallback);
        return ()=>{
            window.removeEventListener('message', messageCallback);
        };
    }, [
        resolve,
        url,
        embedIframeRef
    ]);
};

});


parcelRegister("iJ40f", function(module, exports) {
$parcel$export(module.exports, "default", () => $f524873cb26d1d6c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $3JpAh = parcelRequire("3JpAh");

var $5RpiZ = parcelRequire("5RpiZ");

var $cafmZ = parcelRequire("cafmZ");

var $kPwer = parcelRequire("kPwer");

var $hdYNe = parcelRequire("hdYNe");

var $cZTD2 = parcelRequire("cZTD2");
const $f524873cb26d1d6c$var$UnauthorizedView = ({ context: context, extensionKey: extensionKey, isProductIntegrationSupported: isProductIntegrationSupported, onAuthorize: onAuthorize, testId: testId = 'embed-card-unauthorized-view', ...unresolvedViewProps })=>{
    const { fireEvent: fireEvent } = (0, $5RpiZ.useAnalyticsEvents)();
    const handleOnAuthorizeClick = (0, $eJOHy.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const content = (0, $eJOHy.useMemo)(()=>{
        if (onAuthorize) {
            // Our title and button messages always expect the product name to be present
            // while the description support when product name is not present.
            // To be looked at https://product-fabric.atlassian.net/browse/EDM-8173
            const values = {
                context: context?.text ?? ''
            };
            if (values) // title: Connect your {context} account
            // button: Connect to {context}
            return {
                title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $cafmZ.messages).connect_link_account_card_name,
                    values: values
                }),
                description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kPwer.default), {
                    providerName: context?.text,
                    isProductIntegrationSupported: isProductIntegrationSupported,
                    testId: testId
                }),
                button: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3JpAh.default), {
                    testId: "connect-account",
                    appearance: "primary",
                    onClick: handleOnAuthorizeClick,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $cafmZ.messages).connect_unauthorised_account_action,
                        values: values
                    })
                })
            };
        }
        const values = context?.text ? {
            context: context?.text
        } : undefined;
        if (values) // title: We can't display private pages from {context}
        // description: You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $cafmZ.messages).unauthorised_account_name,
                values: values
            }),
            description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $cafmZ.messages).unauthorised_account_description,
                values: values
            })
        };
        // title: We can't display private pages
        // description: You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $cafmZ.messages).unauthorised_account_name_no_provider
            }),
            description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $cafmZ.messages).unauthorised_account_description_no_provider
            })
        };
    }, [
        context?.text,
        handleOnAuthorizeClick,
        isProductIntegrationSupported,
        onAuthorize,
        testId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hdYNe.default), {
        ...unresolvedViewProps,
        ...content,
        icon: context?.icon,
        image: context?.image ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cZTD2.UnauthorizedSVG), {}),
        testId: testId,
        text: context?.text
    });
};
var $f524873cb26d1d6c$export$2e2bcd8739ae039 = $f524873cb26d1d6c$var$UnauthorizedView;

});
parcelRegister("cZTD2", function(module, exports) {
$parcel$export(module.exports, "UnauthorizedSVG", () => $62dfe11455ad24e9$export$6526edaac83a8c90);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $62dfe11455ad24e9$export$6526edaac83a8c90 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        viewBox: "0 0 565 267",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "unauthorized-svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                clipPath: "url(#clip0_1375_267)",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                        width: "563.88",
                        height: "265.81",
                        transform: "translate(0.870117 0.509766)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M150.05 257.529H143.87L144.52 254.379H150.7L150.05 257.529Z",
                        fill: "#DFE1E5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M181.06 257.531C183.03 257.531 185 257.531 186.97 257.531C186.92 256.481 186.88 255.431 186.83 254.381C185.02 253.691 182.85 253.301 181.08 254.271C181.02 254.301 180.96 254.341 180.9 254.381C180.95 255.431 181.01 256.481 181.06 257.531Z",
                        fill: "#DFE1E5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M141.99 98.8398C110.62 98.8398 85.1801 124.27 85.1801 155.65V206.74C85.1801 238.11 59.7501 263.55 28.3701 263.55H0.870117",
                        stroke: "url(#paint0_linear_1375_267)",
                        strokeWidth: "4.4681",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M420.16 124.399L418.27 121.929L417.53 116.109L417.4 112.789H419.42L421.66 115.439C422.18 116.059 422.62 116.749 422.94 117.499C423.39 118.539 423.63 119.669 423.63 120.809V123.189L420.16 124.399Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M160.63 111.87L159.06 105.6C159.06 105.21 159.37 104.88 159.76 104.86C160.06 105.13 160.4 105.37 160.63 105.26C160.82 105.17 160.76 104.91 160.97 104.78C161.34 104.55 162.03 105.03 162.24 105.18C162.54 105.39 162.74 105.61 162.86 105.76L163.81 106.1C164.14 106.22 164.39 106.5 164.48 106.85L165.67 107.74C166.21 107.82 166.43 110 166.45 110.07L166.04 112.86C166.07 112.97 166.07 113.09 166.05 113.21C165.96 113.65 165.5 113.91 165.07 113.75L161.09 112.32C160.87 112.25 160.7 112.08 160.63 111.87Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M165.73 116.919C166.92 116.499 169.78 120.329 166.77 112.969C166.59 112.519 166.22 110.519 164.39 109.389C162.47 108.209 160.92 109.649 159.28 108.319C158.39 107.599 158.37 106.789 157.23 106.319C156.44 105.989 155.38 105.939 155.19 106.319C154.97 106.749 156.03 107.399 157.51 109.269C158.97 111.119 158.65 111.409 159.96 112.799C160.5 113.369 160.89 113.669 162.06 114.909C162.67 115.559 162.72 115.629 162.97 115.829C163.52 116.269 164.77 117.259 165.73 116.919Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M164.84 175.06C162.1 173.45 162.32 169.37 162.74 163.63C163.81 148.91 166.33 143.51 166.66 135.95C166.88 130.9 166.17 123.59 161.64 114.5C163.73 114.28 165.81 114.06 167.9 113.83C171.82 123.37 173.58 131.57 174.46 137.43C175.59 144.99 175.69 151.82 175.7 154.41C175.73 165.07 174.28 169.57 175.37 173.41C175.42 173.6 175.65 174.22 175.34 174.79C174.3 176.7 167.91 176.86 164.84 175.06Z",
                        fill: "#403294"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.25",
                        d: "M2.76012 266.319H206.4C207.44 266.319 208.29 265.469 208.29 264.429C208.29 263.389 207.44 262.539 206.4 262.539H2.76012C1.72012 262.539 0.870117 263.389 0.870117 264.429C0.870117 265.469 1.72012 266.319 2.76012 266.319Z",
                        fill: "url(#paint1_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.25",
                        d: "M562.86 266.319H359.22C358.18 266.319 357.33 265.469 357.33 264.429C357.33 263.389 358.18 262.539 359.22 262.539H562.86C563.9 262.539 564.75 263.389 564.75 264.429C564.75 265.469 563.9 266.319 562.86 266.319Z",
                        fill: "url(#paint2_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M423.62 98.8398C454.99 98.8398 480.43 124.27 480.43 155.65V206.74C480.43 238.11 505.86 263.55 537.24 263.55H564.75",
                        stroke: "url(#paint3_linear_1375_267)",
                        strokeWidth: "4.4681",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M133.69 107.8C131.9 107.8 130.45 106.35 130.45 104.56V93.1502C130.45 91.3602 131.9 89.9102 133.69 89.9102C135.48 89.9102 136.93 91.3602 136.93 93.1502V104.57C136.92 106.35 135.48 107.8 133.69 107.8Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M140.16 107.8C138.37 107.8 136.92 106.35 136.92 104.56V93.1502C136.92 91.3602 138.37 89.9102 140.16 89.9102C141.95 89.9102 143.4 91.3602 143.4 93.1502V104.57C143.4 106.35 141.95 107.8 140.16 107.8Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M425.01 107.8C423.22 107.8 421.77 106.35 421.77 104.56V93.1502C421.77 91.3602 423.22 89.9102 425.01 89.9102C426.8 89.9102 428.25 91.3602 428.25 93.1502V104.57C428.25 106.35 426.8 107.8 425.01 107.8Z",
                        fill: "#0052CC"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M431.48 107.8C429.69 107.8 428.24 106.35 428.24 104.56V93.1502C428.24 91.3602 429.69 89.9102 431.48 89.9102C433.27 89.9102 434.72 91.3602 434.72 93.1502V104.57C434.72 106.35 433.27 107.8 431.48 107.8Z",
                        fill: "#0052CC"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.38",
                        d: "M285 195.54C338.307 195.54 381.52 152.327 381.52 99.02C381.52 45.7135 338.307 2.5 285 2.5C231.694 2.5 188.48 45.7135 188.48 99.02C188.48 152.327 231.694 195.54 285 195.54Z",
                        fill: "url(#paint4_radial_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M346.07 140.879H381.57C404.79 140.879 423.62 122.059 423.62 98.8293C423.62 75.6093 404.8 56.7793 381.57 56.7793H346.07V140.879Z",
                        fill: "url(#paint5_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M237.09 123.26H276.41V116.82H237.09V123.26Z",
                        fill: "url(#paint6_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M237.09 78.2291H276.41V71.7891H237.09V78.2291Z",
                        fill: "url(#paint7_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M325.86 146.589H340.11C343.4 146.589 346.07 143.919 346.07 140.629V57.4092C346.07 54.1192 343.4 51.4492 340.11 51.4492H325.86V146.589Z",
                        fill: "url(#paint8_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M219.54 140.879H184.04C160.82 140.879 141.99 122.059 141.99 98.8293C141.99 75.6093 160.81 56.7793 184.04 56.7793H219.54V140.879Z",
                        fill: "url(#paint9_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M239.76 146.589H225.51C222.22 146.589 219.55 143.919 219.55 140.629V57.4092C219.55 54.1192 222.22 51.4492 225.51 51.4492H239.76V146.589Z",
                        fill: "url(#paint10_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M379.21 146.581C378.91 146.001 378.4 145.181 377.56 144.401C376.28 143.221 374.91 142.761 374.18 142.581C374 142.441 373.77 142.281 373.48 142.131C373.23 142.001 372.97 141.901 372.7 141.831L370.63 141.251C370.29 141.161 370.07 140.831 370.11 140.481C370.15 140.091 370.51 139.801 370.9 139.851L379.42 140.801C380.47 140.921 381.46 140.291 381.79 139.291L382.01 138.651C382.14 138.281 382.5 138.041 382.9 138.091C383.31 138.141 383.62 138.471 383.64 138.871L383.72 140.251C383.86 142.671 383.35 145.091 382.26 147.251L379.21 146.581Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M428.29 185.99C429.39 188.07 430.46 190.28 431.47 192.61C435.75 202.44 437.91 211.78 438.95 219.77C440.03 222.59 441.07 225.54 442.05 228.64C444.86 237.5 446.64 245.84 447.75 253.4C446.13 253.87 444.51 254.34 442.88 254.81C441.2 250.25 438.53 243.08 435.09 234.23C430.76 223.08 428.59 217.5 428.5 217.3C422.43 203.22 419.13 199.32 420.72 193.98C421.29 192.14 422.84 188.93 428.29 185.99Z",
                        fill: "#0065FF"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M412.72 189.539C409.67 199.159 406.62 208.789 403.57 218.409C400.84 230.159 398.1 241.909 395.37 253.659C398.3 254.449 397.22 254.159 400.15 254.939C403.08 247.829 405.94 240.299 408.66 232.359C410.04 228.319 411.33 224.339 412.52 220.439C414.74 216.039 417.2 213.029 419.05 211.089C423.68 206.239 427.59 204.829 430.28 199.479C432.31 195.449 431.64 193.159 431.46 192.609C431.32 192.189 430.95 191.419 430.21 189.889C429.46 188.319 428.81 187.039 428.38 186.189C426.55 186.889 424.48 187.559 422.18 188.119C418.67 188.989 415.46 189.379 412.72 189.539Z",
                        fill: "url(#paint11_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M396.28 246.85C396.21 248.32 395.94 250.38 395.01 252.65C394.37 254.22 392.97 257.51 389.49 259.78C387.45 261.11 385.46 261.59 384.18 261.79C384.26 262.22 384.24 262.13 384.32 262.57C386.73 262.62 391.82 262.66 394.24 262.71C394.59 261.89 395.4 261.57 395.92 261.8C396.41 262.03 396.5 262.7 396.5 262.75C397.32 262.68 398.14 262.61 398.96 262.54C399.23 261.52 399.51 260.49 399.8 259.45C401 255.15 402.31 251.02 403.69 247.08C401.21 247.01 398.74 246.93 396.28 246.85Z",
                        fill: "#344563"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M440.03 247.221C440.92 249.251 441.84 252.641 441.92 253.771C442.06 255.691 442.18 257.271 441.21 258.681C440.55 259.641 439.65 260.141 438.15 260.971C436.98 261.621 435.94 262.021 435.21 262.261C435.3 262.651 435.28 262.571 435.37 262.961C437.57 262.901 439.76 262.831 441.96 262.771C442.52 262.751 443.09 262.731 443.65 262.711C443.66 262.661 443.77 262.191 444.22 261.991C444.67 261.791 445.08 262.031 445.17 262.081C445.49 262.261 445.62 262.541 445.67 262.651C446.19 262.691 446.78 262.721 447.42 262.691C448.09 262.671 448.7 262.601 449.24 262.521C449.09 261.461 448.94 260.401 448.78 259.341C448.69 258.741 448.53 257.681 448.29 256.131C447.73 252.481 447 247.951 446.83 246.881C444.56 247.001 442.29 247.111 440.03 247.221Z",
                        fill: "#344563"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M404.04 166.88C412.13 163.96 417.86 161.43 418.22 161.14C418.55 160.87 418.88 160.59 418.88 160.59C418.98 160.51 419.08 160.42 419.19 160.32C421.82 157.99 427.78 151.82 427.76 142.35C427.73 131.65 420.19 125.19 419.11 124.29C420.82 123.5 422.52 122.71 424.23 121.92C426.36 123.97 432.76 130.64 433.79 141.01C434.72 150.27 430.85 157.43 429.11 160.66C427.36 163.91 425.44 166.35 424.02 167.97C423.92 170.1 424 172.75 424.56 175.73C425.49 180.68 427.37 184.49 428.86 186.96C423.1 188.75 417.33 190.54 411.57 192.33C413.04 189.13 412.78 187.11 412.25 185.86C411.07 183.05 407.94 182.53 406.78 179.13C406.31 177.76 406.36 176.51 406.46 175.69C404.27 175.89 395.01 176.46 386.94 170C375.33 160.7 377 145.5 377.12 144.57C379.19 145.06 381.27 145.55 383.34 146.04C383.04 147.74 383.3 152.66 384.35 155.65C387.27 163.99 396.59 169.11 404.04 166.88Z",
                        fill: "url(#paint12_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M406.52 152.01C406.67 152.06 406.9 152.11 407.25 152.17C408.21 152.33 408.84 152.57 409.24 152.86C410.29 153.59 409.6 155.01 410.51 157.07C410.6 157.28 410.88 157.87 411.03 158.72C411.1 159.15 411.12 159.47 411.12 159.54C411.15 160.21 411.58 161.58 413.11 164.55C412.78 164.46 412.46 164.37 412.13 164.28C411.17 163.91 410.2 163.54 409.24 163.17C407.16 161.78 406.7 161.57 406.7 160.58C406.69 159.4 406.68 157.33 406.62 157.25C405.95 156.6 405.08 156.48 405.74 155.68C406.12 155.23 406.41 154.9 406.51 154.81C406.82 154.53 407.04 153.83 406.52 152.01Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M409.17 152.81C408.97 155.53 409.02 159.86 410.76 164.7C410.8 164.82 410.85 164.95 410.9 165.07C412.74 169.95 418.57 172.14 423.04 169.45C423.19 169.36 423.35 169.26 423.5 169.16C423.53 169.14 423.55 169.12 423.58 169.11C426.31 167.24 426.68 163.37 424.47 160.91C422.98 159.26 422 157.68 421.33 156.36C419.26 152.28 419.55 149.41 416.8 147.81C414.71 146.59 412.02 146.79 411.13 146.85C409.41 146.98 408.61 147.42 408.23 147.7C407.34 148.37 406.86 149.14 406.64 149.56C406.11 150.55 405.98 151.47 405.94 152C406.33 152.02 406.78 152.08 407.26 152.18C408.02 152.34 408.67 152.58 409.17 152.81Z",
                        fill: "#172B4D"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M298 24.3503L293.82 0.940321C293.72 0.390321 292.95 0.360321 292.8 0.890321L286.8 21.9503L281.93 20.5603C281.56 20.4503 281.2 20.7703 281.27 21.1503L285.45 44.5603C285.55 45.1103 286.32 45.1403 286.47 44.6103L292.47 23.5503L297.34 24.9403C297.71 25.0603 298.07 24.7303 298 24.3503Z",
                        fill: "url(#paint13_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M271.23 34.4501L262.63 26.2801C262.45 26.1101 262.17 26.3001 262.26 26.5301L266.06 36.7401L263.69 37.6201C263.53 37.6801 263.49 37.8801 263.61 38.0001L272.21 46.1701C272.39 46.3401 272.67 46.1501 272.58 45.9201L268.78 35.7101L271.15 34.8301C271.31 34.7801 271.35 34.5701 271.23 34.4501Z",
                        fill: "url(#paint14_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M252.19 156.739L248.63 180.259C248.55 180.809 249.26 181.089 249.58 180.639L262.02 162.619L266.18 165.499C266.5 165.719 266.94 165.529 266.99 165.149L270.55 141.629C270.63 141.079 269.92 140.799 269.6 141.249L257.16 159.269L253 156.389C252.69 156.169 252.25 156.359 252.19 156.739Z",
                        fill: "url(#paint15_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M280.79 160.989L286.31 171.489C286.42 171.709 286.75 171.619 286.74 171.379L286.42 160.489L288.95 160.409C289.12 160.399 289.23 160.219 289.15 160.069L283.63 149.569C283.52 149.349 283.19 149.439 283.2 149.679L283.52 160.569L280.99 160.639C280.82 160.659 280.71 160.839 280.79 160.989Z",
                        fill: "url(#paint16_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M210.22 142.149L210.26 142.049C210.88 140.389 211.84 138.869 213.09 137.609L213.57 137.119C213.8 136.879 214.17 136.829 214.46 136.989C214.83 137.199 214.96 137.679 214.73 138.039L214.35 138.639C213.96 139.259 214.44 140.049 215.17 139.989L216.22 139.909C216.41 139.889 216.6 139.889 216.79 139.889H220.09V140.009C220.09 140.589 219.94 141.149 219.65 141.649L219.85 142.479L212.52 144.559L210.22 142.149Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M167.89 212.219C170.43 201.299 170.03 198.249 168.95 195.809C167.16 191.769 163.58 189.559 161.36 188.459C160.58 189.839 159.49 191.959 158.49 194.659C156.66 199.589 156.32 203.239 155.63 207.859C155.11 211.319 154.24 216.299 152.75 222.379C150.92 226.479 149.08 231.349 147.55 236.919C145.75 243.459 144.81 249.419 144.33 254.469C146.45 254.469 148.58 254.469 150.71 254.459C152.73 251.619 154.81 248.339 156.78 244.619C160.42 237.759 162.67 231.309 164.11 225.929C164.85 223.589 165.87 220.159 166.97 215.949C167.26 214.829 167.56 213.629 167.89 212.219Z",
                        fill: "#6554C0"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M176.58 191.57C179.52 198.15 181.75 203.76 183.34 207.95C186.95 217.46 187.57 220.51 187.81 221.82C188.78 227.05 188.69 231 188.5 237.33C188.37 241.83 187.97 247.87 186.83 255C184.86 255.11 182.88 255.22 180.91 255.33C179.04 250.46 177.13 243.9 176.47 235.99C176.11 231.71 176.19 227.83 176.47 224.47C173.58 221.68 170.54 218.48 167.48 214.83C165.05 211.93 162.9 209.11 161 206.41C161 206.41 156.64 199.14 158.38 195.02C158.38 195.01 158.39 194.99 158.4 194.98C158.89 193.79 159.33 192.79 159.55 192.3C160.25 190.75 160.84 189.5 161.25 188.66C163.04 189.3 165.07 189.9 167.32 190.4C170.78 191.17 173.92 191.48 176.58 191.57Z",
                        fill: "url(#paint17_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M172.03 148.42C171.56 148.18 171.05 147.95 170.5 147.72C169.91 147.47 169.34 147.26 168.81 147.09C168.59 146.7 167.07 144.07 163.95 143.52C163.46 143.44 161.77 143.16 160.05 144.06C157.21 145.55 156.37 149.16 156.64 151.67C156.74 152.59 156.91 154.28 158.16 155.58C159.93 157.42 162.29 156.85 162.98 158.45C163.55 159.76 162.18 160.72 162.73 161.65C163.73 163.34 169.99 163.03 171.08 160.08C171.23 159.68 171.48 158.71 170.76 157.19C171.68 155.93 172.61 154.67 173.53 153.42C173.3 152.89 172.96 152.24 172.45 151.55C171.97 150.91 171.49 150.41 171.07 150.05C171.23 149.86 171.41 149.63 171.58 149.35C171.79 149 171.93 148.68 172.03 148.42Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M163.94 151.95C163.79 150.89 164.25 150.56 163.88 149.91C163.46 149.16 162.68 149.28 162.15 148.38C161.99 148.12 161.68 147.58 161.84 147.09C162.25 145.82 165.44 146.23 165.81 145C165.91 144.65 165.76 144.29 165.61 144.04C165.08 143.65 164.2 143.12 163.02 142.93C160.36 142.5 157.52 144.01 156.11 146.43C154.47 149.25 155.11 152.73 156.74 154.54C157.37 155.24 158.63 156.65 160.4 156.92C160.96 157.01 161.84 157.02 162.34 157.67C162.73 158.17 162.66 158.75 162.98 158.84C163.06 158.86 163.36 158.91 164.01 158.08C164.71 157.19 165.56 156.12 165.39 154.83C165.22 153.5 164.16 153.48 163.94 151.95Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M171.78 160.529C178.49 163.269 181.57 171.049 181.57 176.839C181.57 180.219 180.53 183.109 179.64 185.569C178.42 188.949 177.51 190.789 176 192.699C171.74 198.069 159.59 197.749 157.75 193.939C157.36 193.139 157.51 192.349 157.55 192.109C159.83 178.359 156.81 163.059 163.89 159.849C166.86 158.499 170.07 159.829 171.78 160.529Z",
                        fill: "#5243AA"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M213.33 144.43C213.47 144.59 213.62 144.74 213.76 144.9C209.95 149.37 203.65 155.67 194.36 160.95C183.21 167.29 172.8 169.3 166.51 170.01C164.79 168.3 162.68 165.68 163.29 163.25C163.79 161.24 166.05 159.77 176.29 157.08C180.37 156.01 185.85 154.7 192.45 153.53C198.37 149.36 204.3 145.18 210.22 141.01C210.23 141.02 210.23 141.02 210.24 141.03L213.33 144.43Z",
                        fill: "url(#paint18_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M416.51 117.27L420.41 121.18L421.77 118.83L417.41 116.13C417.1 115.94 416.71 116 416.47 116.27C416.23 116.56 416.24 117 416.51 117.27Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M185.75 257.109C185.75 257.119 185.76 257.129 185.77 257.139C185.88 257.189 186.19 256.219 186.63 256.019C187.47 255.639 188.86 258.159 191.32 259.779C192.43 260.509 193.53 260.909 194.4 261.129C194.73 261.209 194.96 261.509 194.96 261.849V262.549H180.01C179.98 261.659 180.04 260.509 180.34 259.209C180.53 258.409 180.77 257.699 181.02 257.119H185.75V257.109Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M180.08 259.818C181.72 259.818 183.05 261.138 183.09 262.768C182.06 262.768 181.03 262.768 180 262.768V259.818C180.03 259.828 180.06 259.818 180.08 259.818Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M148.77 257.109C148.77 257.119 148.78 257.129 148.79 257.139C148.9 257.189 149.21 256.219 149.65 256.019C150.49 255.639 151.88 258.159 154.34 259.779C155.45 260.509 156.55 260.909 157.42 261.129C157.75 261.209 157.98 261.509 157.98 261.849V262.549H143.03C143 261.659 143.06 260.509 143.36 259.209C143.55 258.409 143.79 257.699 144.04 257.119H148.77V257.109Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M143.11 259.818C144.75 259.818 146.08 261.138 146.12 262.768C145.09 262.768 144.06 262.768 143.03 262.768V259.818C143.05 259.828 143.08 259.818 143.11 259.818Z",
                        fill: "#B3BAC5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint0_linear_1375_267",
                        x1: "141.994",
                        y1: "181.192",
                        x2: "0.870117",
                        y2: "181.192",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#C1C7D0",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint1_linear_1375_267",
                        x1: "208.292",
                        y1: "264.428",
                        x2: "0.870117",
                        y2: "264.428",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#091E42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8433",
                                stopColor: "#091E42",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint2_linear_1375_267",
                        x1: "357.327",
                        y1: "264.428",
                        x2: "564.748",
                        y2: "264.428",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#091E42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8433",
                                stopColor: "#091E42",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint3_linear_1375_267",
                        x1: "423.624",
                        y1: "181.192",
                        x2: "564.748",
                        y2: "181.192",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#0065FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1724",
                                stopColor: "#076AFF",
                                stopOpacity: "0.8007"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.4145",
                                stopColor: "#1976FF",
                                stopOpacity: "0.5208"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6966",
                                stopColor: "#378BFF",
                                stopOpacity: "0.1947"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8651",
                                stopColor: "#4C9AFF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("radialGradient", {
                        id: "paint4_radial_1375_267",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(285 99.0229) scale(96.5182)",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFF0B2"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1584",
                                stopColor: "#FFE587",
                                stopOpacity: "0.8416"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3589",
                                stopColor: "#FFDA57",
                                stopOpacity: "0.6411"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5498",
                                stopColor: "#FFD031",
                                stopOpacity: "0.4502"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7256",
                                stopColor: "#FFC916",
                                stopOpacity: "0.2744"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8811",
                                stopColor: "#FFC506",
                                stopOpacity: "0.1189"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFC400",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint5_linear_1375_267",
                        x1: "346.074",
                        y1: "98.8386",
                        x2: "423.624",
                        y2: "98.8386",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#0052CC"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint6_linear_1375_267",
                        x1: "237.087",
                        y1: "120.044",
                        x2: "276.412",
                        y2: "120.044",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#DFE1E5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint7_linear_1375_267",
                        x1: "237.087",
                        y1: "75.0106",
                        x2: "276.412",
                        y2: "75.0106",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#DFE1E5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint8_linear_1375_267",
                        x1: "335.969",
                        y1: "146.593",
                        x2: "335.969",
                        y2: "51.4514",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#2684FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#B2D4FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint9_linear_1375_267",
                        x1: "219.544",
                        y1: "98.8386",
                        x2: "141.994",
                        y2: "98.8386",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#EBECF0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint10_linear_1375_267",
                        x1: "229.65",
                        y1: "146.593",
                        x2: "229.65",
                        y2: "51.4514",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#F4F5F7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint11_linear_1375_267",
                        x1: "402.858",
                        y1: "216.64",
                        x2: "421.684",
                        y2: "223.492",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#4C9AFF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8134",
                                stopColor: "#0065FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8713",
                                stopColor: "#0065FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint12_linear_1375_267",
                        x1: "376.968",
                        y1: "157.139",
                        x2: "433.936",
                        y2: "157.139",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#B2D4FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint13_linear_1375_267",
                        x1: "289.638",
                        y1: "45.0027",
                        x2: "289.638",
                        y2: "0.510323",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFF0B2"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFC400"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint14_linear_1375_267",
                        x1: "262.238",
                        y1: "36.2259",
                        x2: "272.592",
                        y2: "36.2259",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint15_linear_1375_267",
                        x1: "259.6",
                        y1: "180.859",
                        x2: "259.6",
                        y2: "141.017",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint16_linear_1375_267",
                        x1: "284.971",
                        y1: "171.613",
                        x2: "284.971",
                        y2: "149.45",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint17_linear_1375_267",
                        x1: "157.982",
                        y1: "221.995",
                        x2: "188.627",
                        y2: "221.995",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3435",
                                stopColor: "#6554C0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#998DD9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint18_linear_1375_267",
                        x1: "163.185",
                        y1: "155.517",
                        x2: "213.758",
                        y2: "155.517",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#5243AA"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#8777D9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("clipPath", {
                        id: "clip0_1375_267",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                            width: "563.88",
                            height: "265.81",
                            fill: "white",
                            transform: "translate(0.870117 0.509766)"
                        })
                    })
                ]
            })
        ]
    });

});



parcelRegister("56NmJ", function(module, exports) {
$parcel$export(module.exports, "InlineCard", () => $4df83dd681dfab9f$export$aff6291803939b05);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aqlRB = parcelRequire("aqlRB");

var $aybSF = parcelRequire("aybSF");

var $kePQU = parcelRequire("kePQU");

var $lUdvR = parcelRequire("lUdvR");

var $lJsUk = parcelRequire("lJsUk");

var $4D53f = parcelRequire("4D53f");

var $j0zes = parcelRequire("j0zes");

var $9wIH6 = parcelRequire("9wIH6");

var $75Eqs = parcelRequire("75Eqs");

var $5pSar = parcelRequire("5pSar");

var $huCuF = parcelRequire("huCuF");

var $fGlQF = parcelRequire("fGlQF");

var $h8wAB = parcelRequire("h8wAB");

var $b7hOH = parcelRequire("b7hOH");

var $is9x0 = parcelRequire("is9x0");

var $8ciZl = parcelRequire("8ciZl");
const $4df83dd681dfab9f$var$UFOLoadHoldWrapper = ({ children: children })=>{
    return (0, $kePQU.fg)('platform_renderer_blindspots') ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lUdvR.default), {
                name: "smart-card-inline-card"
            }),
            children
        ]
    }) : children;
};
const $4df83dd681dfab9f$export$aff6291803939b05 = ({ id: id, url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, isSelected: isSelected, isHovered: isHovered, renderers: renderers, onResolve: onResolve, onError: onError, testId: testId, inlinePreloaderStyle: inlinePreloaderStyle, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $aqlRB.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $75Eqs.getExtensionKey)(details);
    const testIdWithStatus = testId ? `${testId}-${status}-view` : undefined;
    const resolvedProps = status === (0, $4D53f.SmartLinkStatus).Resolved ? (0, $9wIH6.extractInlineProps)(details, renderers, removeTextHighlightingFromTitle, false) : {};
    (0, $eJOHy.useEffect)(()=>{
        switch(status){
            case (0, $4D53f.SmartLinkStatus).Resolved:
                onResolve?.({
                    url: url,
                    title: resolvedProps.title
                });
                break;
            case (0, $4D53f.SmartLinkStatus).Errored:
            case (0, $4D53f.SmartLinkStatus).Fallback:
            case (0, $4D53f.SmartLinkStatus).Forbidden:
            case (0, $4D53f.SmartLinkStatus).NotFound:
            case (0, $4D53f.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        url,
        resolvedProps.title
    ]);
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($4df83dd681dfab9f$var$UFOLoadHoldWrapper, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $is9x0.InlineCardResolvingView), {
                    url: url,
                    isSelected: isSelected,
                    onClick: handleFrameClick,
                    testId: testIdWithStatus,
                    inlinePreloaderStyle: inlinePreloaderStyle,
                    resolvingPlaceholder: resolvingPlaceholder,
                    truncateInline: truncateInline
                })
            });
        case 'resolved':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b7hOH.InlineCardResolvedView), {
                ...resolvedProps,
                id: id,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                link: url,
                isSelected: isSelected,
                isHovered: isHovered,
                onClick: handleFrameClick,
                testId: testIdWithStatus,
                truncateInline: truncateInline,
                hideIconLoadingSkeleton: (0, $lJsUk.expValEquals)('platform_editor_smart_card_otp', 'isEnabled', true) && hideIconLoadingSkeleton
            });
        case 'unauthorized':
            const provider = (0, $aybSF.extractSmartLinkProvider)(details);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8ciZl.InlineCardUnauthorizedView), {
                icon: provider && provider.icon,
                context: provider && provider.text,
                url: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                showHoverPreview: showHoverPreview,
                id: id,
                extensionKey: extensionKey,
                truncateInline: truncateInline
            });
        case 'forbidden':
            const providerForbidden = (0, $aybSF.extractSmartLinkProvider)(details);
            const cardMetadata = details?.meta ?? (0, $5pSar.getForbiddenJsonLd)().meta;
            const requestAccessContext = (0, $j0zes.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: providerForbidden?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h8wAB.InlineCardForbiddenView), {
                url: url,
                icon: providerForbidden && providerForbidden.icon,
                context: providerForbidden?.text,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                requestAccessContext: requestAccessContext,
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'not_found':
            const providerNotFound = (0, $aybSF.extractSmartLinkProvider)(details);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fGlQF.InlineCardErroredView), {
                url: url,
                icon: providerNotFound && providerNotFound.icon,
                isSelected: isSelected,
                message: "Can't find link",
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-not-found-view',
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'fallback':
        case 'errored':
        default:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $huCuF.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-errored-view',
                truncateInline: truncateInline
            });
    }
};

});
parcelRegister("fGlQF", function(module, exports) {
$parcel$export(module.exports, "InlineCardErroredView", () => $177869beef213ab8$export$8ae570c871cdb179);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $7aL0y = parcelRequire("7aL0y");

var $cafmZ = parcelRequire("cafmZ");

var $4GHj0 = parcelRequire("4GHj0");

var $ghXXW = parcelRequire("ghXXW");

var $7mpQ5 = parcelRequire("7mpQ5");

var $9m1Bc = parcelRequire("9m1Bc");
const $177869beef213ab8$var$fallbackIcon = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7aL0y))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error",
        LEGACY_size: "small",
        testId: "errored-view-default-icon"
    });
};
const $177869beef213ab8$export$8ae570c871cdb179 = ({ url: url, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-errored-view', icon: icon, message: message, onRetry: onRetry, truncateInline: truncateInline, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const hashAction = !!onRetry;
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        if (onRetry) {
            event.preventDefault();
            event.stopPropagation();
            onRetry();
        }
    }, [
        onRetry
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        return onRetry && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ghXXW.ActionButton), {
            onClick: handleRetry,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $cafmZ.messages).try_again
            })
        });
    }, [
        handleRetry,
        onRetry
    ]);
    const content = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $7mpQ5.Frame), {
        link: hashAction ? undefined : url,
        onClick: hashAction ? undefined : onClick,
        isSelected: isSelected,
        ref: frameRef,
        testId: testId,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9m1Bc.IconAndTitleLayout), {
                icon: icon || $177869beef213ab8$var$fallbackIcon(),
                link: hashAction ? url : undefined,
                title: url,
                onClick: hashAction ? onClick : undefined,
                rightSide: message
            }),
            renderActionButton()
        ]
    });
    if (showHoverPreview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4GHj0.HoverCard), {
        url: url,
        children: content
    });
    return content;
};

});
parcelRegister("ghXXW", function(module, exports) {
$parcel$export(module.exports, "ActionButton", () => $c7dbd3f84934c2a1$export$cfc7921d29ef7b80);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $g8piG = parcelRequire("g8piG");
const $c7dbd3f84934c2a1$var$styles = {
    button: "_1e0c1bgi",
    innerContainer: "_1e0c1nu9 _1y1m1u8q _16d9qvcn _k48p1wq8 _19bv12x7 _ca0qv77o _n3tdv77o _u5f312x7 _y3gn18uv _o5721btx _1nmz9jpi",
    enabled: "_syaz1fxt _80omtlke _bfhkm7j4 _irr315ej _1di6ip91",
    disabled: "_syaz1lh4 _80om13gf _bfhksyzs"
};
const $c7dbd3f84934c2a1$export$cfc7921d29ef7b80 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, isDisabled: isDisabled, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $g8piG.default), {
        ...props,
        isDisabled: isDisabled,
        ref: ref,
        // We need to reset Pressable fixed font size to allow inline card to inherit the font size
        // from parent component such as paragraph and heading
        style: {
            font: `inherit`
        },
        xcss: $c7dbd3f84934c2a1$var$styles.button,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            tabIndex: isDisabled ? undefined : 0,
            className: (0, $hcewu.default)([
                $c7dbd3f84934c2a1$var$styles.innerContainer,
                isDisabled ? $c7dbd3f84934c2a1$var$styles.disabled : $c7dbd3f84934c2a1$var$styles.enabled
            ]),
            children: children
        })
    });
});

});


parcelRegister("h8wAB", function(module, exports) {
$parcel$export(module.exports, "InlineCardForbiddenView", () => $cc201eb3a0e918cb$export$ebd227d2573ed3d8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $8WSiy = parcelRequire("8WSiy");

var $1VQIy = parcelRequire("1VQIy");

var $kePQU = parcelRequire("kePQU");

var $g8piG = parcelRequire("g8piG");


var $cafmZ = parcelRequire("cafmZ");

var $4GHj0 = parcelRequire("4GHj0");

var $ghXXW = parcelRequire("ghXXW");

var $5NGdQ = parcelRequire("5NGdQ");

var $7mpQ5 = parcelRequire("7mpQ5");

var $9m1Bc = parcelRequire("9m1Bc");
const $cc201eb3a0e918cb$var$styles = {
    actionButtonLozengeStyle: "_2rkolb4i _bfhk1w7a _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _p12f1osq"
};
const $cc201eb3a0e918cb$var$fallbackForbiddenIcon = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8WSiy))), {
        label: "error",
        color: "var(--ds-icon-danger, #C9372C)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($1VQIy))),
        LEGACY_size: "small",
        testId: "forbidden-view-fallback-icon"
    });
};
const $cc201eb3a0e918cb$export$ebd227d2573ed3d8 = ({ url: url, icon: icon, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-forbidden-view', truncateInline: truncateInline, requestAccessContext: requestAccessContext, onAuthorise: onAuthorise, context: context, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const [hasRequestAccessContextMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(!!requestAccessContext?.callToActionMessageKey);
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) onAuthorise();
        else requestAccessContext?.action?.promise();
    }, [
        onAuthorise,
        requestAccessContext?.action
    ]);
    const renderForbiddenAccessMessage = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        if (requestAccessContext?.callToActionMessageKey) {
            const { callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $cafmZ.messages)[callToActionMessageKey],
                values: {
                    product: context
                }
            });
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $cafmZ.messages).invalid_permissions,
            children: (formattedMessage)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                    children: formattedMessage
                })
        });
    }, [
        context,
        requestAccessContext
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        const accessType = requestAccessContext?.accessType;
        if (hasRequestAccessContextMessage) {
            const isDisabled = accessType === 'PENDING_REQUEST_EXISTS';
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ghXXW.ActionButton), {
                isDisabled: isDisabled,
                onClick: handleRetry,
                testId: "button-connect-other-account",
                children: renderForbiddenAccessMessage()
            });
        }
        if (onAuthorise) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $g8piG.default), {
            xcss: $cc201eb3a0e918cb$var$styles.actionButtonLozengeStyle,
            onClick: handleRetry,
            style: {
                font: `inherit`
            },
            testId: "button-connect-other-account",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5NGdQ.default), {
                appearance: "moved",
                ...(0, $kePQU.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                children: renderForbiddenAccessMessage()
            })
        });
        return null;
    }, [
        handleRetry,
        hasRequestAccessContextMessage,
        onAuthorise,
        renderForbiddenAccessMessage,
        requestAccessContext?.accessType
    ]);
    const content = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $7mpQ5.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9m1Bc.IconAndTitleLayout), {
                icon: icon ? icon : $cc201eb3a0e918cb$var$fallbackForbiddenIcon(),
                link: url,
                title: url,
                onClick: onClick,
                titleColor: `var(--ds-text-subtle, ${(0, $15543b40efbda8c4$export$c39c0fe0f26207ae)})`
            }),
            renderActionButton()
        ]
    });
    if (showHoverPreview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4GHj0.HoverCard), {
        url: url,
        children: content
    });
    return content;
};

});
parcelRegister("1VQIy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $168401ee4a367ead$var$_react = $168401ee4a367ead$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4RAp5 = parcelRequire("4RAp5");
function $168401ee4a367ead$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $168401ee4a367ead$var$LockFilledIcon = (props)=>/*#__PURE__*/ $168401ee4a367ead$var$_react.default.createElement($4RAp5.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 10V8.002A4.004 4.004 0 0 1 12 4a4 4 0 0 1 4 4.002V10a2 2 0 0 1 2 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 0 1 6 18v-6c0-1.102.897-1.995 2-2m2 0h4V8.002A2 2 0 0 0 12 6c-1.102 0-2 .898-2 2.002zm2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
    }, props));
$168401ee4a367ead$var$LockFilledIcon.displayName = 'LockFilledIcon';
var $168401ee4a367ead$var$_default = module.exports.default = $168401ee4a367ead$var$LockFilledIcon;

});


parcelRegister("is9x0", function(module, exports) {
$parcel$export(module.exports, "InlineCardResolvingView", () => $54cca078cacef9c4$export$98531adac42f053e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $9vwg9 = parcelRequire("9vwg9");

var $eAh3b = parcelRequire("eAh3b");

var $7mpQ5 = parcelRequire("7mpQ5");

var $9m1Bc = parcelRequire("9m1Bc");

var $cZrmv = parcelRequire("cZrmv");
const $54cca078cacef9c4$var$styles = {
    spinnerWrapper: "_11c81o8v _1e0c116y _4cvr1h6o _1bah1h6o _4t3i7vkz _1bsb7vkz"
};
const $54cca078cacef9c4$export$98531adac42f053e = ({ url: url, onClick: onClick, isSelected: isSelected, inlinePreloaderStyle: inlinePreloaderStyle, testId: testId = 'inline-card-resolving-view', titleTextColor: titleTextColor, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline })=>{
    const renderSpinner = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $9vwg9.default), {
            as: "span",
            xcss: $54cca078cacef9c4$var$styles.spinnerWrapper,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eAh3b.default), {
                size: 14
            })
        }), []);
    if (inlinePreloaderStyle === 'on-right-without-skeleton') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7mpQ5.Frame), {
        withoutBackground: true,
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        truncateInline: truncateInline,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9m1Bc.IconTitleWrapper), {
            children: [
                url,
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cZrmv.RightIconPositionWrapper), {
                    children: renderSpinner()
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7mpQ5.Frame), {
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        link: url,
        truncateInline: truncateInline,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9m1Bc.IconAndTitleLayout), {
            icon: renderSpinner(),
            title: resolvingPlaceholder ?? url,
            titleTextColor: titleTextColor
        })
    });
};

});
parcelRegister("cZrmv", function(module, exports) {
$parcel$export(module.exports, "RightIconPositionWrapper", () => $1374a785a42abf0c$export$91b164375b8037b5);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $1374a785a42abf0c$export$91b164375b8037b5 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u0v77o _kqswh2mm _1e0c1o8l",
            __cmplp.className
        ])
    });
});

});


parcelRegister("8ciZl", function(module, exports) {
$parcel$export(module.exports, "InlineCardUnauthorizedView", () => $78285d1dfd68f5a1$export$ece47728c0503997);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $8WSiy = parcelRequire("8WSiy");

var $1VQIy = parcelRequire("1VQIy");


var $5RpiZ = parcelRequire("5RpiZ");

var $cafmZ = parcelRequire("cafmZ");

var $4GHj0 = parcelRequire("4GHj0");

var $ghXXW = parcelRequire("ghXXW");

var $7mpQ5 = parcelRequire("7mpQ5");

var $9m1Bc = parcelRequire("9m1Bc");
const $78285d1dfd68f5a1$var$fallbackUnauthorizedIcon = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8WSiy))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($1VQIy))),
        LEGACY_size: "small"
    });
};
const $78285d1dfd68f5a1$export$ece47728c0503997 = ({ url: url, id: id, icon: icon, onAuthorise: onAuthorise, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-unauthorized-view', showHoverPreview: showHoverPreview = false, truncateInline: truncateInline, context: context })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const { fireEvent: fireEvent } = (0, $5RpiZ.useAnalyticsEvents)();
    const handleConnectAccount = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorise();
        }
    }, [
        fireEvent,
        onAuthorise
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ghXXW.ActionButton), {
            onClick: handleConnectAccount,
            testId: "button-connect-account",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $cafmZ.messages).connect_link_account_card_name,
                values: {
                    context: context
                }
            })
        });
    }, [
        handleConnectAccount,
        context
    ]);
    const inlineCardUnauthenticatedView = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $7mpQ5.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9m1Bc.IconAndTitleLayout), {
                icon: icon ? icon : $78285d1dfd68f5a1$var$fallbackUnauthorizedIcon(),
                title: url,
                link: url,
                onClick: onClick,
                titleColor: `var(--ds-text-subtle, ${(0, $15543b40efbda8c4$export$c39c0fe0f26207ae)})`
            }),
            renderActionButton()
        ]
    });
    if (onAuthorise && showHoverPreview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4GHj0.HoverCard), {
        url: url,
        id: id,
        children: inlineCardUnauthenticatedView
    });
    return inlineCardUnauthenticatedView;
};

});


parcelRegister("gEsSS", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkEvents", () => $a9da64a9d78b10cf$export$ed70996d478e16d3);
$parcel$export(module.exports, "useFire3PWorkflowsClickEvent", () => $a9da64a9d78b10cf$export$e682245dc886cff2);

var $eJOHy = parcelRequire("eJOHy");

var $aqlRB = parcelRequire("aqlRB");

var $4dsff = parcelRequire("4dsff");
function $a9da64a9d78b10cf$export$ed70996d478e16d3() {
    /**
	 * this utility maybe extended in the future to include
	 * more contextual info about SLs
	 */ const events = (0, $eJOHy.useMemo)(()=>new (0, $4dsff.SmartLinkEvents)(), []);
    return events;
}
function $a9da64a9d78b10cf$export$e682245dc886cff2(firstPartyIdentifier, thirdPartyARI) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $aqlRB.useAnalyticsEvents)();
    return ()=>{
        const smartlinkClickAnalyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'smartLink',
            actionSubjectId: 'smartlinkClickAnalyticsWorkflows',
            eventType: 'ui',
            attributes: {
                eventName: 'smartLinkClickAnalyticsThirdPartyWorkflows',
                firstPartyIdentifier: firstPartyIdentifier
            },
            nonPrivacySafeAttributes: {
                thirdPartyARI: thirdPartyARI
            }
        });
        smartlinkClickAnalyticsEvent.fire('media');
    };
}

});



parcelRegister("6Wtd1", function(module, exports) {
$parcel$export(module.exports, "LazyLazilyRenderCard", () => $a7753d50172198d9$export$ff05cac3dc0bcc8d);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hk4Ns = parcelRequire("hk4Ns");

var $Md55L = parcelRequire("Md55L");

var $8JuSD = parcelRequire("8JuSD");

var $1SK0s = parcelRequire("1SK0s");
function $a7753d50172198d9$export$ff05cac3dc0bcc8d(props) {
    const { appearance: appearance, container: container, id: id } = props;
    const offset = Math.ceil(window.innerHeight / 4);
    (0, $eJOHy.useState)(()=>{
        // Start of experience when intersectionObserver is not supported.
        (0, $Md55L.startUfoExperience)('smart-link-rendered', id);
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hk4Ns.default), {
        offset: offset,
        component: appearance === 'inline' ? 'span' : 'div',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "loader-wrapper",
        placeholder: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1SK0s.LoadingCardLink), {
            ...props
        }),
        scrollContainer: container,
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8JuSD.CardWithUrlContent), {
            ...props
        })
    });
}

});
parcelRegister("hk4Ns", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9c8067713fa41b6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fPMMi = parcelRequire("fPMMi");

var $33dyc = parcelRequire("33dyc");

var $b7Pst = parcelRequire("b7Pst");

var $ebmGF = parcelRequire("ebmGF");

var $f5YpG = parcelRequire("f5YpG");

var $lzei4 = parcelRequire("lzei4");

var $drbf6 = parcelRequire("drbf6");
function $c9c8067713fa41b6$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $c9c8067713fa41b6$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $c9c8067713fa41b6$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $c9c8067713fa41b6$var$_typeof(obj);
}
function $c9c8067713fa41b6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c9c8067713fa41b6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c9c8067713fa41b6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c9c8067713fa41b6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c9c8067713fa41b6$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $c9c8067713fa41b6$var$_possibleConstructorReturn(self, call) {
    if (call && ($c9c8067713fa41b6$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $c9c8067713fa41b6$var$_assertThisInitialized(self);
}
function $c9c8067713fa41b6$var$_getPrototypeOf(o) {
    $c9c8067713fa41b6$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c9c8067713fa41b6$var$_getPrototypeOf(o);
}
function $c9c8067713fa41b6$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c9c8067713fa41b6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $c9c8067713fa41b6$var$_setPrototypeOf(subClass, superClass);
}
function $c9c8067713fa41b6$var$_setPrototypeOf(o, p) {
    $c9c8067713fa41b6$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c9c8067713fa41b6$var$_setPrototypeOf(o, p);
}
function $c9c8067713fa41b6$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $c9c8067713fa41b6$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    $c9c8067713fa41b6$var$_inherits(LazilyRender, _React$Component);
    function LazilyRender() {
        var _getPrototypeOf2;
        var _this;
        $c9c8067713fa41b6$var$_classCallCheck(this, LazilyRender);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $c9c8067713fa41b6$var$_possibleConstructorReturn(this, (_getPrototypeOf2 = $c9c8067713fa41b6$var$_getPrototypeOf(LazilyRender)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        $c9c8067713fa41b6$var$_defineProperty($c9c8067713fa41b6$var$_assertThisInitialized(_this), "raf", void 0);
        $c9c8067713fa41b6$var$_defineProperty($c9c8067713fa41b6$var$_assertThisInitialized(_this), "element", void 0);
        $c9c8067713fa41b6$var$_defineProperty($c9c8067713fa41b6$var$_assertThisInitialized(_this), "container", void 0);
        $c9c8067713fa41b6$var$_defineProperty($c9c8067713fa41b6$var$_assertThisInitialized(_this), "state", {
            hasBeenScrolledIntoView: false
        });
        $c9c8067713fa41b6$var$_defineProperty($c9c8067713fa41b6$var$_assertThisInitialized(_this), "update", function() {
            cancelAnimationFrame(_this.raf);
            _this.raf = requestAnimationFrame(function() {
                var elementBounds = _this.getElementBounds();
                var viewportBounds = _this.getViewportBounds();
                var offsetBounds = _this.getOffsetBounds();
                if (!elementBounds || !viewportBounds) return;
                if ((0, $f5YpG.default)(elementBounds, viewportBounds, offsetBounds)) {
                    _this.stopListening(_this.container);
                    _this.setState({
                        hasBeenScrolledIntoView: true
                    }, function() {
                        var onRender = _this.props.onRender;
                        if (onRender) onRender();
                    });
                }
            });
        });
        $c9c8067713fa41b6$var$_defineProperty($c9c8067713fa41b6$var$_assertThisInitialized(_this), "handleMount", function(element) {
            var scrollContainer = _this.props.scrollContainer;
            _this.element = element;
            _this.container = _this.getContainer(scrollContainer);
        });
        return _this;
    }
    $c9c8067713fa41b6$var$_createClass(LazilyRender, [
        {
            key: "getContainer",
            value: function getContainer(scrollContainer) {
                if (scrollContainer) return scrollContainer;
                else {
                    if (this.element) {
                        var container = (0, (/*@__PURE__*/$parcel$interopDefault($fPMMi)))(this.element);
                        if (container === document.scrollingElement || container === document.documentElement || !(0, $lzei4.default)() && container == document.body) return window;
                        else return container;
                    } else return undefined;
                }
            }
        },
        {
            key: "getViewportBounds",
            value: function getViewportBounds() {
                return (0, $33dyc.default)(this.container);
            }
        },
        {
            key: "getElementBounds",
            value: function getElementBounds() {
                return (0, $b7Pst.default)(this.element);
            }
        },
        {
            key: "getOffsetBounds",
            value: function getOffsetBounds() {
                var offset = this.props.offset;
                return (0, $ebmGF.default)(offset);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this2 = this;
                var prevContainer = prevProps.scrollContainer;
                var nextContainer = this.props.scrollContainer; // If a scroll container was defined before, do some cleanup
                // and bootstrap the next scroll container.
                if (prevContainer !== nextContainer) {
                    // If the previous container was already utilised, no cleanup
                    // is required - already done in LazilyRender.update().
                    if (!prevState.hasBeenScrolledIntoView) this.stopListening(prevContainer);
                     // Set a new listener if the scrollContainer is defined, and update 
                    // the container property accordingly. Note: this should only be done
                    // when the next container is different.
                    this.container = this.getContainer(nextContainer);
                    this.startListening(this.container); // Signal that the element has not been scrolled into view and 
                    // recompute its position. This will essentially 'reset' the node's
                    // current status back to a placeholder item if need be.
                    this.setState({
                        hasBeenScrolledIntoView: false
                    }, function() {
                        _this2.update();
                    });
                }
            }
        },
        {
            key: "startListening",
            value: function startListening(container) {
                if (container) container.addEventListener('scroll', this.update, (0, $drbf6.default));
                window.addEventListener('resize', this.update);
            }
        },
        {
            key: "stopListening",
            value: function stopListening(container) {
                if (container) container.removeEventListener('scroll', this.update, (0, $drbf6.default));
                window.removeEventListener('resize', this.update);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.update();
                this.startListening(this.container);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListening(this.container);
            }
        },
        {
            key: "renderChildren",
            value: function renderChildren() {
                var _this$props = this.props, placeholder = _this$props.placeholder, content = _this$props.content, children = _this$props.children;
                var hasBeenScrolledIntoView = this.state.hasBeenScrolledIntoView;
                if (!hasBeenScrolledIntoView && placeholder) return placeholder;
                if (hasBeenScrolledIntoView && content) return content;
                if (children) return children(hasBeenScrolledIntoView);
                return null;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, className = _this$props2.className, component = _this$props2.component;
                return $eJOHy.createElement(component || 'div', {
                    ref: this.handleMount,
                    className: className,
                    children: this.renderChildren()
                });
            }
        }
    ]);
    return LazilyRender;
}($eJOHy.Component);

});
parcelRegister("fPMMi", function(module, exports) {
(function(root, factory) {
    if (typeof define === "function" && define.amd) define([], factory);
    else if (0, module.exports) module.exports = factory();
    else root.Scrollparent = factory();
})(module.exports, function() {
    var regex = /(auto|scroll)/;
    var parents = function(node, ps) {
        if (node.parentNode === null) return ps;
        return parents(node.parentNode, ps.concat([
            node
        ]));
    };
    var style = function(node, prop) {
        return getComputedStyle(node, null).getPropertyValue(prop);
    };
    var overflow = function(node) {
        return style(node, "overflow") + style(node, "overflow-y") + style(node, "overflow-x");
    };
    var scroll = function(node) {
        return regex.test(overflow(node));
    };
    var scrollParent = function(node) {
        if (!(node instanceof HTMLElement || node instanceof SVGElement)) return;
        var ps = parents(node.parentNode, []);
        for(var i = 0; i < ps.length; i += 1){
            if (scroll(ps[i])) return ps[i];
        }
        return document.scrollingElement || document.documentElement;
    };
    return scrollParent;
});

});

parcelRegister("33dyc", function(module, exports) {
$parcel$export(module.exports, "default", () => $238c29c110dc849e$export$2e2bcd8739ae039);

var $b7Pst = parcelRequire("b7Pst");
function $238c29c110dc849e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $238c29c110dc849e$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $238c29c110dc849e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $238c29c110dc849e$export$2e2bcd8739ae039(container) {
    if (!container) return undefined;
    if (container === window) return {
        top: window.pageYOffset,
        left: window.pageXOffset,
        bottom: window.pageYOffset + window.innerHeight,
        right: window.pageXOffset + window.innerWidth
    };
    else {
        var bounds = (0, $b7Pst.default)(container);
        if (bounds) return $238c29c110dc849e$var$_objectSpread({}, bounds, {
            bottom: bounds.top + container.offsetHeight,
            right: bounds.left + container.offsetWidth
        });
        else return undefined;
    }
}

});
parcelRegister("b7Pst", function(module, exports) {
$parcel$export(module.exports, "default", () => $819843b102792787$export$2e2bcd8739ae039);
function $819843b102792787$export$2e2bcd8739ae039(element) {
    if (!element) return undefined;
    var rect = element.getBoundingClientRect();
    return {
        left: window.pageXOffset + rect.left,
        right: window.pageXOffset + rect.left + rect.width,
        top: window.pageYOffset + rect.top,
        bottom: window.pageYOffset + rect.top + rect.height
    };
}

});


parcelRegister("ebmGF", function(module, exports) {
$parcel$export(module.exports, "default", () => $a533b0f56bb7c661$export$2e2bcd8739ae039);
function $a533b0f56bb7c661$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $a533b0f56bb7c661$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $a533b0f56bb7c661$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $a533b0f56bb7c661$var$_typeof(obj);
}
function $a533b0f56bb7c661$export$2e2bcd8739ae039(offset) {
    if (!offset) return undefined;
    var offsetTop;
    var offsetRight;
    var offsetBottom;
    var offsetLeft;
    if ($a533b0f56bb7c661$var$_typeof(offset) === 'object') {
        offsetTop = offset.top || 0;
        offsetRight = offset.right || 0;
        offsetBottom = offset.bottom || 0;
        offsetLeft = offset.left || 0;
    } else {
        offsetTop = offset || 0;
        offsetRight = offset || 0;
        offsetBottom = offset || 0;
        offsetLeft = offset || 0;
    }
    return {
        top: offsetTop,
        right: offsetRight,
        bottom: offsetBottom,
        left: offsetLeft
    };
}

});

parcelRegister("f5YpG", function(module, exports) {
$parcel$export(module.exports, "default", () => $afd62f7a4eb8aeb4$export$2e2bcd8739ae039);
function $afd62f7a4eb8aeb4$export$2e2bcd8739ae039(elementBounds, viewportBounds, offset) {
    var offsetTop = offset && offset.top || 0;
    var offsetRight = offset && offset.right || 0;
    var offsetBottom = offset && offset.bottom || 0;
    var offsetLeft = offset && offset.left || 0;
    return elementBounds.bottom + offsetBottom >= viewportBounds.top && elementBounds.top - offsetTop <= viewportBounds.bottom && elementBounds.right + offsetRight >= viewportBounds.left && elementBounds.left - offsetLeft <= viewportBounds.right;
}

});

parcelRegister("lzei4", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb37f3a1ef8ce023$export$2e2bcd8739ae039);
var $fb37f3a1ef8ce023$export$2e2bcd8739ae039 = function() {
    return document.compatMode === "BackCompat";
};

});

parcelRegister("drbf6", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c86848687969eb2$export$2e2bcd8739ae039);
var $9c86848687969eb2$var$isPassiveListenerSupported = function isPassiveListenerSupported() {
    var supported = false;
    try {
        var opts = Object.defineProperty({}, 'passive', {
            get: function get() {
                supported = true;
            }
        });
        window.addEventListener('test', null, opts);
        window.removeEventListener('test', null, opts);
    } catch (e) {}
    return supported;
};
var $9c86848687969eb2$export$2e2bcd8739ae039 = $9c86848687969eb2$var$isPassiveListenerSupported() ? {
    passive: true
} : undefined;

});





//# sourceMappingURL=@atlaskit-internal_smartcard-urlcardcontent.6001c816.js.map
